export const personalizedAdPolicyHtml = `<div><p>고객님의 개인 정보를 이용하여 광고성 정보를 제공할 수 있는지 여부를 선택하실 수 있습니다. 동의하신다면 저희 협력사에게 공유하게 되어 더 흥미로운 광고를 제공하겠습니다. 동의하지 않으시면 개인정보는 위와 같은 목적으로 이용하지 않습니다. 여전히 광고를 받으실 수 있지만, 해당 광고는 개인 정보에 따라 커스텀되지 않고 더 이상 선호도에 맞지 않을 수 있습니다. 귀하의 개인 정보를 사용하여 광고성 정보를 제공하는 것에 동의하신 후 언제든지 게임 사용자 센터에서 동의를 철회할 수 있습니다.</p></div>`;

export const termDetailHtml = `  <div>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">이용약관</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:'Malgun Gothic'">업데이트 일자</span><span
                style="font-family:微软雅黑">: 2025</span><span style="font-family:'Malgun Gothic'">년</span><span
                style="font-family:微软雅黑">10</span><span style="font-family:'Malgun Gothic'">월</span><span
                style="font-family:微软雅黑">22</span><span style="font-family:'Malgun Gothic'">일</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">제1장 총칙</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">제1조 약관의 목적</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">이 약관은 Blancozone (이하 “회사”)가 온라인으로 제공하는
                게임상품 및 이에 부수된 제반 서비스(이하 “게임콘텐츠”)의 이용과 관련하여 이용자의 이용을 허용하는 계약상 법적 근거를 제공하고, 본 약관을 토대로 게임콘텐츠를 이용함에 있어 회사와
                이용자 간의 권리, 의무 등 사항을 규정함을 목적으로 합니다.</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">제2조 용어의 정의</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">1. ‘회사’라 함은 디바이스 및 온라인을 통하여 게임콘텐츠를
                제공하는 사업자를 말합니다.</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">2. ‘디바이스’라 함은 콘텐츠를 다운로드 받거나 설치하여 사용할 수
                있는 PC, 휴대전화, 스마트폰, PDA, 태블릿, 휴대용 게임기, 콘솔 게임기 등의 기기를 말합니다.</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">3. ‘이용자’라 함은 본 약관에 동의하고 게임콘텐츠의 이용 자격을
                부여받은 자연인(회원, 임시회원, 비회원이 포함되며, ‘임시회원’이라 함은 회원인증을 하지 않고 게스트로그인 모드로 이용하는 이용자를 의미함)을 말합니다.</span><span
                style="font-family:微软雅黑">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">4. ‘게임콘텐츠’라 함은 회사가 제공하는 모든 게임 및 네트워크
                서비스, 애플리케이션, 게임머니 및 게임 아이템 등 서비스와 관련되어 디지털 방식으로 제작된 내용물 일체뿐만 아니라, 인터넷에 연결하여 순위등록, 게시물 작성, 게임머니 또는 게임 아이템
                등의 구매, 네트워크 게임 이용을 할 수 있도록 회사가 제공하는 게임 및 이에 부수된 부가서비스 일체를 말합니다.</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">5. ‘게임세계’라 함은 게임콘텐츠를 통해 회사가 제정한
                게임규칙(이하 “게임규칙”)에 따라 오락을 하거나 오락게임 등 활동을 구현한 각종 가상환경을 말합니다.</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">6. ‘계정(ID)’이라 함은 회사가 허용하는 범위 내에서 이용자의
                신분 식별과 게임콘텐츠 이용을 위하여 이용자가 선정하는 문자, 숫자 또는 특수문자의 조합을 말합니다.</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">7. ‘계정정보’라 함은 이용자의 계정, 비밀번호, 성명 등 회사에
                제공한 정보 및 게임 이용정보, 이용요금 결제상태 등 생성정보를 통칭합니다.</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">8. ‘캐릭터’라 함은 이용자가 게임콘텐츠의 이용 범위 내에서
                게임콘텐츠에 따라 게임세계 내에서 회사에서 제공하는 방식으로 창조하는 가상인물데이터를 말합니다.</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">9. ‘비밀번호’라 함은 이용자의 계좌정보 안전 및 게임권익보호를
                위해 이용자 자신이 선정하는 문자, 숫자 또는 특수문자의 조합을 말합니다.</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">10. ‘게임머니’라 함은 게임콘텐츠 또는 게임콘텐츠의 구매에
                사용되는 가상 화폐를 말합니다.</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">11. ‘사이버 포인트’라 함은 게임 아이템이나 게임콘텐츠를 이용
                또는 구매하기 위해 사용되는 가상의 데이터로서 회사가 책정하고 무료로 지급하는 것을 말합니다.</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">12. ‘게시물’이라 함은 이용자가 게시판에서 게시한 문자, 그림,
                음성, 영상 또는 이들의 조합으로 이루어진 정보를 말합니다.</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">13. 이 약관에서 사용하는 전문용어의 정의는 이미 정한 것을
                제외하고는 관계 법령에 의합니다.</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">제3조 회사정보의 공시</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">회사는 다음 각 호의 사항을 게임 초기화면이나 게임
                홈페이지(https://www.blancozone.com/)에 게시하여 이용자가 이를 바로 알 수 있도록 합니다. 다만 회사의 개인정보처리방침과 구체적인 약관 내용은 링크를 통해 확인할
                있습니다. 8번 항목의 확률 정보는 게임과 웹페이지에 공개됩니다.</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">1. 상호 및 대표자의 성명</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">2. 영업소 소재지(고객서비스센터 포함) 및 전자우편주소</span>
        </p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">3. 전화번호, 팩스번호</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">4. 사업자등록번호, 통신판매업 신고번호</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">5. 개인정보처리방침</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">6. 서비스 이용약관</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">7. 호스팅서비스를 제공하는 사업자의 상호</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">8. 「게임산업진흥에 관한 법률」 등 관련 법령에 따라 표시할 의무가
                있는 확률형 아이템 관련 정보</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">제4조 약관의 공시 및 개정</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">1. 회사는 이 약관의 구체적인 내용을 이용자가 알 수 있도록 게임
                초기화면이나 게임 홈페이지(https://www.blancozone.com/)에 본 약관의 조항들을 게시하는 방법으로 이용자에게 공시합니다. 본 약관의 효력은 공시한 후에
                발생합니다.</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">2. 이용자는 회사가 지정한 메일주소에
                메일(global.support@blancozone.com)을 보냄으로써, 본 약관 내용에 대한 질의를 할 수 있으며, 회사는 합리적인 시간 내에 답변합니다.</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">3. 회사는 게임콘텐츠 이용자의 편의를 위해 관련 약관을 작성하여야
                합니다. 약정할 약관의 효력이 발생하기에 앞서 회사는 쉬운 용어로 계약 해제·해지조항, 면책조항 및 이용자에 대한 충전잔액반환이나 피해보상 등과 같은 중요한 내용을 이용자가 쉽게 알아볼
                수 있도록 작성하거나, 이러한 중요한 조항들을 굵게 표시하거나 그 제시를 위해 팝업화면을 제공합니다.</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">4. 회사는 「전자상거래 등에서의 소비자보호에 관한 법률」,
                「게임산업진흥에 관한 법률」, 「약관의 규제에 관한 법률」, 「정보통신망이용촉진 및 정보보호 등에 관한 법률」, 「콘텐츠산업진흥법」 등 관련 벌령에 근거하여, 위 법령에 위배하지 않는
                전제 하에 이 약관을 보충 또는 개정할 수 있으며, 약관에 대한 보충 및 개정은 동등한 법적 효력을 가집니다.</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; color:#ff0000">5. 회사는 회사의 재량에 따라 본 약관을
                수시로 개정할 수 있습니다. 회사가 약관을 개정할 경우에는 개정약관 효력발생일의 최소 7일 이전부터 게임 초기화면을 통해 이용자에게 이를 공지합니다. 다만, 이용자에게 불리하거나 중대한
                변경인 경우에는 최소 30일 이전부터 동일한 방법으로 이용자에게 공지하며, 이용자가 인터넷에 연결하여 게임콘텐츠 접속 시 쉽게 확인할 수 있도록 게임 내에서 공지하여야 합니다. 개정약관의
                효력은 공시일 또는 공고 실시일로부터 발생합니다.</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">6. 회사가 약관을 개정할 경우에는 개정약관 공지 후 개정약관의
                적용에 대한 이용자의 동의 여부를 확인합니다. 개정약관 공지시 이용자가 동의 또는 거부의 의사표시를 하지 않으면 승낙한 것으로 간주하겠다는 내용도 함께 공지한 경우에는 이용자가 약관
                시행일까지 거부의사를 표시하지 않는다면 개정약관에 동의한 것으로 간주할 수 있습니다.</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; color:#ff0000">7. 이용자에게는 약관개정 확인을 위해
                비정기적으로 사이트를 방문하거나 공지 창을 확인하여야 할 의무가 있습니다. 만약 이용자가 변경된 약관의 내용에 동의하지 않는 경우, 회사와 이용자는 계약을 해지(회원탈퇴)할 수
                있습니다.</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">제5조 약관 외 준칙</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">회사는 이 약관에 포함되지 아니한 사항에 관하여 「전자상거래 등에서의
                소비자보호에 관한 법률」, 「게임산업진흥에 관한 법률」, 「약관의 규제에 관한 법률」, 「정보통신망이용촉진 및 정보보호 등에 관한 법률」, 「콘텐츠산업진흥법」등 관련 법령을 참조하여
                따릅니다.</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">제6조 운영정책</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">1. 이용자의 권익을 보호하고 게임세계 내 질서를 유지하기 위하여
                회사는 아래와 같이 게임콘텐츠 운영정책(이하 “운영정책”)을 제정합니다.</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">2. 회사는 이용자가 운영정책의 내용을 구체적으로 이해할 수 있도록
                게임 초기화면이나 게임 홈페이지(https://www.blancozone.com/)에 이를 공지합니다.</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; color:#ff0000">3. 이용자의 권리 또는 의무에 변경을
                가져오는 것과 관련된 운영정책 개정의 경우에는 본 약관 제4조(약관의 공시 및 개정)에 따릅니다. 만약 이용자의 권리의무와 관련 없는 사항을 개정하는 경우, 본 약관 제6조 제2항의
                방법으로 공지할 수 있습니다.</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">4. 회사는 운영정책의 내용이 본 약관에서 정한 내용과 일치하도록
                유지하며, 운영정책에 대한 개정은 이용자가 예측 가능한 범위에 한하여 할 수 있습니다.</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">제2장 이용조례</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">제7조 이용자 신청 및 방법</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">1. 회사가 제공하는 게임콘텐츠를 이용하고자 하는 경우 이용자는 게임
                초기화면이나 게임 홈페이지에서 이용신청서를 제출하여야 합니다.</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">2. 이용자는 이용신청서 작성 시 회사에서 필요로 하는 각종 정보를
                제공하여야 합니다.</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">3. 이용자는 제1항에 따른 이용신청서 제출 시 반드시 본인의 실명
                및 실제 정보를 기재하여야 합니다. 정보를 허위로 제공하거나 타인의 신원을 도용하는 등 불법 행위를 행하였을 경우 회사는 당해 이용자에 대하여 제공하는 전부 또는 일부 서비스를
            </span><span style="font-family:'Malgun Gothic'">중단 또는 종료</span><span style="font-family:微软雅黑">할 수
                있습니다.</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; color:#ff0000">4. 청소년(19세
                미만</span><span style="font-family:'Malgun Gothic'; color:#ff0000">인</span><span
                style="font-family:微软雅黑; color:#ff0000"> 자.「초·중등교육법 」제2조의 규정에 의한 고등학교에 재학 중인 학생을 포함함)이 이용신청을 할 경우 법정대리인의
                동의를 얻어야 하고, 동의를 이미 받은 청소년이 이용신청을 할 경우에는 위 법령, 약관 및 운영정책에 따르도록 합니다.</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">제8조 이용신청의 승낙과 제한</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; color:#ff0000">1. 이용신청을 하고자 하는 이용자는
                기재할 계정과 개인정보를 준비하여야 하며, 자신이 제공한 개인신원자료에 관한 정보의 진실성, 완전성 및 유효성을 보증하여야 합니다. 회사는 이용조건에 부합되는 신청에 대하여 승낙할 수
                있습니다. 회사는 이용자의 이용신청을 승낙한 때부터 게임콘텐츠에 대한 제공을 개시합니다. 다만, 일부 서비스의 경우에는 회사의 필요에 따라 지정된 일자부터 서비스를 개시할 수 있으며,
                특정 서비스에 대해서는 유료로 제공할 수 있습니다.</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">2. 회사는 다음 각 호의 어느 하나에 해당하는 경우에는 신청을
                거절할 수 있습니다.</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">1) 제7조에 따른 이용자 신청 및 방법 규정에 위반하는
                경우</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">2) 이용요금을 납부하지 않거나, 전액 납부하지 않고 잔액이 완전히
                납부할 수 있을 지 여부를 확인할 수 없는 경우</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">3) 미성년자(제7조 제4항)가 법정대리인의 동의를 얻지 아니하거나
                동의를 얻었음을 확인할 수 없는 경우</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">4) 최근 3개월 내 이용제한 기록이 있는 경우</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">5) 타인의 신용카드, 신원자료를 무단으로 도용하여 게임 가입에
                사용하거나 서비스이용요금을 결제하는 경우</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">6) 대한민국 이외의 국가에서 게임콘텐츠를 이용하고자 하는
                경우</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">7) 게임콘텐츠 제공과 관련하여 일정한 제한을 둘 수 있는
                경우</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">8) 기타 「게임산업진흥에 관한 법률」, 「정보통신망 이용촉진 및
                정보보호 등에 관한 관련 법률」등 규정에 위반하는 경우</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">9) 그 밖에 1호 내지 8호에 준하는 사유와 유사한 행위가 발생하는
                경우</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">3. 회사는 이용자의 이용신청에 대하여 다음 각 호의 어느 하나에
                해당하는 경우에는 그 사유가 해소될 때까지 이용신청에 대한 승낙을 유보하거나 거절할 수 있습니다. 다만, 업무상 또는 기술적인 장애로 인하여 회사가 서비스를 제공할 수 없을 경우 사이트에
                공시하거나 이용자에게 통지하여야 합니다.</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">1) 회사 운영정책에 부합하지 아니한 이용신청을 한 경우(단, 이
                경우 신청인이 회사 정책 상응한 조건에 부합된다고 인정될 때까지)</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">2) 서비스 제공상의 장애 또는 이용요금 결제수단의 장애가 발생한
                경우</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">3) 신청의 승낙에 기술상의 장애가 발생한 경우</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">4. 회사는 서비스를 제공함에 있어 이용자에 대하여 본 약관 외에
                별도 서비스약관의 체결을 요구할 수 있습니다. 별도의 약관체결이 요구되는 게임은 이용자의 동의 및 이용신청 후 이용 가능합니다.</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">5. 회사는 업무상 또는 기술상 특별한 지장이 없는 한, 연중무휴
                1일 24시간 서비스 제공을 원칙으로 합니다. 다만, 시스템 정기점검, 서버의 증설 및 교체, 새로운 게임 내용의 추가, 각종 버그 패치, 새로운 서비스로의 교체 등 운영상 필요한 경우,
                일정기간 서비스를 일시 종료시킬 수 있으며, 이러한 경우 회사는 사전에 그 내용 및 시간을 홈페이지에 공지합니다. 다만, 회사가 사전에 통지할 수 없는 부득이한 사유가 있는 경우 사후에
                통지할 수 있습니다.</span><span style="font-family:微软雅黑">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">6. 회사는 이용자에게 아래와 같은 게임콘텐츠를
                제공합니다.</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">1) 게임 서비스 및 관련 서비스</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">2) 소셜 네트워크 서비스 (SNS)</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">3) 기타 회사가 자체 개발하거나 다른 회사와의 협력 계약 등 방식을
                통해 이용자에게 제공하는 일체의 서비스</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; color:#ff0000">7. 회사는 이용자에게 서비스를 제공함에
                있어 관련 법령, 이용자의 연령, 서비스의 이용 절차에 따라 일부 서비스 이용 등을 제한할 수 있습니다. 이 경우 회사는 해당 내용을 사전에 이용자에게 안내합니다.</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">8. 회사는 이용자의 편의를 위하여 일부 서비스에 대해 ‘임시회원’
                기능을 제공할 수 있습니다. 단, 임시회원 기능 이용 중 아래 각 호에 해당하는 경우 서비스 이용기록 및 구매기록이 삭제되거나 기록을 확인할 수 없는 문제가 발생할 수 있습니다. 따라서
                이러한 사실에 대해 회사는 서비스 최초 이용 시 팝업 등으로 공지할 예정이며 회원인증을 통한 서비스 이용을 권장하며 서비스별로 임시회원이 회원인증을 받는 방식이 다르므로 자세한 사항은
                고객센터 메일로 문의 바랍니다.</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">1) 모바일 기기를 변경한 경우</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">2)</span><span
                style="font-family:微软雅黑">&#xa0;</span><span style="font-family:微软雅黑"> 모바일 기기를 개조하거나 초기화한 경우</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">3)</span><span
                style="font-family:微软雅黑">&#xa0;</span><span style="font-family:微软雅黑"> 모바일 기기에서 어플리케이션 등 콘텐츠를 삭제한
                경우</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">제9조 이용자 계정 및 비밀번호</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">1. 회사가 허용하는 범위 내에서 이용자의 신분식별과 게임콘텐츠
                이용을 위하여 이용자가 선정한 문자, 숫자 또는 특수문자의 조합을 사용합니다.</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">2. 회사는 이용자 가입 시 제공한 신원정보에 대한 진실성과 유효성을
                심사할 수 있습니다.</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">3. 이용자는 자신의 계정과 비밀번호를 적절히 보관하여 이를 정확하고
                안전하게 사용할 의무가 있습니다. 이용자가 위 의무를 소홀히 함으로 인하여 계정 및 비밀번호를 분실하거나 도용 당하거나, 이용자가 제3자에게 이용을 승낙으로써 본인 또는 타인에게 발생하는
                민사상 손해에 대하여는 이용자 본인에게 법률상 책임이 있습니다. 이 경우 회사는 회사의 고의 또는 중과실이 없는 한 면책됩니다.</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">4. 실제 정보로 가입한 이용자가 개인신원자료에 관한 기존 정보를
                변경할 필요가 있는 경우 회사는 적시에 유효하게 이러한 서비스를 제공하여야 합니다.</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">5. 이용자는 적시에 본인의 비밀번호를 변경하여야
                합니다.</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">제10조 이용자 정보의 제공 및 변경</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">1. 이용자는 제공한 개인신원자료에 관한 정보가 진실되고 완전하며
                유효한 것임을 보증하여야 합니다. 허위정보 제공으로 인해 발생한 손해에 대하여 이용자 본인이 책임을 부담하여야 합니다.</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">2. 회원은 개인정보관리화면을 통해 언제든지 자신의 개인정보를 열람할
                수 있습니다. 다만, 서비스 관리를 위해 필요한 실명, 계정(ID) 등은 수정할 수 없습니다.</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">3. 이용자가 등록정보를 변경하고자 하는 경우에는 온라인으로 수정을
                하거나 기타 유효한 연락수단으로 회사에 대하여 그 변경사항을 알려야 합니다.</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">4. 이용자가 회사에 정보 변경사항을 적시에 통지하지 않아 발생한
                손해에 대하여 회사는 책임을 부담하지 않습니다.</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">제11조 개인정보의 관리 및 안전</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">1. 회사는 위 법령에 따라 이용자계정의 안전성과 유효성을 보호하기
                위해 기술상 및 관리상의 합리적인 조치를 적극적으로 취합니다. 회사는 관계 법령의 규정에 따라 이용자 등록정보를 포함한 이용자의 개인정보를 보호하기 위해 노력합니다. 이용자 개인정보의
                보호 및 사용에 대해서는 관련 법령 및 회사의 개인정보처리방침이 적용됩니다. 단, 회사 서비스를 통해 링크된 제3자 제공의 서비스(모든 제3자 사이트 포함)로부터 수집된 개인정보나 회사의
                서비스를 통해 광고 서비스를 하고 있는 다른 회사 또는 기관으로부터 수집된 정보에는 회사의 개인정보처리방침이 적용되지 않습니다.</span><span
                style="font-family:微软雅黑">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">2. 회사에서 이용자를 대상으로 제공하는 게임콘텐츠와 계정정보
                안전보호를 위한 서비스는 이용자 자격이 없는 기타 제3의 이용자에게 적용되지 않습니다.</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; color:#ff0000">3. 게임콘텐츠 이용에 동의한 것은
                이용자의 자율적 의사표시이며, 이용자는 계정정보의 노출이 수반되는 모든 리스크 및 해당 리스크로 인하여 발생한 모든 직∙간접적, 파생적 손해에 대하여 책임을 부담하며, 회사는 이에 대한
                일체적 책임을 지지 않습니다. 다만, 법령에 따라 완전히 배제될 수 없을 경우 회사의 배상책임 한도는 관련 사유로 인하여 이용자가 회사에 지급한 금액에 한합니다. 회사는 이용자의
                귀책사유로 노출된 이용자의 계정정보를 포함한 모든 손해에 대해서 일체의 책임을 지지 않습니다.</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">4. 회사는 이용자의 본인 확인을 위해 필요한 경우, 대한민국 법령상
                적법하게 본인 확인을 할 수 있는 자격을 가진 제3의 기관이나 사업자(“본인확인기관”)를 통하여 본인확인을 진행합니다. 회사는 본인확인기관으로부터 이용자가 입력한 정보에 따른 본인 확인
                결과만을 확인합니다.</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">제3장 회사 및 이용자의 의무</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">제12조 회사의 의무</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">1. 회사는 현행 법령, 정책을 엄격히 준수하고, 법률로 부여받은
                권리를 가지며, 법률 규정에 따라 의무를 이행합니다. 회사는 법령과 본 약관이 금지하거나 미풍양속에 반하는 행위를 하지 않으며, 계속적이고 안정적인 서비스를 제공하기 위하여
                노력합니다.</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">2. 회사는 이용자 안전 및 개인정보(신용정보 포함) 보호를 위해
                반드시 보안시스템을 구축하며 개인정보처리방침을 공시하고 준수함과 동시에 본 약관과 관련 법령을 준수하여야 합니다. 회사는 관련 법령 및 본 약관에서 명확하게 정한 예외적인 경우를
                제외하고는 이용자의 개인정보가 제3자에게 누설되지 않도록 합니다.</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; color:#ff0000">3. 해커공격, 컴퓨터바이러스 감염,
                시스템 붕괴, 네트워크 접속 끊김, 인터넷 속도 저하, 소프트웨어 오류 등 문제로 인한 장애 및 위협이 발생하였을 경우, 이용자는 위 각종 불량 정보, 네트워크 안전 및 인터넷의 장애
                발생은 회사 및 회사의 게임콘텐츠로 인한 것이 아니라는 점과 이러한 문제점 때문에 이용자에게 생길 수 있는 불만, 구역질, 구토 등 정신적 손해 및 다른 손실에 대하여 모두 자체적으로
                책임을 부담하되, 회사가 책임을 지지 아니한다는 점을 충분히 이해하여야 합니다.</span><span
                style="font-family:微软雅黑; color:#ff0000">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">4. 회사는 이용자로부터 제기되는 의견이나 불만이 정당하다고 인정될
                경우에는 즉시 처리합니다. 다만, 바로 처리하기가 곤란한 경우에는 전화나 전자우편으로 그 사유와 처리예정일을 이용자에게 통보합니다.</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">제13조 이용자의 의무</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">1. 이용자는 게임콘텐츠 및 네트워크 서비스 이용에 있어서 본
                약관에서 정하고 있는 사항 및 운영정책 관련 법률 규정을 준수하여야 합니다. 이용자는 다음 각 호의 행위 및 본 약관에 반하는 행위와 현행 법령, 정책에서 금지하는 행위를 하여서는 아니
                됩니다.</span><span style="font-family:微软雅黑">&#xa0;</span><span style="font-family:微软雅黑">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; color:#ff0000">1) 신청 또는 신청 변경 시 허위정보의
                제공</span></p>
        <p style="text-align:left; font-size:12pt"><span
                style="font-family:微软雅黑; color:#ff0000; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; color:#ff0000">2) 타인의 신원정보 도용(타인으로
                가장하는 행위 및 타인과의 관계를 허위로 표시하는 행위)</span></p>
        <p style="text-align:left; font-size:12pt"><span
                style="font-family:微软雅黑; color:#ff0000; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; color:#ff0000">3) 회사의 임직원, 운영자, 기타
                관계자를 사칭하는 행위(회사의 직원 또는 게시판관리자로 가장하거나 사칭하는 행위, 타인의 명의를 도용하여 문장을 게시하거나 메일을 발송하는 행위 포함)</span></p>
        <p style="text-align:left; font-size:12pt"><span
                style="font-family:微软雅黑; color:#ff0000; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; color:#ff0000">4) 회사가 대외적으로 게시한 정보의
                임의적 변경(서비스 공지정보에 대한 변경행위 포함)</span></p>
        <p style="text-align:left; font-size:12pt"><span
                style="font-family:微软雅黑; color:#ff0000; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; color:#ff0000">5) 회사가 외부 노출을 금지한 상품 및
                정보(컴퓨터프로그램, 회사 동의 없이 기타 이용자의 개인정보를 수집, 보관, 배포, 게시하는 행위)의 배포, 공유, 전송, 또는 게시</span></p>
        <p style="text-align:left; font-size:12pt"><span
                style="font-family:微软雅黑; color:#ff0000; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; color:#ff0000">6) 회사가 대외적으로 제공하지 않는
                컴퓨터프로그램이나 설비의 제작, 배포, 사용, 전송</span></p>
        <p style="text-align:left; font-size:12pt"><span
                style="font-family:微软雅黑; color:#ff0000; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; color:#ff0000">7) 회사가 제공하는 게임 상품 또는 그
                소프트웨어 요소 작품의 지식재산권을 침해하는 모든 행위, 또는 회사 또는 기타 이용자의 합법적인 권익에 손해를 끼치는 행위를 진행하는 행위. 회사는 이용자가 이러한 행위를 행하는 것을
                금지하여야 하며 기술상 조치를 취하여 이용자가 이러한 행위에 종사하는 것을 방지할 수 있음.</span></p>
        <p style="text-align:left; font-size:12pt"><span
                style="font-family:微软雅黑; color:#ff0000; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; color:#ff0000">8) 회사 및/또는 제3자에 대한 욕설,
                저주, 모욕, 공격, 비방이 포함되는 내용의 공유, 전송; 미신, 음란, 외설, 저질, 공포, 폭력, 흉악, 도박, 반란, 민족혐오, 국가통일방해, 정권전복 등 불만·혐오한 언론의 함유;
                위 내용들이 들어 있는 사이트명칭, 게임 캐릭터 이름(재물성 도박 등 사행행위에 대한 권유, 참여, 또는 상대방에게 수치심, 혐오감, 공포심을 느끼게 하는 언행, 음향, 글, 화상,
                영상의 전송, 공유, 배포행위 포함)의 설치</span></p>
        <p style="text-align:left; font-size:12pt"><span
                style="font-family:微软雅黑; color:#ff0000; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; color:#ff0000">9) 게임 데이터(계정, 캐릭터,
                게임아이템 등)의 유상 거래, 또는 권리의 객체에 대한 담보, 대여 등을 제공하는 행위</span></p>
        <p style="text-align:left; font-size:12pt"><span
                style="font-family:微软雅黑; color:#ff0000; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; color:#ff0000">10) 게임 데이터(계정, 캐릭터,
                게임아이템 등)의 유상 거래를 공개적으로 광고 선전하고 참여하거나 또는 권리의 객체에 대한 담보, 대여 등을 제공하는 행위(기타 이용자의 캐릭터를 불법 사용하는 행위
                포함)</span><span style="font-family:微软雅黑; color:#ff0000">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span
                style="font-family:微软雅黑; color:#ff0000; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; color:#ff0000">11) 회사의 승낙 없이 광고를 발표하고
                상품을 판매하는 상업 행위를 진행하거나 불법적으로 회사 이익을 침해하는 여하한 행위를 진행, 또는 회사 서비스 운영을 고의로 방해하거나 서비스의 안정적 운영을 방해할 수 있는 정보 및
                수신자의 명시적인 수신 거부 의사에 반하여 광고성 정보를 전송</span></p>
        <p style="text-align:left; font-size:12pt"><span
                style="font-family:微软雅黑; color:#ff0000; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; color:#ff0000">12) 회사의 사전 승낙 없이 회사의
                서비스 또는 서비스를 이용하여 얻은 정보를 복제, 유통, 조장하거나 상업적으로 이용</span></p>
        <p style="text-align:left; font-size:12pt"><span
                style="font-family:微软雅黑; color:#ff0000; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; color:#ff0000">13) 자기 또는 타인의 재산적 이익을
                위한 회사 서비스의 이용 행위</span></p>
        <p style="text-align:left; font-size:12pt"><span
                style="font-family:微软雅黑; color:#ff0000; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; color:#ff0000">14) 타인의 명예를 훼손하거나 손해를
                가하는 행위</span></p>
        <p style="text-align:left; font-size:12pt"><span
                style="font-family:微软雅黑; color:#ff0000; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; color:#ff0000">15) 명의자의 동의나 승낙 없이 결제
                수단을 무단 도용하여 서비스 이용 요금을 결제</span></p>
        <p style="text-align:left; font-size:12pt"><span
                style="font-family:微软雅黑; color:#ff0000; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; color:#ff0000">16) 회사의 지식재산권, 제3자의
                지식재산권, 초상권 등 기타 권리의 침해</span></p>
        <p style="text-align:left; font-size:12pt"><span
                style="font-family:微软雅黑; color:#ff0000; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; color:#ff0000">17) 프로그램의 버그를 악용하거나
                서비스와 관련된 설비의 오작동이나 정보 등의 파괴 및 혼란을 유발하는 컴퓨터바이러스 감염자료를 등록 또는 유포, 관련 법령에 의하여 그 전송 또는 게시가 금지되는 정보(컴퓨터프로그램)
                또는 컴퓨터소프트웨어, 하드웨어, 전기통신 장비의 정상적인 가동을 방해, 파괴할 목적으로 고안된 소프트웨어 바이러스, 다른 컴퓨터 코드, 파일, 프로그램을 포함하고 있는 자료를 전송,
                게시, 유포, 사용</span></p>
        <p style="text-align:left; font-size:12pt"><span
                style="font-family:微软雅黑; color:#ff0000; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; color:#ff0000">18) 회사가 제공한 서비스 안에서나
                홈페이지상에서 이용자 계정을 현금 거래하는 행위</span></p>
        <p style="text-align:left; font-size:12pt"><span
                style="font-family:微软雅黑; color:#ff0000; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; color:#ff0000">19) 결제와 관련된 모든
                부정행위</span></p>
        <p style="text-align:left; font-size:12pt"><span
                style="font-family:微软雅黑; color:#ff0000; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; color:#ff0000">20) 회사에서 제공하는 게임콘텐츠 사용법
                외에 타인의 정상적인 게임콘텐츠 이용을 방해 및 타인에게 손해를 가하는 행위</span></p>
        <p style="text-align:left; font-size:12pt"><span
                style="font-family:微软雅黑; color:#ff0000; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; color:#ff0000">21) 기타 공공질서 및 미풍양속에
                반하거나 반사회적 행동, 불법∙부당한 행위와 관련 법령에 위배하는 행위</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">2. 이용자는 약관 내용, 회사의 게임콘텐츠 등 관련 주의사항을
                성실하게 열람하고 회사가 공시한 통지와 공지들을 준수할 의무가 있으며 회사의 업무에 방해되는 행위를 하여서는 아니 됩니다. 회원은 수시로 관계 법령, 본 약관의 규정을 비롯하여 회사가
                통지하는 사항 등을 준수하여야 하며, 기타 회사의 업무에 방해되는 행위를 하여서는 아니 됩니다. 이용자는 홈페이지의 공지사항 및 게임운영정책 사항을 수시로 확인하여야 합니다.</span>
        </p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">3. 회사는 다음 각 호의 어느 하나에 해당하는 게임내용이나 서비스
                사항에 대하여 일정한 한도 내에서 제한을 둘 수 있으며, 이용자는 이를 충분히 이해하고 관련 규정을 준수하여야 합니다.</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; color:#ff0000">1) 이용자의 계정명, 캐릭터명, 연맹명,
                그룹명칭에 대한 제한</span></p>
        <p style="text-align:left; font-size:12pt"><span
                style="font-family:微软雅黑; color:#ff0000; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; color:#ff0000">2) 채팅 내용과 방법에 대한
                제한</span></p>
        <p style="text-align:left; font-size:12pt"><span
                style="font-family:微软雅黑; color:#ff0000; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; color:#ff0000">3) 게시물 내용에 대한 일정한
                제한</span></p>
        <p style="text-align:left; font-size:12pt"><span
                style="font-family:微软雅黑; color:#ff0000; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; color:#ff0000">4) 게임플레이방법에 대한
                제한</span></p>
        <p style="text-align:left; font-size:12pt"><span
                style="font-family:微软雅黑; color:#ff0000; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; color:#ff0000">5) 기타 이용자의 게임콘텐츠 이용에 대한
                합리적 권리를 침해하지 않는 범위 내에서 회사가 게임콘텐츠 운영상 필요하다고 인정되는 제한</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; color:#ff0000">4. 이용자는 본 서비스를 이용하기 위하여
                자신의 개인정보를 적절히 관리하여야 합니다. 개인정보에 변경이 발생할 경우 상응한 변경 처리를 해야 합니다. 이용자의 개인정보 변경이 지연되거나 누락되어 발생하는 손실은 이용자가
                부담합니다. 이용자의 주소, 연락처, 전자우편 등 이용계약 사항에 변경이 발생할 경우 관련 절차를 통해 회사에 즉시 고지하여야 합니다. 이용자가 제공한 가입정보 및 업데이트한 가입정보가
                정확하지 않을 경우 및 회원이 본조 제1항에 명시된 행위를 행할 경우 회사는 본 약관에 근거하여 회원의 서비스이용을 </span><span
                style="font-family:'Malgun Gothic'; color:#ff0000">중단 </span><span
                style="font-family:微软雅黑; color:#ff0000">또는 </span><span
                style="font-family:'Malgun Gothic'; color:#ff0000">종료</span><span
                style="font-family:微软雅黑; color:#ff0000">할 수 있습니다.</span></p>
        <p style="text-align:left; font-size:12pt"><span
                style="font-family:微软雅黑; color:#ff0000; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">5. 이용자는 콘텐츠를 다운로드 받은 디바이스에 대해 책임을 져야
                하며 보관 및 관리를 잘하여 타인이 이용자의 승낙 없이 서비스를 이용하거나 온라인 게임콘텐츠를 이용하는 것을 방지하여야 합니다.</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">6. 이용자는 회사에서 공식적으로 인정한 경우를 제외하고는 서비스를
                이용하여 상품을 판매하는 등의 영업활동을 할 수 없고, 서비스를 통해 취득한 아이템 및 ID 등을 거래에 제공하거나 제공받을 수 없고, 해킹, 광고로부터 수익취득, 상용소프트웨어 불법배포
                등의 행위를 할 수 없으며, 그와 같은 행위를 준비하거나 홍보할 수 없습니다. 이를 위반하여 발생한 영업 활동의 결과 및 손실, 관계기관에 의한 구속 등 법적 조치 등에 관해서는 전적으로
                이용자의 책임으로 하며 회사는 고의 또는 중과실이 없는 한 이에 대해 일체의 책임을 지지 않습니다. 만약 이용자의 이와 같은 행위와 관련하여 회사에 손해가 발생한 경우 이용자는 일체의
                손해배상 책임을 부담합니다.</span><span style="font-family:微软雅黑">&#xa0;</span><span
                style="font-family:微软雅黑">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; color:#ff0000">7. 회사는 본 서비스 등을 유지하기
                위하여 광고를 게재할 수 있으며, 이용자는 서비스 이용 시 노출되는 광고 게재에 대하여 동의합니다.</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">1) 회사가 제공하는 제3자가 주체인 광고에 이용자가 참여하거나 교신
                또는 거래함으로써 발생하는 손실과 손해에 대해서 회사는 어떠한 책임도 부담하지 않습니다.</span><span style="font-family:微软雅黑">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">2) 회사는 서비스 개선 및 이용자 대상 서비스 소개 등을 위한
                목적으로 이용자 개인에 대한 추가정보를 요구할 수 있으며, 동 요청에 대해 이용자는 승낙하여 추가정보를 제공하거나 이를 거부할 수 있습니다.</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; color:#ff0000">3) 회사는 이용자의 사전 동의 하에
                이용자로부터 수집한 개인정보를 활용하는 경우 SMS(LMS), 스마트폰 알림(Push알림), 전자우편을 활용하여 발송할 수 있으며, 이용자는 원하지 않는 경우 언제든지 수신을 거부할 수
                있습니다.</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">8. 이용자가 게임 운영정책사항에 위반되는 행위를 하였을 때 회사는
                이용자에게 게임 이용제재 혹은 경우에 따라 법적 책임을 물을 수 있습니다.</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">제4장 게임콘텐츠 및 이용방법</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">제14조 게임콘텐츠의 변경</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">1. 이용자는 본 약관에 근거하여 회사로부터 게임콘텐츠를 제공받을 수
                있으며, 회사의 운영정책 및 회사가 설정한 게임규칙을 준수합니다.</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">1) 이용자는 이동통신사의 무선인터넷, 오픈마켓 스토어, 애플리케이션
                스토어, 온라인 사이트(포털, 모바일게임 사이트 또는 당사 홈페이지 등) 및 기타 채널을 통하여 회사가 제공하는 콘텐츠를 구매하거나 다운로드할 수 있습니다.</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">2) 회사가 개발한 게임 타이틀은 회사가 거래하는 유통업체 및 온라인
                쇼핑몰 등을 통하여 구매할 수 있습니다.</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">3) 회사가 제공하는 아이템 등은 온라인 사이트, 게임 및
                애플리케이션 내에서 제공하는 네트워크 서비스를 통하여 구매할 수 있습니다.</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">4) 이용자가 이동통신사의 무선인터넷 및 오픈마켓 스토어,
                애플리케이션 스토어를 통하여 모바일 게임, 애플리케이션을 구매하거나 네트워크 서비스를 이용하는 경우 이동통신사에서 정하는 소정의 데이터 통화료가 부과될 수 있습니다.</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">2. 회사가 게임을 통해 이용자에게 제공하는 게임세계는 회사가 창조한
                가상세계이며 회사가 게임콘텐츠의 제작, 변경, 유지보수, 수정에 대한 포괄적인 권한을 보유합니다.</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">3. 회사는 현실세계로부터 게임세계를 보호하고 게임세계의 질서와
                게임성을 유지하기 위하여 필요한 조치를 취할 수 있습니다.</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">4. 회사는 수시로 운영방식을 변경할 수 있는 권한을 보유합니다.
                즉, 요금부과기준, 유료 소프트웨어의 기능, 유료 대상 및 시간 등 내용을 변경할 수 있습니다 또한 회사는 게임콘텐츠 및 제공하는 서비스에 대하여 업그레이드, 버전변경, 증가, 삭제,
                수정하거나 기능변경이나 게임규칙을 변경하는 등 관련 권한을 보유합니다. 이러한 내용의 변경을 하고자 하는 경우 회사는 이용자에게 본 약관 제4조 제5항, 제6항의 방법에 따라 공지합니다.
                이용자가 관련 변경에 동의할 수 없는 경우 게임콘텐츠 에 대한 이용을 즉시 </span><span
                style="font-family:'Malgun Gothic'">종료</span><span style="font-family:微软雅黑">하여야 합니다. 계속적 이용행위는 이용자가 개정된
                운영방식에 대하여 동의한 것으로 간주합니다.</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">제15조 서비스 중단 및 종료</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; color:#ff0000">1. 회사는 경영방침에 따라 이용자에게
                충분한 게임시간을 제공하여야 합니다. 게임 서비스 일정은 게임 초기화면이나 게임 홈페이지(https://www.blancozone.com/)에서 공지합니다. 회사는 운영상 또는 기술상의
                필요에 따라 제공하고 있는 서비스를 변경할 수 있습니다. 변경될 서비스의 내용 및 변경 실시 일자 등에 대해서는 이용자에게 사전에 통지합니다. 단, 회사가 사전에 통지할 수 없는 치명적인
                고장 발생, 서버 기기결함, 긴급 보안 문제 해결 등의 부득이한 사정이 있는 경우는 사후에 통지할 수 있습니다.</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; color:#ff0000">2. 회사는 다음 각 호의 어느 하나에
                해당하는 운영상 필요에 따라 게임콘텐츠를 </span><span style="font-family:'Malgun Gothic'; color:#ff0000">중단</span><span
                style="font-family:微软雅黑; color:#ff0000">하고 보수를 진행할 수 있으며, </span><span
                style="font-family:'Malgun Gothic'; color:#ff0000">중단 </span><span
                style="font-family:微软雅黑; color:#ff0000">기간 동안 이용자에게 발생한 손실에 대하여 배상할 의무는 없습니다.</span></p>
        <p style="text-align:left; font-size:12pt"><span
                style="font-family:微软雅黑; color:#ff0000; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; color:#ff0000">1) 회사의 컴퓨터 등 설비의 보수점검,
                교체, 정기점검 또는 게임콘텐츠의 수정 및 기타 필요한 경우</span></p>
        <p style="text-align:left; font-size:12pt"><span
                style="font-family:微软雅黑; color:#ff0000; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; color:#ff0000">2) 회사가 게임 상품 중 이용자가 버그
                또는 패치를 사용하는 행위를 효과적으로 억제하기 위하여 서비스 중단 유지보수 또는 복구 등 처리조치를 채택할 수 있습니다. 서비스 중단 유지보수 기간 동안 이용자는 게임 상품의 일부
                게임서버 및/또는 일부 게임 구역에 접속할 수 없을 수도 있습니다. 복구라 함은 모든 이용자의 게임 계정상의 게임 데이터를 어느 한 시점에서의 기록에서 이전의 다른 한 시점의 기록으로
                돌려 놓는 것을 말하며 이로 인해 이용자가 이 기간 동안 정상적인 게임 행위를 통해 획득한 게임도구, 게임아이템 등 게임물품의 등급, 포인트, 명예 등이 영구적으로 상실되거나 또는 기타
                손실을 초래할 수 있습니다.</span><span style="font-family:微软雅黑; color:#ff0000">&#xa0;</span><span
                style="font-family:微软雅黑; color:#ff0000"> 이에 대해 이용자는 충분히 숙지하고 자체적으로 책임을 부담하여야 하며, 회사는 어떠한 배상도 하지
                않습니다.</span></p>
        <p style="text-align:left; font-size:12pt"><span
                style="font-family:微软雅黑; color:#ff0000; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; color:#ff0000">3) 회사는 재량에 따라 본 약관 및 본
                약관에 따른 권리를 수시로 </span><span style="font-family:'Malgun Gothic'; color:#ff0000">중단</span><span
                style="font-family:微软雅黑; color:#ff0000"> 또는 종료할 수 있습니다. 이러한</span><span
                style="font-family:'Malgun Gothic'; color:#ff0000">중단 혹은</span><span
                style="font-family:微软雅黑; color:#ff0000"> 종료는 회사의 해산, 말소, 합병, 분할 또는 회사의 게임상품이나 그의 운영권한을 제3자에게 양도함으로써 초래될
                수 있으며, 또한 법령, 정책, 국가기관의 명령 또는 지진, 화재, 태풍, 파업, 전쟁 등 불가항력 사유로 인하여 발생할 수도 있습니다. 그리고 위 사유 이외의 기타 원인도
            </span><span style="font-family:'Malgun Gothic'; color:#ff0000">중단이나</span><span
                style="font-family:微软雅黑; color:#ff0000"> 종료를 초래할 수 있습니다.</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">3. 회사가 매 주 또는 격주에 한번씩 게임콘텐츠를 중단하여 보수를
                진행해야 하면, 회사는 최소한 24시간 이전에 게임 초기화면이나 게임 홈페이지에서 서비스 중단을 고지합니다.</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">4. 만약 부득이한 사유로 회사가 이용자에게 서비스
            </span><span style="font-family:'Malgun Gothic'">중단 </span><span style="font-family:微软雅黑">등에 관한 사항을 사전 고지 하지
                못한 경우 빠른 시일 내에 게임 초기화면 및 게임 홈페이지의 첫 페이지에서 서비스 중단 유지보수에 관한 통지를 사후 고지할 수 있습니다.</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; color:#ff0000">5. 이용자가 회사가 제공하는 무료 상품
                또는 서비스를 이용함으로써 손실을 받게 된 경우, 회사의 고의 또는 중과실이 없는 한 회사는 이에 대한 책임을 부담하지 않습니다.</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; color:#ff0000">6. 회사는 제2항 제3호에 의하여
                게임</span><span style="font-family:'Malgun Gothic'; color:#ff0000"> 서비스</span><span
                style="font-family:微软雅黑; color:#ff0000">를 </span><span
                style="font-family:'Malgun Gothic'; color:#ff0000">종료</span><span
                style="font-family:微软雅黑; color:#ff0000">할 경우, 30일 전에 홈페이지에서 서비스 중단고지를 공지하여야 합니다. 부득이한 상황으로 적시에 공지하지 못하였을
                경우 사후에 다시 공지할 수 있습니다.</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; color:#ff0000">7. 회사가 제2항에 의하여
                게임</span><span style="font-family:'Malgun Gothic'; color:#ff0000"> 서비스를</span><span
                style="font-family:微软雅黑; color:#ff0000"> </span><span
                style="font-family:'Malgun Gothic'; color:#ff0000">종료하는</span><span
                style="font-family:微软雅黑; color:#ff0000"> 경우 </span><span
                style="font-family:'Malgun Gothic'; color:#ff0000">환불 및 손해 배상은 「콘텐츠이용자 보호지침」에 따라 처리되며, 이용자는 무료 서비스, 잔여
                사용 기간이 없는 유료 서비스, 연속 유료 사용 항목 또는 정기 유료 항목을 신청할 수 없습니다.</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; color:#ff0000">8. 게임</span><span
                style="font-family:'Malgun Gothic'; color:#ff0000"> 서비스를</span><span
                style="font-family:微软雅黑; color:#ff0000"> 종료하는 경우 </span><span
                style="font-family:'Malgun Gothic'; color:#ff0000">사용 기간에 제한이 없는 유료 항목의 사용 기한은 고지된 서비스 종료 시간에 따라
                종료됩니다.</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; color:#ff0000">9. 회사는 서비스의 변경 및
            </span><span style="font-family:'Malgun Gothic'; color:#ff0000">중단으</span><span
                style="font-family:微软雅黑; color:#ff0000">로 발생하는 문제에 대해서는 책임을 지지 않습니다.</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">제16조 정보제공</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">회사는 게임 홈페이지에서 이용자에게 아래의 정보를 제공하여야
                합니다.</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">1. 상호:</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">2. 게임물 명칭:</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">3. 이용등급:</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">4. 등급분류번호:</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">5. 제작연월일:</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">6. 게임물제작업체 또는 배급업자의 신고번호 또는
                등기번호:</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">7. 기타 회사가 필요하다고 인정하는 사항:</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">제17조 정보의 수집</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">1. 회사는 이용자의 게임 내에서의 채팅내용을 보관할 수 있습니다.
                회사는 이용자간의 분쟁 조정, 민원 처리 또는 게임 질서의 유지를 위하여 회사가 유사한 분쟁 처리에 협조가 필요하다고 판단하는 경우에 관련 이용자의 정보를 열람할 수 있고, 사전에
                열람사유 및 열람범위를 이용자에게 고지합니다. 열람한 내용에 대하여 엄격한 비밀유지의무를 준수하여야 하며, 권한을 부여 받지 아니한 제3자는 절대로 열람할 수 없습니다. 계정 도용,
                현금거래, 언행폭력, 게임사기 등 행위와 연관될 경우 회사는 이용자에게 사전 고지 없이 열람 할 수 있으며, 사후에 다시 이용자에게 관련 결정 및 사유를 통지합니다.</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">2. 회사는 이용자의 디바이스 정보를 수집할 수 있으며, 게임콘텐츠
                개선을 위해 프로그램 최적화를 통해 게임콘텐츠 품질을 보증합니다.</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">제18조 게임콘텐츠의 사용</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">1. 회사는 이용자에게 무료 게임콘텐츠와 유료 게임콘텐츠를 제공할 수
                있습니다. 이용자는 유료 게임콘텐츠를 자유로이 선택할 수 있습니다.</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">1) 회사는 이용자에게 아이템을 포함한 게임콘텐츠를 제공할 수
                있습니다. 회사가 제공한 게임콘텐츠는 회사의 정책에 따라서 이용자에게 이용기한을 정할 수 있으며, 이러한 이용기한은 각 게임콘텐츠 서비스 세부이용 지침에서 정하거나 각 게임콘텐츠 서비스
                결제화면 등에 미리 게시하여 이용자에게 고지합니다.</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">2) 회사는 게임콘텐츠에 필요한 최소한의 기술사양에 관한 정보를
                서비스별 홈페이지 권장사양정보에서 제공하며, 이용자는 게임콘텐츠를 이용하기 위하여 서비스에 이용할 단말기 사양, 유무선 통신망의 품질 등이 해당 게임콘텐츠의 이용에 적합한지를 사전에
                확인하여야 합니다.</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">3) 회사는 게임콘텐츠 중 회원에게 치장성아이템 및 게임에 사용하는
                아이템(이하 '아이템'이라 함) 서비스를 유료 또는 무료로 구분하여 제공할 수 있으며 아이템 관련 정책은 다음을 따릅니다.</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">a. 보증기간이 별도로 명시된 유료아이템의 경우는 구매 시 명기한
                보증기간을 따릅니다. 단, 회사가 이용자에게 지급한 무료아이템의 경우에는 서비스 제공 기간을 보증하지 않습니다.</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; color:#ff0000">b. 보증기간이 '영구'로 표시된
                유료아이템이나 보증기간이 표시되지 않은 유료아이템(이하 '영구아이템'이라 함)에 대한 사용은 게임콘텐츠가 정상적으로 제공되는 기간 동안의 이용권을 보장하는 것이며, 만약 이용자가 이용
                약관상 금지 행위를 하였거나 휴면 ID 또는 휴면 캐릭터로 분류되어 그에 따른 제재로서 당해 ID 또는 캐릭터가 이용제한 또는 삭제되는 경우, 영구아이템의 사용도 종료되며 회사는 이용자에
                대하여 구매대금을 반환할 책임을 부담하지 아니합니다.</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; color:#ff0000">c. 회사는 이용자의 부정한 이용을
                방지하기 위하여 타인으로부터 선물 받은 아이템이나 회사로부터 무료로 제공받은 아이템은 환불하지 않습니다.</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; color:#ff0000">d. 회사는 아이템의 보증 기간에 회사의
                게임 내용의 변경 및 아이템 정책에 따라 기존 아이템의 기능 등을 변경하거나 사용할 수 없도록 변경할 수 있습니다. 이때, 유료로 구매한 아이템 사용이 불가능하게 되는 경우에는 30일
                이상 홈페이지 또는 관련 홈페이지에 공지하고 사용권이 남은 아이템을 유료로 구매한 이용자에 한해 기존 아이템의 잔여 기간을 산정한 뒤 등가의 신규 아이템 등으로 보상합니다.</span>
        </p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">4) 회사가 제공하는 아이템을 포함한 콘텐츠의 지식재산권을 포함한
                모든 소유권은 회사에 있으며, 이용자는 회사가 제공하는 범위 내에서 서비스 이용권을 가집니다. 즉, 이용자는 회사가 제공하는 콘텐츠를 일정기간 동안 회사가 제공하는 서비스 범위 내에서
                이용할 권한을 갖는 것이며, 이를 회사가 정한 방법 이외의 방법으로 이용 또는 사용하거나 양도, 판매할 수 없습니다.</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">2. 게임비용을 지불하는 가격과 지불방식은 회사에 의하여 정합니다.
                게임콘텐츠에 대한 구매 대금은 원칙적으로 이동통신사와 애플리케이션 스토어, 온라인사이트에서 정하는 방법, 정책 등에 따라 부과되며, 납부 방법 역시 정해진 방법에 따라 납부하여야 합니다.
                회사의 정책 및 결제업체(이동통신사, 오픈마켓 스토어, 애플리케이션 스토어 등)의 정책, 정부의 방침 등에 따라 각 결제 수단별로 결제 한도가 부여될 수 있습니다.</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">3. 이용자가 유료 게임콘텐츠를 선택할 경우에는 아래 사항에
                유의하여야 합니다.</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">1) </span><span
                style="font-family:'Malgun Gothic'">이용자는</span><span style="font-family:微软雅黑"> </span><span
                style="font-family:'Malgun Gothic'">게임콘텐츠</span><span style="font-family:微软雅黑"> </span><span
                style="font-family:'Malgun Gothic'">비용을</span><span style="font-family:微软雅黑"> </span><span
                style="font-family:'Malgun Gothic'">전액</span><span style="font-family:微软雅黑"> </span><span
                style="font-family:'Malgun Gothic'">납부하여야</span><span style="font-family:微软雅黑"> </span><span
                style="font-family:'Malgun Gothic'">합니다</span><span style="font-family:微软雅黑">. </span><span
                style="font-family:'Malgun Gothic'">만약 이용자가 환불을 요청하여 본 약관 및 관련 법령을 위반한 상태에서 결제 업체를 통해 환불을 받은
                경우</span><span style="font-family:微软雅黑">, </span><span style="font-family:'Malgun Gothic'">게임콘텐츠 비용을 미납한
                것으로 간주합니다</span><span style="font-family:微软雅黑">. </span><span style="font-family:'Malgun Gothic'">회사는 본
                약관 제</span><span style="font-family:微软雅黑">24</span><span style="font-family:'Malgun Gothic'">조에 따라 이용자가
                미납 금액을 지불할 때까지 제한 조치를 취할 권리가 있습니다</span><span style="font-family:微软雅黑">. </span><span
                style="font-family:'Malgun Gothic'">이용자가 새로운 유료 게임 콘텐츠를 구매하기 위해 미지급 비용을 보충하기 전에 게임콘텐츠 비용을 납부할
                경우</span><span style="font-family:微软雅黑">, </span><span style="font-family:'Malgun Gothic'">회사는 다시 납부한
                비용을 우선적으로 미지급 금액을 공제할 권리가 있습니다</span><span style="font-family:微软雅黑">. </span><span
                style="font-family:'Malgun Gothic'">따라 이용자가 미지급 금액을 보충하기 전에는 새로운 유료 게임 콘텐츠를 정상적으로 구매할 수 없습니다</span><span
                style="font-family:微软雅黑">.</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">2) 유료 게임콘텐츠를 구매한 이용자는 회사가 지정한 방식에 따라
                비용을 지불하여야 합니다. 단, 무통장입금 방식으로 지급한 이용자는 신청한 날로부터 3일 후 동등한 금액을 반드시 입금하여야 하며, 기한이 만료되었으나 미지불인 경우 회사는 해당 거래를
                취소할 권리가 있습니다.</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; color:#ff0000">3) 미성년자가 유료 게임아이템을 구매할
                경우에는 부모 등 법정대리인의 동의를 받아야 합니다. 동의를 받지 않은 유료 게임콘텐츠의 이용자는 법정대리인에게 고지한 후 법정대리인이 비용의 지급을 취소할 수 있습니다.</span>
        </p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">4.</span><span
                style="font-family:'Malgun Gothic'"> 구독</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">1）</span><span
                style="font-family:'Malgun Gothic'">구독은</span><span style="font-family:微软雅黑"> </span><span
                style="font-family:'Malgun Gothic'">자동</span><span style="font-family:微软雅黑"> </span><span
                style="font-family:'Malgun Gothic'">연장</span><span style="font-family:微软雅黑"> </span><span
                style="font-family:'Malgun Gothic'">정액제</span><span style="font-family:微软雅黑"> </span><span
                style="font-family:'Malgun Gothic'">서비스로</span><span style="font-family:微软雅黑"> </span><span
                style="font-family:'Malgun Gothic'">구매</span><span style="font-family:微软雅黑"> </span><span
                style="font-family:'Malgun Gothic'">후</span><span style="font-family:微软雅黑"> </span><span
                style="font-family:'Malgun Gothic'">스토어</span><span style="font-family:微软雅黑"> </span><span
                style="font-family:'Malgun Gothic'">마켓에서</span><span style="font-family:微软雅黑"> </span><span
                style="font-family:'Malgun Gothic'">자동</span><span style="font-family:微软雅黑"> </span><span
                style="font-family:'Malgun Gothic'">결제가</span><span style="font-family:微软雅黑"> </span><span
                style="font-family:'Malgun Gothic'">됩니다</span><span style="font-family:微软雅黑">.</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">2） </span><span
                style="font-family:'Malgun Gothic'">자동</span><span style="font-family:微软雅黑"> </span><span
                style="font-family:'Malgun Gothic'">연장</span><span style="font-family:微软雅黑"> </span><span
                style="font-family:'Malgun Gothic'">규칙</span><span style="font-family:微软雅黑">：</span><span
                style="font-family:'Malgun Gothic'">구독</span><span style="font-family:微软雅黑"> </span><span
                style="font-family:'Malgun Gothic'">기간</span><span style="font-family:微软雅黑"> </span><span
                style="font-family:'Malgun Gothic'">만료</span><span style="font-family:微软雅黑"> </span><span
                style="font-family:'Malgun Gothic'">시</span><span style="font-family:微软雅黑"> </span><span
                style="font-family:'Malgun Gothic'">스토어</span><span style="font-family:微软雅黑"> </span><span
                style="font-family:'Malgun Gothic'">마켓에서</span><span style="font-family:微软雅黑"> </span><span
                style="font-family:'Malgun Gothic'">자동으로</span><span style="font-family:微软雅黑"> </span><span
                style="font-family:'Malgun Gothic'">구독료가</span><span style="font-family:微软雅黑"> </span><span
                style="font-family:'Malgun Gothic'">결제되며</span><span style="font-family:微软雅黑"> </span><span
                style="font-family:'Malgun Gothic'">구독</span><span style="font-family:微软雅黑"> </span><span
                style="font-family:'Malgun Gothic'">기간이</span><span style="font-family:微软雅黑"> </span><span
                style="font-family:'Malgun Gothic'">연장됩니다</span><span style="font-family:微软雅黑">.</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">3）</span><span
                style="font-family:'Malgun Gothic'">자동</span><span style="font-family:微软雅黑"> </span><span
                style="font-family:'Malgun Gothic'">연장</span><span style="font-family:微软雅黑"> </span><span
                style="font-family:'Malgun Gothic'">서비스</span><span style="font-family:微软雅黑"> </span><span
                style="font-family:'Malgun Gothic'">취소를</span><span style="font-family:微软雅黑"> </span><span
                style="font-family:'Malgun Gothic'">원하는</span><span style="font-family:微软雅黑"> </span><span
                style="font-family:'Malgun Gothic'">경우</span><span style="font-family:微软雅黑">, </span><span
                style="font-family:'Malgun Gothic'">최소</span><span style="font-family:微软雅黑"> </span><span
                style="font-family:'Malgun Gothic'">구독</span><span style="font-family:微软雅黑"> </span><span
                style="font-family:'Malgun Gothic'">기간</span><span style="font-family:微软雅黑"> </span><span
                style="font-family:'Malgun Gothic'">만료</span><span style="font-family:微软雅黑"> 24</span><span
                style="font-family:'Malgun Gothic'">시간</span><span style="font-family:微软雅黑"> </span><span
                style="font-family:'Malgun Gothic'">전까지</span><span style="font-family:微软雅黑"> </span><span
                style="font-family:'Malgun Gothic'">스토어</span><span style="font-family:微软雅黑"> </span><span
                style="font-family:'Malgun Gothic'">마켓에서</span><span style="font-family:微软雅黑"> </span><span
                style="font-family:'Malgun Gothic'">자동</span><span style="font-family:微软雅黑"> </span><span
                style="font-family:'Malgun Gothic'">연장을</span><span style="font-family:微软雅黑"> </span><span
                style="font-family:'Malgun Gothic'">수동으로</span><span style="font-family:微软雅黑"> </span><span
                style="font-family:'Malgun Gothic'">취소해야</span><span style="font-family:微软雅黑"> </span><span
                style="font-family:'Malgun Gothic'">합니다</span><span style="font-family:微软雅黑">. </span><span
                style="font-family:'Malgun Gothic'">자동</span><span style="font-family:微软雅黑"> </span><span
                style="font-family:'Malgun Gothic'">연장</span><span style="font-family:微软雅黑"> </span><span
                style="font-family:'Malgun Gothic'">취소</span><span style="font-family:微软雅黑"> </span><span
                style="font-family:'Malgun Gothic'">후</span><span style="font-family:微软雅黑"> </span><span
                style="font-family:'Malgun Gothic'">구독</span><span style="font-family:微软雅黑"> </span><span
                style="font-family:'Malgun Gothic'">기간</span><span style="font-family:微软雅黑"> </span><span
                style="font-family:'Malgun Gothic'">만료</span><span style="font-family:微软雅黑"> </span><span
                style="font-family:'Malgun Gothic'">후</span><span style="font-family:微软雅黑"> </span><span
                style="font-family:'Malgun Gothic'">자동으로</span><span style="font-family:微软雅黑"> </span><span
                style="font-family:'Malgun Gothic'">결제가</span><span style="font-family:微软雅黑"> </span><span
                style="font-family:'Malgun Gothic'">되지</span><span style="font-family:微软雅黑"> </span><span
                style="font-family:'Malgun Gothic'">않고</span><span style="font-family:微软雅黑"> </span><span
                style="font-family:'Malgun Gothic'">이번</span><span style="font-family:微软雅黑"> </span><span
                style="font-family:'Malgun Gothic'">구독</span><span style="font-family:微软雅黑"> </span><span
                style="font-family:'Malgun Gothic'">기간이</span><span style="font-family:微软雅黑"> </span><span
                style="font-family:'Malgun Gothic'">만료될</span><span style="font-family:微软雅黑"> </span><span
                style="font-family:'Malgun Gothic'">때까지</span><span style="font-family:微软雅黑"> </span><span
                style="font-family:'Malgun Gothic'">유효하며</span><span style="font-family:微软雅黑"> </span><span
                style="font-family:'Malgun Gothic'">이미</span><span style="font-family:微软雅黑"> </span><span
                style="font-family:'Malgun Gothic'">결제한</span><span style="font-family:微软雅黑"> </span><span
                style="font-family:'Malgun Gothic'">금액은</span><span style="font-family:微软雅黑"> </span><span
                style="font-family:'Malgun Gothic'">반납되지</span><span style="font-family:微软雅黑"> </span><span
                style="font-family:'Malgun Gothic'">않습니다</span><span style="font-family:微软雅黑">.</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">4）</span><span
                style="font-family:'Malgun Gothic'">자동</span><span style="font-family:微软雅黑"> </span><span
                style="font-family:'Malgun Gothic'">연장을</span><span style="font-family:微软雅黑"> </span><span
                style="font-family:'Malgun Gothic'">취소한</span><span style="font-family:微软雅黑"> </span><span
                style="font-family:'Malgun Gothic'">후</span><span style="font-family:微软雅黑"> </span><span
                style="font-family:'Malgun Gothic'">언제든지</span><span style="font-family:微软雅黑"> </span><span
                style="font-family:'Malgun Gothic'">다시</span><span style="font-family:微软雅黑"> </span><span
                style="font-family:'Malgun Gothic'">구독할</span><span style="font-family:微软雅黑"> </span><span
                style="font-family:'Malgun Gothic'">수</span><span style="font-family:微软雅黑"> </span><span
                style="font-family:'Malgun Gothic'">있습니다</span><span style="font-family:微软雅黑">.</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">5）</span><span
                style="font-family:'Malgun Gothic'">해당</span><span style="font-family:微软雅黑"> </span><span
                style="font-family:'Malgun Gothic'">구독은</span><span style="font-family:微软雅黑"> </span><span
                style="font-family:'Malgun Gothic'">구매</span><span style="font-family:微软雅黑"> </span><span
                style="font-family:'Malgun Gothic'">후</span><span style="font-family:微软雅黑"> </span><span
                style="font-family:'Malgun Gothic'">즉시</span><span style="font-family:微软雅黑"> </span><span
                style="font-family:'Malgun Gothic'">사용이</span><span style="font-family:微软雅黑"> </span><span
                style="font-family:'Malgun Gothic'">시작되거나</span><span style="font-family:微软雅黑"> </span><span
                style="font-family:'Malgun Gothic'">게임</span><span style="font-family:微软雅黑"> </span><span
                style="font-family:'Malgun Gothic'">서비스에</span><span style="font-family:微软雅黑"> </span><span
                style="font-family:'Malgun Gothic'">바로</span><span style="font-family:微软雅黑"> </span><span
                style="font-family:'Malgun Gothic'">적용되는</span><span style="font-family:微软雅黑"> </span><span
                style="font-family:'Malgun Gothic'">콘텐츠이다</span><span style="font-family:微软雅黑">.</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">5. 게임 내 ‘캐시’ 및 ‘금전’의 사용</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">1) 이용자가 보유하고 있는 ‘캐시 또한 금전’ 중 게임 내에서
                퀘스트를 진행하면서 획득하거나, 이벤트로 지급하는 캐시 또는 금전을 ‘무료 캐시’ 및 ‘무료 금전’이라 정의합니다. 획득한 무료 캐시 및 무료 금전은 유효기간, 사용범위 등을 별도로
                공지합니다.</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">2) 무료 캐시 및 무료 금전의 경우, 사용범위가 제한될 수
                있습니다.</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; color:#ff0000">3) 무료 캐시 및 무료 금전은 환불 또는
                보상의 대상이 되지 않습니다. </span><span style="font-family:'Malgun Gothic'; color:#ff0000">결제를 통해 구매한 유료
                상품</span><span style="font-family:微软雅黑; color:#ff0000">(</span><span
                style="font-family:'Malgun Gothic'; color:#ff0000">게임 머니 포함</span><span
                style="font-family:微软雅黑; color:#ff0000">), </span><span
                style="font-family:'Malgun Gothic'; color:#ff0000">무료 캐시 및 무료 금전이 공존하는 경우</span><span
                style="font-family:微软雅黑; color:#ff0000">, </span><span
                style="font-family:'Malgun Gothic'; color:#ff0000">결제를 통해 구매한 유료 상품</span><span
                style="font-family:微软雅黑; color:#ff0000">(</span><span
                style="font-family:'Malgun Gothic'; color:#ff0000">게임 머니 포함</span><span
                style="font-family:微软雅黑; color:#ff0000">)</span><span
                style="font-family:'Malgun Gothic'; color:#ff0000">이 먼저 소모됩니다</span><span
                style="font-family:微软雅黑; color:#ff0000">. </span><span
                style="font-family:'Malgun Gothic'; color:#ff0000">단</span><span
                style="font-family:微软雅黑; color:#ff0000">, </span><span
                style="font-family:'Malgun Gothic'; color:#ff0000">사정에 따라 상품의 이용 순서는 다르게 적용될 수 있으며</span><span
                style="font-family:微软雅黑; color:#ff0000">, </span><span
                style="font-family:'Malgun Gothic'; color:#ff0000">이 경우 홈페이지</span><span
                style="font-family:微软雅黑; color:#ff0000">, </span><span
                style="font-family:'Malgun Gothic'; color:#ff0000">공식카페 등을 통하여 공지합니다</span><span
                style="font-family:微软雅黑; color:#ff0000">.</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">제19조 사이버 포인트</span><span
                style="font-family:微软雅黑">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">1. 회사는 이용자의 정보에 근거하여 이용자에게 사이버 포인트를
                제공할 수 있습니다(이용자 정보는 &lt;개인정보처리방침&gt; 참조). 회사가 정한 유효기간 내에 사용되지 않은 사이버 포인트는 소멸될 수 있습니다.</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">2. 회사에서 제공한 사이버 포인트의 적립에 오류가 있을 경우,
                이용자는 회사에 정정 신청을 할 수 있으며, 회사는 확인한 후 인터넷에서 정정조치를 취할 수 있습니다.</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">3. 회사는 이용자에게 제공한 게임콘텐츠가 곧 만기되는 경우, 회사는
                1개월 전에 유효한 방법으로 이용자에게 관련 통지를 발송하여야 합니다. </span><span style="font-family:微软雅黑; color:#ff0000">회사가 이용자에게
                게임콘텐츠의 제공을 </span><span style="font-family:'Malgun Gothic'; color:#ff0000">종료</span><span
                style="font-family:微软雅黑; color:#ff0000">할 때 이용자에게 미사용 사이버 포인트가 아직 남아있는 경우, 미사용 사이버 포인트는 소멸됩니다.</span>
        </p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">제20조 지식재산권의 귀속</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">1. 본 약관 및 아래 모든 작품 또는 자료의 소유권 및 저작권을
                포함한 모든 지식 재산권은 회사에 귀속하고 관련 법령의 보호를 받습니다.</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">2. 이용자는 회사나 서비스 제공업자의 사전 허가 없이 회사가 제공한
                게임콘텐츠 관련 정보를 제3자에게 이용하게 할 수 없습니다.</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">3. 다음 각 호의 어느 하나에 해당하는 경우, 회사는
                &lt;개인정보처리방침&gt;에 명시되어 있는 방법으로 이용자 정보(이용자가 게임단말기 혹은 게임콘텐츠를 통하여 획득한 정보 등, 및 문자, 이미지, 오디오, 비디오 및 모든 정보)를
                획득 및 사용할 수 있습니다</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">1) 이용자가 애플리케이션을 사용하는 관련 정보, 사용시간, 사용장소
                및 사용방식 포함 (이용자가 애플리케이션에 대하여 변경, 복제, 전달, 발행, 방송 등 행위를 하였는지 여부)</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">2) 회사는 이용자의 사전 동의 없이 이용자가 제작한 작품을 판매,
                임대, 양도할 수 없습니다.</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">4. 회사는 이용자가 게임콘텐츠 내에 게시한 작품(예를 들어 게시판
                게시물)에 대하여 이용자의 명시적인 허락 없이는 무단으로 사용하지 않습니다. 이용자가 서비스 범위 내에서 게시한 게시물의 저작권은 해당 저작권자에 귀속되고 이용자는 해당 게시물을 수시로
                삭제할 수 있습니다.</span><span style="font-family:微软雅黑">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">5. 회사는 이용자가 게임 내 및 게시판에서 제13조 (이용자의
                의무)에서 규정한 금지내용을 게시하였다고 판단하는 경우, 본 약관 및 관련 법령에 근거하여 이에 대하여 상응하는 조치를 취할 수 있습니다.</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">6. 회사가 운영하는 게시판에 게시된 게시물로 인하여 법률상 이익이
                침해된 이용자는 회사에 해당 게시물의 삭제 또는 반박내용의 게재를 요청할 수 있으며, 회사는 유효한 조치를 신속히 취하고, 이를 즉시 이용자에게 통지하여야 합니다.</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">7. 이용자가 회원신분이 해제된 후에도 여전히 회사가 제공하는
                게임콘텐츠를 사용하는 경우, 회사는 제3항 규정에 따라 이용자 정보를 획득 및 사용할 권리가 있습니다.</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">8. 이용자는 회사의 동의 없이 서비스 사용 시 획득한 정보를 영리의
                목적으로 사용하거나 제3자에게 사용하도록 제공하여서는 아니 됩니다.</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">9. 이용자가 게임콘텐츠 내에 게시한 게시물은 검색 혹은 서비스나
                관련 프로모션 활동 등으로 인하여 공개될 수 있습니다. 이때 해당 게시물은 필요한 범위 내에서 일부 수정, 복제, 편집 후 게시될 수 있습니다. 이때 회사는 저작권법의 내용을 준수하여야
                하며, 이용자는 수시로 고객센터 혹은 서비스 관리 기능을 통하여 관련 게시물을 삭제하거나 검색결과에서 배제하거나 비공개로 설정하는 등 처리를 할 수 있습니다.</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">10. 이용자의 게시물이 저작권 등 문제로 인하여 제3자에 의하여
                이의가 제기된 경우, 회사가 해당 이의가 합리적인 이유가 있다고 판단하는 경우, 회사는 이용자에게 사전 통지 없이 해당 게시물을 즉시 삭제하거나 등록을 거부할 수 있습니다. 저작권 및
                권리침해로 인한 게시금지 등 사항은 저작권법 및 관련 법령의 규정에 따릅니다.</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">11. 이 외에는 이용자의 게시물 게시와 관련하여 아래 유의사항이
                있습니다.</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">1) 게시물로 인한 손실 혹은 문제는 이용자 개인이 책임을 지며
                회사는 이에 대하여 책임을 부담하지 않습니다.</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">2) 회사는 관리 상의 필요에 따라 사전 통지 없이 게시물을 이동할
                수 있습니다.</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">3) 타인이 이용자의 게시물이 그 타인의 권리를 침해하였음을 이유로
                회사를 상대로 손해배상 등을 청구한 경우, 게시물을 작성한 이용자는 회사가 면책될 수 있도록 적극 협조하여야 합니다. 회사가 면책되지 못한 경우, 이용자는 이로 인한 문제에 대한 책임을
                부담하여야 합니다.</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">4) 이용자가 작성하거나 전달한 게시물이 다음 중 어느 하나에
                해당하는 경우, 회사는 사전 통지 없이 이를 삭제하거나 등록을 거부할 수 있습니다.</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">a. 다른 이용자 혹은 다른 사람에 대하여 비방, 사생활 침해,
                모욕행위를 하거나, 혹은 이로 인하여 타인의 명예를 훼손한 경우</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">b. 서비스의 안정적인 운영에 영향을 미치거나 미칠 가능성이 있는
                경우</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">c. 범죄행위와 관련된 내용이라고 판단되는 경우</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">d. 회사 및 제3자의 지식재산권 등 기타 권리를 침해하는 내용이
                있는 경우.</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">제5장 청약 철회 및 계약해제</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">제21조 청약 철회</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">1. 원칙적으로, 회사로부터 유료 게임상품을 구매한 이용자는 구매일
                혹은 지불일로부터 7일 내에 청약철회를 할 수 있습니다. 회사가 이용자에게 제공하는 유료 콘텐츠는 청약철회가 가능한 콘텐츠와 청약철회가 제한되는 콘텐츠로 구분되어 제공됩니다. 유료로 직접
                구매하여 청약철회가 가능한 유료 콘텐츠에 대해서는 구매 후 7일 기간 내에 청약철회를 할 수 있습니다. 단, 선물 및 이벤트 보상 등의 방법으로 회사나 제3자로부터 제공받은 콘텐츠 또는
                구매 즉시 효과가 발생하는 등 일부 사용한 콘텐츠의 경우 등에는 관련법령에 따라 청약철회가 제한될 수 있으며, 이 경우 회사는 관련 법령에서 정한 바에 따른 조치를 취합니다.</span>
        </p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; color:#ff0000">2. 이용자는 아래 경우에 청약철회를 할
                수 없습니다.</span></p>
        <p style="text-align:left; font-size:12pt"><span
                style="font-family:微软雅黑; color:#ff0000; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; color:#ff0000">1) 이용자에게 책임이 있는 사유로 재화
                등이 멸실 되거나 훼손된 경우</span></p>
        <p style="text-align:left; font-size:12pt"><span
                style="font-family:微软雅黑; color:#ff0000; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; color:#ff0000">2) 이용자의 구매, 사용시간이 지나 다시
                판매하기 곤란할 경우</span></p>
        <p style="text-align:left; font-size:12pt"><span
                style="font-family:微软雅黑; color:#ff0000; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; color:#ff0000">3) 제품의 포장이 훼손된
                경우</span></p>
        <p style="text-align:left; font-size:12pt"><span
                style="font-family:微软雅黑; color:#ff0000; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; color:#ff0000">4) 서비스 이용과정에서 획득한 아이템의
                경우</span></p>
        <p style="text-align:left; font-size:12pt"><span
                style="font-family:微软雅黑; color:#ff0000; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; color:#ff0000">5) 구매 후 즉시 사용이 시작되거나 게임
                서비스에 바로 적용되는 콘텐츠의 경우</span></p>
        <p style="text-align:left; font-size:12pt"><span
                style="font-family:微软雅黑; color:#ff0000; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; color:#ff0000">6) 부가적인 혜택이 제공되는 아이템 또는
                묶음형 판매 콘텐츠에서 이미 추가 혜택이 사용되거나 일부가 사용되어 회수가 불가능한 경우</span></p>
        <p style="text-align:left; font-size:12pt"><span
                style="font-family:微软雅黑; color:#ff0000; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; color:#ff0000">7) 개봉 시 효용이 결정되는
                캡슐형/확률형 아이템을 개봉한 경우</span></p>
        <p style="text-align:left; font-size:12pt"><span
                style="font-family:微软雅黑; color:#ff0000; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; color:#ff0000">8) 회사가 이용자에게 무료로 지급한 재화
                및 아이템</span></p>
        <p style="text-align:left; font-size:12pt"><span
                style="font-family:微软雅黑; color:#ff0000; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; color:#ff0000">9) 타인으로부터 선물 받은 유료재화 및
                유료아이템</span></p>
        <p style="text-align:left; font-size:12pt"><span
                style="font-family:微软雅黑; color:#ff0000; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; color:#ff0000">10) 그 밖에 거래의 안전을 위하여 관련
                법령에 의하여 2차 거래가 명시적으로 금지된 경우</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">3. 회사는 본조 제2항 제2호부터 제8호까지 규정에 따라 이용자의
                철회신청을 받아들이지 아니할 경우에는 상품 포장에 표기 및 설명을 하거나 사전에 이용자에게 테스트용 서비스를 제공합니다. 만약 회사가 이러한 조치를 하지 않을 경우 이용자는 위 조항에도
                불구하고 청약을 철회할 수 있습니다.</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">4. 이용자는 본조 제2항 제1호부터 제3호까지의 규정에도 불구하고
                유료 게임상품의 내용이 표시·광고 내용과 다르거나 계약내용과 다르게 이행된 경우에는 구매 후 3개월 내에 청약철회를 신청할 수 있고, 구매한 상품과 계약서에서 약정한 상품이 동일하지
                아니함을 안 날로부터 30일 내에 청약을 철회할 수 있습니다.</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">5. 미성년자가 법정대리인의 동의 없이 유료 게임상품을 구매한 경우,
                미성년자 또는 법정대리인은 회사에 청약철회를 요청할 수 있으며, 회사는 법정대리인임을 증명할 수 있는 서류를 요구할 수 있습니다. </span><span
                style="font-family:微软雅黑; color:#ff0000">단, 미성년자의 구매가 법정대리인으로부터 처분을 허락 받은 재산의 범위 내인 경우 또는 미성년자가 사술 등을
                사용하여 성인으로 하여금 믿게 한 때에는 취소가 제한됩니다. 구매자의 미성년자 여부는 구매가 진행된 단말기 또는 신용카드 등 결제수단의 명의자를 기준으로 판단됩니다.</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">6. </span><span
                style="font-family:'Malgun Gothic'">상기</span><span style="font-family:微软雅黑"> </span><span
                style="font-family:'Malgun Gothic'">제</span><span style="font-family:微软雅黑">21</span><span
                style="font-family:'Malgun Gothic'">조</span><span style="font-family:微软雅黑"> </span><span
                style="font-family:'Malgun Gothic'">제</span><span style="font-family:微软雅黑">1</span><span
                style="font-family:'Malgun Gothic'">항</span><span style="font-family:微软雅黑"> </span><span
                style="font-family:'Malgun Gothic'">내지</span><span style="font-family:微软雅黑"> </span><span
                style="font-family:'Malgun Gothic'">제</span><span style="font-family:微软雅黑">5</span><span
                style="font-family:'Malgun Gothic'">항의</span><span style="font-family:微软雅黑"> </span><span
                style="font-family:'Malgun Gothic'">경우</span><span style="font-family:微软雅黑"> </span><span
                style="font-family:'Malgun Gothic'">외에도</span><span style="font-family:微软雅黑"> </span><span
                style="font-family:'Malgun Gothic'">이용자는</span><span style="font-family:微软雅黑"> </span><span
                style="font-family:'Malgun Gothic'">기타</span><span style="font-family:微软雅黑"> </span><span
                style="font-family:'Malgun Gothic'">적용되는</span><span style="font-family:微软雅黑"> </span><span
                style="font-family:'Malgun Gothic'">법령에</span><span style="font-family:微软雅黑"> </span><span
                style="font-family:'Malgun Gothic'">따라</span><span style="font-family:微软雅黑"> </span><span
                style="font-family:'Malgun Gothic'">청약</span><span style="font-family:微软雅黑"> </span><span
                style="font-family:'Malgun Gothic'">철회를</span><span style="font-family:微软雅黑"> </span><span
                style="font-family:'Malgun Gothic'">할</span><span style="font-family:微软雅黑"> </span><span
                style="font-family:'Malgun Gothic'">수</span><span style="font-family:微软雅黑"> </span><span
                style="font-family:'Malgun Gothic'">있습니다</span><span style="font-family:微软雅黑">. </span><span
                style="font-family:'Malgun Gothic'; color:#ff0000">단</span><span
                style="font-family:微软雅黑; color:#ff0000">, </span><span
                style="font-family:'Malgun Gothic'; color:#ff0000">본</span><span
                style="font-family:微软雅黑; color:#ff0000"> </span><span
                style="font-family:'Malgun Gothic'; color:#ff0000">약관</span><span
                style="font-family:微软雅黑; color:#ff0000"> </span><span
                style="font-family:'Malgun Gothic'; color:#ff0000">제</span><span
                style="font-family:微软雅黑; color:#ff0000">21</span><span
                style="font-family:'Malgun Gothic'; color:#ff0000">조</span><span
                style="font-family:微软雅黑; color:#ff0000"> </span><span
                style="font-family:'Malgun Gothic'; color:#ff0000">제</span><span
                style="font-family:微软雅黑; color:#ff0000">1</span><span
                style="font-family:'Malgun Gothic'; color:#ff0000">항</span><span
                style="font-family:微软雅黑; color:#ff0000"> </span><span
                style="font-family:'Malgun Gothic'; color:#ff0000">내지</span><span
                style="font-family:微软雅黑; color:#ff0000"> </span><span
                style="font-family:'Malgun Gothic'; color:#ff0000">제</span><span
                style="font-family:微软雅黑; color:#ff0000">5</span><span
                style="font-family:'Malgun Gothic'; color:#ff0000">항의</span><span
                style="font-family:微软雅黑; color:#ff0000"> </span><span
                style="font-family:'Malgun Gothic'; color:#ff0000">경우에</span><span
                style="font-family:微软雅黑; color:#ff0000"> </span><span
                style="font-family:'Malgun Gothic'; color:#ff0000">해당하지</span><span
                style="font-family:微软雅黑; color:#ff0000"> </span><span
                style="font-family:'Malgun Gothic'; color:#ff0000">않고</span><span
                style="font-family:微软雅黑; color:#ff0000"> </span><span
                style="font-family:'Malgun Gothic'; color:#ff0000">여하한</span><span
                style="font-family:微软雅黑; color:#ff0000"> </span><span
                style="font-family:'Malgun Gothic'; color:#ff0000">법령에</span><span
                style="font-family:微软雅黑; color:#ff0000"> </span><span
                style="font-family:'Malgun Gothic'; color:#ff0000">의하여</span><span
                style="font-family:微软雅黑; color:#ff0000"> </span><span
                style="font-family:'Malgun Gothic'; color:#ff0000">청약</span><span
                style="font-family:微软雅黑; color:#ff0000"> </span><span
                style="font-family:'Malgun Gothic'; color:#ff0000">철회가</span><span
                style="font-family:微软雅黑; color:#ff0000"> </span><span
                style="font-family:'Malgun Gothic'; color:#ff0000">허용되는</span><span
                style="font-family:微软雅黑; color:#ff0000"> </span><span
                style="font-family:'Malgun Gothic'; color:#ff0000">것도</span><span
                style="font-family:微软雅黑; color:#ff0000"> </span><span
                style="font-family:'Malgun Gothic'; color:#ff0000">아닌</span><span
                style="font-family:微软雅黑; color:#ff0000"> </span><span
                style="font-family:'Malgun Gothic'; color:#ff0000">경우</span><span
                style="font-family:微软雅黑; color:#ff0000">, </span><span
                style="font-family:'Malgun Gothic'; color:#ff0000">이용자는</span><span
                style="font-family:微软雅黑; color:#ff0000"> </span><span
                style="font-family:'Malgun Gothic'; color:#ff0000">청약을</span><span
                style="font-family:微软雅黑; color:#ff0000"> </span><span
                style="font-family:'Malgun Gothic'; color:#ff0000">철회할</span><span
                style="font-family:微软雅黑; color:#ff0000"> </span><span
                style="font-family:'Malgun Gothic'; color:#ff0000">수</span><span
                style="font-family:微软雅黑; color:#ff0000"> </span><span
                style="font-family:'Malgun Gothic'; color:#ff0000">없습니다</span><span
                style="font-family:微软雅黑; color:#ff0000">.</span></p>
        <p style="font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">7. 이용자는 구두 또는 서면(전자메일 포함) 등 형식으로 청약철회를
                할 수 있습니다.</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">제22조 청약철회 등의 효과</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">1. 이용자가 청약철회를 한 경우 회사는 지체 없이 이용자의 유료
                게임상품을 회수 또는 삭제하고, 유료 게임상품을 회수 또는 삭제한 날로부터 3영업일 이내에 지급받은 대금을 환급합니다. 동일한 방법으로 환불이 불가할 경우 이를 사전에
                고지합니다.</span><span style="font-family:微软雅黑">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">2. 이용자의 권익을 보장하기 위하여, 회사가 이용자에게 환급을
                지연한 때에는 그 지연기간에 대하여 전자상거래 등에서의 소비자보호에 관한 법률 및 시행령에서 정하는 이율을 곱하여 산정한 지연이자를 지급합니다.</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">3. 위 대금을 환급함에 있어서 이용자가 신용카드나 그 밖에 이용자
                계좌 정보의 안전을 보장하는 유사한 방식으로 지급하였는데 해당 대금이 회사에 입금되지 않은 경우, 회사는 신용카드를 발급한 금융기관 또는 결제수단을 제공한 사업자(이하 “금융기관
                등”)에게 빠른 시일 내로 이용자에게 지급받은 금액을 환급할 것을 통지하여야 합니다. 회사가 위 금융기관 등으로부터 대금을 이미 지급받은 경우, 회사는 해당 금액을 금융기관 등에 반환하고
                금융기관 등이 다시 이를 이용자에게 반환하여야 합니다. 회사는 위 금액 환급 관련 사항을 이용자에게 고지하여야 합니다.</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">4. 회사는 이미 유료 콘텐츠 등이 일부 사용되거나 일부 소비된
                경우에는 그 콘텐츠 등의 일부 사용 또는 일부 소비에 의하여 이용자가 얻은 이익 또는 그 콘텐츠의 공급에 든 비용에 상당하는 금액을 이용자에게 청구할 수 있습니다</span><span
                style="font-family:微软雅黑">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">5. 이용자가 청약철회를 신청한 경우 제품 혹은 서비스의 반환에
                필요한 비용은 이용자가 부담하고, 회사는 이용자에게 청약철회를 이유로 위약금 또는 손해배상을 청구할 수 없습니다.</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">제23조 회사의 계약해지 신청</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">1. 이용자가 본 약관에서 정한 이용자의 의무를 위반한 경우, 회사는
                이용자에게 게임콘텐츠 계약의 해지를 요청할 수 있습니다. 회사는 이용자의 실제 본인 여부를 확인한 후 필요한 조치를 취합니다.</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">2. 회사가 이용계약을 해지하는 경우 회사는 이용자에게 서면으로 다음
                각 호의 사항을 통보합니다.</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">1) 해지사유</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">2) 해지일</span><span
                style="font-family:微软雅黑">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; color:#ff0000">3. 제1항에 따라 이용자는 유료서비스를
                비롯한 게임콘텐츠의 사용권한을 상실하고, 이로 인한 환불 및 손해배상을 청구할 수 없습니다.</span></p>
        <p style="text-align:left; font-size:12pt"><span
                style="font-family:微软雅黑; color:#ff0000; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; color:#ff0000">4. 회사는 이용자가 현행법 위반 및 고의
                또는 중대한 과실로 회사에 손해를 입힌 경우에는 사전 통보 없이 이용계약을 해지할 수 있으며, 이 경우 회원은 유료로 구매한 상품에 대해 사용권한이 상실되고 이로 인한 환불 및 손해배상을
                청구할 수 없습니다.</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; color:#ff0000">5. 회사는 회원의 계정 또는 캐릭터가
                부당한 목적으로 사용되는 것을 방지하고 보다 원활한 서비스 제공을 위하여 12개월 이상 접속기록이 없는 회원의 계정 또는 캐릭터(이하 “휴면계정”이라고 함) 경우 해당 계정 또는 캐릭터를
                삭제할 수 있습니다. 휴면상태로 분류된 경우, 안내메일 또는 공지사항 발표 후 일주일 간의 안내 기간을 거쳐 계정 또는 캐릭터의 모든 정보가 삭제되며 복구되지 않습니다. 회원은 안내 기간
                중 게임 접속 등을 통해 휴면 상태를 해지할 수 있습니다.</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">제24조 이용자에 대한 제한조치</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">1. 회사는 이용자가 본 약관 및 관련 법령을 위반하는 경우 이용자에
                대하여 게임 내에서 일정한 제한조치를 설정할 수 있습니다. 구체적인 의무위반 사유 및 제한조치 등은 개별 게임의 운영정책에서 정합니다.</span><span
                style="font-family:微软雅黑">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">1) 캐릭터의 일부 권한 제한: 일정한 기간 동안 캐릭터의 채팅 등
                게임 기능 제한</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">2) 캐릭터 사용 제한: 지정 이용자의 캐릭터에 대한 임시 계정정지
                혹은 영구정지</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">3) 계정의 사용 제한: 지정 게임계정에 대한 임시 계정정지 혹은
                영구정지</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">4) 이용자의 사용 제한: 지정 이용자에 대한 임시 계정정지 혹은
                영구정지.</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">2. 회사의 제한조치가 정당한 경우, 이용자는 계정이 정지된 기간
                동안의 손해에 대하여 책임을 지며, 회사는 이에 대하여 배상책임을 부담하지 않습니다.</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">제25조 임시조치의 사용</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">1. 회사는 아래에 해당하는 경우 이용자에 대하여 임시 계정정지
                조치, 즉 이용자의 게임 계정을 임시적으로 정지함으로써 정지 기간 동안 이용자가 회사의 게임 상품에 등록할 수 없고 관련 서비스를 사용할 수 없도록 할 수 있습니다.</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; color:#ff0000">1) 이용자의 계정이 해킹 또는 타인에
                의하여 도용된 경우</span></p>
        <p style="text-align:left; font-size:12pt"><span
                style="font-family:微软雅黑; color:#ff0000; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; color:#ff0000">2) 개인이용자 또는 기업에서
                불법프로그램이 사용되는 경우</span></p>
        <p style="text-align:left; font-size:12pt"><span
                style="font-family:微软雅黑; color:#ff0000; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; color:#ff0000">3) 회사가 임시정지 외의 기타 임시적인
                수단을 통하여 관련 상황을 조사하여야 하는 경우</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">2. 회사는 조사가 완료된 후 임시조치를 해제하고 정지된 기간만큼
                이용자의 게임콘텐츠 시간을 반환하거나 연장합니다. 단, 회사의 조사 결과 관련 법령 및 본 약관에 위반한 것으로 판단된 이용자에 대해서는 그러하지 아니합니다.</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">제26조 제한조치 사유 및 절차</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">1. 회사는 이용자가 본 약관을 위반한 행위의 내용, 정도, 횟수,
                결과 등 제반 요소를 고려하여 제한조치를 부과하는 구체적인 이유와 절차를 정합니다.</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">2. 회사가 제25조에서 정한 제한조치를 하는 경우에는, 전자우편을
                통하거나 게임 공식 홈페이지(https://www.blancozone.com/)에서 이용자에게 아래 내용에 대하여 고지하여야 합니다.</span><span
                style="font-family:微软雅黑">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">1) 이용제한 이유</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">2) 이용제한 유형 및 기간</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">3) 이용제한에 대한 이의신청 방법</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">제27조 사용제한에 대한 이의신청</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">1. 회사의 제한조치에 대하여 이의가 있는 경우, 이용자는 통지를
                받은 날로부터 서면으로 회사에 이의를 제출하여야 합니다.</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">2. 회사는 이용자의 서면신청을 받은 날로부터 15일 이내에 서면
                또는 전자우편을 통하여 답변을 하여야 합니다. 회사가 15일 이내에 답변하지 못한 경우에는 지연의 이유 및 처리 일정을 이용자에게 통보하여야 합니다.</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">3. 회사는 위 답변에 따라 상응하는 조치를 취하여야
                합니다.</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">제6장 배상 및 환불</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">제28조 손해배상</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">1. 회사가 고의 또는 중과실로 이용자에게 손해를 끼친 경우, 회사는
                이용자에게 그 손해를 배상하여야 합니다.</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">2. 이용자가 본 약관의 규정을 위반함으로 인하여 회사에 손해를 끼친
                경우, 이용자는 회사에게 그 손해를 배상을 할 책임이 있습니다.</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; color:#ff0000">3. 이용자가 게임콘텐츠를 이용하면서 행한
                불법행위나 본 약관 위반행위로 인하여 회사가 이용자 이외의 제3자로부터 손해배상청구 또는 소송을 비롯한 각종 이의제기를 받는 경우, 이용자는 자신의 책임과 비용으로 회사를 면책시켜야
                하며, 관련 책임과 비용은 이용자가 부담하여야 합니다.</span><span style="font-family:微软雅黑"> 회사가 면책되지 못한 경우 이용자는 그로 인하여 회사에 발생한
                모든 손해를 배상할 책임이 있습니다.</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">4. 회사는 무료로 제공하는 서비스와 관련하여 발생하는 사항에
                대해서는 어떠한 손해도 책임을 지지 않습니다. 단, 회사의 고의나 중과실로 인한 손해인 경우는 예외로 합니다.</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">제29조 환불</span></p>
        <ol type="1" style="margin:0pt; padding-left:0pt">
            <li style="text-align:left; font-family:微软雅黑; font-size:12pt; list-style-position:inside"><span
                    style="font-family:'Malgun Gothic'">아래의 경우에 해당하면 이용자는 환불을 요청할 수 있습니다</span><span>.</span></li>
        </ol>
        <ol type="1" class="awlist1" style="margin:0pt; padding-left:0pt">
            <li
                style="text-align:left; font-family:微软雅黑; font-size:12pt; list-style-position:inside; -aw-list-padding-sml:3.33pt">
                <span style="width:3.33pt; font:7pt 'Times New Roman'; display:inline-block; -aw-import:ignore">&#xa0;
                </span><span style="font-family:'Malgun Gothic'">이용자가 이용약관 제</span><span>21</span><span
                    style="font-family:'Malgun Gothic'">조에 따라 청약을 철회할 경우</span></li>
            <li
                style="text-align:left; font-family:微软雅黑; font-size:12pt; list-style-position:inside; -aw-list-padding-sml:3.33pt">
                <span style="width:3.33pt; font:7pt 'Times New Roman'; display:inline-block; -aw-import:ignore">&#xa0;
                </span><span style="font-family:'Malgun Gothic'">적용되는 다른 법령에 당사가 이용자에게 환불해야 하는 경우가 명확히 규정된 경우</span>
            </li>
        </ol>
        <p style="font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">2. </span><span
                style="font-family:'Malgun Gothic'">제1항에 따라 이용자의 환불 이유가 인정되는 경우 이용자는 이를 환불받을 수 있습니다. </span><span
                style="font-family:'Malgun Gothic'; color:#ff0000">그러나 이용자가 환불받을 수 있는 범위는 이용자가 아직까지 소비하지 않은 부분으로 제한되며,
            </span><span style="font-family:微软雅黑; color:#ff0000">은행이체 및 결제대행수수료 등의 사유로 환불 금액이 10,000원 이내인 경우에는
            </span><span style="font-family:'Malgun Gothic'; color:#ff0000">회사가</span><span
                style="font-family:微软雅黑; color:#ff0000"> 총 금액의 10% 이내의 수수료를 공제하고 나머지 잔액을 환불할 수 있습니다. 이때 만약 총 금액의 10% 이내의
                수수료 공제금액이 환불 금액보다 많은 경우에는 환불하지 않습니다.</span><span style="font-family:微软雅黑; color:#ff0000">&#xa0;</span>
        </p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">3. 이용자가 환불을 요청하고자 하는 경우, 회사에서 정한 절차에
                따라 환불신청을 하여야 하며, 회사는 구매 내역을 확인한 후, 이용자에게 본인확인을 위한 별도의 서류 제출을 요구할 수 있고, 환불신청의 정당성을 심사합니다. 이때 회사는 이용자에게
                중대한 위약행위가 없는지 등 제반 사정을 고려하여 이용자의 요청에 따라 계약을 해제할지를 결정합니다.</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">4. 계속적 이용계약의 경우에는 상품가액에서 이용자가 이미 사용한
                부분에 해당하는 금액(각 상품별 사용금액 산정기준은 상품 구매 시 별도 고지함)을 제외하고 남은 금액에서 남은금액의 10% 이내 수수료 또는 남은 금액이 10,000원 이내인 경우에는
                일정수수료를 공제한 후 나머지 금액을 환불해 드립니다. </span><span style="font-family:微软雅黑; color:#ff0000">일정금액을 공제하는 경우 공제 후
                남은 금액이 공제금액보다 작은 경우에는 환불할 수 없습니다.</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; color:#ff0000">5. 현행법령 및 중대한 조항 위반 등
                이용자의 귀책사유로 이용계약을 해지하는 경우 환불이 제한될 수 있습니다.</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">제30조 면책조항</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; color:#ff0000">1. 회사는 이용자의 귀책사유로 인한
                서비스의 종료, 이용장애, 게임콘텐츠 </span><span style="font-family:'Malgun Gothic'; color:#ff0000">종료</span><span
                style="font-family:微软雅黑; color:#ff0000"> 및 계약해지에 대하여 책임이 면제됩니다.</span></p>
        <p style="text-align:left; font-size:12pt"><span
                style="font-family:微软雅黑; color:#ff0000; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; color:#ff0000">2. 회사의 고의 또는 중대한 과실이 없는
                한, 회사는 이동통신 서비스의 장애[천재지변(예로서, 지진, 홍수, 번개 등, 기계실 주요 설비, 선로나 전기공급 시스템에 중대한 고장이나 화재가 발생하는 경우 등)을 포함하나, 이에
                한하지 아니함]으로 인한 책임이 면제됩니다.</span></p>
        <p style="text-align:left; font-size:12pt"><span
                style="font-family:微软雅黑; color:#ff0000; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; color:#ff0000">3. 회사는 사전에 이용자에게 공지된
                게임콘텐츠용 설비의 보수, 교체, 정기점검, 공사 등 부득이한 사유로 인하여 게임콘텐츠가 종료되거나 장애가 발생한 경우에 대해서 고의 또는 중대한 과실이 없는 한 책임이
                면제됩니다.</span></p>
        <p style="text-align:left; font-size:12pt"><span
                style="font-family:微软雅黑; color:#ff0000; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; color:#ff0000">4. 회사의 고의 또는 중대한 과실이 없는
                한, 회사는 이용자의 컴퓨터와 기타 전자설비에 각종 소프트웨어/하드웨어 장애로 인한 책임이 면제됩니다.</span></p>
        <p style="text-align:left; font-size:12pt"><span
                style="font-family:微软雅黑; color:#ff0000; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; color:#ff0000">5. 이용자는 제3자로부터 게임상품을
                획득하여서는 아니 되며, 만약 이용자가 제3자로부터 게임상품을 취득하였을 경우에는, 이용자는 그에 상응하는 위험을 스스로 부담하고, 회사는 해당 게임상품이 정상적으로 사용될 수 있는 것과
                반환청구를 받지 않는 것을 보장하지 않습니다. 이로 인하여 이용자가 손해를 입었을 경우, 회사는 이에 대한 책임을 지지 않습니다.</span></p>
        <p style="text-align:left; font-size:12pt"><span
                style="font-family:微软雅黑; color:#ff0000; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; color:#ff0000">6. 회사는 이용자 상호간 발생한 분쟁에
                개입할 의무가 없으며, 이에 따라 회사는 이와 같은 유형의 분쟁으로 인한 손해배상책임을 부담할 의무도 없습니다.</span></p>
        <p style="text-align:left; font-size:12pt"><span
                style="font-family:微软雅黑; color:#ff0000; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; color:#ff0000">7. 이용자가 회사가 제공한 무료 제품
                혹은 서비스를 사용함으로 인하여 손해를 입은 경우, 회사는 이에 대한 책임을 지지 않습니다. 단 그 손해가 회사의 고의 또는 중대한 과실에 의한 경우는 제외합니다.</span></p>
        <p style="text-align:left; font-size:12pt"><span
                style="font-family:微软雅黑; color:#ff0000; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; color:#ff0000">8. 회원가입 시 이용자가 잘못된 정보를
                제공하거나 이용자의 잘못된 조작방법, 또는 이용자 자신의 전자기기 고장으로 인하여 손해가 발생한 경우 회사는 일체의 책임을 지지 않습니다.</span></p>
        <p style="text-align:left; font-size:12pt"><span
                style="font-family:微软雅黑; color:#ff0000; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; color:#ff0000">9. 회사는 이용자가 서비스를 이용하면서
                취득한 등급, 아이템, 콘텐츠 등의 소실에 대해서 회사의 고의 또는 중대한 과실로 인한 경우를 제외하고는 책임을 부담하지 않습니다.</span></p>
        <p style="text-align:left; font-size:12pt"><span
                style="font-family:微软雅黑; color:#ff0000; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; color:#ff0000">10. 이용자의 단말기 변경, 번호 변경,
                해외 로밍, 통신사 이동 등의 경우 게임콘텐츠의 전부 또는 일부 기능을 이용할 수 없는 경우가 발생할 수 있으며, 이 경우 회사는 책임지지 않습니다.</span></p>
        <p style="text-align:left; font-size:12pt"><span
                style="font-family:微软雅黑; color:#ff0000; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; color:#ff0000">11. 회사에서 제공하는 게임콘텐츠를
                삭제하는 경우, 이용 정보(점수, 캐릭터, 아이템, 게임머니 등)가 삭제되는 경우가 있을 수 있으므로 이용자는 삭제에 신중을 기하여야 하며 회사는 이에 대해 책임을 지지
                않습니다.</span></p>
        <p style="text-align:left; font-size:12pt"><span
                style="font-family:微软雅黑; color:#ff0000; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; color:#ff0000">12. 회사는 임시회원 기능 이용 중
                발생한 문제에 대해서는 일체 책임을 지지 않습니다.</span></p>
        <p style="text-align:left; font-size:12pt"><span
                style="font-family:微软雅黑; color:#ff0000; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; color:#ff0000">13. 회사는 이용자가 서비스를 이용하여
                기대하는 수익을 얻지 못한 것에 대하여 책임을 지지 않으며, 서비스에 대한 취소 또는 이용으로 발생하는 손해 등에 대해서는 책임을 지지 않습니다.</span></p>
        <p style="text-align:left; font-size:12pt"><span
                style="font-family:微软雅黑; color:#ff0000; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; color:#ff0000">14. 국가 법률, 법규, 정책 및
                국가기관의 명령 등으로 인하여 이용자에게 손실을 끼친 경우, 회사는 이에 대한 책임을 지지 않습니다.</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">제31조 이용자 고발 및 분쟁의 해결</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">1. 이용자 고발 및 분쟁해결의 편리를 위하여, 회사는 게임 초기화면
                및 게임 홈페이지에서 이용자 게시판을 마련하고 이를 담당하는 전문적인 고객서비스부서를 설립함으로써 관련 정보 수집 및 처리를 진행하도록 하여야 합니다.</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">2. 회사는 합리적인 기한 내에 이용자의 의견과 불만을 유효하게
                처리하여야 합니다. 처리기간을 연장하여야 하는 경우, 회사는 홈페이지, 전자우편 혹은 서면의 방법으로 이용자에게 처리 상황을 통지하여야 합니다.</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">3. 회사와 이용자 상호간의 분쟁은 제3의 분쟁조정기관에 조정을
                맡기는 경우, 회사는 사실대로 진술하여야 하고 조정결과를 받아들여야 합니다.</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">제32조 이용자에 대한 통지</span><span
                style="font-family:微软雅黑">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">1. 회사는 서비스를 사용하는 과정에서 이용자가 필요로 하는 각종
                정보에 대하여 서비스화면, 전자우편 또는 서신 우편 등 방식으로 이를 이용자에게 제공할 수 있습니다. 회사는 통지 발송 시에는 이용자가 지정한 전자우편 주소 등 통신방법을 사용하여야
                합니다.</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">2. 회사는 전체 이용자에게 중요한 통지를 발송하여야 할 때 회사
                사이트에서 가장 윗 부분에 해당 통지 내용을 공시하여야 하며, 공시기한은 7일보다 적어서는 아니 됩니다.</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">3. 서비스 개선 및 이용자에 대한 서비스 소개 등을 목적으로 회사는
                이용자의 동의를 받은 후 추가적인 개인정보를 제공하도록 요구할 수 있습니다.</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">제33조 준거법 및 관할권</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">1. 본 약관은 대한민국 법률에 따라 제정 및 해석되고 해당 분쟁을
                접수한 대한민국 법원이 관할권을 가집니다.</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">2. 관련 서비스의 사용에 대하여 회사와 이용자 간에 분쟁이 발생할
                경우, 양 당사자는 협상을 통하여 원만하게 해결하여야 합니다.</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:'Malgun Gothic'">제 </span><span
                style="font-family:微软雅黑">34</span><span style="font-family:'Malgun Gothic'">조 연락방법</span></p>
        <p style="text-align:left; font-size:12pt"><br /><span style="font-family:'Malgun Gothic'">회사</span><span
                style="font-family:微软雅黑"> </span><span style="font-family:'Malgun Gothic'">연락처는</span><span
                style="font-family:微软雅黑"> </span><span style="font-family:微软雅黑">&#xa0;</span><a
                href="mailto:service@Blancozone.com" style="text-decoration:none"><span
                    style="font-family:微软雅黑; color:#000000">service@Blancozone.com</span></a><span
                style="font-family:微软雅黑"> </span><span style="font-family:'Malgun Gothic'">입니다</span><span
                style="font-family:微软雅黑">.</span><br /><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span>
        </p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">「</span><span
                style="font-family:'Malgun Gothic'">게임산업진흥에</span><span style="font-family:微软雅黑"> </span><span
                style="font-family:'Malgun Gothic'">관한</span><span style="font-family:微软雅黑"> </span><span
                style="font-family:'Malgun Gothic'">법률</span><span style="font-family:微软雅黑">」 </span><span
                style="font-family:'Malgun Gothic'">제</span><span style="font-family:微软雅黑">31</span><span
                style="font-family:'Malgun Gothic'">조</span><span style="font-family:微软雅黑"> </span><span
                style="font-family:'Malgun Gothic'">제</span><span style="font-family:微软雅黑">2</span><span
                style="font-family:'Malgun Gothic'">항에</span><span style="font-family:微软雅黑"> </span><span
                style="font-family:'Malgun Gothic'">따라</span><span style="font-family:微软雅黑"> </span><span
                style="font-family:'Malgun Gothic'">회사는</span><span style="font-family:微软雅黑"> </span><span
                style="font-family:'Malgun Gothic'">다음과</span><span style="font-family:微软雅黑"> </span><span
                style="font-family:'Malgun Gothic'">같이</span><span style="font-family:微软雅黑"> </span><span
                style="font-family:'Malgun Gothic'">국내대리인을</span><span style="font-family:微软雅黑"> </span><span
                style="font-family:'Malgun Gothic'">지정합니다</span><span style="font-family:微软雅黑">.</span><br /><br /><span
                style="font-family:'Malgun Gothic'; font-size:10.5pt">국</span><span
                style="font-family:'Malgun Gothic'">내대리인의</span><span style="font-family:微软雅黑"> </span><span
                style="font-family:'Malgun Gothic'">성명</span><span style="font-family:微软雅黑">: 주식회사 버스터</span><br /><span
                style="font-family:'Malgun Gothic'">국내대리인의</span><span style="font-family:微软雅黑"> </span><span
                style="font-family:'Malgun Gothic'">주소</span><span style="font-family:微软雅黑">: 서울특별시 금천구 가산디지털2로 143, 12층
                1201호,1202호(가산 어반워크2)</span><br /><span style="font-family:'Malgun Gothic'">국내대리인의</span><span
                style="font-family:微软雅黑"> </span><span style="font-family:'Malgun Gothic'">전화번호</span><span
                style="font-family:微软雅黑">: 010-2638-1897</span><br /><span
                style="font-family:'Malgun Gothic'">국내대리인의</span><span style="font-family:微软雅黑"> </span><span
                style="font-family:'Malgun Gothic'">전자우편주소</span><span style="font-family:微软雅黑">:
                team@busters.co.kr</span><br /><br /><span style="font-family:'Malgun Gothic'">국내대리인은</span><span
                style="font-family:微软雅黑"> 「</span><span style="font-family:'Malgun Gothic'">게임산업진흥에</span><span
                style="font-family:微软雅黑"> </span><span style="font-family:'Malgun Gothic'">관한</span><span
                style="font-family:微软雅黑"> </span><span style="font-family:'Malgun Gothic'">법률</span><span
                style="font-family:微软雅黑">」</span><span style="font-family:'Malgun Gothic'">에</span><span
                style="font-family:微软雅黑"> </span><span style="font-family:'Malgun Gothic'">따라 부여된</span><span
                style="font-family:微软雅黑"> </span><span style="font-family:'Malgun Gothic'">법정</span><span
                style="font-family:微软雅黑"> </span><span style="font-family:'Malgun Gothic'">의무</span><span
                style="font-family:微软雅黑"> </span><span style="font-family:'Malgun Gothic'">이행만을</span><span
                style="font-family:微软雅黑"> </span><span style="font-family:'Malgun Gothic'">담당하며</span><span
                style="font-family:微软雅黑">, </span><span style="font-family:'Malgun Gothic'">이용자를 대상으로 한 고객</span><span
                style="font-family:微软雅黑"> </span><span style="font-family:'Malgun Gothic'">서비스</span><span
                style="font-family:微软雅黑"> </span><span style="font-family:'Malgun Gothic'">업무는</span><span
                style="font-family:微软雅黑"> </span><span style="font-family:'Malgun Gothic'">담당하지</span><span
                style="font-family:微软雅黑"> </span><span style="font-family:'Malgun Gothic'">않습니다</span><span
                style="font-family:微软雅黑">.</span><br /><span style="font-family:'Malgun Gothic'">서비스</span><span
                style="font-family:微软雅黑"> </span><span style="font-family:'Malgun Gothic'">이용과</span><span
                style="font-family:微软雅黑"> </span><span style="font-family:'Malgun Gothic'">관련하여</span><span
                style="font-family:微软雅黑"> </span><span style="font-family:'Malgun Gothic'">문의 사항이</span><span
                style="font-family:微软雅黑"> </span><span style="font-family:'Malgun Gothic'">있을</span><span
                style="font-family:微软雅黑"> </span><span style="font-family:'Malgun Gothic'">경우</span><span
                style="font-family:微软雅黑">, </span><span style="font-family:'Malgun Gothic'">국내대리인이</span><span
                style="font-family:微软雅黑"> </span><span style="font-family:'Malgun Gothic'">아닌</span><span
                style="font-family:微软雅黑"> </span><span style="font-family:'Malgun Gothic'">회사</span><span
                style="font-family:微软雅黑"> </span><span style="font-family:'Malgun Gothic'">측에</span><span
                style="font-family:微软雅黑"> </span><span style="font-family:'Malgun Gothic'">문의해야</span><span
                style="font-family:微软雅黑"> </span><span style="font-family:'Malgun Gothic'">합니다</span><span
                style="font-family:微软雅黑">.</span><br /><br /><br /><span
                style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">제35조 기타 조항</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">본 약관에 기재되지 않은 사항 및 본 약관의 해석은 정부가 제정한
                관련 법령 혹은 상관례를 따릅니다.</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p><span style="-aw-import:ignore">&#xa0;</span></p>
    </div>
`;

export const zrrglobalTermDetailHtml = `  <div>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">이용약관</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:'Malgun Gothic'">업데이트 일자</span><span
                style="font-family:微软雅黑">: 2025</span><span style="font-family:'Malgun Gothic'">년</span><span
                style="font-family:微软雅黑">10</span><span style="font-family:'Malgun Gothic'">월</span><span
                style="font-family:微软雅黑">22</span><span style="font-family:'Malgun Gothic'">일</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">제1장 총칙</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">제1조 약관의 목적</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">이 약관은 BUILDING-BLOCKS NETWORK TECHNOLOGY CO.LIMITED (이하 “회사”)가 온라인으로 제공하는
                게임상품 및 이에 부수된 제반 서비스(이하 “게임콘텐츠”)의 이용과 관련하여 이용자의 이용을 허용하는 계약상 법적 근거를 제공하고, 본 약관을 토대로 게임콘텐츠를 이용함에 있어 회사와
                이용자 간의 권리, 의무 등 사항을 규정함을 목적으로 합니다.</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">제2조 용어의 정의</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">1. ‘회사’라 함은 디바이스 및 온라인을 통하여 게임콘텐츠를
                제공하는 사업자를 말합니다.</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">2. ‘디바이스’라 함은 콘텐츠를 다운로드 받거나 설치하여 사용할 수
                있는 PC, 휴대전화, 스마트폰, PDA, 태블릿, 휴대용 게임기, 콘솔 게임기 등의 기기를 말합니다.</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">3. ‘이용자’라 함은 본 약관에 동의하고 게임콘텐츠의 이용 자격을
                부여받은 자연인(회원, 임시회원, 비회원이 포함되며, ‘임시회원’이라 함은 회원인증을 하지 않고 게스트로그인 모드로 이용하는 이용자를 의미함)을 말합니다.</span><span
                style="font-family:微软雅黑">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">4. ‘게임콘텐츠’라 함은 회사가 제공하는 모든 게임 및 네트워크
                서비스, 애플리케이션, 게임머니 및 게임 아이템 등 서비스와 관련되어 디지털 방식으로 제작된 내용물 일체뿐만 아니라, 인터넷에 연결하여 순위등록, 게시물 작성, 게임머니 또는 게임 아이템
                등의 구매, 네트워크 게임 이용을 할 수 있도록 회사가 제공하는 게임 및 이에 부수된 부가서비스 일체를 말합니다.</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">5. ‘게임세계’라 함은 게임콘텐츠를 통해 회사가 제정한
                게임규칙(이하 “게임규칙”)에 따라 오락을 하거나 오락게임 등 활동을 구현한 각종 가상환경을 말합니다.</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">6. ‘계정(ID)’이라 함은 회사가 허용하는 범위 내에서 이용자의
                신분 식별과 게임콘텐츠 이용을 위하여 이용자가 선정하는 문자, 숫자 또는 특수문자의 조합을 말합니다.</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">7. ‘계정정보’라 함은 이용자의 계정, 비밀번호, 성명 등 회사에
                제공한 정보 및 게임 이용정보, 이용요금 결제상태 등 생성정보를 통칭합니다.</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">8. ‘캐릭터’라 함은 이용자가 게임콘텐츠의 이용 범위 내에서
                게임콘텐츠에 따라 게임세계 내에서 회사에서 제공하는 방식으로 창조하는 가상인물데이터를 말합니다.</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">9. ‘비밀번호’라 함은 이용자의 계좌정보 안전 및 게임권익보호를
                위해 이용자 자신이 선정하는 문자, 숫자 또는 특수문자의 조합을 말합니다.</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">10. ‘게임머니’라 함은 게임콘텐츠 또는 게임콘텐츠의 구매에
                사용되는 가상 화폐를 말합니다.</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">11. ‘사이버 포인트’라 함은 게임 아이템이나 게임콘텐츠를 이용
                또는 구매하기 위해 사용되는 가상의 데이터로서 회사가 책정하고 무료로 지급하는 것을 말합니다.</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">12. ‘게시물’이라 함은 이용자가 게시판에서 게시한 문자, 그림,
                음성, 영상 또는 이들의 조합으로 이루어진 정보를 말합니다.</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">13. 이 약관에서 사용하는 전문용어의 정의는 이미 정한 것을
                제외하고는 관계 법령에 의합니다.</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">제3조 회사정보의 공시</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">회사는 다음 각 호의 사항을 게임 초기화면이나 게임
                홈페이지(https://www.zrrglobal.com/)에 게시하여 이용자가 이를 바로 알 수 있도록 합니다. 다만 회사의 개인정보처리방침과 구체적인 약관 내용은 링크를 통해 확인할
                있습니다. 8번 항목의 확률 정보는 게임과 웹페이지에 공개됩니다.</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">1. 상호 및 대표자의 성명</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">2. 영업소 소재지(고객서비스센터 포함) 및 전자우편주소</span>
        </p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">3. 전화번호, 팩스번호</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">4. 사업자등록번호, 통신판매업 신고번호</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">5. 개인정보처리방침</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">6. 서비스 이용약관</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">7. 호스팅서비스를 제공하는 사업자의 상호</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">8. 「게임산업진흥에 관한 법률」 등 관련 법령에 따라 표시할 의무가
                있는 확률형 아이템 관련 정보</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">제4조 약관의 공시 및 개정</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">1. 회사는 이 약관의 구체적인 내용을 이용자가 알 수 있도록 게임
                초기화면이나 게임 홈페이지(https://www.zrrglobal.com/)에 본 약관의 조항들을 게시하는 방법으로 이용자에게 공시합니다. 본 약관의 효력은 공시한 후에
                발생합니다.</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">2. 이용자는 회사가 지정한 메일주소에 메일(https://www.zrrglobal.com/)을 보냄으로써, 본 약관 내용에 대한 질의를 할 수 있으며, 회사는 합리적인 시간 내에 답변합니다.</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">3. 회사는 게임콘텐츠 이용자의 편의를 위해 관련 약관을 작성하여야
                합니다. 약정할 약관의 효력이 발생하기에 앞서 회사는 쉬운 용어로 계약 해제·해지조항, 면책조항 및 이용자에 대한 충전잔액반환이나 피해보상 등과 같은 중요한 내용을 이용자가 쉽게 알아볼
                수 있도록 작성하거나, 이러한 중요한 조항들을 굵게 표시하거나 그 제시를 위해 팝업화면을 제공합니다.</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">4. 회사는 「전자상거래 등에서의 소비자보호에 관한 법률」,
                「게임산업진흥에 관한 법률」, 「약관의 규제에 관한 법률」, 「정보통신망이용촉진 및 정보보호 등에 관한 법률」, 「콘텐츠산업진흥법」 등 관련 벌령에 근거하여, 위 법령에 위배하지 않는
                전제 하에 이 약관을 보충 또는 개정할 수 있으며, 약관에 대한 보충 및 개정은 동등한 법적 효력을 가집니다.</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; color:#ff0000">5. 회사는 회사의 재량에 따라 본 약관을
                수시로 개정할 수 있습니다. 회사가 약관을 개정할 경우에는 개정약관 효력발생일의 최소 7일 이전부터 게임 초기화면을 통해 이용자에게 이를 공지합니다. 다만, 이용자에게 불리하거나 중대한
                변경인 경우에는 최소 30일 이전부터 동일한 방법으로 이용자에게 공지하며, 이용자가 인터넷에 연결하여 게임콘텐츠 접속 시 쉽게 확인할 수 있도록 게임 내에서 공지하여야 합니다. 개정약관의
                효력은 공시일 또는 공고 실시일로부터 발생합니다.</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">6. 회사가 약관을 개정할 경우에는 개정약관 공지 후 개정약관의
                적용에 대한 이용자의 동의 여부를 확인합니다. 개정약관 공지시 이용자가 동의 또는 거부의 의사표시를 하지 않으면 승낙한 것으로 간주하겠다는 내용도 함께 공지한 경우에는 이용자가 약관
                시행일까지 거부의사를 표시하지 않는다면 개정약관에 동의한 것으로 간주할 수 있습니다.</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; color:#ff0000">7. 이용자에게는 약관개정 확인을 위해
                비정기적으로 사이트를 방문하거나 공지 창을 확인하여야 할 의무가 있습니다. 만약 이용자가 변경된 약관의 내용에 동의하지 않는 경우, 회사와 이용자는 계약을 해지(회원탈퇴)할 수
                있습니다.</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">제5조 약관 외 준칙</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">회사는 이 약관에 포함되지 아니한 사항에 관하여 「전자상거래 등에서의
                소비자보호에 관한 법률」, 「게임산업진흥에 관한 법률」, 「약관의 규제에 관한 법률」, 「정보통신망이용촉진 및 정보보호 등에 관한 법률」, 「콘텐츠산업진흥법」등 관련 법령을 참조하여
                따릅니다.</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">제6조 운영정책</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">1. 이용자의 권익을 보호하고 게임세계 내 질서를 유지하기 위하여
                회사는 아래와 같이 게임콘텐츠 운영정책(이하 “운영정책”)을 제정합니다.</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">2. 회사는 이용자가 운영정책의 내용을 구체적으로 이해할 수 있도록
                게임 초기화면이나 게임 홈페이지(https://www.zrrglobal.com/)에 이를 공지합니다.</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; color:#ff0000">3. 이용자의 권리 또는 의무에 변경을
                가져오는 것과 관련된 운영정책 개정의 경우에는 본 약관 제4조(약관의 공시 및 개정)에 따릅니다. 만약 이용자의 권리의무와 관련 없는 사항을 개정하는 경우, 본 약관 제6조 제2항의
                방법으로 공지할 수 있습니다.</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">4. 회사는 운영정책의 내용이 본 약관에서 정한 내용과 일치하도록
                유지하며, 운영정책에 대한 개정은 이용자가 예측 가능한 범위에 한하여 할 수 있습니다.</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">제2장 이용조례</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">제7조 이용자 신청 및 방법</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">1. 회사가 제공하는 게임콘텐츠를 이용하고자 하는 경우 이용자는 게임
                초기화면이나 게임 홈페이지에서 이용신청서를 제출하여야 합니다.</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">2. 이용자는 이용신청서 작성 시 회사에서 필요로 하는 각종 정보를
                제공하여야 합니다.</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">3. 이용자는 제1항에 따른 이용신청서 제출 시 반드시 본인의 실명
                및 실제 정보를 기재하여야 합니다. 정보를 허위로 제공하거나 타인의 신원을 도용하는 등 불법 행위를 행하였을 경우 회사는 당해 이용자에 대하여 제공하는 전부 또는 일부 서비스를
            </span><span style="font-family:'Malgun Gothic'">중단 또는 종료</span><span style="font-family:微软雅黑">할 수
                있습니다.</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; color:#ff0000">4. 청소년(19세
                미만</span><span style="font-family:'Malgun Gothic'; color:#ff0000">인</span><span
                style="font-family:微软雅黑; color:#ff0000"> 자.「초·중등교육법 」제2조의 규정에 의한 고등학교에 재학 중인 학생을 포함함)이 이용신청을 할 경우 법정대리인의
                동의를 얻어야 하고, 동의를 이미 받은 청소년이 이용신청을 할 경우에는 위 법령, 약관 및 운영정책에 따르도록 합니다.</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">제8조 이용신청의 승낙과 제한</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; color:#ff0000">1. 이용신청을 하고자 하는 이용자는
                기재할 계정과 개인정보를 준비하여야 하며, 자신이 제공한 개인신원자료에 관한 정보의 진실성, 완전성 및 유효성을 보증하여야 합니다. 회사는 이용조건에 부합되는 신청에 대하여 승낙할 수
                있습니다. 회사는 이용자의 이용신청을 승낙한 때부터 게임콘텐츠에 대한 제공을 개시합니다. 다만, 일부 서비스의 경우에는 회사의 필요에 따라 지정된 일자부터 서비스를 개시할 수 있으며,
                특정 서비스에 대해서는 유료로 제공할 수 있습니다.</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">2. 회사는 다음 각 호의 어느 하나에 해당하는 경우에는 신청을
                거절할 수 있습니다.</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">1) 제7조에 따른 이용자 신청 및 방법 규정에 위반하는
                경우</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">2) 이용요금을 납부하지 않거나, 전액 납부하지 않고 잔액이 완전히
                납부할 수 있을 지 여부를 확인할 수 없는 경우</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">3) 미성년자(제7조 제4항)가 법정대리인의 동의를 얻지 아니하거나
                동의를 얻었음을 확인할 수 없는 경우</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">4) 최근 3개월 내 이용제한 기록이 있는 경우</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">5) 타인의 신용카드, 신원자료를 무단으로 도용하여 게임 가입에
                사용하거나 서비스이용요금을 결제하는 경우</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">6) 대한민국 이외의 국가에서 게임콘텐츠를 이용하고자 하는
                경우</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">7) 게임콘텐츠 제공과 관련하여 일정한 제한을 둘 수 있는
                경우</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">8) 기타 「게임산업진흥에 관한 법률」, 「정보통신망 이용촉진 및
                정보보호 등에 관한 관련 법률」등 규정에 위반하는 경우</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">9) 그 밖에 1호 내지 8호에 준하는 사유와 유사한 행위가 발생하는
                경우</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">3. 회사는 이용자의 이용신청에 대하여 다음 각 호의 어느 하나에
                해당하는 경우에는 그 사유가 해소될 때까지 이용신청에 대한 승낙을 유보하거나 거절할 수 있습니다. 다만, 업무상 또는 기술적인 장애로 인하여 회사가 서비스를 제공할 수 없을 경우 사이트에
                공시하거나 이용자에게 통지하여야 합니다.</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">1) 회사 운영정책에 부합하지 아니한 이용신청을 한 경우(단, 이
                경우 신청인이 회사 정책 상응한 조건에 부합된다고 인정될 때까지)</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">2) 서비스 제공상의 장애 또는 이용요금 결제수단의 장애가 발생한
                경우</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">3) 신청의 승낙에 기술상의 장애가 발생한 경우</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">4. 회사는 서비스를 제공함에 있어 이용자에 대하여 본 약관 외에
                별도 서비스약관의 체결을 요구할 수 있습니다. 별도의 약관체결이 요구되는 게임은 이용자의 동의 및 이용신청 후 이용 가능합니다.</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">5. 회사는 업무상 또는 기술상 특별한 지장이 없는 한, 연중무휴
                1일 24시간 서비스 제공을 원칙으로 합니다. 다만, 시스템 정기점검, 서버의 증설 및 교체, 새로운 게임 내용의 추가, 각종 버그 패치, 새로운 서비스로의 교체 등 운영상 필요한 경우,
                일정기간 서비스를 일시 종료시킬 수 있으며, 이러한 경우 회사는 사전에 그 내용 및 시간을 홈페이지에 공지합니다. 다만, 회사가 사전에 통지할 수 없는 부득이한 사유가 있는 경우 사후에
                통지할 수 있습니다.</span><span style="font-family:微软雅黑">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">6. 회사는 이용자에게 아래와 같은 게임콘텐츠를
                제공합니다.</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">1) 게임 서비스 및 관련 서비스</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">2) 소셜 네트워크 서비스 (SNS)</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">3) 기타 회사가 자체 개발하거나 다른 회사와의 협력 계약 등 방식을
                통해 이용자에게 제공하는 일체의 서비스</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; color:#ff0000">7. 회사는 이용자에게 서비스를 제공함에
                있어 관련 법령, 이용자의 연령, 서비스의 이용 절차에 따라 일부 서비스 이용 등을 제한할 수 있습니다. 이 경우 회사는 해당 내용을 사전에 이용자에게 안내합니다.</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">8. 회사는 이용자의 편의를 위하여 일부 서비스에 대해 ‘임시회원’
                기능을 제공할 수 있습니다. 단, 임시회원 기능 이용 중 아래 각 호에 해당하는 경우 서비스 이용기록 및 구매기록이 삭제되거나 기록을 확인할 수 없는 문제가 발생할 수 있습니다. 따라서
                이러한 사실에 대해 회사는 서비스 최초 이용 시 팝업 등으로 공지할 예정이며 회원인증을 통한 서비스 이용을 권장하며 서비스별로 임시회원이 회원인증을 받는 방식이 다르므로 자세한 사항은
                고객센터 메일로 문의 바랍니다.</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">1) 모바일 기기를 변경한 경우</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">2)</span><span
                style="font-family:微软雅黑">&#xa0;</span><span style="font-family:微软雅黑"> 모바일 기기를 개조하거나 초기화한 경우</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">3)</span><span
                style="font-family:微软雅黑">&#xa0;</span><span style="font-family:微软雅黑"> 모바일 기기에서 어플리케이션 등 콘텐츠를 삭제한
                경우</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">제9조 이용자 계정 및 비밀번호</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">1. 회사가 허용하는 범위 내에서 이용자의 신분식별과 게임콘텐츠
                이용을 위하여 이용자가 선정한 문자, 숫자 또는 특수문자의 조합을 사용합니다.</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">2. 회사는 이용자 가입 시 제공한 신원정보에 대한 진실성과 유효성을
                심사할 수 있습니다.</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">3. 이용자는 자신의 계정과 비밀번호를 적절히 보관하여 이를 정확하고
                안전하게 사용할 의무가 있습니다. 이용자가 위 의무를 소홀히 함으로 인하여 계정 및 비밀번호를 분실하거나 도용 당하거나, 이용자가 제3자에게 이용을 승낙으로써 본인 또는 타인에게 발생하는
                민사상 손해에 대하여는 이용자 본인에게 법률상 책임이 있습니다. 이 경우 회사는 회사의 고의 또는 중과실이 없는 한 면책됩니다.</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">4. 실제 정보로 가입한 이용자가 개인신원자료에 관한 기존 정보를
                변경할 필요가 있는 경우 회사는 적시에 유효하게 이러한 서비스를 제공하여야 합니다.</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">5. 이용자는 적시에 본인의 비밀번호를 변경하여야
                합니다.</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">제10조 이용자 정보의 제공 및 변경</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">1. 이용자는 제공한 개인신원자료에 관한 정보가 진실되고 완전하며
                유효한 것임을 보증하여야 합니다. 허위정보 제공으로 인해 발생한 손해에 대하여 이용자 본인이 책임을 부담하여야 합니다.</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">2. 회원은 개인정보관리화면을 통해 언제든지 자신의 개인정보를 열람할
                수 있습니다. 다만, 서비스 관리를 위해 필요한 실명, 계정(ID) 등은 수정할 수 없습니다.</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">3. 이용자가 등록정보를 변경하고자 하는 경우에는 온라인으로 수정을
                하거나 기타 유효한 연락수단으로 회사에 대하여 그 변경사항을 알려야 합니다.</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">4. 이용자가 회사에 정보 변경사항을 적시에 통지하지 않아 발생한
                손해에 대하여 회사는 책임을 부담하지 않습니다.</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">제11조 개인정보의 관리 및 안전</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">1. 회사는 위 법령에 따라 이용자계정의 안전성과 유효성을 보호하기
                위해 기술상 및 관리상의 합리적인 조치를 적극적으로 취합니다. 회사는 관계 법령의 규정에 따라 이용자 등록정보를 포함한 이용자의 개인정보를 보호하기 위해 노력합니다. 이용자 개인정보의
                보호 및 사용에 대해서는 관련 법령 및 회사의 개인정보처리방침이 적용됩니다. 단, 회사 서비스를 통해 링크된 제3자 제공의 서비스(모든 제3자 사이트 포함)로부터 수집된 개인정보나 회사의
                서비스를 통해 광고 서비스를 하고 있는 다른 회사 또는 기관으로부터 수집된 정보에는 회사의 개인정보처리방침이 적용되지 않습니다.</span><span
                style="font-family:微软雅黑">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">2. 회사에서 이용자를 대상으로 제공하는 게임콘텐츠와 계정정보
                안전보호를 위한 서비스는 이용자 자격이 없는 기타 제3의 이용자에게 적용되지 않습니다.</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; color:#ff0000">3. 게임콘텐츠 이용에 동의한 것은
                이용자의 자율적 의사표시이며, 이용자는 계정정보의 노출이 수반되는 모든 리스크 및 해당 리스크로 인하여 발생한 모든 직∙간접적, 파생적 손해에 대하여 책임을 부담하며, 회사는 이에 대한
                일체적 책임을 지지 않습니다. 다만, 법령에 따라 완전히 배제될 수 없을 경우 회사의 배상책임 한도는 관련 사유로 인하여 이용자가 회사에 지급한 금액에 한합니다. 회사는 이용자의
                귀책사유로 노출된 이용자의 계정정보를 포함한 모든 손해에 대해서 일체의 책임을 지지 않습니다.</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">4. 회사는 이용자의 본인 확인을 위해 필요한 경우, 대한민국 법령상
                적법하게 본인 확인을 할 수 있는 자격을 가진 제3의 기관이나 사업자(“본인확인기관”)를 통하여 본인확인을 진행합니다. 회사는 본인확인기관으로부터 이용자가 입력한 정보에 따른 본인 확인
                결과만을 확인합니다.</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">제3장 회사 및 이용자의 의무</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">제12조 회사의 의무</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">1. 회사는 현행 법령, 정책을 엄격히 준수하고, 법률로 부여받은
                권리를 가지며, 법률 규정에 따라 의무를 이행합니다. 회사는 법령과 본 약관이 금지하거나 미풍양속에 반하는 행위를 하지 않으며, 계속적이고 안정적인 서비스를 제공하기 위하여
                노력합니다.</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">2. 회사는 이용자 안전 및 개인정보(신용정보 포함) 보호를 위해
                반드시 보안시스템을 구축하며 개인정보처리방침을 공시하고 준수함과 동시에 본 약관과 관련 법령을 준수하여야 합니다. 회사는 관련 법령 및 본 약관에서 명확하게 정한 예외적인 경우를
                제외하고는 이용자의 개인정보가 제3자에게 누설되지 않도록 합니다.</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; color:#ff0000">3. 해커공격, 컴퓨터바이러스 감염,
                시스템 붕괴, 네트워크 접속 끊김, 인터넷 속도 저하, 소프트웨어 오류 등 문제로 인한 장애 및 위협이 발생하였을 경우, 이용자는 위 각종 불량 정보, 네트워크 안전 및 인터넷의 장애
                발생은 회사 및 회사의 게임콘텐츠로 인한 것이 아니라는 점과 이러한 문제점 때문에 이용자에게 생길 수 있는 불만, 구역질, 구토 등 정신적 손해 및 다른 손실에 대하여 모두 자체적으로
                책임을 부담하되, 회사가 책임을 지지 아니한다는 점을 충분히 이해하여야 합니다.</span><span
                style="font-family:微软雅黑; color:#ff0000">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">4. 회사는 이용자로부터 제기되는 의견이나 불만이 정당하다고 인정될
                경우에는 즉시 처리합니다. 다만, 바로 처리하기가 곤란한 경우에는 전화나 전자우편으로 그 사유와 처리예정일을 이용자에게 통보합니다.</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">제13조 이용자의 의무</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">1. 이용자는 게임콘텐츠 및 네트워크 서비스 이용에 있어서 본
                약관에서 정하고 있는 사항 및 운영정책 관련 법률 규정을 준수하여야 합니다. 이용자는 다음 각 호의 행위 및 본 약관에 반하는 행위와 현행 법령, 정책에서 금지하는 행위를 하여서는 아니
                됩니다.</span><span style="font-family:微软雅黑">&#xa0;</span><span style="font-family:微软雅黑">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; color:#ff0000">1) 신청 또는 신청 변경 시 허위정보의
                제공</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; color:#ff0000">2) 타인의 신원정보 도용(타인으로
                가장하는 행위 및 타인과의 관계를 허위로 표시하는 행위)</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; color:#ff0000">3) 회사의 임직원, 운영자, 기타
                관계자를 사칭하는 행위(회사의 직원 또는 게시판관리자로 가장하거나 사칭하는 행위, 타인의 명의를 도용하여 문장을 게시하거나 메일을 발송하는 행위 포함)</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; color:#ff0000">4) 회사가 대외적으로 게시한 정보의
                임의적 변경(서비스 공지정보에 대한 변경행위 포함)</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; color:#ff0000">5) 회사가 외부 노출을 금지한 상품 및
                정보(컴퓨터프로그램, 회사 동의 없이 기타 이용자의 개인정보를 수집, 보관, 배포, 게시하는 행위)의 배포, 공유, 전송, 또는 게시</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; color:#ff0000">6) 회사가 대외적으로 제공하지 않는
                컴퓨터프로그램이나 설비의 제작, 배포, 사용, 전송</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; color:#ff0000">7) 회사가 제공하는 게임 상품 또는 그
                소프트웨어 요소 작품의 지식재산권을 침해하는 모든 행위, 또는 회사 또는 기타 이용자의 합법적인 권익에 손해를 끼치는 행위를 진행하는 행위. 회사는 이용자가 이러한 행위를 행하는 것을
                금지하여야 하며 기술상 조치를 취하여 이용자가 이러한 행위에 종사하는 것을 방지할 수 있음.</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; color:#ff0000">8) 회사 및/또는 제3자에 대한 욕설,
                저주, 모욕, 공격, 비방이 포함되는 내용의 공유, 전송; 미신, 음란, 외설, 저질, 공포, 폭력, 흉악, 도박, 반란, 민족혐오, 국가통일방해, 정권전복 등 불만·혐오한 언론의 함유;
                위 내용들이 들어 있는 사이트명칭, 게임 캐릭터 이름(재물성 도박 등 사행행위에 대한 권유, 참여, 또는 상대방에게 수치심, 혐오감, 공포심을 느끼게 하는 언행, 음향, 글, 화상,
                영상의 전송, 공유, 배포행위 포함)의 설치</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; color:#ff0000">9) 게임 데이터(계정, 캐릭터,
                게임아이템 등)의 유상 거래, 또는 권리의 객체에 대한 담보, 대여 등을 제공하는 행위</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; color:#ff0000">10) 게임 데이터(계정, 캐릭터,
                게임아이템 등)의 유상 거래를 공개적으로 광고 선전하고 참여하거나 또는 권리의 객체에 대한 담보, 대여 등을 제공하는 행위(기타 이용자의 캐릭터를 불법 사용하는 행위
                포함)</span><span style="font-family:微软雅黑; color:#ff0000">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; color:#ff0000">11) 회사의 승낙 없이 광고를 발표하고
                상품을 판매하는 상업 행위를 진행하거나 불법적으로 회사 이익을 침해하는 여하한 행위를 진행, 또는 회사 서비스 운영을 고의로 방해하거나 서비스의 안정적 운영을 방해할 수 있는 정보 및
                수신자의 명시적인 수신 거부 의사에 반하여 광고성 정보를 전송</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; color:#ff0000">12) 회사의 사전 승낙 없이 회사의
                서비스 또는 서비스를 이용하여 얻은 정보를 복제, 유통, 조장하거나 상업적으로 이용</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; color:#ff0000">13) 자기 또는 타인의 재산적 이익을
                위한 회사 서비스의 이용 행위</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; color:#ff0000">14) 타인의 명예를 훼손하거나 손해를
                가하는 행위</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; color:#ff0000">15) 명의자의 동의나 승낙 없이 결제
                수단을 무단 도용하여 서비스 이용 요금을 결제</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; color:#ff0000">16) 회사의 지식재산권, 제3자의
                지식재산권, 초상권 등 기타 권리의 침해</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; color:#ff0000">17) 프로그램의 버그를 악용하거나
                서비스와 관련된 설비의 오작동이나 정보 등의 파괴 및 혼란을 유발하는 컴퓨터바이러스 감염자료를 등록 또는 유포, 관련 법령에 의하여 그 전송 또는 게시가 금지되는 정보(컴퓨터프로그램)
                또는 컴퓨터소프트웨어, 하드웨어, 전기통신 장비의 정상적인 가동을 방해, 파괴할 목적으로 고안된 소프트웨어 바이러스, 다른 컴퓨터 코드, 파일, 프로그램을 포함하고 있는 자료를 전송,
                게시, 유포, 사용</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; color:#ff0000">18) 회사가 제공한 서비스 안에서나
                홈페이지상에서 이용자 계정을 현금 거래하는 행위</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; color:#ff0000">19) 결제와 관련된 모든
                부정행위</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; color:#ff0000">20) 회사에서 제공하는 게임콘텐츠 사용법
                외에 타인의 정상적인 게임콘텐츠 이용을 방해 및 타인에게 손해를 가하는 행위</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; color:#ff0000">21) 기타 공공질서 및 미풍양속에
                반하거나 반사회적 행동, 불법∙부당한 행위와 관련 법령에 위배하는 행위</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">2. 이용자는 약관 내용, 회사의 게임콘텐츠 등 관련 주의사항을
                성실하게 열람하고 회사가 공시한 통지와 공지들을 준수할 의무가 있으며 회사의 업무에 방해되는 행위를 하여서는 아니 됩니다. 회원은 수시로 관계 법령, 본 약관의 규정을 비롯하여 회사가
                통지하는 사항 등을 준수하여야 하며, 기타 회사의 업무에 방해되는 행위를 하여서는 아니 됩니다. 이용자는 홈페이지의 공지사항 및 게임운영정책 사항을 수시로 확인하여야 합니다.</span>
        </p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">3. 회사는 다음 각 호의 어느 하나에 해당하는 게임내용이나 서비스
                사항에 대하여 일정한 한도 내에서 제한을 둘 수 있으며, 이용자는 이를 충분히 이해하고 관련 규정을 준수하여야 합니다.</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; color:#ff0000">1) 이용자의 계정명, 캐릭터명, 연맹명,
                그룹명칭에 대한 제한</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; color:#ff0000">2) 채팅 내용과 방법에 대한
                제한</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; color:#ff0000">3) 게시물 내용에 대한 일정한
                제한</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; color:#ff0000">4) 게임플레이방법에 대한
                제한</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; color:#ff0000">5) 기타 이용자의 게임콘텐츠 이용에 대한
                합리적 권리를 침해하지 않는 범위 내에서 회사가 게임콘텐츠 운영상 필요하다고 인정되는 제한</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; color:#ff0000">4. 이용자는 본 서비스를 이용하기 위하여
                자신의 개인정보를 적절히 관리하여야 합니다. 개인정보에 변경이 발생할 경우 상응한 변경 처리를 해야 합니다. 이용자의 개인정보 변경이 지연되거나 누락되어 발생하는 손실은 이용자가
                부담합니다. 이용자의 주소, 연락처, 전자우편 등 이용계약 사항에 변경이 발생할 경우 관련 절차를 통해 회사에 즉시 고지하여야 합니다. 이용자가 제공한 가입정보 및 업데이트한 가입정보가
                정확하지 않을 경우 및 회원이 본조 제1항에 명시된 행위를 행할 경우 회사는 본 약관에 근거하여 회원의 서비스이용을 </span><span
                style="font-family:'Malgun Gothic'; color:#ff0000">중단 </span><span
                style="font-family:微软雅黑; color:#ff0000">또는 </span><span
                style="font-family:'Malgun Gothic'; color:#ff0000">종료</span><span
                style="font-family:微软雅黑; color:#ff0000">할 수 있습니다.</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">5. 이용자는 콘텐츠를 다운로드 받은 디바이스에 대해 책임을 져야
                하며 보관 및 관리를 잘하여 타인이 이용자의 승낙 없이 서비스를 이용하거나 온라인 게임콘텐츠를 이용하는 것을 방지하여야 합니다.</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">6. 이용자는 회사에서 공식적으로 인정한 경우를 제외하고는 서비스를
                이용하여 상품을 판매하는 등의 영업활동을 할 수 없고, 서비스를 통해 취득한 아이템 및 ID 등을 거래에 제공하거나 제공받을 수 없고, 해킹, 광고로부터 수익취득, 상용소프트웨어 불법배포
                등의 행위를 할 수 없으며, 그와 같은 행위를 준비하거나 홍보할 수 없습니다. 이를 위반하여 발생한 영업 활동의 결과 및 손실, 관계기관에 의한 구속 등 법적 조치 등에 관해서는 전적으로
                이용자의 책임으로 하며 회사는 고의 또는 중과실이 없는 한 이에 대해 일체의 책임을 지지 않습니다. 만약 이용자의 이와 같은 행위와 관련하여 회사에 손해가 발생한 경우 이용자는 일체의
                손해배상 책임을 부담합니다.</span><span style="font-family:微软雅黑">&#xa0;</span><span
                style="font-family:微软雅黑">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; color:#ff0000">7. 회사는 본 서비스 등을 유지하기
                위하여 광고를 게재할 수 있으며, 이용자는 서비스 이용 시 노출되는 광고 게재에 대하여 동의합니다.</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">1) 회사가 제공하는 제3자가 주체인 광고에 이용자가 참여하거나 교신
                또는 거래함으로써 발생하는 손실과 손해에 대해서 회사는 어떠한 책임도 부담하지 않습니다.</span><span style="font-family:微软雅黑">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">2) 회사는 서비스 개선 및 이용자 대상 서비스 소개 등을 위한
                목적으로 이용자 개인에 대한 추가정보를 요구할 수 있으며, 동 요청에 대해 이용자는 승낙하여 추가정보를 제공하거나 이를 거부할 수 있습니다.</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; color:#ff0000">3) 회사는 이용자의 사전 동의 하에
                이용자로부터 수집한 개인정보를 활용하는 경우 SMS(LMS), 스마트폰 알림(Push알림), 전자우편을 활용하여 발송할 수 있으며, 이용자는 원하지 않는 경우 언제든지 수신을 거부할 수
                있습니다.</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">8. 이용자가 게임 운영정책사항에 위반되는 행위를 하였을 때 회사는
                이용자에게 게임 이용제재 혹은 경우에 따라 법적 책임을 물을 수 있습니다.</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">제4장 게임콘텐츠 및 이용방법</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">제14조 게임콘텐츠의 변경</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">1. 이용자는 본 약관에 근거하여 회사로부터 게임콘텐츠를 제공받을 수
                있으며, 회사의 운영정책 및 회사가 설정한 게임규칙을 준수합니다.</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">1) 이용자는 이동통신사의 무선인터넷, 오픈마켓 스토어, 애플리케이션
                스토어, 온라인 사이트(포털, 모바일게임 사이트 또는 당사 홈페이지 등) 및 기타 채널을 통하여 회사가 제공하는 콘텐츠를 구매하거나 다운로드할 수 있습니다.</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">2) 회사가 개발한 게임 타이틀은 회사가 거래하는 유통업체 및 온라인
                쇼핑몰 등을 통하여 구매할 수 있습니다.</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">3) 회사가 제공하는 아이템 등은 온라인 사이트, 게임 및
                애플리케이션 내에서 제공하는 네트워크 서비스를 통하여 구매할 수 있습니다.</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">4) 이용자가 이동통신사의 무선인터넷 및 오픈마켓 스토어,
                애플리케이션 스토어를 통하여 모바일 게임, 애플리케이션을 구매하거나 네트워크 서비스를 이용하는 경우 이동통신사에서 정하는 소정의 데이터 통화료가 부과될 수 있습니다.</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">2. 회사가 게임을 통해 이용자에게 제공하는 게임세계는 회사가 창조한
                가상세계이며 회사가 게임콘텐츠의 제작, 변경, 유지보수, 수정에 대한 포괄적인 권한을 보유합니다.</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">3. 회사는 현실세계로부터 게임세계를 보호하고 게임세계의 질서와
                게임성을 유지하기 위하여 필요한 조치를 취할 수 있습니다.</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">4. 회사는 수시로 운영방식을 변경할 수 있는 권한을 보유합니다.
                즉, 요금부과기준, 유료 소프트웨어의 기능, 유료 대상 및 시간 등 내용을 변경할 수 있습니다 또한 회사는 게임콘텐츠 및 제공하는 서비스에 대하여 업그레이드, 버전변경, 증가, 삭제,
                수정하거나 기능변경이나 게임규칙을 변경하는 등 관련 권한을 보유합니다. 이러한 내용의 변경을 하고자 하는 경우 회사는 이용자에게 본 약관 제4조 제5항, 제6항의 방법에 따라 공지합니다.
                이용자가 관련 변경에 동의할 수 없는 경우 게임콘텐츠 에 대한 이용을 즉시 </span><span
                style="font-family:'Malgun Gothic'">종료</span><span style="font-family:微软雅黑">하여야 합니다. 계속적 이용행위는 이용자가 개정된
                운영방식에 대하여 동의한 것으로 간주합니다.</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">제15조 서비스 중단 및 종료</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; color:#ff0000">1. 회사는 경영방침에 따라 이용자에게
                충분한 게임시간을 제공하여야 합니다. 게임 서비스 일정은 게임 초기화면이나 게임 홈페이지(https://www.zrrglobal.com/)에서 공지합니다. 회사는 운영상 또는 기술상의
                필요에 따라 제공하고 있는 서비스를 변경할 수 있습니다. 변경될 서비스의 내용 및 변경 실시 일자 등에 대해서는 이용자에게 사전에 통지합니다. 단, 회사가 사전에 통지할 수 없는 치명적인
                고장 발생, 서버 기기결함, 긴급 보안 문제 해결 등의 부득이한 사정이 있는 경우는 사후에 통지할 수 있습니다.</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; color:#ff0000">2. 회사는 다음 각 호의 어느 하나에
                해당하는 운영상 필요에 따라 게임콘텐츠를 </span><span style="font-family:'Malgun Gothic'; color:#ff0000">중단</span><span
                style="font-family:微软雅黑; color:#ff0000">하고 보수를 진행할 수 있으며, </span><span
                style="font-family:'Malgun Gothic'; color:#ff0000">중단 </span><span
                style="font-family:微软雅黑; color:#ff0000">기간 동안 이용자에게 발생한 손실에 대하여 배상할 의무는 없습니다.</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; color:#ff0000">1) 회사의 컴퓨터 등 설비의 보수점검,
                교체, 정기점검 또는 게임콘텐츠의 수정 및 기타 필요한 경우</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; color:#ff0000">2) 회사가 게임 상품 중 이용자가 버그
                또는 패치를 사용하는 행위를 효과적으로 억제하기 위하여 서비스 중단 유지보수 또는 복구 등 처리조치를 채택할 수 있습니다. 서비스 중단 유지보수 기간 동안 이용자는 게임 상품의 일부
                게임서버 및/또는 일부 게임 구역에 접속할 수 없을 수도 있습니다. 복구라 함은 모든 이용자의 게임 계정상의 게임 데이터를 어느 한 시점에서의 기록에서 이전의 다른 한 시점의 기록으로
                돌려 놓는 것을 말하며 이로 인해 이용자가 이 기간 동안 정상적인 게임 행위를 통해 획득한 게임도구, 게임아이템 등 게임물품의 등급, 포인트, 명예 등이 영구적으로 상실되거나 또는 기타
                손실을 초래할 수 있습니다.</span><span style="font-family:微软雅黑; color:#ff0000">&#xa0;</span><span
                style="font-family:微软雅黑; color:#ff0000"> 이에 대해 이용자는 충분히 숙지하고 자체적으로 책임을 부담하여야 하며, 회사는 어떠한 배상도 하지
                않습니다.</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; color:#ff0000">3) 회사는 재량에 따라 본 약관 및 본
                약관에 따른 권리를 수시로 </span><span style="font-family:'Malgun Gothic'; color:#ff0000">중단</span><span
                style="font-family:微软雅黑; color:#ff0000"> 또는 종료할 수 있습니다. 이러한</span><span
                style="font-family:'Malgun Gothic'; color:#ff0000">중단 혹은</span><span
                style="font-family:微软雅黑; color:#ff0000"> 종료는 회사의 해산, 말소, 합병, 분할 또는 회사의 게임상품이나 그의 운영권한을 제3자에게 양도함으로써 초래될
                수 있으며, 또한 법령, 정책, 국가기관의 명령 또는 지진, 화재, 태풍, 파업, 전쟁 등 불가항력 사유로 인하여 발생할 수도 있습니다. 그리고 위 사유 이외의 기타 원인도
            </span><span style="font-family:'Malgun Gothic'; color:#ff0000">중단이나</span><span
                style="font-family:微软雅黑; color:#ff0000"> 종료를 초래할 수 있습니다.</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">3. 회사가 매 주 또는 격주에 한번씩 게임콘텐츠를 중단하여 보수를
                진행해야 하면, 회사는 최소한 24시간 이전에 게임 초기화면이나 게임 홈페이지에서 서비스 중단을 고지합니다.</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">4. 만약 부득이한 사유로 회사가 이용자에게 서비스
            </span><span style="font-family:'Malgun Gothic'">중단 </span><span style="font-family:微软雅黑">등에 관한 사항을 사전 고지 하지
                못한 경우 빠른 시일 내에 게임 초기화면 및 게임 홈페이지의 첫 페이지에서 서비스 중단 유지보수에 관한 통지를 사후 고지할 수 있습니다.</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; color:#ff0000">5. 이용자가 회사가 제공하는 무료 상품
                또는 서비스를 이용함으로써 손실을 받게 된 경우, 회사의 고의 또는 중과실이 없는 한 회사는 이에 대한 책임을 부담하지 않습니다.</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; color:#ff0000">6. 회사는 제2항 제3호에 의하여
                게임</span><span style="font-family:'Malgun Gothic'; color:#ff0000"> 서비스</span><span
                style="font-family:微软雅黑; color:#ff0000">를 </span><span
                style="font-family:'Malgun Gothic'; color:#ff0000">종료</span><span
                style="font-family:微软雅黑; color:#ff0000">할 경우, 30일 전에 홈페이지에서 서비스 중단고지를 공지하여야 합니다. 부득이한 상황으로 적시에 공지하지 못하였을
                경우 사후에 다시 공지할 수 있습니다.</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; color:#ff0000">7. 회사가 제2항에 의하여
                게임</span><span style="font-family:'Malgun Gothic'; color:#ff0000"> 서비스를</span><span
                style="font-family:微软雅黑; color:#ff0000"> </span><span
                style="font-family:'Malgun Gothic'; color:#ff0000">종료하는</span><span
                style="font-family:微软雅黑; color:#ff0000"> 경우 </span><span
                style="font-family:'Malgun Gothic'; color:#ff0000">환불 및 손해 배상은 「콘텐츠이용자 보호지침」에 따라 처리되며, 이용자는 무료 서비스, 잔여
                사용 기간이 없는 유료 서비스, 연속 유료 사용 항목 또는 정기 유료 항목을 신청할 수 없습니다.</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; color:#ff0000">8. 게임</span><span
                style="font-family:'Malgun Gothic'; color:#ff0000"> 서비스를</span><span
                style="font-family:微软雅黑; color:#ff0000"> 종료하는 경우 </span><span
                style="font-family:'Malgun Gothic'; color:#ff0000">사용 기간에 제한이 없는 유료 항목의 사용 기한은 고지된 서비스 종료 시간에 따라
                종료됩니다.</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; color:#ff0000">9. 회사는 서비스의 변경 및
            </span><span style="font-family:'Malgun Gothic'; color:#ff0000">중단으</span><span
                style="font-family:微软雅黑; color:#ff0000">로 발생하는 문제에 대해서는 책임을 지지 않습니다.</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">제16조 정보제공</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">회사는 게임 홈페이지에서 이용자에게 아래의 정보를 제공하여야
                합니다.</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">1. 상호:</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">2. 게임물 명칭:</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">3. 이용등급:</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">4. 등급분류번호:</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">5. 제작연월일:</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">6. 게임물제작업체 또는 배급업자의 신고번호 또는
                등기번호:</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">7. 기타 회사가 필요하다고 인정하는 사항:</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">제17조 정보의 수집</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">1. 회사는 이용자의 게임 내에서의 채팅내용을 보관할 수 있습니다.
                회사는 이용자간의 분쟁 조정, 민원 처리 또는 게임 질서의 유지를 위하여 회사가 유사한 분쟁 처리에 협조가 필요하다고 판단하는 경우에 관련 이용자의 정보를 열람할 수 있고, 사전에
                열람사유 및 열람범위를 이용자에게 고지합니다. 열람한 내용에 대하여 엄격한 비밀유지의무를 준수하여야 하며, 권한을 부여 받지 아니한 제3자는 절대로 열람할 수 없습니다. 계정 도용,
                현금거래, 언행폭력, 게임사기 등 행위와 연관될 경우 회사는 이용자에게 사전 고지 없이 열람 할 수 있으며, 사후에 다시 이용자에게 관련 결정 및 사유를 통지합니다.</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">2. 회사는 이용자의 디바이스 정보를 수집할 수 있으며, 게임콘텐츠
                개선을 위해 프로그램 최적화를 통해 게임콘텐츠 품질을 보증합니다.</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">제18조 게임콘텐츠의 사용</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">1. 회사는 이용자에게 무료 게임콘텐츠와 유료 게임콘텐츠를 제공할 수
                있습니다. 이용자는 유료 게임콘텐츠를 자유로이 선택할 수 있습니다.</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">1) 회사는 이용자에게 아이템을 포함한 게임콘텐츠를 제공할 수
                있습니다. 회사가 제공한 게임콘텐츠는 회사의 정책에 따라서 이용자에게 이용기한을 정할 수 있으며, 이러한 이용기한은 각 게임콘텐츠 서비스 세부이용 지침에서 정하거나 각 게임콘텐츠 서비스
                결제화면 등에 미리 게시하여 이용자에게 고지합니다.</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">2) 회사는 게임콘텐츠에 필요한 최소한의 기술사양에 관한 정보를
                서비스별 홈페이지 권장사양정보에서 제공하며, 이용자는 게임콘텐츠를 이용하기 위하여 서비스에 이용할 단말기 사양, 유무선 통신망의 품질 등이 해당 게임콘텐츠의 이용에 적합한지를 사전에
                확인하여야 합니다.</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">3) 회사는 게임콘텐츠 중 회원에게 치장성아이템 및 게임에 사용하는
                아이템(이하 '아이템'이라 함) 서비스를 유료 또는 무료로 구분하여 제공할 수 있으며 아이템 관련 정책은 다음을 따릅니다.</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">a. 보증기간이 별도로 명시된 유료아이템의 경우는 구매 시 명기한
                보증기간을 따릅니다. 단, 회사가 이용자에게 지급한 무료아이템의 경우에는 서비스 제공 기간을 보증하지 않습니다.</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; color:#ff0000">b. 보증기간이 '영구'로 표시된
                유료아이템이나 보증기간이 표시되지 않은 유료아이템(이하 '영구아이템'이라 함)에 대한 사용은 게임콘텐츠가 정상적으로 제공되는 기간 동안의 이용권을 보장하는 것이며, 만약 이용자가 이용
                약관상 금지 행위를 하였거나 휴면 ID 또는 휴면 캐릭터로 분류되어 그에 따른 제재로서 당해 ID 또는 캐릭터가 이용제한 또는 삭제되는 경우, 영구아이템의 사용도 종료되며 회사는 이용자에
                대하여 구매대금을 반환할 책임을 부담하지 아니합니다.</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; color:#ff0000">c. 회사는 이용자의 부정한 이용을
                방지하기 위하여 타인으로부터 선물 받은 아이템이나 회사로부터 무료로 제공받은 아이템은 환불하지 않습니다.</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; color:#ff0000">d. 회사는 아이템의 보증 기간에 회사의
                게임 내용의 변경 및 아이템 정책에 따라 기존 아이템의 기능 등을 변경하거나 사용할 수 없도록 변경할 수 있습니다. 이때, 유료로 구매한 아이템 사용이 불가능하게 되는 경우에는 30일
                이상 홈페이지 또는 관련 홈페이지에 공지하고 사용권이 남은 아이템을 유료로 구매한 이용자에 한해 기존 아이템의 잔여 기간을 산정한 뒤 등가의 신규 아이템 등으로 보상합니다.</span>
        </p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">4) 회사가 제공하는 아이템을 포함한 콘텐츠의 지식재산권을 포함한
                모든 소유권은 회사에 있으며, 이용자는 회사가 제공하는 범위 내에서 서비스 이용권을 가집니다. 즉, 이용자는 회사가 제공하는 콘텐츠를 일정기간 동안 회사가 제공하는 서비스 범위 내에서
                이용할 권한을 갖는 것이며, 이를 회사가 정한 방법 이외의 방법으로 이용 또는 사용하거나 양도, 판매할 수 없습니다.</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">2. 게임비용을 지불하는 가격과 지불방식은 회사에 의하여 정합니다.
                게임콘텐츠에 대한 구매 대금은 원칙적으로 이동통신사와 애플리케이션 스토어, 온라인사이트에서 정하는 방법, 정책 등에 따라 부과되며, 납부 방법 역시 정해진 방법에 따라 납부하여야 합니다.
                회사의 정책 및 결제업체(이동통신사, 오픈마켓 스토어, 애플리케이션 스토어 등)의 정책, 정부의 방침 등에 따라 각 결제 수단별로 결제 한도가 부여될 수 있습니다.</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">3. 이용자가 유료 게임콘텐츠를 선택할 경우에는 아래 사항에
                유의하여야 합니다.</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">1) </span><span
                style="font-family:'Malgun Gothic'">이용자는</span><span style="font-family:微软雅黑"> </span><span
                style="font-family:'Malgun Gothic'">게임콘텐츠</span><span style="font-family:微软雅黑"> </span><span
                style="font-family:'Malgun Gothic'">비용을</span><span style="font-family:微软雅黑"> </span><span
                style="font-family:'Malgun Gothic'">전액</span><span style="font-family:微软雅黑"> </span><span
                style="font-family:'Malgun Gothic'">납부하여야</span><span style="font-family:微软雅黑"> </span><span
                style="font-family:'Malgun Gothic'">합니다</span><span style="font-family:微软雅黑">. </span><span
                style="font-family:'Malgun Gothic'">만약 이용자가 환불을 요청하여 본 약관 및 관련 법령을 위반한 상태에서 결제 업체를 통해 환불을 받은
                경우</span><span style="font-family:微软雅黑">, </span><span style="font-family:'Malgun Gothic'">게임콘텐츠 비용을 미납한
                것으로 간주합니다</span><span style="font-family:微软雅黑">. </span><span style="font-family:'Malgun Gothic'">회사는 본
                약관 제</span><span style="font-family:微软雅黑">24</span><span style="font-family:'Malgun Gothic'">조에 따라 이용자가
                미납 금액을 지불할 때까지 제한 조치를 취할 권리가 있습니다</span><span style="font-family:微软雅黑">. </span><span
                style="font-family:'Malgun Gothic'">이용자가 새로운 유료 게임 콘텐츠를 구매하기 위해 미지급 비용을 보충하기 전에 게임콘텐츠 비용을 납부할
                경우</span><span style="font-family:微软雅黑">, </span><span style="font-family:'Malgun Gothic'">회사는 다시 납부한
                비용을 우선적으로 미지급 금액을 공제할 권리가 있습니다</span><span style="font-family:微软雅黑">. </span><span
                style="font-family:'Malgun Gothic'">따라 이용자가 미지급 금액을 보충하기 전에는 새로운 유료 게임 콘텐츠를 정상적으로 구매할 수 없습니다</span><span
                style="font-family:微软雅黑">.</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">2) 유료 게임콘텐츠를 구매한 이용자는 회사가 지정한 방식에 따라
                비용을 지불하여야 합니다. 단, 무통장입금 방식으로 지급한 이용자는 신청한 날로부터 3일 후 동등한 금액을 반드시 입금하여야 하며, 기한이 만료되었으나 미지불인 경우 회사는 해당 거래를
                취소할 권리가 있습니다.</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; color:#ff0000">3) 미성년자가 유료 게임아이템을 구매할
                경우에는 부모 등 법정대리인의 동의를 받아야 합니다. 동의를 받지 않은 유료 게임콘텐츠의 이용자는 법정대리인에게 고지한 후 법정대리인이 비용의 지급을 취소할 수 있습니다.</span>
        </p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">4.</span><span
                style="font-family:'Malgun Gothic'"> 구독</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">1）</span><span
                style="font-family:'Malgun Gothic'">구독은</span><span style="font-family:微软雅黑"> </span><span
                style="font-family:'Malgun Gothic'">자동</span><span style="font-family:微软雅黑"> </span><span
                style="font-family:'Malgun Gothic'">연장</span><span style="font-family:微软雅黑"> </span><span
                style="font-family:'Malgun Gothic'">정액제</span><span style="font-family:微软雅黑"> </span><span
                style="font-family:'Malgun Gothic'">서비스로</span><span style="font-family:微软雅黑"> </span><span
                style="font-family:'Malgun Gothic'">구매</span><span style="font-family:微软雅黑"> </span><span
                style="font-family:'Malgun Gothic'">후</span><span style="font-family:微软雅黑"> </span><span
                style="font-family:'Malgun Gothic'">스토어</span><span style="font-family:微软雅黑"> </span><span
                style="font-family:'Malgun Gothic'">마켓에서</span><span style="font-family:微软雅黑"> </span><span
                style="font-family:'Malgun Gothic'">자동</span><span style="font-family:微软雅黑"> </span><span
                style="font-family:'Malgun Gothic'">결제가</span><span style="font-family:微软雅黑"> </span><span
                style="font-family:'Malgun Gothic'">됩니다</span><span style="font-family:微软雅黑">.</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">2） </span><span
                style="font-family:'Malgun Gothic'">자동</span><span style="font-family:微软雅黑"> </span><span
                style="font-family:'Malgun Gothic'">연장</span><span style="font-family:微软雅黑"> </span><span
                style="font-family:'Malgun Gothic'">규칙</span><span style="font-family:微软雅黑">：</span><span
                style="font-family:'Malgun Gothic'">구독</span><span style="font-family:微软雅黑"> </span><span
                style="font-family:'Malgun Gothic'">기간</span><span style="font-family:微软雅黑"> </span><span
                style="font-family:'Malgun Gothic'">만료</span><span style="font-family:微软雅黑"> </span><span
                style="font-family:'Malgun Gothic'">시</span><span style="font-family:微软雅黑"> </span><span
                style="font-family:'Malgun Gothic'">스토어</span><span style="font-family:微软雅黑"> </span><span
                style="font-family:'Malgun Gothic'">마켓에서</span><span style="font-family:微软雅黑"> </span><span
                style="font-family:'Malgun Gothic'">자동으로</span><span style="font-family:微软雅黑"> </span><span
                style="font-family:'Malgun Gothic'">구독료가</span><span style="font-family:微软雅黑"> </span><span
                style="font-family:'Malgun Gothic'">결제되며</span><span style="font-family:微软雅黑"> </span><span
                style="font-family:'Malgun Gothic'">구독</span><span style="font-family:微软雅黑"> </span><span
                style="font-family:'Malgun Gothic'">기간이</span><span style="font-family:微软雅黑"> </span><span
                style="font-family:'Malgun Gothic'">연장됩니다</span><span style="font-family:微软雅黑">.</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">3）</span><span
                style="font-family:'Malgun Gothic'">자동</span><span style="font-family:微软雅黑"> </span><span
                style="font-family:'Malgun Gothic'">연장</span><span style="font-family:微软雅黑"> </span><span
                style="font-family:'Malgun Gothic'">서비스</span><span style="font-family:微软雅黑"> </span><span
                style="font-family:'Malgun Gothic'">취소를</span><span style="font-family:微软雅黑"> </span><span
                style="font-family:'Malgun Gothic'">원하는</span><span style="font-family:微软雅黑"> </span><span
                style="font-family:'Malgun Gothic'">경우</span><span style="font-family:微软雅黑">, </span><span
                style="font-family:'Malgun Gothic'">최소</span><span style="font-family:微软雅黑"> </span><span
                style="font-family:'Malgun Gothic'">구독</span><span style="font-family:微软雅黑"> </span><span
                style="font-family:'Malgun Gothic'">기간</span><span style="font-family:微软雅黑"> </span><span
                style="font-family:'Malgun Gothic'">만료</span><span style="font-family:微软雅黑"> 24</span><span
                style="font-family:'Malgun Gothic'">시간</span><span style="font-family:微软雅黑"> </span><span
                style="font-family:'Malgun Gothic'">전까지</span><span style="font-family:微软雅黑"> </span><span
                style="font-family:'Malgun Gothic'">스토어</span><span style="font-family:微软雅黑"> </span><span
                style="font-family:'Malgun Gothic'">마켓에서</span><span style="font-family:微软雅黑"> </span><span
                style="font-family:'Malgun Gothic'">자동</span><span style="font-family:微软雅黑"> </span><span
                style="font-family:'Malgun Gothic'">연장을</span><span style="font-family:微软雅黑"> </span><span
                style="font-family:'Malgun Gothic'">수동으로</span><span style="font-family:微软雅黑"> </span><span
                style="font-family:'Malgun Gothic'">취소해야</span><span style="font-family:微软雅黑"> </span><span
                style="font-family:'Malgun Gothic'">합니다</span><span style="font-family:微软雅黑">. </span><span
                style="font-family:'Malgun Gothic'">자동</span><span style="font-family:微软雅黑"> </span><span
                style="font-family:'Malgun Gothic'">연장</span><span style="font-family:微软雅黑"> </span><span
                style="font-family:'Malgun Gothic'">취소</span><span style="font-family:微软雅黑"> </span><span
                style="font-family:'Malgun Gothic'">후</span><span style="font-family:微软雅黑"> </span><span
                style="font-family:'Malgun Gothic'">구독</span><span style="font-family:微软雅黑"> </span><span
                style="font-family:'Malgun Gothic'">기간</span><span style="font-family:微软雅黑"> </span><span
                style="font-family:'Malgun Gothic'">만료</span><span style="font-family:微软雅黑"> </span><span
                style="font-family:'Malgun Gothic'">후</span><span style="font-family:微软雅黑"> </span><span
                style="font-family:'Malgun Gothic'">자동으로</span><span style="font-family:微软雅黑"> </span><span
                style="font-family:'Malgun Gothic'">결제가</span><span style="font-family:微软雅黑"> </span><span
                style="font-family:'Malgun Gothic'">되지</span><span style="font-family:微软雅黑"> </span><span
                style="font-family:'Malgun Gothic'">않고</span><span style="font-family:微软雅黑"> </span><span
                style="font-family:'Malgun Gothic'">이번</span><span style="font-family:微软雅黑"> </span><span
                style="font-family:'Malgun Gothic'">구독</span><span style="font-family:微软雅黑"> </span><span
                style="font-family:'Malgun Gothic'">기간이</span><span style="font-family:微软雅黑"> </span><span
                style="font-family:'Malgun Gothic'">만료될</span><span style="font-family:微软雅黑"> </span><span
                style="font-family:'Malgun Gothic'">때까지</span><span style="font-family:微软雅黑"> </span><span
                style="font-family:'Malgun Gothic'">유효하며</span><span style="font-family:微软雅黑"> </span><span
                style="font-family:'Malgun Gothic'">이미</span><span style="font-family:微软雅黑"> </span><span
                style="font-family:'Malgun Gothic'">결제한</span><span style="font-family:微软雅黑"> </span><span
                style="font-family:'Malgun Gothic'">금액은</span><span style="font-family:微软雅黑"> </span><span
                style="font-family:'Malgun Gothic'">반납되지</span><span style="font-family:微软雅黑"> </span><span
                style="font-family:'Malgun Gothic'">않습니다</span><span style="font-family:微软雅黑">.</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">4）</span><span
                style="font-family:'Malgun Gothic'">자동</span><span style="font-family:微软雅黑"> </span><span
                style="font-family:'Malgun Gothic'">연장을</span><span style="font-family:微软雅黑"> </span><span
                style="font-family:'Malgun Gothic'">취소한</span><span style="font-family:微软雅黑"> </span><span
                style="font-family:'Malgun Gothic'">후</span><span style="font-family:微软雅黑"> </span><span
                style="font-family:'Malgun Gothic'">언제든지</span><span style="font-family:微软雅黑"> </span><span
                style="font-family:'Malgun Gothic'">다시</span><span style="font-family:微软雅黑"> </span><span
                style="font-family:'Malgun Gothic'">구독할</span><span style="font-family:微软雅黑"> </span><span
                style="font-family:'Malgun Gothic'">수</span><span style="font-family:微软雅黑"> </span><span
                style="font-family:'Malgun Gothic'">있습니다</span><span style="font-family:微软雅黑">.</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">5）</span><span
                style="font-family:'Malgun Gothic'">해당</span><span style="font-family:微软雅黑"> </span><span
                style="font-family:'Malgun Gothic'">구독은</span><span style="font-family:微软雅黑"> </span><span
                style="font-family:'Malgun Gothic'">구매</span><span style="font-family:微软雅黑"> </span><span
                style="font-family:'Malgun Gothic'">후</span><span style="font-family:微软雅黑"> </span><span
                style="font-family:'Malgun Gothic'">즉시</span><span style="font-family:微软雅黑"> </span><span
                style="font-family:'Malgun Gothic'">사용이</span><span style="font-family:微软雅黑"> </span><span
                style="font-family:'Malgun Gothic'">시작되거나</span><span style="font-family:微软雅黑"> </span><span
                style="font-family:'Malgun Gothic'">게임</span><span style="font-family:微软雅黑"> </span><span
                style="font-family:'Malgun Gothic'">서비스에</span><span style="font-family:微软雅黑"> </span><span
                style="font-family:'Malgun Gothic'">바로</span><span style="font-family:微软雅黑"> </span><span
                style="font-family:'Malgun Gothic'">적용되는</span><span style="font-family:微软雅黑"> </span><span
                style="font-family:'Malgun Gothic'">콘텐츠이다</span><span style="font-family:微软雅黑">.</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">5. 게임 내 ‘캐시’ 및 ‘금전’의 사용</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">1) 이용자가 보유하고 있는 ‘캐시 또한 금전’ 중 게임 내에서
                퀘스트를 진행하면서 획득하거나, 이벤트로 지급하는 캐시 또는 금전을 ‘무료 캐시’ 및 ‘무료 금전’이라 정의합니다. 획득한 무료 캐시 및 무료 금전은 유효기간, 사용범위 등을 별도로
                공지합니다.</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">2) 무료 캐시 및 무료 금전의 경우, 사용범위가 제한될 수
                있습니다.</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; color:#ff0000">3) 무료 캐시 및 무료 금전은 환불 또는
                보상의 대상이 되지 않습니다. </span><span style="font-family:'Malgun Gothic'; color:#ff0000">결제를 통해 구매한 유료
                상품</span><span style="font-family:微软雅黑; color:#ff0000">(</span><span
                style="font-family:'Malgun Gothic'; color:#ff0000">게임 머니 포함</span><span
                style="font-family:微软雅黑; color:#ff0000">), </span><span
                style="font-family:'Malgun Gothic'; color:#ff0000">무료 캐시 및 무료 금전이 공존하는 경우</span><span
                style="font-family:微软雅黑; color:#ff0000">, </span><span
                style="font-family:'Malgun Gothic'; color:#ff0000">결제를 통해 구매한 유료 상품</span><span
                style="font-family:微软雅黑; color:#ff0000">(</span><span
                style="font-family:'Malgun Gothic'; color:#ff0000">게임 머니 포함</span><span
                style="font-family:微软雅黑; color:#ff0000">)</span><span
                style="font-family:'Malgun Gothic'; color:#ff0000">이 먼저 소모됩니다</span><span
                style="font-family:微软雅黑; color:#ff0000">. </span><span
                style="font-family:'Malgun Gothic'; color:#ff0000">단</span><span
                style="font-family:微软雅黑; color:#ff0000">, </span><span
                style="font-family:'Malgun Gothic'; color:#ff0000">사정에 따라 상품의 이용 순서는 다르게 적용될 수 있으며</span><span
                style="font-family:微软雅黑; color:#ff0000">, </span><span
                style="font-family:'Malgun Gothic'; color:#ff0000">이 경우 홈페이지</span><span
                style="font-family:微软雅黑; color:#ff0000">, </span><span
                style="font-family:'Malgun Gothic'; color:#ff0000">공식카페 등을 통하여 공지합니다</span><span
                style="font-family:微软雅黑; color:#ff0000">.</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">제19조 사이버 포인트</span><span
                style="font-family:微软雅黑">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">1. 회사는 이용자의 정보에 근거하여 이용자에게 사이버 포인트를
                제공할 수 있습니다(이용자 정보는 &lt;개인정보처리방침&gt; 참조). 회사가 정한 유효기간 내에 사용되지 않은 사이버 포인트는 소멸될 수 있습니다.</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">2. 회사에서 제공한 사이버 포인트의 적립에 오류가 있을 경우,
                이용자는 회사에 정정 신청을 할 수 있으며, 회사는 확인한 후 인터넷에서 정정조치를 취할 수 있습니다.</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">3. 회사는 이용자에게 제공한 게임콘텐츠가 곧 만기되는 경우, 회사는
                1개월 전에 유효한 방법으로 이용자에게 관련 통지를 발송하여야 합니다. </span><span style="font-family:微软雅黑; color:#ff0000">회사가 이용자에게
                게임콘텐츠의 제공을 </span><span style="font-family:'Malgun Gothic'; color:#ff0000">종료</span><span
                style="font-family:微软雅黑; color:#ff0000">할 때 이용자에게 미사용 사이버 포인트가 아직 남아있는 경우, 미사용 사이버 포인트는 소멸됩니다.</span>
        </p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">제20조 지식재산권의 귀속</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">1. 본 약관 및 아래 모든 작품 또는 자료의 소유권 및 저작권을
                포함한 모든 지식 재산권은 회사에 귀속하고 관련 법령의 보호를 받습니다.</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">2. 이용자는 회사나 서비스 제공업자의 사전 허가 없이 회사가 제공한
                게임콘텐츠 관련 정보를 제3자에게 이용하게 할 수 없습니다.</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">3. 다음 각 호의 어느 하나에 해당하는 경우, 회사는
                &lt;개인정보처리방침&gt;에 명시되어 있는 방법으로 이용자 정보(이용자가 게임단말기 혹은 게임콘텐츠를 통하여 획득한 정보 등, 및 문자, 이미지, 오디오, 비디오 및 모든 정보)를
                획득 및 사용할 수 있습니다</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">1) 이용자가 애플리케이션을 사용하는 관련 정보, 사용시간, 사용장소
                및 사용방식 포함 (이용자가 애플리케이션에 대하여 변경, 복제, 전달, 발행, 방송 등 행위를 하였는지 여부)</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">2) 회사는 이용자의 사전 동의 없이 이용자가 제작한 작품을 판매,
                임대, 양도할 수 없습니다.</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">4. 회사는 이용자가 게임콘텐츠 내에 게시한 작품(예를 들어 게시판
                게시물)에 대하여 이용자의 명시적인 허락 없이는 무단으로 사용하지 않습니다. 이용자가 서비스 범위 내에서 게시한 게시물의 저작권은 해당 저작권자에 귀속되고 이용자는 해당 게시물을 수시로
                삭제할 수 있습니다.</span><span style="font-family:微软雅黑">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">5. 회사는 이용자가 게임 내 및 게시판에서 제13조 (이용자의
                의무)에서 규정한 금지내용을 게시하였다고 판단하는 경우, 본 약관 및 관련 법령에 근거하여 이에 대하여 상응하는 조치를 취할 수 있습니다.</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">6. 회사가 운영하는 게시판에 게시된 게시물로 인하여 법률상 이익이
                침해된 이용자는 회사에 해당 게시물의 삭제 또는 반박내용의 게재를 요청할 수 있으며, 회사는 유효한 조치를 신속히 취하고, 이를 즉시 이용자에게 통지하여야 합니다.</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">7. 이용자가 회원신분이 해제된 후에도 여전히 회사가 제공하는
                게임콘텐츠를 사용하는 경우, 회사는 제3항 규정에 따라 이용자 정보를 획득 및 사용할 권리가 있습니다.</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">8. 이용자는 회사의 동의 없이 서비스 사용 시 획득한 정보를 영리의
                목적으로 사용하거나 제3자에게 사용하도록 제공하여서는 아니 됩니다.</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">9. 이용자가 게임콘텐츠 내에 게시한 게시물은 검색 혹은 서비스나
                관련 프로모션 활동 등으로 인하여 공개될 수 있습니다. 이때 해당 게시물은 필요한 범위 내에서 일부 수정, 복제, 편집 후 게시될 수 있습니다. 이때 회사는 저작권법의 내용을 준수하여야
                하며, 이용자는 수시로 고객센터 혹은 서비스 관리 기능을 통하여 관련 게시물을 삭제하거나 검색결과에서 배제하거나 비공개로 설정하는 등 처리를 할 수 있습니다.</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">10. 이용자의 게시물이 저작권 등 문제로 인하여 제3자에 의하여
                이의가 제기된 경우, 회사가 해당 이의가 합리적인 이유가 있다고 판단하는 경우, 회사는 이용자에게 사전 통지 없이 해당 게시물을 즉시 삭제하거나 등록을 거부할 수 있습니다. 저작권 및
                권리침해로 인한 게시금지 등 사항은 저작권법 및 관련 법령의 규정에 따릅니다.</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">11. 이 외에는 이용자의 게시물 게시와 관련하여 아래 유의사항이
                있습니다.</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">1) 게시물로 인한 손실 혹은 문제는 이용자 개인이 책임을 지며
                회사는 이에 대하여 책임을 부담하지 않습니다.</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">2) 회사는 관리 상의 필요에 따라 사전 통지 없이 게시물을 이동할
                수 있습니다.</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">3) 타인이 이용자의 게시물이 그 타인의 권리를 침해하였음을 이유로
                회사를 상대로 손해배상 등을 청구한 경우, 게시물을 작성한 이용자는 회사가 면책될 수 있도록 적극 협조하여야 합니다. 회사가 면책되지 못한 경우, 이용자는 이로 인한 문제에 대한 책임을
                부담하여야 합니다.</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">4) 이용자가 작성하거나 전달한 게시물이 다음 중 어느 하나에
                해당하는 경우, 회사는 사전 통지 없이 이를 삭제하거나 등록을 거부할 수 있습니다.</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">a. 다른 이용자 혹은 다른 사람에 대하여 비방, 사생활 침해,
                모욕행위를 하거나, 혹은 이로 인하여 타인의 명예를 훼손한 경우</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">b. 서비스의 안정적인 운영에 영향을 미치거나 미칠 가능성이 있는
                경우</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">c. 범죄행위와 관련된 내용이라고 판단되는 경우</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">d. 회사 및 제3자의 지식재산권 등 기타 권리를 침해하는 내용이
                있는 경우.</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">제5장 청약 철회 및 계약해제</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">제21조 청약 철회</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">1. 원칙적으로, 회사로부터 유료 게임상품을 구매한 이용자는 구매일
                혹은 지불일로부터 7일 내에 청약철회를 할 수 있습니다. 회사가 이용자에게 제공하는 유료 콘텐츠는 청약철회가 가능한 콘텐츠와 청약철회가 제한되는 콘텐츠로 구분되어 제공됩니다. 유료로 직접
                구매하여 청약철회가 가능한 유료 콘텐츠에 대해서는 구매 후 7일 기간 내에 청약철회를 할 수 있습니다. 단, 선물 및 이벤트 보상 등의 방법으로 회사나 제3자로부터 제공받은 콘텐츠 또는
                구매 즉시 효과가 발생하는 등 일부 사용한 콘텐츠의 경우 등에는 관련법령에 따라 청약철회가 제한될 수 있으며, 이 경우 회사는 관련 법령에서 정한 바에 따른 조치를 취합니다.</span>
        </p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; color:#ff0000">2. 이용자는 아래 경우에 청약철회를 할
                수 없습니다.</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; color:#ff0000">1) 이용자에게 책임이 있는 사유로 재화
                등이 멸실 되거나 훼손된 경우</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; color:#ff0000">2) 이용자의 구매, 사용시간이 지나 다시
                판매하기 곤란할 경우</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; color:#ff0000">3) 제품의 포장이 훼손된
                경우</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; color:#ff0000">4) 서비스 이용과정에서 획득한 아이템의
                경우</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; color:#ff0000">5) 구매 후 즉시 사용이 시작되거나 게임
                서비스에 바로 적용되는 콘텐츠의 경우</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; color:#ff0000">6) 부가적인 혜택이 제공되는 아이템 또는
                묶음형 판매 콘텐츠에서 이미 추가 혜택이 사용되거나 일부가 사용되어 회수가 불가능한 경우</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; color:#ff0000">7) 개봉 시 효용이 결정되는
                캡슐형/확률형 아이템을 개봉한 경우</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; color:#ff0000">8) 회사가 이용자에게 무료로 지급한 재화
                및 아이템</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; color:#ff0000">9) 타인으로부터 선물 받은 유료재화 및
                유료아이템</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; color:#ff0000">10) 그 밖에 거래의 안전을 위하여 관련
                법령에 의하여 2차 거래가 명시적으로 금지된 경우</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">3. 회사는 본조 제2항 제2호부터 제8호까지 규정에 따라 이용자의
                철회신청을 받아들이지 아니할 경우에는 상품 포장에 표기 및 설명을 하거나 사전에 이용자에게 테스트용 서비스를 제공합니다. 만약 회사가 이러한 조치를 하지 않을 경우 이용자는 위 조항에도
                불구하고 청약을 철회할 수 있습니다.</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">4. 이용자는 본조 제2항 제1호부터 제3호까지의 규정에도 불구하고
                유료 게임상품의 내용이 표시·광고 내용과 다르거나 계약내용과 다르게 이행된 경우에는 구매 후 3개월 내에 청약철회를 신청할 수 있고, 구매한 상품과 계약서에서 약정한 상품이 동일하지
                아니함을 안 날로부터 30일 내에 청약을 철회할 수 있습니다.</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">5. 미성년자가 법정대리인의 동의 없이 유료 게임상품을 구매한 경우,
                미성년자 또는 법정대리인은 회사에 청약철회를 요청할 수 있으며, 회사는 법정대리인임을 증명할 수 있는 서류를 요구할 수 있습니다. </span><span
                style="font-family:微软雅黑; color:#ff0000">단, 미성년자의 구매가 법정대리인으로부터 처분을 허락 받은 재산의 범위 내인 경우 또는 미성년자가 사술 등을
                사용하여 성인으로 하여금 믿게 한 때에는 취소가 제한됩니다. 구매자의 미성년자 여부는 구매가 진행된 단말기 또는 신용카드 등 결제수단의 명의자를 기준으로 판단됩니다.</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">6. </span><span
                style="font-family:'Malgun Gothic'">상기</span><span style="font-family:微软雅黑"> </span><span
                style="font-family:'Malgun Gothic'">제</span><span style="font-family:微软雅黑">21</span><span
                style="font-family:'Malgun Gothic'">조</span><span style="font-family:微软雅黑"> </span><span
                style="font-family:'Malgun Gothic'">제</span><span style="font-family:微软雅黑">1</span><span
                style="font-family:'Malgun Gothic'">항</span><span style="font-family:微软雅黑"> </span><span
                style="font-family:'Malgun Gothic'">내지</span><span style="font-family:微软雅黑"> </span><span
                style="font-family:'Malgun Gothic'">제</span><span style="font-family:微软雅黑">5</span><span
                style="font-family:'Malgun Gothic'">항의</span><span style="font-family:微软雅黑"> </span><span
                style="font-family:'Malgun Gothic'">경우</span><span style="font-family:微软雅黑"> </span><span
                style="font-family:'Malgun Gothic'">외에도</span><span style="font-family:微软雅黑"> </span><span
                style="font-family:'Malgun Gothic'">이용자는</span><span style="font-family:微软雅黑"> </span><span
                style="font-family:'Malgun Gothic'">기타</span><span style="font-family:微软雅黑"> </span><span
                style="font-family:'Malgun Gothic'">적용되는</span><span style="font-family:微软雅黑"> </span><span
                style="font-family:'Malgun Gothic'">법령에</span><span style="font-family:微软雅黑"> </span><span
                style="font-family:'Malgun Gothic'">따라</span><span style="font-family:微软雅黑"> </span><span
                style="font-family:'Malgun Gothic'">청약</span><span style="font-family:微软雅黑"> </span><span
                style="font-family:'Malgun Gothic'">철회를</span><span style="font-family:微软雅黑"> </span><span
                style="font-family:'Malgun Gothic'">할</span><span style="font-family:微软雅黑"> </span><span
                style="font-family:'Malgun Gothic'">수</span><span style="font-family:微软雅黑"> </span><span
                style="font-family:'Malgun Gothic'">있습니다</span><span style="font-family:微软雅黑">. </span><span
                style="font-family:'Malgun Gothic'; color:#ff0000">단</span><span
                style="font-family:微软雅黑; color:#ff0000">, </span><span
                style="font-family:'Malgun Gothic'; color:#ff0000">본</span><span
                style="font-family:微软雅黑; color:#ff0000"> </span><span
                style="font-family:'Malgun Gothic'; color:#ff0000">약관</span><span
                style="font-family:微软雅黑; color:#ff0000"> </span><span
                style="font-family:'Malgun Gothic'; color:#ff0000">제</span><span
                style="font-family:微软雅黑; color:#ff0000">21</span><span
                style="font-family:'Malgun Gothic'; color:#ff0000">조</span><span
                style="font-family:微软雅黑; color:#ff0000"> </span><span
                style="font-family:'Malgun Gothic'; color:#ff0000">제</span><span
                style="font-family:微软雅黑; color:#ff0000">1</span><span
                style="font-family:'Malgun Gothic'; color:#ff0000">항</span><span
                style="font-family:微软雅黑; color:#ff0000"> </span><span
                style="font-family:'Malgun Gothic'; color:#ff0000">내지</span><span
                style="font-family:微软雅黑; color:#ff0000"> </span><span
                style="font-family:'Malgun Gothic'; color:#ff0000">제</span><span
                style="font-family:微软雅黑; color:#ff0000">5</span><span
                style="font-family:'Malgun Gothic'; color:#ff0000">항의</span><span
                style="font-family:微软雅黑; color:#ff0000"> </span><span
                style="font-family:'Malgun Gothic'; color:#ff0000">경우에</span><span
                style="font-family:微软雅黑; color:#ff0000"> </span><span
                style="font-family:'Malgun Gothic'; color:#ff0000">해당하지</span><span
                style="font-family:微软雅黑; color:#ff0000"> </span><span
                style="font-family:'Malgun Gothic'; color:#ff0000">않고</span><span
                style="font-family:微软雅黑; color:#ff0000"> </span><span
                style="font-family:'Malgun Gothic'; color:#ff0000">여하한</span><span
                style="font-family:微软雅黑; color:#ff0000"> </span><span
                style="font-family:'Malgun Gothic'; color:#ff0000">법령에</span><span
                style="font-family:微软雅黑; color:#ff0000"> </span><span
                style="font-family:'Malgun Gothic'; color:#ff0000">의하여</span><span
                style="font-family:微软雅黑; color:#ff0000"> </span><span
                style="font-family:'Malgun Gothic'; color:#ff0000">청약</span><span
                style="font-family:微软雅黑; color:#ff0000"> </span><span
                style="font-family:'Malgun Gothic'; color:#ff0000">철회가</span><span
                style="font-family:微软雅黑; color:#ff0000"> </span><span
                style="font-family:'Malgun Gothic'; color:#ff0000">허용되는</span><span
                style="font-family:微软雅黑; color:#ff0000"> </span><span
                style="font-family:'Malgun Gothic'; color:#ff0000">것도</span><span
                style="font-family:微软雅黑; color:#ff0000"> </span><span
                style="font-family:'Malgun Gothic'; color:#ff0000">아닌</span><span
                style="font-family:微软雅黑; color:#ff0000"> </span><span
                style="font-family:'Malgun Gothic'; color:#ff0000">경우</span><span
                style="font-family:微软雅黑; color:#ff0000">, </span><span
                style="font-family:'Malgun Gothic'; color:#ff0000">이용자는</span><span
                style="font-family:微软雅黑; color:#ff0000"> </span><span
                style="font-family:'Malgun Gothic'; color:#ff0000">청약을</span><span
                style="font-family:微软雅黑; color:#ff0000"> </span><span
                style="font-family:'Malgun Gothic'; color:#ff0000">철회할</span><span
                style="font-family:微软雅黑; color:#ff0000"> </span><span
                style="font-family:'Malgun Gothic'; color:#ff0000">수</span><span
                style="font-family:微软雅黑; color:#ff0000"> </span><span
                style="font-family:'Malgun Gothic'; color:#ff0000">없습니다</span><span
                style="font-family:微软雅黑; color:#ff0000">.</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">7. 이용자는 구두 또는 서면(전자메일 포함) 등 형식으로 청약철회를
                할 수 있습니다.</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">제22조 청약철회 등의 효과</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">1. 이용자가 청약철회를 한 경우 회사는 지체 없이 이용자의 유료
                게임상품을 회수 또는 삭제하고, 유료 게임상품을 회수 또는 삭제한 날로부터 3영업일 이내에 지급받은 대금을 환급합니다. 동일한 방법으로 환불이 불가할 경우 이를 사전에
                고지합니다.</span><span style="font-family:微软雅黑">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">2. 이용자의 권익을 보장하기 위하여, 회사가 이용자에게 환급을
                지연한 때에는 그 지연기간에 대하여 전자상거래 등에서의 소비자보호에 관한 법률 및 시행령에서 정하는 이율을 곱하여 산정한 지연이자를 지급합니다.</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">3. 위 대금을 환급함에 있어서 이용자가 신용카드나 그 밖에 이용자
                계좌 정보의 안전을 보장하는 유사한 방식으로 지급하였는데 해당 대금이 회사에 입금되지 않은 경우, 회사는 신용카드를 발급한 금융기관 또는 결제수단을 제공한 사업자(이하 “금융기관
                등”)에게 빠른 시일 내로 이용자에게 지급받은 금액을 환급할 것을 통지하여야 합니다. 회사가 위 금융기관 등으로부터 대금을 이미 지급받은 경우, 회사는 해당 금액을 금융기관 등에 반환하고
                금융기관 등이 다시 이를 이용자에게 반환하여야 합니다. 회사는 위 금액 환급 관련 사항을 이용자에게 고지하여야 합니다.</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">4. 회사는 이미 유료 콘텐츠 등이 일부 사용되거나 일부 소비된
                경우에는 그 콘텐츠 등의 일부 사용 또는 일부 소비에 의하여 이용자가 얻은 이익 또는 그 콘텐츠의 공급에 든 비용에 상당하는 금액을 이용자에게 청구할 수 있습니다</span><span
                style="font-family:微软雅黑">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">5. 이용자가 청약철회를 신청한 경우 제품 혹은 서비스의 반환에
                필요한 비용은 이용자가 부담하고, 회사는 이용자에게 청약철회를 이유로 위약금 또는 손해배상을 청구할 수 없습니다.</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">제23조 회사의 계약해지 신청</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">1. 이용자가 본 약관에서 정한 이용자의 의무를 위반한 경우, 회사는
                이용자에게 게임콘텐츠 계약의 해지를 요청할 수 있습니다. 회사는 이용자의 실제 본인 여부를 확인한 후 필요한 조치를 취합니다.</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">2. 회사가 이용계약을 해지하는 경우 회사는 이용자에게 서면으로 다음
                각 호의 사항을 통보합니다.</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">1) 해지사유</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">2) 해지일</span><span
                style="font-family:微软雅黑">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; color:#ff0000">3. 제1항에 따라 이용자는 유료서비스를
                비롯한 게임콘텐츠의 사용권한을 상실하고, 이로 인한 환불 및 손해배상을 청구할 수 없습니다.</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; color:#ff0000">4. 회사는 이용자가 현행법 위반 및 고의
                또는 중대한 과실로 회사에 손해를 입힌 경우에는 사전 통보 없이 이용계약을 해지할 수 있으며, 이 경우 회원은 유료로 구매한 상품에 대해 사용권한이 상실되고 이로 인한 환불 및 손해배상을
                청구할 수 없습니다.</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; color:#ff0000">5. 회사는 회원의 계정 또는 캐릭터가
                부당한 목적으로 사용되는 것을 방지하고 보다 원활한 서비스 제공을 위하여 12개월 이상 접속기록이 없는 회원의 계정 또는 캐릭터(이하 “휴면계정”이라고 함) 경우 해당 계정 또는 캐릭터를
                삭제할 수 있습니다. 휴면상태로 분류된 경우, 안내메일 또는 공지사항 발표 후 일주일 간의 안내 기간을 거쳐 계정 또는 캐릭터의 모든 정보가 삭제되며 복구되지 않습니다. 회원은 안내 기간
                중 게임 접속 등을 통해 휴면 상태를 해지할 수 있습니다.</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">제24조 이용자에 대한 제한조치</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">1. 회사는 이용자가 본 약관 및 관련 법령을 위반하는 경우 이용자에
                대하여 게임 내에서 일정한 제한조치를 설정할 수 있습니다. 구체적인 의무위반 사유 및 제한조치 등은 개별 게임의 운영정책에서 정합니다.</span><span
                style="font-family:微软雅黑">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">1) 캐릭터의 일부 권한 제한: 일정한 기간 동안 캐릭터의 채팅 등
                게임 기능 제한</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">2) 캐릭터 사용 제한: 지정 이용자의 캐릭터에 대한 임시 계정정지
                혹은 영구정지</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">3) 계정의 사용 제한: 지정 게임계정에 대한 임시 계정정지 혹은
                영구정지</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">4) 이용자의 사용 제한: 지정 이용자에 대한 임시 계정정지 혹은
                영구정지.</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">2. 회사의 제한조치가 정당한 경우, 이용자는 계정이 정지된 기간
                동안의 손해에 대하여 책임을 지며, 회사는 이에 대하여 배상책임을 부담하지 않습니다.</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">제25조 임시조치의 사용</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">1. 회사는 아래에 해당하는 경우 이용자에 대하여 임시 계정정지
                조치, 즉 이용자의 게임 계정을 임시적으로 정지함으로써 정지 기간 동안 이용자가 회사의 게임 상품에 등록할 수 없고 관련 서비스를 사용할 수 없도록 할 수 있습니다.</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; color:#ff0000">1) 이용자의 계정이 해킹 또는 타인에
                의하여 도용된 경우</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; color:#ff0000">2) 개인이용자 또는 기업에서
                불법프로그램이 사용되는 경우</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; color:#ff0000">3) 회사가 임시정지 외의 기타 임시적인
                수단을 통하여 관련 상황을 조사하여야 하는 경우</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">2. 회사는 조사가 완료된 후 임시조치를 해제하고 정지된 기간만큼
                이용자의 게임콘텐츠 시간을 반환하거나 연장합니다. 단, 회사의 조사 결과 관련 법령 및 본 약관에 위반한 것으로 판단된 이용자에 대해서는 그러하지 아니합니다.</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">제26조 제한조치 사유 및 절차</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">1. 회사는 이용자가 본 약관을 위반한 행위의 내용, 정도, 횟수,
                결과 등 제반 요소를 고려하여 제한조치를 부과하는 구체적인 이유와 절차를 정합니다.</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">2. 회사가 제25조에서 정한 제한조치를 하는 경우에는, 전자우편을
                통하거나 게임 공식 홈페이지(https://www.zrrglobal.com/)에서 이용자에게 아래 내용에 대하여 고지하여야 합니다.</span><span
                style="font-family:微软雅黑">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">1) 이용제한 이유</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">2) 이용제한 유형 및 기간</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">3) 이용제한에 대한 이의신청 방법</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">제27조 사용제한에 대한 이의신청</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">1. 회사의 제한조치에 대하여 이의가 있는 경우, 이용자는 통지를
                받은 날로부터 서면으로 회사에 이의를 제출하여야 합니다.</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">2. 회사는 이용자의 서면신청을 받은 날로부터 15일 이내에 서면
                또는 전자우편을 통하여 답변을 하여야 합니다. 회사가 15일 이내에 답변하지 못한 경우에는 지연의 이유 및 처리 일정을 이용자에게 통보하여야 합니다.</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">3. 회사는 위 답변에 따라 상응하는 조치를 취하여야
                합니다.</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">제6장 배상 및 환불</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">제28조 손해배상</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">1. 회사가 고의 또는 중과실로 이용자에게 손해를 끼친 경우, 회사는
                이용자에게 그 손해를 배상하여야 합니다.</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">2. 이용자가 본 약관의 규정을 위반함으로 인하여 회사에 손해를 끼친
                경우, 이용자는 회사에게 그 손해를 배상을 할 책임이 있습니다.</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; color:#ff0000">3. 이용자가 게임콘텐츠를 이용하면서 행한
                불법행위나 본 약관 위반행위로 인하여 회사가 이용자 이외의 제3자로부터 손해배상청구 또는 소송을 비롯한 각종 이의제기를 받는 경우, 이용자는 자신의 책임과 비용으로 회사를 면책시켜야
                하며, 관련 책임과 비용은 이용자가 부담하여야 합니다.</span><span style="font-family:微软雅黑"> 회사가 면책되지 못한 경우 이용자는 그로 인하여 회사에 발생한
                모든 손해를 배상할 책임이 있습니다.</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">4. 회사는 무료로 제공하는 서비스와 관련하여 발생하는 사항에
                대해서는 어떠한 손해도 책임을 지지 않습니다. 단, 회사의 고의나 중과실로 인한 손해인 경우는 예외로 합니다.</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">제29조 환불</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">1.아래의 경우에 해당하면 이용자는 환불을 요청할 수 있습니다.</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">2. 이용자가 이용약관 제21조에 따라 청약을 철회할 경우</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">3. 적용되는 다른 법령에 당사가 이용자에게 환불해야 하는 경우가 명확히 규정된 경우</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">2. </span><span
                style="font-family:'Malgun Gothic'">제1항에 따라 이용자의 환불 이유가 인정되는 경우 이용자는 이를 환불받을 수 있습니다. </span><span
                style="font-family:'Malgun Gothic'; color:#ff0000">그러나 이용자가 환불받을 수 있는 범위는 이용자가 아직까지 소비하지 않은 부분으로 제한되며,
            </span><span style="font-family:微软雅黑; color:#ff0000">은행이체 및 결제대행수수료 등의 사유로 환불 금액이 10,000원 이내인 경우에는
            </span><span style="font-family:'Malgun Gothic'; color:#ff0000">회사가</span><span
                style="font-family:微软雅黑; color:#ff0000"> 총 금액의 10% 이내의 수수료를 공제하고 나머지 잔액을 환불할 수 있습니다. 이때 만약 총 금액의 10% 이내의
                수수료 공제금액이 환불 금액보다 많은 경우에는 환불하지 않습니다.</span><span style="font-family:微软雅黑; color:#ff0000">&#xa0;</span>
        </p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">3. 이용자가 환불을 요청하고자 하는 경우, 회사에서 정한 절차에
                따라 환불신청을 하여야 하며, 회사는 구매 내역을 확인한 후, 이용자에게 본인확인을 위한 별도의 서류 제출을 요구할 수 있고, 환불신청의 정당성을 심사합니다. 이때 회사는 이용자에게
                중대한 위약행위가 없는지 등 제반 사정을 고려하여 이용자의 요청에 따라 계약을 해제할지를 결정합니다.</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">4. 계속적 이용계약의 경우에는 상품가액에서 이용자가 이미 사용한
                부분에 해당하는 금액(각 상품별 사용금액 산정기준은 상품 구매 시 별도 고지함)을 제외하고 남은 금액에서 남은금액의 10% 이내 수수료 또는 남은 금액이 10,000원 이내인 경우에는
                일정수수료를 공제한 후 나머지 금액을 환불해 드립니다. </span><span style="font-family:微软雅黑; color:#ff0000">일정금액을 공제하는 경우 공제 후
                남은 금액이 공제금액보다 작은 경우에는 환불할 수 없습니다.</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; color:#ff0000">5. 현행법령 및 중대한 조항 위반 등
                이용자의 귀책사유로 이용계약을 해지하는 경우 환불이 제한될 수 있습니다.</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">제30조 면책조항</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; color:#ff0000">1. 회사는 이용자의 귀책사유로 인한
                서비스의 종료, 이용장애, 게임콘텐츠 </span><span style="font-family:'Malgun Gothic'; color:#ff0000">종료</span><span
                style="font-family:微软雅黑; color:#ff0000"> 및 계약해지에 대하여 책임이 면제됩니다.</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; color:#ff0000">2. 회사의 고의 또는 중대한 과실이 없는
                한, 회사는 이동통신 서비스의 장애[천재지변(예로서, 지진, 홍수, 번개 등, 기계실 주요 설비, 선로나 전기공급 시스템에 중대한 고장이나 화재가 발생하는 경우 등)을 포함하나, 이에
                한하지 아니함]으로 인한 책임이 면제됩니다.</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; color:#ff0000">3. 회사는 사전에 이용자에게 공지된
                게임콘텐츠용 설비의 보수, 교체, 정기점검, 공사 등 부득이한 사유로 인하여 게임콘텐츠가 종료되거나 장애가 발생한 경우에 대해서 고의 또는 중대한 과실이 없는 한 책임이
                면제됩니다.</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; color:#ff0000">4. 회사의 고의 또는 중대한 과실이 없는
                한, 회사는 이용자의 컴퓨터와 기타 전자설비에 각종 소프트웨어/하드웨어 장애로 인한 책임이 면제됩니다.</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; color:#ff0000">5. 이용자는 제3자로부터 게임상품을
                획득하여서는 아니 되며, 만약 이용자가 제3자로부터 게임상품을 취득하였을 경우에는, 이용자는 그에 상응하는 위험을 스스로 부담하고, 회사는 해당 게임상품이 정상적으로 사용될 수 있는 것과
                반환청구를 받지 않는 것을 보장하지 않습니다. 이로 인하여 이용자가 손해를 입었을 경우, 회사는 이에 대한 책임을 지지 않습니다.</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; color:#ff0000">6. 회사는 이용자 상호간 발생한 분쟁에
                개입할 의무가 없으며, 이에 따라 회사는 이와 같은 유형의 분쟁으로 인한 손해배상책임을 부담할 의무도 없습니다.</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; color:#ff0000">7. 이용자가 회사가 제공한 무료 제품
                혹은 서비스를 사용함으로 인하여 손해를 입은 경우, 회사는 이에 대한 책임을 지지 않습니다. 단 그 손해가 회사의 고의 또는 중대한 과실에 의한 경우는 제외합니다.</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; color:#ff0000">8. 회원가입 시 이용자가 잘못된 정보를
                제공하거나 이용자의 잘못된 조작방법, 또는 이용자 자신의 전자기기 고장으로 인하여 손해가 발생한 경우 회사는 일체의 책임을 지지 않습니다.</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; color:#ff0000">9. 회사는 이용자가 서비스를 이용하면서
                취득한 등급, 아이템, 콘텐츠 등의 소실에 대해서 회사의 고의 또는 중대한 과실로 인한 경우를 제외하고는 책임을 부담하지 않습니다.</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; color:#ff0000">10. 이용자의 단말기 변경, 번호 변경,
                해외 로밍, 통신사 이동 등의 경우 게임콘텐츠의 전부 또는 일부 기능을 이용할 수 없는 경우가 발생할 수 있으며, 이 경우 회사는 책임지지 않습니다.</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; color:#ff0000">11. 회사에서 제공하는 게임콘텐츠를
                삭제하는 경우, 이용 정보(점수, 캐릭터, 아이템, 게임머니 등)가 삭제되는 경우가 있을 수 있으므로 이용자는 삭제에 신중을 기하여야 하며 회사는 이에 대해 책임을 지지
                않습니다.</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; color:#ff0000">12. 회사는 임시회원 기능 이용 중
                발생한 문제에 대해서는 일체 책임을 지지 않습니다.</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; color:#ff0000">13. 회사는 이용자가 서비스를 이용하여
                기대하는 수익을 얻지 못한 것에 대하여 책임을 지지 않으며, 서비스에 대한 취소 또는 이용으로 발생하는 손해 등에 대해서는 책임을 지지 않습니다.</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; color:#ff0000">14. 국가 법률, 법규, 정책 및
                국가기관의 명령 등으로 인하여 이용자에게 손실을 끼친 경우, 회사는 이에 대한 책임을 지지 않습니다.</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">제31조 이용자 고발 및 분쟁의 해결</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">1. 이용자 고발 및 분쟁해결의 편리를 위하여, 회사는 게임 초기화면
                및 게임 홈페이지에서 이용자 게시판을 마련하고 이를 담당하는 전문적인 고객서비스부서를 설립함으로써 관련 정보 수집 및 처리를 진행하도록 하여야 합니다.</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">2. 회사는 합리적인 기한 내에 이용자의 의견과 불만을 유효하게
                처리하여야 합니다. 처리기간을 연장하여야 하는 경우, 회사는 홈페이지, 전자우편 혹은 서면의 방법으로 이용자에게 처리 상황을 통지하여야 합니다.</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">3. 회사와 이용자 상호간의 분쟁은 제3의 분쟁조정기관에 조정을
                맡기는 경우, 회사는 사실대로 진술하여야 하고 조정결과를 받아들여야 합니다.</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">제32조 이용자에 대한 통지</span><span
                style="font-family:微软雅黑">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">1. 회사는 서비스를 사용하는 과정에서 이용자가 필요로 하는 각종
                정보에 대하여 서비스화면, 전자우편 또는 서신 우편 등 방식으로 이를 이용자에게 제공할 수 있습니다. 회사는 통지 발송 시에는 이용자가 지정한 전자우편 주소 등 통신방법을 사용하여야
                합니다.</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">2. 회사는 전체 이용자에게 중요한 통지를 발송하여야 할 때 회사
                사이트에서 가장 윗 부분에 해당 통지 내용을 공시하여야 하며, 공시기한은 7일보다 적어서는 아니 됩니다.</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">3. 서비스 개선 및 이용자에 대한 서비스 소개 등을 목적으로 회사는
                이용자의 동의를 받은 후 추가적인 개인정보를 제공하도록 요구할 수 있습니다.</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">제33조 준거법 및 관할권</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">1. 본 약관은 대한민국 법률에 따라 제정 및 해석되고 해당 분쟁을
                접수한 대한민국 법원이 관할권을 가집니다.</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">2. 관련 서비스의 사용에 대하여 회사와 이용자 간에 분쟁이 발생할
                경우, 양 당사자는 협상을 통하여 원만하게 해결하여야 합니다.</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:'Malgun Gothic'">제 </span><span
                style="font-family:微软雅黑">34</span><span style="font-family:'Malgun Gothic'">조 연락방법</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><br /><span style="font-family:'Malgun Gothic'">회사</span><span
                style="font-family:微软雅黑"> </span><span style="font-family:'Malgun Gothic'">연락처는</span><span
                style="font-family:微软雅黑"> </span><span style="font-family:微软雅黑">&#xa0;</span><a
                href="mailto:service@zrrglobal.com" style="text-decoration:none"><span
                    style="font-family:微软雅黑; color:#000000">service@zrrglobal.com</span></a><span
                style="font-family:微软雅黑"> </span><span style="font-family:'Malgun Gothic'">입니다</span><span
                style="font-family:微软雅黑">.</span><br /><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span>
        </p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">「</span><span
                style="font-family:'Malgun Gothic'">게임산업진흥에</span><span style="font-family:微软雅黑"> </span><span
                style="font-family:'Malgun Gothic'">관한</span><span style="font-family:微软雅黑"> </span><span
                style="font-family:'Malgun Gothic'">법률</span><span style="font-family:微软雅黑">」 </span><span
                style="font-family:'Malgun Gothic'">제</span><span style="font-family:微软雅黑">31</span><span
                style="font-family:'Malgun Gothic'">조</span><span style="font-family:微软雅黑"> </span><span
                style="font-family:'Malgun Gothic'">제</span><span style="font-family:微软雅黑">2</span><span
                style="font-family:'Malgun Gothic'">항에</span><span style="font-family:微软雅黑"> </span><span
                style="font-family:'Malgun Gothic'">따라</span><span style="font-family:微软雅黑"> </span><span
                style="font-family:'Malgun Gothic'">회사는</span><span style="font-family:微软雅黑"> </span><span
                style="font-family:'Malgun Gothic'">다음과</span><span style="font-family:微软雅黑"> </span><span
                style="font-family:'Malgun Gothic'">같이</span><span style="font-family:微软雅黑"> </span><span
                style="font-family:'Malgun Gothic'">국내대리인을</span><span style="font-family:微软雅黑"> </span><span
                style="font-family:'Malgun Gothic'">지정합니다</span><span style="font-family:微软雅黑">.</span><br /><br />
                <span style="font-family:'Malgun Gothic'">국내대리인은</span><span
                style="font-family:微软雅黑"> 「</span><span style="font-family:'Malgun Gothic'">게임산업진흥에</span><span
                style="font-family:微软雅黑"> </span><span style="font-family:'Malgun Gothic'">관한</span><span
                style="font-family:微软雅黑"> </span><span style="font-family:'Malgun Gothic'">법률</span><span
                style="font-family:微软雅黑">」</span><span style="font-family:'Malgun Gothic'">에</span><span
                style="font-family:微软雅黑"> </span><span style="font-family:'Malgun Gothic'">따라 부여된</span><span
                style="font-family:微软雅黑"> </span><span style="font-family:'Malgun Gothic'">법정</span><span
                style="font-family:微软雅黑"> </span><span style="font-family:'Malgun Gothic'">의무</span><span
                style="font-family:微软雅黑"> </span><span style="font-family:'Malgun Gothic'">이행만을</span><span
                style="font-family:微软雅黑"> </span><span style="font-family:'Malgun Gothic'">담당하며</span><span
                style="font-family:微软雅黑">, </span><span style="font-family:'Malgun Gothic'">이용자를 대상으로 한 고객</span><span
                style="font-family:微软雅黑"> </span><span style="font-family:'Malgun Gothic'">서비스</span><span
                style="font-family:微软雅黑"> </span><span style="font-family:'Malgun Gothic'">업무는</span><span
                style="font-family:微软雅黑"> </span><span style="font-family:'Malgun Gothic'">담당하지</span><span
                style="font-family:微软雅黑"> </span><span style="font-family:'Malgun Gothic'">않습니다</span><span
                style="font-family:微软雅黑">.</span><br /><span style="font-family:'Malgun Gothic'">서비스</span><span
                style="font-family:微软雅黑"> </span><span style="font-family:'Malgun Gothic'">이용과</span><span
                style="font-family:微软雅黑"> </span><span style="font-family:'Malgun Gothic'">관련하여</span><span
                style="font-family:微软雅黑"> </span><span style="font-family:'Malgun Gothic'">문의 사항이</span><span
                style="font-family:微软雅黑"> </span><span style="font-family:'Malgun Gothic'">있을</span><span
                style="font-family:微软雅黑"> </span><span style="font-family:'Malgun Gothic'">경우</span><span
                style="font-family:微软雅黑">, </span><span style="font-family:'Malgun Gothic'">국내대리인이</span><span
                style="font-family:微软雅黑"> </span><span style="font-family:'Malgun Gothic'">아닌</span><span
                style="font-family:微软雅黑"> </span><span style="font-family:'Malgun Gothic'">회사</span><span
                style="font-family:微软雅黑"> </span><span style="font-family:'Malgun Gothic'">측에</span><span
                style="font-family:微软雅黑"> </span><span style="font-family:'Malgun Gothic'">문의해야</span><span
                style="font-family:微软雅黑"> </span><span style="font-family:'Malgun Gothic'">합니다</span><span
                style="font-family:微软雅黑">.</span><br /><br /><br /><span
                style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">제35조 기타 조항</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑; -aw-import:ignore">&#xa0;</span></p>
        <p style="text-align:left; font-size:12pt"><span style="font-family:微软雅黑">본 약관에 기재되지 않은 사항 및 본 약관의 해석은 정부가 제정한
                관련 법령 혹은 상관례를 따릅니다.</span></p>
    </div>`;

export const useDetailHtml = `
     <div>
        <p style="margin-right:38.75pt"><span style="font-family:'Malgun Gothic'">본사</span></p>
        <p style="margin-right:38.75pt; text-align:left; widows:2; orphans:2; font-size:9pt"><span
                style="font-family:'Malgun Gothic'; -aw-import:ignore">&#xa0;</span></p>
        <table cellspacing="0" cellpadding="0" class="TableGrid"
            style="margin-right:9pt; margin-left:9pt; border:0.75pt solid #000000; -aw-border:0.5pt single #000000; -aw-border-insideh:0.5pt single #000000; -aw-border-insidev:0.5pt single #000000; border-collapse:collapse; float:left">
            <tr>
                <td
                    style="width:163.5pt; border-right-style:solid; border-right-width:0.75pt; border-bottom-style:solid; border-bottom-width:0.75pt; padding-right:5.03pt; padding-left:5.03pt; vertical-align:top; -aw-border-bottom:0.5pt single #000000; -aw-border-right:0.5pt single #000000">
                    <p style="margin-right:38.75pt; text-align:justify; font-size:10.5pt"><span
                            style="font-family:'Malgun Gothic'">목적</span></p>
                </td>
                <td
                    style="width:166.4pt; border-right-style:solid; border-right-width:0.75pt; border-left-style:solid; border-left-width:0.75pt; border-bottom-style:solid; border-bottom-width:0.75pt; padding-right:5.03pt; padding-left:5.03pt; vertical-align:top; -aw-border-bottom:0.5pt single #000000; -aw-border-left:0.5pt single #000000; -aw-border-right:0.5pt single #000000">
                    <p style="margin-right:38.75pt; text-align:justify; font-size:10.5pt"><span
                            style="font-family:'Malgun Gothic'">정보 유형</span></p>
                </td>
                <td
                    style="width:163.55pt; border-left-style:solid; border-left-width:0.75pt; border-bottom-style:solid; border-bottom-width:0.75pt; padding-right:5.03pt; padding-left:5.03pt; vertical-align:top; -aw-border-bottom:0.5pt single #000000; -aw-border-left:0.5pt single #000000">
                    <p style="margin-right:38.75pt; text-align:justify; font-size:10.5pt"><span
                            style="font-family:'Malgun Gothic'">보관 기한</span></p>
                </td>
            </tr>
            <tr>
                <td
                    style="width:163.5pt; border-top-style:solid; border-top-width:0.75pt; border-right-style:solid; border-right-width:0.75pt; border-bottom-style:solid; border-bottom-width:0.75pt; padding-right:5.03pt; padding-left:5.03pt; vertical-align:top; -aw-border-bottom:0.5pt single #000000; -aw-border-right:0.5pt single #000000; -aw-border-top:0.5pt single #000000">
                    <p style="margin-right:38.75pt; text-align:justify; font-size:10.5pt"><span
                            style="font-family:'Malgun Gothic'">회원가입 시 사용자 신분 인증</span></p>
                </td>
                <td
                    style="width:166.4pt; border-style:solid; border-width:0.75pt; padding-right:5.03pt; padding-left:5.03pt; vertical-align:top; -aw-border:0.5pt single #000000">
                    <p style="margin-right:38.75pt; text-align:justify; font-size:10.5pt"><span
                            style="font-family:'Malgun Gothic'">계정, 비밀번호, 핸드폰 번호</span></p>
                </td>
                <td
                    style="width:163.55pt; border-top-style:solid; border-top-width:0.75pt; border-left-style:solid; border-left-width:0.75pt; border-bottom-style:solid; border-bottom-width:0.75pt; padding-right:5.03pt; padding-left:5.03pt; vertical-align:top; -aw-border-bottom:0.5pt single #000000; -aw-border-left:0.5pt single #000000; -aw-border-top:0.5pt single #000000">
                    <p style="margin-right:38.75pt; text-align:justify; font-size:10.5pt"><span
                            style="font-family:'Malgun Gothic'">회원 탈퇴 시 즉시 삭제</span></p>
                </td>
            </tr>
            <tr>
                <td
                    style="width:163.5pt; border-top-style:solid; border-top-width:0.75pt; border-right-style:solid; border-right-width:0.75pt; border-bottom-style:solid; border-bottom-width:0.75pt; padding-right:5.03pt; padding-left:5.03pt; vertical-align:top; -aw-border-bottom:0.5pt single #000000; -aw-border-right:0.5pt single #000000; -aw-border-top:0.5pt single #000000">
                    <p style="margin-right:38.75pt; text-align:justify; font-size:10.5pt"><span
                            style="font-family:'Malgun Gothic'">모바일 서비스 및 이벤트 상품 배송 등에 활용</span></p>
                </td>
                <td
                    style="width:166.4pt; border-style:solid; border-width:0.75pt; padding-right:5.03pt; padding-left:5.03pt; vertical-align:top; -aw-border:0.5pt single #000000">
                    <p style="margin-right:38.75pt; text-align:justify; font-size:10.5pt"><span
                            style="font-family:'Malgun Gothic'">IP 주소, 접속 날짜, 서비스 이용 기록, 부정 이용 기록, 오류 정보</span></p>
                </td>
                <td
                    style="width:163.55pt; border-top-style:solid; border-top-width:0.75pt; border-left-style:solid; border-left-width:0.75pt; border-bottom-style:solid; border-bottom-width:0.75pt; padding-right:5.03pt; padding-left:5.03pt; vertical-align:top; -aw-border-bottom:0.5pt single #000000; -aw-border-left:0.5pt single #000000; -aw-border-top:0.5pt single #000000">
                    <p style="margin-right:38.75pt; text-align:justify; font-size:10.5pt"><span
                            style="font-family:'Malgun Gothic'">회원 탈퇴 시 즉시 폐기되나, 계약 및 주문내역, 취소내역, 정산내역, 재무내역 등은 회원 탈퇴 후
                            5년간 보관됩니다.</span></p>
                </td>
            </tr>
            <tr>
                <td
                    style="width:163.5pt; border-top-style:solid; border-top-width:0.75pt; border-right-style:solid; border-right-width:0.75pt; border-bottom-style:solid; border-bottom-width:0.75pt; padding-right:5.03pt; padding-left:5.03pt; vertical-align:top; -aw-border-bottom:0.5pt single #000000; -aw-border-right:0.5pt single #000000; -aw-border-top:0.5pt single #000000">
                    <p style="margin-right:38.75pt; text-align:justify; font-size:10.5pt"><span
                            style="font-family:'Malgun Gothic'">서비스 이용 시 본인확인 절차, 비밀번호 분실, 계정 잠금, 결제 환불 등의 서비스 그리고 이용자
                            특성에 따른 맞춤형 서비스 제공 </span></p>
                </td>
                <td
                    style="width:166.4pt; border-style:solid; border-width:0.75pt; padding-right:5.03pt; padding-left:5.03pt; vertical-align:top; -aw-border:0.5pt single #000000">
                    <p style="margin-right:38.75pt; text-align:justify; font-size:10.5pt"><span
                            style="font-family:'Malgun Gothic'">ID, 비밀번호, 캐릭터명, 핸드폰 기종 그리고 광고 식별자</span></p>
                </td>
                <td
                    style="width:163.55pt; border-top-style:solid; border-top-width:0.75pt; border-left-style:solid; border-left-width:0.75pt; border-bottom-style:solid; border-bottom-width:0.75pt; padding-right:5.03pt; padding-left:5.03pt; vertical-align:top; -aw-border-bottom:0.5pt single #000000; -aw-border-left:0.5pt single #000000; -aw-border-top:0.5pt single #000000">
                    <p style="margin-right:38.75pt; text-align:justify; font-size:10.5pt"><span
                            style="font-family:'Malgun Gothic'">회원 탈퇴 시 즉시 삭제</span></p>
                </td>
            </tr>
            <tr>
                <td
                    style="width:163.5pt; border-top-style:solid; border-top-width:0.75pt; border-right-style:solid; border-right-width:0.75pt; border-bottom-style:solid; border-bottom-width:0.75pt; padding-right:5.03pt; padding-left:5.03pt; vertical-align:top; -aw-border-bottom:0.5pt single #000000; -aw-border-right:0.5pt single #000000; -aw-border-top:0.5pt single #000000">
                    <p style="margin-right:38.75pt; text-align:justify; font-size:10.5pt"><span
                            style="font-family:'Malgun Gothic'">요금을 정산하기 위해 유료 서비스 결제 시 수집</span></p>
                </td>
                <td
                    style="width:166.4pt; border-style:solid; border-width:0.75pt; padding-right:5.03pt; padding-left:5.03pt; vertical-align:top; -aw-border:0.5pt single #000000">
                    <p style="margin-right:38.75pt; text-align:justify; font-size:10.5pt"><span
                            style="font-family:'Malgun Gothic'">IP 주소</span></p>
                </td>
                <td
                    style="width:163.55pt; border-top-style:solid; border-top-width:0.75pt; border-left-style:solid; border-left-width:0.75pt; border-bottom-style:solid; border-bottom-width:0.75pt; padding-right:5.03pt; padding-left:5.03pt; vertical-align:top; -aw-border-bottom:0.5pt single #000000; -aw-border-left:0.5pt single #000000; -aw-border-top:0.5pt single #000000">
                    <p style="margin-right:38.75pt; text-align:justify; font-size:10.5pt"><span
                            style="font-family:'Malgun Gothic'">결제 정보는 회원 탈퇴 후 5년간 보관됩니다.</span></p>
                </td>
            </tr>
            <tr>
                <td
                    style="width:163.5pt; border-top-style:solid; border-top-width:0.75pt; border-right-style:solid; border-right-width:0.75pt; border-bottom-style:solid; border-bottom-width:0.75pt; padding-right:5.03pt; padding-left:5.03pt; vertical-align:top; -aw-border-bottom:0.5pt single #000000; -aw-border-right:0.5pt single #000000; -aw-border-top:0.5pt single #000000">
                    <p style="margin-right:38.75pt; text-align:justify; font-size:10.5pt"><span
                            style="font-family:'Malgun Gothic'">계약 이행 및 분쟁 처리</span></p>
                </td>
                <td
                    style="width:166.4pt; border-style:solid; border-width:0.75pt; padding-right:5.03pt; padding-left:5.03pt; vertical-align:top; -aw-border:0.5pt single #000000">
                    <p style="margin-right:38.75pt; text-align:justify; font-size:10.5pt"><span
                            style="font-family:'Malgun Gothic'">IP 주소, 서버 이용 기록(접속 로그 기록, 서비스 종료 일자)</span></p>
                </td>
                <td
                    style="width:163.55pt; border-top-style:solid; border-top-width:0.75pt; border-left-style:solid; border-left-width:0.75pt; border-bottom-style:solid; border-bottom-width:0.75pt; padding-right:5.03pt; padding-left:5.03pt; vertical-align:top; -aw-border-bottom:0.5pt single #000000; -aw-border-left:0.5pt single #000000; -aw-border-top:0.5pt single #000000">
                    <p style="margin-right:38.75pt; text-align:justify; font-size:10.5pt"><span
                            style="font-family:'Malgun Gothic'">분쟁 관련 정보는 회원 탈퇴 후 3년간 보관되며, 웹페이지 접속기록은 회원 탈퇴 후 3개월간
                            보관됩니다.</span></p>
                </td>
            </tr>
            <tr>
                <td
                    style="width:163.5pt; border-top-style:solid; border-top-width:0.75pt; border-right-style:solid; border-right-width:0.75pt; border-bottom-style:solid; border-bottom-width:0.75pt; padding-right:5.03pt; padding-left:5.03pt; vertical-align:top; -aw-border-bottom:0.5pt single #000000; -aw-border-right:0.5pt single #000000; -aw-border-top:0.5pt single #000000">
                    <p style="margin-right:38.75pt; text-align:justify; font-size:10.5pt"><span
                            style="font-family:'Malgun Gothic'">이용자 식별 및 중복 가입 확인, 결제 환불 등 고객 서비스를 위해 사용합니다.</span></p>
                </td>
                <td
                    style="width:166.4pt; border-style:solid; border-width:0.75pt; padding-right:5.03pt; padding-left:5.03pt; vertical-align:top; -aw-border:0.5pt single #000000">
                    <p style="margin-right:38.75pt; text-align:justify; font-size:10.5pt"><span
                            style="font-family:'Malgun Gothic'">중복 가입 확인 정보(DI)에 사용합니다.</span></p>
                </td>
                <td
                    style="width:163.55pt; border-top-style:solid; border-top-width:0.75pt; border-left-style:solid; border-left-width:0.75pt; border-bottom-style:solid; border-bottom-width:0.75pt; padding-right:5.03pt; padding-left:5.03pt; vertical-align:top; -aw-border-bottom:0.5pt single #000000; -aw-border-left:0.5pt single #000000; -aw-border-top:0.5pt single #000000">
                    <p style="margin-right:38.75pt; text-align:justify; font-size:10.5pt"><span
                            style="font-family:'Malgun Gothic'">회원 탈퇴 시 즉시 삭제</span></p>
                </td>
            </tr>
            <tr>
                <td
                    style="width:163.5pt; border-top-style:solid; border-top-width:0.75pt; border-right-style:solid; border-right-width:0.75pt; border-bottom-style:solid; border-bottom-width:0.75pt; padding-right:5.03pt; padding-left:5.03pt; vertical-align:top; -aw-border-bottom:0.5pt single #000000; -aw-border-right:0.5pt single #000000; -aw-border-top:0.5pt single #000000">
                    <p style="margin-right:38.75pt; text-align:justify; font-size:10.5pt"><span
                            style="font-family:'Malgun Gothic'">외부 기업과 연락하고 협력 서비스를 이용할 때 사용합니다.</span></p>
                </td>
                <td
                    style="width:166.4pt; border-style:solid; border-width:0.75pt; padding-right:5.03pt; padding-left:5.03pt; vertical-align:top; -aw-border:0.5pt single #000000">
                    <p style="margin-right:38.75pt; text-align:justify; font-size:10.5pt"><span
                            style="font-family:'Malgun Gothic'">암호화된 동일 인식 식별 정보(CI)</span></p>
                </td>
                <td
                    style="width:163.55pt; border-top-style:solid; border-top-width:0.75pt; border-left-style:solid; border-left-width:0.75pt; border-bottom-style:solid; border-bottom-width:0.75pt; padding-right:5.03pt; padding-left:5.03pt; vertical-align:top; -aw-border-bottom:0.5pt single #000000; -aw-border-left:0.5pt single #000000; -aw-border-top:0.5pt single #000000">
                    <p style="margin-right:38.75pt; text-align:justify; font-size:10.5pt"><span
                            style="font-family:'Malgun Gothic'">회원 탈퇴 시 즉시 삭제</span></p>
                </td>
            </tr>
            <tr>
                <td
                    style="width:163.5pt; border-top-style:solid; border-top-width:0.75pt; border-right-style:solid; border-right-width:0.75pt; padding-right:5.03pt; padding-left:5.03pt; vertical-align:top; -aw-border-right:0.5pt single #000000; -aw-border-top:0.5pt single #000000">
                    <p style="margin-right:38.75pt; text-align:justify; font-size:10.5pt"><span
                            style="font-family:'Malgun Gothic'">확인 가능한 연령</span></p>
                </td>
                <td
                    style="width:166.4pt; border-top-style:solid; border-top-width:0.75pt; border-right-style:solid; border-right-width:0.75pt; border-left-style:solid; border-left-width:0.75pt; padding-right:5.03pt; padding-left:5.03pt; vertical-align:top; -aw-border-left:0.5pt single #000000; -aw-border-right:0.5pt single #000000; -aw-border-top:0.5pt single #000000">
                    <p style="margin-right:38.75pt; text-align:justify; font-size:10.5pt"><span
                            style="font-family:'Malgun Gothic'">출생연월</span></p>
                </td>
                <td
                    style="width:163.55pt; border-top-style:solid; border-top-width:0.75pt; border-left-style:solid; border-left-width:0.75pt; padding-right:5.03pt; padding-left:5.03pt; vertical-align:top; -aw-border-left:0.5pt single #000000; -aw-border-top:0.5pt single #000000">
                    <p style="margin-right:38.75pt; text-align:justify; font-size:10.5pt"><span
                            style="font-family:'Malgun Gothic'">회원 탈퇴 시 즉시 삭제</span></p>
                </td>
            </tr>
        </table>
        <p style="margin-right:38.75pt; text-align:left; widows:2; orphans:2"><br
                style="page-break-before:always; clear:both" /><span style="font-family:'Malgun Gothic'"> 임시 회원 모드에서,
                회사는 사용자가 직접 만든 계정과 비밀번호를 수집하지 않습니다. 대신 임시 회원에게 암호화된 계정, 비밀 번호를 자동으로 생성합니다. 동시에 위 표에 나열된 다른 정보를
                수집합니다.</span></p>
        <p style="margin-right:38.75pt"><span style="font-family:'Malgun Gothic'; -aw-import:ignore">&#xa0;</span></p>
        <p style="margin-right:38.75pt"><span style="font-family:'Malgun Gothic'">다음 정보는 사용자가 특정 상황을 능동적으로 수행할 때만 회사가
                수집합니다. 회원이 해당 상황을 수행하지 않으면, 사용자가 이 방침에 동의하더라도 회사는 아래 정보를 자동으로 수집하지 않습니다.</span></p>
        <table cellspacing="0" cellpadding="0" class="TableGrid"
            style="border:0.75pt solid #000000; -aw-border:0.5pt single #000000; -aw-border-insideh:0.5pt single #000000; -aw-border-insidev:0.5pt single #000000; border-collapse:collapse">
            <tr>
                <td
                    style="width:144.9pt; border-right-style:solid; border-right-width:0.75pt; border-bottom-style:solid; border-bottom-width:0.75pt; padding-right:5.03pt; padding-left:5.03pt; vertical-align:top; -aw-border-bottom:0.5pt single #000000; -aw-border-right:0.5pt single #000000">
                    <p style="margin-right:38.75pt; text-align:justify; font-size:10.5pt"><span
                            style="font-family:'Malgun Gothic'">수행 상황</span></p>
                </td>
                <td
                    style="width:166.4pt; border-right-style:solid; border-right-width:0.75pt; border-left-style:solid; border-left-width:0.75pt; border-bottom-style:solid; border-bottom-width:0.75pt; padding-right:5.03pt; padding-left:5.03pt; vertical-align:top; -aw-border-bottom:0.5pt single #000000; -aw-border-left:0.5pt single #000000; -aw-border-right:0.5pt single #000000">
                    <p style="margin-right:38.75pt; text-align:justify; font-size:10.5pt"><span
                            style="font-family:'Malgun Gothic'">목적</span></p>
                </td>
                <td
                    style="width:81.3pt; border-right-style:solid; border-right-width:0.75pt; border-left-style:solid; border-left-width:0.75pt; border-bottom-style:solid; border-bottom-width:0.75pt; padding-right:5.03pt; padding-left:5.03pt; vertical-align:top; -aw-border-bottom:0.5pt single #000000; -aw-border-left:0.5pt single #000000; -aw-border-right:0.5pt single #000000">
                    <p style="margin-right:38.75pt; text-align:justify; font-size:10.5pt"><span
                            style="font-family:'Malgun Gothic'">정보 유형</span></p>
                </td>
                <td
                    style="width:187.65pt; border-left-style:solid; border-left-width:0.75pt; border-bottom-style:solid; border-bottom-width:0.75pt; padding-right:5.03pt; padding-left:5.03pt; vertical-align:top; -aw-border-bottom:0.5pt single #000000; -aw-border-left:0.5pt single #000000">
                    <p style="margin-right:38.75pt; text-align:justify; font-size:10.5pt"><span
                            style="font-family:'Malgun Gothic'">보관 기한</span></p>
                </td>
            </tr>
            <tr>
                <td
                    style="width:144.9pt; border-top-style:solid; border-top-width:0.75pt; border-right-style:solid; border-right-width:0.75pt; border-bottom-style:solid; border-bottom-width:0.75pt; padding-right:5.03pt; padding-left:5.03pt; vertical-align:top; -aw-border-bottom:0.5pt single #000000; -aw-border-right:0.5pt single #000000; -aw-border-top:0.5pt single #000000">
                    <p style="margin-right:38.75pt; text-align:justify; font-size:10.5pt"><span
                            style="font-family:'Malgun Gothic'">회원이 회사에 이메일을 쓰거나 고객서비스 직원과 연락할 때 제공하는 정보</span></p>
                </td>
                <td
                    style="width:166.4pt; border-style:solid; border-width:0.75pt; padding-right:5.03pt; padding-left:5.03pt; vertical-align:top; -aw-border:0.5pt single #000000">
                    <p style="margin-right:38.75pt; text-align:justify; font-size:10.5pt"><span
                            style="font-family:'Malgun Gothic'">회원에게 답변할 때 사용합니다.</span></p>
                </td>
                <td
                    style="width:81.3pt; border-style:solid; border-width:0.75pt; padding-right:5.03pt; padding-left:5.03pt; vertical-align:top; -aw-border:0.5pt single #000000">
                    <p style="margin-right:38.75pt; text-align:justify; font-size:10.5pt"><span
                            style="font-family:'Malgun Gothic'">이메일 주소</span></p>
                </td>
                <td
                    style="width:187.65pt; border-top-style:solid; border-top-width:0.75pt; border-left-style:solid; border-left-width:0.75pt; border-bottom-style:solid; border-bottom-width:0.75pt; padding-right:5.03pt; padding-left:5.03pt; vertical-align:top; -aw-border-bottom:0.5pt single #000000; -aw-border-left:0.5pt single #000000; -aw-border-top:0.5pt single #000000">
                    <p style="margin-right:38.75pt; text-align:justify; font-size:10.5pt"><span
                            style="font-family:'Malgun Gothic'">사용자가 회원 탈퇴할 때까지 해당 정보를 보관하지만, 분쟁과 관련된 정보는 회원 자격 해지 후 3년간
                            보관됩니다.</span></p>
                </td>
            </tr>
            <tr>
                <td
                    style="width:144.9pt; border-top-style:solid; border-top-width:0.75pt; border-right-style:solid; border-right-width:0.75pt; border-bottom-style:solid; border-bottom-width:0.75pt; padding-right:5.03pt; padding-left:5.03pt; vertical-align:top; -aw-border-bottom:0.5pt single #000000; -aw-border-right:0.5pt single #000000; -aw-border-top:0.5pt single #000000">
                    <p style="margin-right:38.75pt; text-align:justify; font-size:10.5pt"><span
                            style="font-family:'Malgun Gothic'">회원이 설문조사에 응답하여 선택적으로 작성합니다.</span></p>
                </td>
                <td
                    style="width:166.4pt; border-style:solid; border-width:0.75pt; padding-right:5.03pt; padding-left:5.03pt; vertical-align:top; -aw-border:0.5pt single #000000">
                    <p style="margin-right:38.75pt; text-align:justify; font-size:10.5pt"><span
                            style="font-family:'Malgun Gothic'">회원에게 피드백할 때 사용합니다.</span></p>
                </td>
                <td
                    style="width:81.3pt; border-style:solid; border-width:0.75pt; padding-right:5.03pt; padding-left:5.03pt; vertical-align:top; -aw-border:0.5pt single #000000">
                    <p style="margin-right:38.75pt; text-align:justify; font-size:10.5pt"><span
                            style="font-family:'Malgun Gothic'">이메일 주소</span></p>
                </td>
                <td
                    style="width:187.65pt; border-top-style:solid; border-top-width:0.75pt; border-left-style:solid; border-left-width:0.75pt; border-bottom-style:solid; border-bottom-width:0.75pt; padding-right:5.03pt; padding-left:5.03pt; vertical-align:top; -aw-border-bottom:0.5pt single #000000; -aw-border-left:0.5pt single #000000; -aw-border-top:0.5pt single #000000">
                    <p style="margin-right:38.75pt; text-align:justify; font-size:10.5pt"><span
                            style="font-family:'Malgun Gothic'">회원 탈퇴 시 즉시 삭제</span></p>
                </td>
            </tr>
            <tr>
                <td
                    style="width:144.9pt; border-top-style:solid; border-top-width:0.75pt; border-right-style:solid; border-right-width:0.75pt; border-bottom-style:solid; border-bottom-width:0.75pt; padding-right:5.03pt; padding-left:5.03pt; vertical-align:top; -aw-border-bottom:0.5pt single #000000; -aw-border-right:0.5pt single #000000; -aw-border-top:0.5pt single #000000">
                    <p style="margin-right:38.75pt; text-align:justify; font-size:10.5pt"><span
                            style="font-family:'Malgun Gothic'">회원이 이메일 구독 이벤트에 참여할 때의 정보</span></p>
                </td>
                <td
                    style="width:166.4pt; border-style:solid; border-width:0.75pt; padding-right:5.03pt; padding-left:5.03pt; vertical-align:top; -aw-border:0.5pt single #000000">
                    <p style="margin-right:38.75pt; text-align:justify; font-size:10.5pt"><span
                            style="font-family:'Malgun Gothic'">회원 이메일로 정보를 발송할 때 사용하며, 여기에는 마케팅 정보 등이 포함되나 이에 국한되지
                            않습니다.</span></p>
                </td>
                <td
                    style="width:81.3pt; border-style:solid; border-width:0.75pt; padding-right:5.03pt; padding-left:5.03pt; vertical-align:top; -aw-border:0.5pt single #000000">
                    <p style="margin-right:38.75pt; text-align:justify; font-size:10.5pt"><span
                            style="font-family:'Malgun Gothic'">이메일 주소</span></p>
                </td>
                <td
                    style="width:187.65pt; border-top-style:solid; border-top-width:0.75pt; border-left-style:solid; border-left-width:0.75pt; border-bottom-style:solid; border-bottom-width:0.75pt; padding-right:5.03pt; padding-left:5.03pt; vertical-align:top; -aw-border-bottom:0.5pt single #000000; -aw-border-left:0.5pt single #000000; -aw-border-top:0.5pt single #000000">
                    <p style="margin-right:38.75pt; text-align:justify; font-size:10.5pt"><span
                            style="font-family:'Malgun Gothic'">구독 취소 혹은 회원 탈퇴 시 즉시 삭제</span></p>
                </td>
            </tr>
            <tr>
                <td
                    style="width:144.9pt; border-top-style:solid; border-top-width:0.75pt; border-right-style:solid; border-right-width:0.75pt; border-bottom-style:solid; border-bottom-width:0.75pt; padding-right:5.03pt; padding-left:5.03pt; vertical-align:top; -aw-border-bottom:0.5pt single #000000; -aw-border-right:0.5pt single #000000; -aw-border-top:0.5pt single #000000">
                    <p style="margin-right:38.75pt; text-align:justify; font-size:10.5pt"><span
                            style="font-family:'Malgun Gothic'">14세 미만 회원가입 절차 중</span></p>
                </td>
                <td
                    style="width:166.4pt; border-style:solid; border-width:0.75pt; padding-right:5.03pt; padding-left:5.03pt; vertical-align:top; -aw-border:0.5pt single #000000">
                    <p style="margin-right:38.75pt; text-align:justify; font-size:10.5pt"><span
                            style="font-family:'Malgun Gothic'">미성년자 회원의 개인정보 수집 및 이용에 대해 보호자의 동의를 확인하는 데 사용합니다.</span>
                    </p>
                </td>
                <td
                    style="width:81.3pt; border-style:solid; border-width:0.75pt; padding-right:5.03pt; padding-left:5.03pt; vertical-align:top; -aw-border:0.5pt single #000000">
                    <p style="margin-right:38.75pt; text-align:justify; font-size:10.5pt"><span
                            style="font-family:'Malgun Gothic'">보호자 이메일 주소</span></p>
                </td>
                <td
                    style="width:187.65pt; border-top-style:solid; border-top-width:0.75pt; border-left-style:solid; border-left-width:0.75pt; border-bottom-style:solid; border-bottom-width:0.75pt; padding-right:5.03pt; padding-left:5.03pt; vertical-align:top; -aw-border-bottom:0.5pt single #000000; -aw-border-left:0.5pt single #000000; -aw-border-top:0.5pt single #000000">
                    <p style="margin-right:38.75pt; text-align:justify; font-size:10.5pt"><span
                            style="font-family:'Malgun Gothic'">이용자가 회원 탈퇴할 때까지, 혹은 이용자의 나이가 24살이 될 때까지</span></p>
                </td>
            </tr>
            <tr>
                <td
                    style="width:144.9pt; border-top-style:solid; border-top-width:0.75pt; border-right-style:solid; border-right-width:0.75pt; border-bottom-style:solid; border-bottom-width:0.75pt; padding-right:5.03pt; padding-left:5.03pt; vertical-align:top; -aw-border-bottom:0.5pt single #000000; -aw-border-right:0.5pt single #000000; -aw-border-top:0.5pt single #000000">
                    <p style="margin-right:38.75pt; text-align:justify; font-size:10.5pt"><span
                            style="font-family:'Malgun Gothic'">회원이 회사에 전화를 걸거나 회사 고객서비스 직원과 연락할 때 제공합니다.</span></p>
                </td>
                <td
                    style="width:166.4pt; border-style:solid; border-width:0.75pt; padding-right:5.03pt; padding-left:5.03pt; vertical-align:top; -aw-border:0.5pt single #000000">
                    <p style="margin-right:38.75pt; text-align:justify; font-size:10.5pt"><span
                            style="font-family:'Malgun Gothic'">회원에게 후속 연락을 취하는 데 사용합니다.</span></p>
                </td>
                <td
                    style="width:81.3pt; border-style:solid; border-width:0.75pt; padding-right:5.03pt; padding-left:5.03pt; vertical-align:top; -aw-border:0.5pt single #000000">
                    <p style="margin-right:38.75pt; text-align:justify; font-size:10.5pt"><span
                            style="font-family:'Malgun Gothic'">전화번호</span></p>
                </td>
                <td
                    style="width:187.65pt; border-top-style:solid; border-top-width:0.75pt; border-left-style:solid; border-left-width:0.75pt; border-bottom-style:solid; border-bottom-width:0.75pt; padding-right:5.03pt; padding-left:5.03pt; vertical-align:top; -aw-border-bottom:0.5pt single #000000; -aw-border-left:0.5pt single #000000; -aw-border-top:0.5pt single #000000">
                    <p style="margin-right:38.75pt; text-align:justify; font-size:10.5pt"><span
                            style="font-family:'Malgun Gothic'">사용자가 회원 탈퇴할 때까지 해당 정보를 보관하지만, 분쟁과 관련된 정보는 회원 자격 해지 후 3년간
                            보관됩니다.</span></p>
                </td>
            </tr>
            <tr>
                <td
                    style="width:144.9pt; border-top-style:solid; border-top-width:0.75pt; border-right-style:solid; border-right-width:0.75pt; border-bottom-style:solid; border-bottom-width:0.75pt; padding-right:5.03pt; padding-left:5.03pt; vertical-align:top; -aw-border-bottom:0.5pt single #000000; -aw-border-right:0.5pt single #000000; -aw-border-top:0.5pt single #000000">
                    <p style="margin-right:38.75pt; text-align:justify; font-size:10.5pt"><span
                            style="font-family:'Malgun Gothic'">회원이 설문조사에 응답하여 선택적으로 작성합니다.</span></p>
                </td>
                <td
                    style="width:166.4pt; border-style:solid; border-width:0.75pt; padding-right:5.03pt; padding-left:5.03pt; vertical-align:top; -aw-border:0.5pt single #000000">
                    <p style="margin-right:38.75pt; text-align:justify; font-size:10.5pt"><span
                            style="font-family:'Malgun Gothic'">회원에게 피드백할 때 사용합니다.</span></p>
                </td>
                <td
                    style="width:81.3pt; border-style:solid; border-width:0.75pt; padding-right:5.03pt; padding-left:5.03pt; vertical-align:top; -aw-border:0.5pt single #000000">
                    <p style="margin-right:38.75pt; text-align:justify; font-size:10.5pt"><span
                            style="font-family:'Malgun Gothic'">전화번호</span></p>
                </td>
                <td
                    style="width:187.65pt; border-top-style:solid; border-top-width:0.75pt; border-left-style:solid; border-left-width:0.75pt; border-bottom-style:solid; border-bottom-width:0.75pt; padding-right:5.03pt; padding-left:5.03pt; vertical-align:top; -aw-border-bottom:0.5pt single #000000; -aw-border-left:0.5pt single #000000; -aw-border-top:0.5pt single #000000">
                    <p style="margin-right:38.75pt; text-align:justify; font-size:10.5pt"><span
                            style="font-family:'Malgun Gothic'">회원 탈퇴 시 즉시 삭제</span></p>
                </td>
            </tr>
            <tr>
                <td
                    style="width:144.9pt; border-top-style:solid; border-top-width:0.75pt; border-right-style:solid; border-right-width:0.75pt; border-bottom-style:solid; border-bottom-width:0.75pt; padding-right:5.03pt; padding-left:5.03pt; vertical-align:top; -aw-border-bottom:0.5pt single #000000; -aw-border-right:0.5pt single #000000; -aw-border-top:0.5pt single #000000">
                    <p style="margin-right:38.75pt; text-align:justify; font-size:10.5pt"><span
                            style="font-family:'Malgun Gothic'">회원이 핸드폰 번호 구독 이벤트에 참가</span></p>
                </td>
                <td
                    style="width:166.4pt; border-style:solid; border-width:0.75pt; padding-right:5.03pt; padding-left:5.03pt; vertical-align:top; -aw-border:0.5pt single #000000">
                    <p style="margin-right:38.75pt; text-align:justify; font-size:10.5pt"><span
                            style="font-family:'Malgun Gothic'">회원 핸드폰으로 정보를 발송할 때 사용하며, 여기에는 마케팅 정보 등이 포함되나 이에 국한되지
                            않습니다.</span></p>
                </td>
                <td
                    style="width:81.3pt; border-style:solid; border-width:0.75pt; padding-right:5.03pt; padding-left:5.03pt; vertical-align:top; -aw-border:0.5pt single #000000">
                    <p style="margin-right:38.75pt; text-align:justify; font-size:10.5pt"><span
                            style="font-family:'Malgun Gothic'">이메일 주소</span></p>
                </td>
                <td
                    style="width:187.65pt; border-top-style:solid; border-top-width:0.75pt; border-left-style:solid; border-left-width:0.75pt; border-bottom-style:solid; border-bottom-width:0.75pt; padding-right:5.03pt; padding-left:5.03pt; vertical-align:top; -aw-border-bottom:0.5pt single #000000; -aw-border-left:0.5pt single #000000; -aw-border-top:0.5pt single #000000">
                    <p style="margin-right:38.75pt; text-align:justify; font-size:10.5pt"><span
                            style="font-family:'Malgun Gothic'">구독 취소 혹은 회원 탈퇴 시 즉시 삭제</span></p>
                </td>
            </tr>
            <tr>
                <td
                    style="width:144.9pt; border-top-style:solid; border-top-width:0.75pt; border-right-style:solid; border-right-width:0.75pt; padding-right:5.03pt; padding-left:5.03pt; vertical-align:top; -aw-border-right:0.5pt single #000000; -aw-border-top:0.5pt single #000000">
                    <p style="margin-right:38.75pt; text-align:justify; font-size:10.5pt"><span
                            style="font-family:'Malgun Gothic'">회원이 직원과 의사소통할 때 제공</span></p>
                </td>
                <td
                    style="width:166.4pt; border-top-style:solid; border-top-width:0.75pt; border-right-style:solid; border-right-width:0.75pt; border-left-style:solid; border-left-width:0.75pt; padding-right:5.03pt; padding-left:5.03pt; vertical-align:top; -aw-border-left:0.5pt single #000000; -aw-border-right:0.5pt single #000000; -aw-border-top:0.5pt single #000000">
                    <p style="margin-right:38.75pt; text-align:justify; font-size:10.5pt"><span
                            style="font-family:'Malgun Gothic'">회원에게 제공하는 생일 패키지 혹은 상품권</span></p>
                </td>
                <td
                    style="width:81.3pt; border-top-style:solid; border-top-width:0.75pt; border-right-style:solid; border-right-width:0.75pt; border-left-style:solid; border-left-width:0.75pt; padding-right:5.03pt; padding-left:5.03pt; vertical-align:top; -aw-border-left:0.5pt single #000000; -aw-border-right:0.5pt single #000000; -aw-border-top:0.5pt single #000000">
                    <p style="margin-right:38.75pt; text-align:justify; font-size:10.5pt"><span
                            style="font-family:'Malgun Gothic'">출생연월</span></p>
                </td>
                <td
                    style="width:187.65pt; border-top-style:solid; border-top-width:0.75pt; border-left-style:solid; border-left-width:0.75pt; padding-right:5.03pt; padding-left:5.03pt; vertical-align:top; -aw-border-left:0.5pt single #000000; -aw-border-top:0.5pt single #000000">
                    <p style="margin-right:38.75pt; text-align:justify; font-size:10.5pt"><span
                            style="font-family:'Malgun Gothic'">회원은 언제든지 회사에 요청하여 해당 정보를 삭제할 수 있습니다. 회원 탈퇴 시 즉시
                            폐기됩니다.</span></p>
                </td>
            </tr>
        </table>
        <p style="margin-right:38.75pt; font-size:9pt"><span
                style="font-family:'Malgun Gothic'; -aw-import:ignore">&#xa0;</span></p>
        <p style="margin-right:38.75pt; font-size:9pt"><span style="font-family:'Malgun Gothic'">법률에 따라 회사는 위의 경로를 통해
                획득한 전화번호 또는 이메일 주소로 마케팅 홍보 메일이나 문자 메시지를 발송할 수 있습니다. (회원 보호자 이메일 주소는 제외. 회사는 이러한 주소로 보호자의 동의와 무관한 마케팅 홍보
                메일을 보내지 않지만, 보호자 동의와 관련된 서비스 메일은 발송할 수 있습니다) 회원은 수신한 마케팅 홍보 메일이나 문자를 통해 언제든지 구독을 취소할 수 있습니다. 구독 취소 후에는
                회사가 해당 전화번호나 이메일 주소로 마케팅 홍보 메일을 보내지 않습니다. 다만 사용자가 직접 이메일 또는 휴대전화 번호 구독 이벤트에 다시 참여하는 경우는 예외입니다. 사용자의 별도
                동의를 다시 받지 않는 한, 회사는 밤 9시부터 다음날 오전 8시 사이에는 마케팅 홍보 문자 메시지를 발송하지 않습니다.</span></p>
        <p style="margin-right:38.75pt"><span style="font-family:'Malgun Gothic'; -aw-import:ignore">&#xa0;</span></p>
        <p style="margin-right:38.75pt"><span style="font-family:'Malgun Gothic'">회사가 제3자에게 획득한 정보</span></p>
        <p style="margin-right:38.75pt"><span style="font-family:'Malgun Gothic'; -aw-import:ignore">&#xa0;</span></p>
        <table cellspacing="0" cellpadding="0" class="TableGrid"
            style="border:0.75pt solid #000000; -aw-border:0.5pt single #000000; -aw-border-insideh:0.5pt single #000000; -aw-border-insidev:0.5pt single #000000; border-collapse:collapse">
            <tr>
                <td
                    style="width:163.55pt; border-right-style:solid; border-right-width:0.75pt; border-bottom-style:solid; border-bottom-width:0.75pt; padding-right:5.03pt; padding-left:5.03pt; vertical-align:top; -aw-border-bottom:0.5pt single #000000; -aw-border-right:0.5pt single #000000">
                    <p style="margin-right:38.75pt; text-align:justify; font-size:10.5pt"><span
                            style="font-family:'Malgun Gothic'">제3자 명칭</span></p>
                </td>
                <td
                    style="width:163.55pt; border-right-style:solid; border-right-width:0.75pt; border-left-style:solid; border-left-width:0.75pt; border-bottom-style:solid; border-bottom-width:0.75pt; padding-right:5.03pt; padding-left:5.03pt; vertical-align:top; -aw-border-bottom:0.5pt single #000000; -aw-border-left:0.5pt single #000000; -aw-border-right:0.5pt single #000000">
                    <p style="margin-right:38.75pt; text-align:justify; font-size:10.5pt"><span
                            style="font-family:'Malgun Gothic'">획득 정보 유형</span></p>
                </td>
                <td
                    style="width:163.55pt; border-right-style:solid; border-right-width:0.75pt; border-left-style:solid; border-left-width:0.75pt; border-bottom-style:solid; border-bottom-width:0.75pt; padding-right:5.03pt; padding-left:5.03pt; vertical-align:top; -aw-border-bottom:0.5pt single #000000; -aw-border-left:0.5pt single #000000; -aw-border-right:0.5pt single #000000">
                    <p style="margin-right:38.75pt; text-align:justify; font-size:10.5pt"><span
                            style="font-family:'Malgun Gothic'">목적</span></p>
                </td>
                <td
                    style="width:163.55pt; border-left-style:solid; border-left-width:0.75pt; border-bottom-style:solid; border-bottom-width:0.75pt; padding-right:5.03pt; padding-left:5.03pt; vertical-align:top; -aw-border-bottom:0.5pt single #000000; -aw-border-left:0.5pt single #000000">
                    <p style="margin-right:38.75pt; text-align:justify; font-size:10.5pt"><span
                            style="font-family:'Malgun Gothic'">보관 기한</span></p>
                </td>
            </tr>
            <tr>
                <td
                    style="width:163.55pt; border-top-style:solid; border-top-width:0.75pt; border-right-style:solid; border-right-width:0.75pt; border-bottom-style:solid; border-bottom-width:0.75pt; padding-right:5.03pt; padding-left:5.03pt; vertical-align:top; -aw-border-bottom:0.5pt single #000000; -aw-border-right:0.5pt single #000000; -aw-border-top:0.5pt single #000000">
                    <p style="margin-right:38.75pt; text-align:justify; font-size:10.5pt"><span
                            style="font-family:'Malgun Gothic'">Google</span></p>
                </td>
                <td
                    style="width:163.55pt; border-style:solid; border-width:0.75pt; padding-right:5.03pt; padding-left:5.03pt; vertical-align:top; -aw-border:0.5pt single #000000">
                    <p style="margin-right:38.75pt; text-align:justify; font-size:10.5pt"><span
                            style="font-family:'Malgun Gothic'">공개 프로필 (이름), 이메일 주소</span></p>
                </td>
                <td
                    style="width:163.55pt; border-style:solid; border-width:0.75pt; padding-right:5.03pt; padding-left:5.03pt; vertical-align:top; -aw-border:0.5pt single #000000">
                    <p style="margin-right:38.75pt; text-align:justify; font-size:10.5pt"><span
                            style="font-family:'Malgun Gothic'">제3자 계정으로 게임에 로그인하거나 임시 회원이 제3자 계정을 연결하여 정식 회원으로 업그레이드할 때
                            사용합니다.</span></p>
                    <p style="margin-right:38.75pt; text-align:justify; font-size:10.5pt"><span
                            style="font-family:'Malgun Gothic'">회원이 Google 계정으로 로그인하거나 Google 계정을 연동할 때, Google이 자동으로
                            이메일 주소를 회사에 제공합니다.</span></p>
                </td>
                <td
                    style="width:163.55pt; border-top-style:solid; border-top-width:0.75pt; border-left-style:solid; border-left-width:0.75pt; border-bottom-style:solid; border-bottom-width:0.75pt; padding-right:5.03pt; padding-left:5.03pt; vertical-align:top; -aw-border-bottom:0.5pt single #000000; -aw-border-left:0.5pt single #000000; -aw-border-top:0.5pt single #000000">
                    <p style="margin-right:38.75pt; text-align:justify; font-size:10.5pt"><span
                            style="font-family:'Malgun Gothic'">회원 탈퇴 시 즉시 삭제</span></p>
                </td>
            </tr>
            <tr>
                <td
                    style="width:163.55pt; border-top-style:solid; border-top-width:0.75pt; border-right-style:solid; border-right-width:0.75pt; border-bottom-style:solid; border-bottom-width:0.75pt; padding-right:5.03pt; padding-left:5.03pt; vertical-align:top; -aw-border-bottom:0.5pt single #000000; -aw-border-right:0.5pt single #000000; -aw-border-top:0.5pt single #000000">
                    <p style="margin-right:38.75pt; text-align:justify; font-size:10.5pt"><span
                            style="font-family:'Malgun Gothic'">Facebook</span></p>
                </td>
                <td
                    style="width:163.55pt; border-style:solid; border-width:0.75pt; padding-right:5.03pt; padding-left:5.03pt; vertical-align:top; -aw-border:0.5pt single #000000">
                    <p style="margin-right:38.75pt; text-align:justify; font-size:10.5pt"><span
                            style="font-family:'Malgun Gothic'">공개 프로필 (이름), 이메일 주소 (선택 가능)</span></p>
                </td>
                <td
                    style="width:163.55pt; border-style:solid; border-width:0.75pt; padding-right:5.03pt; padding-left:5.03pt; vertical-align:top; -aw-border:0.5pt single #000000">
                    <p style="margin-right:38.75pt; text-align:justify; font-size:10.5pt"><span
                            style="font-family:'Malgun Gothic'">제3자 계정으로 게임에 로그인하거나 임시 회원이 제3자 계정을 연결하여 정식 회원으로 업그레이드할 때
                            사용합니다.</span></p>
                    <p style="margin-right:38.75pt; text-align:justify; font-size:10.5pt"><span
                            style="font-family:'Malgun Gothic'">회원은 Facebook 계정으로 로그인하거나 연동할 때 추가로 이메일 주소를 제공할지 여부를 선택할
                            수 있습니다.</span></p>
                </td>
                <td
                    style="width:163.55pt; border-top-style:solid; border-top-width:0.75pt; border-left-style:solid; border-left-width:0.75pt; border-bottom-style:solid; border-bottom-width:0.75pt; padding-right:5.03pt; padding-left:5.03pt; vertical-align:top; -aw-border-bottom:0.5pt single #000000; -aw-border-left:0.5pt single #000000; -aw-border-top:0.5pt single #000000">
                    <p style="margin-right:38.75pt; text-align:justify; font-size:10.5pt"><span
                            style="font-family:'Malgun Gothic'">회원 탈퇴 시 즉시 삭제</span></p>
                </td>
            </tr>
            <tr>
                <td
                    style="width:163.55pt; border-top-style:solid; border-top-width:0.75pt; border-right-style:solid; border-right-width:0.75pt; border-bottom-style:solid; border-bottom-width:0.75pt; padding-right:5.03pt; padding-left:5.03pt; vertical-align:top; -aw-border-bottom:0.5pt single #000000; -aw-border-right:0.5pt single #000000; -aw-border-top:0.5pt single #000000">
                    <p style="margin-right:38.75pt; text-align:justify; font-size:10.5pt"><span
                            style="font-family:'Malgun Gothic'">Apple</span></p>
                </td>
                <td
                    style="width:163.55pt; border-style:solid; border-width:0.75pt; padding-right:5.03pt; padding-left:5.03pt; vertical-align:top; -aw-border:0.5pt single #000000">
                    <p style="margin-right:38.75pt; text-align:justify; font-size:10.5pt"><span
                            style="font-family:'Malgun Gothic'">공개 프로필 (이름), 이메일 주소 (선택 가능)</span></p>
                </td>
                <td
                    style="width:163.55pt; border-style:solid; border-width:0.75pt; padding-right:5.03pt; padding-left:5.03pt; vertical-align:top; -aw-border:0.5pt single #000000">
                    <p style="margin-right:38.75pt; text-align:justify; font-size:10.5pt"><span
                            style="font-family:'Malgun Gothic'">제3자 계정으로 게임에 로그인하거나 임시 회원이 제3자 계정을 연결하여 정식 회원으로 업그레이드할 때
                            사용합니다.</span></p>
                    <p style="margin-right:38.75pt; text-align:justify; font-size:10.5pt"><span
                            style="font-family:'Malgun Gothic'">회원은 Apple 계정으로 로그인하거나 연동할 때 추가로 이메일 주소를 제공할지 여부를 선택할 수
                            있습니다.</span></p>
                </td>
                <td
                    style="width:163.55pt; border-top-style:solid; border-top-width:0.75pt; border-left-style:solid; border-left-width:0.75pt; border-bottom-style:solid; border-bottom-width:0.75pt; padding-right:5.03pt; padding-left:5.03pt; vertical-align:top; -aw-border-bottom:0.5pt single #000000; -aw-border-left:0.5pt single #000000; -aw-border-top:0.5pt single #000000">
                    <p style="margin-right:38.75pt; text-align:justify; font-size:10.5pt"><span
                            style="font-family:'Malgun Gothic'">회원 탈퇴 시 즉시 삭제</span></p>
                </td>
            </tr>
            <tr>
                <td
                    style="width:163.55pt; border-top-style:solid; border-top-width:0.75pt; border-right-style:solid; border-right-width:0.75pt; border-bottom-style:solid; border-bottom-width:0.75pt; padding-right:5.03pt; padding-left:5.03pt; vertical-align:top; -aw-border-bottom:0.5pt single #000000; -aw-border-right:0.5pt single #000000; -aw-border-top:0.5pt single #000000">
                    <p style="margin-right:38.75pt; text-align:justify; font-size:10.5pt"><span
                            style="font-family:'Malgun Gothic'">Discord</span></p>
                </td>
                <td
                    style="width:163.55pt; border-style:solid; border-width:0.75pt; padding-right:5.03pt; padding-left:5.03pt; vertical-align:top; -aw-border:0.5pt single #000000">
                    <p style="margin-right:38.75pt; text-align:justify; font-size:10.5pt"><span
                            style="font-family:'Malgun Gothic'">Discord 계정</span></p>
                </td>
                <td
                    style="width:163.55pt; border-style:solid; border-width:0.75pt; padding-right:5.03pt; padding-left:5.03pt; vertical-align:top; -aw-border:0.5pt single #000000">
                    <p style="margin-right:38.75pt; text-align:justify; font-size:10.5pt"><span
                            style="font-family:'Malgun Gothic'">회원이 Discord 커뮤니티에서 게임 계정을 연동할 때 수집합니다. 연동 후 회원은 회사가
                            커뮤니티에서 주최하는 이벤트에 참여할 수 있고, Discord 커뮤니티 내에서 회사의 관련 이벤트 알림을 받게 됩니다.</span></p>
                </td>
                <td
                    style="width:163.55pt; border-top-style:solid; border-top-width:0.75pt; border-left-style:solid; border-left-width:0.75pt; border-bottom-style:solid; border-bottom-width:0.75pt; padding-right:5.03pt; padding-left:5.03pt; vertical-align:top; -aw-border-bottom:0.5pt single #000000; -aw-border-left:0.5pt single #000000; -aw-border-top:0.5pt single #000000">
                    <p style="margin-right:38.75pt; text-align:justify; font-size:10.5pt"><span
                            style="font-family:'Malgun Gothic'">회원 탈퇴 혹은 연동 해지 시 즉시 삭제</span></p>
                </td>
            </tr>
            <tr>
                <td
                    style="width:163.55pt; border-top-style:solid; border-top-width:0.75pt; border-right-style:solid; border-right-width:0.75pt; padding-right:5.03pt; padding-left:5.03pt; vertical-align:top; -aw-border-right:0.5pt single #000000; -aw-border-top:0.5pt single #000000">
                    <p style="margin-right:38.75pt; text-align:justify; font-size:10.5pt"><span
                            style="font-family:'Malgun Gothic'">Kakao Talk</span></p>
                </td>
                <td
                    style="width:163.55pt; border-top-style:solid; border-top-width:0.75pt; border-right-style:solid; border-right-width:0.75pt; border-left-style:solid; border-left-width:0.75pt; padding-right:5.03pt; padding-left:5.03pt; vertical-align:top; -aw-border-left:0.5pt single #000000; -aw-border-right:0.5pt single #000000; -aw-border-top:0.5pt single #000000">
                    <p style="margin-right:38.75pt; text-align:justify; font-size:10.5pt"><span
                            style="font-family:'Malgun Gothic'">Kakao Talk계정</span></p>
                </td>
                <td
                    style="width:163.55pt; border-top-style:solid; border-top-width:0.75pt; border-right-style:solid; border-right-width:0.75pt; border-left-style:solid; border-left-width:0.75pt; padding-right:5.03pt; padding-left:5.03pt; vertical-align:top; -aw-border-left:0.5pt single #000000; -aw-border-right:0.5pt single #000000; -aw-border-top:0.5pt single #000000">
                    <p style="margin-right:38.75pt; text-align:justify; font-size:10.5pt"><span
                            style="font-family:'Malgun Gothic'">회원이 게임 내에서 개인 Kakao Talk 계정을 연동하거나 회사의 Kakao Talk 공식 채널을
                            추가하면 관련 정보가 수집됩니다.</span></p>
                </td>
                <td
                    style="width:163.55pt; border-top-style:solid; border-top-width:0.75pt; border-left-style:solid; border-left-width:0.75pt; padding-right:5.03pt; padding-left:5.03pt; vertical-align:top; -aw-border-left:0.5pt single #000000; -aw-border-top:0.5pt single #000000">
                    <p style="margin-right:38.75pt; text-align:justify; font-size:10.5pt"><span
                            style="font-family:'Malgun Gothic'">회원 탈퇴 후 즉시 삭제(회원이 숙려 기간을 선택하지 않은 경우)/숙려 기간 종료 및 회사의
                            Kakao Talk 공식 채널 추가 취소 후 삭제</span></p>
                    <p style="margin-right:38.75pt; text-align:justify; font-size:10.5pt"><span
                            style="font-family:'Malgun Gothic'">회원이 게임 내에서 개인 Kakao Talk 계정 연동을 해제하고, 회사의 Kakao Talk 공식
                            채널 추가를 취소하면 관련 정보가 삭제됩니다.</span></p>
                </td>
            </tr>
        </table>
        <p style="margin-right:38.75pt"><span style="font-family:'Malgun Gothic'; -aw-import:ignore">&#xa0;</span></p>
        <p style="margin-right:38.75pt"><span style="font-family:'Malgun Gothic'">일부 게임에서만 임시 회원이 제3자 계정을 연결하여 정식 회원으로
                업그레이드할 수 있는 기능을 제공합니다.</span></p>
        <p style="margin-right:38.75pt"><span style="font-family:'Malgun Gothic'">제3자 플랫폼 인증을 통해 회원가입할 때, 위에 언급된 정보 외의
                다른 개인정보는 저장하지 않습니다.</span></p>
        <p style="margin-right:38.75pt; font-size:9pt"><span
                style="font-family:'Malgun Gothic'; -aw-import:ignore">&#xa0;</span></p>
    </div>
`;

export const zrrglobalUseDetailHtml = `
     <div>
        <p style="margin-right:38.75pt"><span style="font-family:'Malgun Gothic'">본사</span></p>
        <p style="margin-right:38.75pt; text-align:left; widows:2; orphans:2; font-size:9pt"><span
                style="font-family:'Malgun Gothic'; -aw-import:ignore">&#xa0;</span></p>
        <table cellspacing="0" cellpadding="0" class="TableGrid"
            style="margin-right:9pt; margin-left:9pt; border:0.75pt solid #000000; -aw-border:0.5pt single #000000; -aw-border-insideh:0.5pt single #000000; -aw-border-insidev:0.5pt single #000000; border-collapse:collapse; float:left">
            <tr>
                <td
                    style="width:163.5pt; border-right-style:solid; border-right-width:0.75pt; border-bottom-style:solid; border-bottom-width:0.75pt; padding-right:5.03pt; padding-left:5.03pt; vertical-align:top; -aw-border-bottom:0.5pt single #000000; -aw-border-right:0.5pt single #000000">
                    <p style="margin-right:38.75pt; text-align:justify; font-size:10.5pt"><span
                            style="font-family:'Malgun Gothic'">목적</span></p>
                </td>
                <td
                    style="width:166.4pt; border-right-style:solid; border-right-width:0.75pt; border-left-style:solid; border-left-width:0.75pt; border-bottom-style:solid; border-bottom-width:0.75pt; padding-right:5.03pt; padding-left:5.03pt; vertical-align:top; -aw-border-bottom:0.5pt single #000000; -aw-border-left:0.5pt single #000000; -aw-border-right:0.5pt single #000000">
                    <p style="margin-right:38.75pt; text-align:justify; font-size:10.5pt"><span
                            style="font-family:'Malgun Gothic'">정보 유형</span></p>
                </td>
                <td
                    style="width:163.55pt; border-left-style:solid; border-left-width:0.75pt; border-bottom-style:solid; border-bottom-width:0.75pt; padding-right:5.03pt; padding-left:5.03pt; vertical-align:top; -aw-border-bottom:0.5pt single #000000; -aw-border-left:0.5pt single #000000">
                    <p style="margin-right:38.75pt; text-align:justify; font-size:10.5pt"><span
                            style="font-family:'Malgun Gothic'">보관 기한</span></p>
                </td>
            </tr>
            <tr>
                <td
                    style="width:163.5pt; border-top-style:solid; border-top-width:0.75pt; border-right-style:solid; border-right-width:0.75pt; border-bottom-style:solid; border-bottom-width:0.75pt; padding-right:5.03pt; padding-left:5.03pt; vertical-align:top; -aw-border-bottom:0.5pt single #000000; -aw-border-right:0.5pt single #000000; -aw-border-top:0.5pt single #000000">
                    <p style="margin-right:38.75pt; text-align:justify; font-size:10.5pt"><span
                            style="font-family:'Malgun Gothic'">회원가입 시 사용자 신분 인증</span></p>
                </td>
                <td
                    style="width:166.4pt; border-style:solid; border-width:0.75pt; padding-right:5.03pt; padding-left:5.03pt; vertical-align:top; -aw-border:0.5pt single #000000">
                    <p style="margin-right:38.75pt; text-align:justify; font-size:10.5pt"><span
                            style="font-family:'Malgun Gothic'">계정, 비밀번호, 핸드폰 번호</span></p>
                </td>
                <td
                    style="width:163.55pt; border-top-style:solid; border-top-width:0.75pt; border-left-style:solid; border-left-width:0.75pt; border-bottom-style:solid; border-bottom-width:0.75pt; padding-right:5.03pt; padding-left:5.03pt; vertical-align:top; -aw-border-bottom:0.5pt single #000000; -aw-border-left:0.5pt single #000000; -aw-border-top:0.5pt single #000000">
                    <p style="margin-right:38.75pt; text-align:justify; font-size:10.5pt"><span
                            style="font-family:'Malgun Gothic'">회원 탈퇴 시 즉시 삭제</span></p>
                </td>
            </tr>
            <tr>
                <td
                    style="width:163.5pt; border-top-style:solid; border-top-width:0.75pt; border-right-style:solid; border-right-width:0.75pt; border-bottom-style:solid; border-bottom-width:0.75pt; padding-right:5.03pt; padding-left:5.03pt; vertical-align:top; -aw-border-bottom:0.5pt single #000000; -aw-border-right:0.5pt single #000000; -aw-border-top:0.5pt single #000000">
                    <p style="margin-right:38.75pt; text-align:justify; font-size:10.5pt"><span
                            style="font-family:'Malgun Gothic'">모바일 서비스 및 이벤트 상품 배송 등에 활용</span></p>
                </td>
                <td
                    style="width:166.4pt; border-style:solid; border-width:0.75pt; padding-right:5.03pt; padding-left:5.03pt; vertical-align:top; -aw-border:0.5pt single #000000">
                    <p style="margin-right:38.75pt; text-align:justify; font-size:10.5pt"><span
                            style="font-family:'Malgun Gothic'">IP 주소, 접속 날짜, 서비스 이용 기록, 부정 이용 기록, 오류 정보</span></p>
                </td>
                <td
                    style="width:163.55pt; border-top-style:solid; border-top-width:0.75pt; border-left-style:solid; border-left-width:0.75pt; border-bottom-style:solid; border-bottom-width:0.75pt; padding-right:5.03pt; padding-left:5.03pt; vertical-align:top; -aw-border-bottom:0.5pt single #000000; -aw-border-left:0.5pt single #000000; -aw-border-top:0.5pt single #000000">
                    <p style="margin-right:38.75pt; text-align:justify; font-size:10.5pt"><span
                            style="font-family:'Malgun Gothic'">회원 탈퇴 시 즉시 폐기되나, 계약 및 주문내역, 취소내역, 정산내역, 재무내역 등은 회원 탈퇴 후
                            5년간 보관됩니다.</span></p>
                </td>
            </tr>
            <tr>
                <td
                    style="width:163.5pt; border-top-style:solid; border-top-width:0.75pt; border-right-style:solid; border-right-width:0.75pt; border-bottom-style:solid; border-bottom-width:0.75pt; padding-right:5.03pt; padding-left:5.03pt; vertical-align:top; -aw-border-bottom:0.5pt single #000000; -aw-border-right:0.5pt single #000000; -aw-border-top:0.5pt single #000000">
                    <p style="margin-right:38.75pt; text-align:justify; font-size:10.5pt"><span
                            style="font-family:'Malgun Gothic'">서비스 이용 시 본인확인 절차, 비밀번호 분실, 계정 잠금, 결제 환불 등의 서비스 그리고 이용자
                            특성에 따른 맞춤형 서비스 제공 </span></p>
                </td>
                <td
                    style="width:166.4pt; border-style:solid; border-width:0.75pt; padding-right:5.03pt; padding-left:5.03pt; vertical-align:top; -aw-border:0.5pt single #000000">
                    <p style="margin-right:38.75pt; text-align:justify; font-size:10.5pt"><span
                            style="font-family:'Malgun Gothic'">ID, 비밀번호, 캐릭터명, 핸드폰 기종 그리고 광고 식별자</span></p>
                </td>
                <td
                    style="width:163.55pt; border-top-style:solid; border-top-width:0.75pt; border-left-style:solid; border-left-width:0.75pt; border-bottom-style:solid; border-bottom-width:0.75pt; padding-right:5.03pt; padding-left:5.03pt; vertical-align:top; -aw-border-bottom:0.5pt single #000000; -aw-border-left:0.5pt single #000000; -aw-border-top:0.5pt single #000000">
                    <p style="margin-right:38.75pt; text-align:justify; font-size:10.5pt"><span
                            style="font-family:'Malgun Gothic'">회원 탈퇴 시 즉시 삭제</span></p>
                </td>
            </tr>
            <tr>
                <td
                    style="width:163.5pt; border-top-style:solid; border-top-width:0.75pt; border-right-style:solid; border-right-width:0.75pt; border-bottom-style:solid; border-bottom-width:0.75pt; padding-right:5.03pt; padding-left:5.03pt; vertical-align:top; -aw-border-bottom:0.5pt single #000000; -aw-border-right:0.5pt single #000000; -aw-border-top:0.5pt single #000000">
                    <p style="margin-right:38.75pt; text-align:justify; font-size:10.5pt"><span
                            style="font-family:'Malgun Gothic'">요금을 정산하기 위해 유료 서비스 결제 시 수집</span></p>
                </td>
                <td
                    style="width:166.4pt; border-style:solid; border-width:0.75pt; padding-right:5.03pt; padding-left:5.03pt; vertical-align:top; -aw-border:0.5pt single #000000">
                    <p style="margin-right:38.75pt; text-align:justify; font-size:10.5pt"><span
                            style="font-family:'Malgun Gothic'">IP 주소</span></p>
                </td>
                <td
                    style="width:163.55pt; border-top-style:solid; border-top-width:0.75pt; border-left-style:solid; border-left-width:0.75pt; border-bottom-style:solid; border-bottom-width:0.75pt; padding-right:5.03pt; padding-left:5.03pt; vertical-align:top; -aw-border-bottom:0.5pt single #000000; -aw-border-left:0.5pt single #000000; -aw-border-top:0.5pt single #000000">
                    <p style="margin-right:38.75pt; text-align:justify; font-size:10.5pt"><span
                            style="font-family:'Malgun Gothic'">결제 정보는 회원 탈퇴 후 5년간 보관됩니다.</span></p>
                </td>
            </tr>
            <tr>
                <td
                    style="width:163.5pt; border-top-style:solid; border-top-width:0.75pt; border-right-style:solid; border-right-width:0.75pt; border-bottom-style:solid; border-bottom-width:0.75pt; padding-right:5.03pt; padding-left:5.03pt; vertical-align:top; -aw-border-bottom:0.5pt single #000000; -aw-border-right:0.5pt single #000000; -aw-border-top:0.5pt single #000000">
                    <p style="margin-right:38.75pt; text-align:justify; font-size:10.5pt"><span
                            style="font-family:'Malgun Gothic'">계약 이행 및 분쟁 처리</span></p>
                </td>
                <td
                    style="width:166.4pt; border-style:solid; border-width:0.75pt; padding-right:5.03pt; padding-left:5.03pt; vertical-align:top; -aw-border:0.5pt single #000000">
                    <p style="margin-right:38.75pt; text-align:justify; font-size:10.5pt"><span
                            style="font-family:'Malgun Gothic'">IP 주소, 서버 이용 기록(접속 로그 기록, 서비스 종료 일자)</span></p>
                </td>
                <td
                    style="width:163.55pt; border-top-style:solid; border-top-width:0.75pt; border-left-style:solid; border-left-width:0.75pt; border-bottom-style:solid; border-bottom-width:0.75pt; padding-right:5.03pt; padding-left:5.03pt; vertical-align:top; -aw-border-bottom:0.5pt single #000000; -aw-border-left:0.5pt single #000000; -aw-border-top:0.5pt single #000000">
                    <p style="margin-right:38.75pt; text-align:justify; font-size:10.5pt"><span
                            style="font-family:'Malgun Gothic'">분쟁 관련 정보는 회원 탈퇴 후 3년간 보관되며, 웹페이지 접속기록은 회원 탈퇴 후 3개월간
                            보관됩니다.</span></p>
                </td>
            </tr>
            <tr>
                <td
                    style="width:163.5pt; border-top-style:solid; border-top-width:0.75pt; border-right-style:solid; border-right-width:0.75pt; border-bottom-style:solid; border-bottom-width:0.75pt; padding-right:5.03pt; padding-left:5.03pt; vertical-align:top; -aw-border-bottom:0.5pt single #000000; -aw-border-right:0.5pt single #000000; -aw-border-top:0.5pt single #000000">
                    <p style="margin-right:38.75pt; text-align:justify; font-size:10.5pt"><span
                            style="font-family:'Malgun Gothic'">이용자 식별 및 중복 가입 확인, 결제 환불 등 고객 서비스를 위해 사용합니다.</span></p>
                </td>
                <td
                    style="width:166.4pt; border-style:solid; border-width:0.75pt; padding-right:5.03pt; padding-left:5.03pt; vertical-align:top; -aw-border:0.5pt single #000000">
                    <p style="margin-right:38.75pt; text-align:justify; font-size:10.5pt"><span
                            style="font-family:'Malgun Gothic'">중복 가입 확인 정보(DI)에 사용합니다.</span></p>
                </td>
                <td
                    style="width:163.55pt; border-top-style:solid; border-top-width:0.75pt; border-left-style:solid; border-left-width:0.75pt; border-bottom-style:solid; border-bottom-width:0.75pt; padding-right:5.03pt; padding-left:5.03pt; vertical-align:top; -aw-border-bottom:0.5pt single #000000; -aw-border-left:0.5pt single #000000; -aw-border-top:0.5pt single #000000">
                    <p style="margin-right:38.75pt; text-align:justify; font-size:10.5pt"><span
                            style="font-family:'Malgun Gothic'">회원 탈퇴 시 즉시 삭제</span></p>
                </td>
            </tr>
            <tr>
                <td
                    style="width:163.5pt; border-top-style:solid; border-top-width:0.75pt; border-right-style:solid; border-right-width:0.75pt; border-bottom-style:solid; border-bottom-width:0.75pt; padding-right:5.03pt; padding-left:5.03pt; vertical-align:top; -aw-border-bottom:0.5pt single #000000; -aw-border-right:0.5pt single #000000; -aw-border-top:0.5pt single #000000">
                    <p style="margin-right:38.75pt; text-align:justify; font-size:10.5pt"><span
                            style="font-family:'Malgun Gothic'">외부 기업과 연락하고 협력 서비스를 이용할 때 사용합니다.</span></p>
                </td>
                <td
                    style="width:166.4pt; border-style:solid; border-width:0.75pt; padding-right:5.03pt; padding-left:5.03pt; vertical-align:top; -aw-border:0.5pt single #000000">
                    <p style="margin-right:38.75pt; text-align:justify; font-size:10.5pt"><span
                            style="font-family:'Malgun Gothic'">암호화된 동일 인식 식별 정보(CI)</span></p>
                </td>
                <td
                    style="width:163.55pt; border-top-style:solid; border-top-width:0.75pt; border-left-style:solid; border-left-width:0.75pt; border-bottom-style:solid; border-bottom-width:0.75pt; padding-right:5.03pt; padding-left:5.03pt; vertical-align:top; -aw-border-bottom:0.5pt single #000000; -aw-border-left:0.5pt single #000000; -aw-border-top:0.5pt single #000000">
                    <p style="margin-right:38.75pt; text-align:justify; font-size:10.5pt"><span
                            style="font-family:'Malgun Gothic'">회원 탈퇴 시 즉시 삭제</span></p>
                </td>
            </tr>
            <tr>
                <td
                    style="width:163.5pt; border-top-style:solid; border-top-width:0.75pt; border-right-style:solid; border-right-width:0.75pt; padding-right:5.03pt; padding-left:5.03pt; vertical-align:top; -aw-border-right:0.5pt single #000000; -aw-border-top:0.5pt single #000000">
                    <p style="margin-right:38.75pt; text-align:justify; font-size:10.5pt"><span
                            style="font-family:'Malgun Gothic'">확인 가능한 연령</span></p>
                </td>
                <td
                    style="width:166.4pt; border-top-style:solid; border-top-width:0.75pt; border-right-style:solid; border-right-width:0.75pt; border-left-style:solid; border-left-width:0.75pt; padding-right:5.03pt; padding-left:5.03pt; vertical-align:top; -aw-border-left:0.5pt single #000000; -aw-border-right:0.5pt single #000000; -aw-border-top:0.5pt single #000000">
                    <p style="margin-right:38.75pt; text-align:justify; font-size:10.5pt"><span
                            style="font-family:'Malgun Gothic'">출생연월</span></p>
                </td>
                <td
                    style="width:163.55pt; border-top-style:solid; border-top-width:0.75pt; border-left-style:solid; border-left-width:0.75pt; padding-right:5.03pt; padding-left:5.03pt; vertical-align:top; -aw-border-left:0.5pt single #000000; -aw-border-top:0.5pt single #000000">
                    <p style="margin-right:38.75pt; text-align:justify; font-size:10.5pt"><span
                            style="font-family:'Malgun Gothic'">회원 탈퇴 시 즉시 삭제</span></p>
                </td>
            </tr>
        </table>
        <p style="margin-right:38.75pt; text-align:left; widows:2; orphans:2"><br
                style="page-break-before:always; clear:both" /><span style="font-family:'Malgun Gothic'"> 임시 회원 모드에서,
                회사는 사용자가 직접 만든 계정과 비밀번호를 수집하지 않습니다. 대신 임시 회원에게 암호화된 계정, 비밀 번호를 자동으로 생성합니다. 동시에 위 표에 나열된 다른 정보를
                수집합니다.</span></p>
        <p style="margin-right:38.75pt"><span style="font-family:'Malgun Gothic'; -aw-import:ignore">&#xa0;</span></p>
        <p style="margin-right:38.75pt"><span style="font-family:'Malgun Gothic'">다음 정보는 사용자가 특정 상황을 능동적으로 수행할 때만 회사가
                수집합니다. 회원이 해당 상황을 수행하지 않으면, 사용자가 이 방침에 동의하더라도 회사는 아래 정보를 자동으로 수집하지 않습니다.</span></p>
        <table cellspacing="0" cellpadding="0" class="TableGrid"
            style="border:0.75pt solid #000000; -aw-border:0.5pt single #000000; -aw-border-insideh:0.5pt single #000000; -aw-border-insidev:0.5pt single #000000; border-collapse:collapse">
            <tr>
                <td
                    style="width:144.9pt; border-right-style:solid; border-right-width:0.75pt; border-bottom-style:solid; border-bottom-width:0.75pt; padding-right:5.03pt; padding-left:5.03pt; vertical-align:top; -aw-border-bottom:0.5pt single #000000; -aw-border-right:0.5pt single #000000">
                    <p style="margin-right:38.75pt; text-align:justify; font-size:10.5pt"><span
                            style="font-family:'Malgun Gothic'">수행 상황</span></p>
                </td>
                <td
                    style="width:166.4pt; border-right-style:solid; border-right-width:0.75pt; border-left-style:solid; border-left-width:0.75pt; border-bottom-style:solid; border-bottom-width:0.75pt; padding-right:5.03pt; padding-left:5.03pt; vertical-align:top; -aw-border-bottom:0.5pt single #000000; -aw-border-left:0.5pt single #000000; -aw-border-right:0.5pt single #000000">
                    <p style="margin-right:38.75pt; text-align:justify; font-size:10.5pt"><span
                            style="font-family:'Malgun Gothic'">목적</span></p>
                </td>
                <td
                    style="width:81.3pt; border-right-style:solid; border-right-width:0.75pt; border-left-style:solid; border-left-width:0.75pt; border-bottom-style:solid; border-bottom-width:0.75pt; padding-right:5.03pt; padding-left:5.03pt; vertical-align:top; -aw-border-bottom:0.5pt single #000000; -aw-border-left:0.5pt single #000000; -aw-border-right:0.5pt single #000000">
                    <p style="margin-right:38.75pt; text-align:justify; font-size:10.5pt"><span
                            style="font-family:'Malgun Gothic'">정보 유형</span></p>
                </td>
                <td
                    style="width:187.65pt; border-left-style:solid; border-left-width:0.75pt; border-bottom-style:solid; border-bottom-width:0.75pt; padding-right:5.03pt; padding-left:5.03pt; vertical-align:top; -aw-border-bottom:0.5pt single #000000; -aw-border-left:0.5pt single #000000">
                    <p style="margin-right:38.75pt; text-align:justify; font-size:10.5pt"><span
                            style="font-family:'Malgun Gothic'">보관 기한</span></p>
                </td>
            </tr>
            <tr>
                <td
                    style="width:144.9pt; border-top-style:solid; border-top-width:0.75pt; border-right-style:solid; border-right-width:0.75pt; border-bottom-style:solid; border-bottom-width:0.75pt; padding-right:5.03pt; padding-left:5.03pt; vertical-align:top; -aw-border-bottom:0.5pt single #000000; -aw-border-right:0.5pt single #000000; -aw-border-top:0.5pt single #000000">
                    <p style="margin-right:38.75pt; text-align:justify; font-size:10.5pt"><span
                            style="font-family:'Malgun Gothic'">회원이 회사에 이메일을 쓰거나 고객서비스 직원과 연락할 때 제공하는 정보</span></p>
                </td>
                <td
                    style="width:166.4pt; border-style:solid; border-width:0.75pt; padding-right:5.03pt; padding-left:5.03pt; vertical-align:top; -aw-border:0.5pt single #000000">
                    <p style="margin-right:38.75pt; text-align:justify; font-size:10.5pt"><span
                            style="font-family:'Malgun Gothic'">회원에게 답변할 때 사용합니다.</span></p>
                </td>
                <td
                    style="width:81.3pt; border-style:solid; border-width:0.75pt; padding-right:5.03pt; padding-left:5.03pt; vertical-align:top; -aw-border:0.5pt single #000000">
                    <p style="margin-right:38.75pt; text-align:justify; font-size:10.5pt"><span
                            style="font-family:'Malgun Gothic'">이메일 주소</span></p>
                </td>
                <td
                    style="width:187.65pt; border-top-style:solid; border-top-width:0.75pt; border-left-style:solid; border-left-width:0.75pt; border-bottom-style:solid; border-bottom-width:0.75pt; padding-right:5.03pt; padding-left:5.03pt; vertical-align:top; -aw-border-bottom:0.5pt single #000000; -aw-border-left:0.5pt single #000000; -aw-border-top:0.5pt single #000000">
                    <p style="margin-right:38.75pt; text-align:justify; font-size:10.5pt"><span
                            style="font-family:'Malgun Gothic'">사용자가 회원 탈퇴할 때까지 해당 정보를 보관하지만, 분쟁과 관련된 정보는 회원 자격 해지 후 3년간
                            보관됩니다.</span></p>
                </td>
            </tr>
            <tr>
                <td
                    style="width:144.9pt; border-top-style:solid; border-top-width:0.75pt; border-right-style:solid; border-right-width:0.75pt; border-bottom-style:solid; border-bottom-width:0.75pt; padding-right:5.03pt; padding-left:5.03pt; vertical-align:top; -aw-border-bottom:0.5pt single #000000; -aw-border-right:0.5pt single #000000; -aw-border-top:0.5pt single #000000">
                    <p style="margin-right:38.75pt; text-align:justify; font-size:10.5pt"><span
                            style="font-family:'Malgun Gothic'">회원이 설문조사에 응답하여 선택적으로 작성합니다.</span></p>
                </td>
                <td
                    style="width:166.4pt; border-style:solid; border-width:0.75pt; padding-right:5.03pt; padding-left:5.03pt; vertical-align:top; -aw-border:0.5pt single #000000">
                    <p style="margin-right:38.75pt; text-align:justify; font-size:10.5pt"><span
                            style="font-family:'Malgun Gothic'">회원에게 피드백할 때 사용합니다.</span></p>
                </td>
                <td
                    style="width:81.3pt; border-style:solid; border-width:0.75pt; padding-right:5.03pt; padding-left:5.03pt; vertical-align:top; -aw-border:0.5pt single #000000">
                    <p style="margin-right:38.75pt; text-align:justify; font-size:10.5pt"><span
                            style="font-family:'Malgun Gothic'">이메일 주소</span></p>
                </td>
                <td
                    style="width:187.65pt; border-top-style:solid; border-top-width:0.75pt; border-left-style:solid; border-left-width:0.75pt; border-bottom-style:solid; border-bottom-width:0.75pt; padding-right:5.03pt; padding-left:5.03pt; vertical-align:top; -aw-border-bottom:0.5pt single #000000; -aw-border-left:0.5pt single #000000; -aw-border-top:0.5pt single #000000">
                    <p style="margin-right:38.75pt; text-align:justify; font-size:10.5pt"><span
                            style="font-family:'Malgun Gothic'">회원 탈퇴 시 즉시 삭제</span></p>
                </td>
            </tr>
            <tr>
                <td
                    style="width:144.9pt; border-top-style:solid; border-top-width:0.75pt; border-right-style:solid; border-right-width:0.75pt; border-bottom-style:solid; border-bottom-width:0.75pt; padding-right:5.03pt; padding-left:5.03pt; vertical-align:top; -aw-border-bottom:0.5pt single #000000; -aw-border-right:0.5pt single #000000; -aw-border-top:0.5pt single #000000">
                    <p style="margin-right:38.75pt; text-align:justify; font-size:10.5pt"><span
                            style="font-family:'Malgun Gothic'">회원이 이메일 구독 이벤트에 참여할 때의 정보</span></p>
                </td>
                <td
                    style="width:166.4pt; border-style:solid; border-width:0.75pt; padding-right:5.03pt; padding-left:5.03pt; vertical-align:top; -aw-border:0.5pt single #000000">
                    <p style="margin-right:38.75pt; text-align:justify; font-size:10.5pt"><span
                            style="font-family:'Malgun Gothic'">회원 이메일로 정보를 발송할 때 사용하며, 여기에는 마케팅 정보 등이 포함되나 이에 국한되지
                            않습니다.</span></p>
                </td>
                <td
                    style="width:81.3pt; border-style:solid; border-width:0.75pt; padding-right:5.03pt; padding-left:5.03pt; vertical-align:top; -aw-border:0.5pt single #000000">
                    <p style="margin-right:38.75pt; text-align:justify; font-size:10.5pt"><span
                            style="font-family:'Malgun Gothic'">이메일 주소</span></p>
                </td>
                <td
                    style="width:187.65pt; border-top-style:solid; border-top-width:0.75pt; border-left-style:solid; border-left-width:0.75pt; border-bottom-style:solid; border-bottom-width:0.75pt; padding-right:5.03pt; padding-left:5.03pt; vertical-align:top; -aw-border-bottom:0.5pt single #000000; -aw-border-left:0.5pt single #000000; -aw-border-top:0.5pt single #000000">
                    <p style="margin-right:38.75pt; text-align:justify; font-size:10.5pt"><span
                            style="font-family:'Malgun Gothic'">구독 취소 혹은 회원 탈퇴 시 즉시 삭제</span></p>
                </td>
            </tr>
            <tr>
                <td
                    style="width:144.9pt; border-top-style:solid; border-top-width:0.75pt; border-right-style:solid; border-right-width:0.75pt; border-bottom-style:solid; border-bottom-width:0.75pt; padding-right:5.03pt; padding-left:5.03pt; vertical-align:top; -aw-border-bottom:0.5pt single #000000; -aw-border-right:0.5pt single #000000; -aw-border-top:0.5pt single #000000">
                    <p style="margin-right:38.75pt; text-align:justify; font-size:10.5pt"><span
                            style="font-family:'Malgun Gothic'">14세 미만 회원가입 절차 중</span></p>
                </td>
                <td
                    style="width:166.4pt; border-style:solid; border-width:0.75pt; padding-right:5.03pt; padding-left:5.03pt; vertical-align:top; -aw-border:0.5pt single #000000">
                    <p style="margin-right:38.75pt; text-align:justify; font-size:10.5pt"><span
                            style="font-family:'Malgun Gothic'">미성년자 회원의 개인정보 수집 및 이용에 대해 보호자의 동의를 확인하는 데 사용합니다.</span>
                    </p>
                </td>
                <td
                    style="width:81.3pt; border-style:solid; border-width:0.75pt; padding-right:5.03pt; padding-left:5.03pt; vertical-align:top; -aw-border:0.5pt single #000000">
                    <p style="margin-right:38.75pt; text-align:justify; font-size:10.5pt"><span
                            style="font-family:'Malgun Gothic'">보호자 이메일 주소</span></p>
                </td>
                <td
                    style="width:187.65pt; border-top-style:solid; border-top-width:0.75pt; border-left-style:solid; border-left-width:0.75pt; border-bottom-style:solid; border-bottom-width:0.75pt; padding-right:5.03pt; padding-left:5.03pt; vertical-align:top; -aw-border-bottom:0.5pt single #000000; -aw-border-left:0.5pt single #000000; -aw-border-top:0.5pt single #000000">
                    <p style="margin-right:38.75pt; text-align:justify; font-size:10.5pt"><span
                            style="font-family:'Malgun Gothic'">이용자가 회원 탈퇴할 때까지, 혹은 이용자의 나이가 24살이 될 때까지</span></p>
                </td>
            </tr>
            <tr>
                <td
                    style="width:144.9pt; border-top-style:solid; border-top-width:0.75pt; border-right-style:solid; border-right-width:0.75pt; border-bottom-style:solid; border-bottom-width:0.75pt; padding-right:5.03pt; padding-left:5.03pt; vertical-align:top; -aw-border-bottom:0.5pt single #000000; -aw-border-right:0.5pt single #000000; -aw-border-top:0.5pt single #000000">
                    <p style="margin-right:38.75pt; text-align:justify; font-size:10.5pt"><span
                            style="font-family:'Malgun Gothic'">회원이 회사에 전화를 걸거나 회사 고객서비스 직원과 연락할 때 제공합니다.</span></p>
                </td>
                <td
                    style="width:166.4pt; border-style:solid; border-width:0.75pt; padding-right:5.03pt; padding-left:5.03pt; vertical-align:top; -aw-border:0.5pt single #000000">
                    <p style="margin-right:38.75pt; text-align:justify; font-size:10.5pt"><span
                            style="font-family:'Malgun Gothic'">회원에게 후속 연락을 취하는 데 사용합니다.</span></p>
                </td>
                <td
                    style="width:81.3pt; border-style:solid; border-width:0.75pt; padding-right:5.03pt; padding-left:5.03pt; vertical-align:top; -aw-border:0.5pt single #000000">
                    <p style="margin-right:38.75pt; text-align:justify; font-size:10.5pt"><span
                            style="font-family:'Malgun Gothic'">전화번호</span></p>
                </td>
                <td
                    style="width:187.65pt; border-top-style:solid; border-top-width:0.75pt; border-left-style:solid; border-left-width:0.75pt; border-bottom-style:solid; border-bottom-width:0.75pt; padding-right:5.03pt; padding-left:5.03pt; vertical-align:top; -aw-border-bottom:0.5pt single #000000; -aw-border-left:0.5pt single #000000; -aw-border-top:0.5pt single #000000">
                    <p style="margin-right:38.75pt; text-align:justify; font-size:10.5pt"><span
                            style="font-family:'Malgun Gothic'">사용자가 회원 탈퇴할 때까지 해당 정보를 보관하지만, 분쟁과 관련된 정보는 회원 자격 해지 후 3년간
                            보관됩니다.</span></p>
                </td>
            </tr>
            <tr>
                <td
                    style="width:144.9pt; border-top-style:solid; border-top-width:0.75pt; border-right-style:solid; border-right-width:0.75pt; border-bottom-style:solid; border-bottom-width:0.75pt; padding-right:5.03pt; padding-left:5.03pt; vertical-align:top; -aw-border-bottom:0.5pt single #000000; -aw-border-right:0.5pt single #000000; -aw-border-top:0.5pt single #000000">
                    <p style="margin-right:38.75pt; text-align:justify; font-size:10.5pt"><span
                            style="font-family:'Malgun Gothic'">회원이 설문조사에 응답하여 선택적으로 작성합니다.</span></p>
                </td>
                <td
                    style="width:166.4pt; border-style:solid; border-width:0.75pt; padding-right:5.03pt; padding-left:5.03pt; vertical-align:top; -aw-border:0.5pt single #000000">
                    <p style="margin-right:38.75pt; text-align:justify; font-size:10.5pt"><span
                            style="font-family:'Malgun Gothic'">회원에게 피드백할 때 사용합니다.</span></p>
                </td>
                <td
                    style="width:81.3pt; border-style:solid; border-width:0.75pt; padding-right:5.03pt; padding-left:5.03pt; vertical-align:top; -aw-border:0.5pt single #000000">
                    <p style="margin-right:38.75pt; text-align:justify; font-size:10.5pt"><span
                            style="font-family:'Malgun Gothic'">전화번호</span></p>
                </td>
                <td
                    style="width:187.65pt; border-top-style:solid; border-top-width:0.75pt; border-left-style:solid; border-left-width:0.75pt; border-bottom-style:solid; border-bottom-width:0.75pt; padding-right:5.03pt; padding-left:5.03pt; vertical-align:top; -aw-border-bottom:0.5pt single #000000; -aw-border-left:0.5pt single #000000; -aw-border-top:0.5pt single #000000">
                    <p style="margin-right:38.75pt; text-align:justify; font-size:10.5pt"><span
                            style="font-family:'Malgun Gothic'">회원 탈퇴 시 즉시 삭제</span></p>
                </td>
            </tr>
            <tr>
                <td
                    style="width:144.9pt; border-top-style:solid; border-top-width:0.75pt; border-right-style:solid; border-right-width:0.75pt; border-bottom-style:solid; border-bottom-width:0.75pt; padding-right:5.03pt; padding-left:5.03pt; vertical-align:top; -aw-border-bottom:0.5pt single #000000; -aw-border-right:0.5pt single #000000; -aw-border-top:0.5pt single #000000">
                    <p style="margin-right:38.75pt; text-align:justify; font-size:10.5pt"><span
                            style="font-family:'Malgun Gothic'">회원이 핸드폰 번호 구독 이벤트에 참가</span></p>
                </td>
                <td
                    style="width:166.4pt; border-style:solid; border-width:0.75pt; padding-right:5.03pt; padding-left:5.03pt; vertical-align:top; -aw-border:0.5pt single #000000">
                    <p style="margin-right:38.75pt; text-align:justify; font-size:10.5pt"><span
                            style="font-family:'Malgun Gothic'">회원 핸드폰으로 정보를 발송할 때 사용하며, 여기에는 마케팅 정보 등이 포함되나 이에 국한되지
                            않습니다.</span></p>
                </td>
                <td
                    style="width:81.3pt; border-style:solid; border-width:0.75pt; padding-right:5.03pt; padding-left:5.03pt; vertical-align:top; -aw-border:0.5pt single #000000">
                    <p style="margin-right:38.75pt; text-align:justify; font-size:10.5pt"><span
                            style="font-family:'Malgun Gothic'">이메일 주소</span></p>
                </td>
                <td
                    style="width:187.65pt; border-top-style:solid; border-top-width:0.75pt; border-left-style:solid; border-left-width:0.75pt; border-bottom-style:solid; border-bottom-width:0.75pt; padding-right:5.03pt; padding-left:5.03pt; vertical-align:top; -aw-border-bottom:0.5pt single #000000; -aw-border-left:0.5pt single #000000; -aw-border-top:0.5pt single #000000">
                    <p style="margin-right:38.75pt; text-align:justify; font-size:10.5pt"><span
                            style="font-family:'Malgun Gothic'">구독 취소 혹은 회원 탈퇴 시 즉시 삭제</span></p>
                </td>
            </tr>
            <tr>
                <td
                    style="width:144.9pt; border-top-style:solid; border-top-width:0.75pt; border-right-style:solid; border-right-width:0.75pt; padding-right:5.03pt; padding-left:5.03pt; vertical-align:top; -aw-border-right:0.5pt single #000000; -aw-border-top:0.5pt single #000000">
                    <p style="margin-right:38.75pt; text-align:justify; font-size:10.5pt"><span
                            style="font-family:'Malgun Gothic'">회원이 직원과 의사소통할 때 제공</span></p>
                </td>
                <td
                    style="width:166.4pt; border-top-style:solid; border-top-width:0.75pt; border-right-style:solid; border-right-width:0.75pt; border-left-style:solid; border-left-width:0.75pt; padding-right:5.03pt; padding-left:5.03pt; vertical-align:top; -aw-border-left:0.5pt single #000000; -aw-border-right:0.5pt single #000000; -aw-border-top:0.5pt single #000000">
                    <p style="margin-right:38.75pt; text-align:justify; font-size:10.5pt"><span
                            style="font-family:'Malgun Gothic'">회원에게 제공하는 생일 패키지 혹은 상품권</span></p>
                </td>
                <td
                    style="width:81.3pt; border-top-style:solid; border-top-width:0.75pt; border-right-style:solid; border-right-width:0.75pt; border-left-style:solid; border-left-width:0.75pt; padding-right:5.03pt; padding-left:5.03pt; vertical-align:top; -aw-border-left:0.5pt single #000000; -aw-border-right:0.5pt single #000000; -aw-border-top:0.5pt single #000000">
                    <p style="margin-right:38.75pt; text-align:justify; font-size:10.5pt"><span
                            style="font-family:'Malgun Gothic'">출생연월</span></p>
                </td>
                <td
                    style="width:187.65pt; border-top-style:solid; border-top-width:0.75pt; border-left-style:solid; border-left-width:0.75pt; padding-right:5.03pt; padding-left:5.03pt; vertical-align:top; -aw-border-left:0.5pt single #000000; -aw-border-top:0.5pt single #000000">
                    <p style="margin-right:38.75pt; text-align:justify; font-size:10.5pt"><span
                            style="font-family:'Malgun Gothic'">회원은 언제든지 회사에 요청하여 해당 정보를 삭제할 수 있습니다. 회원 탈퇴 시 즉시
                            폐기됩니다.</span></p>
                </td>
            </tr>
        </table>
        <p style="margin-right:38.75pt; font-size:9pt"><span
                style="font-family:'Malgun Gothic'; -aw-import:ignore">&#xa0;</span></p>
        <p style="margin-right:38.75pt; font-size:9pt"><span style="font-family:'Malgun Gothic'">법률에 따라 회사는 위의 경로를 통해
                획득한 전화번호 또는 이메일 주소로 마케팅 홍보 메일이나 문자 메시지를 발송할 수 있습니다. (회원 보호자 이메일 주소는 제외. 회사는 이러한 주소로 보호자의 동의와 무관한 마케팅 홍보
                메일을 보내지 않지만, 보호자 동의와 관련된 서비스 메일은 발송할 수 있습니다) 회원은 수신한 마케팅 홍보 메일이나 문자를 통해 언제든지 구독을 취소할 수 있습니다. 구독 취소 후에는
                회사가 해당 전화번호나 이메일 주소로 마케팅 홍보 메일을 보내지 않습니다. 다만 사용자가 직접 이메일 또는 휴대전화 번호 구독 이벤트에 다시 참여하는 경우는 예외입니다. 사용자의 별도
                동의를 다시 받지 않는 한, 회사는 밤 9시부터 다음날 오전 8시 사이에는 마케팅 홍보 문자 메시지를 발송하지 않습니다.</span></p>
        <p style="margin-right:38.75pt"><span style="font-family:'Malgun Gothic'; -aw-import:ignore">&#xa0;</span></p>
        <p style="margin-right:38.75pt"><span style="font-family:'Malgun Gothic'">회사가 제3자에게 획득한 정보</span></p>
        <p style="margin-right:38.75pt"><span style="font-family:'Malgun Gothic'; -aw-import:ignore">&#xa0;</span></p>
        <table cellspacing="0" cellpadding="0" class="TableGrid"
            style="border:0.75pt solid #000000; -aw-border:0.5pt single #000000; -aw-border-insideh:0.5pt single #000000; -aw-border-insidev:0.5pt single #000000; border-collapse:collapse">
            <tr>
                <td
                    style="width:163.55pt; border-right-style:solid; border-right-width:0.75pt; border-bottom-style:solid; border-bottom-width:0.75pt; padding-right:5.03pt; padding-left:5.03pt; vertical-align:top; -aw-border-bottom:0.5pt single #000000; -aw-border-right:0.5pt single #000000">
                    <p style="margin-right:38.75pt; text-align:justify; font-size:10.5pt"><span
                            style="font-family:'Malgun Gothic'">제3자 명칭</span></p>
                </td>
                <td
                    style="width:163.55pt; border-right-style:solid; border-right-width:0.75pt; border-left-style:solid; border-left-width:0.75pt; border-bottom-style:solid; border-bottom-width:0.75pt; padding-right:5.03pt; padding-left:5.03pt; vertical-align:top; -aw-border-bottom:0.5pt single #000000; -aw-border-left:0.5pt single #000000; -aw-border-right:0.5pt single #000000">
                    <p style="margin-right:38.75pt; text-align:justify; font-size:10.5pt"><span
                            style="font-family:'Malgun Gothic'">획득 정보 유형</span></p>
                </td>
                <td
                    style="width:163.55pt; border-right-style:solid; border-right-width:0.75pt; border-left-style:solid; border-left-width:0.75pt; border-bottom-style:solid; border-bottom-width:0.75pt; padding-right:5.03pt; padding-left:5.03pt; vertical-align:top; -aw-border-bottom:0.5pt single #000000; -aw-border-left:0.5pt single #000000; -aw-border-right:0.5pt single #000000">
                    <p style="margin-right:38.75pt; text-align:justify; font-size:10.5pt"><span
                            style="font-family:'Malgun Gothic'">목적</span></p>
                </td>
                <td
                    style="width:163.55pt; border-left-style:solid; border-left-width:0.75pt; border-bottom-style:solid; border-bottom-width:0.75pt; padding-right:5.03pt; padding-left:5.03pt; vertical-align:top; -aw-border-bottom:0.5pt single #000000; -aw-border-left:0.5pt single #000000">
                    <p style="margin-right:38.75pt; text-align:justify; font-size:10.5pt"><span
                            style="font-family:'Malgun Gothic'">보관 기한</span></p>
                </td>
            </tr>
            <tr>
                <td
                    style="width:163.55pt; border-top-style:solid; border-top-width:0.75pt; border-right-style:solid; border-right-width:0.75pt; border-bottom-style:solid; border-bottom-width:0.75pt; padding-right:5.03pt; padding-left:5.03pt; vertical-align:top; -aw-border-bottom:0.5pt single #000000; -aw-border-right:0.5pt single #000000; -aw-border-top:0.5pt single #000000">
                    <p style="margin-right:38.75pt; text-align:justify; font-size:10.5pt"><span
                            style="font-family:'Malgun Gothic'">Google</span></p>
                </td>
                <td
                    style="width:163.55pt; border-style:solid; border-width:0.75pt; padding-right:5.03pt; padding-left:5.03pt; vertical-align:top; -aw-border:0.5pt single #000000">
                    <p style="margin-right:38.75pt; text-align:justify; font-size:10.5pt"><span
                            style="font-family:'Malgun Gothic'">공개 프로필 (이름), 이메일 주소</span></p>
                </td>
                <td
                    style="width:163.55pt; border-style:solid; border-width:0.75pt; padding-right:5.03pt; padding-left:5.03pt; vertical-align:top; -aw-border:0.5pt single #000000">
                    <p style="margin-right:38.75pt; text-align:justify; font-size:10.5pt"><span
                            style="font-family:'Malgun Gothic'">제3자 계정으로 게임에 로그인하거나 임시 회원이 제3자 계정을 연결하여 정식 회원으로 업그레이드할 때
                            사용합니다.</span></p>
                    <p style="margin-right:38.75pt; text-align:justify; font-size:10.5pt"><span
                            style="font-family:'Malgun Gothic'">회원이 Google 계정으로 로그인하거나 Google 계정을 연동할 때, Google이 자동으로
                            이메일 주소를 회사에 제공합니다.</span></p>
                </td>
                <td
                    style="width:163.55pt; border-top-style:solid; border-top-width:0.75pt; border-left-style:solid; border-left-width:0.75pt; border-bottom-style:solid; border-bottom-width:0.75pt; padding-right:5.03pt; padding-left:5.03pt; vertical-align:top; -aw-border-bottom:0.5pt single #000000; -aw-border-left:0.5pt single #000000; -aw-border-top:0.5pt single #000000">
                    <p style="margin-right:38.75pt; text-align:justify; font-size:10.5pt"><span
                            style="font-family:'Malgun Gothic'">회원 탈퇴 시 즉시 삭제</span></p>
                </td>
            </tr>
            <tr>
                <td
                    style="width:163.55pt; border-top-style:solid; border-top-width:0.75pt; border-right-style:solid; border-right-width:0.75pt; border-bottom-style:solid; border-bottom-width:0.75pt; padding-right:5.03pt; padding-left:5.03pt; vertical-align:top; -aw-border-bottom:0.5pt single #000000; -aw-border-right:0.5pt single #000000; -aw-border-top:0.5pt single #000000">
                    <p style="margin-right:38.75pt; text-align:justify; font-size:10.5pt"><span
                            style="font-family:'Malgun Gothic'">Facebook</span></p>
                </td>
                <td
                    style="width:163.55pt; border-style:solid; border-width:0.75pt; padding-right:5.03pt; padding-left:5.03pt; vertical-align:top; -aw-border:0.5pt single #000000">
                    <p style="margin-right:38.75pt; text-align:justify; font-size:10.5pt"><span
                            style="font-family:'Malgun Gothic'">공개 프로필 (이름), 이메일 주소 (선택 가능)</span></p>
                </td>
                <td
                    style="width:163.55pt; border-style:solid; border-width:0.75pt; padding-right:5.03pt; padding-left:5.03pt; vertical-align:top; -aw-border:0.5pt single #000000">
                    <p style="margin-right:38.75pt; text-align:justify; font-size:10.5pt"><span
                            style="font-family:'Malgun Gothic'">제3자 계정으로 게임에 로그인하거나 임시 회원이 제3자 계정을 연결하여 정식 회원으로 업그레이드할 때
                            사용합니다.</span></p>
                    <p style="margin-right:38.75pt; text-align:justify; font-size:10.5pt"><span
                            style="font-family:'Malgun Gothic'">회원은 Facebook 계정으로 로그인하거나 연동할 때 추가로 이메일 주소를 제공할지 여부를 선택할
                            수 있습니다.</span></p>
                </td>
                <td
                    style="width:163.55pt; border-top-style:solid; border-top-width:0.75pt; border-left-style:solid; border-left-width:0.75pt; border-bottom-style:solid; border-bottom-width:0.75pt; padding-right:5.03pt; padding-left:5.03pt; vertical-align:top; -aw-border-bottom:0.5pt single #000000; -aw-border-left:0.5pt single #000000; -aw-border-top:0.5pt single #000000">
                    <p style="margin-right:38.75pt; text-align:justify; font-size:10.5pt"><span
                            style="font-family:'Malgun Gothic'">회원 탈퇴 시 즉시 삭제</span></p>
                </td>
            </tr>
            <tr>
                <td
                    style="width:163.55pt; border-top-style:solid; border-top-width:0.75pt; border-right-style:solid; border-right-width:0.75pt; border-bottom-style:solid; border-bottom-width:0.75pt; padding-right:5.03pt; padding-left:5.03pt; vertical-align:top; -aw-border-bottom:0.5pt single #000000; -aw-border-right:0.5pt single #000000; -aw-border-top:0.5pt single #000000">
                    <p style="margin-right:38.75pt; text-align:justify; font-size:10.5pt"><span
                            style="font-family:'Malgun Gothic'">Apple</span></p>
                </td>
                <td
                    style="width:163.55pt; border-style:solid; border-width:0.75pt; padding-right:5.03pt; padding-left:5.03pt; vertical-align:top; -aw-border:0.5pt single #000000">
                    <p style="margin-right:38.75pt; text-align:justify; font-size:10.5pt"><span
                            style="font-family:'Malgun Gothic'">공개 프로필 (이름), 이메일 주소 (선택 가능)</span></p>
                </td>
                <td
                    style="width:163.55pt; border-style:solid; border-width:0.75pt; padding-right:5.03pt; padding-left:5.03pt; vertical-align:top; -aw-border:0.5pt single #000000">
                    <p style="margin-right:38.75pt; text-align:justify; font-size:10.5pt"><span
                            style="font-family:'Malgun Gothic'">제3자 계정으로 게임에 로그인하거나 임시 회원이 제3자 계정을 연결하여 정식 회원으로 업그레이드할 때
                            사용합니다.</span></p>
                    <p style="margin-right:38.75pt; text-align:justify; font-size:10.5pt"><span
                            style="font-family:'Malgun Gothic'">회원은 Apple 계정으로 로그인하거나 연동할 때 추가로 이메일 주소를 제공할지 여부를 선택할 수
                            있습니다.</span></p>
                </td>
                <td
                    style="width:163.55pt; border-top-style:solid; border-top-width:0.75pt; border-left-style:solid; border-left-width:0.75pt; border-bottom-style:solid; border-bottom-width:0.75pt; padding-right:5.03pt; padding-left:5.03pt; vertical-align:top; -aw-border-bottom:0.5pt single #000000; -aw-border-left:0.5pt single #000000; -aw-border-top:0.5pt single #000000">
                    <p style="margin-right:38.75pt; text-align:justify; font-size:10.5pt"><span
                            style="font-family:'Malgun Gothic'">회원 탈퇴 시 즉시 삭제</span></p>
                </td>
            </tr>
            <tr>
                <td
                    style="width:163.55pt; border-top-style:solid; border-top-width:0.75pt; border-right-style:solid; border-right-width:0.75pt; border-bottom-style:solid; border-bottom-width:0.75pt; padding-right:5.03pt; padding-left:5.03pt; vertical-align:top; -aw-border-bottom:0.5pt single #000000; -aw-border-right:0.5pt single #000000; -aw-border-top:0.5pt single #000000">
                    <p style="margin-right:38.75pt; text-align:justify; font-size:10.5pt"><span
                            style="font-family:'Malgun Gothic'">Discord</span></p>
                </td>
                <td
                    style="width:163.55pt; border-style:solid; border-width:0.75pt; padding-right:5.03pt; padding-left:5.03pt; vertical-align:top; -aw-border:0.5pt single #000000">
                    <p style="margin-right:38.75pt; text-align:justify; font-size:10.5pt"><span
                            style="font-family:'Malgun Gothic'">Discord 계정</span></p>
                </td>
                <td
                    style="width:163.55pt; border-style:solid; border-width:0.75pt; padding-right:5.03pt; padding-left:5.03pt; vertical-align:top; -aw-border:0.5pt single #000000">
                    <p style="margin-right:38.75pt; text-align:justify; font-size:10.5pt"><span
                            style="font-family:'Malgun Gothic'">회원이 Discord 커뮤니티에서 게임 계정을 연동할 때 수집합니다. 연동 후 회원은 회사가
                            커뮤니티에서 주최하는 이벤트에 참여할 수 있고, Discord 커뮤니티 내에서 회사의 관련 이벤트 알림을 받게 됩니다.</span></p>
                </td>
                <td
                    style="width:163.55pt; border-top-style:solid; border-top-width:0.75pt; border-left-style:solid; border-left-width:0.75pt; border-bottom-style:solid; border-bottom-width:0.75pt; padding-right:5.03pt; padding-left:5.03pt; vertical-align:top; -aw-border-bottom:0.5pt single #000000; -aw-border-left:0.5pt single #000000; -aw-border-top:0.5pt single #000000">
                    <p style="margin-right:38.75pt; text-align:justify; font-size:10.5pt"><span
                            style="font-family:'Malgun Gothic'">회원 탈퇴 혹은 연동 해지 시 즉시 삭제</span></p>
                </td>
            </tr>
            <tr>
                <td
                    style="width:163.55pt; border-top-style:solid; border-top-width:0.75pt; border-right-style:solid; border-right-width:0.75pt; padding-right:5.03pt; padding-left:5.03pt; vertical-align:top; -aw-border-right:0.5pt single #000000; -aw-border-top:0.5pt single #000000">
                    <p style="margin-right:38.75pt; text-align:justify; font-size:10.5pt"><span
                            style="font-family:'Malgun Gothic'">Kakao Talk</span></p>
                </td>
                <td
                    style="width:163.55pt; border-top-style:solid; border-top-width:0.75pt; border-right-style:solid; border-right-width:0.75pt; border-left-style:solid; border-left-width:0.75pt; padding-right:5.03pt; padding-left:5.03pt; vertical-align:top; -aw-border-left:0.5pt single #000000; -aw-border-right:0.5pt single #000000; -aw-border-top:0.5pt single #000000">
                    <p style="margin-right:38.75pt; text-align:justify; font-size:10.5pt"><span
                            style="font-family:'Malgun Gothic'">Kakao Talk계정</span></p>
                </td>
                <td
                    style="width:163.55pt; border-top-style:solid; border-top-width:0.75pt; border-right-style:solid; border-right-width:0.75pt; border-left-style:solid; border-left-width:0.75pt; padding-right:5.03pt; padding-left:5.03pt; vertical-align:top; -aw-border-left:0.5pt single #000000; -aw-border-right:0.5pt single #000000; -aw-border-top:0.5pt single #000000">
                    <p style="margin-right:38.75pt; text-align:justify; font-size:10.5pt"><span
                            style="font-family:'Malgun Gothic'">회원이 게임 내에서 개인 Kakao Talk 계정을 연동하거나 회사의 Kakao Talk 공식 채널을
                            추가하면 관련 정보가 수집됩니다.</span></p>
                </td>
                <td
                    style="width:163.55pt; border-top-style:solid; border-top-width:0.75pt; border-left-style:solid; border-left-width:0.75pt; padding-right:5.03pt; padding-left:5.03pt; vertical-align:top; -aw-border-left:0.5pt single #000000; -aw-border-top:0.5pt single #000000">
                    <p style="margin-right:38.75pt; text-align:justify; font-size:10.5pt"><span
                            style="font-family:'Malgun Gothic'">회원 탈퇴 후 즉시 삭제(회원이 숙려 기간을 선택하지 않은 경우)/숙려 기간 종료 및 회사의
                            Kakao Talk 공식 채널 추가 취소 후 삭제</span></p>
                    <p style="margin-right:38.75pt; text-align:justify; font-size:10.5pt"><span
                            style="font-family:'Malgun Gothic'">회원이 게임 내에서 개인 Kakao Talk 계정 연동을 해제하고, 회사의 Kakao Talk 공식
                            채널 추가를 취소하면 관련 정보가 삭제됩니다.</span></p>
                </td>
            </tr>
        </table>
        <p style="margin-right:38.75pt"><span style="font-family:'Malgun Gothic'; -aw-import:ignore">&#xa0;</span></p>
        <p style="margin-right:38.75pt"><span style="font-family:'Malgun Gothic'">일부 게임에서만 임시 회원이 제3자 계정을 연결하여 정식 회원으로
                업그레이드할 수 있는 기능을 제공합니다.</span></p>
        <p style="margin-right:38.75pt"><span style="font-family:'Malgun Gothic'">제3자 플랫폼 인증을 통해 회원가입할 때, 위에 언급된 정보 외의
                다른 개인정보는 저장하지 않습니다.</span></p>
        <p style="margin-right:38.75pt; font-size:9pt"><span
                style="font-family:'Malgun Gothic'; -aw-import:ignore">&#xa0;</span></p>
    </div>
`;

export const thirdDetailHtml = `
<div>
<p style="margin-top: 0pt; margin-bottom: 8pt" class="title">
    항목 상세 내용
</p>
<p style="margin-top: 0pt; margin-bottom: 8pt">
  <span style="-aw-import: ignore">&#xa0;</span>
</p>
<p style="margin-top: 0pt; margin-bottom: 8pt">
  <span>회사는</span><span> </span><span>이용자의</span><span> </span
  ><span>개인정보에</span><span> </span><span>대한</span><span> </span
  ><span>보호를</span><span> </span><span>중요시하고</span><span> </span
  ><span>각종</span><span> </span><span>안전기술</span><span> </span
  ><span>및</span><span> </span><span>프로그램을</span><span> </span
  ><span>통하여</span><span> </span><span>이용자의</span><span> </span
  ><span>개인정보가</span><span> </span><span>수권을</span><span> </span
  ><span>받지</span><span> </span><span>아니한</span><span> </span
  ><span>상태로</span><span> </span><span>방문</span><span>, </span
  ><span>사용</span><span> </span><span>및</span><span> </span
  ><span>누설되지</span><span> </span><span>않도록</span><span> </span
  ><span>하고</span><span> </span><span>있습니다</span><span>. </span
  ><span>법률</span><span> </span><span>및</span><span> </span
  ><span>정부의</span><span> </span><span>요구</span><span>, </span
  ><span>혹은</span><span> </span><span>이용자의</span><span> </span
  ><span>동의</span><span> </span><span>외</span><span>, </span
  ><span>회사는</span><span> </span><span>합작업체</span><span> </span
  ><span>외의</span><span> </span><span>제</span><span>3</span
  ><span>자에게</span><span> </span><span>이용자의</span><span> </span
  ><span>개인정보자원을</span><span> </span><span>공개하거나</span
  ><span> </span><span>제공하지</span><span> </span><span>않습니다</span
  ><span>. </span><span>다만</span><span>, </span><span>아래의</span
  ><span> </span><span>경우</span><span> </span><span>제</span
  ><span>3</span><span>자에</span><span> </span><span>공개되는</span
  ><span> </span><span>경우에는</span><span> </span><span>예외로</span
  ><span> </span><span>합니다</span><span>. </span>
</p>
<p style="margin-top: 0pt; margin-bottom: 8pt">
  <span style="-aw-import: ignore">&#xa0;</span>
</p>
<p style="margin-top: 0pt; margin-bottom: 8pt">
  <span>첫째</span><span>, </span><span>이용자가</span><span> </span
  ><span>사전에</span><span> </span><span>공개</span><span> </span
  ><span>또는</span><span> </span><span>제공에</span><span> </span
  ><span>동의한</span><span> </span><span>경우</span><span> (</span
  ><span>이용자</span><span> </span><span>본인</span><span> </span
  ><span>혹은</span><span> </span><span>법정대리인이</span><span> </span
  ><span>공개를</span><span> </span><span>수권한</span><span> </span
  ><span>경우</span><span> </span><span>포함</span><span>)</span
  ><span style="line-height: 108%"
    >당사가 국외 제3자에게 정보를 제공하는 부분에 대한 것은 「개인정보
    국외 제3자 제공」을 참조해 주세요.</span
  >
</p>
<p style="margin-top: 0pt; margin-bottom: 8pt">
  <span style="-aw-import: ignore">&#xa0;</span>
</p>
<p style="margin-top: 0pt; margin-bottom: 8pt">
  <span>둘째</span><span>, </span><span>홈페이지에</span><span> </span
  ><span>게시한</span><span> </span><span>서비스</span><span> </span
  ><span>이용약관이나</span><span> </span><span>운영정책</span
  ><span> </span><span>등</span><span> </span><span>회사가</span
  ><span> </span><span>정한</span><span> </span><span>정책을</span
  ><span> </span><span>위반한</span><span> </span><span>경우</span>
</p>
<p style="margin-top: 0pt; margin-bottom: 8pt">
  <span style="-aw-import: ignore">&#xa0;</span>
</p>
<p style="margin-top: 0pt; margin-bottom: 8pt">
  <span>셋째</span><span>, </span><span>서비스를</span><span> </span
  ><span>이용하여</span><span> </span><span>타인에게</span><span> </span
  ><span>정신적</span><span>, </span><span>물질적</span><span> </span
  ><span>피해를</span><span> </span><span>줌으로써</span><span> </span
  ><span>그에</span><span> </span><span>대한</span><span> </span
  ><span>법적인</span><span> </span><span>조치를</span><span> </span
  ><span>취하기</span><span> </span><span>위해</span><span> </span
  ><span>개인정보를</span><span> </span><span>공개해야</span><span> </span
  ><span>한다고</span><span> </span><span>판단되는</span><span> </span
  ><span>충분한</span><span> </span><span>근거가</span><span> </span
  ><span>있는</span><span> </span><span>경우</span><span> (</span
  ><span>긴급한</span><span> </span><span>상황에서</span><span> </span
  ><span>기타</span><span> </span><span>이용자</span><span> </span
  ><span>및</span><span> </span><span>제</span><span>3</span
  ><span>자의</span><span> </span><span>인신</span><span> </span
  ><span>안전을</span><span> </span><span>보호하기</span><span> </span
  ><span>위하여</span><span> </span><span>공개한</span><span> </span
  ><span>경우</span><span> </span><span>포함</span><span>)</span>
</p>
<p style="margin-top: 0pt; margin-bottom: 8pt">
  <span style="-aw-import: ignore">&#xa0;</span>
</p>
<p style="margin-top: 0pt; margin-bottom: 8pt">
  <span>넷째</span><span>, </span><span>기타</span><span> </span
  ><span>법에</span><span> </span><span>의해</span><span> </span
  ><span>공개</span><span> </span><span>혹은</span><span> </span
  ><span>제공함이</span><span> </span><span>요구된다고</span><span> </span
  ><span>선의로</span><span> </span><span>판단되는</span><span> </span
  ><span>경우</span>
</p>
<p style="margin-top: 0pt; margin-bottom: 8pt">
  <span>(ex. </span><span>한국</span><span> </span><span>법률의</span
  ><span> </span><span>규정에</span><span> </span><span>의하여</span
  ><span> </span><span>관련</span><span> </span><span>정부기관에</span
  ><span> </span><span>공개한</span><span> </span><span>경우</span
  ><span>, </span><span>자료</span><span> </span><span>제공이</span
  ><span> </span><span>강제되는</span><span> </span><span>경우</span
  ><span>, </span><span>또는</span><span> </span><span>적법한</span
  ><span> </span><span>절차에</span><span> </span><span>의한</span
  ><span> </span><span>법원</span><span>, </span><span>수사기관</span
  ><span>, </span><span>기타</span><span> </span><span>행정기관의</span
  ><span> </span><span>요청이</span><span> </span><span>있는</span
  ><span> </span><span>경우</span><span>)</span>
</p>
<p style="margin-top: 0pt; margin-bottom: 8pt">
  <span style="-aw-import: ignore">&#xa0;</span>
</p>
</div>`;

export const zrrglobalThirdDetailHtml = `
<div>
<p style="margin-top: 0pt; margin-bottom: 8pt" class="title">
    항목 상세 내용
</p>
<p style="margin-top: 0pt; margin-bottom: 8pt">
  <span style="-aw-import: ignore">&#xa0;</span>
</p>
<p style="margin-top: 0pt; margin-bottom: 8pt">
  <span>회사는</span><span> </span><span>이용자의</span><span> </span
  ><span>개인정보에</span><span> </span><span>대한</span><span> </span
  ><span>보호를</span><span> </span><span>중요시하고</span><span> </span
  ><span>각종</span><span> </span><span>안전기술</span><span> </span
  ><span>및</span><span> </span><span>프로그램을</span><span> </span
  ><span>통하여</span><span> </span><span>이용자의</span><span> </span
  ><span>개인정보가</span><span> </span><span>수권을</span><span> </span
  ><span>받지</span><span> </span><span>아니한</span><span> </span
  ><span>상태로</span><span> </span><span>방문</span><span>, </span
  ><span>사용</span><span> </span><span>및</span><span> </span
  ><span>누설되지</span><span> </span><span>않도록</span><span> </span
  ><span>하고</span><span> </span><span>있습니다</span><span>. </span
  ><span>법률</span><span> </span><span>및</span><span> </span
  ><span>정부의</span><span> </span><span>요구</span><span>, </span
  ><span>혹은</span><span> </span><span>이용자의</span><span> </span
  ><span>동의</span><span> </span><span>외</span><span>, </span
  ><span>회사는</span><span> </span><span>합작업체</span><span> </span
  ><span>외의</span><span> </span><span>제</span><span>3</span
  ><span>자에게</span><span> </span><span>이용자의</span><span> </span
  ><span>개인정보자원을</span><span> </span><span>공개하거나</span
  ><span> </span><span>제공하지</span><span> </span><span>않습니다</span
  ><span>. </span><span>다만</span><span>, </span><span>아래의</span
  ><span> </span><span>경우</span><span> </span><span>제</span
  ><span>3</span><span>자에</span><span> </span><span>공개되는</span
  ><span> </span><span>경우에는</span><span> </span><span>예외로</span
  ><span> </span><span>합니다</span><span>. </span>
</p>
<p style="margin-top: 0pt; margin-bottom: 8pt">
  <span style="-aw-import: ignore">&#xa0;</span>
</p>
<p style="margin-top: 0pt; margin-bottom: 8pt">
  <span>첫째</span><span>, </span><span>이용자가</span><span> </span
  ><span>사전에</span><span> </span><span>공개</span><span> </span
  ><span>또는</span><span> </span><span>제공에</span><span> </span
  ><span>동의한</span><span> </span><span>경우</span><span> (</span
  ><span>이용자</span><span> </span><span>본인</span><span> </span
  ><span>혹은</span><span> </span><span>법정대리인이</span><span> </span
  ><span>공개를</span><span> </span><span>수권한</span><span> </span
  ><span>경우</span><span> </span><span>포함</span><span>)</span
  ><span style="line-height: 108%"
    >당사가 국외 제3자에게 정보를 제공하는 부분에 대한 것은 「개인정보
    국외 제3자 제공」을 참조해 주세요.</span
  >
</p>
<p style="margin-top: 0pt; margin-bottom: 8pt">
  <span style="-aw-import: ignore">&#xa0;</span>
</p>
<p style="margin-top: 0pt; margin-bottom: 8pt">
  <span>둘째</span><span>, </span><span>홈페이지에</span><span> </span
  ><span>게시한</span><span> </span><span>서비스</span><span> </span
  ><span>이용약관이나</span><span> </span><span>운영정책</span
  ><span> </span><span>등</span><span> </span><span>회사가</span
  ><span> </span><span>정한</span><span> </span><span>정책을</span
  ><span> </span><span>위반한</span><span> </span><span>경우</span>
</p>
<p style="margin-top: 0pt; margin-bottom: 8pt">
  <span style="-aw-import: ignore">&#xa0;</span>
</p>
<p style="margin-top: 0pt; margin-bottom: 8pt">
  <span>셋째</span><span>, </span><span>서비스를</span><span> </span
  ><span>이용하여</span><span> </span><span>타인에게</span><span> </span
  ><span>정신적</span><span>, </span><span>물질적</span><span> </span
  ><span>피해를</span><span> </span><span>줌으로써</span><span> </span
  ><span>그에</span><span> </span><span>대한</span><span> </span
  ><span>법적인</span><span> </span><span>조치를</span><span> </span
  ><span>취하기</span><span> </span><span>위해</span><span> </span
  ><span>개인정보를</span><span> </span><span>공개해야</span><span> </span
  ><span>한다고</span><span> </span><span>판단되는</span><span> </span
  ><span>충분한</span><span> </span><span>근거가</span><span> </span
  ><span>있는</span><span> </span><span>경우</span><span> (</span
  ><span>긴급한</span><span> </span><span>상황에서</span><span> </span
  ><span>기타</span><span> </span><span>이용자</span><span> </span
  ><span>및</span><span> </span><span>제</span><span>3</span
  ><span>자의</span><span> </span><span>인신</span><span> </span
  ><span>안전을</span><span> </span><span>보호하기</span><span> </span
  ><span>위하여</span><span> </span><span>공개한</span><span> </span
  ><span>경우</span><span> </span><span>포함</span><span>)</span>
</p>
<p style="margin-top: 0pt; margin-bottom: 8pt">
  <span style="-aw-import: ignore">&#xa0;</span>
</p>
<p style="margin-top: 0pt; margin-bottom: 8pt">
  <span>넷째</span><span>, </span><span>기타</span><span> </span
  ><span>법에</span><span> </span><span>의해</span><span> </span
  ><span>공개</span><span> </span><span>혹은</span><span> </span
  ><span>제공함이</span><span> </span><span>요구된다고</span><span> </span
  ><span>선의로</span><span> </span><span>판단되는</span><span> </span
  ><span>경우</span>
</p>
<p style="margin-top: 0pt; margin-bottom: 8pt">
  <span>(ex. </span><span>한국</span><span> </span><span>법률의</span
  ><span> </span><span>규정에</span><span> </span><span>의하여</span
  ><span> </span><span>관련</span><span> </span><span>정부기관에</span
  ><span> </span><span>공개한</span><span> </span><span>경우</span
  ><span>, </span><span>자료</span><span> </span><span>제공이</span
  ><span> </span><span>강제되는</span><span> </span><span>경우</span
  ><span>, </span><span>또는</span><span> </span><span>적법한</span
  ><span> </span><span>절차에</span><span> </span><span>의한</span
  ><span> </span><span>법원</span><span>, </span><span>수사기관</span
  ><span>, </span><span>기타</span><span> </span><span>행정기관의</span
  ><span> </span><span>요청이</span><span> </span><span>있는</span
  ><span> </span><span>경우</span><span>)</span>
</p>
<p style="margin-top: 0pt; margin-bottom: 8pt">
  <span style="-aw-import: ignore">&#xa0;</span>
</p>
</div>`;

export const threeSeventForeignThirdDetailHtml = `    <div>
        <table cellspacing="0" cellpadding="0" class="10"
            style="border:0.75pt solid #000000; -aw-border:0.5pt single #000000; -aw-border-insideh:0.5pt single #000000; -aw-border-insidev:0.5pt single #000000; border-collapse:collapse">
            <tr>
                <td
                    style="width:48.8pt; border-right-style:solid; border-right-width:0.75pt; border-bottom-style:solid; border-bottom-width:0.75pt; padding-right:5.03pt; padding-left:5.03pt; vertical-align:top; -aw-border-bottom:0.5pt single #000000; -aw-border-right:0.5pt single #000000">
                    <p style="text-align:justify; font-size:10.5pt"><span style="font-family:等线">업체명(연락처)</span><span
                            style="font-family:等线">&#xa0;</span></p>
                </td>
                <td
                    style="width:109.2pt; border-right-style:solid; border-right-width:0.75pt; border-left-style:solid; border-left-width:0.75pt; border-bottom-style:solid; border-bottom-width:0.75pt; padding-right:5.03pt; padding-left:5.03pt; vertical-align:top; -aw-border-bottom:0.5pt single #000000; -aw-border-left:0.5pt single #000000; -aw-border-right:0.5pt single #000000">
                    <p style="text-align:justify; font-size:10.5pt"><span style="font-family:等线">개인정보 이전국가</span></p>
                </td>
                <td
                    style="width:49.2pt; border-right-style:solid; border-right-width:0.75pt; border-left-style:solid; border-left-width:0.75pt; border-bottom-style:solid; border-bottom-width:0.75pt; padding-right:5.03pt; padding-left:5.03pt; vertical-align:top; -aw-border-bottom:0.5pt single #000000; -aw-border-left:0.5pt single #000000; -aw-border-right:0.5pt single #000000">
                    <p style="text-align:justify; font-size:10.5pt"><span style="font-family:等线">이용 목적</span></p>
                </td>
                <td
                    style="width:117.9pt; border-right-style:solid; border-right-width:0.75pt; border-left-style:solid; border-left-width:0.75pt; border-bottom-style:solid; border-bottom-width:0.75pt; padding-right:5.03pt; padding-left:5.03pt; vertical-align:top; -aw-border-bottom:0.5pt single #000000; -aw-border-left:0.5pt single #000000; -aw-border-right:0.5pt single #000000">
                    <p style="text-align:justify; font-size:10.5pt"><span style="font-family:等线">이전 항목</span></p>
                </td>
                <td
                    style="width:81.35pt; border-right-style:solid; border-right-width:0.75pt; border-left-style:solid; border-left-width:0.75pt; border-bottom-style:solid; border-bottom-width:0.75pt; padding-right:5.03pt; padding-left:5.03pt; vertical-align:top; -aw-border-bottom:0.5pt single #000000; -aw-border-left:0.5pt single #000000; -aw-border-right:0.5pt single #000000">
                    <p style="text-align:justify; font-size:10.5pt"><span style="font-family:等线">이전 일시 및 방법</span></p>
                </td>
                <td
                    style="width:258.55pt; border-left-style:solid; border-left-width:0.75pt; border-bottom-style:solid; border-bottom-width:0.75pt; padding-right:5.03pt; padding-left:5.03pt; vertical-align:top; -aw-border-bottom:0.5pt single #000000; -aw-border-left:0.5pt single #000000">
                    <p style="text-align:justify; font-size:10.5pt"><span style="font-family:等线">보유 및 이용기간</span></p>
                </td>
            </tr>
            <tr>
                <td
                    style="width:48.8pt; border-top-style:solid; border-top-width:0.75pt; border-right-style:solid; border-right-width:0.75pt; border-bottom-style:solid; border-bottom-width:0.75pt; padding-right:5.03pt; padding-left:5.03pt; vertical-align:top; -aw-border-bottom:0.5pt single #000000; -aw-border-right:0.5pt single #000000; -aw-border-top:0.5pt single #000000">
                    <p style="text-align:justify; font-size:10.5pt"><span style="font-family:等线">Amazon Web Services,
                            Inc</span></p>
                    <p style="text-align:justify; font-size:10.5pt"><span style="font-family:等线">（</span><a
                            href="mailto:leonxing@amazon.com" style="text-decoration:none"><span
                                style="font-family:等线; color:#000000">leonxing@amazon.com</span></a><span
                            style="font-family:等线">）</span></p>
                </td>
                <td
                    style="width:109.2pt; border-style:solid; border-width:0.75pt; padding-right:5.03pt; padding-left:5.03pt; vertical-align:top; -aw-border:0.5pt single #000000">
                    <p style="text-align:justify; font-size:10.5pt"><span style="font-family:等线">싱가포르, </span><span
                            style="font-family:Batang">말레이시아</span></p>
                </td>
                <td rowspan="2"
                    style="width:49.2pt; border-style:solid; border-width:0.75pt; padding-right:5.03pt; padding-left:5.03pt; vertical-align:top; -aw-border:0.5pt single #000000">
                    <p style="text-align:justify; font-size:10.5pt"><span style="font-family:等线">이용자 개인정보 보관</span></p>
                </td>
                <td rowspan="2"
                    style="width:117.9pt; border-style:solid; border-width:0.75pt; padding-right:5.03pt; padding-left:5.03pt; vertical-align:top; -aw-border:0.5pt single #000000">
                    <p style="text-align:justify; font-size:10.5pt"><span style="font-family:等线">ID, 비밀번호, 캐릭터 명칭, 휴대폰
                            모델명, 생년월일, 방문 날짜, 서비스 이용 기록, 불량 이용 기록, 결산 기록, 에러 정보</span></p>
                    <p style="text-align:justify; font-size:10.5pt"><span
                            style="font-family:等线; -aw-import:ignore">&#xa0;</span></p>
                </td>
                <td rowspan="2"
                    style="width:81.35pt; border-style:solid; border-width:0.75pt; padding-right:5.03pt; padding-left:5.03pt; vertical-align:top; -aw-border:0.5pt single #000000">
                    <p style="text-align:justify; font-size:10.5pt"><span style="font-family:等线">수집 후 즉시 전송</span></p>
                    <p style="text-align:justify; font-size:10.5pt"><span style="font-family:等线">네트워크를 통한 전송 및 복사</span>
                    </p>
                </td>
                <td rowspan="2"
                    style="width:258.55pt; border-top-style:solid; border-top-width:0.75pt; border-left-style:solid; border-left-width:0.75pt; border-bottom-style:solid; border-bottom-width:0.75pt; padding-right:5.03pt; padding-left:5.03pt; vertical-align:top; -aw-border-bottom:0.5pt single #000000; -aw-border-left:0.5pt single #000000; -aw-border-top:0.5pt single #000000">
                    <p style="text-align:justify; font-size:10.5pt"><span style="font-family:等线">계약 및 주문 내역, 주문 취소 내역,
                            결제 정보, 재무 기록은 회원 탈퇴 후 5년간 보관</span></p>
                    <p style="text-align:justify; font-size:10.5pt"><span style="font-family:等线">분쟁 관련 정보는 회원 탈퇴 후 3년간
                            보관</span></p>
                    <p style="text-align:justify; font-size:10.5pt"><span style="font-family:等线">계정, 비밀번호, 휴대폰 기종은 회원 탈퇴
                            후 30일간 보관</span></p>
                    <p style="text-align:justify; font-size:10.5pt"><span style="font-family:等线">기타 정보는 회원 탈퇴 시 즉시
                            파기</span></p>
                </td>
            </tr>
            <tr>
                <td
                    style="width:48.8pt; border-top-style:solid; border-top-width:0.75pt; border-right-style:solid; border-right-width:0.75pt; border-bottom-style:solid; border-bottom-width:0.75pt; padding-right:5.03pt; padding-left:5.03pt; vertical-align:top; -aw-border-bottom:0.5pt single #000000; -aw-border-right:0.5pt single #000000; -aw-border-top:0.5pt single #000000">
                    <p style="text-align:justify; font-size:10.5pt"><span style="font-family:等线">Alibaba Cloud</span>
                    </p>
                    <p style="text-align:justify; font-size:10.5pt"><span style="font-family:等线">（</span><span
                            style="font-family:等线">&#xa0;</span><a href="mailto:intlcompliance@service.aliyun.com"
                            style="text-decoration:none"><span
                                style="font-family:等线; color:#000000">intlcompliance@service.aliyun.com</span></a><span
                            style="font-family:等线">）</span></p>
                </td>
                <td
                    style="width:109.2pt; border-style:solid; border-width:0.75pt; padding-right:5.03pt; padding-left:5.03pt; vertical-align:top; -aw-border:0.5pt single #000000">
                    <p style="text-align:justify; font-size:10.5pt"><span style="font-family:'等线 Light'">싱가포르</span></p>
                </td>
            </tr>
            <tr>
                <td
                    style="width:48.8pt; border-top-style:solid; border-top-width:0.75pt; border-right-style:solid; border-right-width:0.75pt; padding-right:5.03pt; padding-left:5.03pt; vertical-align:top; -aw-border-right:0.5pt single #000000; -aw-border-top:0.5pt single #000000">
                    <p style="text-align:justify; font-size:10.5pt"><span style="font-family:等线">Azure OpenAI Service
                            （</span><a href="mailto:cscraireport@microsoft.com" style="text-decoration:none"><span
                                style="font-family:等线; color:#000000">cscraireport@microsoft.com</span></a><span
                            style="font-family:等线">）</span></p>
                </td>
                <td
                    style="width:109.2pt; border-top-style:solid; border-top-width:0.75pt; border-right-style:solid; border-right-width:0.75pt; border-left-style:solid; border-left-width:0.75pt; padding-right:5.03pt; padding-left:5.03pt; vertical-align:top; -aw-border-left:0.5pt single #000000; -aw-border-right:0.5pt single #000000; -aw-border-top:0.5pt single #000000">
                    <p style="text-align:justify; font-size:10.5pt"><span style="font-family:'等线 Light'">미국, 스웨덴</span>
                    </p>
                </td>
                <td
                    style="width:49.2pt; border-top-style:solid; border-top-width:0.75pt; border-right-style:solid; border-right-width:0.75pt; border-left-style:solid; border-left-width:0.75pt; padding-right:5.03pt; padding-left:5.03pt; vertical-align:top; -aw-border-left:0.5pt single #000000; -aw-border-right:0.5pt single #000000; -aw-border-top:0.5pt single #000000">
                    <p style="text-align:justify; font-size:10.5pt"><span style="font-family:'等线 Light'">AI 스마트 고객
                            서비스</span></p>
                </td>
                <td
                    style="width:117.9pt; border-top-style:solid; border-top-width:0.75pt; border-right-style:solid; border-right-width:0.75pt; border-left-style:solid; border-left-width:0.75pt; padding-right:5.03pt; padding-left:5.03pt; vertical-align:top; -aw-border-left:0.5pt single #000000; -aw-border-right:0.5pt single #000000; -aw-border-top:0.5pt single #000000">
                    <p style="text-align:justify; font-size:10.5pt"><span style="font-family:'等线 Light'">회원이 스마트 고객센터에
                            입력한 모든 정보</span></p>
                </td>
                <td
                    style="width:81.35pt; border-top-style:solid; border-top-width:0.75pt; border-right-style:solid; border-right-width:0.75pt; border-left-style:solid; border-left-width:0.75pt; padding-right:5.03pt; padding-left:5.03pt; vertical-align:top; -aw-border-left:0.5pt single #000000; -aw-border-right:0.5pt single #000000; -aw-border-top:0.5pt single #000000">
                    <p style="text-align:justify; font-size:10.5pt"><span style="font-family:'等线 Light'">수집 후 즉시
                            전송</span></p>
                    <p style="text-align:justify; font-size:10.5pt"><span style="font-family:'等线 Light'">네트워크 전송 및
                            복제</span></p>
                </td>
                <td
                    style="width:258.55pt; border-top-style:solid; border-top-width:0.75pt; border-left-style:solid; border-left-width:0.75pt; padding-right:5.03pt; padding-left:5.03pt; vertical-align:top; -aw-border-left:0.5pt single #000000; -aw-border-top:0.5pt single #000000">
                    <p style="text-align:justify; font-size:10.5pt"><span style="font-family:'等线 Light'">사용자정보는 분쟁과 관련이
                            있을 수 있으므로 회원탈퇴 후 최최대 3년까지 보관됩니다.</span></p>
                </td>
            </tr>
        </table>
        <p><span>* </span><span style="font-family:宋体">상기 연락처는 영문 메일 문의만 받습니다</span></p>
    </div>`;

export const foreignThirdDetailHtml = `
 <div>
    <table cellspacing="0" cellpadding="0" class="10"
        style="border:0.75pt solid #000000; -aw-border:0.5pt single #000000; -aw-border-insideh:0.5pt single #000000; -aw-border-insidev:0.5pt single #000000; border-collapse:collapse">
        <tr>
            <td
                style="width:48.8pt; border-right-style:solid; border-right-width:0.75pt; border-bottom-style:solid; border-bottom-width:0.75pt; padding-right:5.03pt; padding-left:5.03pt; vertical-align:top; -aw-border-bottom:0.5pt single #000000; -aw-border-right:0.5pt single #000000">
                <p style="text-align:justify; font-size:10.5pt"><span style="font-family:等线">업체명(연락처)</span><span
                        style="font-family:等线">&#xa0;</span></p>
            </td>
            <td
                style="width:109.2pt; border-right-style:solid; border-right-width:0.75pt; border-left-style:solid; border-left-width:0.75pt; border-bottom-style:solid; border-bottom-width:0.75pt; padding-right:5.03pt; padding-left:5.03pt; vertical-align:top; -aw-border-bottom:0.5pt single #000000; -aw-border-left:0.5pt single #000000; -aw-border-right:0.5pt single #000000">
                <p style="text-align:justify; font-size:10.5pt"><span style="font-family:等线">개인정보 이전국가</span></p>
            </td>
            <td
                style="width:49.2pt; border-right-style:solid; border-right-width:0.75pt; border-left-style:solid; border-left-width:0.75pt; border-bottom-style:solid; border-bottom-width:0.75pt; padding-right:5.03pt; padding-left:5.03pt; vertical-align:top; -aw-border-bottom:0.5pt single #000000; -aw-border-left:0.5pt single #000000; -aw-border-right:0.5pt single #000000">
                <p style="text-align:justify; font-size:10.5pt"><span style="font-family:等线">이용 목적</span></p>
            </td>
            <td
                style="width:117.9pt; border-right-style:solid; border-right-width:0.75pt; border-left-style:solid; border-left-width:0.75pt; border-bottom-style:solid; border-bottom-width:0.75pt; padding-right:5.03pt; padding-left:5.03pt; vertical-align:top; -aw-border-bottom:0.5pt single #000000; -aw-border-left:0.5pt single #000000; -aw-border-right:0.5pt single #000000">
                <p style="text-align:justify; font-size:10.5pt"><span style="font-family:等线">이전 항목</span></p>
            </td>
            <td
                style="width:81.35pt; border-right-style:solid; border-right-width:0.75pt; border-left-style:solid; border-left-width:0.75pt; border-bottom-style:solid; border-bottom-width:0.75pt; padding-right:5.03pt; padding-left:5.03pt; vertical-align:top; -aw-border-bottom:0.5pt single #000000; -aw-border-left:0.5pt single #000000; -aw-border-right:0.5pt single #000000">
                <p style="text-align:justify; font-size:10.5pt"><span style="font-family:等线">이전 일시 및 방법</span></p>
            </td>
            <td
                style="width:258.55pt; border-left-style:solid; border-left-width:0.75pt; border-bottom-style:solid; border-bottom-width:0.75pt; padding-right:5.03pt; padding-left:5.03pt; vertical-align:top; -aw-border-bottom:0.5pt single #000000; -aw-border-left:0.5pt single #000000">
                <p style="text-align:justify; font-size:10.5pt"><span style="font-family:等线">보유 및 이용기간</span></p>
            </td>
        </tr>
        <tr>
            <td
                style="width:48.8pt; border-top-style:solid; border-top-width:0.75pt; border-right-style:solid; border-right-width:0.75pt; border-bottom-style:solid; border-bottom-width:0.75pt; padding-right:5.03pt; padding-left:5.03pt; vertical-align:top; -aw-border-bottom:0.5pt single #000000; -aw-border-right:0.5pt single #000000; -aw-border-top:0.5pt single #000000">
                <p style="text-align:justify; font-size:10.5pt"><span style="font-family:等线">Amazon Web Services,
                        Inc</span></p>
                <p style="text-align:justify; font-size:10.5pt"><span style="font-family:等线">（</span><a
                        href="mailto:leonxing@amazon.com" style="text-decoration:none"><span
                            style="font-family:等线; color:#000000">leonxing@amazon.com</span></a><span
                        style="font-family:等线">）</span></p>
            </td>
            <td
                style="width:109.2pt; border-style:solid; border-width:0.75pt; padding-right:5.03pt; padding-left:5.03pt; vertical-align:top; -aw-border:0.5pt single #000000">
                <p style="text-align:justify; font-size:10.5pt"><span style="font-family:等线">싱가포르, </span><span
                        style="font-family:Batang">말레이시아</span></p>
            </td>
            <td rowspan="2"
                style="width:49.2pt; border-style:solid; border-width:0.75pt; padding-right:5.03pt; padding-left:5.03pt; vertical-align:top; -aw-border:0.5pt single #000000">
                <p style="text-align:justify; font-size:10.5pt"><span style="font-family:等线">이용자 개인정보 보관</span></p>
            </td>
            <td rowspan="2"
                style="width:117.9pt; border-style:solid; border-width:0.75pt; padding-right:5.03pt; padding-left:5.03pt; vertical-align:top; -aw-border:0.5pt single #000000">
                <p style="text-align:justify; font-size:10.5pt"><span style="font-family:等线">ID, 비밀번호, 캐릭터 명칭, 휴대폰
                        모델명, 생년월일, 방문 날짜, 서비스 이용 기록, 불량 이용 기록, 결산 기록, 에러 정보</span></p>
                <p style="text-align:justify; font-size:10.5pt"><span
                        style="font-family:等线; -aw-import:ignore">&#xa0;</span></p>
            </td>
            <td rowspan="2"
                style="width:81.35pt; border-style:solid; border-width:0.75pt; padding-right:5.03pt; padding-left:5.03pt; vertical-align:top; -aw-border:0.5pt single #000000">
                <p style="text-align:justify; font-size:10.5pt"><span style="font-family:等线">수집 후 즉시 전송</span></p>
                <p style="text-align:justify; font-size:10.5pt"><span style="font-family:等线">네트워크를 통한 전송 및 복사</span>
                </p>
            </td>
            <td rowspan="2"
                style="width:258.55pt; border-top-style:solid; border-top-width:0.75pt; border-left-style:solid; border-left-width:0.75pt; border-bottom-style:solid; border-bottom-width:0.75pt; padding-right:5.03pt; padding-left:5.03pt; vertical-align:top; -aw-border-bottom:0.5pt single #000000; -aw-border-left:0.5pt single #000000; -aw-border-top:0.5pt single #000000">
                <p style="text-align:justify; font-size:10.5pt"><span style="font-family:等线">계약 및 주문 내역, 주문 취소 내역,
                        결제 정보, 재무 기록은 회원 탈퇴 후 5년간 보관</span></p>
                <p style="text-align:justify; font-size:10.5pt"><span style="font-family:等线">분쟁 관련 정보는 회원 탈퇴 후 3년간
                        보관</span></p>
                <p style="text-align:justify; font-size:10.5pt"><span style="font-family:等线">계정, 비밀번호, 휴대폰 기종은 회원 탈퇴
                        후 30일간 보관</span></p>
                <p style="text-align:justify; font-size:10.5pt"><span style="font-family:等线">기타 정보는 회원 탈퇴 시 즉시
                        파기</span></p>
            </td>
        </tr>
        <tr>
            <td
                style="width:48.8pt; border-top-style:solid; border-top-width:0.75pt; border-right-style:solid; border-right-width:0.75pt; border-bottom-style:solid; border-bottom-width:0.75pt; padding-right:5.03pt; padding-left:5.03pt; vertical-align:top; -aw-border-bottom:0.5pt single #000000; -aw-border-right:0.5pt single #000000; -aw-border-top:0.5pt single #000000">
                <p style="text-align:justify; font-size:10.5pt"><span style="font-family:等线">Alibaba Cloud</span>
                </p>
                <p style="text-align:justify; font-size:10.5pt"><span style="font-family:等线">（</span><span
                        style="font-family:等线">&#xa0;</span><a href="mailto:intlcompliance@service.aliyun.com"
                        style="text-decoration:none"><span
                            style="font-family:等线; color:#000000">intlcompliance@service.aliyun.com</span></a><span
                        style="font-family:等线">）</span></p>
            </td>
            <td
                style="width:109.2pt; border-style:solid; border-width:0.75pt; padding-right:5.03pt; padding-left:5.03pt; vertical-align:top; -aw-border:0.5pt single #000000">
                <p style="text-align:justify; font-size:10.5pt"><span style="font-family:'等线 Light'">싱가포르</span></p>
            </td>
        </tr>
        <tr>
            <td
                style="width:48.8pt; border-top-style:solid; border-top-width:0.75pt; border-right-style:solid; border-right-width:0.75pt; padding-right:5.03pt; padding-left:5.03pt; vertical-align:top; -aw-border-right:0.5pt single #000000; -aw-border-top:0.5pt single #000000">
                <p style="text-align:justify; font-size:10.5pt"><span style="font-family:等线">Azure OpenAI Service
                        （</span><a href="mailto:cscraireport@microsoft.com" style="text-decoration:none"><span
                            style="font-family:等线; color:#000000">cscraireport@microsoft.com</span></a><span
                        style="font-family:等线">）</span></p>
            </td>
            <td
                style="width:109.2pt; border-top-style:solid; border-top-width:0.75pt; border-right-style:solid; border-right-width:0.75pt; border-left-style:solid; border-left-width:0.75pt; padding-right:5.03pt; padding-left:5.03pt; vertical-align:top; -aw-border-left:0.5pt single #000000; -aw-border-right:0.5pt single #000000; -aw-border-top:0.5pt single #000000">
                <p style="text-align:justify; font-size:10.5pt"><span style="font-family:'等线 Light'">미국, 스웨덴</span>
                </p>
            </td>
            <td
                style="width:49.2pt; border-top-style:solid; border-top-width:0.75pt; border-right-style:solid; border-right-width:0.75pt; border-left-style:solid; border-left-width:0.75pt; padding-right:5.03pt; padding-left:5.03pt; vertical-align:top; -aw-border-left:0.5pt single #000000; -aw-border-right:0.5pt single #000000; -aw-border-top:0.5pt single #000000">
                <p style="text-align:justify; font-size:10.5pt"><span style="font-family:'等线 Light'">AI 스마트 고객
                        서비스</span></p>
            </td>
            <td
                style="width:117.9pt; border-top-style:solid; border-top-width:0.75pt; border-right-style:solid; border-right-width:0.75pt; border-left-style:solid; border-left-width:0.75pt; padding-right:5.03pt; padding-left:5.03pt; vertical-align:top; -aw-border-left:0.5pt single #000000; -aw-border-right:0.5pt single #000000; -aw-border-top:0.5pt single #000000">
                <p style="text-align:justify; font-size:10.5pt"><span style="font-family:'等线 Light'">회원이 스마트 고객센터에
                        입력한 모든 정보</span></p>
            </td>
            <td
                style="width:81.35pt; border-top-style:solid; border-top-width:0.75pt; border-right-style:solid; border-right-width:0.75pt; border-left-style:solid; border-left-width:0.75pt; padding-right:5.03pt; padding-left:5.03pt; vertical-align:top; -aw-border-left:0.5pt single #000000; -aw-border-right:0.5pt single #000000; -aw-border-top:0.5pt single #000000">
                <p style="text-align:justify; font-size:10.5pt"><span style="font-family:'等线 Light'">수집 후 즉시
                        전송</span></p>
                <p style="text-align:justify; font-size:10.5pt"><span style="font-family:'等线 Light'">네트워크 전송 및
                        복제</span></p>
            </td>
            <td
                style="width:258.55pt; border-top-style:solid; border-top-width:0.75pt; border-left-style:solid; border-left-width:0.75pt; padding-right:5.03pt; padding-left:5.03pt; vertical-align:top; -aw-border-left:0.5pt single #000000; -aw-border-top:0.5pt single #000000">
                <p style="text-align:justify; font-size:10.5pt"><span style="font-family:'等线 Light'">사용자정보는 분쟁과 관련이
                        있을 수 있으므로 회원탈퇴 후 최최대 3년까지 보관됩니다.</span></p>
            </td>
        </tr>
    </table>
    <p><span>* </span><span style="font-family:宋体">상기 연락처는 영문 메일 문의만 받습니다</span></p>
</div>
`;

export const zrrglobalForeignThirdDetailHtml = `
 <div>
    <table cellspacing="0" cellpadding="0" class="10"
        style="border:0.75pt solid #000000; -aw-border:0.5pt single #000000; -aw-border-insideh:0.5pt single #000000; -aw-border-insidev:0.5pt single #000000; border-collapse:collapse">
        <tr>
            <td
                style="width:48.8pt; border-right-style:solid; border-right-width:0.75pt; border-bottom-style:solid; border-bottom-width:0.75pt; padding-right:5.03pt; padding-left:5.03pt; vertical-align:top; -aw-border-bottom:0.5pt single #000000; -aw-border-right:0.5pt single #000000">
                <p style="text-align:justify; font-size:10.5pt"><span style="font-family:等线">업체명(연락처)</span><span
                        style="font-family:等线">&#xa0;</span></p>
            </td>
            <td
                style="width:109.2pt; border-right-style:solid; border-right-width:0.75pt; border-left-style:solid; border-left-width:0.75pt; border-bottom-style:solid; border-bottom-width:0.75pt; padding-right:5.03pt; padding-left:5.03pt; vertical-align:top; -aw-border-bottom:0.5pt single #000000; -aw-border-left:0.5pt single #000000; -aw-border-right:0.5pt single #000000">
                <p style="text-align:justify; font-size:10.5pt"><span style="font-family:等线">개인정보 이전국가</span></p>
            </td>
            <td
                style="width:49.2pt; border-right-style:solid; border-right-width:0.75pt; border-left-style:solid; border-left-width:0.75pt; border-bottom-style:solid; border-bottom-width:0.75pt; padding-right:5.03pt; padding-left:5.03pt; vertical-align:top; -aw-border-bottom:0.5pt single #000000; -aw-border-left:0.5pt single #000000; -aw-border-right:0.5pt single #000000">
                <p style="text-align:justify; font-size:10.5pt"><span style="font-family:等线">이용 목적</span></p>
            </td>
            <td
                style="width:117.9pt; border-right-style:solid; border-right-width:0.75pt; border-left-style:solid; border-left-width:0.75pt; border-bottom-style:solid; border-bottom-width:0.75pt; padding-right:5.03pt; padding-left:5.03pt; vertical-align:top; -aw-border-bottom:0.5pt single #000000; -aw-border-left:0.5pt single #000000; -aw-border-right:0.5pt single #000000">
                <p style="text-align:justify; font-size:10.5pt"><span style="font-family:等线">이전 항목</span></p>
            </td>
            <td
                style="width:81.35pt; border-right-style:solid; border-right-width:0.75pt; border-left-style:solid; border-left-width:0.75pt; border-bottom-style:solid; border-bottom-width:0.75pt; padding-right:5.03pt; padding-left:5.03pt; vertical-align:top; -aw-border-bottom:0.5pt single #000000; -aw-border-left:0.5pt single #000000; -aw-border-right:0.5pt single #000000">
                <p style="text-align:justify; font-size:10.5pt"><span style="font-family:等线">이전 일시 및 방법</span></p>
            </td>
            <td
                style="width:258.55pt; border-left-style:solid; border-left-width:0.75pt; border-bottom-style:solid; border-bottom-width:0.75pt; padding-right:5.03pt; padding-left:5.03pt; vertical-align:top; -aw-border-bottom:0.5pt single #000000; -aw-border-left:0.5pt single #000000">
                <p style="text-align:justify; font-size:10.5pt"><span style="font-family:等线">보유 및 이용기간</span></p>
            </td>
        </tr>
        <tr>
            <td
                style="width:48.8pt; border-top-style:solid; border-top-width:0.75pt; border-right-style:solid; border-right-width:0.75pt; border-bottom-style:solid; border-bottom-width:0.75pt; padding-right:5.03pt; padding-left:5.03pt; vertical-align:top; -aw-border-bottom:0.5pt single #000000; -aw-border-right:0.5pt single #000000; -aw-border-top:0.5pt single #000000">
                <p style="text-align:justify; font-size:10.5pt"><span style="font-family:等线">Amazon Web Services,
                        Inc</span></p>
                <p style="text-align:justify; font-size:10.5pt"><span style="font-family:等线">（</span><a
                        href="mailto:leonxing@amazon.com" style="text-decoration:none"><span
                            style="font-family:等线; color:#000000">leonxing@amazon.com</span></a><span
                        style="font-family:等线">）</span></p>
            </td>
            <td
                style="width:109.2pt; border-style:solid; border-width:0.75pt; padding-right:5.03pt; padding-left:5.03pt; vertical-align:top; -aw-border:0.5pt single #000000">
                <p style="text-align:justify; font-size:10.5pt"><span style="font-family:等线">싱가포르, </span><span
                        style="font-family:Batang">말레이시아</span></p>
            </td>
            <td rowspan="2"
                style="width:49.2pt; border-style:solid; border-width:0.75pt; padding-right:5.03pt; padding-left:5.03pt; vertical-align:top; -aw-border:0.5pt single #000000">
                <p style="text-align:justify; font-size:10.5pt"><span style="font-family:等线">이용자 개인정보 보관</span></p>
            </td>
            <td rowspan="2"
                style="width:117.9pt; border-style:solid; border-width:0.75pt; padding-right:5.03pt; padding-left:5.03pt; vertical-align:top; -aw-border:0.5pt single #000000">
                <p style="text-align:justify; font-size:10.5pt"><span style="font-family:等线">ID, 비밀번호, 캐릭터 명칭, 휴대폰
                        모델명, 생년월일, 방문 날짜, 서비스 이용 기록, 불량 이용 기록, 결산 기록, 에러 정보</span></p>
                <p style="text-align:justify; font-size:10.5pt"><span
                        style="font-family:等线; -aw-import:ignore">&#xa0;</span></p>
            </td>
            <td rowspan="2"
                style="width:81.35pt; border-style:solid; border-width:0.75pt; padding-right:5.03pt; padding-left:5.03pt; vertical-align:top; -aw-border:0.5pt single #000000">
                <p style="text-align:justify; font-size:10.5pt"><span style="font-family:等线">수집 후 즉시 전송</span></p>
                <p style="text-align:justify; font-size:10.5pt"><span style="font-family:等线">네트워크를 통한 전송 및 복사</span>
                </p>
            </td>
            <td rowspan="2"
                style="width:258.55pt; border-top-style:solid; border-top-width:0.75pt; border-left-style:solid; border-left-width:0.75pt; border-bottom-style:solid; border-bottom-width:0.75pt; padding-right:5.03pt; padding-left:5.03pt; vertical-align:top; -aw-border-bottom:0.5pt single #000000; -aw-border-left:0.5pt single #000000; -aw-border-top:0.5pt single #000000">
                <p style="text-align:justify; font-size:10.5pt"><span style="font-family:等线">계약 및 주문 내역, 주문 취소 내역,
                        결제 정보, 재무 기록은 회원 탈퇴 후 5년간 보관</span></p>
                <p style="text-align:justify; font-size:10.5pt"><span style="font-family:等线">분쟁 관련 정보는 회원 탈퇴 후 3년간
                        보관</span></p>
                <p style="text-align:justify; font-size:10.5pt"><span style="font-family:等线">계정, 비밀번호, 휴대폰 기종은 회원 탈퇴
                        후 30일간 보관</span></p>
                <p style="text-align:justify; font-size:10.5pt"><span style="font-family:等线">기타 정보는 회원 탈퇴 시 즉시
                        파기</span></p>
            </td>
        </tr>
        <tr>
            <td
                style="width:48.8pt; border-top-style:solid; border-top-width:0.75pt; border-right-style:solid; border-right-width:0.75pt; border-bottom-style:solid; border-bottom-width:0.75pt; padding-right:5.03pt; padding-left:5.03pt; vertical-align:top; -aw-border-bottom:0.5pt single #000000; -aw-border-right:0.5pt single #000000; -aw-border-top:0.5pt single #000000">
                <p style="text-align:justify; font-size:10.5pt"><span style="font-family:等线">Alibaba Cloud</span>
                </p>
                <p style="text-align:justify; font-size:10.5pt"><span style="font-family:等线">（</span><span
                        style="font-family:等线">&#xa0;</span><a href="mailto:intlcompliance@service.aliyun.com"
                        style="text-decoration:none"><span
                            style="font-family:等线; color:#000000">intlcompliance@service.aliyun.com</span></a><span
                        style="font-family:等线">）</span></p>
            </td>
            <td
                style="width:109.2pt; border-style:solid; border-width:0.75pt; padding-right:5.03pt; padding-left:5.03pt; vertical-align:top; -aw-border:0.5pt single #000000">
                <p style="text-align:justify; font-size:10.5pt"><span style="font-family:'等线 Light'">싱가포르</span></p>
            </td>
        </tr>
        <tr>
            <td
                style="width:48.8pt; border-top-style:solid; border-top-width:0.75pt; border-right-style:solid; border-right-width:0.75pt; padding-right:5.03pt; padding-left:5.03pt; vertical-align:top; -aw-border-right:0.5pt single #000000; -aw-border-top:0.5pt single #000000">
                <p style="text-align:justify; font-size:10.5pt"><span style="font-family:等线">Azure OpenAI Service
                        （</span><a href="mailto:cscraireport@microsoft.com" style="text-decoration:none"><span
                            style="font-family:等线; color:#000000">cscraireport@microsoft.com</span></a><span
                        style="font-family:等线">）</span></p>
            </td>
            <td
                style="width:109.2pt; border-top-style:solid; border-top-width:0.75pt; border-right-style:solid; border-right-width:0.75pt; border-left-style:solid; border-left-width:0.75pt; padding-right:5.03pt; padding-left:5.03pt; vertical-align:top; -aw-border-left:0.5pt single #000000; -aw-border-right:0.5pt single #000000; -aw-border-top:0.5pt single #000000">
                <p style="text-align:justify; font-size:10.5pt"><span style="font-family:'等线 Light'">미국, 스웨덴</span>
                </p>
            </td>
            <td
                style="width:49.2pt; border-top-style:solid; border-top-width:0.75pt; border-right-style:solid; border-right-width:0.75pt; border-left-style:solid; border-left-width:0.75pt; padding-right:5.03pt; padding-left:5.03pt; vertical-align:top; -aw-border-left:0.5pt single #000000; -aw-border-right:0.5pt single #000000; -aw-border-top:0.5pt single #000000">
                <p style="text-align:justify; font-size:10.5pt"><span style="font-family:'等线 Light'">AI 스마트 고객
                        서비스</span></p>
            </td>
            <td
                style="width:117.9pt; border-top-style:solid; border-top-width:0.75pt; border-right-style:solid; border-right-width:0.75pt; border-left-style:solid; border-left-width:0.75pt; padding-right:5.03pt; padding-left:5.03pt; vertical-align:top; -aw-border-left:0.5pt single #000000; -aw-border-right:0.5pt single #000000; -aw-border-top:0.5pt single #000000">
                <p style="text-align:justify; font-size:10.5pt"><span style="font-family:'等线 Light'">회원이 스마트 고객센터에
                        입력한 모든 정보</span></p>
            </td>
            <td
                style="width:81.35pt; border-top-style:solid; border-top-width:0.75pt; border-right-style:solid; border-right-width:0.75pt; border-left-style:solid; border-left-width:0.75pt; padding-right:5.03pt; padding-left:5.03pt; vertical-align:top; -aw-border-left:0.5pt single #000000; -aw-border-right:0.5pt single #000000; -aw-border-top:0.5pt single #000000">
                <p style="text-align:justify; font-size:10.5pt"><span style="font-family:'等线 Light'">수집 후 즉시
                        전송</span></p>
                <p style="text-align:justify; font-size:10.5pt"><span style="font-family:'等线 Light'">네트워크 전송 및
                        복제</span></p>
            </td>
            <td
                style="width:258.55pt; border-top-style:solid; border-top-width:0.75pt; border-left-style:solid; border-left-width:0.75pt; padding-right:5.03pt; padding-left:5.03pt; vertical-align:top; -aw-border-left:0.5pt single #000000; -aw-border-top:0.5pt single #000000">
                <p style="text-align:justify; font-size:10.5pt"><span style="font-family:'等线 Light'">사용자정보는 분쟁과 관련이
                        있을 수 있으므로 회원탈퇴 후 최최대 3년까지 보관됩니다.</span></p>
            </td>
        </tr>
    </table>
    <p><span>* </span><span style="font-family:宋体">상기 연락처는 영문 메일 문의만 받습니다</span></p>
</div>
`;

export const zrrglobalOperationPolicyHtml = `
<div>
<p
  style="margin-bottom: 14pt; line-height: normal; widows: 2; orphans: 2"
>
  <span>본</span><span> </span><span>운영정책은 BUILDING-BLOCKS NETWORK TECHNOLOGY CO.LIMITED</span><span> </span
  ><span>(</span><span>이하</span><span> </span><span>"</span
  ><span>회사</span><span>")</span><span>가</span><span> </span
  ><span>게임</span><span> </span><span>관련</span><span> </span
  ><span>서비스</span><span>(</span><span>이하</span><span> </span
  ><span>'</span><span>서비스</span><span>')</span><span>를</span
  ><span> </span><span>고객이</span><span> </span><span>이용함에</span
  ><span> </span><span>있어</span><span> </span><span>발생할</span
  ><span> </span><span>수</span><span> </span><span>있는</span
  ><span> </span><span>문제에</span><span> </span><span>대해</span
  ><span>, </span><span>보다</span><span> </span><span>공정하고</span
  ><span> </span><span>형평성을</span><span> </span><span>기반으로</span
  ><span> </span><span>한</span><span> </span><span>서비스</span
  ><span> </span><span>제공</span><span> </span><span>및</span
  ><span> </span><span>고객의</span><span> </span><span>사용권</span
  ><span> </span><span>보호를</span><span> </span><span>목적으로</span
  ><span> </span><span>하고</span><span> </span><span>있습니다</span
  ><span>.</span>
</p>
<p
  style="
    margin-top: 14pt;
    margin-bottom: 14pt;
    line-height: normal;
    widows: 2;
    orphans: 2;
  "
>
  <span>회사는</span><span> </span><span>중립적이고</span><span>, </span
  ><span>객관적인</span><span> </span><span>입장에서</span><span> </span
  ><span>고객이</span><span> </span><span>쾌적한</span><span> </span
  ><span>환경을</span><span> </span><span>통해</span><span> </span
  ><span>서비스를</span><span> </span><span>받을</span><span> </span
  ><span>수</span><span> </span><span>있도록최선의</span><span> </span
  ><span>노력을</span><span> </span><span>다할</span><span> </span
  ><span>것을</span><span> </span><span>약속</span><span> </span
  ><span>드립니다</span><span>. </span><span>운영정책에는</span
  ><span> </span><span>서비스</span><span> </span><span>이용</span
  ><span> </span><span>시</span><span> </span><span>유의하셔야</span
  ><span> </span><span>할</span><span> </span><span>내용이</span
  ><span> </span><span>포함되어있으니</span><span> </span><span>주의</span
  ><span> </span><span>깊게</span><span> </span><span>확인하시기를</span
  ><span> </span><span>권해</span><span> </span><span>드립니다</span
  ><span>.</span>
</p>
<p
  style="
    margin-top: 14pt;
    margin-bottom: 14pt;
    line-height: normal;
    widows: 2;
    orphans: 2;
  "
>
  <span>1.</span><span>&#xa0;</span><span>총칙</span>
</p>
<p
  style="
    margin-top: 14pt;
    margin-bottom: 14pt;
    line-height: normal;
    widows: 2;
    orphans: 2;
  "
>
  <span>1)</span><span>이</span><span>"</span><span>운영정책</span
  ><span>"</span><span>은</span><span> </span><span>서비스</span
  ><span> </span><span>운영</span><span> </span><span>상</span
  ><span> </span><span>발생할</span><span> </span><span>수</span
  ><span> </span><span>있는</span><span> </span><span>문제점에</span
  ><span> </span><span>대해</span><span> </span
  ><span>합리적이며공정하게</span><span> </span><span>대처하기</span
  ><span> </span><span>위하여</span><span> </span><span>마련되었으며</span
  ><span>, "</span><span>회사</span><span>"</span><span>가서비스를</span
  ><span> </span><span>운영하고</span><span>, </span><span>회원</span
  ><span> </span><span>여러분이</span><span> </span><span>서비스를</span
  ><span> </span><span>이용함에</span><span> </span><span>있어</span
  ><span> </span><span>필요한</span><span> </span><span>세부</span
  ><span> </span><span>규칙을</span><span> </span><span>담고</span
  ><span> </span><span>있습니다</span><span>.</span>
</p>
<p
  style="
    margin-top: 14pt;
    margin-bottom: 14pt;
    line-height: normal;
    widows: 2;
    orphans: 2;
  "
>
  <span>2)"</span><span>회사</span><span>"</span><span>는서비스의</span
  ><span> </span><span>효율적인</span><span> </span><span>운영을</span
  ><span> </span><span>위해</span><span> </span><span>"</span
  ><span>운영정책</span><span>"</span><span>의내용을</span><span> </span
  ><span>추가</span><span>, </span><span>변경</span><span>, </span
  ><span>삭제할</span><span> </span><span>수</span><span> </span
  ><span>있습니다</span><span>. "</span><span>운영정책</span
  ><span>" </span><span>의</span><span> </span><span>내용이</span
  ><span> </span><span>추가</span><span>, </span><span>변경</span
  ><span>, </span><span>삭제될</span><span> </span><span>경우</span
  ><span> </span><span>"</span><span>회사</span><span>"</span
  ><span>는</span><span> </span><span>적용일자</span><span> </span
  ><span>7</span><span>일</span><span> </span><span>이전부터</span
  ><span> </span><span>서비스</span><span> </span><span>페이지의</span
  ><span> </span><span>'</span><span>공지사항</span><span>'</span
  ><span>을</span><span> </span><span>통해</span><span> </span
  ><span>공지하거나</span><span> </span><span>전자우편</span
  ><span>, </span><span>쪽지</span><span>, </span><span>기타</span
  ><span> </span><span>연락이</span><span> </span><span>가능한</span
  ><span> </span><span>통지</span><span> </span><span>방법</span
  ><span> </span><span>중</span><span> </span><span>하나를</span
  ><span> </span><span>택하여</span><span> </span><span>통지합니다</span
  ><span>. </span><span>단</span><span>, </span><span>회원</span
  ><span> </span><span>여러분께</span><span> </span><span>불리한</span
  ><span> </span><span>내용</span><span> </span><span>또는</span
  ><span> </span><span>중요한</span><span> </span><span>내용의</span
  ><span> </span><span>경우</span><span> </span><span>30</span
  ><span>일</span><span> </span><span>전에</span><span> </span
  ><span>'</span><span>공지사항</span><span>'</span><span>을통해</span
  ><span> </span><span>공지하거나</span><span> </span
  ><span>전자우편으로</span><span> </span><span>통지합니다</span
  ><span>.</span>
</p>
<p
  style="
    margin-top: 14pt;
    margin-bottom: 14pt;
    line-height: normal;
    widows: 2;
    orphans: 2;
  "
>
  <span>3)</span><span>이</span><span>"</span><span>운영정책</span
  ><span>"</span><span>은</span><span> </span><span>"</span
  ><span>약관</span><span>"</span><span>에</span><span> </span
  ><span>포함하기</span><span> </span><span>어려운</span><span> </span
  ><span>서비스</span><span> </span><span>운영의</span><span> </span
  ><span>세부</span><span> </span><span>규칙을</span><span> </span
  ><span>포함하고</span><span> </span><span>있으며</span><span>, </span
  ><span>약관의일부를</span><span> </span><span>구성합니다</span
  ><span>. </span><span>이</span><span> </span><span>"</span
  ><span>운영정책</span><span>"</span><span>의</span><span> </span
  ><span>내용을</span><span> </span><span>회원</span><span> </span
  ><span>여러분께서</span><span> </span><span>알지</span><span> </span
  ><span>못하여</span><span> </span><span>발생한</span><span> </span
  ><span>피해에</span><span> </span><span>대해서는</span><span> </span
  ><span>도움을</span><span> </span><span>드리기</span><span> </span
  ><span>어려우므로</span><span>, </span><span>이</span><span> </span
  ><span>"</span><span>운영정책</span><span>"</span><span>의내용을</span
  ><span> </span><span>반드시</span><span> </span><span>확인하시기</span
  ><span> </span><span>바랍니다</span><span>.</span>
</p>
<p
  style="
    margin-top: 14pt;
    margin-bottom: 14pt;
    line-height: normal;
    widows: 2;
    orphans: 2;
  "
>
  <span>4)</span><span>이</span><span>"</span><span>운영정책</span
  ><span>"</span><span>에</span><span> </span><span>명시되지</span
  ><span> </span><span>않은</span><span> </span><span>사항에</span
  ><span> </span><span>대해서는</span><span> </span><span>이용약관</span
  ><span>, </span><span>관계</span><span> </span><span>법령</span
  ><span>, </span><span>그리고</span><span> </span><span>회원</span
  ><span> </span><span>여러분과</span><span>"</span><span>회사</span
  ><span>"</span><span>가</span><span> </span><span>공유</span
  ><span> </span><span>하는</span><span> </span><span>일반적인</span
  ><span> </span><span>사회적</span><span> </span><span>통념에</span
  ><span> </span><span>의하여</span><span> </span><span>처리되거나</span
  ><span>, </span><span>그에</span><span> </span><span>준하는</span
  ><span> </span><span>기준에</span><span> </span><span>의하여</span
  ><span> </span><span>사안을</span><span> </span><span>처리</span
  ><span> </span><span>합니다</span><span>.</span>
</p>
<p
  style="
    margin-top: 14pt;
    margin-bottom: 14pt;
    line-height: normal;
    widows: 2;
    orphans: 2;
  "
>
  <span>2. "</span><span>회원</span><span>"</span><span>의</span
  ><span> </span><span>의무와</span><span> </span><span>권리</span>
</p>
<p
  style="
    margin-top: 14pt;
    margin-bottom: 14pt;
    line-height: normal;
    widows: 2;
    orphans: 2;
  "
>
  <span>1)"</span><span>회사</span><span>"</span><span>는회원</span
  ><span> </span><span>여러분께</span><span> </span><span>양질의</span
  ><span> </span><span>서비스를</span><span> </span><span>제공하고자</span
  ><span> </span><span>노력하고</span><span> </span><span>있습니다</span
  ><span>. </span><span>다만</span><span>,"</span><span>회사</span
  ><span>"</span><span>는</span><span> </span><span>회원</span
  ><span> </span><span>여러분께서</span><span> </span><span>양질의</span
  ><span> </span><span>서비스를</span><span> </span><span>쾌적하게</span
  ><span> </span><span>이용하시기</span><span> </span
  ><span>위해서아래와</span><span> </span><span>같은</span><span> </span
  ><span>몇</span><span> </span><span>가지</span><span> </span
  ><span>사항을</span><span> </span><span>지켜주실</span><span> </span
  ><span>것을</span><span> </span><span>부탁</span><span> </span
  ><span>드립니다</span><span>.</span>
</p>
<p
  style="
    margin-top: 14pt;
    margin-bottom: 14pt;
    line-height: normal;
    widows: 2;
    orphans: 2;
  "
>
  <span>2)</span><span>회원</span><span> </span><span>여러분께서는</span
  ><span> </span><span>회원</span><span> </span><span>본인의</span
  ><span> </span><span>정보로</span><span> </span><span>회원가입</span
  ><span>&#xa0;</span><span>또는</span><span> </span><span>서비스를</span
  ><span> </span><span>이용해</span><span> </span><span>주셔야</span
  ><span> </span><span>합니다</span><span>. </span><span>타인의</span
  ><span> </span><span>정보</span><span> </span><span>또는</span
  ><span> </span><span>허위</span><span> </span><span>정보를</span
  ><span> </span><span>이용하여</span><span> </span><span>회원가입</span
  ><span> </span><span>또는</span><span> </span><span>서비스를</span
  ><span>&#xa0;</span><span>이용하시는</span><span> </span
  ><span>경우</span><span> </span><span>"</span><span>회사</span
  ><span>"</span><span>는</span><span> </span><span>이에</span
  ><span> </span><span>대하여</span><span>&#xa0;</span><span>어떠한</span
  ><span> </span><span>도움도</span><span> </span><span>드리지</span
  ><span> </span><span>않으며</span><span>, "</span><span>회사</span
  ><span>"</span><span>가</span><span>&#xa0;</span><span>제공하는</span
  ><span> </span><span>각종</span><span> </span><span>혜택</span
  ><span> </span><span>또한</span><span> </span><span>제공해드리지</span
  ><span> </span><span>않습니다</span><span>.</span>
</p>
<p
  style="
    margin-top: 14pt;
    margin-bottom: 14pt;
    line-height: normal;
    widows: 2;
    orphans: 2;
  "
>
  <span>3)"</span><span>회사</span><span>"</span><span>는</span
  ><span>&#xa0;</span><span>아이템</span><span> </span><span>및</span
  ><span> </span><span>계정의</span><span> </span><span>공유</span
  ><span> </span><span>및</span><span> </span><span>양도</span
  ><span>, </span><span>현금</span><span> </span><span>거래를</span
  ><span> </span><span>인정하지</span><span> </span><span>않습니다</span
  ><span>. </span><span>이로인해</span><span> </span><span>발생하는</span
  ><span> </span><span>문제</span><span>(</span><span>사기</span
  ><span>, </span><span>계정도용</span><span> </span><span>등</span
  ><span>)</span><span>에</span><span> </span><span>대해서는</span
  ><span> </span><span>도움을</span><span> </span><span>드리기</span
  ><span> </span><span>어려우므로</span><span> </span><span>아이템</span
  ><span> </span><span>및</span><span> </span><span>계정의</span
  ><span> </span><span>공유</span><span>, </span><span>거래</span
  ><span>, </span><span>양도에</span><span> </span><span>대해서는</span
  ><span> </span><span>신중히</span><span> </span><span>결정해</span
  ><span> </span><span>주시기</span><span> </span><span>바랍니다</span
  ><span>.</span>
</p>
<p
  style="
    margin-top: 14pt;
    margin-bottom: 14pt;
    line-height: normal;
    widows: 2;
    orphans: 2;
  "
>
  <span>4)</span><span>회원</span><span> </span><span>여러분께서는</span
  ><span> </span><span>"</span><span>회사</span><span>"</span
  ><span>의</span><span> </span><span>서비스를</span><span> </span
  ><span>이용하여</span><span> </span><span>얻은</span><span> </span
  ><span>정보를</span><span> </span><span>"</span><span>회사</span
  ><span>"</span><span>의</span><span> </span><span>사전</span
  ><span> </span><span>동의</span><span> </span><span>없이</span
  ><span> </span><span>복사</span><span>/</span><span>&#xa0;</span
  ><span>복제</span><span>/</span><span>&#xa0;</span><span>변경</span
  ><span>/ </span><span>번역</span><span>/</span><span>&#xa0;</span
  ><span>출판</span><span>/</span><span>&#xa0;</span><span>방송</span
  ><span> </span><span>등의</span><span> </span><span>방법으로</span
  ><span> </span><span>사용하거나</span><span>, </span><span>이를</span
  ><span> </span><span>타인에게</span><span> </span><span>제공하실</span
  ><span> </span><span>수</span><span> </span><span>없습니다</span
  ><span>. </span><span>해당</span><span> </span><span>행위로</span
  ><span> </span><span>인한</span><span> </span><span>모든</span
  ><span> </span><span>결과에</span><span> </span><span>대한</span
  ><span> </span><span>책임은</span><span> </span><span>회원에게</span
  ><span> </span><span>있으며</span><span> </span><span>“</span
  ><span>회사</span><span>”</span><span>에</span><span> </span
  ><span>손해가</span><span> </span><span>발생할</span><span> </span
  ><span>경우</span><span> </span><span>“</span><span>회사</span
  ><span>”</span><span>는</span><span> </span><span>해당</span
  ><span> </span><span>회원에게</span><span> </span><span>대한</span
  ><span> </span><span>손해배상</span><span> </span><span>등을</span
  ><span> </span><span>청구할</span><span> </span><span>수</span
  ><span> </span><span>있습니다</span><span>.</span>
</p>
<p
  style="
    margin-top: 14pt;
    margin-bottom: 14pt;
    line-height: normal;
    widows: 2;
    orphans: 2;
  "
>
  <span>5)</span><span>회원</span><span> </span><span>여러분께서는</span
  ><span> </span><span>운영진</span><span> </span><span>사칭</span
  ><span>, </span><span>업무</span><span> </span><span>관여</span
  ><span>, </span><span>중재</span><span> </span><span>방해</span
  ><span> </span><span>등</span><span> </span><span>운영진의</span
  ><span> </span><span>업무를</span><span> </span><span>방해하는</span
  ><span> </span><span>행위를</span><span> </span
  ><span>하셔서는안됩니다</span><span>. </span><span>운영진의</span
  ><span> </span><span>업무를</span><span> </span><span>방해하는</span
  ><span> </span><span>행위를</span><span> </span><span>할</span
  ><span> </span><span>경우</span><span> </span><span>서비스</span
  ><span> </span><span>이용에</span><span> </span><span>제한을</span
  ><span> </span><span>받으실</span><span> </span><span>수</span
  ><span> </span><span>있습니다</span><span>.</span>
</p>
<p
  style="
    margin-top: 14pt;
    margin-bottom: 14pt;
    line-height: normal;
    widows: 2;
    orphans: 2;
  "
>
  <span>6)</span><span>회원</span><span> </span><span>여러분께서는</span
  ><span> </span><span>게임의</span><span> </span><span>취약점</span
  ><span>(</span><span>버그</span><span>, </span><span>계정도용</span
  ><span>, </span><span>불법프로그램</span><span>)</span><span>을</span
  ><span> </span><span>발견했을</span><span> </span><span>경우</span
  ><span> </span><span>반드시</span><span> </span><span>1:1</span
  ><span>문의</span><span> </span><span>등으로</span><span> </span
  ><span>신고해</span><span> </span><span>주셔야</span><span> </span
  ><span>합니다</span><span>. </span><span>신고를</span><span> </span
  ><span>하지</span><span> </span><span>않고</span><span> </span
  ><span>이를</span><span> </span><span>악용하거나</span><span> </span
  ><span>타인에게</span><span> </span><span>전달하는</span><span> </span
  ><span>경우</span><span>, </span><span>의도적인</span><span>&#xa0;</span
  ><span>불건전</span><span> </span><span>행위로</span><span> </span
  ><span>판단하여</span><span> </span><span>불이익을</span><span> </span
  ><span>받으실</span><span> </span><span>수</span><span> </span
  ><span>있습니다</span><span>. </span><span>다음에</span><span> </span
  ><span>해당할</span><span> </span><span>경우에는</span><span> </span
  ><span>사전</span><span> </span><span>경고</span><span> </span
  ><span>없이</span><span> </span><span>서비스이용</span><span> </span
  ><span>제한</span><span> </span><span>조치가</span><span> </span
  ><span>될</span><span> </span><span>수</span><span> </span
  ><span>있으므로</span><span> </span><span>주의</span><span> </span
  ><span>바랍니다</span><span>.</span><span> </span><span>①</span
  ><span> </span><span>시스템의</span><span> </span><span>문제점을</span
  ><span> </span><span>통한</span><span> </span><span>악용</span
  ><span> </span><span>행위</span><span> </span><span>②</span
  ><span> </span><span>버그를</span><span> </span><span>알리지</span
  ><span> </span><span>않고</span><span> </span><span>이를</span
  ><span> </span><span>유포</span><span> </span><span>및</span
  ><span> </span><span>악용하는</span><span> </span><span>행위</span
  ><span> </span><span>③</span><span> "</span><span>회사</span
  ><span>"</span><span>에서</span><span> </span><span>인정하지</span
  ><span> </span><span>않은</span><span>&#xa0;</span
  ><span>불법프로그램</span><span>("</span><span>회사</span><span>"</span
  ><span>로부터</span><span> </span><span>공식적으로</span><span> </span
  ><span>전달받거나승인되지</span><span> </span><span>않은</span
  ><span> </span><span>프로그램</span><span>)</span><span>을</span
  ><span> </span><span>사용하는</span><span> </span><span>행위</span
  ><span> </span><span>④</span><span> </span><span>클라이언트의</span
  ><span> </span><span>무단</span><span> </span><span>변조</span
  ><span> </span><span>행위</span><span> </span><span>⑤</span
  ><span> </span><span>시스템의</span><span> </span><span>불안정을</span
  ><span> </span><span>이용하여</span><span> </span><span>다른</span
  ><span> </span><span>회원의</span><span> </span><span>게임플레이를</span
  ><span> </span><span>방해하는</span><span> </span><span>행위</span
  ><span> </span><span>⑥</span><span> </span><span>데이터</span
  ><span> </span><span>조작</span><span> </span><span>및</span
  ><span> </span><span>추출행위</span><span> </span><span>⑦</span
  ><span> </span><span>그</span><span> </span><span>외</span><span> </span
  ><span>운영진의</span><span> </span><span>판단에</span><span> </span
  ><span>"</span><span>운영정책</span><span>"</span><span>과</span
  ><span>&#xa0;</span><span>어긋난다고</span><span> </span
  ><span>판단되는</span><span> </span><span>행위</span>
</p>
<p
  style="
    margin-top: 14pt;
    margin-bottom: 14pt;
    line-height: normal;
    widows: 2;
    orphans: 2;
  "
>
  <span>7)</span><span>회원</span><span> </span><span>여러분께서는</span
  ><span> </span><span>고객센터를</span><span> </span><span>통해</span
  ><span> </span><span>"</span><span>서비스</span><span>" </span
  ><span>와</span><span> </span><span>관련된</span><span> </span
  ><span>문의를</span><span> </span><span>하실</span><span> </span
  ><span>수</span><span> </span><span>있습니다</span><span>.</span>
</p>
<p
  style="
    margin-top: 14pt;
    margin-bottom: 14pt;
    line-height: normal;
    widows: 2;
    orphans: 2;
  "
>
  <span>8)</span><span>회원</span><span> </span><span>여러분께서</span
  ><span> </span><span>서비스</span><span> </span><span>이용</span
  ><span> </span><span>과정에서</span><span> </span
  ><span>부당한피해를</span><span> </span><span>당한</span><span> </span
  ><span>경우</span><span>, </span><span>정당한</span><span> </span
  ><span>방법을</span><span> </span><span>통하여</span><span> </span
  ><span>피해</span><span> </span><span>회복을</span><span> </span
  ><span>위한</span><span> </span><span>권리를</span><span> </span
  ><span>행사할</span><span> </span><span>수</span><span> </span
  ><span>있습니다</span><span>. "</span><span>회사</span><span>"</span
  ><span>는</span><span> </span><span>회원</span><span> </span
  ><span>여러분의</span><span> </span><span>정당한</span><span> </span
  ><span>권리를</span><span> </span><span>보호하기위해</span><span> </span
  ><span>최선을</span><span> </span><span>다할</span><span> </span
  ><span>것을</span><span> </span><span>약속합니다</span><span>.</span>
</p>
<p
  style="
    margin-top: 14pt;
    margin-bottom: 14pt;
    line-height: normal;
    widows: 2;
    orphans: 2;
  "
>
  <span>3.</span><span>&#xa0;</span><span>계정</span><span> </span
  ><span>관리</span>
</p>
<p
  style="
    margin-top: 14pt;
    margin-bottom: 14pt;
    line-height: normal;
    widows: 2;
    orphans: 2;
  "
>
  <span>1)</span><span>회원</span><span> </span><span>여러분께서</span
  ><span> </span><span>사용하시는</span><span> </span><span>계정에</span
  ><span> </span><span>대한모든</span><span> </span><span>책임은</span
  ><span> </span><span>일차적으로</span><span> </span><span>회원</span
  ><span> </span><span>여러분에게</span><span> </span><span>있습니다</span
  ><span>.</span>
</p>
<p
  style="
    margin-top: 14pt;
    margin-bottom: 14pt;
    line-height: normal;
    widows: 2;
    orphans: 2;
  "
>
  <span>2)</span><span>회원</span><span> </span><span>여러분이</span
  ><span> </span><span>자신의</span><span> </span><span>개인정보</span
  ><span> </span><span>또는</span><span> </span><span>계정을</span
  ><span>&#xa0;</span><span>타인과</span><span> </span
  ><span>공유하거나</span><span> </span><span>비정상적인</span
  ><span> </span><span>방법으로</span><span> </span><span>양도</span
  ><span>/</span><span>매매한</span><span> </span><span>경우</span
  ><span> </span><span>"</span><span>회사</span><span>"</span
  ><span>는</span><span> </span><span>이를</span><span> </span
  ><span>인정하지</span><span> </span><span>않으며</span><span> </span
  ><span>이로</span><span> </span><span>인해</span><span> </span
  ><span>발생하는</span><span> </span><span>모든</span><span> </span
  ><span>문제</span><span>(</span><span>사기</span><span>, </span
  ><span>계정도용</span><span> </span><span>피해</span><span> </span
  ><span>등</span><span>)</span><span>에</span><span> </span
  ><span>대해서는</span><span>"</span><span>회사</span><span>"</span
  ><span>의</span><span> </span><span>보호를</span><span> </span
  ><span>받으실</span><span> </span><span>수</span><span> </span
  ><span>없습니다</span><span>.</span>
</p>
<p
  style="
    margin-top: 14pt;
    margin-bottom: 14pt;
    line-height: normal;
    widows: 2;
    orphans: 2;
  "
>
  <span>3)</span><span>회원</span><span> </span><span>여러분께서</span
  ><span> </span><span>계정</span><span>, </span><span>캐릭터</span
  ><span>, </span><span>아이템의</span><span> </span><span>현금</span
  ><span>/</span><span>현물거래를</span><span> </span><span>시도할</span
  ><span> </span><span>경우</span><span> </span><span>경고</span
  ><span> </span><span>없이</span><span> </span><span>이용</span
  ><span> </span><span>권한이</span><span> </span><span>박탈</span
  ><span> </span><span>될</span><span> </span><span>수</span><span> </span
  ><span>있으며</span><span>, </span><span>이로</span><span> </span
  ><span>인해</span><span> </span><span>발생하는</span><span> </span
  ><span>문제에</span><span> </span><span>대해서는도움을</span
  ><span> </span><span>드리기</span><span> </span><span>어렵습니다</span
  ><span>.</span>
</p>
<p
  style="
    margin-top: 14pt;
    margin-bottom: 14pt;
    line-height: normal;
    widows: 2;
    orphans: 2;
  "
>
  <span>4)</span><span>회원</span><span> </span><span>여러분께서</span
  ><span> </span><span>사용하시는</span><span> </span><span>계정의</span
  ><span> </span><span>비밀번호는</span><span>&#xa0;</span
  ><span>주기적으로</span><span> </span><span>변경함으로써</span
  ><span> </span><span>계정</span><span> </span><span>도용</span
  ><span> </span><span>등</span><span> </span><span>타인의</span
  ><span> </span><span>부정한</span><span> </span><span>행위로부터</span
  ><span> </span><span>자신의</span><span> </span><span>정보를</span
  ><span> </span><span>보호할</span><span> </span><span>수</span
  ><span> </span><span>있습니다</span><span>.</span>
</p>
<p
  style="
    margin-top: 14pt;
    margin-bottom: 14pt;
    line-height: normal;
    widows: 2;
    orphans: 2;
  "
>
  <span>5)</span><span>사기는</span><span> </span><span>개인</span
  ><span> </span><span>과실에</span><span> </span><span>의해</span
  ><span> </span><span>발생되는</span><span> </span><span>경우가</span
  ><span>&#xa0;</span><span>대부분으로</span><span>, </span
  ><span>이로</span><span> </span><span>인해</span><span> </span
  ><span>발생한</span><span> </span><span>피해에</span><span> </span
  ><span>대해서는</span><span> </span><span>도움을</span><span> </span
  ><span>드리기는</span><span> </span><span>어렵습니다</span
  ><span>. </span><span>따라서</span><span> </span><span>비슷한</span
  ><span> </span><span>캐릭터</span><span> </span><span>명</span
  ><span> </span><span>생성을</span><span> </span><span>통한</span
  ><span> </span><span>지인</span><span> </span><span>사칭</span
  ><span>, </span><span>친분을</span><span> </span><span>이용한사기</span
  ><span> </span><span>등의</span><span> </span><span>피해를</span
  ><span> </span><span>입지</span><span> </span><span>않도록</span
  ><span> </span><span>거래</span><span> </span><span>또는</span
  ><span> </span><span>아이템</span><span> </span><span>이동</span
  ><span> </span><span>시</span><span> </span><span>각별히</span
  ><span> </span><span>주의하시기를</span><span> </span><span>당부</span
  ><span> </span><span>드립니다</span><span>.</span>
</p>
<p
  style="
    margin-top: 14pt;
    margin-bottom: 14pt;
    line-height: normal;
    widows: 2;
    orphans: 2;
  "
>
  <span>4.</span><span>&#xa0;</span><span>명칭</span><span> </span
  ><span>관리</span><span> </span><span>기준</span>
</p>
<p
  style="
    margin-top: 14pt;
    margin-bottom: 14pt;
    line-height: normal;
    widows: 2;
    orphans: 2;
  "
>
  <span>회원여러분께서는</span><span> </span><span>캐릭터</span
  ><span> </span><span>명</span><span>, </span><span>길드</span
  ><span> </span><span>명</span><span> </span><span>등</span><span> </span
  ><span>서비스</span><span> </span><span>내에서</span><span> </span
  ><span>사용되는</span><span> </span><span>모든</span><span> </span
  ><span>명칭을</span><span> </span><span>자유롭게</span><span> </span
  ><span>생성하실</span><span> </span><span>수</span><span> </span
  ><span>있습니다</span><span>. </span><span>단</span><span>, </span
  ><span>다음과</span><span> </span><span>같은</span><span> </span
  ><span>경우에는</span><span> </span><span>적발</span><span> </span
  ><span>시</span><span> </span><span>경고</span><span>, </span
  ><span>운영진의</span><span> </span><span>직권</span><span> </span
  ><span>변경</span><span> </span><span>또는</span><span> </span
  ><span>"</span><span>운영정책</span><span>"</span><span>에</span
  ><span> </span><span>따른</span><span> </span><span>제재가</span
  ><span> </span><span>이루어질</span><span> </span><span>수</span
  ><span> </span><span>있으므로</span><span> </span
  ><span>주의하시기를</span><span> </span><span>당부</span><span> </span
  ><span>드립니다</span><span>.</span>
</p>
<p
  style="
    margin-top: 14pt;
    margin-bottom: 14pt;
    line-height: normal;
    widows: 2;
    orphans: 2;
  "
>
  <span>1)</span><span>타인에게</span><span> </span><span>불쾌감을</span
  ><span> </span><span>주는</span><span> </span><span>명칭</span
  ><span> </span><span>2)</span><span>욕설</span><span> </span
  ><span>및</span><span> </span><span>비속어</span><span>, </span
  ><span>광고</span><span>, </span><span>선정적이거나</span><span> </span
  ><span>음란한</span><span> </span><span>내용이</span><span> </span
  ><span>포함된</span><span> </span><span>명칭</span><span> </span
  ><span>3)</span><span>인종</span><span> </span><span>및</span
  ><span> </span><span>성차별적인</span><span> </span><span>명칭</span
  ><span> </span><span>4)</span><span>특정인이나</span><span> </span
  ><span>지역</span><span>, </span><span>집단</span><span>, </span
  ><span>종교에</span><span> </span><span>대한</span><span> </span
  ><span>비하의</span><span> </span><span>내용을</span><span> </span
  ><span>담은</span><span> </span><span>명칭</span><span> </span
  ><span>5)"</span><span>회사</span><span>",</span><span>서비스</span
  ><span>, </span><span>원작과</span><span> </span><span>관련된</span
  ><span> </span><span>자</span><span> </span><span>또는</span
  ><span> </span><span>이를</span><span> </span><span>사칭할</span
  ><span> </span><span>의도가</span><span> </span><span>있다고</span
  ><span> </span><span>판단되는</span><span> </span><span>명칭</span
  ><span> </span><span>6)'</span><span>운영자</span><span>','</span
  ><span>도우미</span><span>', 'GM' </span><span>등</span><span> </span
  ><span>서비스를</span><span> </span><span>운영하는</span><span> </span
  ><span>자로</span><span> </span><span>인식되거나</span><span> </span
  ><span>오인될</span><span> </span><span>수</span><span> </span
  ><span>있는</span><span> </span><span>명칭</span><span> </span
  ><span>7)</span><span>아이템</span><span>,</span><span>계정의</span
  ><span> </span><span>현금거래를</span><span> </span
  ><span>유인하거나</span><span> </span><span>현금거래의</span
  ><span> </span><span>의도를</span><span> </span><span>가지고</span
  ><span> </span><span>생성한</span><span> </span><span>것으로</span
  ><span> </span><span>판단되는</span><span> </span><span>명칭</span
  ><span> </span><span>8)</span><span>반사회적이거나</span><span> </span
  ><span>반사회적인</span><span> </span><span>인물</span><span>, </span
  ><span>집단을</span><span> </span><span>미화할</span><span> </span
  ><span>의도를</span><span> </span><span>가지고</span><span> </span
  ><span>생성한</span><span> </span><span>것으로</span><span> </span
  ><span>판단되는</span><span> </span><span>명칭</span><span> </span
  ><span>9)</span><span>제</span><span>3</span><span>자의상표</span
  ><span>, </span><span>서비스</span><span> </span><span>표</span
  ><span>, </span><span>저작권을</span><span> </span><span>침해할</span
  ><span> </span><span>가능성이</span><span> </span><span>있다고</span
  ><span> </span><span>판단되는명칭</span><span> </span><span>10)</span
  ><span>특정</span><span> </span><span>상품이나</span><span> </span
  ><span>사이트의</span><span> </span><span>광고</span><span>(</span
  ><span>비영리</span><span> </span><span>사이트</span><span> </span
  ><span>포함</span><span>) </span><span>목적이</span><span> </span
  ><span>있다고</span><span> </span><span>판단되는</span><span> </span
  ><span>명칭</span>
</p>
<p
  style="
    margin-top: 14pt;
    margin-bottom: 14pt;
    line-height: normal;
    widows: 2;
    orphans: 2;
  "
>
  <span>5.</span><span>&#xa0;</span><span>복구</span><span> </span
  ><span>기준</span>
</p>
<p
  style="
    margin-top: 14pt;
    margin-bottom: 14pt;
    line-height: normal;
    widows: 2;
    orphans: 2;
  "
>
  <span>1)</span><span>기술적인</span><span> </span><span>오류로</span
  ><span> </span><span>아이템이나</span><span> </span><span>캐릭터</span
  ><span> </span><span>정보의소실</span><span>, </span><span>변경된</span
  ><span> </span><span>경우</span><span> </span><span>정보가</span
  ><span> </span><span>확인되는</span><span> </span><span>범위</span
  ><span> </span><span>내에서</span><span> </span><span>복구가</span
  ><span> </span><span>가능</span><span> </span><span>합니다</span
  ><span>.</span><span>단</span><span>, </span><span>회원</span
  ><span> </span><span>여러분</span><span> </span><span>스스로의</span
  ><span> </span><span>과실이나</span><span> </span><span>"</span
  ><span>운영정책</span><span>"</span><span>에</span><span> </span
  ><span>명시된</span><span> </span><span>내용</span><span>, </span
  ><span>게임</span><span> </span><span>내</span><span> </span
  ><span>공지</span><span> </span><span>사항에</span><span> </span
  ><span>공지한</span><span> </span><span>내용</span><span> </span
  ><span>등을사전에</span><span> </span><span>숙지하지</span><span> </span
  ><span>못하여</span><span> </span><span>발생한</span><span> </span
  ><span>부분에</span><span> </span><span>대해서는</span><span> </span
  ><span>"</span><span>회사</span><span>"</span><span>가도움을</span
  ><span> </span><span>드리기</span><span> </span><span>어렵습니다</span
  ><span>.</span>
</p>
<p
  style="
    margin-top: 14pt;
    margin-bottom: 14pt;
    line-height: normal;
    widows: 2;
    orphans: 2;
  "
>
  <span>2)</span><span>사기는</span><span> </span><span>개인</span
  ><span> </span><span>과실에</span><span> </span><span>의해</span
  ><span> </span><span>발생하는</span><span> </span><span>경우가</span
  ><span>&#xa0;</span><span>대부분으로</span><span>, </span
  ><span>사기로</span><span> </span><span>인해</span><span> </span
  ><span>발생된</span><span> </span><span>피해는</span><span> </span
  ><span>"</span><span>회사</span><span>"</span><span>가</span
  ><span> </span><span>도움을</span><span> </span><span>드리기</span
  ><span> </span><span>어렵습니다</span><span>. </span><span>다만</span
  ><span> </span><span>추가</span><span> </span><span>피해</span
  ><span> </span><span>예방을</span><span> </span><span>위해조사를</span
  ><span> </span><span>진행하여</span><span> </span><span>확인된</span
  ><span> </span><span>가해</span><span> </span><span>계정은</span
  ><span> </span><span>"</span><span>운영정책</span><span>"</span
  ><span>에따라</span><span> </span><span>서비스</span><span> </span
  ><span>이용이</span><span> </span><span>제한됩니다</span><span>.</span>
</p>
<p
  style="
    margin-top: 14pt;
    margin-bottom: 14pt;
    line-height: normal;
    widows: 2;
    orphans: 2;
  "
>
  <span>3)</span><span>복구</span><span> </span><span>신청은</span
  ><span> </span><span>문제가</span><span> </span><span>발생한</span
  ><span> </span><span>날로부터</span><span> </span><span>14</span
  ><span>일이내에</span><span> </span><span>1:1</span><span>문의</span
  ><span> </span><span>등을</span><span> </span><span>통해</span
  ><span> </span><span>"</span><span>회사</span><span>"</span
  ><span>에</span><span> </span><span>접수를</span><span> </span
  ><span>하셔야</span><span> </span><span>하며</span><span>, </span
  ><span>문의</span><span> </span><span>접수</span><span> </span
  ><span>기간이</span><span> </span><span>지나면</span><span> </span
  ><span>복구에</span><span> </span><span>도움을</span><span> </span
  ><span>드리기</span><span> </span><span>어렵습니다</span><span>.</span>
</p>
<p
  style="
    margin-top: 14pt;
    margin-bottom: 14pt;
    line-height: normal;
    widows: 2;
    orphans: 2;
  "
>
  <span>4)</span><span>고객의</span><span> </span><span>고의</span
  ><span> </span><span>또는</span><span> </span><span>과실에</span
  ><span> </span><span>의한</span><span> </span><span>재화</span
  ><span>/</span><span>아이템</span><span>/</span><span>경험치</span
  ><span> </span><span>등의</span><span> </span><span>손실은</span
  ><span> </span><span>복구가</span><span> </span><span>불가합니다</span
  ><span>.</span>
</p>
<p
  style="
    margin-top: 14pt;
    margin-bottom: 14pt;
    line-height: normal;
    widows: 2;
    orphans: 2;
  "
>
  <span>5)</span><span>아이템</span><span> </span><span>강화를</span
  ><span> </span><span>통한</span><span> </span><span>소모나</span
  ><span> </span><span>유저간의</span><span> </span
  ><span>아이템거래부분은</span><span> </span><span>복구</span
  ><span> </span><span>도움을</span><span> </span><span>드리지</span
  ><span> </span><span>않습니다</span><span>.</span>
</p>
<p
  style="
    margin-top: 14pt;
    margin-bottom: 14pt;
    line-height: normal;
    widows: 2;
    orphans: 2;
  "
>
  <span>6)</span><span>상점에</span><span> </span><span>판매하거나</span
  ><span> </span><span>잘못</span><span> </span><span>장착하여</span
  ><span> </span><span>소실된</span><span>&#xa0;</span><span>장비</span
  ><span> </span><span>아이템은</span><span> </span><span>복구</span
  ><span> </span><span>도움을</span><span> </span><span>드리지</span
  ><span> </span><span>않습니다</span><span>.</span>
</p>
<p
  style="
    margin-top: 14pt;
    margin-bottom: 14pt;
    line-height: normal;
    widows: 2;
    orphans: 2;
  "
>
  <span>7)</span><span>문의</span><span> </span><span>접수는</span
  ><span> </span><span>문제가</span><span> </span><span>발생한</span
  ><span> </span><span>계정</span><span> </span><span>본인이</span
  ><span>&#xa0;</span><span>직접</span><span> </span><span>접수해야</span
  ><span> </span><span>하며</span><span>, </span><span>타인의</span
  ><span> </span><span>대리</span><span> </span><span>접수는</span
  ><span> </span><span>인정되지</span><span> </span><span>않습니다</span
  ><span>.</span>
</p>
<p
  style="
    margin-top: 14pt;
    margin-bottom: 14pt;
    line-height: normal;
    widows: 2;
    orphans: 2;
  "
>
  <span>6.</span><span>&#xa0;</span><span>운영진의</span><span> </span
  ><span>의무와</span><span> </span><span>역할</span>
</p>
<p
  style="
    margin-top: 14pt;
    margin-bottom: 14pt;
    line-height: normal;
    widows: 2;
    orphans: 2;
  "
>
  <span>1)</span><span>운영진은</span><span> </span><span>회원</span
  ><span> </span><span>여러분이</span><span> </span><span>즐겁게</span
  ><span> </span><span>게임</span><span> </span
  ><span>서비스를이용하실</span><span> </span><span>수</span><span> </span
  ><span>있는</span><span> </span><span>최선의</span><span> </span
  ><span>환경을</span><span> </span><span>제공하기</span><span> </span
  ><span>위해</span><span> </span><span>필요한</span><span> </span
  ><span>역할을</span><span> </span><span>수행합니다</span><span>.</span>
</p>
<p
  style="
    margin-top: 14pt;
    margin-bottom: 14pt;
    line-height: normal;
    widows: 2;
    orphans: 2;
  "
>
  <span>2)</span><span>운영진은</span><span> </span><span>중립적인</span
  ><span> </span><span>위치에서</span><span> </span><span>주어진</span
  ><span> </span><span>역할을</span><span>&#xa0;</span
  ><span>수행하며</span><span>, </span><span>회원</span><span> </span
  ><span>간</span><span> </span><span>분쟁에</span><span> </span
  ><span>개입하지</span><span> </span><span>않습니다</span><span>. </span
  ><span>다만</span><span>, "</span><span>운영정책</span><span>" </span
  ><span>을</span><span> </span><span>위반하는</span><span> </span
  ><span>내용이나</span><span> </span><span>정상적인</span><span> </span
  ><span>서비스운영이</span><span> </span><span>어렵다고</span
  ><span> </span><span>판단되는</span><span> </span><span>경우에는</span
  ><span> </span><span>중립적인</span><span> </span><span>입장에서</span
  ><span> </span><span>사안에</span><span> </span><span>대해</span
  ><span> </span><span>검토한</span><span> </span><span>후</span
  ><span>, </span><span>필요한</span><span> </span><span>조치를</span
  ><span> </span><span>행할</span><span> </span><span>수있습니다</span
  ><span>.</span>
</p>
<p
  style="
    margin-top: 14pt;
    margin-bottom: 14pt;
    line-height: normal;
    widows: 2;
    orphans: 2;
  "
>
  <span>3)</span><span>운영진은</span><span> </span><span>이용약관</span
  ><span>, </span><span>개인정보취급</span><span>(</span><span>처리</span
  ><span>)</span><span>방침및</span><span> </span><span>이</span
  ><span> </span><span>"</span><span>운영정책</span><span>"</span
  ><span>을</span><span> </span><span>준수합니다</span><span>.</span>
</p>
<p
  style="
    margin-top: 14pt;
    margin-bottom: 14pt;
    line-height: normal;
    widows: 2;
    orphans: 2;
  "
>
  <span>4)</span><span>운영진은</span><span> </span><span>회원의</span
  ><span> </span><span>개인정보</span><span>(</span><span>신상정보</span
  ><span>, </span><span>비밀번호</span><span> </span><span>등</span
  ><span>)</span><span>를요구하지</span><span> </span><span>않으며</span
  ><span>, </span><span>회원의</span><span> </span><span>개인정보를</span
  ><span> </span><span>절대</span><span> </span><span>임의로</span
  ><span> </span><span>수정하거나</span><span> </span><span>유출하지</span
  ><span> </span><span>않습니다</span><span>. </span><span>단</span
  ><span>, </span><span>사법기관의</span><span> </span><span>정식</span
  ><span> </span><span>협조요청이</span><span> </span><span>있을</span
  ><span> </span><span>시에는</span><span> </span><span>해당</span
  ><span> </span><span>기관에</span><span> </span><span>제공할수</span
  ><span> </span><span>있습니다</span><span>.</span>
</p>
<p
  style="
    margin-top: 14pt;
    margin-bottom: 14pt;
    line-height: normal;
    widows: 2;
    orphans: 2;
  "
>
  <span>5)</span><span>운영진은</span><span> </span><span>회원</span
  ><span> </span><span>여러분의</span><span> </span><span>문의</span
  ><span> </span><span>및</span><span> </span><span>요청</span
  ><span> </span><span>사항에최대한</span><span> </span
  ><span>친절하고</span><span> </span><span>신속하게</span><span> </span
  ><span>응대합니다</span><span>. </span><span>단</span><span>, </span
  ><span>공개적으로</span><span> </span><span>알려진게임</span
  ><span> </span><span>내</span><span> </span><span>정보</span
  ><span> </span><span>외</span><span> </span><span>추후</span
  ><span> </span><span>업데이트에</span><span> </span><span>대한</span
  ><span> </span><span>사항</span><span>, </span><span>게임</span
  ><span> </span><span>특성상</span><span> </span><span>공개가</span
  ><span> </span><span>불가능한</span><span> </span><span>내용에</span
  ><span> </span><span>대해서는</span><span> </span><span>제한적인</span
  ><span>&#xa0;</span><span>답변을</span><span> </span
  ><span>드리거나</span><span>, </span><span>답변을</span><span> </span
  ><span>드리지</span><span> </span><span>않을</span><span> </span
  ><span>수</span><span> </span><span>있습니다</span><span>.</span>
</p>
<p
  style="
    margin-top: 14pt;
    margin-bottom: 14pt;
    line-height: normal;
    widows: 2;
    orphans: 2;
  "
>
  <span>6)</span><span>운영진은</span><span> </span><span>회원</span
  ><span> </span><span>여러분으로부터</span><span> </span><span>게임</span
  ><span> </span><span>내</span><span> </span><span>발생할</span
  ><span> </span><span>수</span><span> </span><span>있는</span
  ><span> </span><span>모든</span><span> </span><span>형태의</span
  ><span> </span><span>버그를</span><span> </span><span>제보</span
  ><span> </span><span>받으며</span><span>, </span><span>이를</span
  ><span> </span><span>확인하고</span><span> </span><span>수정할</span
  ><span> </span><span>의무를</span><span> </span><span>가집니다</span
  ><span>. </span><span>게임</span><span> </span><span>내</span
  ><span> </span><span>다양한</span><span> </span><span>환경</span
  ><span>/</span><span>제반</span><span> </span><span>사항으로</span
  ><span> </span><span>인해</span><span> </span><span>버그</span
  ><span> </span><span>수정이</span><span> </span><span>지연될</span
  ><span> </span><span>경우</span><span>, </span><span>운영진은</span
  ><span> </span><span>회원에게</span><span> </span><span>공지</span
  ><span> </span><span>혹은</span><span>1:1</span><span>문의</span
  ><span> </span><span>답변을</span><span> </span><span>통해</span
  ><span> </span><span>안내할</span><span> </span><span>수</span
  ><span> </span><span>있도록</span><span> </span><span>최선을</span
  ><span> </span><span>다합니다</span><span>.</span>
</p>
<p
  style="
    margin-top: 14pt;
    margin-bottom: 14pt;
    line-height: normal;
    widows: 2;
    orphans: 2;
  "
>
  <span>7)</span><span>운영진은</span><span> </span><span>이용약관</span
  ><span>, </span><span>이</span><span> </span><span>"</span
  ><span>운영정책</span><span>"</span><span>을</span><span>&#xa0;</span
  ><span>위반한</span><span> </span><span>회원</span><span> </span
  ><span>또는</span><span> </span><span>복수의</span><span> </span
  ><span>회원에</span><span> </span><span>대해</span><span> </span
  ><span>약관</span><span> </span><span>및</span><span> </span
  ><span>"</span><span>운영정책</span><span>"</span><span>에정해진</span
  ><span> </span><span>각</span><span> </span><span>종</span><span> </span
  ><span>제한</span><span> </span><span>조치를</span><span> </span
  ><span>적용할</span><span> </span><span>수</span><span> </span
  ><span>있습니다</span><span>.</span>
</p>
<p
  style="
    margin-top: 14pt;
    margin-bottom: 14pt;
    line-height: normal;
    widows: 2;
    orphans: 2;
  "
>
  <span>8)</span><span>운영진은</span><span> </span><span>게임</span
  ><span> </span><span>서비스</span><span> </span><span>내</span
  ><span>/</span><span>외적으로</span><span> </span><span>비정상적인</span
  ><span> </span><span>현상이</span><span> </span><span>발생할</span
  ><span> </span><span>경우</span><span> </span><span>서비스의</span
  ><span> </span><span>일부</span><span> </span><span>혹은</span
  ><span> </span><span>전부를</span><span> </span><span>일시적으로</span
  ><span> </span><span>중단하거나</span><span>, </span><span>접근을</span
  ><span> </span><span>제한할</span><span> </span><span>수</span
  ><span> </span><span>있습니다</span><span>.</span>
</p>
<p
  style="
    margin-top: 14pt;
    margin-bottom: 14pt;
    line-height: normal;
    widows: 2;
    orphans: 2;
  "
>
  <span>9)</span><span>운영진은</span><span> </span><span>건전한</span
  ><span> </span><span>게임문화</span><span> </span><span>정착</span
  ><span>, </span><span>유해정보로부터의</span><span> </span
  ><span>청소년</span><span> </span><span>회원</span><span> </span
  ><span>보호</span><span>, </span><span>명예훼손</span><span> </span
  ><span>등</span><span> </span><span>특정</span><span> </span
  ><span>회원의</span><span> </span><span>권리침해방지를</span
  ><span> </span><span>위하여</span><span> </span><span>관련</span
  ><span> </span><span>법령</span><span> </span><span>및</span
  ><span> </span><span>약관</span><span>, "</span><span>운영정책</span
  ><span>"</span><span>에의거</span><span> </span><span>회원이</span
  ><span> </span><span>작성한</span><span> </span><span>게시물을</span
  ><span> </span><span>사전</span><span> </span><span>통보</span
  ><span> </span><span>없이</span><span> </span><span>편집</span
  ><span>, </span><span>이동</span><span>, </span><span>삭제할수</span
  ><span> </span><span>있으며</span><span>, </span><span>경우에</span
  ><span> </span><span>따라</span><span> </span><span>서비스</span
  ><span> </span><span>이용</span><span> </span><span>또한</span
  ><span> </span><span>제한할</span><span> </span><span>수</span
  ><span> </span><span>있습니다</span><span>.</span>
</p>
<p
  style="
    margin-top: 14pt;
    margin-bottom: 14pt;
    line-height: normal;
    widows: 2;
    orphans: 2;
  "
>
  <span>7.</span><span>비</span><span> </span><span>매너</span
  ><span> </span><span>행위</span><span> </span><span>관리</span
  ><span> </span><span>기준</span>
</p>
<p
  style="
    margin-top: 14pt;
    margin-bottom: 14pt;
    line-height: normal;
    widows: 2;
    orphans: 2;
  "
>
  <span>1)"</span><span>회사</span><span>"</span><span>는회원</span
  ><span> </span><span>여러분이</span><span> </span><span>시스템</span
  ><span> </span><span>버그</span><span> </span><span>등을</span
  ><span> </span><span>악용하거나</span><span> </span><span>다른</span
  ><span> </span><span>회원과</span><span> </span><span>해당</span
  ><span> </span><span>내용을</span><span> </span><span>공유하는</span
  ><span> </span><span>것을</span><span> </span><span>금지합니다</span
  ><span>. </span><span>버그악용의</span><span> </span><span>경우</span
  ><span> </span><span>게임</span><span> </span><span>콘텐츠</span
  ><span> </span><span>및</span><span> </span><span>정상적인</span
  ><span> </span><span>게임진행</span><span> </span><span>등을</span
  ><span> </span><span>방해하는</span><span> </span><span>행위이기</span
  ><span> </span><span>때문입니다</span><span>.</span>
</p>
<p
  style="
    margin-top: 14pt;
    margin-bottom: 14pt;
    line-height: normal;
    widows: 2;
    orphans: 2;
  "
>
  <span>2)</span><span>시스템</span><span> </span><span>버그</span
  ><span> </span><span>등을</span><span> </span><span>악용하는</span
  ><span> </span><span>것은</span><span> </span><span>다른</span
  ><span> </span><span>회원여러분과의</span><span> </span
  ><span>형평성에</span><span> </span><span>어긋나는</span><span> </span
  ><span>행위이기</span><span> </span><span>때문에</span><span> </span
  ><span>시스템</span><span> </span><span>버그나</span><span> </span
  ><span>문제점을</span><span> </span><span>악용</span><span>, </span
  ><span>공유할</span><span> </span><span>경우</span><span> </span
  ><span>사전</span><span> </span><span>안내</span><span> </span
  ><span>없이게임</span><span> </span><span>이용이</span><span> </span
  ><span>제한되거나</span><span> </span><span>회원</span><span> </span
  ><span>자격이</span><span> </span><span>정지될</span><span> </span
  ><span>수</span><span> </span><span>있으니</span><span> </span
  ><span>각별한</span><span> </span><span>주의를</span><span> </span
  ><span>당부</span><span> </span><span>드립니다</span><span>.</span>
</p>
<p
  style="
    margin-top: 14pt;
    margin-bottom: 14pt;
    line-height: normal;
    widows: 2;
    orphans: 2;
  "
>
  <span>3)</span><span>게임</span><span> </span><span>내</span
  ><span> </span><span>커뮤니티</span><span> </span><span>및</span
  ><span> </span><span>"</span><span>회사</span><span>"</span
  ><span>가</span><span> </span><span>공식적으로</span><span> </span
  ><span>인정한</span><span> </span><span>커뮤니티에서</span><span> </span
  ><span>공공의안녕</span><span> </span><span>및</span><span> </span
  ><span>미풍양속을</span><span> </span><span>저해하는</span><span> </span
  ><span>행위는</span><span> </span><span>다른</span><span> </span
  ><span>고객에게</span><span> </span><span>커다란</span><span> </span
  ><span>피해를</span><span> </span><span>입힐</span><span> </span
  ><span>우려가</span><span> </span><span>있기</span><span> </span
  ><span>때문에</span><span> </span><span>다음과</span><span> </span
  ><span>같은</span><span> </span><span>행위</span><span> </span
  ><span>및</span><span> </span><span>게시물을</span><span> </span
  ><span>등록할</span><span> </span><span>경우</span><span> </span
  ><span>게시물의</span><span> </span><span>게시자및</span><span> </span
  ><span>비매너</span><span> </span><span>행위자에</span><span> </span
  ><span>대해서</span><span> </span><span>고객</span><span> </span
  ><span>권한</span><span> </span><span>정지</span><span> </span
  ><span>등을</span><span> </span><span>취할</span><span> </span
  ><span>수</span><span> </span><span>있습니다</span><span>.</span
  ><span> </span><span>①</span><span> </span><span>영리를</span
  ><span> </span><span>목적으로</span><span> </span><span>하거나</span
  ><span> </span><span>광고</span><span> </span><span>또는</span
  ><span> </span><span>광고와</span><span> </span><span>유사하다고</span
  ><span> </span><span>판단되는</span><span> </span><span>내용인</span
  ><span> </span><span>경우</span><span> </span><span>②</span
  ><span> </span><span>현금</span><span> </span><span>거래</span
  ><span> </span><span>및</span><span> </span><span>계정</span
  ><span> </span><span>거래</span><span>, </span><span>서버간</span
  ><span> </span><span>거래에</span><span> </span><span>관련한</span
  ><span> </span><span>시도</span><span> </span><span>또는</span
  ><span> </span><span>타</span><span> </span><span>회원들을</span
  ><span> </span><span>선동하려는</span><span> </span><span>경우</span
  ><span> </span><span>③</span><span> </span><span>회사</span
  ><span>, </span><span>다른</span><span> </span><span>회원</span
  ><span> </span><span>또는</span><span> </span><span>제</span
  ><span> </span><span>3</span><span>자에게</span><span> </span
  ><span>심한모욕을</span><span> </span><span>주거나</span><span> </span
  ><span>중상모략으로</span><span> </span><span>명예를</span><span> </span
  ><span>손상시키는</span><span> </span><span>내용인</span><span> </span
  ><span>경우</span><span> </span><span>④</span><span> </span
  ><span>청소년</span><span> </span><span>보호법에</span><span> </span
  ><span>위반되는</span><span> </span><span>내용의</span><span> </span
  ><span>정보</span><span>, </span><span>문장</span><span>, </span
  ><span>도형등을</span><span> </span><span>게시하거나</span><span> </span
  ><span>링크시키는</span><span> </span><span>경우</span><span> </span
  ><span>⑤</span><span> </span><span>불법</span><span> </span
  ><span>복제</span><span> </span><span>또는</span><span> </span
  ><span>해킹을</span><span> </span><span>조장하는</span><span> </span
  ><span>내용인</span><span> </span><span>경우</span><span> </span
  ><span>⑥</span><span> </span><span>범죄와</span><span> </span
  ><span>결부된다고</span><span> </span><span>객관적으로</span
  ><span> </span><span>인정되는</span><span> </span><span>내용일</span
  ><span> </span><span>경우</span><span> </span><span>⑦</span
  ><span> </span><span>다른</span><span> </span><span>이용자</span
  ><span> </span><span>또는</span><span> </span><span>제</span
  ><span> </span><span>3</span><span>의</span><span> </span
  ><span>저작권</span><span> </span><span>등</span><span> </span
  ><span>기타</span><span> </span><span>권리를</span><span> </span
  ><span>침해하는</span><span> </span><span>내용일</span><span> </span
  ><span>경우</span><span> </span><span>⑧</span><span> </span
  ><span>회사에서</span><span> </span><span>규정한</span><span> </span
  ><span>게시물</span><span> </span><span>원칙에서</span><span> </span
  ><span>벗어나거나</span><span>, </span><span>게시판</span><span> </span
  ><span>성격에</span><span> </span><span>부합하지</span><span> </span
  ><span>않을</span><span> </span><span>경우</span><span> </span
  ><span>⑨</span><span> </span><span>허위</span><span> </span
  ><span>사실을</span><span> </span><span>유포하거나</span><span> </span
  ><span>다수의</span><span> </span><span>고객에게</span><span> </span
  ><span>오해를</span><span> </span><span>불러</span><span> </span
  ><span>일으킬</span><span> </span><span>수</span><span> </span
  ><span>있는</span><span> </span><span>경우</span><span> </span
  ><span>⑩</span><span> </span><span>도배</span><span> </span
  ><span>또는</span><span> </span><span>욕설</span><span>, </span
  ><span>음란한</span><span> </span><span>단어</span><span> </span
  ><span>및</span><span> </span><span>표현이</span><span> </span
  ><span>포함된</span><span> </span><span>내용일</span><span> </span
  ><span>경우</span><span> </span><span>⑪</span><span> </span
  ><span>운영진</span><span> </span><span>및</span><span> </span
  ><span>회사</span><span> </span><span>임직원을</span><span> </span
  ><span>사칭할</span><span> </span><span>경우</span><span> </span
  ><span>⑫</span><span> </span><span>약관</span><span> </span
  ><span>및</span><span> </span><span>기타</span><span> </span
  ><span>관계</span><span> </span><span>법령에</span><span> </span
  ><span>위배되는</span><span> </span><span>내용일</span><span> </span
  ><span>경우</span>
</p>
<p
  style="
    margin-top: 14pt;
    margin-bottom: 14pt;
    line-height: normal;
    widows: 2;
    orphans: 2;
  "
>
  <span>4)</span><span>사기</span><span>(</span><span>상대방을속여</span
  ><span> </span><span>게임</span><span> </span><span>내</span
  ><span> </span><span>부당한</span><span> </span><span>이득을</span
  ><span> </span><span>취하려는</span><span> </span><span>모든</span
  ><span> </span><span>행위</span><span>)</span><span>를</span
  ><span> </span><span>행할</span><span> </span><span>경우</span
  ><span>, </span><span>다른고객에게</span><span> </span><span>큰</span
  ><span> </span><span>피해를</span><span> </span><span>입히는</span
  ><span> </span><span>행위이기</span><span> </span><span>때문에</span
  ><span> </span><span>운영정책에</span><span> </span><span>따른</span
  ><span> </span><span>여러</span><span> </span><span>제한과</span
  ><span> </span><span>관계</span><span> </span><span>법령에</span
  ><span> </span><span>따른</span><span> </span><span>처벌을</span
  ><span> </span><span>받을</span><span> </span><span>수</span
  ><span> </span><span>있습니다</span><span>.</span>
</p>
<p
  style="
    margin-top: 14pt;
    margin-bottom: 14pt;
    line-height: normal;
    widows: 2;
    orphans: 2;
  "
>
  <span>8.</span><span>서비스의</span><span> </span><span>변경</span>
</p>
<p
  style="
    margin-top: 14pt;
    margin-bottom: 14pt;
    line-height: normal;
    widows: 2;
    orphans: 2;
  "
>
  <span>1)"</span><span>회사</span><span>"</span><span>는새로운</span
  ><span> </span><span>게임</span><span> </span><span>내용</span
  ><span>, </span><span>각종</span><span> </span><span>버그</span
  ><span> </span><span>패치</span><span> </span><span>등</span
  ><span> </span><span>서비스의</span><span> </span><span>운영상</span
  ><span>, </span><span>기술상필요한</span><span> </span
  ><span>경우에</span><span> </span><span>서비스의</span><span> </span
  ><span>전부</span><span> </span><span>또는</span><span> </span
  ><span>일부를</span><span> </span><span>사전</span><span> </span
  ><span>공지</span><span> </span><span>후</span><span> </span
  ><span>수정할</span><span> </span><span>수</span><span> </span
  ><span>있습니다</span><span>. </span><span>단</span><span>, </span
  ><span>기간통신망의</span><span> </span><span>장애</span><span> </span
  ><span>등</span><span> </span><span>사전에</span><span> </span
  ><span>공지할</span><span> </span><span>수</span><span> </span
  ><span>없는</span><span> </span><span>부득이한</span><span> </span
  ><span>사유가</span><span> </span><span>있는</span><span> </span
  ><span>경우에는</span><span> </span><span>사후</span><span> </span
  ><span>공지할</span><span> </span><span>수도</span><span> </span
  ><span>있습니다</span><span>.</span>
</p>
<p
  style="
    margin-top: 14pt;
    margin-bottom: 14pt;
    line-height: normal;
    widows: 2;
    orphans: 2;
  "
>
  <span>2)"</span><span>회원</span><span>"</span><span>여러분께서는</span
  ><span> </span><span>서비스의</span><span> </span><span>변경</span
  ><span> </span><span>등으로</span><span> </span><span>인해</span
  ><span> </span><span>유료서비스</span><span> </span><span>이용이</span
  ><span> </span><span>불가함으로</span><span> </span><span>받은</span
  ><span> </span><span>손해</span><span> </span><span>외에</span
  ><span> </span><span>별도의</span><span> </span><span>손해</span
  ><span> </span><span>배상을</span><span> </span><span>청구할</span
  ><span> </span><span>수</span><span> </span><span>없습니다</span
  ><span>. </span><span>특히</span><span> </span><span>서비스</span
  ><span> </span><span>이용에</span><span> </span><span>따른</span
  ><span> </span><span>기대수익</span><span>, </span><span>회사가</span
  ><span> </span><span>직접</span><span> </span><span>제공하지</span
  ><span> </span><span>않은</span><span> </span><span>혜택의상실로</span
  ><span> </span><span>인한</span><span> </span><span>피해에</span
  ><span> </span><span>대해</span><span> </span><span>"</span
  ><span>회사</span><span>"</span><span>는</span><span> </span
  ><span>책임질의무를</span><span> </span><span>지지</span><span> </span
  ><span>않습니다</span><span>.</span>
</p>
<p
  style="
    margin-top: 14pt;
    margin-bottom: 14pt;
    line-height: normal;
    widows: 2;
    orphans: 2;
  "
>
  <span>9.</span><span>고객지원</span>
</p>
<p
  style="
    margin-top: 14pt;
    margin-bottom: 14pt;
    line-height: normal;
    widows: 2;
    orphans: 2;
  "
>
  <span>서비스</span><span> </span><span>및</span><span> </span
  ><span>게임과</span><span> </span><span>관련된</span><span> </span
  ><span>문의는</span><span> </span><span>게임</span><span> </span
  ><span>내</span><span> </span><span>고객센터</span><span> </span
  ><span>등의</span><span> </span><span>공식적인</span><span> </span
  ><span>경로를</span><span> </span><span>통한</span><span> </span
  ><span>문의</span><span> </span><span>접수에</span><span> </span
  ><span>대해서만</span><span> </span><span>처리됩니다</span>
</p>
<p
  style="
    margin-top: 14pt;
    margin-bottom: 14pt;
    line-height: normal;
    widows: 2;
    orphans: 2;
  "
>
  <span>10.</span><span>게임</span><span> </span><span>이용제한</span
  ><span> </span><span>기준</span>
</p>
<p
  style="
    margin-top: 14pt;
    margin-bottom: 14pt;
    line-height: normal;
    widows: 2;
    orphans: 2;
  "
>
  <span>게임</span><span> </span><span>이용제한</span><span> </span
  ><span>기준은</span><span> </span><span>"</span><span>서비스</span
  ><span>"</span><span>을</span><span> </span><span>이용하면서</span
  ><span> </span><span>회원</span><span> </span><span>여러분이</span
  ><span> </span><span>원활한</span><span> </span><span>플레이를</span
  ><span> </span><span>하실</span><span> </span><span>수</span
  ><span> </span><span>있도록</span><span> </span><span>게임</span
  ><span> </span><span>진행</span><span> </span><span>방해</span
  ><span> </span><span>또는</span><span> </span><span>미풍양속을</span
  ><span> </span><span>저해하는행위</span><span> </span
  ><span>등으로부터</span><span> </span><span>보호하기</span><span> </span
  ><span>위해</span><span> </span><span>수립되었습니다</span><span>.</span
  ><span> </span><span>회원</span><span> </span><span>여러분이</span
  ><span> </span><span>"</span><span>운영정책</span><span>"</span
  ><span>에</span><span> </span><span>명시된</span><span> </span
  ><span>이용제한</span><span> </span><span>기준을</span><span> </span
  ><span>위반하는</span><span> </span><span>경우</span><span> </span
  ><span>사전</span><span> </span><span>안내</span><span> </span
  ><span>없이</span><span> </span><span>이용에</span><span> </span
  ><span>제한을</span><span> </span><span>받으실</span><span> </span
  ><span>수</span><span> </span><span>있습니다</span><span>.</span
  ><span> </span><span>이용제한</span><span> </span><span>조치를</span
  ><span> </span><span>받으신</span><span> </span><span>경우</span
  ><span> </span><span>아래와</span><span> </span><span>같은</span
  ><span> </span><span>절차에</span><span> </span><span>따라</span
  ><span> </span><span>이의</span><span> </span><span>신청을</span
  ><span> </span><span>하실</span><span> </span><span>수</span
  ><span> </span><span>있습니다</span><span>.</span>
</p>
<p
  style="
    margin-top: 14pt;
    margin-bottom: 14pt;
    line-height: normal;
    widows: 2;
    orphans: 2;
  "
>
  <span>①</span><span> </span><span>게임</span><span> </span
  ><span>내</span><span> </span><span>[</span><span>고객센터</span
  ><span>]&gt; [1:1 </span><span>문의</span><span>]</span><span>를</span
  ><span> </span><span>통해서</span><span> </span><span>이의</span
  ><span> </span><span>신청을</span><span> </span><span>하실</span
  ><span> </span><span>수</span><span> </span><span>있습니다</span
  ><span>.</span><span> </span><span>②</span><span> </span
  ><span>이의</span><span> </span><span>신청은</span><span> </span
  ><span>이용제한</span><span> </span><span>적용일로부터</span
  ><span> </span><span>7</span><span>일</span><span> </span
  ><span>이내에만</span><span> </span><span>접수할</span><span> </span
  ><span>수</span><span> </span><span>있습니다</span><span>.</span
  ><span> </span><span>③</span><span> </span><span>이의</span
  ><span> </span><span>신청은</span><span> </span><span>접수일로부터</span
  ><span> </span><span>최대</span><span> </span><span>7</span
  ><span>일</span><span> </span><span>내에</span><span> </span
  ><span>처리됩니다</span><span>.</span><span> </span><span>게임</span
  ><span> </span><span>이용제한</span><span> </span><span>기준은</span
  ><span> </span><span>다음과</span><span> </span><span>같습니다</span
  ><span>.</span>
</p>
<p
  style="
    margin-top: 14pt;
    margin-bottom: 14pt;
    line-height: normal;
    widows: 2;
    orphans: 2;
  "
>
  <span>게임</span><span> </span><span>이용제한</span><span> </span
  ><span>기준은</span><span> </span><span>다음과</span><span> </span
  ><span>같습니다</span><span>.</span>
</p>
<table
  cellspacing="0"
  cellpadding="0"
  style="
    width: 100%;
    margin-bottom: 0pt;
    border: 1.5pt solid #000000;
    border-collapse: collapse;
  "
>
  <tr style="height: 40.5pt">
    <td
      style="
        width: 25.04%;
        border-right-style: solid;
        border-right-width: 1.5pt;
        border-bottom-style: solid;
        border-bottom-width: 1.5pt;
        padding-top: 0.75pt;
        padding-bottom: 0.75pt;
        vertical-align: middle;
        -aw-padding-bottom: 0.75pt;
        -aw-padding-left: 0.75pt;
        -aw-padding-right: 0.75pt;
        -aw-padding-top: 0.75pt;
      "
      class="td-title"
    >
      <p
        style="
          margin-bottom: 0pt;
          text-align: center;
          widows: 2;
          orphans: 2;
        "
      >
        <span style="font-weight: bold">유형</span>
      </p>
    </td>
    <td
      style="
        width: 25.32%;
        border-right-style: solid;
        border-right-width: 1.5pt;
        border-bottom-style: solid;
        border-bottom-width: 1.5pt;
        padding-top: 0.75pt;
        padding-left: 0.75pt;
        padding-bottom: 0.75pt;
        vertical-align: middle;
        -aw-padding-bottom: 0.75pt;
        -aw-padding-right: 0.75pt;
        -aw-padding-top: 0.75pt;
      "
      class="td-title"
    >
      <p
        style="
          margin-bottom: 0pt;
          text-align: center;
          widows: 2;
          orphans: 2;
        "
      >
        <span style="font-weight: bold">상세설명</span>
      </p>
    </td>
    <td
      style="
        width: 8.34%;
        border-right-style: solid;
        border-right-width: 1.5pt;
        border-bottom-style: solid;
        border-bottom-width: 1.5pt;
        padding-top: 0.75pt;
        padding-left: 0.75pt;
        padding-bottom: 0.75pt;
        vertical-align: middle;
        -aw-padding-bottom: 0.75pt;
        -aw-padding-right: 0.75pt;
        -aw-padding-top: 0.75pt;
      "
      class="td-title"
    >
      <p
        style="
          margin-bottom: 0pt;
          text-align: center;
          widows: 2;
          orphans: 2;
        "
      >
        <span style="font-weight: bold">1</span
        ><span style="font-weight: bold">차</span>
      </p>
    </td>
    <td
      style="
        width: 10.18%;
        border-right-style: solid;
        border-right-width: 1.5pt;
        border-bottom-style: solid;
        border-bottom-width: 1.5pt;
        padding-top: 0.75pt;
        padding-left: 0.75pt;
        padding-bottom: 0.75pt;
        vertical-align: middle;
        -aw-padding-bottom: 0.75pt;
        -aw-padding-right: 0.75pt;
        -aw-padding-top: 0.75pt;
      "
      class="td-title"
    >
      <p
        style="
          margin-bottom: 0pt;
          text-align: center;
          widows: 2;
          orphans: 2;
        "
      >
        <span style="font-weight: bold">2</span
        ><span style="font-weight: bold">차</span>
      </p>
    </td>
    <td
      style="
        width: 10.18%;
        border-right-style: solid;
        border-right-width: 1.5pt;
        border-bottom-style: solid;
        border-bottom-width: 1.5pt;
        padding-top: 0.75pt;
        padding-left: 0.75pt;
        padding-bottom: 0.75pt;
        vertical-align: middle;
        -aw-padding-bottom: 0.75pt;
        -aw-padding-right: 0.75pt;
        -aw-padding-top: 0.75pt;
      "
      class="td-title"
    >
      <p
        style="
          margin-bottom: 0pt;
          text-align: center;
          widows: 2;
          orphans: 2;
        "
      >
        <span style="font-weight: bold">3</span
        ><span style="font-weight: bold">차</span>
      </p>
    </td>
    <td
      style="
        width: 10.18%;
        border-right-style: solid;
        border-right-width: 1.5pt;
        border-bottom-style: solid;
        border-bottom-width: 1.5pt;
        padding-top: 0.75pt;
        padding-left: 0.75pt;
        padding-bottom: 0.75pt;
        vertical-align: middle;
        -aw-padding-bottom: 0.75pt;
        -aw-padding-right: 0.75pt;
        -aw-padding-top: 0.75pt;
      "
      class="td-title"
    >
      <p
        style="
          margin-bottom: 0pt;
          text-align: center;
          widows: 2;
          orphans: 2;
        "
      >
        <span style="font-weight: bold">4</span
        ><span style="font-weight: bold">차</span>
      </p>
    </td>
    <td
      style="
        width: 10.78%;
        border-bottom-style: solid;
        border-bottom-width: 1.5pt;
        padding-top: 0.75pt;
        padding-left: 0.75pt;
        padding-bottom: 0.75pt;
        vertical-align: middle;
        -aw-padding-bottom: 0.75pt;
        -aw-padding-right: 0.75pt;
        -aw-padding-top: 0.75pt;
      "
      class="td-title"
    >
      <p
        style="
          margin-bottom: 0pt;
          text-align: center;
          widows: 2;
          orphans: 2;
        "
      >
        <span style="font-weight: bold">5</span
        ><span style="font-weight: bold">차</span>
      </p>
    </td>
  </tr>
  <tr style="height: 225pt">
    <td
      rowspan="4"
      style="
        width: 25.04%;
        border-right-style: solid;
        border-right-width: 1.5pt;
        border-bottom-style: solid;
        border-bottom-width: 1.5pt;
        padding-top: 0.75pt;
        padding-bottom: 0.75pt;
        vertical-align: middle;
        -aw-padding-bottom: 0.75pt;
        -aw-padding-left: 0.75pt;
        -aw-padding-right: 0.75pt;
      "
    >
      <p
        style="
          margin-right: 6pt;
          margin-left: 6pt;
          margin-bottom: 0pt;
          text-align: center;
          widows: 2;
          orphans: 2;
        "
      >
        <span>배매너행위</span>
      </p>
    </td>
    <td
      style="
        width: 25.32%;
        border-right-style: solid;
        border-right-width: 1.5pt;
        border-bottom-style: solid;
        border-bottom-width: 1.5pt;
        padding-top: 0.75pt;
        padding-left: 0.75pt;
        padding-bottom: 0.75pt;
        vertical-align: middle;
        -aw-padding-bottom: 0.75pt;
        -aw-padding-right: 0.75pt;
      "
    >
      <p
        style="
          margin-bottom: 0pt;
          text-align: center;
          widows: 2;
          orphans: 2;
        "
      >
        <span>다른회원의</span><span> </span><span>원활한</span
        ><span> </span><span>게임</span><span> </span><span>서비스</span
        ><span> </span><span>이요을</span><span> </span
        ><span>방해하는</span><span> </span><span>해위</span
        ><span>, </span><span>다수의</span><span> </span
        ><span>고객에게</span><span> </span><span>피해를</span
        ><span> </span><span>입히는</span><span> </span><span>행위</span
        ><span>, </span><span>특정</span><span> </span><span>다른</span
        ><span> </span><span>고객의</span><span> </span
        ><span>플레이를</span><span> </span><span>지속적으로</span
        ><span> </span><span>방해하거나</span><span> </span
        ><span>이와</span><span> </span><span>유사한</span><span> </span
        ><span>행위를</span><span> </span><span>범하는</span><span> </span
        ><span>경우</span><span>.</span>
      </p>
    </td>
    <td
      style="
        width: 8.34%;
        border-right-style: solid;
        border-right-width: 1.5pt;
        border-bottom-style: solid;
        border-bottom-width: 1.5pt;
        padding-top: 0.75pt;
        padding-left: 0.75pt;
        padding-bottom: 0.75pt;
        vertical-align: middle;
        -aw-padding-bottom: 0.75pt;
        -aw-padding-right: 0.75pt;
      "
    >
      <p
        style="
          margin-right: 6pt;
          margin-left: 6pt;
          margin-bottom: 0pt;
          text-align: center;
          widows: 2;
          orphans: 2;
        "
      >
        <span>경고</span>
      </p>
    </td>
    <td
      style="
        width: 10.18%;
        border-right-style: solid;
        border-right-width: 1.5pt;
        border-bottom-style: solid;
        border-bottom-width: 1.5pt;
        padding-top: 0.75pt;
        padding-left: 0.75pt;
        padding-bottom: 0.75pt;
        vertical-align: middle;
        -aw-padding-bottom: 0.75pt;
        -aw-padding-right: 0.75pt;
      "
    >
      <p
        style="
          margin-bottom: 0pt;
          text-align: center;
          widows: 2;
          orphans: 2;
        "
      >
        <span>1</span><span>일정지</span>
      </p>
    </td>
    <td
      style="
        width: 10.18%;
        border-right-style: solid;
        border-right-width: 1.5pt;
        border-bottom-style: solid;
        border-bottom-width: 1.5pt;
        padding-top: 0.75pt;
        padding-left: 0.75pt;
        padding-bottom: 0.75pt;
        vertical-align: middle;
        -aw-padding-bottom: 0.75pt;
        -aw-padding-right: 0.75pt;
      "
    >
      <p
        style="
          margin-bottom: 0pt;
          text-align: center;
          widows: 2;
          orphans: 2;
        "
      >
        <span>3</span><span>일정지</span>
      </p>
    </td>
    <td
      style="
        width: 10.18%;
        border-right-style: solid;
        border-right-width: 1.5pt;
        border-bottom-style: solid;
        border-bottom-width: 1.5pt;
        padding-top: 0.75pt;
        padding-left: 0.75pt;
        padding-bottom: 0.75pt;
        vertical-align: middle;
        -aw-padding-bottom: 0.75pt;
        -aw-padding-right: 0.75pt;
      "
    >
      <p
        style="
          margin-bottom: 0pt;
          text-align: center;
          widows: 2;
          orphans: 2;
        "
      >
        <span>5</span><span>일정지</span>
      </p>
    </td>
    <td
      style="
        width: 10.78%;
        border-bottom-style: solid;
        border-bottom-width: 1.5pt;
        padding-top: 0.75pt;
        padding-left: 0.75pt;
        padding-bottom: 0.75pt;
        vertical-align: middle;
        -aw-padding-bottom: 0.75pt;
        -aw-padding-right: 0.75pt;
      "
    >
      <p
        style="
          margin-bottom: 0pt;
          text-align: center;
          widows: 2;
          orphans: 2;
        "
      >
        <span>영구정지</span>
      </p>
    </td>
  </tr>
  <tr style="height: 159.75pt">
    <td
      rowspan="2"
      style="
        width: 25.32%;
        border-right-style: solid;
        border-right-width: 1.5pt;
        border-bottom-style: solid;
        border-bottom-width: 1.5pt;
        padding-top: 0.75pt;
        padding-left: 0.75pt;
        padding-bottom: 0.75pt;
        vertical-align: middle;
        -aw-padding-bottom: 0.75pt;
        -aw-padding-right: 0.75pt;
      "
    >
      <p
        style="
          margin-bottom: 0pt;
          text-align: center;
          widows: 2;
          orphans: 2;
        "
      >
        <span>게임내</span><span> </span><span>경제</span><span> </span
        ><span>시스템</span><span> </span><span>등</span><span> </span
        ><span>밸런스</span><span> </span><span>및</span><span> </span
        ><span>서비스</span><span> </span><span>전반에</span><span> </span
        ><span>문제를</span><span> </span><span>발생시킨</span
        ><span> </span><span>행위</span>
      </p>
    </td>
    <td
      rowspan="2"
      style="
        width: 8.34%;
        border-right-style: solid;
        border-right-width: 1.5pt;
        border-bottom-style: solid;
        border-bottom-width: 1.5pt;
        padding-top: 0.75pt;
        padding-left: 0.75pt;
        padding-bottom: 0.75pt;
        vertical-align: middle;
        -aw-padding-bottom: 0.75pt;
        -aw-padding-right: 0.75pt;
      "
    >
      <p
        style="
          margin-right: 6pt;
          margin-left: 6pt;
          margin-bottom: 0pt;
          text-align: center;
          widows: 2;
          orphans: 2;
        "
      >
        <span>경고</span>
      </p>
    </td>
    <td
      style="
        width: 10.18%;
        border-right-style: solid;
        border-right-width: 1.5pt;
        border-bottom-style: solid;
        border-bottom-width: 1.5pt;
        padding-top: 0.75pt;
        padding-left: 0.75pt;
        padding-bottom: 0.75pt;
        vertical-align: middle;
        -aw-padding-bottom: 0.75pt;
        -aw-padding-right: 0.75pt;
      "
    >
      <p
        style="
          margin-bottom: 0pt;
          text-align: center;
          widows: 2;
          orphans: 2;
        "
      >
        <span>1</span><span>일정지</span>
      </p>
    </td>
    <td
      style="
        width: 10.18%;
        border-right-style: solid;
        border-right-width: 1.5pt;
        border-bottom-style: solid;
        border-bottom-width: 1.5pt;
        padding-top: 0.75pt;
        padding-left: 0.75pt;
        padding-bottom: 0.75pt;
        vertical-align: middle;
        -aw-padding-bottom: 0.75pt;
        -aw-padding-right: 0.75pt;
      "
    >
      <p
        style="
          margin-bottom: 0pt;
          text-align: center;
          widows: 2;
          orphans: 2;
        "
      >
        <span>3</span><span>일정지</span>
      </p>
    </td>
    <td
      style="
        width: 10.18%;
        border-right-style: solid;
        border-right-width: 1.5pt;
        border-bottom-style: solid;
        border-bottom-width: 1.5pt;
        padding-top: 0.75pt;
        padding-left: 0.75pt;
        padding-bottom: 0.75pt;
        vertical-align: middle;
        -aw-padding-bottom: 0.75pt;
        -aw-padding-right: 0.75pt;
      "
    >
      <p
        style="
          margin-bottom: 0pt;
          text-align: center;
          widows: 2;
          orphans: 2;
        "
      >
        <span>5</span><span>일정지</span>
      </p>
    </td>
    <td
      style="
        width: 10.78%;
        border-bottom-style: solid;
        border-bottom-width: 1.5pt;
        padding-top: 0.75pt;
        padding-left: 0.75pt;
        padding-bottom: 0.75pt;
        vertical-align: middle;
        -aw-padding-bottom: 0.75pt;
        -aw-padding-right: 0.75pt;
      "
    >
      <p
        style="
          margin-bottom: 0pt;
          text-align: center;
          widows: 2;
          orphans: 2;
        "
      >
        <span>영구정지</span>
      </p>
    </td>
  </tr>
  <tr style="height: 76.5pt">
    <td
      colspan="4"
      style="
        border-bottom-style: solid;
        border-bottom-width: 1.5pt;
        padding-top: 0.75pt;
        padding-left: 0.75pt;
        padding-bottom: 0.75pt;
        vertical-align: middle;
        -aw-padding-bottom: 0.75pt;
        -aw-padding-right: 0.75pt;
      "
    >
      <p
        style="
          margin-bottom: 0pt;
          text-align: center;
          widows: 2;
          orphans: 2;
        "
      >
        <span>경중에</span><span> </span><span>따라</span><span> </span
        ><span>가중하여</span><span> </span><span>이용이</span
        ><span> </span><span>제한될</span><span> </span><span>수</span
        ><span> </span><span>있습니다</span><span>.</span>
      </p>
    </td>
  </tr>
  <tr style="height: 185.25pt">
    <td
      style="
        width: 25.32%;
        border-right-style: solid;
        border-right-width: 1.5pt;
        padding-top: 0.75pt;
        padding-left: 0.75pt;
        padding-bottom: 0.75pt;
        vertical-align: middle;
        -aw-padding-bottom: 0.75pt;
        -aw-padding-right: 0.75pt;
      "
    >
      <p
        style="
          margin-bottom: 0pt;
          text-align: center;
          widows: 2;
          orphans: 2;
        "
      >
        <span>도배</span><span>, </span><span>욕설</span><span>, </span
        ><span>성적</span><span> </span><span>표현</span><span>, </span
        ><span>친우</span><span> </span><span>대상</span><span> </span
        ><span>욕설</span><span>, </span><span>광고</span><span> </span
        ><span>등을</span><span> </span><span>통해</span><span> </span
        ><span>불쾌감을</span><span> </span><span>주는</span><span> </span
        ><span>행위</span>
      </p>
    </td>
    <td
      style="
        width: 8.34%;
        border-right-style: solid;
        border-right-width: 1.5pt;
        padding-top: 0.75pt;
        padding-left: 0.75pt;
        padding-bottom: 0.75pt;
        vertical-align: middle;
        -aw-padding-bottom: 0.75pt;
        -aw-padding-right: 0.75pt;
      "
    >
      <p
        style="
          margin-right: 6pt;
          margin-left: 6pt;
          margin-bottom: 0pt;
          text-align: center;
          widows: 2;
          orphans: 2;
        "
      >
        <span>경고</span>
      </p>
    </td>
    <td
      style="
        width: 10.18%;
        border-right-style: solid;
        border-right-width: 1.5pt;
        padding-top: 0.75pt;
        padding-left: 0.75pt;
        padding-bottom: 0.75pt;
        vertical-align: middle;
        -aw-padding-bottom: 0.75pt;
        -aw-padding-right: 0.75pt;
      "
    >
      <p
        style="
          margin-bottom: 0pt;
          text-align: center;
          widows: 2;
          orphans: 2;
        "
      >
        <span>1</span><span>일정지</span>
      </p>
    </td>
    <td
      style="
        width: 10.18%;
        border-right-style: solid;
        border-right-width: 1.5pt;
        padding-top: 0.75pt;
        padding-left: 0.75pt;
        padding-bottom: 0.75pt;
        vertical-align: middle;
        -aw-padding-bottom: 0.75pt;
        -aw-padding-right: 0.75pt;
      "
    >
      <p
        style="
          margin-bottom: 0pt;
          text-align: center;
          widows: 2;
          orphans: 2;
        "
      >
        <span>3</span><span>일정지</span>
      </p>
    </td>
    <td
      style="
        width: 10.18%;
        border-right-style: solid;
        border-right-width: 1.5pt;
        padding-top: 0.75pt;
        padding-left: 0.75pt;
        padding-bottom: 0.75pt;
        vertical-align: middle;
        -aw-padding-bottom: 0.75pt;
        -aw-padding-right: 0.75pt;
      "
    >
      <p
        style="
          margin-bottom: 0pt;
          text-align: center;
          widows: 2;
          orphans: 2;
        "
      >
        <span>5</span><span>일정지</span>
      </p>
    </td>
    <td
      style="
        width: 10.78%;
        padding-top: 0.75pt;
        padding-left: 0.75pt;
        padding-bottom: 0.75pt;
        vertical-align: middle;
        -aw-padding-bottom: 0.75pt;
        -aw-padding-right: 0.75pt;
      "
    >
      <p
        style="
          margin-bottom: 0pt;
          text-align: center;
          widows: 2;
          orphans: 2;
        "
      >
        <span>영구정지</span>
      </p>
    </td>
  </tr>
</table>
<p
  style="
    margin-top: 14pt;
    margin-bottom: 14pt;
    text-align: justify;
    line-height: normal;
    widows: 2;
    orphans: 2;
  "
>
  <span>&#xa0;</span>
</p>
<table
  cellspacing="0"
  cellpadding="0"
  style="
    width: 100%;
    margin-bottom: 0pt;
    border: 1.5pt solid #000000;
    border-collapse: collapse;
  "
>
  <tr style="height: 40.5pt">
    <td
      style="
        width: 27.58%;
        border-right-style: solid;
        border-right-width: 1.5pt;
        border-bottom-style: solid;
        border-bottom-width: 1.5pt;
        padding-top: 0.75pt;
        padding-bottom: 0.75pt;
        vertical-align: middle;
        -aw-padding-bottom: 0.75pt;
        -aw-padding-left: 0.75pt;
        -aw-padding-right: 0.75pt;
        -aw-padding-top: 0.75pt;
      "
      class="td-title"
    >
      <p
        style="
          margin-bottom: 0pt;
          text-align: center;
          widows: 2;
          orphans: 2;
        "
      >
        <span style="font-weight: bold">유형</span>
      </p>
    </td>
    <td
      style="
        width: 10.52%;
        border-right-style: solid;
        border-right-width: 1.5pt;
        border-bottom-style: solid;
        border-bottom-width: 1.5pt;
        padding-top: 0.75pt;
        padding-left: 0.75pt;
        padding-bottom: 0.75pt;
        vertical-align: middle;
        -aw-padding-bottom: 0.75pt;
        -aw-padding-right: 0.75pt;
        -aw-padding-top: 0.75pt;
      "
      class="td-title"
    >
      <p
        style="
          margin-bottom: 0pt;
          text-align: center;
          widows: 2;
          orphans: 2;
        "
      >
        <span style="font-weight: bold">상세설명</span>
      </p>
    </td>
    <td
      style="
        width: 13.72%;
        border-right-style: solid;
        border-right-width: 1.5pt;
        border-bottom-style: solid;
        border-bottom-width: 1.5pt;
        padding-top: 0.75pt;
        padding-left: 0.75pt;
        padding-bottom: 0.75pt;
        vertical-align: middle;
        -aw-padding-bottom: 0.75pt;
        -aw-padding-right: 0.75pt;
        -aw-padding-top: 0.75pt;
      "
      class="td-title"
    >
      <p
        style="
          margin-bottom: 0pt;
          text-align: center;
          widows: 2;
          orphans: 2;
        "
      >
        <span style="font-weight: bold">1</span
        ><span style="font-weight: bold">차</span>
      </p>
    </td>
    <td
      style="
        width: 13.72%;
        border-right-style: solid;
        border-right-width: 1.5pt;
        border-bottom-style: solid;
        border-bottom-width: 1.5pt;
        padding-top: 0.75pt;
        padding-left: 0.75pt;
        padding-bottom: 0.75pt;
        vertical-align: middle;
        -aw-padding-bottom: 0.75pt;
        -aw-padding-right: 0.75pt;
        -aw-padding-top: 0.75pt;
      "
      class="td-title"
    >
      <p
        style="
          margin-bottom: 0pt;
          text-align: center;
          widows: 2;
          orphans: 2;
        "
      >
        <span style="font-weight: bold">2</span
        ><span style="font-weight: bold">차</span>
      </p>
    </td>
    <td
      style="
        width: 19.5%;
        border-right-style: solid;
        border-right-width: 1.5pt;
        border-bottom-style: solid;
        border-bottom-width: 1.5pt;
        padding-top: 0.75pt;
        padding-left: 0.75pt;
        padding-bottom: 0.75pt;
        vertical-align: middle;
        -aw-padding-bottom: 0.75pt;
        -aw-padding-right: 0.75pt;
        -aw-padding-top: 0.75pt;
      "
      class="td-title"
    >
      <p
        style="
          margin-bottom: 0pt;
          text-align: center;
          widows: 2;
          orphans: 2;
        "
      >
        <span style="font-weight: bold">3</span
        ><span style="font-weight: bold">차</span>
      </p>
    </td>
    <td
      style="
        width: 7.46%;
        border-right-style: solid;
        border-right-width: 1.5pt;
        border-bottom-style: solid;
        border-bottom-width: 1.5pt;
        padding-top: 0.75pt;
        padding-left: 0.75pt;
        padding-bottom: 0.75pt;
        vertical-align: middle;
        -aw-padding-bottom: 0.75pt;
        -aw-padding-right: 0.75pt;
        -aw-padding-top: 0.75pt;
      "
      class="td-title"
    >
      <p
        style="
          margin-bottom: 0pt;
          text-align: center;
          widows: 2;
          orphans: 2;
        "
      >
        <span style="font-weight: bold">4</span
        ><span style="font-weight: bold">차</span>
      </p>
    </td>
    <td
      style="
        width: 7.46%;
        border-bottom-style: solid;
        border-bottom-width: 1.5pt;
        padding-top: 0.75pt;
        padding-left: 0.75pt;
        padding-bottom: 0.75pt;
        vertical-align: middle;
        -aw-padding-bottom: 0.75pt;
        -aw-padding-right: 0.75pt;
        -aw-padding-top: 0.75pt;
      "
      class="td-title"
    >
      <p
        style="
          margin-bottom: 0pt;
          text-align: center;
          widows: 2;
          orphans: 2;
        "
      >
        <span style="font-weight: bold">5</span
        ><span style="font-weight: bold">차</span>
      </p>
    </td>
  </tr>
  <tr style="height: 154.5pt">
    <td
      rowspan="2"
      style="
        width: 27.58%;
        border-right-style: solid;
        border-right-width: 1.5pt;
        border-bottom-style: solid;
        border-bottom-width: 1.5pt;
        padding-top: 0.75pt;
        padding-bottom: 0.75pt;
        vertical-align: middle;
        -aw-padding-bottom: 0.75pt;
        -aw-padding-left: 0.75pt;
        -aw-padding-right: 0.75pt;
      "
    >
      <p
        style="
          margin-right: 6pt;
          margin-left: 6pt;
          margin-bottom: 0pt;
          text-align: center;
          widows: 2;
          orphans: 2;
        "
      >
        <span>배매너행위</span>
      </p>
    </td>
    <td
      style="
        width: 10.52%;
        border-right-style: solid;
        border-right-width: 1.5pt;
        border-bottom-style: solid;
        border-bottom-width: 1.5pt;
        padding-top: 0.75pt;
        padding-left: 0.75pt;
        padding-bottom: 0.75pt;
        vertical-align: middle;
        -aw-padding-bottom: 0.75pt;
        -aw-padding-right: 0.75pt;
      "
    >
      <p
        style="
          margin-bottom: 0pt;
          text-align: center;
          widows: 2;
          orphans: 2;
        "
      >
        <span>운영진의</span><span> </span><span>게임운영을</span
        ><span> </span><span>의도적으로</span><span> </span
        ><span>방해하거나</span><span> </span><span>정상적인</span
        ><span> </span><span>운영을</span><span> </span
        ><span>저해하는</span><span> </span><span>행위</span>
      </p>
    </td>
    <td
      style="
        width: 13.72%;
        border-right-style: solid;
        border-right-width: 1.5pt;
        border-bottom-style: solid;
        border-bottom-width: 1.5pt;
        padding-top: 0.75pt;
        padding-left: 0.75pt;
        padding-bottom: 0.75pt;
        vertical-align: middle;
        -aw-padding-bottom: 0.75pt;
        -aw-padding-right: 0.75pt;
      "
    >
      <p
        style="
          margin-right: 6pt;
          margin-left: 6pt;
          margin-bottom: 0pt;
          text-align: center;
          widows: 2;
          orphans: 2;
        "
      >
        <span>경고</span>
      </p>
    </td>
    <td
      style="
        width: 13.72%;
        border-right-style: solid;
        border-right-width: 1.5pt;
        border-bottom-style: solid;
        border-bottom-width: 1.5pt;
        padding-top: 0.75pt;
        padding-left: 0.75pt;
        padding-bottom: 0.75pt;
        vertical-align: middle;
        -aw-padding-bottom: 0.75pt;
        -aw-padding-right: 0.75pt;
      "
    >
      <p
        style="
          margin-bottom: 0pt;
          text-align: center;
          widows: 2;
          orphans: 2;
        "
      >
        <span>1</span><span>일정지</span>
      </p>
    </td>
    <td
      style="
        width: 19.5%;
        border-right-style: solid;
        border-right-width: 1.5pt;
        border-bottom-style: solid;
        border-bottom-width: 1.5pt;
        padding-top: 0.75pt;
        padding-left: 0.75pt;
        padding-bottom: 0.75pt;
        vertical-align: middle;
        -aw-padding-bottom: 0.75pt;
        -aw-padding-right: 0.75pt;
      "
    >
      <p
        style="
          margin-bottom: 0pt;
          text-align: center;
          widows: 2;
          orphans: 2;
        "
      >
        <span>3</span><span>일정지</span>
      </p>
    </td>
    <td
      style="
        width: 7.46%;
        border-right-style: solid;
        border-right-width: 1.5pt;
        border-bottom-style: solid;
        border-bottom-width: 1.5pt;
        padding-top: 0.75pt;
        padding-left: 0.75pt;
        padding-bottom: 0.75pt;
        vertical-align: middle;
        -aw-padding-bottom: 0.75pt;
        -aw-padding-right: 0.75pt;
      "
    >
      <p
        style="
          margin-bottom: 0pt;
          text-align: center;
          widows: 2;
          orphans: 2;
        "
      >
        <span>5</span><span>일정지</span>
      </p>
    </td>
    <td
      style="
        width: 7.46%;
        border-bottom-style: solid;
        border-bottom-width: 1.5pt;
        padding-top: 0.75pt;
        padding-left: 0.75pt;
        padding-bottom: 0.75pt;
        vertical-align: middle;
        -aw-padding-bottom: 0.75pt;
        -aw-padding-right: 0.75pt;
      "
    >
      <p
        style="
          margin-bottom: 0pt;
          text-align: center;
          widows: 2;
          orphans: 2;
        "
      >
        <span>영구정지</span>
      </p>
    </td>
  </tr>
  <tr style="height: 160.5pt">
    <td
      style="
        width: 10.52%;
        border-right-style: solid;
        border-right-width: 1.5pt;
        border-bottom-style: solid;
        border-bottom-width: 1.5pt;
        padding-top: 0.75pt;
        padding-left: 0.75pt;
        padding-bottom: 0.75pt;
        vertical-align: middle;
        -aw-padding-bottom: 0.75pt;
        -aw-padding-right: 0.75pt;
      "
    >
      <p
        style="
          margin-bottom: 0pt;
          text-align: center;
          widows: 2;
          orphans: 2;
        "
      >
        <span>유언비어</span><span> </span><span>유포</span><span>, </span
        ><span>대한민국</span><span> </span><span>실정법</span
        ><span> </span><span>및</span><span> </span><span>공공질서</span
        ><span>, </span><span>미풍약속에</span><span> </span
        ><span>위반되는</span><span> </span><span>모든</span><span> </span
        ><span>행위</span>
      </p>
    </td>
    <td
      style="
        width: 13.72%;
        border-right-style: solid;
        border-right-width: 1.5pt;
        border-bottom-style: solid;
        border-bottom-width: 1.5pt;
        padding-top: 0.75pt;
        padding-left: 0.75pt;
        padding-bottom: 0.75pt;
        vertical-align: middle;
        -aw-padding-bottom: 0.75pt;
        -aw-padding-right: 0.75pt;
      "
    >
      <p
        style="
          margin-right: 6pt;
          margin-left: 6pt;
          margin-bottom: 0pt;
          text-align: center;
          widows: 2;
          orphans: 2;
        "
      >
        <span>경고</span>
      </p>
    </td>
    <td
      style="
        width: 13.72%;
        border-right-style: solid;
        border-right-width: 1.5pt;
        border-bottom-style: solid;
        border-bottom-width: 1.5pt;
        padding-top: 0.75pt;
        padding-left: 0.75pt;
        padding-bottom: 0.75pt;
        vertical-align: middle;
        -aw-padding-bottom: 0.75pt;
        -aw-padding-right: 0.75pt;
      "
    >
      <p
        style="
          margin-bottom: 0pt;
          text-align: center;
          widows: 2;
          orphans: 2;
        "
      >
        <span>1</span><span>일정지</span>
      </p>
    </td>
    <td
      style="
        width: 19.5%;
        border-right-style: solid;
        border-right-width: 1.5pt;
        border-bottom-style: solid;
        border-bottom-width: 1.5pt;
        padding-top: 0.75pt;
        padding-left: 0.75pt;
        padding-bottom: 0.75pt;
        vertical-align: middle;
        -aw-padding-bottom: 0.75pt;
        -aw-padding-right: 0.75pt;
      "
    >
      <p
        style="
          margin-bottom: 0pt;
          text-align: center;
          widows: 2;
          orphans: 2;
        "
      >
        <span>3</span><span>일정지</span>
      </p>
    </td>
    <td
      style="
        width: 7.46%;
        border-right-style: solid;
        border-right-width: 1.5pt;
        border-bottom-style: solid;
        border-bottom-width: 1.5pt;
        padding-top: 0.75pt;
        padding-left: 0.75pt;
        padding-bottom: 0.75pt;
        vertical-align: middle;
        -aw-padding-bottom: 0.75pt;
        -aw-padding-right: 0.75pt;
      "
    >
      <p
        style="
          margin-bottom: 0pt;
          text-align: center;
          widows: 2;
          orphans: 2;
        "
      >
        <span>5</span><span>일정지</span>
      </p>
    </td>
    <td
      style="
        width: 7.46%;
        border-bottom-style: solid;
        border-bottom-width: 1.5pt;
        padding-top: 0.75pt;
        padding-left: 0.75pt;
        padding-bottom: 0.75pt;
        vertical-align: middle;
        -aw-padding-bottom: 0.75pt;
        -aw-padding-right: 0.75pt;
      "
    >
      <p
        style="
          margin-bottom: 0pt;
          text-align: center;
          widows: 2;
          orphans: 2;
        "
      >
        <span>영구정지</span>
      </p>
    </td>
  </tr>
  <tr style="height: 316.5pt">
    <td
      style="
        width: 27.58%;
        border-right-style: solid;
        border-right-width: 1.5pt;
        padding-top: 0.75pt;
        padding-bottom: 0.75pt;
        vertical-align: middle;
        -aw-padding-bottom: 0.75pt;
        -aw-padding-left: 0.75pt;
        -aw-padding-right: 0.75pt;
      "
    >
      <p
        style="
          margin-right: 6pt;
          margin-left: 6pt;
          margin-bottom: 0pt;
          text-align: center;
          widows: 2;
          orphans: 2;
        "
      >
        <span>운영자</span><span style="">&#xa0;</span><span>및</span
        ><span style="">&#xa0;</span><span>직원사칭</span>
      </p>
    </td>
    <td
      style="
        width: 10.52%;
        border-right-style: solid;
        border-right-width: 1.5pt;
        padding-top: 0.75pt;
        padding-left: 0.75pt;
        padding-bottom: 0.75pt;
        vertical-align: middle;
        -aw-padding-bottom: 0.75pt;
        -aw-padding-right: 0.75pt;
      "
    >
      <p
        style="
          margin-bottom: 0pt;
          text-align: center;
          widows: 2;
          orphans: 2;
        "
      >
        <span>타인을</span><span> </span><span>기망하여</span
        ><span> </span><span>이득을</span><span> </span
        ><span>취하려는</span><span> </span><span>행위</span><span> </span
        ><span>또는</span><span> </span><span>타인의</span><span> </span
        ><span>서비스</span><span> </span><span>이용을</span><span> </span
        ><span>방해한</span><span> </span><span>경우</span>
      </p>
    </td>
    <td
      style="
        width: 13.72%;
        border-right-style: solid;
        border-right-width: 1.5pt;
        padding-top: 0.75pt;
        padding-left: 0.75pt;
        padding-bottom: 0.75pt;
        vertical-align: middle;
        -aw-padding-bottom: 0.75pt;
        -aw-padding-right: 0.75pt;
      "
    >
      <p
        style="
          margin-bottom: 0pt;
          text-align: center;
          widows: 2;
          orphans: 2;
        "
      >
        <span>재화회수후</span><span>&#xa0;</span><span> </span
        ><span>3</span><span>일</span><span> </span><span>정지</span>
      </p>
    </td>
    <td
      style="
        width: 13.72%;
        border-right-style: solid;
        border-right-width: 1.5pt;
        padding-top: 0.75pt;
        padding-left: 0.75pt;
        padding-bottom: 0.75pt;
        vertical-align: middle;
        -aw-padding-bottom: 0.75pt;
        -aw-padding-right: 0.75pt;
      "
    >
      <p
        style="
          margin-bottom: 0pt;
          text-align: center;
          widows: 2;
          orphans: 2;
        "
      >
        <span>재화회수후</span><span>&#xa0;</span><span> </span
        ><span>7</span><span>일</span><span> </span><span>정지</span>
      </p>
    </td>
    <td
      style="
        width: 19.5%;
        border-right-style: solid;
        border-right-width: 1.5pt;
        padding-top: 0.75pt;
        padding-left: 0.75pt;
        padding-bottom: 0.75pt;
        vertical-align: middle;
        -aw-padding-bottom: 0.75pt;
        -aw-padding-right: 0.75pt;
      "
    >
      <p
        style="
          margin-bottom: 0pt;
          text-align: center;
          widows: 2;
          orphans: 2;
        "
      >
        <span>재화회수후</span><span>&#xa0;</span><span> </span
        ><span>30</span><span>일</span><span>&#xa0;</span><span> </span
        ><span>정지</span>
      </p>
    </td>
    <td
      style="
        width: 7.46%;
        border-right-style: solid;
        border-right-width: 1.5pt;
        padding-top: 0.75pt;
        padding-left: 0.75pt;
        padding-bottom: 0.75pt;
        vertical-align: middle;
        -aw-padding-bottom: 0.75pt;
        -aw-padding-right: 0.75pt;
      "
    >
      <p
        style="
          margin-bottom: 0pt;
          text-align: center;
          widows: 2;
          orphans: 2;
        "
      >
        <span>영구정지</span>
      </p>
    </td>
    <td
      style="
        width: 7.46%;
        padding-top: 0.75pt;
        padding-left: 0.75pt;
        padding-bottom: 0.75pt;
        vertical-align: middle;
        -aw-padding-bottom: 0.75pt;
        -aw-padding-right: 0.75pt;
      "
    >
      <p
        style="
          margin-bottom: 0pt;
          text-align: center;
          widows: 2;
          orphans: 2;
        "
      >
        <span>&#xa0;</span>
      </p>
    </td>
  </tr>
</table>
<p
  style="
    margin-top: 14pt;
    margin-bottom: 14pt;
    line-height: normal;
    widows: 2;
    orphans: 2;
  "
>
  <span>&#xa0;</span>
</p>
<table
  cellspacing="0"
  cellpadding="0"
  style="
    width: 100%;
    margin-bottom: 0pt;
    border: 1.5pt solid #000000;
    border-collapse: collapse;
    float: left;
  "
>
  <tr style="height: 40.5pt">
    <td
      style="
        width: 20%;
        border-right-style: solid;
        border-right-width: 1.5pt;
        border-bottom-style: solid;
        border-bottom-width: 1.5pt;
        padding-top: 0.75pt;
        padding-bottom: 0.75pt;
        vertical-align: middle;
        -aw-padding-bottom: 0.75pt;
        -aw-padding-left: 0.75pt;
        -aw-padding-right: 0.75pt;
        -aw-padding-top: 0.75pt;
      "
      class="td-title"
    >
      <p
        style="
          margin-bottom: 0pt;
          text-align: center;
          widows: 2;
          orphans: 2;
        "
      >
        <span style="font-weight: bold">유형</span>
      </p>
    </td>
    <td
      style="
        width: 20%;
        border-right-style: solid;
        border-right-width: 1.5pt;
        border-bottom-style: solid;
        border-bottom-width: 1.5pt;
        padding-top: 0.75pt;
        padding-left: 0.75pt;
        padding-bottom: 0.75pt;
        vertical-align: middle;
        -aw-padding-bottom: 0.75pt;
        -aw-padding-right: 0.75pt;
        -aw-padding-top: 0.75pt;
      "
      class="td-title"
    >
      <p
        style="
          margin-bottom: 0pt;
          text-align: center;
          widows: 2;
          orphans: 2;
        "
      >
        <span style="font-weight: bold">상세설명</span>
      </p>
    </td>
    <td
      style="
        width: 8%;
        border-right-style: solid;
        border-right-width: 1.5pt;
        border-bottom-style: solid;
        border-bottom-width: 1.5pt;
        padding-top: 0.75pt;
        padding-left: 0.75pt;
        padding-bottom: 0.75pt;
        vertical-align: middle;
        -aw-padding-bottom: 0.75pt;
        -aw-padding-right: 0.75pt;
        -aw-padding-top: 0.75pt;
      "
      class="td-title"
    >
      <p
        style="
          margin-bottom: 0pt;
          text-align: center;
          widows: 2;
          orphans: 2;
        "
      >
        <span style="font-weight: bold">1</span
        ><span style="font-weight: bold">차</span>
      </p>
    </td>
    <td
      style="
        width: 8%;
        border-right-style: solid;
        border-right-width: 1.5pt;
        border-bottom-style: solid;
        border-bottom-width: 1.5pt;
        padding-top: 0.75pt;
        padding-left: 0.75pt;
        padding-bottom: 0.75pt;
        vertical-align: middle;
        -aw-padding-bottom: 0.75pt;
        -aw-padding-right: 0.75pt;
        -aw-padding-top: 0.75pt;
      "
      class="td-title"
    >
      <p
        style="
          margin-bottom: 0pt;
          text-align: center;
          widows: 2;
          orphans: 2;
        "
      >
        <span style="font-weight: bold">2</span
        ><span style="font-weight: bold">차</span>
      </p>
    </td>
    <td
      style="
        width: 10%;
        border-right-style: solid;
        border-right-width: 1.5pt;
        border-bottom-style: solid;
        border-bottom-width: 1.5pt;
        padding-top: 0.75pt;
        padding-left: 0.75pt;
        padding-bottom: 0.75pt;
        vertical-align: middle;
        -aw-padding-bottom: 0.75pt;
        -aw-padding-right: 0.75pt;
        -aw-padding-top: 0.75pt;
      "
      class="td-title"
    >
      <p
        style="
          margin-bottom: 0pt;
          text-align: center;
          widows: 2;
          orphans: 2;
        "
      >
        <span style="font-weight: bold">3</span
        ><span style="font-weight: bold">차</span>
      </p>
    </td>
    <td
      style="
        width: 6%;
        border-right-style: solid;
        border-right-width: 1.5pt;
        border-bottom-style: solid;
        border-bottom-width: 1.5pt;
        padding-top: 0.75pt;
        padding-left: 0.75pt;
        padding-bottom: 0.75pt;
        vertical-align: middle;
        -aw-padding-bottom: 0.75pt;
        -aw-padding-right: 0.75pt;
        -aw-padding-top: 0.75pt;
      "
      class="td-title"
    >
      <p
        style="
          margin-bottom: 0pt;
          text-align: center;
          widows: 2;
          orphans: 2;
        "
      >
        <span style="font-weight: bold">4</span
        ><span style="font-weight: bold">차</span>
      </p>
    </td>
    <td
      style="
        width: 6%;
        border-bottom-style: solid;
        border-bottom-width: 1.5pt;
        padding-top: 0.75pt;
        padding-left: 0.75pt;
        padding-bottom: 0.75pt;
        vertical-align: middle;
        -aw-padding-bottom: 0.75pt;
        -aw-padding-right: 0.75pt;
        -aw-padding-top: 0.75pt;
      "
      class="td-title"
    >
      <p
        style="
          margin-bottom: 0pt;
          text-align: center;
          widows: 2;
          orphans: 2;
        "
      >
        <span style="font-weight: bold">5</span
        ><span style="font-weight: bold">차</span>
      </p>
    </td>
  </tr>
  <tr style="height: 90pt">
    <td
      style="
        width: 20%;
        border-right-style: solid;
        border-right-width: 1.5pt;
        border-bottom-style: solid;
        border-bottom-width: 1.5pt;
        padding-top: 0.75pt;
        padding-bottom: 0.75pt;
        vertical-align: middle;
        -aw-padding-bottom: 0.75pt;
        -aw-padding-left: 0.75pt;
        -aw-padding-right: 0.75pt;
      "
    >
      <p
        style="
          margin-right: 6pt;
          margin-left: 6pt;
          margin-bottom: 0pt;
          text-align: center;
          widows: 2;
          orphans: 2;
        "
      >
        <span>명칭</span>
      </p>
    </td>
    <td
      style="
        width: 20%;
        border-right-style: solid;
        border-right-width: 1.5pt;
        border-bottom-style: solid;
        border-bottom-width: 1.5pt;
        padding-top: 0.75pt;
        padding-left: 0.75pt;
        padding-bottom: 0.75pt;
        vertical-align: middle;
        -aw-padding-bottom: 0.75pt;
        -aw-padding-right: 0.75pt;
      "
    >
      <p
        style="
          margin-bottom: 0pt;
          text-align: center;
          widows: 2;
          orphans: 2;
        "
      >
        <span>명칭</span><span> </span><span>관리</span><span> </span
        ><span>기준에</span><span> </span><span>어긋나는</span
        ><span> </span><span>명칭을</span><span> </span
        ><span>사용하는</span><span> </span><span>경우</span>
      </p>
    </td>
    <td
      style="
        width: 8%;
        border-right-style: solid;
        border-right-width: 1.5pt;
        border-bottom-style: solid;
        border-bottom-width: 1.5pt;
        padding-top: 0.75pt;
        padding-left: 0.75pt;
        padding-bottom: 0.75pt;
        vertical-align: middle;
        -aw-padding-bottom: 0.75pt;
        -aw-padding-right: 0.75pt;
      "
    >
      <p
        style="
          margin-right: 6pt;
          margin-left: 6pt;
          margin-bottom: 0pt;
          text-align: center;
          widows: 2;
          orphans: 2;
        "
      >
        <span>경고</span>
      </p>
    </td>
    <td
      style="
        width: 8%;
        border-right-style: solid;
        border-right-width: 1.5pt;
        border-bottom-style: solid;
        border-bottom-width: 1.5pt;
        padding-top: 0.75pt;
        padding-left: 0.75pt;
        padding-bottom: 0.75pt;
        vertical-align: middle;
        -aw-padding-bottom: 0.75pt;
        -aw-padding-right: 0.75pt;
      "
    >
      <p
        style="
          margin-bottom: 0pt;
          text-align: center;
          widows: 2;
          orphans: 2;
        "
      >
        <span>1</span><span>일정지</span>
      </p>
    </td>
    <td
      style="
        width: 10%;
        border-right-style: solid;
        border-right-width: 1.5pt;
        border-bottom-style: solid;
        border-bottom-width: 1.5pt;
        padding-top: 0.75pt;
        padding-left: 0.75pt;
        padding-bottom: 0.75pt;
        vertical-align: middle;
        -aw-padding-bottom: 0.75pt;
        -aw-padding-right: 0.75pt;
      "
    >
      <p
        style="
          margin-bottom: 0pt;
          text-align: center;
          widows: 2;
          orphans: 2;
        "
      >
        <span>3</span><span>일정지</span>
      </p>
    </td>
    <td
      style="
        width: 6%;
        border-right-style: solid;
        border-right-width: 1.5pt;
        border-bottom-style: solid;
        border-bottom-width: 1.5pt;
        padding-top: 0.75pt;
        padding-left: 0.75pt;
        padding-bottom: 0.75pt;
        vertical-align: middle;
        -aw-padding-bottom: 0.75pt;
        -aw-padding-right: 0.75pt;
      "
    >
      <p
        style="
          margin-bottom: 0pt;
          text-align: center;
          widows: 2;
          orphans: 2;
        "
      >
        <span>5</span><span>일정지</span>
      </p>
    </td>
    <td
      style="
        width: 6%;
        border-bottom-style: solid;
        border-bottom-width: 1.5pt;
        padding-top: 0.75pt;
        padding-left: 0.75pt;
        padding-bottom: 0.75pt;
        vertical-align: middle;
        -aw-padding-bottom: 0.75pt;
        -aw-padding-right: 0.75pt;
      "
    >
      <p
        style="
          margin-bottom: 0pt;
          text-align: center;
          widows: 2;
          orphans: 2;
        "
      >
        <span>영구정지</span>
      </p>
    </td>
  </tr>
  <tr style="height: 156pt">
    <td
      rowspan="2"
      style="
        width: 20%;
        border-right-style: solid;
        border-right-width: 1.5pt;
        border-bottom-style: solid;
        border-bottom-width: 1.5pt;
        padding-top: 0.75pt;
        padding-bottom: 0.75pt;
        vertical-align: middle;
        -aw-padding-bottom: 0.75pt;
        -aw-padding-left: 0.75pt;
        -aw-padding-right: 0.75pt;
      "
    >
      <p
        style="
          margin-right: 6pt;
          margin-left: 6pt;
          margin-bottom: 0pt;
          text-align: center;
          widows: 2;
          orphans: 2;
        "
      >
        <span>사기</span>
      </p>
    </td>
    <td
      style="
        width: 20%;
        border-right-style: solid;
        border-right-width: 1.5pt;
        border-bottom-style: solid;
        border-bottom-width: 1.5pt;
        padding-top: 0.75pt;
        padding-left: 0.75pt;
        padding-bottom: 0.75pt;
        vertical-align: middle;
        -aw-padding-bottom: 0.75pt;
        -aw-padding-right: 0.75pt;
      "
    >
      <p
        style="
          margin-bottom: 0pt;
          text-align: center;
          widows: 2;
          orphans: 2;
        "
      >
        <span>특정</span><span> </span><span>캐릭터와</span><span> </span
        ><span>혼동을</span><span> </span><span>줄</span><span> </span
        ><span>수</span><span> </span><span>있는</span><span> </span
        ><span>닉넴임을</span><span> </span><span>사용하여</span
        ><span> </span><span>사기</span><span> </span><span>행위를</span
        ><span> </span><span>하는</span><span> </span><span>경우</span>
      </p>
    </td>
    <td
      style="
        width: 8%;
        border-right-style: solid;
        border-right-width: 1.5pt;
        border-bottom-style: solid;
        border-bottom-width: 1.5pt;
        padding-top: 0.75pt;
        padding-left: 0.75pt;
        padding-bottom: 0.75pt;
        vertical-align: middle;
        -aw-padding-bottom: 0.75pt;
        -aw-padding-right: 0.75pt;
      "
    >
      <p
        style="
          margin-bottom: 0pt;
          text-align: center;
          widows: 2;
          orphans: 2;
        "
      >
        <span>재화회수후</span><span>&#xa0;</span><span> </span
        ><span>3</span><span>일</span><span> </span><span>영구정지</span>
      </p>
    </td>
    <td
      style="
        width: 8%;
        border-right-style: solid;
        border-right-width: 1.5pt;
        border-bottom-style: solid;
        border-bottom-width: 1.5pt;
        padding-top: 0.75pt;
        padding-left: 0.75pt;
        padding-bottom: 0.75pt;
        vertical-align: middle;
        -aw-padding-bottom: 0.75pt;
        -aw-padding-right: 0.75pt;
      "
    >
      <p
        style="
          margin-bottom: 0pt;
          text-align: center;
          widows: 2;
          orphans: 2;
        "
      >
        <span>재화회수후</span><span>&#xa0;</span><span> </span
        ><span>7</span><span>일</span><span> </span><span>영구정지</span>
      </p>
    </td>
    <td
      style="
        width: 10%;
        border-right-style: solid;
        border-right-width: 1.5pt;
        border-bottom-style: solid;
        border-bottom-width: 1.5pt;
        padding-top: 0.75pt;
        padding-left: 0.75pt;
        padding-bottom: 0.75pt;
        vertical-align: middle;
        -aw-padding-bottom: 0.75pt;
        -aw-padding-right: 0.75pt;
      "
    >
      <p
        style="
          margin-bottom: 0pt;
          text-align: center;
          widows: 2;
          orphans: 2;
        "
      >
        <span>재화회수후</span><span>&#xa0;</span><span> </span
        ><span>30</span><span>일</span><span>&#xa0;</span><span> </span
        ><span>영구정지</span>
      </p>
    </td>
    <td
      style="
        width: 6%;
        border-right-style: solid;
        border-right-width: 1.5pt;
        border-bottom-style: solid;
        border-bottom-width: 1.5pt;
        padding-top: 0.75pt;
        padding-left: 0.75pt;
        padding-bottom: 0.75pt;
        vertical-align: middle;
        -aw-padding-bottom: 0.75pt;
        -aw-padding-right: 0.75pt;
      "
    >
      <p
        style="
          margin-bottom: 0pt;
          text-align: center;
          widows: 2;
          orphans: 2;
        "
      >
        <span>&#xa0;</span>
      </p>
    </td>
    <td
      style="
        width: 6%;
        border-bottom-style: solid;
        border-bottom-width: 1.5pt;
        padding-top: 0.75pt;
        padding-left: 0.75pt;
        padding-bottom: 0.75pt;
        vertical-align: middle;
        -aw-padding-bottom: 0.75pt;
        -aw-padding-right: 0.75pt;
      "
    >
      <p
        style="
          margin-bottom: 0pt;
          text-align: center;
          widows: 2;
          orphans: 2;
        "
      >
        <span>&#xa0;</span>
      </p>
    </td>
  </tr>
  <tr style="height: 153pt">
    <td
      style="
        width: 20%;
        border-right-style: solid;
        border-right-width: 1.5pt;
        border-bottom-style: solid;
        border-bottom-width: 1.5pt;
        padding-top: 0.75pt;
        padding-left: 0.75pt;
        padding-bottom: 0.75pt;
        vertical-align: middle;
        -aw-padding-bottom: 0.75pt;
        -aw-padding-right: 0.75pt;
      "
    >
      <p
        style="
          margin-bottom: 0pt;
          text-align: center;
          widows: 2;
          orphans: 2;
        "
      >
        <span>게임내</span><span> </span><span>아이템</span><span>/</span
        ><span>게임</span><span> </span><span>머니</span><span> </span
        ><span>등을</span><span> </span><span>부당하게</span><span> </span
        ><span>취하기</span><span> </span><span>위해</span><span> </span
        ><span>고의적인</span><span> </span><span>목적을</span
        ><span> </span><span>가지고</span><span> </span><span>사기</span
        ><span> </span><span>행위를</span><span> </span><span>하는</span
        ><span> </span><span>경우</span>
      </p>
    </td>
    <td
      style="
        width: 8%;
        border-right-style: solid;
        border-right-width: 1.5pt;
        border-bottom-style: solid;
        border-bottom-width: 1.5pt;
        padding-top: 0.75pt;
        padding-left: 0.75pt;
        padding-bottom: 0.75pt;
        vertical-align: middle;
        -aw-padding-bottom: 0.75pt;
        -aw-padding-right: 0.75pt;
      "
    >
      <p
        style="
          margin-bottom: 0pt;
          text-align: center;
          widows: 2;
          orphans: 2;
        "
      >
        <span>재화회수후</span><span>&#xa0;</span><span> </span
        ><span>3</span><span>일</span><span> </span><span>정지</span>
      </p>
    </td>
    <td
      style="
        width: 8%;
        border-right-style: solid;
        border-right-width: 1.5pt;
        border-bottom-style: solid;
        border-bottom-width: 1.5pt;
        padding-top: 0.75pt;
        padding-left: 0.75pt;
        padding-bottom: 0.75pt;
        vertical-align: middle;
        -aw-padding-bottom: 0.75pt;
        -aw-padding-right: 0.75pt;
      "
    >
      <p
        style="
          margin-bottom: 0pt;
          text-align: center;
          widows: 2;
          orphans: 2;
        "
      >
        <span>재화회수후</span><span>&#xa0;</span><span> </span
        ><span>7</span><span>일</span><span> </span><span>정지</span>
      </p>
    </td>
    <td
      style="
        width: 10%;
        border-right-style: solid;
        border-right-width: 1.5pt;
        border-bottom-style: solid;
        border-bottom-width: 1.5pt;
        padding-top: 0.75pt;
        padding-left: 0.75pt;
        padding-bottom: 0.75pt;
        vertical-align: middle;
        -aw-padding-bottom: 0.75pt;
        -aw-padding-right: 0.75pt;
      "
    >
      <p
        style="
          margin-bottom: 0pt;
          text-align: center;
          widows: 2;
          orphans: 2;
        "
      >
        <span>재화회수후</span><span>&#xa0;</span><span> </span
        ><span>30</span><span>일</span><span>&#xa0;</span><span> </span
        ><span>정지</span>
      </p>
    </td>
    <td
      style="
        width: 6%;
        border-right-style: solid;
        border-right-width: 1.5pt;
        border-bottom-style: solid;
        border-bottom-width: 1.5pt;
        padding-top: 0.75pt;
        padding-left: 0.75pt;
        padding-bottom: 0.75pt;
        vertical-align: middle;
        -aw-padding-bottom: 0.75pt;
        -aw-padding-right: 0.75pt;
      "
    >
      <p
        style="
          margin-bottom: 0pt;
          text-align: center;
          widows: 2;
          orphans: 2;
        "
      >
        <span>영구정지</span>
      </p>
    </td>
    <td
      style="
        width: 6%;
        border-bottom-style: solid;
        border-bottom-width: 1.5pt;
        padding-top: 0.75pt;
        padding-left: 0.75pt;
        padding-bottom: 0.75pt;
        vertical-align: middle;
        -aw-padding-bottom: 0.75pt;
        -aw-padding-right: 0.75pt;
      "
    >
      <p
        style="
          margin-bottom: 0pt;
          text-align: center;
          widows: 2;
          orphans: 2;
        "
      >
        <span>&#xa0;</span>
      </p>
    </td>
  </tr>
  <tr style="height: 146.25pt">
    <td
      style="
        width: 20%;
        border-right-style: solid;
        border-right-width: 1.5pt;
        padding-top: 0.75pt;
        padding-bottom: 0.75pt;
        vertical-align: middle;
        -aw-padding-bottom: 0.75pt;
        -aw-padding-left: 0.75pt;
        -aw-padding-right: 0.75pt;
      "
    >
      <p
        style="
          margin-bottom: 0pt;
          text-align: center;
          widows: 2;
          orphans: 2;
        "
      >
        <span>시스템오류</span><span style="">&#xa0;</span
        ><span>또는</span><span style="">&#xa0;</span><span>버그의</span
        ><span style="">&#xa0;</span><span>악용</span>
      </p>
    </td>
    <td
      style="
        width: 20%;
        border-right-style: solid;
        border-right-width: 1.5pt;
        padding-top: 0.75pt;
        padding-left: 0.75pt;
        padding-bottom: 0.75pt;
        vertical-align: middle;
        -aw-padding-bottom: 0.75pt;
        -aw-padding-right: 0.75pt;
      "
    >
      <p
        style="
          margin-bottom: 0pt;
          text-align: center;
          widows: 2;
          orphans: 2;
        "
      >
        <span>서비스상의</span><span> </span><span>버그임을</span
        ><span> </span><span>인지하고도</span><span> </span
        ><span>반복적으로</span><span> </span><span>또는</span
        ><span> </span><span>경고조치</span><span> </span
        ><span>후에도</span><span> </span><span>이를</span><span> </span
        ><span>악용하여</span><span> </span><span>시스템이나</span
        ><span> </span><span>서비스</span><span> </span><span>또는</span
        ><span> </span><span>게임</span><span> </span><span>환경에</span
        ><span> </span><span>중대한</span><span> </span><span>영향을</span
        ><span> </span><span>미치는</span><span> </span><span>행위</span>
      </p>
    </td>
    <td
      style="
        width: 8%;
        border-right-style: solid;
        border-right-width: 1.5pt;
        padding-top: 0.75pt;
        padding-left: 0.75pt;
        padding-bottom: 0.75pt;
        vertical-align: middle;
        -aw-padding-bottom: 0.75pt;
        -aw-padding-right: 0.75pt;
      "
    >
      <p
        style="
          margin-bottom: 0pt;
          text-align: center;
          widows: 2;
          orphans: 2;
        "
      >
        <span>재화회수후</span><span>&#xa0;</span><span> </span
        ><span>3</span><span>일</span><span> </span><span>정지</span>
      </p>
    </td>
    <td
      style="
        width: 8%;
        border-right-style: solid;
        border-right-width: 1.5pt;
        padding-top: 0.75pt;
        padding-left: 0.75pt;
        padding-bottom: 0.75pt;
        vertical-align: middle;
        -aw-padding-bottom: 0.75pt;
        -aw-padding-right: 0.75pt;
      "
    >
      <p
        style="
          margin-bottom: 0pt;
          text-align: center;
          widows: 2;
          orphans: 2;
        "
      >
        <span>재화회수후</span><span>&#xa0;</span><span> </span
        ><span>7</span><span>일</span><span> </span><span>정지</span>
      </p>
    </td>
    <td
      style="
        width: 10%;
        border-right-style: solid;
        border-right-width: 1.5pt;
        padding-top: 0.75pt;
        padding-left: 0.75pt;
        padding-bottom: 0.75pt;
        vertical-align: middle;
        -aw-padding-bottom: 0.75pt;
        -aw-padding-right: 0.75pt;
      "
    >
      <p
        style="
          margin-bottom: 0pt;
          text-align: center;
          widows: 2;
          orphans: 2;
        "
      >
        <span>재화회수후</span><span>&#xa0;</span><span> </span
        ><span>30</span><span>일</span><span>&#xa0;</span><span> </span
        ><span>정지</span>
      </p>
    </td>
    <td
      style="
        width: 6%;
        border-right-style: solid;
        border-right-width: 1.5pt;
        padding-top: 0.75pt;
        padding-left: 0.75pt;
        padding-bottom: 0.75pt;
        vertical-align: middle;
        -aw-padding-bottom: 0.75pt;
        -aw-padding-right: 0.75pt;
      "
    >
      <p
        style="
          margin-bottom: 0pt;
          text-align: center;
          widows: 2;
          orphans: 2;
        "
      >
        <span>영구정지</span>
      </p>
    </td>
    <td
      style="
        width: 6%;
        padding-top: 0.75pt;
        padding-left: 0.75pt;
        padding-bottom: 0.75pt;
        vertical-align: middle;
        -aw-padding-bottom: 0.75pt;
        -aw-padding-right: 0.75pt;
      "
    >
      <p
        style="
          margin-bottom: 0pt;
          text-align: center;
          widows: 2;
          orphans: 2;
        "
      >
        <span>&#xa0;</span>
      </p>
    </td>
  </tr>
</table>
<p
  style="
    margin-top: 14pt;
    margin-bottom: 14pt;
    text-align: justify;
    line-height: normal;
    widows: 2;
    orphans: 2;
  "
>
  <span>&#xa0;</span>
</p>
<table
  cellspacing="0"
  cellpadding="0"
  style="
    width: 100%;
    margin-bottom: 0pt;
    border: 1.5pt solid #000000;
    border-collapse: collapse;
    float: left;
  "
>
  <tr style="height: 40.5pt">
    <td
      style="
        width: 11.56%;
        border-right-style: solid;
        border-right-width: 1.5pt;
        border-bottom-style: solid;
        border-bottom-width: 1.5pt;
        padding-top: 0.75pt;
        padding-bottom: 0.75pt;
        vertical-align: middle;
        -aw-padding-bottom: 0.75pt;
        -aw-padding-left: 0.75pt;
        -aw-padding-right: 0.75pt;
        -aw-padding-top: 0.75pt;
      "
      class="td-title"
    >
      <p
        style="
          margin-bottom: 0pt;
          text-align: center;
          widows: 2;
          orphans: 2;
        "
      >
        <span style="font-weight: bold">유형</span>
      </p>
    </td>
    <td
      style="
        width: 53.38%;
        border-right-style: solid;
        border-right-width: 1.5pt;
        border-bottom-style: solid;
        border-bottom-width: 1.5pt;
        padding-top: 0.75pt;
        padding-left: 0.75pt;
        padding-bottom: 0.75pt;
        vertical-align: middle;
        -aw-padding-bottom: 0.75pt;
        -aw-padding-right: 0.75pt;
        -aw-padding-top: 0.75pt;
      "
      class="td-title"
    >
      <p
        style="
          margin-bottom: 0pt;
          text-align: center;
          widows: 2;
          orphans: 2;
        "
      >
        <span style="font-weight: bold">상세설명</span>
      </p>
    </td>
    <td
      style="
        width: 10.42%;
        border-right-style: solid;
        border-right-width: 1.5pt;
        border-bottom-style: solid;
        border-bottom-width: 1.5pt;
        padding-top: 0.75pt;
        padding-left: 0.75pt;
        padding-bottom: 0.75pt;
        vertical-align: middle;
        -aw-padding-bottom: 0.75pt;
        -aw-padding-right: 0.75pt;
        -aw-padding-top: 0.75pt;
      "
      class="td-title"
    >
      <p
        style="
          margin-bottom: 0pt;
          text-align: center;
          widows: 2;
          orphans: 2;
        "
      >
        <span style="font-weight: bold">1</span
        ><span style="font-weight: bold">차</span>
      </p>
    </td>
    <td
      style="
        width: 6.24%;
        border-right-style: solid;
        border-right-width: 1.5pt;
        border-bottom-style: solid;
        border-bottom-width: 1.5pt;
        padding-top: 0.75pt;
        padding-left: 0.75pt;
        padding-bottom: 0.75pt;
        vertical-align: middle;
        -aw-padding-bottom: 0.75pt;
        -aw-padding-right: 0.75pt;
        -aw-padding-top: 0.75pt;
      "
      class="td-title"
    >
      <p
        style="
          margin-bottom: 0pt;
          text-align: center;
          widows: 2;
          orphans: 2;
        "
      >
        <span style="font-weight: bold">2</span
        ><span style="font-weight: bold">차</span>
      </p>
    </td>
    <td
      style="
        width: 5.9%;
        border-right-style: solid;
        border-right-width: 1.5pt;
        border-bottom-style: solid;
        border-bottom-width: 1.5pt;
        padding-top: 0.75pt;
        padding-left: 0.75pt;
        padding-bottom: 0.75pt;
        vertical-align: middle;
        -aw-padding-bottom: 0.75pt;
        -aw-padding-right: 0.75pt;
        -aw-padding-top: 0.75pt;
      "
      class="td-title"
    >
      <p
        style="
          margin-bottom: 0pt;
          text-align: center;
          widows: 2;
          orphans: 2;
        "
      >
        <span style="font-weight: bold">3</span
        ><span style="font-weight: bold">차</span>
      </p>
    </td>
    <td
      style="
        width: 6.24%;
        border-right-style: solid;
        border-right-width: 1.5pt;
        border-bottom-style: solid;
        border-bottom-width: 1.5pt;
        padding-top: 0.75pt;
        padding-left: 0.75pt;
        padding-bottom: 0.75pt;
        vertical-align: middle;
        -aw-padding-bottom: 0.75pt;
        -aw-padding-right: 0.75pt;
        -aw-padding-top: 0.75pt;
      "
      class="td-title"
    >
      <p
        style="
          margin-bottom: 0pt;
          text-align: center;
          widows: 2;
          orphans: 2;
        "
      >
        <span style="font-weight: bold">4</span
        ><span style="font-weight: bold">차</span>
      </p>
    </td>
    <td
      style="
        width: 6.24%;
        border-bottom-style: solid;
        border-bottom-width: 1.5pt;
        padding-top: 0.75pt;
        padding-left: 0.75pt;
        padding-bottom: 0.75pt;
        vertical-align: middle;
        -aw-padding-bottom: 0.75pt;
        -aw-padding-right: 0.75pt;
        -aw-padding-top: 0.75pt;
      "
      class="td-title"
    >
      <p
        style="
          margin-bottom: 0pt;
          text-align: center;
          widows: 2;
          orphans: 2;
        "
      >
        <span style="font-weight: bold">5</span
        ><span style="font-weight: bold">차</span>
      </p>
    </td>
  </tr>
  <tr style="height: 99pt">
    <td
      rowspan="2"
      style="
        width: 11.56%;
        border-right-style: solid;
        border-right-width: 1.5pt;
        border-bottom-style: solid;
        border-bottom-width: 1.5pt;
        padding-top: 0.75pt;
        padding-bottom: 0.75pt;
        vertical-align: middle;
        -aw-padding-bottom: 0.75pt;
        -aw-padding-left: 0.75pt;
        -aw-padding-right: 0.75pt;
      "
    >
      <p
        style="
          margin-right: 6pt;
          margin-left: 6pt;
          margin-bottom: 0pt;
          text-align: center;
          widows: 2;
          orphans: 2;
        "
      >
        <span>현금거래</span>
      </p>
    </td>
    <td
      style="
        width: 53.38%;
        border-right-style: solid;
        border-right-width: 1.5pt;
        border-bottom-style: solid;
        border-bottom-width: 1.5pt;
        padding-top: 0.75pt;
        padding-left: 0.75pt;
        padding-bottom: 0.75pt;
        vertical-align: middle;
        -aw-padding-bottom: 0.75pt;
        -aw-padding-right: 0.75pt;
      "
    >
      <p
        style="
          margin-bottom: 0pt;
          text-align: center;
          widows: 2;
          orphans: 2;
        "
      >
        <span>게임내</span><span> </span><span>컨텐츠</span><span> </span
        ><span>(</span><span>아이템</span><span>/</span
        ><span>게임머니</span><span> </span><span>등</span><span>)</span
        ><span>를</span><span> </span><span>현금</span><span>/</span
        ><span>현물</span><span> </span><span>등으로</span><span> </span
        ><span>거래하거나</span><span> </span><span>거래를</span
        ><span> </span><span>알선한</span><span> </span><span>행위</span>
      </p>
    </td>
    <td
      style="
        width: 10.42%;
        border-right-style: solid;
        border-right-width: 1.5pt;
        border-bottom-style: solid;
        border-bottom-width: 1.5pt;
        padding-top: 0.75pt;
        padding-left: 0.75pt;
        padding-bottom: 0.75pt;
        vertical-align: middle;
        -aw-padding-bottom: 0.75pt;
        -aw-padding-right: 0.75pt;
      "
    >
      <p
        style="
          margin-bottom: 0pt;
          text-align: center;
          widows: 2;
          orphans: 2;
        "
      >
        <span>1</span><span>일정지</span>
      </p>
    </td>
    <td
      style="
        width: 6.24%;
        border-right-style: solid;
        border-right-width: 1.5pt;
        border-bottom-style: solid;
        border-bottom-width: 1.5pt;
        padding-top: 0.75pt;
        padding-left: 0.75pt;
        padding-bottom: 0.75pt;
        vertical-align: middle;
        -aw-padding-bottom: 0.75pt;
        -aw-padding-right: 0.75pt;
      "
    >
      <p
        style="
          margin-bottom: 0pt;
          text-align: center;
          widows: 2;
          orphans: 2;
        "
      >
        <span>3</span><span>일정지</span>
      </p>
    </td>
    <td
      style="
        width: 5.9%;
        border-right-style: solid;
        border-right-width: 1.5pt;
        border-bottom-style: solid;
        border-bottom-width: 1.5pt;
        padding-top: 0.75pt;
        padding-left: 0.75pt;
        padding-bottom: 0.75pt;
        vertical-align: middle;
        -aw-padding-bottom: 0.75pt;
        -aw-padding-right: 0.75pt;
      "
    >
      <p
        style="
          margin-bottom: 0pt;
          text-align: center;
          widows: 2;
          orphans: 2;
        "
      >
        <span>5</span><span>일정지</span>
      </p>
    </td>
    <td
      style="
        width: 6.24%;
        border-right-style: solid;
        border-right-width: 1.5pt;
        border-bottom-style: solid;
        border-bottom-width: 1.5pt;
        padding-top: 0.75pt;
        padding-left: 0.75pt;
        padding-bottom: 0.75pt;
        vertical-align: middle;
        -aw-padding-bottom: 0.75pt;
        -aw-padding-right: 0.75pt;
      "
    >
      <p
        style="
          margin-bottom: 0pt;
          text-align: center;
          widows: 2;
          orphans: 2;
        "
      >
        <span>영구정지</span>
      </p>
    </td>
    <td
      style="
        width: 6.24%;
        border-bottom-style: solid;
        border-bottom-width: 1.5pt;
        padding-top: 0.75pt;
        padding-left: 0.75pt;
        padding-bottom: 0.75pt;
        vertical-align: middle;
        -aw-padding-bottom: 0.75pt;
        -aw-padding-right: 0.75pt;
      "
    >
      <p
        style="
          margin-right: 6pt;
          margin-left: 6pt;
          margin-bottom: 0pt;
          text-align: center;
          widows: 2;
          orphans: 2;
        "
      >
        <span>&#xa0;</span>
      </p>
    </td>
  </tr>
  <tr style="height: 163.5pt">
    <td
      style="
        width: 53.38%;
        border-right-style: solid;
        border-right-width: 1.5pt;
        border-bottom-style: solid;
        border-bottom-width: 1.5pt;
        padding-top: 0.75pt;
        padding-left: 0.75pt;
        padding-bottom: 0.75pt;
        vertical-align: middle;
        -aw-padding-bottom: 0.75pt;
        -aw-padding-right: 0.75pt;
      "
    >
      <p
        style="
          margin-bottom: 0pt;
          text-align: center;
          widows: 2;
          orphans: 2;
        "
      >
        <span>게임내</span><span> </span><span>컨텐츠</span><span>(</span
        ><span>아이템</span><span>/</span><span>게임머니</span
        ><span>)</span><span>를</span><span> </span><span>현금</span
        ><span>/</span><span>현물</span><span> </span><span>등으로</span
        ><span> </span><span>거래</span><span> </span><span>또는</span
        ><span> </span><span>시도하는</span><span> </span
        ><span>행위</span>
      </p>
    </td>
    <td
      style="
        width: 10.42%;
        border-right-style: solid;
        border-right-width: 1.5pt;
        border-bottom-style: solid;
        border-bottom-width: 1.5pt;
        padding-top: 0.75pt;
        padding-left: 0.75pt;
        padding-bottom: 0.75pt;
        vertical-align: middle;
        -aw-padding-bottom: 0.75pt;
        -aw-padding-right: 0.75pt;
      "
    >
      <p
        style="
          margin-bottom: 0pt;
          text-align: center;
          widows: 2;
          orphans: 2;
        "
      >
        <span>재화회수후</span><span>&#xa0;</span><span> </span
        ><span>7</span><span>일</span><span> </span><span>정지</span>
      </p>
    </td>
    <td
      style="
        width: 6.24%;
        border-right-style: solid;
        border-right-width: 1.5pt;
        border-bottom-style: solid;
        border-bottom-width: 1.5pt;
        padding-top: 0.75pt;
        padding-left: 0.75pt;
        padding-bottom: 0.75pt;
        vertical-align: middle;
        -aw-padding-bottom: 0.75pt;
        -aw-padding-right: 0.75pt;
      "
    >
      <p
        style="
          margin-bottom: 0pt;
          text-align: center;
          widows: 2;
          orphans: 2;
        "
      >
        <span>영구정지</span>
      </p>
    </td>
    <td
      style="
        width: 5.9%;
        border-right-style: solid;
        border-right-width: 1.5pt;
        border-bottom-style: solid;
        border-bottom-width: 1.5pt;
        padding-top: 0.75pt;
        padding-left: 0.75pt;
        padding-bottom: 0.75pt;
        vertical-align: middle;
        -aw-padding-bottom: 0.75pt;
        -aw-padding-right: 0.75pt;
      "
    >
      <p
        style="
          margin-bottom: 0pt;
          text-align: center;
          widows: 2;
          orphans: 2;
        "
      >
        <span>&#xa0;</span>
      </p>
    </td>
    <td
      style="
        width: 6.24%;
        border-right-style: solid;
        border-right-width: 1.5pt;
        border-bottom-style: solid;
        border-bottom-width: 1.5pt;
        padding-top: 0.75pt;
        padding-left: 0.75pt;
        padding-bottom: 0.75pt;
        vertical-align: middle;
        -aw-padding-bottom: 0.75pt;
        -aw-padding-right: 0.75pt;
      "
    >
      <p
        style="
          margin-bottom: 0pt;
          text-align: center;
          widows: 2;
          orphans: 2;
        "
      >
        <span>&#xa0;</span>
      </p>
    </td>
    <td
      style="
        width: 6.24%;
        border-bottom-style: solid;
        border-bottom-width: 1.5pt;
        padding-top: 0.75pt;
        padding-left: 0.75pt;
        padding-bottom: 0.75pt;
        vertical-align: middle;
        -aw-padding-bottom: 0.75pt;
        -aw-padding-right: 0.75pt;
      "
    >
      <p
        style="
          margin-right: 6pt;
          margin-left: 6pt;
          margin-bottom: 0pt;
          text-align: center;
          widows: 2;
          orphans: 2;
        "
      >
        <span>&#xa0;</span>
      </p>
    </td>
  </tr>
  <tr style="height: 177pt">
    <td
      rowspan="2"
      style="
        width: 11.56%;
        border-right-style: solid;
        border-right-width: 1.5pt;
        border-bottom-style: solid;
        border-bottom-width: 1.5pt;
        padding-top: 0.75pt;
        padding-bottom: 0.75pt;
        vertical-align: middle;
        -aw-padding-bottom: 0.75pt;
        -aw-padding-left: 0.75pt;
        -aw-padding-right: 0.75pt;
      "
    >
      <p
        style="
          margin-right: 6pt;
          margin-left: 6pt;
          margin-bottom: 0pt;
          text-align: center;
          widows: 2;
          orphans: 2;
        "
      >
        <span>불법프로그램</span>
      </p>
    </td>
    <td
      style="
        width: 53.38%;
        border-right-style: solid;
        border-right-width: 1.5pt;
        border-bottom-style: solid;
        border-bottom-width: 1.5pt;
        padding-top: 0.75pt;
        padding-left: 0.75pt;
        padding-bottom: 0.75pt;
        vertical-align: middle;
        -aw-padding-bottom: 0.75pt;
        -aw-padding-right: 0.75pt;
      "
    >
      <p
        style="
          margin-bottom: 0pt;
          text-align: center;
          widows: 2;
          orphans: 2;
        "
      >
        <span>스프드</span><span> </span><span>핵</span><span>, </span
        ><span>메모리</span><span> </span><span>핵</span><span>, </span
        ><span>멀티로더</span><span>, </span><span>매크로</span
        ><span> </span><span>프로그램</span><span>, </span
        ><span>해킹</span><span> </span><span>프로그램</span><span> </span
        ><span>등</span><span> </span><span>회사가</span><span> </span
        ><span>제공하거나</span><span> </span><span>승인하지</span
        ><span> </span><span>않은</span><span> </span><span>모든</span
        ><span> </span><span>소프트웨어나</span><span> </span
        ><span>장치</span><span>(</span><span>하드웨어</span><span>)</span
        ><span>등</span><span> </span><span>불법프로그램을</span
        ><span> </span><span>이용</span><span>/</span><span>제작</span
        ><span>/</span><span>유포</span><span> </span><span>하는</span
        ><span> </span><span>행위</span>
      </p>
    </td>
    <td
      style="
        width: 10.42%;
        border-right-style: solid;
        border-right-width: 1.5pt;
        border-bottom-style: solid;
        border-bottom-width: 1.5pt;
        padding-top: 0.75pt;
        padding-left: 0.75pt;
        padding-bottom: 0.75pt;
        vertical-align: middle;
        -aw-padding-bottom: 0.75pt;
        -aw-padding-right: 0.75pt;
      "
    >
      <p
        style="
          margin-bottom: 0pt;
          text-align: center;
          widows: 2;
          orphans: 2;
        "
      >
        <span>재화회수후</span><span>&#xa0;</span><span> </span
        ><span>7</span><span>일</span><span> </span><span>정지</span>
      </p>
    </td>
    <td
      colspan="4"
      style="
        border-bottom-style: solid;
        border-bottom-width: 1.5pt;
        padding-top: 0.75pt;
        padding-left: 0.75pt;
        padding-bottom: 0.75pt;
        vertical-align: middle;
        -aw-padding-bottom: 0.75pt;
        -aw-padding-right: 0.75pt;
      "
    >
      <p
        style="
          margin-right: 6pt;
          margin-left: 6pt;
          margin-bottom: 0pt;
          text-align: center;
          widows: 2;
          orphans: 2;
        "
      >
        <span>재화</span><span> </span><span>회수후</span><span> </span
        ><span>영구</span><span> </span><span>정지</span><span>(</span
        ><span>사안의</span><span> </span><span>경중에</span><span> </span
        ><span>따라</span><span> </span><span>사법기관</span><span> </span
        ><span>수사</span><span> </span><span>의뢰</span><span>)</span>
      </p>
    </td>
  </tr>
  <tr style="height: 193.5pt">
    <td
      style="
        width: 53.38%;
        border-right-style: solid;
        border-right-width: 1.5pt;
        border-bottom-style: solid;
        border-bottom-width: 1.5pt;
        padding-top: 0.75pt;
        padding-left: 0.75pt;
        padding-bottom: 0.75pt;
        vertical-align: middle;
        -aw-padding-bottom: 0.75pt;
        -aw-padding-right: 0.75pt;
      "
    >
      <p
        style="
          margin-bottom: 0pt;
          text-align: center;
          widows: 2;
          orphans: 2;
        "
      >
        <span>회사로부터</span><span> </span><span>특별한</span
        ><span> </span><span>권리를</span><span> </span><span>받지</span
        ><span> </span><span>않고</span><span> </span
        ><span>프로그램을</span><span> </span><span>제작하거나</span
        ><span>, </span><span>조작된</span><span> </span
        ><span>프로그램을</span><span> </span><span>이용하여</span
        ><span> </span><span>회사의</span><span> </span
        ><span>서비스를</span><span> </span><span>비정상적으로</span
        ><span> </span><span>사용하는</span><span> </span
        ><span>행위</span>
      </p>
    </td>
    <td
      style="
        width: 10.42%;
        border-right-style: solid;
        border-right-width: 1.5pt;
        border-bottom-style: solid;
        border-bottom-width: 1.5pt;
        padding-top: 0.75pt;
        padding-left: 0.75pt;
        padding-bottom: 0.75pt;
        vertical-align: middle;
        -aw-padding-bottom: 0.75pt;
        -aw-padding-right: 0.75pt;
      "
    >
      <p
        style="
          margin-bottom: 0pt;
          text-align: center;
          widows: 2;
          orphans: 2;
        "
      >
        <span>재화회수후</span><span>&#xa0;</span><span> </span
        ><span>7</span><span>일</span><span> </span><span>정지</span>
      </p>
    </td>
    <td
      colspan="4"
      style="
        border-bottom-style: solid;
        border-bottom-width: 1.5pt;
        padding-top: 0.75pt;
        padding-left: 0.75pt;
        padding-bottom: 0.75pt;
        vertical-align: middle;
        -aw-padding-bottom: 0.75pt;
        -aw-padding-right: 0.75pt;
      "
    >
      <p
        style="
          margin-right: 6pt;
          margin-left: 6pt;
          margin-bottom: 0pt;
          text-align: center;
          widows: 2;
          orphans: 2;
        "
      >
        <span>재화</span><span> </span><span>회수후</span><span> </span
        ><span>영구</span><span> </span><span>정지</span><span>(</span
        ><span>사안의</span><span> </span><span>경중에</span><span> </span
        ><span>따라</span><span> </span><span>사법기관</span><span> </span
        ><span>수사</span><span> </span><span>의뢰</span><span>)</span>
      </p>
    </td>
  </tr>
  <tr style="height: 40.5pt">
    <td
      style="
        width: 11.56%;
        border-right-style: solid;
        border-right-width: 1.5pt;
        border-bottom-style: solid;
        border-bottom-width: 1.5pt;
        padding-top: 0.75pt;
        padding-bottom: 0.75pt;
        vertical-align: middle;
        -aw-padding-bottom: 0.75pt;
        -aw-padding-left: 0.75pt;
        -aw-padding-right: 0.75pt;
      "
      class="td-title"
    >
      <p
        style="
          margin-bottom: 0pt;
          text-align: center;
          widows: 2;
          orphans: 2;
        "
      >
        <span style="font-weight: bold">유형</span>
      </p>
    </td>
    <td
      style="
        width: 53.38%;
        border-right-style: solid;
        border-right-width: 1.5pt;
        border-bottom-style: solid;
        border-bottom-width: 1.5pt;
        padding-top: 0.75pt;
        padding-left: 0.75pt;
        padding-bottom: 0.75pt;
        vertical-align: middle;
        -aw-padding-bottom: 0.75pt;
        -aw-padding-right: 0.75pt;
      "
      class="td-title"
    >
      <p
        style="
          margin-bottom: 0pt;
          text-align: center;
          widows: 2;
          orphans: 2;
        "
      >
        <span style="font-weight: bold">상세설명</span>
      </p>
    </td>
    <td
      style="
        width: 10.42%;
        border-right-style: solid;
        border-right-width: 1.5pt;
        border-bottom-style: solid;
        border-bottom-width: 1.5pt;
        padding-top: 0.75pt;
        padding-left: 0.75pt;
        padding-bottom: 0.75pt;
        vertical-align: middle;
        -aw-padding-bottom: 0.75pt;
        -aw-padding-right: 0.75pt;
      "
      class="td-title"
    >
      <p
        style="
          margin-bottom: 0pt;
          text-align: center;
          widows: 2;
          orphans: 2;
        "
      >
        <span style="font-weight: bold">1</span
        ><span style="font-weight: bold">차</span>
      </p>
    </td>
    <td
      style="
        width: 6.24%;
        border-right-style: solid;
        border-right-width: 1.5pt;
        border-bottom-style: solid;
        border-bottom-width: 1.5pt;
        padding-top: 0.75pt;
        padding-left: 0.75pt;
        padding-bottom: 0.75pt;
        vertical-align: middle;
        -aw-padding-bottom: 0.75pt;
        -aw-padding-right: 0.75pt;
      "
      class="td-title"
    >
      <p
        style="
          margin-bottom: 0pt;
          text-align: center;
          widows: 2;
          orphans: 2;
        "
      >
        <span style="font-weight: bold">2</span
        ><span style="font-weight: bold">차</span>
      </p>
    </td>
    <td
      style="
        width: 5.9%;
        border-right-style: solid;
        border-right-width: 1.5pt;
        border-bottom-style: solid;
        border-bottom-width: 1.5pt;
        padding-top: 0.75pt;
        padding-left: 0.75pt;
        padding-bottom: 0.75pt;
        vertical-align: middle;
        -aw-padding-bottom: 0.75pt;
        -aw-padding-right: 0.75pt;
      "
      class="td-title"
    >
      <p
        style="
          margin-bottom: 0pt;
          text-align: center;
          widows: 2;
          orphans: 2;
        "
      >
        <span style="font-weight: bold">3</span
        ><span style="font-weight: bold">차</span>
      </p>
    </td>
    <td
      style="
        width: 6.24%;
        border-right-style: solid;
        border-right-width: 1.5pt;
        border-bottom-style: solid;
        border-bottom-width: 1.5pt;
        padding-top: 0.75pt;
        padding-left: 0.75pt;
        padding-bottom: 0.75pt;
        vertical-align: middle;
        -aw-padding-bottom: 0.75pt;
        -aw-padding-right: 0.75pt;
      "
      class="td-title"
    >
      <p
        style="
          margin-bottom: 0pt;
          text-align: center;
          widows: 2;
          orphans: 2;
        "
      >
        <span style="font-weight: bold">4</span
        ><span style="font-weight: bold">차</span>
      </p>
    </td>
    <td
      style="
        width: 6.24%;
        border-bottom-style: solid;
        border-bottom-width: 1.5pt;
        padding-top: 0.75pt;
        padding-left: 0.75pt;
        padding-bottom: 0.75pt;
        vertical-align: middle;
        -aw-padding-bottom: 0.75pt;
        -aw-padding-right: 0.75pt;
      "
      class="td-title"
    >
      <p
        style="
          margin-bottom: 0pt;
          text-align: center;
          widows: 2;
          orphans: 2;
        "
      >
        <span style="font-weight: bold">5</span
        ><span style="font-weight: bold">차</span>
      </p>
    </td>
  </tr>
  <tr style="height: 131.25pt">
    <td
      rowspan="2"
      style="
        width: 11.56%;
        border-right-style: solid;
        border-right-width: 1.5pt;
        border-bottom-style: solid;
        border-bottom-width: 1.5pt;
        padding-top: 0.75pt;
        padding-bottom: 0.75pt;
        vertical-align: middle;
        -aw-padding-bottom: 0.75pt;
        -aw-padding-left: 0.75pt;
        -aw-padding-right: 0.75pt;
      "
    >
      <p
        style="
          margin-right: 6pt;
          margin-left: 6pt;
          margin-bottom: 0pt;
          text-align: center;
          widows: 2;
          orphans: 2;
        "
      >
        <span>계정도용</span>
      </p>
    </td>
    <td
      style="
        width: 53.38%;
        border-right-style: solid;
        border-right-width: 1.5pt;
        border-bottom-style: solid;
        border-bottom-width: 1.5pt;
        padding-top: 0.75pt;
        padding-left: 0.75pt;
        padding-bottom: 0.75pt;
        vertical-align: middle;
        -aw-padding-bottom: 0.75pt;
        -aw-padding-right: 0.75pt;
      "
    >
      <p
        style="
          margin-bottom: 0pt;
          text-align: center;
          widows: 2;
          orphans: 2;
        "
      >
        <span>다른</span><span> </span><span>회원의</span><span> </span
        ><span>계정에</span><span> </span><span>접속하여</span
        ><span> </span><span>피해를</span><span> </span><span>주는</span
        ><span> </span><span>행위</span>
      </p>
    </td>
    <td
      style="
        width: 10.42%;
        border-right-style: solid;
        border-right-width: 1.5pt;
        border-bottom-style: solid;
        border-bottom-width: 1.5pt;
        padding-top: 0.75pt;
        padding-left: 0.75pt;
        padding-bottom: 0.75pt;
        vertical-align: middle;
        -aw-padding-bottom: 0.75pt;
        -aw-padding-right: 0.75pt;
      "
    >
      <p
        style="
          margin-bottom: 0pt;
          text-align: center;
          widows: 2;
          orphans: 2;
        "
      >
        <span>재화회수후</span><span>&#xa0;</span><span> </span
        ><span>30</span><span>일</span><span> </span><span>정지</span>
      </p>
    </td>
    <td
      style="
        width: 6.24%;
        border-right-style: solid;
        border-right-width: 1.5pt;
        border-bottom-style: solid;
        border-bottom-width: 1.5pt;
        padding-top: 0.75pt;
        padding-left: 0.75pt;
        padding-bottom: 0.75pt;
        vertical-align: middle;
        -aw-padding-bottom: 0.75pt;
        -aw-padding-right: 0.75pt;
      "
    >
      <p
        style="
          margin-bottom: 0pt;
          text-align: center;
          widows: 2;
          orphans: 2;
        "
      >
        <span>영구정지</span>
      </p>
    </td>
    <td
      style="
        width: 5.9%;
        border-right-style: solid;
        border-right-width: 1.5pt;
        border-bottom-style: solid;
        border-bottom-width: 1.5pt;
        padding-top: 0.75pt;
        padding-left: 0.75pt;
        padding-bottom: 0.75pt;
        vertical-align: middle;
        -aw-padding-bottom: 0.75pt;
        -aw-padding-right: 0.75pt;
      "
    >
      <p
        style="
          margin-bottom: 0pt;
          text-align: center;
          widows: 2;
          orphans: 2;
        "
      >
        <span>&#xa0;</span>
      </p>
    </td>
    <td
      style="
        width: 6.24%;
        border-right-style: solid;
        border-right-width: 1.5pt;
        border-bottom-style: solid;
        border-bottom-width: 1.5pt;
        padding-top: 0.75pt;
        padding-left: 0.75pt;
        padding-bottom: 0.75pt;
        vertical-align: middle;
        -aw-padding-bottom: 0.75pt;
        -aw-padding-right: 0.75pt;
      "
    >
      <p
        style="
          margin-right: 6pt;
          margin-left: 6pt;
          margin-bottom: 0pt;
          text-align: center;
          widows: 2;
          orphans: 2;
        "
      >
        <span>&#xa0;</span>
      </p>
    </td>
    <td
      style="
        width: 6.24%;
        border-bottom-style: solid;
        border-bottom-width: 1.5pt;
        padding-top: 0.75pt;
        padding-left: 0.75pt;
        padding-bottom: 0.75pt;
        vertical-align: middle;
        -aw-padding-bottom: 0.75pt;
        -aw-padding-right: 0.75pt;
      "
    >
      <p
        style="
          margin-right: 6pt;
          margin-left: 6pt;
          margin-bottom: 0pt;
          text-align: center;
          widows: 2;
          orphans: 2;
        "
      >
        <span>&#xa0;</span>
      </p>
    </td>
  </tr>
  <tr style="height: 131.25pt">
    <td
      style="
        width: 53.38%;
        border-right-style: solid;
        border-right-width: 1.5pt;
        border-bottom-style: solid;
        border-bottom-width: 1.5pt;
        padding-top: 0.75pt;
        padding-left: 0.75pt;
        padding-bottom: 0.75pt;
        vertical-align: middle;
        -aw-padding-bottom: 0.75pt;
        -aw-padding-right: 0.75pt;
      "
    >
      <p
        style="
          margin-bottom: 0pt;
          text-align: center;
          widows: 2;
          orphans: 2;
        "
      >
        <span>제</span><span>3</span><span>자의</span><span> </span
        ><span>신용카드</span><span>, </span><span>휴대폰</span
        ><span>, ARS </span><span>등</span><span> </span
        ><span>결제수단을</span><span> </span><span>무단으로</span
        ><span> </span><span>도용하여</span><span> </span
        ><span>아이템</span><span> </span><span>구매등</span><span> </span
        ><span>게임서비스를</span><span> </span><span>이용한</span
        ><span> </span><span>경우</span>
      </p>
    </td>
    <td
      style="
        width: 10.42%;
        border-right-style: solid;
        border-right-width: 1.5pt;
        border-bottom-style: solid;
        border-bottom-width: 1.5pt;
        padding-top: 0.75pt;
        padding-left: 0.75pt;
        padding-bottom: 0.75pt;
        vertical-align: middle;
        -aw-padding-bottom: 0.75pt;
        -aw-padding-right: 0.75pt;
      "
    >
      <p
        style="
          margin-bottom: 0pt;
          text-align: center;
          widows: 2;
          orphans: 2;
        "
      >
        <span>재화회수후</span><span>&#xa0;</span><span>&#xa0;</span
        ><span> </span><span>영구정지</span>
      </p>
    </td>
    <td
      style="
        width: 6.24%;
        border-right-style: solid;
        border-right-width: 1.5pt;
        border-bottom-style: solid;
        border-bottom-width: 1.5pt;
        padding-top: 0.75pt;
        padding-left: 0.75pt;
        padding-bottom: 0.75pt;
        vertical-align: middle;
        -aw-padding-bottom: 0.75pt;
        -aw-padding-right: 0.75pt;
      "
    >
      <p
        style="
          margin-bottom: 0pt;
          text-align: center;
          widows: 2;
          orphans: 2;
        "
      >
        <span>&#xa0;</span>
      </p>
    </td>
    <td
      style="
        width: 5.9%;
        border-right-style: solid;
        border-right-width: 1.5pt;
        border-bottom-style: solid;
        border-bottom-width: 1.5pt;
        padding-top: 0.75pt;
        padding-left: 0.75pt;
        padding-bottom: 0.75pt;
        vertical-align: middle;
        -aw-padding-bottom: 0.75pt;
        -aw-padding-right: 0.75pt;
      "
    >
      <p
        style="
          margin-bottom: 0pt;
          text-align: center;
          widows: 2;
          orphans: 2;
        "
      >
        <span>&#xa0;</span>
      </p>
    </td>
    <td
      style="
        width: 6.24%;
        border-right-style: solid;
        border-right-width: 1.5pt;
        border-bottom-style: solid;
        border-bottom-width: 1.5pt;
        padding-top: 0.75pt;
        padding-left: 0.75pt;
        padding-bottom: 0.75pt;
        vertical-align: middle;
        -aw-padding-bottom: 0.75pt;
        -aw-padding-right: 0.75pt;
      "
    >
      <p
        style="
          margin-right: 6pt;
          margin-left: 6pt;
          margin-bottom: 0pt;
          text-align: center;
          widows: 2;
          orphans: 2;
        "
      >
        <span>&#xa0;</span>
      </p>
    </td>
    <td
      style="
        width: 6.24%;
        border-bottom-style: solid;
        border-bottom-width: 1.5pt;
        padding-top: 0.75pt;
        padding-left: 0.75pt;
        padding-bottom: 0.75pt;
        vertical-align: middle;
        -aw-padding-bottom: 0.75pt;
        -aw-padding-right: 0.75pt;
      "
    >
      <p
        style="
          margin-right: 6pt;
          margin-left: 6pt;
          margin-bottom: 0pt;
          text-align: center;
          widows: 2;
          orphans: 2;
        "
      >
        <span>&#xa0;</span>
      </p>
    </td>
  </tr>
  <tr style="height: 169.5pt">
    <td
      rowspan="2"
      style="
        width: 11.56%;
        border-right-style: solid;
        border-right-width: 1.5pt;
        border-bottom-style: solid;
        border-bottom-width: 1.5pt;
        padding-top: 0.75pt;
        padding-bottom: 0.75pt;
        vertical-align: middle;
        -aw-padding-bottom: 0.75pt;
        -aw-padding-left: 0.75pt;
        -aw-padding-right: 0.75pt;
      "
    >
      <p
        style="
          margin-right: 6pt;
          margin-left: 6pt;
          margin-bottom: 0pt;
          text-align: center;
          widows: 2;
          orphans: 2;
        "
      >
        <span>게임운영방해</span>
      </p>
    </td>
    <td
      style="
        width: 53.38%;
        border-right-style: solid;
        border-right-width: 1.5pt;
        border-bottom-style: solid;
        border-bottom-width: 1.5pt;
        padding-top: 0.75pt;
        padding-left: 0.75pt;
        padding-bottom: 0.75pt;
        vertical-align: middle;
        -aw-padding-bottom: 0.75pt;
        -aw-padding-right: 0.75pt;
      "
    >
      <p
        style="
          margin-bottom: 0pt;
          text-align: center;
          widows: 2;
          orphans: 2;
        "
      >
        <span>게임내</span><span> </span><span>사행성을</span
        ><span> </span><span>조장하는</span><span> </span
        ><span>불건전한</span><span> </span><span>도박진행</span
        ><span> </span><span>및</span><span> </span><span>사행성</span
        ><span> </span><span>행위</span><span> </span><span>조장</span
        ><span> </span><span>및</span><span> </span><span>관련</span
        ><span> </span><span>광고</span><span> </span><span>등을</span
        ><span> </span><span>유포하는</span><span> </span><span>행위</span
        ><span> </span><span>또한</span><span>, </span
        ><span>우연성에</span><span> </span><span>따른</span><span> </span
        ><span>득실을</span><span> </span><span>통해서</span><span> </span
        ><span>다른</span><span> </span><span>유저로부터</span
        ><span> </span><span>이득을</span><span> </span><span>취하는</span
        ><span> </span><span>행위</span>
      </p>
    </td>
    <td
      style="
        width: 10.42%;
        border-right-style: solid;
        border-right-width: 1.5pt;
        border-bottom-style: solid;
        border-bottom-width: 1.5pt;
        padding-top: 0.75pt;
        padding-left: 0.75pt;
        padding-bottom: 0.75pt;
        vertical-align: middle;
        -aw-padding-bottom: 0.75pt;
        -aw-padding-right: 0.75pt;
      "
    >
      <p
        style="
          margin-bottom: 0pt;
          text-align: center;
          widows: 2;
          orphans: 2;
        "
      >
        <span>재화회수후</span><span>&#xa0;</span><span> </span
        ><span>30</span><span>일</span><span> </span><span>정지</span>
      </p>
    </td>
    <td
      style="
        width: 6.24%;
        border-right-style: solid;
        border-right-width: 1.5pt;
        border-bottom-style: solid;
        border-bottom-width: 1.5pt;
        padding-top: 0.75pt;
        padding-left: 0.75pt;
        padding-bottom: 0.75pt;
        vertical-align: middle;
        -aw-padding-bottom: 0.75pt;
        -aw-padding-right: 0.75pt;
      "
    >
      <p
        style="
          margin-bottom: 0pt;
          text-align: center;
          widows: 2;
          orphans: 2;
        "
      >
        <span>영구정지</span>
      </p>
    </td>
    <td
      style="
        width: 5.9%;
        border-right-style: solid;
        border-right-width: 1.5pt;
        border-bottom-style: solid;
        border-bottom-width: 1.5pt;
        padding-top: 0.75pt;
        padding-left: 0.75pt;
        padding-bottom: 0.75pt;
        vertical-align: middle;
        -aw-padding-bottom: 0.75pt;
        -aw-padding-right: 0.75pt;
      "
    >
      <p
        style="
          margin-bottom: 0pt;
          text-align: center;
          widows: 2;
          orphans: 2;
        "
      >
        <span>&#xa0;</span>
      </p>
    </td>
    <td
      style="
        width: 6.24%;
        border-right-style: solid;
        border-right-width: 1.5pt;
        border-bottom-style: solid;
        border-bottom-width: 1.5pt;
        padding-top: 0.75pt;
        padding-left: 0.75pt;
        padding-bottom: 0.75pt;
        vertical-align: middle;
        -aw-padding-bottom: 0.75pt;
        -aw-padding-right: 0.75pt;
      "
    >
      <p
        style="
          margin-right: 6pt;
          margin-left: 6pt;
          margin-bottom: 0pt;
          text-align: center;
          widows: 2;
          orphans: 2;
        "
      >
        <span>&#xa0;</span>
      </p>
    </td>
    <td
      style="
        width: 6.24%;
        border-bottom-style: solid;
        border-bottom-width: 1.5pt;
        padding-top: 0.75pt;
        padding-left: 0.75pt;
        padding-bottom: 0.75pt;
        vertical-align: middle;
        -aw-padding-bottom: 0.75pt;
        -aw-padding-right: 0.75pt;
      "
    >
      <p
        style="
          margin-right: 6pt;
          margin-left: 6pt;
          margin-bottom: 0pt;
          text-align: center;
          widows: 2;
          orphans: 2;
        "
      >
        <span>&#xa0;</span>
      </p>
    </td>
  </tr>
  <tr style="height: 172.5pt">
    <td
      style="
        width: 53.38%;
        border-right-style: solid;
        border-right-width: 1.5pt;
        padding-top: 0.75pt;
        padding-left: 0.75pt;
        padding-bottom: 0.75pt;
        vertical-align: middle;
        -aw-padding-bottom: 0.75pt;
        -aw-padding-right: 0.75pt;
      "
    >
      <p
        style="
          margin-bottom: 0pt;
          text-align: center;
          widows: 2;
          orphans: 2;
        "
      >
        <span>허위사실을</span><span> </span><span>유포하거나</span
        ><span> </span><span>공지되지</span><span> </span><span>않은</span
        ><span> </span><span>비밀정보를</span><span> </span
        ><span>유포하여</span><span> </span><span>부당한</span
        ><span> </span><span>이득을</span><span> </span><span>얻거나</span
        ><span> </span><span>타인에게</span><span> </span><span>혼란</span
        ><span> </span><span>및</span><span> </span><span>피해를</span
        ><span> </span><span>야기</span><span>&#xa0;</span><span> </span
        ><span>시키는</span><span> </span><span>행위</span>
      </p>
    </td>
    <td
      style="
        width: 10.42%;
        border-right-style: solid;
        border-right-width: 1.5pt;
        padding-top: 0.75pt;
        padding-left: 0.75pt;
        padding-bottom: 0.75pt;
        vertical-align: middle;
        -aw-padding-bottom: 0.75pt;
        -aw-padding-right: 0.75pt;
      "
    >
      <p
        style="
          margin-right: 6pt;
          margin-left: 6pt;
          margin-bottom: 0pt;
          text-align: center;
          widows: 2;
          orphans: 2;
        "
      >
        <span>경고</span>
      </p>
    </td>
    <td
      style="
        width: 6.24%;
        border-right-style: solid;
        border-right-width: 1.5pt;
        padding-top: 0.75pt;
        padding-left: 0.75pt;
        padding-bottom: 0.75pt;
        vertical-align: middle;
        -aw-padding-bottom: 0.75pt;
        -aw-padding-right: 0.75pt;
      "
    >
      <p
        style="
          margin-bottom: 0pt;
          text-align: center;
          widows: 2;
          orphans: 2;
        "
      >
        <span>1</span><span>일정지</span>
      </p>
    </td>
    <td
      style="
        width: 5.9%;
        border-right-style: solid;
        border-right-width: 1.5pt;
        padding-top: 0.75pt;
        padding-left: 0.75pt;
        padding-bottom: 0.75pt;
        vertical-align: middle;
        -aw-padding-bottom: 0.75pt;
        -aw-padding-right: 0.75pt;
      "
    >
      <p
        style="
          margin-bottom: 0pt;
          text-align: center;
          widows: 2;
          orphans: 2;
        "
      >
        <span>3</span><span>일정지</span>
      </p>
    </td>
    <td
      style="
        width: 6.24%;
        border-right-style: solid;
        border-right-width: 1.5pt;
        padding-top: 0.75pt;
        padding-left: 0.75pt;
        padding-bottom: 0.75pt;
        vertical-align: middle;
        -aw-padding-bottom: 0.75pt;
        -aw-padding-right: 0.75pt;
      "
    >
      <p
        style="
          margin-bottom: 0pt;
          text-align: center;
          widows: 2;
          orphans: 2;
        "
      >
        <span>5</span><span>일정지</span>
      </p>
    </td>
    <td
      style="
        width: 6.24%;
        padding-top: 0.75pt;
        padding-left: 0.75pt;
        padding-bottom: 0.75pt;
        vertical-align: middle;
        -aw-padding-bottom: 0.75pt;
        -aw-padding-right: 0.75pt;
      "
    >
      <p
        style="
          margin-bottom: 0pt;
          text-align: center;
          widows: 2;
          orphans: 2;
        "
      >
        <span>영구정지</span>
      </p>
    </td>
  </tr>
</table>
<p
  style="
    margin-top: 14pt;
    margin-bottom: 14pt;
    line-height: normal;
    widows: 2;
    orphans: 2;
  "
>
  <span>&#xa0;</span>
</p>
<p
  style="
    margin-top: 14pt;
    margin-bottom: 14pt;
    line-height: normal;
    widows: 2;
    orphans: 2;
  "
>
  <span>운영진</span><span> </span><span>판단</span><span> </span
  ><span>하에</span><span> </span><span>이용</span><span> </span
  ><span>제한</span><span> </span><span>기간과</span><span> </span
  ><span>방법이</span><span> </span><span>변경될</span><span> </span
  ><span>수</span><span> </span><span>있습니다</span><span>.</span>
</p>
<p
  style="
    margin-top: 14pt;
    margin-bottom: 14pt;
    line-height: normal;
    widows: 2;
    orphans: 2;
  "
>
  <span>&#xa0;</span>
</p>
<p
  style="
    margin-top: 14pt;
    margin-bottom: 14pt;
    line-height: normal;
    widows: 2;
    orphans: 2;
  "
>
  <span>사례가</span><span> </span><span>중복되는</span><span> </span
  ><span>경우</span><span> </span><span>가중하여</span><span> </span
  ><span>이용이</span><span> </span><span>제한될</span><span> </span
  ><span>수</span><span> </span><span>있습니다</span><span>.</span>
</p>
<p
  style="
    margin-top: 14pt;
    margin-bottom: 14pt;
    line-height: normal;
    widows: 2;
    orphans: 2;
  "
>
  <span>위의</span><span> </span><span>항목에</span><span> </span
  ><span>해당되지</span><span> </span><span>않는</span><span> </span
  ><span>사항이라</span><span> </span><span>하더라도</span><span> </span
  ><span>운영진의</span><span> </span><span>객관적인</span><span> </span
  ><span>판단하에</span><span> </span><span>이용이</span><span> </span
  ><span>제한</span><span> </span><span>될</span><span> </span
  ><span>수</span><span> </span><span>있습니다</span><span>.</span>
</p>
<p
  style="
    margin-top: 14pt;
    margin-bottom: 14pt;
    line-height: normal;
    widows: 2;
    orphans: 2;
  "
>
  <span>11.</span><span>&#xa0;</span><span>커뮤니티</span><span> </span
  ><span>운영</span><span> </span><span>기준</span>
</p>
<p
  style="
    margin-top: 14pt;
    margin-bottom: 14pt;
    line-height: normal;
    widows: 2;
    orphans: 2;
  "
>
  <span>1)</span><span>회사는</span><span> </span><span>서비스와</span
  ><span> </span><span>관련된</span><span> </span><span>커뮤니티를</span
  ><span> </span><span>운영할수</span><span> </span><span>있고</span
  ><span>, </span><span>커뮤니티</span><span> </span><span>서비스는</span
  ><span> </span><span>회원</span><span> </span><span>여러분</span
  ><span> </span><span>누구나</span><span> </span><span>이용하실</span
  ><span> </span><span>수</span><span> </span><span>있습니다</span
  ><span>.</span>
</p>
<p
  style="
    margin-top: 14pt;
    margin-bottom: 14pt;
    line-height: normal;
    widows: 2;
    orphans: 2;
  "
>
  <span>2)</span><span>본</span><span> </span><span>커뮤니티</span
  ><span> </span><span>운영</span><span> </span><span>기준은</span
  ><span> </span><span>회사가</span><span> </span
  ><span>제공하는커뮤니티의</span><span> </span><span>원활한</span
  ><span> </span><span>이용</span><span> </span><span>및</span
  ><span> </span><span>건전한</span><span> </span><span>온라인</span
  ><span> </span><span>커뮤니티</span><span> </span><span>문화를</span
  ><span> </span><span>위하여</span><span> </span><span>제공되는</span
  ><span> </span><span>회사의</span><span> </span><span>규정입니다</span
  ><span>.</span>
</p>
<p
  style="
    margin-top: 14pt;
    margin-bottom: 14pt;
    line-height: normal;
    widows: 2;
    orphans: 2;
  "
>
  <span>3)</span><span>회원</span><span> </span><span>여러분이</span
  ><span> </span><span>커뮤니티</span><span> </span><span>내</span
  ><span> </span><span>다음과</span><span> </span><span>같은</span
  ><span>&#xa0;</span><span>불건전하고</span><span> </span
  ><span>매너에</span><span> </span><span>어긋나는</span><span> </span
  ><span>유형의</span><span> </span><span>글</span><span> </span
  ><span>또는</span><span> </span><span>댓글을</span><span> </span
  ><span>게재할</span><span> </span><span>경우</span><span> </span
  ><span>사전</span><span> </span><span>안내</span><span> </span
  ><span>없이</span><span> </span><span>게시물이</span><span> </span
  ><span>삭제될</span><span> </span><span>수</span><span> </span
  ><span>있으며</span><span>, </span><span>작성하신</span
  ><span>&#xa0;</span><span>회원</span><span> </span><span>여러분에</span
  ><span> </span><span>대하여</span><span> </span><span>서비스</span
  ><span> </span><span>이용제한</span><span> </span><span>조치를</span
  ><span> </span><span>취할</span><span> </span><span>수</span
  ><span> </span><span>있습니다</span><span>.</span>
</p>
<p
  style="
    margin-top: 14pt;
    margin-bottom: 14pt;
    line-height: normal;
    widows: 2;
    orphans: 2;
  "
>
  <span>①</span><span> </span><span>사회</span><span> </span
  ><span>질서나</span><span> </span><span>기타</span><span> </span
  ><span>미풍양속에</span><span> </span><span>위배되는</span><span> </span
  ><span>내용</span><span> </span><span>②</span><span> </span
  ><span>회사의</span><span> </span><span>영업을</span><span> </span
  ><span>방해하거나</span><span> </span><span>음해하는</span><span> </span
  ><span>내용</span><span> </span><span>③</span><span> </span
  ><span>특정</span><span> </span><span>또는</span><span> </span
  ><span>불특정</span><span> </span><span>대상을</span><span> </span
  ><span>비하하거나</span><span> </span><span>비방하는</span><span> </span
  ><span>내용</span><span> </span><span>④</span><span> </span
  ><span>불법프로그램의</span><span> </span><span>제작</span
  ><span>, </span><span>공유</span><span>, </span><span>배포와</span
  ><span> </span><span>관련된내용</span><span> </span><span>⑤</span
  ><span> </span><span>계정이나</span><span> </span><span>아이템</span
  ><span> </span><span>매매</span><span>, </span><span>교환</span
  ><span> </span><span>등과</span><span> </span><span>관련된</span
  ><span> </span><span>내용</span><span> </span><span>⑥</span
  ><span> </span><span>상업적</span><span> </span><span>광고성</span
  ><span> </span><span>내용</span><span> </span><span>⑦</span
  ><span> </span><span>회사의</span><span> </span><span>임직원을</span
  ><span> </span><span>사칭하거나</span><span>, </span
  ><span>사칭하려는</span><span> </span><span>의도를</span><span> </span
  ><span>담은</span><span> </span><span>내용</span><span> </span
  ><span>⑧</span><span> </span><span>타인의</span><span> </span
  ><span>개인정보를</span><span> </span><span>침해하거나</span
  ><span> </span><span>명예훼손</span><span> </span><span>및</span
  ><span> </span><span>모욕하는</span><span> </span><span>내용</span
  ><span> </span><span>⑨</span><span> </span><span>현금</span
  ><span> </span><span>및</span><span> </span><span>현물을</span
  ><span> </span><span>이용한</span><span> </span><span>거래와</span
  ><span> </span><span>관련된</span><span> </span><span>내용</span
  ><span> </span><span>⑩</span><span> </span><span>같은</span
  ><span> </span><span>내용을</span><span> </span><span>반복적</span
  ><span>(</span><span>도배성</span><span>)</span><span>으로</span
  ><span> </span><span>게시하는내용</span><span> </span><span>⑪</span
  ><span> </span><span>반사회적이거나</span><span> </span
  ><span>관계법령에</span><span> </span><span>저촉되는</span><span> </span
  ><span>내용</span><span> </span><span>⑫</span><span> </span
  ><span>기타</span><span> </span><span>각</span><span> </span
  ><span>게시판의</span><span> </span><span>용도와</span><span> </span
  ><span>무관하다고</span><span> </span><span>판단되는</span><span> </span
  ><span>내용</span><span> </span><span>⑬</span><span> </span
  ><span>저작권법에</span><span> </span><span>의거하여</span><span> </span
  ><span>저작권</span><span> </span><span>침해</span><span> </span
  ><span>소지가</span><span> </span><span>있다고</span><span> </span
  ><span>판단되는</span><span> </span><span>내용의</span><span> </span
  ><span>게시물</span><span> </span><span>및</span><span> </span
  ><span>파일</span>
</p>
<p
  style="
    margin-top: 14pt;
    margin-bottom: 14pt;
    line-height: normal;
    widows: 2;
    orphans: 2;
  "
>
  <span>4)</span><span>회사는</span><span> </span><span>각</span
  ><span> </span><span>커뮤니티</span><span> </span><span>게시판의</span
  ><span> </span><span>성격에</span><span> </span><span>맞지않는</span
  ><span> </span><span>글이나</span><span> </span><span>댓글은</span
  ><span> </span><span>다른</span><span> </span><span>게시판으로</span
  ><span> </span><span>이동시키거나</span><span> </span><span>삭제할</span
  ><span> </span><span>수</span><span> </span><span>있습니다</span
  ><span>.</span>
</p>
<p
  style="
    margin-top: 14pt;
    margin-bottom: 14pt;
    line-height: normal;
    widows: 2;
    orphans: 2;
  "
>
  <span>5)"</span><span>서비스</span><span>"</span><span>관련</span
  ><span> </span><span>커뮤니티</span><span> </span><span>내에</span
  ><span> </span><span>등록된</span><span> </span><span>게시물은</span
  ><span> </span><span>등록한</span><span> </span><span>회원</span
  ><span> </span><span>여러분께</span><span> </span><span>책임이</span
  ><span> </span><span>있습니다</span><span>.</span>
</p>
<p
  style="
    margin-top: 14pt;
    margin-bottom: 14pt;
    line-height: normal;
    widows: 2;
    orphans: 2;
  "
>
  <span>6)"</span><span>서비스</span><span>"</span><span>관련</span
  ><span> </span><span>커뮤니티는</span><span> </span><span>각</span
  ><span> </span><span>게시판에</span><span> </span><span>올린</span
  ><span> </span><span>회원</span><span> </span><span>여러분의</span
  ><span> </span><span>글을</span><span> </span><span>소중하게</span
  ><span> </span><span>관리하고</span><span> </span><span>유지하는데</span
  ><span> </span><span>최선을</span><span> </span><span>다합니다</span
  ><span>.</span><span>단</span><span>, </span><span>불의의</span
  ><span> </span><span>사고나</span><span> </span><span>자연재해</span
  ><span>, </span><span>기타</span><span> </span
  ><span>기술적인문제로</span><span> </span><span>발생하는</span
  ><span> </span><span>게시판</span><span> </span><span>데이터</span
  ><span> </span><span>손실에</span><span> </span><span>대하여</span
  ><span> </span><span>"</span><span>회사</span><span>"</span
  ><span>가책임을</span><span> </span><span>지지</span><span> </span
  ><span>않습니다</span><span>.</span>
</p>
<p
  style="
    margin-top: 14pt;
    margin-bottom: 14pt;
    line-height: normal;
    widows: 2;
    orphans: 2;
  "
>
  <span>7)"</span><span>서비스</span><span>"</span><span>관련</span
  ><span> </span><span>커뮤니티</span><span> </span><span>내에서</span
  ><span> </span><span>타인의</span><span> </span><span>명예를</span
  ><span> </span><span>훼손하거나</span><span> </span><span>이로</span
  ><span> </span><span>이한</span><span> </span><span>발생한</span
  ><span> </span><span>문제에</span><span> </span><span>대해서</span
  ><span> </span><span>이용자간의</span><span> </span><span>해결을</span
  ><span> </span><span>원칙으로</span><span> </span><span>하며</span
  ><span>, "</span><span>회사</span><span>"</span><span>는</span
  ><span> </span><span>책임을</span><span> </span><span>지지</span
  ><span> </span><span>않습니다</span><span>.</span>
</p>
<p
  style="
    margin-top: 14pt;
    margin-bottom: 14pt;
    line-height: normal;
    widows: 2;
    orphans: 2;
  "
>
  <span>12.</span><span>부칙</span>
</p>
<p
  style="
    margin-top: 14pt;
    margin-bottom: 14pt;
    line-height: normal;
    widows: 2;
    orphans: 2;
  "
>
  <span>본</span><span> </span><span>운영</span><span> </span
  ><span>정책은</span><span> </span><span>2026</span><span>년</span
  ><span> </span><span>5</span><span>월</span><span> </span><span>14</span
  ><span>일부로적용</span><span> </span><span>됩니다</span><span>.</span>
</p>
<p
  style="
    margin-top: 14pt;
    margin-bottom: 14pt;
    text-align: justify;
    line-height: normal;
    widows: 2;
    orphans: 2;
  "
>
  <span>&#xa0;</span>
</p>
<p><span style="-aw-import: ignore">&#xa0;</span></p>
</div>`;

export const operationPolicyHtml = `
<div>
<p
  style="margin-bottom: 14pt; line-height: normal; widows: 2; orphans: 2"
>
  <span>본</span><span> </span><span>운영정책은 BLANCOZONE NETWORK CO., LIMITED</span><span> </span
  ><span>(</span><span>이하</span><span> </span><span>"</span
  ><span>회사</span><span>")</span><span>가</span><span> </span
  ><span>게임</span><span> </span><span>관련</span><span> </span
  ><span>서비스</span><span>(</span><span>이하</span><span> </span
  ><span>'</span><span>서비스</span><span>')</span><span>를</span
  ><span> </span><span>고객이</span><span> </span><span>이용함에</span
  ><span> </span><span>있어</span><span> </span><span>발생할</span
  ><span> </span><span>수</span><span> </span><span>있는</span
  ><span> </span><span>문제에</span><span> </span><span>대해</span
  ><span>, </span><span>보다</span><span> </span><span>공정하고</span
  ><span> </span><span>형평성을</span><span> </span><span>기반으로</span
  ><span> </span><span>한</span><span> </span><span>서비스</span
  ><span> </span><span>제공</span><span> </span><span>및</span
  ><span> </span><span>고객의</span><span> </span><span>사용권</span
  ><span> </span><span>보호를</span><span> </span><span>목적으로</span
  ><span> </span><span>하고</span><span> </span><span>있습니다</span
  ><span>.</span>
</p>
<p
  style="
    margin-top: 14pt;
    margin-bottom: 14pt;
    line-height: normal;
    widows: 2;
    orphans: 2;
  "
>
  <span>회사는</span><span> </span><span>중립적이고</span><span>, </span
  ><span>객관적인</span><span> </span><span>입장에서</span><span> </span
  ><span>고객이</span><span> </span><span>쾌적한</span><span> </span
  ><span>환경을</span><span> </span><span>통해</span><span> </span
  ><span>서비스를</span><span> </span><span>받을</span><span> </span
  ><span>수</span><span> </span><span>있도록최선의</span><span> </span
  ><span>노력을</span><span> </span><span>다할</span><span> </span
  ><span>것을</span><span> </span><span>약속</span><span> </span
  ><span>드립니다</span><span>. </span><span>운영정책에는</span
  ><span> </span><span>서비스</span><span> </span><span>이용</span
  ><span> </span><span>시</span><span> </span><span>유의하셔야</span
  ><span> </span><span>할</span><span> </span><span>내용이</span
  ><span> </span><span>포함되어있으니</span><span> </span><span>주의</span
  ><span> </span><span>깊게</span><span> </span><span>확인하시기를</span
  ><span> </span><span>권해</span><span> </span><span>드립니다</span
  ><span>.</span>
</p>
<p
  style="
    margin-top: 14pt;
    margin-bottom: 14pt;
    line-height: normal;
    widows: 2;
    orphans: 2;
  "
>
  <span>1.</span><span>&#xa0;</span><span>총칙</span>
</p>
<p
  style="
    margin-top: 14pt;
    margin-bottom: 14pt;
    line-height: normal;
    widows: 2;
    orphans: 2;
  "
>
  <span>1)</span><span>이</span><span>"</span><span>운영정책</span
  ><span>"</span><span>은</span><span> </span><span>서비스</span
  ><span> </span><span>운영</span><span> </span><span>상</span
  ><span> </span><span>발생할</span><span> </span><span>수</span
  ><span> </span><span>있는</span><span> </span><span>문제점에</span
  ><span> </span><span>대해</span><span> </span
  ><span>합리적이며공정하게</span><span> </span><span>대처하기</span
  ><span> </span><span>위하여</span><span> </span><span>마련되었으며</span
  ><span>, "</span><span>회사</span><span>"</span><span>가서비스를</span
  ><span> </span><span>운영하고</span><span>, </span><span>회원</span
  ><span> </span><span>여러분이</span><span> </span><span>서비스를</span
  ><span> </span><span>이용함에</span><span> </span><span>있어</span
  ><span> </span><span>필요한</span><span> </span><span>세부</span
  ><span> </span><span>규칙을</span><span> </span><span>담고</span
  ><span> </span><span>있습니다</span><span>.</span>
</p>
<p
  style="
    margin-top: 14pt;
    margin-bottom: 14pt;
    line-height: normal;
    widows: 2;
    orphans: 2;
  "
>
  <span>2)"</span><span>회사</span><span>"</span><span>는서비스의</span
  ><span> </span><span>효율적인</span><span> </span><span>운영을</span
  ><span> </span><span>위해</span><span> </span><span>"</span
  ><span>운영정책</span><span>"</span><span>의내용을</span><span> </span
  ><span>추가</span><span>, </span><span>변경</span><span>, </span
  ><span>삭제할</span><span> </span><span>수</span><span> </span
  ><span>있습니다</span><span>. "</span><span>운영정책</span
  ><span>" </span><span>의</span><span> </span><span>내용이</span
  ><span> </span><span>추가</span><span>, </span><span>변경</span
  ><span>, </span><span>삭제될</span><span> </span><span>경우</span
  ><span> </span><span>"</span><span>회사</span><span>"</span
  ><span>는</span><span> </span><span>적용일자</span><span> </span
  ><span>7</span><span>일</span><span> </span><span>이전부터</span
  ><span> </span><span>서비스</span><span> </span><span>페이지의</span
  ><span> </span><span>'</span><span>공지사항</span><span>'</span
  ><span>을</span><span> </span><span>통해</span><span> </span
  ><span>공지하거나</span><span> </span><span>전자우편</span
  ><span>, </span><span>쪽지</span><span>, </span><span>기타</span
  ><span> </span><span>연락이</span><span> </span><span>가능한</span
  ><span> </span><span>통지</span><span> </span><span>방법</span
  ><span> </span><span>중</span><span> </span><span>하나를</span
  ><span> </span><span>택하여</span><span> </span><span>통지합니다</span
  ><span>. </span><span>단</span><span>, </span><span>회원</span
  ><span> </span><span>여러분께</span><span> </span><span>불리한</span
  ><span> </span><span>내용</span><span> </span><span>또는</span
  ><span> </span><span>중요한</span><span> </span><span>내용의</span
  ><span> </span><span>경우</span><span> </span><span>30</span
  ><span>일</span><span> </span><span>전에</span><span> </span
  ><span>'</span><span>공지사항</span><span>'</span><span>을통해</span
  ><span> </span><span>공지하거나</span><span> </span
  ><span>전자우편으로</span><span> </span><span>통지합니다</span
  ><span>.</span>
</p>
<p
  style="
    margin-top: 14pt;
    margin-bottom: 14pt;
    line-height: normal;
    widows: 2;
    orphans: 2;
  "
>
  <span>3)</span><span>이</span><span>"</span><span>운영정책</span
  ><span>"</span><span>은</span><span> </span><span>"</span
  ><span>약관</span><span>"</span><span>에</span><span> </span
  ><span>포함하기</span><span> </span><span>어려운</span><span> </span
  ><span>서비스</span><span> </span><span>운영의</span><span> </span
  ><span>세부</span><span> </span><span>규칙을</span><span> </span
  ><span>포함하고</span><span> </span><span>있으며</span><span>, </span
  ><span>약관의일부를</span><span> </span><span>구성합니다</span
  ><span>. </span><span>이</span><span> </span><span>"</span
  ><span>운영정책</span><span>"</span><span>의</span><span> </span
  ><span>내용을</span><span> </span><span>회원</span><span> </span
  ><span>여러분께서</span><span> </span><span>알지</span><span> </span
  ><span>못하여</span><span> </span><span>발생한</span><span> </span
  ><span>피해에</span><span> </span><span>대해서는</span><span> </span
  ><span>도움을</span><span> </span><span>드리기</span><span> </span
  ><span>어려우므로</span><span>, </span><span>이</span><span> </span
  ><span>"</span><span>운영정책</span><span>"</span><span>의내용을</span
  ><span> </span><span>반드시</span><span> </span><span>확인하시기</span
  ><span> </span><span>바랍니다</span><span>.</span>
</p>
<p
  style="
    margin-top: 14pt;
    margin-bottom: 14pt;
    line-height: normal;
    widows: 2;
    orphans: 2;
  "
>
  <span>4)</span><span>이</span><span>"</span><span>운영정책</span
  ><span>"</span><span>에</span><span> </span><span>명시되지</span
  ><span> </span><span>않은</span><span> </span><span>사항에</span
  ><span> </span><span>대해서는</span><span> </span><span>이용약관</span
  ><span>, </span><span>관계</span><span> </span><span>법령</span
  ><span>, </span><span>그리고</span><span> </span><span>회원</span
  ><span> </span><span>여러분과</span><span>"</span><span>회사</span
  ><span>"</span><span>가</span><span> </span><span>공유</span
  ><span> </span><span>하는</span><span> </span><span>일반적인</span
  ><span> </span><span>사회적</span><span> </span><span>통념에</span
  ><span> </span><span>의하여</span><span> </span><span>처리되거나</span
  ><span>, </span><span>그에</span><span> </span><span>준하는</span
  ><span> </span><span>기준에</span><span> </span><span>의하여</span
  ><span> </span><span>사안을</span><span> </span><span>처리</span
  ><span> </span><span>합니다</span><span>.</span>
</p>
<p
  style="
    margin-top: 14pt;
    margin-bottom: 14pt;
    line-height: normal;
    widows: 2;
    orphans: 2;
  "
>
  <span>2. "</span><span>회원</span><span>"</span><span>의</span
  ><span> </span><span>의무와</span><span> </span><span>권리</span>
</p>
<p
  style="
    margin-top: 14pt;
    margin-bottom: 14pt;
    line-height: normal;
    widows: 2;
    orphans: 2;
  "
>
  <span>1)"</span><span>회사</span><span>"</span><span>는회원</span
  ><span> </span><span>여러분께</span><span> </span><span>양질의</span
  ><span> </span><span>서비스를</span><span> </span><span>제공하고자</span
  ><span> </span><span>노력하고</span><span> </span><span>있습니다</span
  ><span>. </span><span>다만</span><span>,"</span><span>회사</span
  ><span>"</span><span>는</span><span> </span><span>회원</span
  ><span> </span><span>여러분께서</span><span> </span><span>양질의</span
  ><span> </span><span>서비스를</span><span> </span><span>쾌적하게</span
  ><span> </span><span>이용하시기</span><span> </span
  ><span>위해서아래와</span><span> </span><span>같은</span><span> </span
  ><span>몇</span><span> </span><span>가지</span><span> </span
  ><span>사항을</span><span> </span><span>지켜주실</span><span> </span
  ><span>것을</span><span> </span><span>부탁</span><span> </span
  ><span>드립니다</span><span>.</span>
</p>
<p
  style="
    margin-top: 14pt;
    margin-bottom: 14pt;
    line-height: normal;
    widows: 2;
    orphans: 2;
  "
>
  <span>2)</span><span>회원</span><span> </span><span>여러분께서는</span
  ><span> </span><span>회원</span><span> </span><span>본인의</span
  ><span> </span><span>정보로</span><span> </span><span>회원가입</span
  ><span>&#xa0;</span><span>또는</span><span> </span><span>서비스를</span
  ><span> </span><span>이용해</span><span> </span><span>주셔야</span
  ><span> </span><span>합니다</span><span>. </span><span>타인의</span
  ><span> </span><span>정보</span><span> </span><span>또는</span
  ><span> </span><span>허위</span><span> </span><span>정보를</span
  ><span> </span><span>이용하여</span><span> </span><span>회원가입</span
  ><span> </span><span>또는</span><span> </span><span>서비스를</span
  ><span>&#xa0;</span><span>이용하시는</span><span> </span
  ><span>경우</span><span> </span><span>"</span><span>회사</span
  ><span>"</span><span>는</span><span> </span><span>이에</span
  ><span> </span><span>대하여</span><span>&#xa0;</span><span>어떠한</span
  ><span> </span><span>도움도</span><span> </span><span>드리지</span
  ><span> </span><span>않으며</span><span>, "</span><span>회사</span
  ><span>"</span><span>가</span><span>&#xa0;</span><span>제공하는</span
  ><span> </span><span>각종</span><span> </span><span>혜택</span
  ><span> </span><span>또한</span><span> </span><span>제공해드리지</span
  ><span> </span><span>않습니다</span><span>.</span>
</p>
<p
  style="
    margin-top: 14pt;
    margin-bottom: 14pt;
    line-height: normal;
    widows: 2;
    orphans: 2;
  "
>
  <span>3)"</span><span>회사</span><span>"</span><span>는</span
  ><span>&#xa0;</span><span>아이템</span><span> </span><span>및</span
  ><span> </span><span>계정의</span><span> </span><span>공유</span
  ><span> </span><span>및</span><span> </span><span>양도</span
  ><span>, </span><span>현금</span><span> </span><span>거래를</span
  ><span> </span><span>인정하지</span><span> </span><span>않습니다</span
  ><span>. </span><span>이로인해</span><span> </span><span>발생하는</span
  ><span> </span><span>문제</span><span>(</span><span>사기</span
  ><span>, </span><span>계정도용</span><span> </span><span>등</span
  ><span>)</span><span>에</span><span> </span><span>대해서는</span
  ><span> </span><span>도움을</span><span> </span><span>드리기</span
  ><span> </span><span>어려우므로</span><span> </span><span>아이템</span
  ><span> </span><span>및</span><span> </span><span>계정의</span
  ><span> </span><span>공유</span><span>, </span><span>거래</span
  ><span>, </span><span>양도에</span><span> </span><span>대해서는</span
  ><span> </span><span>신중히</span><span> </span><span>결정해</span
  ><span> </span><span>주시기</span><span> </span><span>바랍니다</span
  ><span>.</span>
</p>
<p
  style="
    margin-top: 14pt;
    margin-bottom: 14pt;
    line-height: normal;
    widows: 2;
    orphans: 2;
  "
>
  <span>4)</span><span>회원</span><span> </span><span>여러분께서는</span
  ><span> </span><span>"</span><span>회사</span><span>"</span
  ><span>의</span><span> </span><span>서비스를</span><span> </span
  ><span>이용하여</span><span> </span><span>얻은</span><span> </span
  ><span>정보를</span><span> </span><span>"</span><span>회사</span
  ><span>"</span><span>의</span><span> </span><span>사전</span
  ><span> </span><span>동의</span><span> </span><span>없이</span
  ><span> </span><span>복사</span><span>/</span><span>&#xa0;</span
  ><span>복제</span><span>/</span><span>&#xa0;</span><span>변경</span
  ><span>/ </span><span>번역</span><span>/</span><span>&#xa0;</span
  ><span>출판</span><span>/</span><span>&#xa0;</span><span>방송</span
  ><span> </span><span>등의</span><span> </span><span>방법으로</span
  ><span> </span><span>사용하거나</span><span>, </span><span>이를</span
  ><span> </span><span>타인에게</span><span> </span><span>제공하실</span
  ><span> </span><span>수</span><span> </span><span>없습니다</span
  ><span>. </span><span>해당</span><span> </span><span>행위로</span
  ><span> </span><span>인한</span><span> </span><span>모든</span
  ><span> </span><span>결과에</span><span> </span><span>대한</span
  ><span> </span><span>책임은</span><span> </span><span>회원에게</span
  ><span> </span><span>있으며</span><span> </span><span>“</span
  ><span>회사</span><span>”</span><span>에</span><span> </span
  ><span>손해가</span><span> </span><span>발생할</span><span> </span
  ><span>경우</span><span> </span><span>“</span><span>회사</span
  ><span>”</span><span>는</span><span> </span><span>해당</span
  ><span> </span><span>회원에게</span><span> </span><span>대한</span
  ><span> </span><span>손해배상</span><span> </span><span>등을</span
  ><span> </span><span>청구할</span><span> </span><span>수</span
  ><span> </span><span>있습니다</span><span>.</span>
</p>
<p
  style="
    margin-top: 14pt;
    margin-bottom: 14pt;
    line-height: normal;
    widows: 2;
    orphans: 2;
  "
>
  <span>5)</span><span>회원</span><span> </span><span>여러분께서는</span
  ><span> </span><span>운영진</span><span> </span><span>사칭</span
  ><span>, </span><span>업무</span><span> </span><span>관여</span
  ><span>, </span><span>중재</span><span> </span><span>방해</span
  ><span> </span><span>등</span><span> </span><span>운영진의</span
  ><span> </span><span>업무를</span><span> </span><span>방해하는</span
  ><span> </span><span>행위를</span><span> </span
  ><span>하셔서는안됩니다</span><span>. </span><span>운영진의</span
  ><span> </span><span>업무를</span><span> </span><span>방해하는</span
  ><span> </span><span>행위를</span><span> </span><span>할</span
  ><span> </span><span>경우</span><span> </span><span>서비스</span
  ><span> </span><span>이용에</span><span> </span><span>제한을</span
  ><span> </span><span>받으실</span><span> </span><span>수</span
  ><span> </span><span>있습니다</span><span>.</span>
</p>
<p
  style="
    margin-top: 14pt;
    margin-bottom: 14pt;
    line-height: normal;
    widows: 2;
    orphans: 2;
  "
>
  <span>6)</span><span>회원</span><span> </span><span>여러분께서는</span
  ><span> </span><span>게임의</span><span> </span><span>취약점</span
  ><span>(</span><span>버그</span><span>, </span><span>계정도용</span
  ><span>, </span><span>불법프로그램</span><span>)</span><span>을</span
  ><span> </span><span>발견했을</span><span> </span><span>경우</span
  ><span> </span><span>반드시</span><span> </span><span>1:1</span
  ><span>문의</span><span> </span><span>등으로</span><span> </span
  ><span>신고해</span><span> </span><span>주셔야</span><span> </span
  ><span>합니다</span><span>. </span><span>신고를</span><span> </span
  ><span>하지</span><span> </span><span>않고</span><span> </span
  ><span>이를</span><span> </span><span>악용하거나</span><span> </span
  ><span>타인에게</span><span> </span><span>전달하는</span><span> </span
  ><span>경우</span><span>, </span><span>의도적인</span><span>&#xa0;</span
  ><span>불건전</span><span> </span><span>행위로</span><span> </span
  ><span>판단하여</span><span> </span><span>불이익을</span><span> </span
  ><span>받으실</span><span> </span><span>수</span><span> </span
  ><span>있습니다</span><span>. </span><span>다음에</span><span> </span
  ><span>해당할</span><span> </span><span>경우에는</span><span> </span
  ><span>사전</span><span> </span><span>경고</span><span> </span
  ><span>없이</span><span> </span><span>서비스이용</span><span> </span
  ><span>제한</span><span> </span><span>조치가</span><span> </span
  ><span>될</span><span> </span><span>수</span><span> </span
  ><span>있으므로</span><span> </span><span>주의</span><span> </span
  ><span>바랍니다</span><span>.</span><span> </span><span>①</span
  ><span> </span><span>시스템의</span><span> </span><span>문제점을</span
  ><span> </span><span>통한</span><span> </span><span>악용</span
  ><span> </span><span>행위</span><span> </span><span>②</span
  ><span> </span><span>버그를</span><span> </span><span>알리지</span
  ><span> </span><span>않고</span><span> </span><span>이를</span
  ><span> </span><span>유포</span><span> </span><span>및</span
  ><span> </span><span>악용하는</span><span> </span><span>행위</span
  ><span> </span><span>③</span><span> "</span><span>회사</span
  ><span>"</span><span>에서</span><span> </span><span>인정하지</span
  ><span> </span><span>않은</span><span>&#xa0;</span
  ><span>불법프로그램</span><span>("</span><span>회사</span><span>"</span
  ><span>로부터</span><span> </span><span>공식적으로</span><span> </span
  ><span>전달받거나승인되지</span><span> </span><span>않은</span
  ><span> </span><span>프로그램</span><span>)</span><span>을</span
  ><span> </span><span>사용하는</span><span> </span><span>행위</span
  ><span> </span><span>④</span><span> </span><span>클라이언트의</span
  ><span> </span><span>무단</span><span> </span><span>변조</span
  ><span> </span><span>행위</span><span> </span><span>⑤</span
  ><span> </span><span>시스템의</span><span> </span><span>불안정을</span
  ><span> </span><span>이용하여</span><span> </span><span>다른</span
  ><span> </span><span>회원의</span><span> </span><span>게임플레이를</span
  ><span> </span><span>방해하는</span><span> </span><span>행위</span
  ><span> </span><span>⑥</span><span> </span><span>데이터</span
  ><span> </span><span>조작</span><span> </span><span>및</span
  ><span> </span><span>추출행위</span><span> </span><span>⑦</span
  ><span> </span><span>그</span><span> </span><span>외</span><span> </span
  ><span>운영진의</span><span> </span><span>판단에</span><span> </span
  ><span>"</span><span>운영정책</span><span>"</span><span>과</span
  ><span>&#xa0;</span><span>어긋난다고</span><span> </span
  ><span>판단되는</span><span> </span><span>행위</span>
</p>
<p
  style="
    margin-top: 14pt;
    margin-bottom: 14pt;
    line-height: normal;
    widows: 2;
    orphans: 2;
  "
>
  <span>7)</span><span>회원</span><span> </span><span>여러분께서는</span
  ><span> </span><span>고객센터를</span><span> </span><span>통해</span
  ><span> </span><span>"</span><span>서비스</span><span>" </span
  ><span>와</span><span> </span><span>관련된</span><span> </span
  ><span>문의를</span><span> </span><span>하실</span><span> </span
  ><span>수</span><span> </span><span>있습니다</span><span>.</span>
</p>
<p
  style="
    margin-top: 14pt;
    margin-bottom: 14pt;
    line-height: normal;
    widows: 2;
    orphans: 2;
  "
>
  <span>8)</span><span>회원</span><span> </span><span>여러분께서</span
  ><span> </span><span>서비스</span><span> </span><span>이용</span
  ><span> </span><span>과정에서</span><span> </span
  ><span>부당한피해를</span><span> </span><span>당한</span><span> </span
  ><span>경우</span><span>, </span><span>정당한</span><span> </span
  ><span>방법을</span><span> </span><span>통하여</span><span> </span
  ><span>피해</span><span> </span><span>회복을</span><span> </span
  ><span>위한</span><span> </span><span>권리를</span><span> </span
  ><span>행사할</span><span> </span><span>수</span><span> </span
  ><span>있습니다</span><span>. "</span><span>회사</span><span>"</span
  ><span>는</span><span> </span><span>회원</span><span> </span
  ><span>여러분의</span><span> </span><span>정당한</span><span> </span
  ><span>권리를</span><span> </span><span>보호하기위해</span><span> </span
  ><span>최선을</span><span> </span><span>다할</span><span> </span
  ><span>것을</span><span> </span><span>약속합니다</span><span>.</span>
</p>
<p
  style="
    margin-top: 14pt;
    margin-bottom: 14pt;
    line-height: normal;
    widows: 2;
    orphans: 2;
  "
>
  <span>3.</span><span>&#xa0;</span><span>계정</span><span> </span
  ><span>관리</span>
</p>
<p
  style="
    margin-top: 14pt;
    margin-bottom: 14pt;
    line-height: normal;
    widows: 2;
    orphans: 2;
  "
>
  <span>1)</span><span>회원</span><span> </span><span>여러분께서</span
  ><span> </span><span>사용하시는</span><span> </span><span>계정에</span
  ><span> </span><span>대한모든</span><span> </span><span>책임은</span
  ><span> </span><span>일차적으로</span><span> </span><span>회원</span
  ><span> </span><span>여러분에게</span><span> </span><span>있습니다</span
  ><span>.</span>
</p>
<p
  style="
    margin-top: 14pt;
    margin-bottom: 14pt;
    line-height: normal;
    widows: 2;
    orphans: 2;
  "
>
  <span>2)</span><span>회원</span><span> </span><span>여러분이</span
  ><span> </span><span>자신의</span><span> </span><span>개인정보</span
  ><span> </span><span>또는</span><span> </span><span>계정을</span
  ><span>&#xa0;</span><span>타인과</span><span> </span
  ><span>공유하거나</span><span> </span><span>비정상적인</span
  ><span> </span><span>방법으로</span><span> </span><span>양도</span
  ><span>/</span><span>매매한</span><span> </span><span>경우</span
  ><span> </span><span>"</span><span>회사</span><span>"</span
  ><span>는</span><span> </span><span>이를</span><span> </span
  ><span>인정하지</span><span> </span><span>않으며</span><span> </span
  ><span>이로</span><span> </span><span>인해</span><span> </span
  ><span>발생하는</span><span> </span><span>모든</span><span> </span
  ><span>문제</span><span>(</span><span>사기</span><span>, </span
  ><span>계정도용</span><span> </span><span>피해</span><span> </span
  ><span>등</span><span>)</span><span>에</span><span> </span
  ><span>대해서는</span><span>"</span><span>회사</span><span>"</span
  ><span>의</span><span> </span><span>보호를</span><span> </span
  ><span>받으실</span><span> </span><span>수</span><span> </span
  ><span>없습니다</span><span>.</span>
</p>
<p
  style="
    margin-top: 14pt;
    margin-bottom: 14pt;
    line-height: normal;
    widows: 2;
    orphans: 2;
  "
>
  <span>3)</span><span>회원</span><span> </span><span>여러분께서</span
  ><span> </span><span>계정</span><span>, </span><span>캐릭터</span
  ><span>, </span><span>아이템의</span><span> </span><span>현금</span
  ><span>/</span><span>현물거래를</span><span> </span><span>시도할</span
  ><span> </span><span>경우</span><span> </span><span>경고</span
  ><span> </span><span>없이</span><span> </span><span>이용</span
  ><span> </span><span>권한이</span><span> </span><span>박탈</span
  ><span> </span><span>될</span><span> </span><span>수</span><span> </span
  ><span>있으며</span><span>, </span><span>이로</span><span> </span
  ><span>인해</span><span> </span><span>발생하는</span><span> </span
  ><span>문제에</span><span> </span><span>대해서는도움을</span
  ><span> </span><span>드리기</span><span> </span><span>어렵습니다</span
  ><span>.</span>
</p>
<p
  style="
    margin-top: 14pt;
    margin-bottom: 14pt;
    line-height: normal;
    widows: 2;
    orphans: 2;
  "
>
  <span>4)</span><span>회원</span><span> </span><span>여러분께서</span
  ><span> </span><span>사용하시는</span><span> </span><span>계정의</span
  ><span> </span><span>비밀번호는</span><span>&#xa0;</span
  ><span>주기적으로</span><span> </span><span>변경함으로써</span
  ><span> </span><span>계정</span><span> </span><span>도용</span
  ><span> </span><span>등</span><span> </span><span>타인의</span
  ><span> </span><span>부정한</span><span> </span><span>행위로부터</span
  ><span> </span><span>자신의</span><span> </span><span>정보를</span
  ><span> </span><span>보호할</span><span> </span><span>수</span
  ><span> </span><span>있습니다</span><span>.</span>
</p>
<p
  style="
    margin-top: 14pt;
    margin-bottom: 14pt;
    line-height: normal;
    widows: 2;
    orphans: 2;
  "
>
  <span>5)</span><span>사기는</span><span> </span><span>개인</span
  ><span> </span><span>과실에</span><span> </span><span>의해</span
  ><span> </span><span>발생되는</span><span> </span><span>경우가</span
  ><span>&#xa0;</span><span>대부분으로</span><span>, </span
  ><span>이로</span><span> </span><span>인해</span><span> </span
  ><span>발생한</span><span> </span><span>피해에</span><span> </span
  ><span>대해서는</span><span> </span><span>도움을</span><span> </span
  ><span>드리기는</span><span> </span><span>어렵습니다</span
  ><span>. </span><span>따라서</span><span> </span><span>비슷한</span
  ><span> </span><span>캐릭터</span><span> </span><span>명</span
  ><span> </span><span>생성을</span><span> </span><span>통한</span
  ><span> </span><span>지인</span><span> </span><span>사칭</span
  ><span>, </span><span>친분을</span><span> </span><span>이용한사기</span
  ><span> </span><span>등의</span><span> </span><span>피해를</span
  ><span> </span><span>입지</span><span> </span><span>않도록</span
  ><span> </span><span>거래</span><span> </span><span>또는</span
  ><span> </span><span>아이템</span><span> </span><span>이동</span
  ><span> </span><span>시</span><span> </span><span>각별히</span
  ><span> </span><span>주의하시기를</span><span> </span><span>당부</span
  ><span> </span><span>드립니다</span><span>.</span>
</p>
<p
  style="
    margin-top: 14pt;
    margin-bottom: 14pt;
    line-height: normal;
    widows: 2;
    orphans: 2;
  "
>
  <span>4.</span><span>&#xa0;</span><span>명칭</span><span> </span
  ><span>관리</span><span> </span><span>기준</span>
</p>
<p
  style="
    margin-top: 14pt;
    margin-bottom: 14pt;
    line-height: normal;
    widows: 2;
    orphans: 2;
  "
>
  <span>회원여러분께서는</span><span> </span><span>캐릭터</span
  ><span> </span><span>명</span><span>, </span><span>길드</span
  ><span> </span><span>명</span><span> </span><span>등</span><span> </span
  ><span>서비스</span><span> </span><span>내에서</span><span> </span
  ><span>사용되는</span><span> </span><span>모든</span><span> </span
  ><span>명칭을</span><span> </span><span>자유롭게</span><span> </span
  ><span>생성하실</span><span> </span><span>수</span><span> </span
  ><span>있습니다</span><span>. </span><span>단</span><span>, </span
  ><span>다음과</span><span> </span><span>같은</span><span> </span
  ><span>경우에는</span><span> </span><span>적발</span><span> </span
  ><span>시</span><span> </span><span>경고</span><span>, </span
  ><span>운영진의</span><span> </span><span>직권</span><span> </span
  ><span>변경</span><span> </span><span>또는</span><span> </span
  ><span>"</span><span>운영정책</span><span>"</span><span>에</span
  ><span> </span><span>따른</span><span> </span><span>제재가</span
  ><span> </span><span>이루어질</span><span> </span><span>수</span
  ><span> </span><span>있으므로</span><span> </span
  ><span>주의하시기를</span><span> </span><span>당부</span><span> </span
  ><span>드립니다</span><span>.</span>
</p>
<p
  style="
    margin-top: 14pt;
    margin-bottom: 14pt;
    line-height: normal;
    widows: 2;
    orphans: 2;
  "
>
  <span>1)</span><span>타인에게</span><span> </span><span>불쾌감을</span
  ><span> </span><span>주는</span><span> </span><span>명칭</span
  ><span> </span><span>2)</span><span>욕설</span><span> </span
  ><span>및</span><span> </span><span>비속어</span><span>, </span
  ><span>광고</span><span>, </span><span>선정적이거나</span><span> </span
  ><span>음란한</span><span> </span><span>내용이</span><span> </span
  ><span>포함된</span><span> </span><span>명칭</span><span> </span
  ><span>3)</span><span>인종</span><span> </span><span>및</span
  ><span> </span><span>성차별적인</span><span> </span><span>명칭</span
  ><span> </span><span>4)</span><span>특정인이나</span><span> </span
  ><span>지역</span><span>, </span><span>집단</span><span>, </span
  ><span>종교에</span><span> </span><span>대한</span><span> </span
  ><span>비하의</span><span> </span><span>내용을</span><span> </span
  ><span>담은</span><span> </span><span>명칭</span><span> </span
  ><span>5)"</span><span>회사</span><span>",</span><span>서비스</span
  ><span>, </span><span>원작과</span><span> </span><span>관련된</span
  ><span> </span><span>자</span><span> </span><span>또는</span
  ><span> </span><span>이를</span><span> </span><span>사칭할</span
  ><span> </span><span>의도가</span><span> </span><span>있다고</span
  ><span> </span><span>판단되는</span><span> </span><span>명칭</span
  ><span> </span><span>6)'</span><span>운영자</span><span>','</span
  ><span>도우미</span><span>', 'GM' </span><span>등</span><span> </span
  ><span>서비스를</span><span> </span><span>운영하는</span><span> </span
  ><span>자로</span><span> </span><span>인식되거나</span><span> </span
  ><span>오인될</span><span> </span><span>수</span><span> </span
  ><span>있는</span><span> </span><span>명칭</span><span> </span
  ><span>7)</span><span>아이템</span><span>,</span><span>계정의</span
  ><span> </span><span>현금거래를</span><span> </span
  ><span>유인하거나</span><span> </span><span>현금거래의</span
  ><span> </span><span>의도를</span><span> </span><span>가지고</span
  ><span> </span><span>생성한</span><span> </span><span>것으로</span
  ><span> </span><span>판단되는</span><span> </span><span>명칭</span
  ><span> </span><span>8)</span><span>반사회적이거나</span><span> </span
  ><span>반사회적인</span><span> </span><span>인물</span><span>, </span
  ><span>집단을</span><span> </span><span>미화할</span><span> </span
  ><span>의도를</span><span> </span><span>가지고</span><span> </span
  ><span>생성한</span><span> </span><span>것으로</span><span> </span
  ><span>판단되는</span><span> </span><span>명칭</span><span> </span
  ><span>9)</span><span>제</span><span>3</span><span>자의상표</span
  ><span>, </span><span>서비스</span><span> </span><span>표</span
  ><span>, </span><span>저작권을</span><span> </span><span>침해할</span
  ><span> </span><span>가능성이</span><span> </span><span>있다고</span
  ><span> </span><span>판단되는명칭</span><span> </span><span>10)</span
  ><span>특정</span><span> </span><span>상품이나</span><span> </span
  ><span>사이트의</span><span> </span><span>광고</span><span>(</span
  ><span>비영리</span><span> </span><span>사이트</span><span> </span
  ><span>포함</span><span>) </span><span>목적이</span><span> </span
  ><span>있다고</span><span> </span><span>판단되는</span><span> </span
  ><span>명칭</span>
</p>
<p
  style="
    margin-top: 14pt;
    margin-bottom: 14pt;
    line-height: normal;
    widows: 2;
    orphans: 2;
  "
>
  <span>5.</span><span>&#xa0;</span><span>복구</span><span> </span
  ><span>기준</span>
</p>
<p
  style="
    margin-top: 14pt;
    margin-bottom: 14pt;
    line-height: normal;
    widows: 2;
    orphans: 2;
  "
>
  <span>1)</span><span>기술적인</span><span> </span><span>오류로</span
  ><span> </span><span>아이템이나</span><span> </span><span>캐릭터</span
  ><span> </span><span>정보의소실</span><span>, </span><span>변경된</span
  ><span> </span><span>경우</span><span> </span><span>정보가</span
  ><span> </span><span>확인되는</span><span> </span><span>범위</span
  ><span> </span><span>내에서</span><span> </span><span>복구가</span
  ><span> </span><span>가능</span><span> </span><span>합니다</span
  ><span>.</span><span>단</span><span>, </span><span>회원</span
  ><span> </span><span>여러분</span><span> </span><span>스스로의</span
  ><span> </span><span>과실이나</span><span> </span><span>"</span
  ><span>운영정책</span><span>"</span><span>에</span><span> </span
  ><span>명시된</span><span> </span><span>내용</span><span>, </span
  ><span>게임</span><span> </span><span>내</span><span> </span
  ><span>공지</span><span> </span><span>사항에</span><span> </span
  ><span>공지한</span><span> </span><span>내용</span><span> </span
  ><span>등을사전에</span><span> </span><span>숙지하지</span><span> </span
  ><span>못하여</span><span> </span><span>발생한</span><span> </span
  ><span>부분에</span><span> </span><span>대해서는</span><span> </span
  ><span>"</span><span>회사</span><span>"</span><span>가도움을</span
  ><span> </span><span>드리기</span><span> </span><span>어렵습니다</span
  ><span>.</span>
</p>
<p
  style="
    margin-top: 14pt;
    margin-bottom: 14pt;
    line-height: normal;
    widows: 2;
    orphans: 2;
  "
>
  <span>2)</span><span>사기는</span><span> </span><span>개인</span
  ><span> </span><span>과실에</span><span> </span><span>의해</span
  ><span> </span><span>발생하는</span><span> </span><span>경우가</span
  ><span>&#xa0;</span><span>대부분으로</span><span>, </span
  ><span>사기로</span><span> </span><span>인해</span><span> </span
  ><span>발생된</span><span> </span><span>피해는</span><span> </span
  ><span>"</span><span>회사</span><span>"</span><span>가</span
  ><span> </span><span>도움을</span><span> </span><span>드리기</span
  ><span> </span><span>어렵습니다</span><span>. </span><span>다만</span
  ><span> </span><span>추가</span><span> </span><span>피해</span
  ><span> </span><span>예방을</span><span> </span><span>위해조사를</span
  ><span> </span><span>진행하여</span><span> </span><span>확인된</span
  ><span> </span><span>가해</span><span> </span><span>계정은</span
  ><span> </span><span>"</span><span>운영정책</span><span>"</span
  ><span>에따라</span><span> </span><span>서비스</span><span> </span
  ><span>이용이</span><span> </span><span>제한됩니다</span><span>.</span>
</p>
<p
  style="
    margin-top: 14pt;
    margin-bottom: 14pt;
    line-height: normal;
    widows: 2;
    orphans: 2;
  "
>
  <span>3)</span><span>복구</span><span> </span><span>신청은</span
  ><span> </span><span>문제가</span><span> </span><span>발생한</span
  ><span> </span><span>날로부터</span><span> </span><span>14</span
  ><span>일이내에</span><span> </span><span>1:1</span><span>문의</span
  ><span> </span><span>등을</span><span> </span><span>통해</span
  ><span> </span><span>"</span><span>회사</span><span>"</span
  ><span>에</span><span> </span><span>접수를</span><span> </span
  ><span>하셔야</span><span> </span><span>하며</span><span>, </span
  ><span>문의</span><span> </span><span>접수</span><span> </span
  ><span>기간이</span><span> </span><span>지나면</span><span> </span
  ><span>복구에</span><span> </span><span>도움을</span><span> </span
  ><span>드리기</span><span> </span><span>어렵습니다</span><span>.</span>
</p>
<p
  style="
    margin-top: 14pt;
    margin-bottom: 14pt;
    line-height: normal;
    widows: 2;
    orphans: 2;
  "
>
  <span>4)</span><span>고객의</span><span> </span><span>고의</span
  ><span> </span><span>또는</span><span> </span><span>과실에</span
  ><span> </span><span>의한</span><span> </span><span>재화</span
  ><span>/</span><span>아이템</span><span>/</span><span>경험치</span
  ><span> </span><span>등의</span><span> </span><span>손실은</span
  ><span> </span><span>복구가</span><span> </span><span>불가합니다</span
  ><span>.</span>
</p>
<p
  style="
    margin-top: 14pt;
    margin-bottom: 14pt;
    line-height: normal;
    widows: 2;
    orphans: 2;
  "
>
  <span>5)</span><span>아이템</span><span> </span><span>강화를</span
  ><span> </span><span>통한</span><span> </span><span>소모나</span
  ><span> </span><span>유저간의</span><span> </span
  ><span>아이템거래부분은</span><span> </span><span>복구</span
  ><span> </span><span>도움을</span><span> </span><span>드리지</span
  ><span> </span><span>않습니다</span><span>.</span>
</p>
<p
  style="
    margin-top: 14pt;
    margin-bottom: 14pt;
    line-height: normal;
    widows: 2;
    orphans: 2;
  "
>
  <span>6)</span><span>상점에</span><span> </span><span>판매하거나</span
  ><span> </span><span>잘못</span><span> </span><span>장착하여</span
  ><span> </span><span>소실된</span><span>&#xa0;</span><span>장비</span
  ><span> </span><span>아이템은</span><span> </span><span>복구</span
  ><span> </span><span>도움을</span><span> </span><span>드리지</span
  ><span> </span><span>않습니다</span><span>.</span>
</p>
<p
  style="
    margin-top: 14pt;
    margin-bottom: 14pt;
    line-height: normal;
    widows: 2;
    orphans: 2;
  "
>
  <span>7)</span><span>문의</span><span> </span><span>접수는</span
  ><span> </span><span>문제가</span><span> </span><span>발생한</span
  ><span> </span><span>계정</span><span> </span><span>본인이</span
  ><span>&#xa0;</span><span>직접</span><span> </span><span>접수해야</span
  ><span> </span><span>하며</span><span>, </span><span>타인의</span
  ><span> </span><span>대리</span><span> </span><span>접수는</span
  ><span> </span><span>인정되지</span><span> </span><span>않습니다</span
  ><span>.</span>
</p>
<p
  style="
    margin-top: 14pt;
    margin-bottom: 14pt;
    line-height: normal;
    widows: 2;
    orphans: 2;
  "
>
  <span>6.</span><span>&#xa0;</span><span>운영진의</span><span> </span
  ><span>의무와</span><span> </span><span>역할</span>
</p>
<p
  style="
    margin-top: 14pt;
    margin-bottom: 14pt;
    line-height: normal;
    widows: 2;
    orphans: 2;
  "
>
  <span>1)</span><span>운영진은</span><span> </span><span>회원</span
  ><span> </span><span>여러분이</span><span> </span><span>즐겁게</span
  ><span> </span><span>게임</span><span> </span
  ><span>서비스를이용하실</span><span> </span><span>수</span><span> </span
  ><span>있는</span><span> </span><span>최선의</span><span> </span
  ><span>환경을</span><span> </span><span>제공하기</span><span> </span
  ><span>위해</span><span> </span><span>필요한</span><span> </span
  ><span>역할을</span><span> </span><span>수행합니다</span><span>.</span>
</p>
<p
  style="
    margin-top: 14pt;
    margin-bottom: 14pt;
    line-height: normal;
    widows: 2;
    orphans: 2;
  "
>
  <span>2)</span><span>운영진은</span><span> </span><span>중립적인</span
  ><span> </span><span>위치에서</span><span> </span><span>주어진</span
  ><span> </span><span>역할을</span><span>&#xa0;</span
  ><span>수행하며</span><span>, </span><span>회원</span><span> </span
  ><span>간</span><span> </span><span>분쟁에</span><span> </span
  ><span>개입하지</span><span> </span><span>않습니다</span><span>. </span
  ><span>다만</span><span>, "</span><span>운영정책</span><span>" </span
  ><span>을</span><span> </span><span>위반하는</span><span> </span
  ><span>내용이나</span><span> </span><span>정상적인</span><span> </span
  ><span>서비스운영이</span><span> </span><span>어렵다고</span
  ><span> </span><span>판단되는</span><span> </span><span>경우에는</span
  ><span> </span><span>중립적인</span><span> </span><span>입장에서</span
  ><span> </span><span>사안에</span><span> </span><span>대해</span
  ><span> </span><span>검토한</span><span> </span><span>후</span
  ><span>, </span><span>필요한</span><span> </span><span>조치를</span
  ><span> </span><span>행할</span><span> </span><span>수있습니다</span
  ><span>.</span>
</p>
<p
  style="
    margin-top: 14pt;
    margin-bottom: 14pt;
    line-height: normal;
    widows: 2;
    orphans: 2;
  "
>
  <span>3)</span><span>운영진은</span><span> </span><span>이용약관</span
  ><span>, </span><span>개인정보취급</span><span>(</span><span>처리</span
  ><span>)</span><span>방침및</span><span> </span><span>이</span
  ><span> </span><span>"</span><span>운영정책</span><span>"</span
  ><span>을</span><span> </span><span>준수합니다</span><span>.</span>
</p>
<p
  style="
    margin-top: 14pt;
    margin-bottom: 14pt;
    line-height: normal;
    widows: 2;
    orphans: 2;
  "
>
  <span>4)</span><span>운영진은</span><span> </span><span>회원의</span
  ><span> </span><span>개인정보</span><span>(</span><span>신상정보</span
  ><span>, </span><span>비밀번호</span><span> </span><span>등</span
  ><span>)</span><span>를요구하지</span><span> </span><span>않으며</span
  ><span>, </span><span>회원의</span><span> </span><span>개인정보를</span
  ><span> </span><span>절대</span><span> </span><span>임의로</span
  ><span> </span><span>수정하거나</span><span> </span><span>유출하지</span
  ><span> </span><span>않습니다</span><span>. </span><span>단</span
  ><span>, </span><span>사법기관의</span><span> </span><span>정식</span
  ><span> </span><span>협조요청이</span><span> </span><span>있을</span
  ><span> </span><span>시에는</span><span> </span><span>해당</span
  ><span> </span><span>기관에</span><span> </span><span>제공할수</span
  ><span> </span><span>있습니다</span><span>.</span>
</p>
<p
  style="
    margin-top: 14pt;
    margin-bottom: 14pt;
    line-height: normal;
    widows: 2;
    orphans: 2;
  "
>
  <span>5)</span><span>운영진은</span><span> </span><span>회원</span
  ><span> </span><span>여러분의</span><span> </span><span>문의</span
  ><span> </span><span>및</span><span> </span><span>요청</span
  ><span> </span><span>사항에최대한</span><span> </span
  ><span>친절하고</span><span> </span><span>신속하게</span><span> </span
  ><span>응대합니다</span><span>. </span><span>단</span><span>, </span
  ><span>공개적으로</span><span> </span><span>알려진게임</span
  ><span> </span><span>내</span><span> </span><span>정보</span
  ><span> </span><span>외</span><span> </span><span>추후</span
  ><span> </span><span>업데이트에</span><span> </span><span>대한</span
  ><span> </span><span>사항</span><span>, </span><span>게임</span
  ><span> </span><span>특성상</span><span> </span><span>공개가</span
  ><span> </span><span>불가능한</span><span> </span><span>내용에</span
  ><span> </span><span>대해서는</span><span> </span><span>제한적인</span
  ><span>&#xa0;</span><span>답변을</span><span> </span
  ><span>드리거나</span><span>, </span><span>답변을</span><span> </span
  ><span>드리지</span><span> </span><span>않을</span><span> </span
  ><span>수</span><span> </span><span>있습니다</span><span>.</span>
</p>
<p
  style="
    margin-top: 14pt;
    margin-bottom: 14pt;
    line-height: normal;
    widows: 2;
    orphans: 2;
  "
>
  <span>6)</span><span>운영진은</span><span> </span><span>회원</span
  ><span> </span><span>여러분으로부터</span><span> </span><span>게임</span
  ><span> </span><span>내</span><span> </span><span>발생할</span
  ><span> </span><span>수</span><span> </span><span>있는</span
  ><span> </span><span>모든</span><span> </span><span>형태의</span
  ><span> </span><span>버그를</span><span> </span><span>제보</span
  ><span> </span><span>받으며</span><span>, </span><span>이를</span
  ><span> </span><span>확인하고</span><span> </span><span>수정할</span
  ><span> </span><span>의무를</span><span> </span><span>가집니다</span
  ><span>. </span><span>게임</span><span> </span><span>내</span
  ><span> </span><span>다양한</span><span> </span><span>환경</span
  ><span>/</span><span>제반</span><span> </span><span>사항으로</span
  ><span> </span><span>인해</span><span> </span><span>버그</span
  ><span> </span><span>수정이</span><span> </span><span>지연될</span
  ><span> </span><span>경우</span><span>, </span><span>운영진은</span
  ><span> </span><span>회원에게</span><span> </span><span>공지</span
  ><span> </span><span>혹은</span><span>1:1</span><span>문의</span
  ><span> </span><span>답변을</span><span> </span><span>통해</span
  ><span> </span><span>안내할</span><span> </span><span>수</span
  ><span> </span><span>있도록</span><span> </span><span>최선을</span
  ><span> </span><span>다합니다</span><span>.</span>
</p>
<p
  style="
    margin-top: 14pt;
    margin-bottom: 14pt;
    line-height: normal;
    widows: 2;
    orphans: 2;
  "
>
  <span>7)</span><span>운영진은</span><span> </span><span>이용약관</span
  ><span>, </span><span>이</span><span> </span><span>"</span
  ><span>운영정책</span><span>"</span><span>을</span><span>&#xa0;</span
  ><span>위반한</span><span> </span><span>회원</span><span> </span
  ><span>또는</span><span> </span><span>복수의</span><span> </span
  ><span>회원에</span><span> </span><span>대해</span><span> </span
  ><span>약관</span><span> </span><span>및</span><span> </span
  ><span>"</span><span>운영정책</span><span>"</span><span>에정해진</span
  ><span> </span><span>각</span><span> </span><span>종</span><span> </span
  ><span>제한</span><span> </span><span>조치를</span><span> </span
  ><span>적용할</span><span> </span><span>수</span><span> </span
  ><span>있습니다</span><span>.</span>
</p>
<p
  style="
    margin-top: 14pt;
    margin-bottom: 14pt;
    line-height: normal;
    widows: 2;
    orphans: 2;
  "
>
  <span>8)</span><span>운영진은</span><span> </span><span>게임</span
  ><span> </span><span>서비스</span><span> </span><span>내</span
  ><span>/</span><span>외적으로</span><span> </span><span>비정상적인</span
  ><span> </span><span>현상이</span><span> </span><span>발생할</span
  ><span> </span><span>경우</span><span> </span><span>서비스의</span
  ><span> </span><span>일부</span><span> </span><span>혹은</span
  ><span> </span><span>전부를</span><span> </span><span>일시적으로</span
  ><span> </span><span>중단하거나</span><span>, </span><span>접근을</span
  ><span> </span><span>제한할</span><span> </span><span>수</span
  ><span> </span><span>있습니다</span><span>.</span>
</p>
<p
  style="
    margin-top: 14pt;
    margin-bottom: 14pt;
    line-height: normal;
    widows: 2;
    orphans: 2;
  "
>
  <span>9)</span><span>운영진은</span><span> </span><span>건전한</span
  ><span> </span><span>게임문화</span><span> </span><span>정착</span
  ><span>, </span><span>유해정보로부터의</span><span> </span
  ><span>청소년</span><span> </span><span>회원</span><span> </span
  ><span>보호</span><span>, </span><span>명예훼손</span><span> </span
  ><span>등</span><span> </span><span>특정</span><span> </span
  ><span>회원의</span><span> </span><span>권리침해방지를</span
  ><span> </span><span>위하여</span><span> </span><span>관련</span
  ><span> </span><span>법령</span><span> </span><span>및</span
  ><span> </span><span>약관</span><span>, "</span><span>운영정책</span
  ><span>"</span><span>에의거</span><span> </span><span>회원이</span
  ><span> </span><span>작성한</span><span> </span><span>게시물을</span
  ><span> </span><span>사전</span><span> </span><span>통보</span
  ><span> </span><span>없이</span><span> </span><span>편집</span
  ><span>, </span><span>이동</span><span>, </span><span>삭제할수</span
  ><span> </span><span>있으며</span><span>, </span><span>경우에</span
  ><span> </span><span>따라</span><span> </span><span>서비스</span
  ><span> </span><span>이용</span><span> </span><span>또한</span
  ><span> </span><span>제한할</span><span> </span><span>수</span
  ><span> </span><span>있습니다</span><span>.</span>
</p>
<p
  style="
    margin-top: 14pt;
    margin-bottom: 14pt;
    line-height: normal;
    widows: 2;
    orphans: 2;
  "
>
  <span>7.</span><span>비</span><span> </span><span>매너</span
  ><span> </span><span>행위</span><span> </span><span>관리</span
  ><span> </span><span>기준</span>
</p>
<p
  style="
    margin-top: 14pt;
    margin-bottom: 14pt;
    line-height: normal;
    widows: 2;
    orphans: 2;
  "
>
  <span>1)"</span><span>회사</span><span>"</span><span>는회원</span
  ><span> </span><span>여러분이</span><span> </span><span>시스템</span
  ><span> </span><span>버그</span><span> </span><span>등을</span
  ><span> </span><span>악용하거나</span><span> </span><span>다른</span
  ><span> </span><span>회원과</span><span> </span><span>해당</span
  ><span> </span><span>내용을</span><span> </span><span>공유하는</span
  ><span> </span><span>것을</span><span> </span><span>금지합니다</span
  ><span>. </span><span>버그악용의</span><span> </span><span>경우</span
  ><span> </span><span>게임</span><span> </span><span>콘텐츠</span
  ><span> </span><span>및</span><span> </span><span>정상적인</span
  ><span> </span><span>게임진행</span><span> </span><span>등을</span
  ><span> </span><span>방해하는</span><span> </span><span>행위이기</span
  ><span> </span><span>때문입니다</span><span>.</span>
</p>
<p
  style="
    margin-top: 14pt;
    margin-bottom: 14pt;
    line-height: normal;
    widows: 2;
    orphans: 2;
  "
>
  <span>2)</span><span>시스템</span><span> </span><span>버그</span
  ><span> </span><span>등을</span><span> </span><span>악용하는</span
  ><span> </span><span>것은</span><span> </span><span>다른</span
  ><span> </span><span>회원여러분과의</span><span> </span
  ><span>형평성에</span><span> </span><span>어긋나는</span><span> </span
  ><span>행위이기</span><span> </span><span>때문에</span><span> </span
  ><span>시스템</span><span> </span><span>버그나</span><span> </span
  ><span>문제점을</span><span> </span><span>악용</span><span>, </span
  ><span>공유할</span><span> </span><span>경우</span><span> </span
  ><span>사전</span><span> </span><span>안내</span><span> </span
  ><span>없이게임</span><span> </span><span>이용이</span><span> </span
  ><span>제한되거나</span><span> </span><span>회원</span><span> </span
  ><span>자격이</span><span> </span><span>정지될</span><span> </span
  ><span>수</span><span> </span><span>있으니</span><span> </span
  ><span>각별한</span><span> </span><span>주의를</span><span> </span
  ><span>당부</span><span> </span><span>드립니다</span><span>.</span>
</p>
<p
  style="
    margin-top: 14pt;
    margin-bottom: 14pt;
    line-height: normal;
    widows: 2;
    orphans: 2;
  "
>
  <span>3)</span><span>게임</span><span> </span><span>내</span
  ><span> </span><span>커뮤니티</span><span> </span><span>및</span
  ><span> </span><span>"</span><span>회사</span><span>"</span
  ><span>가</span><span> </span><span>공식적으로</span><span> </span
  ><span>인정한</span><span> </span><span>커뮤니티에서</span><span> </span
  ><span>공공의안녕</span><span> </span><span>및</span><span> </span
  ><span>미풍양속을</span><span> </span><span>저해하는</span><span> </span
  ><span>행위는</span><span> </span><span>다른</span><span> </span
  ><span>고객에게</span><span> </span><span>커다란</span><span> </span
  ><span>피해를</span><span> </span><span>입힐</span><span> </span
  ><span>우려가</span><span> </span><span>있기</span><span> </span
  ><span>때문에</span><span> </span><span>다음과</span><span> </span
  ><span>같은</span><span> </span><span>행위</span><span> </span
  ><span>및</span><span> </span><span>게시물을</span><span> </span
  ><span>등록할</span><span> </span><span>경우</span><span> </span
  ><span>게시물의</span><span> </span><span>게시자및</span><span> </span
  ><span>비매너</span><span> </span><span>행위자에</span><span> </span
  ><span>대해서</span><span> </span><span>고객</span><span> </span
  ><span>권한</span><span> </span><span>정지</span><span> </span
  ><span>등을</span><span> </span><span>취할</span><span> </span
  ><span>수</span><span> </span><span>있습니다</span><span>.</span
  ><span> </span><span>①</span><span> </span><span>영리를</span
  ><span> </span><span>목적으로</span><span> </span><span>하거나</span
  ><span> </span><span>광고</span><span> </span><span>또는</span
  ><span> </span><span>광고와</span><span> </span><span>유사하다고</span
  ><span> </span><span>판단되는</span><span> </span><span>내용인</span
  ><span> </span><span>경우</span><span> </span><span>②</span
  ><span> </span><span>현금</span><span> </span><span>거래</span
  ><span> </span><span>및</span><span> </span><span>계정</span
  ><span> </span><span>거래</span><span>, </span><span>서버간</span
  ><span> </span><span>거래에</span><span> </span><span>관련한</span
  ><span> </span><span>시도</span><span> </span><span>또는</span
  ><span> </span><span>타</span><span> </span><span>회원들을</span
  ><span> </span><span>선동하려는</span><span> </span><span>경우</span
  ><span> </span><span>③</span><span> </span><span>회사</span
  ><span>, </span><span>다른</span><span> </span><span>회원</span
  ><span> </span><span>또는</span><span> </span><span>제</span
  ><span> </span><span>3</span><span>자에게</span><span> </span
  ><span>심한모욕을</span><span> </span><span>주거나</span><span> </span
  ><span>중상모략으로</span><span> </span><span>명예를</span><span> </span
  ><span>손상시키는</span><span> </span><span>내용인</span><span> </span
  ><span>경우</span><span> </span><span>④</span><span> </span
  ><span>청소년</span><span> </span><span>보호법에</span><span> </span
  ><span>위반되는</span><span> </span><span>내용의</span><span> </span
  ><span>정보</span><span>, </span><span>문장</span><span>, </span
  ><span>도형등을</span><span> </span><span>게시하거나</span><span> </span
  ><span>링크시키는</span><span> </span><span>경우</span><span> </span
  ><span>⑤</span><span> </span><span>불법</span><span> </span
  ><span>복제</span><span> </span><span>또는</span><span> </span
  ><span>해킹을</span><span> </span><span>조장하는</span><span> </span
  ><span>내용인</span><span> </span><span>경우</span><span> </span
  ><span>⑥</span><span> </span><span>범죄와</span><span> </span
  ><span>결부된다고</span><span> </span><span>객관적으로</span
  ><span> </span><span>인정되는</span><span> </span><span>내용일</span
  ><span> </span><span>경우</span><span> </span><span>⑦</span
  ><span> </span><span>다른</span><span> </span><span>이용자</span
  ><span> </span><span>또는</span><span> </span><span>제</span
  ><span> </span><span>3</span><span>의</span><span> </span
  ><span>저작권</span><span> </span><span>등</span><span> </span
  ><span>기타</span><span> </span><span>권리를</span><span> </span
  ><span>침해하는</span><span> </span><span>내용일</span><span> </span
  ><span>경우</span><span> </span><span>⑧</span><span> </span
  ><span>회사에서</span><span> </span><span>규정한</span><span> </span
  ><span>게시물</span><span> </span><span>원칙에서</span><span> </span
  ><span>벗어나거나</span><span>, </span><span>게시판</span><span> </span
  ><span>성격에</span><span> </span><span>부합하지</span><span> </span
  ><span>않을</span><span> </span><span>경우</span><span> </span
  ><span>⑨</span><span> </span><span>허위</span><span> </span
  ><span>사실을</span><span> </span><span>유포하거나</span><span> </span
  ><span>다수의</span><span> </span><span>고객에게</span><span> </span
  ><span>오해를</span><span> </span><span>불러</span><span> </span
  ><span>일으킬</span><span> </span><span>수</span><span> </span
  ><span>있는</span><span> </span><span>경우</span><span> </span
  ><span>⑩</span><span> </span><span>도배</span><span> </span
  ><span>또는</span><span> </span><span>욕설</span><span>, </span
  ><span>음란한</span><span> </span><span>단어</span><span> </span
  ><span>및</span><span> </span><span>표현이</span><span> </span
  ><span>포함된</span><span> </span><span>내용일</span><span> </span
  ><span>경우</span><span> </span><span>⑪</span><span> </span
  ><span>운영진</span><span> </span><span>및</span><span> </span
  ><span>회사</span><span> </span><span>임직원을</span><span> </span
  ><span>사칭할</span><span> </span><span>경우</span><span> </span
  ><span>⑫</span><span> </span><span>약관</span><span> </span
  ><span>및</span><span> </span><span>기타</span><span> </span
  ><span>관계</span><span> </span><span>법령에</span><span> </span
  ><span>위배되는</span><span> </span><span>내용일</span><span> </span
  ><span>경우</span>
</p>
<p
  style="
    margin-top: 14pt;
    margin-bottom: 14pt;
    line-height: normal;
    widows: 2;
    orphans: 2;
  "
>
  <span>4)</span><span>사기</span><span>(</span><span>상대방을속여</span
  ><span> </span><span>게임</span><span> </span><span>내</span
  ><span> </span><span>부당한</span><span> </span><span>이득을</span
  ><span> </span><span>취하려는</span><span> </span><span>모든</span
  ><span> </span><span>행위</span><span>)</span><span>를</span
  ><span> </span><span>행할</span><span> </span><span>경우</span
  ><span>, </span><span>다른고객에게</span><span> </span><span>큰</span
  ><span> </span><span>피해를</span><span> </span><span>입히는</span
  ><span> </span><span>행위이기</span><span> </span><span>때문에</span
  ><span> </span><span>운영정책에</span><span> </span><span>따른</span
  ><span> </span><span>여러</span><span> </span><span>제한과</span
  ><span> </span><span>관계</span><span> </span><span>법령에</span
  ><span> </span><span>따른</span><span> </span><span>처벌을</span
  ><span> </span><span>받을</span><span> </span><span>수</span
  ><span> </span><span>있습니다</span><span>.</span>
</p>
<p
  style="
    margin-top: 14pt;
    margin-bottom: 14pt;
    line-height: normal;
    widows: 2;
    orphans: 2;
  "
>
  <span>8.</span><span>서비스의</span><span> </span><span>변경</span>
</p>
<p
  style="
    margin-top: 14pt;
    margin-bottom: 14pt;
    line-height: normal;
    widows: 2;
    orphans: 2;
  "
>
  <span>1)"</span><span>회사</span><span>"</span><span>는새로운</span
  ><span> </span><span>게임</span><span> </span><span>내용</span
  ><span>, </span><span>각종</span><span> </span><span>버그</span
  ><span> </span><span>패치</span><span> </span><span>등</span
  ><span> </span><span>서비스의</span><span> </span><span>운영상</span
  ><span>, </span><span>기술상필요한</span><span> </span
  ><span>경우에</span><span> </span><span>서비스의</span><span> </span
  ><span>전부</span><span> </span><span>또는</span><span> </span
  ><span>일부를</span><span> </span><span>사전</span><span> </span
  ><span>공지</span><span> </span><span>후</span><span> </span
  ><span>수정할</span><span> </span><span>수</span><span> </span
  ><span>있습니다</span><span>. </span><span>단</span><span>, </span
  ><span>기간통신망의</span><span> </span><span>장애</span><span> </span
  ><span>등</span><span> </span><span>사전에</span><span> </span
  ><span>공지할</span><span> </span><span>수</span><span> </span
  ><span>없는</span><span> </span><span>부득이한</span><span> </span
  ><span>사유가</span><span> </span><span>있는</span><span> </span
  ><span>경우에는</span><span> </span><span>사후</span><span> </span
  ><span>공지할</span><span> </span><span>수도</span><span> </span
  ><span>있습니다</span><span>.</span>
</p>
<p
  style="
    margin-top: 14pt;
    margin-bottom: 14pt;
    line-height: normal;
    widows: 2;
    orphans: 2;
  "
>
  <span>2)"</span><span>회원</span><span>"</span><span>여러분께서는</span
  ><span> </span><span>서비스의</span><span> </span><span>변경</span
  ><span> </span><span>등으로</span><span> </span><span>인해</span
  ><span> </span><span>유료서비스</span><span> </span><span>이용이</span
  ><span> </span><span>불가함으로</span><span> </span><span>받은</span
  ><span> </span><span>손해</span><span> </span><span>외에</span
  ><span> </span><span>별도의</span><span> </span><span>손해</span
  ><span> </span><span>배상을</span><span> </span><span>청구할</span
  ><span> </span><span>수</span><span> </span><span>없습니다</span
  ><span>. </span><span>특히</span><span> </span><span>서비스</span
  ><span> </span><span>이용에</span><span> </span><span>따른</span
  ><span> </span><span>기대수익</span><span>, </span><span>회사가</span
  ><span> </span><span>직접</span><span> </span><span>제공하지</span
  ><span> </span><span>않은</span><span> </span><span>혜택의상실로</span
  ><span> </span><span>인한</span><span> </span><span>피해에</span
  ><span> </span><span>대해</span><span> </span><span>"</span
  ><span>회사</span><span>"</span><span>는</span><span> </span
  ><span>책임질의무를</span><span> </span><span>지지</span><span> </span
  ><span>않습니다</span><span>.</span>
</p>
<p
  style="
    margin-top: 14pt;
    margin-bottom: 14pt;
    line-height: normal;
    widows: 2;
    orphans: 2;
  "
>
  <span>9.</span><span>고객지원</span>
</p>
<p
  style="
    margin-top: 14pt;
    margin-bottom: 14pt;
    line-height: normal;
    widows: 2;
    orphans: 2;
  "
>
  <span>서비스</span><span> </span><span>및</span><span> </span
  ><span>게임과</span><span> </span><span>관련된</span><span> </span
  ><span>문의는</span><span> </span><span>게임</span><span> </span
  ><span>내</span><span> </span><span>고객센터</span><span> </span
  ><span>등의</span><span> </span><span>공식적인</span><span> </span
  ><span>경로를</span><span> </span><span>통한</span><span> </span
  ><span>문의</span><span> </span><span>접수에</span><span> </span
  ><span>대해서만</span><span> </span><span>처리됩니다</span>
</p>
<p
  style="
    margin-top: 14pt;
    margin-bottom: 14pt;
    line-height: normal;
    widows: 2;
    orphans: 2;
  "
>
  <span>10.</span><span>게임</span><span> </span><span>이용제한</span
  ><span> </span><span>기준</span>
</p>
<p
  style="
    margin-top: 14pt;
    margin-bottom: 14pt;
    line-height: normal;
    widows: 2;
    orphans: 2;
  "
>
  <span>게임</span><span> </span><span>이용제한</span><span> </span
  ><span>기준은</span><span> </span><span>"</span><span>서비스</span
  ><span>"</span><span>을</span><span> </span><span>이용하면서</span
  ><span> </span><span>회원</span><span> </span><span>여러분이</span
  ><span> </span><span>원활한</span><span> </span><span>플레이를</span
  ><span> </span><span>하실</span><span> </span><span>수</span
  ><span> </span><span>있도록</span><span> </span><span>게임</span
  ><span> </span><span>진행</span><span> </span><span>방해</span
  ><span> </span><span>또는</span><span> </span><span>미풍양속을</span
  ><span> </span><span>저해하는행위</span><span> </span
  ><span>등으로부터</span><span> </span><span>보호하기</span><span> </span
  ><span>위해</span><span> </span><span>수립되었습니다</span><span>.</span
  ><span> </span><span>회원</span><span> </span><span>여러분이</span
  ><span> </span><span>"</span><span>운영정책</span><span>"</span
  ><span>에</span><span> </span><span>명시된</span><span> </span
  ><span>이용제한</span><span> </span><span>기준을</span><span> </span
  ><span>위반하는</span><span> </span><span>경우</span><span> </span
  ><span>사전</span><span> </span><span>안내</span><span> </span
  ><span>없이</span><span> </span><span>이용에</span><span> </span
  ><span>제한을</span><span> </span><span>받으실</span><span> </span
  ><span>수</span><span> </span><span>있습니다</span><span>.</span
  ><span> </span><span>이용제한</span><span> </span><span>조치를</span
  ><span> </span><span>받으신</span><span> </span><span>경우</span
  ><span> </span><span>아래와</span><span> </span><span>같은</span
  ><span> </span><span>절차에</span><span> </span><span>따라</span
  ><span> </span><span>이의</span><span> </span><span>신청을</span
  ><span> </span><span>하실</span><span> </span><span>수</span
  ><span> </span><span>있습니다</span><span>.</span>
</p>
<p
  style="
    margin-top: 14pt;
    margin-bottom: 14pt;
    line-height: normal;
    widows: 2;
    orphans: 2;
  "
>
  <span>①</span><span> </span><span>게임</span><span> </span
  ><span>내</span><span> </span><span>[</span><span>고객센터</span
  ><span>]&gt; [1:1 </span><span>문의</span><span>]</span><span>를</span
  ><span> </span><span>통해서</span><span> </span><span>이의</span
  ><span> </span><span>신청을</span><span> </span><span>하실</span
  ><span> </span><span>수</span><span> </span><span>있습니다</span
  ><span>.</span><span> </span><span>②</span><span> </span
  ><span>이의</span><span> </span><span>신청은</span><span> </span
  ><span>이용제한</span><span> </span><span>적용일로부터</span
  ><span> </span><span>7</span><span>일</span><span> </span
  ><span>이내에만</span><span> </span><span>접수할</span><span> </span
  ><span>수</span><span> </span><span>있습니다</span><span>.</span
  ><span> </span><span>③</span><span> </span><span>이의</span
  ><span> </span><span>신청은</span><span> </span><span>접수일로부터</span
  ><span> </span><span>최대</span><span> </span><span>7</span
  ><span>일</span><span> </span><span>내에</span><span> </span
  ><span>처리됩니다</span><span>.</span><span> </span><span>게임</span
  ><span> </span><span>이용제한</span><span> </span><span>기준은</span
  ><span> </span><span>다음과</span><span> </span><span>같습니다</span
  ><span>.</span>
</p>
<p
  style="
    margin-top: 14pt;
    margin-bottom: 14pt;
    line-height: normal;
    widows: 2;
    orphans: 2;
  "
>
  <span>게임</span><span> </span><span>이용제한</span><span> </span
  ><span>기준은</span><span> </span><span>다음과</span><span> </span
  ><span>같습니다</span><span>.</span>
</p>
<table
  cellspacing="0"
  cellpadding="0"
  style="
    width: 100%;
    margin-bottom: 0pt;
    border: 1.5pt solid #000000;
    border-collapse: collapse;
  "
>
  <tr style="height: 40.5pt">
    <td
      style="
        width: 25.04%;
        border-right-style: solid;
        border-right-width: 1.5pt;
        border-bottom-style: solid;
        border-bottom-width: 1.5pt;
        padding-top: 0.75pt;
        padding-bottom: 0.75pt;
        vertical-align: middle;
        -aw-padding-bottom: 0.75pt;
        -aw-padding-left: 0.75pt;
        -aw-padding-right: 0.75pt;
        -aw-padding-top: 0.75pt;
      "
      class="td-title"
    >
      <p
        style="
          margin-bottom: 0pt;
          text-align: center;
          widows: 2;
          orphans: 2;
        "
      >
        <span style="font-weight: bold">유형</span>
      </p>
    </td>
    <td
      style="
        width: 25.32%;
        border-right-style: solid;
        border-right-width: 1.5pt;
        border-bottom-style: solid;
        border-bottom-width: 1.5pt;
        padding-top: 0.75pt;
        padding-left: 0.75pt;
        padding-bottom: 0.75pt;
        vertical-align: middle;
        -aw-padding-bottom: 0.75pt;
        -aw-padding-right: 0.75pt;
        -aw-padding-top: 0.75pt;
      "
      class="td-title"
    >
      <p
        style="
          margin-bottom: 0pt;
          text-align: center;
          widows: 2;
          orphans: 2;
        "
      >
        <span style="font-weight: bold">상세설명</span>
      </p>
    </td>
    <td
      style="
        width: 8.34%;
        border-right-style: solid;
        border-right-width: 1.5pt;
        border-bottom-style: solid;
        border-bottom-width: 1.5pt;
        padding-top: 0.75pt;
        padding-left: 0.75pt;
        padding-bottom: 0.75pt;
        vertical-align: middle;
        -aw-padding-bottom: 0.75pt;
        -aw-padding-right: 0.75pt;
        -aw-padding-top: 0.75pt;
      "
      class="td-title"
    >
      <p
        style="
          margin-bottom: 0pt;
          text-align: center;
          widows: 2;
          orphans: 2;
        "
      >
        <span style="font-weight: bold">1</span
        ><span style="font-weight: bold">차</span>
      </p>
    </td>
    <td
      style="
        width: 10.18%;
        border-right-style: solid;
        border-right-width: 1.5pt;
        border-bottom-style: solid;
        border-bottom-width: 1.5pt;
        padding-top: 0.75pt;
        padding-left: 0.75pt;
        padding-bottom: 0.75pt;
        vertical-align: middle;
        -aw-padding-bottom: 0.75pt;
        -aw-padding-right: 0.75pt;
        -aw-padding-top: 0.75pt;
      "
      class="td-title"
    >
      <p
        style="
          margin-bottom: 0pt;
          text-align: center;
          widows: 2;
          orphans: 2;
        "
      >
        <span style="font-weight: bold">2</span
        ><span style="font-weight: bold">차</span>
      </p>
    </td>
    <td
      style="
        width: 10.18%;
        border-right-style: solid;
        border-right-width: 1.5pt;
        border-bottom-style: solid;
        border-bottom-width: 1.5pt;
        padding-top: 0.75pt;
        padding-left: 0.75pt;
        padding-bottom: 0.75pt;
        vertical-align: middle;
        -aw-padding-bottom: 0.75pt;
        -aw-padding-right: 0.75pt;
        -aw-padding-top: 0.75pt;
      "
      class="td-title"
    >
      <p
        style="
          margin-bottom: 0pt;
          text-align: center;
          widows: 2;
          orphans: 2;
        "
      >
        <span style="font-weight: bold">3</span
        ><span style="font-weight: bold">차</span>
      </p>
    </td>
    <td
      style="
        width: 10.18%;
        border-right-style: solid;
        border-right-width: 1.5pt;
        border-bottom-style: solid;
        border-bottom-width: 1.5pt;
        padding-top: 0.75pt;
        padding-left: 0.75pt;
        padding-bottom: 0.75pt;
        vertical-align: middle;
        -aw-padding-bottom: 0.75pt;
        -aw-padding-right: 0.75pt;
        -aw-padding-top: 0.75pt;
      "
      class="td-title"
    >
      <p
        style="
          margin-bottom: 0pt;
          text-align: center;
          widows: 2;
          orphans: 2;
        "
      >
        <span style="font-weight: bold">4</span
        ><span style="font-weight: bold">차</span>
      </p>
    </td>
    <td
      style="
        width: 10.78%;
        border-bottom-style: solid;
        border-bottom-width: 1.5pt;
        padding-top: 0.75pt;
        padding-left: 0.75pt;
        padding-bottom: 0.75pt;
        vertical-align: middle;
        -aw-padding-bottom: 0.75pt;
        -aw-padding-right: 0.75pt;
        -aw-padding-top: 0.75pt;
      "
      class="td-title"
    >
      <p
        style="
          margin-bottom: 0pt;
          text-align: center;
          widows: 2;
          orphans: 2;
        "
      >
        <span style="font-weight: bold">5</span
        ><span style="font-weight: bold">차</span>
      </p>
    </td>
  </tr>
  <tr style="height: 225pt">
    <td
      rowspan="4"
      style="
        width: 25.04%;
        border-right-style: solid;
        border-right-width: 1.5pt;
        border-bottom-style: solid;
        border-bottom-width: 1.5pt;
        padding-top: 0.75pt;
        padding-bottom: 0.75pt;
        vertical-align: middle;
        -aw-padding-bottom: 0.75pt;
        -aw-padding-left: 0.75pt;
        -aw-padding-right: 0.75pt;
      "
    >
      <p
        style="
          margin-right: 6pt;
          margin-left: 6pt;
          margin-bottom: 0pt;
          text-align: center;
          widows: 2;
          orphans: 2;
        "
      >
        <span>배매너행위</span>
      </p>
    </td>
    <td
      style="
        width: 25.32%;
        border-right-style: solid;
        border-right-width: 1.5pt;
        border-bottom-style: solid;
        border-bottom-width: 1.5pt;
        padding-top: 0.75pt;
        padding-left: 0.75pt;
        padding-bottom: 0.75pt;
        vertical-align: middle;
        -aw-padding-bottom: 0.75pt;
        -aw-padding-right: 0.75pt;
      "
    >
      <p
        style="
          margin-bottom: 0pt;
          text-align: center;
          widows: 2;
          orphans: 2;
        "
      >
        <span>다른회원의</span><span> </span><span>원활한</span
        ><span> </span><span>게임</span><span> </span><span>서비스</span
        ><span> </span><span>이요을</span><span> </span
        ><span>방해하는</span><span> </span><span>해위</span
        ><span>, </span><span>다수의</span><span> </span
        ><span>고객에게</span><span> </span><span>피해를</span
        ><span> </span><span>입히는</span><span> </span><span>행위</span
        ><span>, </span><span>특정</span><span> </span><span>다른</span
        ><span> </span><span>고객의</span><span> </span
        ><span>플레이를</span><span> </span><span>지속적으로</span
        ><span> </span><span>방해하거나</span><span> </span
        ><span>이와</span><span> </span><span>유사한</span><span> </span
        ><span>행위를</span><span> </span><span>범하는</span><span> </span
        ><span>경우</span><span>.</span>
      </p>
    </td>
    <td
      style="
        width: 8.34%;
        border-right-style: solid;
        border-right-width: 1.5pt;
        border-bottom-style: solid;
        border-bottom-width: 1.5pt;
        padding-top: 0.75pt;
        padding-left: 0.75pt;
        padding-bottom: 0.75pt;
        vertical-align: middle;
        -aw-padding-bottom: 0.75pt;
        -aw-padding-right: 0.75pt;
      "
    >
      <p
        style="
          margin-right: 6pt;
          margin-left: 6pt;
          margin-bottom: 0pt;
          text-align: center;
          widows: 2;
          orphans: 2;
        "
      >
        <span>경고</span>
      </p>
    </td>
    <td
      style="
        width: 10.18%;
        border-right-style: solid;
        border-right-width: 1.5pt;
        border-bottom-style: solid;
        border-bottom-width: 1.5pt;
        padding-top: 0.75pt;
        padding-left: 0.75pt;
        padding-bottom: 0.75pt;
        vertical-align: middle;
        -aw-padding-bottom: 0.75pt;
        -aw-padding-right: 0.75pt;
      "
    >
      <p
        style="
          margin-bottom: 0pt;
          text-align: center;
          widows: 2;
          orphans: 2;
        "
      >
        <span>1</span><span>일정지</span>
      </p>
    </td>
    <td
      style="
        width: 10.18%;
        border-right-style: solid;
        border-right-width: 1.5pt;
        border-bottom-style: solid;
        border-bottom-width: 1.5pt;
        padding-top: 0.75pt;
        padding-left: 0.75pt;
        padding-bottom: 0.75pt;
        vertical-align: middle;
        -aw-padding-bottom: 0.75pt;
        -aw-padding-right: 0.75pt;
      "
    >
      <p
        style="
          margin-bottom: 0pt;
          text-align: center;
          widows: 2;
          orphans: 2;
        "
      >
        <span>3</span><span>일정지</span>
      </p>
    </td>
    <td
      style="
        width: 10.18%;
        border-right-style: solid;
        border-right-width: 1.5pt;
        border-bottom-style: solid;
        border-bottom-width: 1.5pt;
        padding-top: 0.75pt;
        padding-left: 0.75pt;
        padding-bottom: 0.75pt;
        vertical-align: middle;
        -aw-padding-bottom: 0.75pt;
        -aw-padding-right: 0.75pt;
      "
    >
      <p
        style="
          margin-bottom: 0pt;
          text-align: center;
          widows: 2;
          orphans: 2;
        "
      >
        <span>5</span><span>일정지</span>
      </p>
    </td>
    <td
      style="
        width: 10.78%;
        border-bottom-style: solid;
        border-bottom-width: 1.5pt;
        padding-top: 0.75pt;
        padding-left: 0.75pt;
        padding-bottom: 0.75pt;
        vertical-align: middle;
        -aw-padding-bottom: 0.75pt;
        -aw-padding-right: 0.75pt;
      "
    >
      <p
        style="
          margin-bottom: 0pt;
          text-align: center;
          widows: 2;
          orphans: 2;
        "
      >
        <span>영구정지</span>
      </p>
    </td>
  </tr>
  <tr style="height: 159.75pt">
    <td
      rowspan="2"
      style="
        width: 25.32%;
        border-right-style: solid;
        border-right-width: 1.5pt;
        border-bottom-style: solid;
        border-bottom-width: 1.5pt;
        padding-top: 0.75pt;
        padding-left: 0.75pt;
        padding-bottom: 0.75pt;
        vertical-align: middle;
        -aw-padding-bottom: 0.75pt;
        -aw-padding-right: 0.75pt;
      "
    >
      <p
        style="
          margin-bottom: 0pt;
          text-align: center;
          widows: 2;
          orphans: 2;
        "
      >
        <span>게임내</span><span> </span><span>경제</span><span> </span
        ><span>시스템</span><span> </span><span>등</span><span> </span
        ><span>밸런스</span><span> </span><span>및</span><span> </span
        ><span>서비스</span><span> </span><span>전반에</span><span> </span
        ><span>문제를</span><span> </span><span>발생시킨</span
        ><span> </span><span>행위</span>
      </p>
    </td>
    <td
      rowspan="2"
      style="
        width: 8.34%;
        border-right-style: solid;
        border-right-width: 1.5pt;
        border-bottom-style: solid;
        border-bottom-width: 1.5pt;
        padding-top: 0.75pt;
        padding-left: 0.75pt;
        padding-bottom: 0.75pt;
        vertical-align: middle;
        -aw-padding-bottom: 0.75pt;
        -aw-padding-right: 0.75pt;
      "
    >
      <p
        style="
          margin-right: 6pt;
          margin-left: 6pt;
          margin-bottom: 0pt;
          text-align: center;
          widows: 2;
          orphans: 2;
        "
      >
        <span>경고</span>
      </p>
    </td>
    <td
      style="
        width: 10.18%;
        border-right-style: solid;
        border-right-width: 1.5pt;
        border-bottom-style: solid;
        border-bottom-width: 1.5pt;
        padding-top: 0.75pt;
        padding-left: 0.75pt;
        padding-bottom: 0.75pt;
        vertical-align: middle;
        -aw-padding-bottom: 0.75pt;
        -aw-padding-right: 0.75pt;
      "
    >
      <p
        style="
          margin-bottom: 0pt;
          text-align: center;
          widows: 2;
          orphans: 2;
        "
      >
        <span>1</span><span>일정지</span>
      </p>
    </td>
    <td
      style="
        width: 10.18%;
        border-right-style: solid;
        border-right-width: 1.5pt;
        border-bottom-style: solid;
        border-bottom-width: 1.5pt;
        padding-top: 0.75pt;
        padding-left: 0.75pt;
        padding-bottom: 0.75pt;
        vertical-align: middle;
        -aw-padding-bottom: 0.75pt;
        -aw-padding-right: 0.75pt;
      "
    >
      <p
        style="
          margin-bottom: 0pt;
          text-align: center;
          widows: 2;
          orphans: 2;
        "
      >
        <span>3</span><span>일정지</span>
      </p>
    </td>
    <td
      style="
        width: 10.18%;
        border-right-style: solid;
        border-right-width: 1.5pt;
        border-bottom-style: solid;
        border-bottom-width: 1.5pt;
        padding-top: 0.75pt;
        padding-left: 0.75pt;
        padding-bottom: 0.75pt;
        vertical-align: middle;
        -aw-padding-bottom: 0.75pt;
        -aw-padding-right: 0.75pt;
      "
    >
      <p
        style="
          margin-bottom: 0pt;
          text-align: center;
          widows: 2;
          orphans: 2;
        "
      >
        <span>5</span><span>일정지</span>
      </p>
    </td>
    <td
      style="
        width: 10.78%;
        border-bottom-style: solid;
        border-bottom-width: 1.5pt;
        padding-top: 0.75pt;
        padding-left: 0.75pt;
        padding-bottom: 0.75pt;
        vertical-align: middle;
        -aw-padding-bottom: 0.75pt;
        -aw-padding-right: 0.75pt;
      "
    >
      <p
        style="
          margin-bottom: 0pt;
          text-align: center;
          widows: 2;
          orphans: 2;
        "
      >
        <span>영구정지</span>
      </p>
    </td>
  </tr>
  <tr style="height: 76.5pt">
    <td
      colspan="4"
      style="
        border-bottom-style: solid;
        border-bottom-width: 1.5pt;
        padding-top: 0.75pt;
        padding-left: 0.75pt;
        padding-bottom: 0.75pt;
        vertical-align: middle;
        -aw-padding-bottom: 0.75pt;
        -aw-padding-right: 0.75pt;
      "
    >
      <p
        style="
          margin-bottom: 0pt;
          text-align: center;
          widows: 2;
          orphans: 2;
        "
      >
        <span>경중에</span><span> </span><span>따라</span><span> </span
        ><span>가중하여</span><span> </span><span>이용이</span
        ><span> </span><span>제한될</span><span> </span><span>수</span
        ><span> </span><span>있습니다</span><span>.</span>
      </p>
    </td>
  </tr>
  <tr style="height: 185.25pt">
    <td
      style="
        width: 25.32%;
        border-right-style: solid;
        border-right-width: 1.5pt;
        padding-top: 0.75pt;
        padding-left: 0.75pt;
        padding-bottom: 0.75pt;
        vertical-align: middle;
        -aw-padding-bottom: 0.75pt;
        -aw-padding-right: 0.75pt;
      "
    >
      <p
        style="
          margin-bottom: 0pt;
          text-align: center;
          widows: 2;
          orphans: 2;
        "
      >
        <span>도배</span><span>, </span><span>욕설</span><span>, </span
        ><span>성적</span><span> </span><span>표현</span><span>, </span
        ><span>친우</span><span> </span><span>대상</span><span> </span
        ><span>욕설</span><span>, </span><span>광고</span><span> </span
        ><span>등을</span><span> </span><span>통해</span><span> </span
        ><span>불쾌감을</span><span> </span><span>주는</span><span> </span
        ><span>행위</span>
      </p>
    </td>
    <td
      style="
        width: 8.34%;
        border-right-style: solid;
        border-right-width: 1.5pt;
        padding-top: 0.75pt;
        padding-left: 0.75pt;
        padding-bottom: 0.75pt;
        vertical-align: middle;
        -aw-padding-bottom: 0.75pt;
        -aw-padding-right: 0.75pt;
      "
    >
      <p
        style="
          margin-right: 6pt;
          margin-left: 6pt;
          margin-bottom: 0pt;
          text-align: center;
          widows: 2;
          orphans: 2;
        "
      >
        <span>경고</span>
      </p>
    </td>
    <td
      style="
        width: 10.18%;
        border-right-style: solid;
        border-right-width: 1.5pt;
        padding-top: 0.75pt;
        padding-left: 0.75pt;
        padding-bottom: 0.75pt;
        vertical-align: middle;
        -aw-padding-bottom: 0.75pt;
        -aw-padding-right: 0.75pt;
      "
    >
      <p
        style="
          margin-bottom: 0pt;
          text-align: center;
          widows: 2;
          orphans: 2;
        "
      >
        <span>1</span><span>일정지</span>
      </p>
    </td>
    <td
      style="
        width: 10.18%;
        border-right-style: solid;
        border-right-width: 1.5pt;
        padding-top: 0.75pt;
        padding-left: 0.75pt;
        padding-bottom: 0.75pt;
        vertical-align: middle;
        -aw-padding-bottom: 0.75pt;
        -aw-padding-right: 0.75pt;
      "
    >
      <p
        style="
          margin-bottom: 0pt;
          text-align: center;
          widows: 2;
          orphans: 2;
        "
      >
        <span>3</span><span>일정지</span>
      </p>
    </td>
    <td
      style="
        width: 10.18%;
        border-right-style: solid;
        border-right-width: 1.5pt;
        padding-top: 0.75pt;
        padding-left: 0.75pt;
        padding-bottom: 0.75pt;
        vertical-align: middle;
        -aw-padding-bottom: 0.75pt;
        -aw-padding-right: 0.75pt;
      "
    >
      <p
        style="
          margin-bottom: 0pt;
          text-align: center;
          widows: 2;
          orphans: 2;
        "
      >
        <span>5</span><span>일정지</span>
      </p>
    </td>
    <td
      style="
        width: 10.78%;
        padding-top: 0.75pt;
        padding-left: 0.75pt;
        padding-bottom: 0.75pt;
        vertical-align: middle;
        -aw-padding-bottom: 0.75pt;
        -aw-padding-right: 0.75pt;
      "
    >
      <p
        style="
          margin-bottom: 0pt;
          text-align: center;
          widows: 2;
          orphans: 2;
        "
      >
        <span>영구정지</span>
      </p>
    </td>
  </tr>
</table>
<p
  style="
    margin-top: 14pt;
    margin-bottom: 14pt;
    text-align: justify;
    line-height: normal;
    widows: 2;
    orphans: 2;
  "
>
  <span>&#xa0;</span>
</p>
<table
  cellspacing="0"
  cellpadding="0"
  style="
    width: 100%;
    margin-bottom: 0pt;
    border: 1.5pt solid #000000;
    border-collapse: collapse;
  "
>
  <tr style="height: 40.5pt">
    <td
      style="
        width: 27.58%;
        border-right-style: solid;
        border-right-width: 1.5pt;
        border-bottom-style: solid;
        border-bottom-width: 1.5pt;
        padding-top: 0.75pt;
        padding-bottom: 0.75pt;
        vertical-align: middle;
        -aw-padding-bottom: 0.75pt;
        -aw-padding-left: 0.75pt;
        -aw-padding-right: 0.75pt;
        -aw-padding-top: 0.75pt;
      "
      class="td-title"
    >
      <p
        style="
          margin-bottom: 0pt;
          text-align: center;
          widows: 2;
          orphans: 2;
        "
      >
        <span style="font-weight: bold">유형</span>
      </p>
    </td>
    <td
      style="
        width: 10.52%;
        border-right-style: solid;
        border-right-width: 1.5pt;
        border-bottom-style: solid;
        border-bottom-width: 1.5pt;
        padding-top: 0.75pt;
        padding-left: 0.75pt;
        padding-bottom: 0.75pt;
        vertical-align: middle;
        -aw-padding-bottom: 0.75pt;
        -aw-padding-right: 0.75pt;
        -aw-padding-top: 0.75pt;
      "
      class="td-title"
    >
      <p
        style="
          margin-bottom: 0pt;
          text-align: center;
          widows: 2;
          orphans: 2;
        "
      >
        <span style="font-weight: bold">상세설명</span>
      </p>
    </td>
    <td
      style="
        width: 13.72%;
        border-right-style: solid;
        border-right-width: 1.5pt;
        border-bottom-style: solid;
        border-bottom-width: 1.5pt;
        padding-top: 0.75pt;
        padding-left: 0.75pt;
        padding-bottom: 0.75pt;
        vertical-align: middle;
        -aw-padding-bottom: 0.75pt;
        -aw-padding-right: 0.75pt;
        -aw-padding-top: 0.75pt;
      "
      class="td-title"
    >
      <p
        style="
          margin-bottom: 0pt;
          text-align: center;
          widows: 2;
          orphans: 2;
        "
      >
        <span style="font-weight: bold">1</span
        ><span style="font-weight: bold">차</span>
      </p>
    </td>
    <td
      style="
        width: 13.72%;
        border-right-style: solid;
        border-right-width: 1.5pt;
        border-bottom-style: solid;
        border-bottom-width: 1.5pt;
        padding-top: 0.75pt;
        padding-left: 0.75pt;
        padding-bottom: 0.75pt;
        vertical-align: middle;
        -aw-padding-bottom: 0.75pt;
        -aw-padding-right: 0.75pt;
        -aw-padding-top: 0.75pt;
      "
      class="td-title"
    >
      <p
        style="
          margin-bottom: 0pt;
          text-align: center;
          widows: 2;
          orphans: 2;
        "
      >
        <span style="font-weight: bold">2</span
        ><span style="font-weight: bold">차</span>
      </p>
    </td>
    <td
      style="
        width: 19.5%;
        border-right-style: solid;
        border-right-width: 1.5pt;
        border-bottom-style: solid;
        border-bottom-width: 1.5pt;
        padding-top: 0.75pt;
        padding-left: 0.75pt;
        padding-bottom: 0.75pt;
        vertical-align: middle;
        -aw-padding-bottom: 0.75pt;
        -aw-padding-right: 0.75pt;
        -aw-padding-top: 0.75pt;
      "
      class="td-title"
    >
      <p
        style="
          margin-bottom: 0pt;
          text-align: center;
          widows: 2;
          orphans: 2;
        "
      >
        <span style="font-weight: bold">3</span
        ><span style="font-weight: bold">차</span>
      </p>
    </td>
    <td
      style="
        width: 7.46%;
        border-right-style: solid;
        border-right-width: 1.5pt;
        border-bottom-style: solid;
        border-bottom-width: 1.5pt;
        padding-top: 0.75pt;
        padding-left: 0.75pt;
        padding-bottom: 0.75pt;
        vertical-align: middle;
        -aw-padding-bottom: 0.75pt;
        -aw-padding-right: 0.75pt;
        -aw-padding-top: 0.75pt;
      "
      class="td-title"
    >
      <p
        style="
          margin-bottom: 0pt;
          text-align: center;
          widows: 2;
          orphans: 2;
        "
      >
        <span style="font-weight: bold">4</span
        ><span style="font-weight: bold">차</span>
      </p>
    </td>
    <td
      style="
        width: 7.46%;
        border-bottom-style: solid;
        border-bottom-width: 1.5pt;
        padding-top: 0.75pt;
        padding-left: 0.75pt;
        padding-bottom: 0.75pt;
        vertical-align: middle;
        -aw-padding-bottom: 0.75pt;
        -aw-padding-right: 0.75pt;
        -aw-padding-top: 0.75pt;
      "
      class="td-title"
    >
      <p
        style="
          margin-bottom: 0pt;
          text-align: center;
          widows: 2;
          orphans: 2;
        "
      >
        <span style="font-weight: bold">5</span
        ><span style="font-weight: bold">차</span>
      </p>
    </td>
  </tr>
  <tr style="height: 154.5pt">
    <td
      rowspan="2"
      style="
        width: 27.58%;
        border-right-style: solid;
        border-right-width: 1.5pt;
        border-bottom-style: solid;
        border-bottom-width: 1.5pt;
        padding-top: 0.75pt;
        padding-bottom: 0.75pt;
        vertical-align: middle;
        -aw-padding-bottom: 0.75pt;
        -aw-padding-left: 0.75pt;
        -aw-padding-right: 0.75pt;
      "
    >
      <p
        style="
          margin-right: 6pt;
          margin-left: 6pt;
          margin-bottom: 0pt;
          text-align: center;
          widows: 2;
          orphans: 2;
        "
      >
        <span>배매너행위</span>
      </p>
    </td>
    <td
      style="
        width: 10.52%;
        border-right-style: solid;
        border-right-width: 1.5pt;
        border-bottom-style: solid;
        border-bottom-width: 1.5pt;
        padding-top: 0.75pt;
        padding-left: 0.75pt;
        padding-bottom: 0.75pt;
        vertical-align: middle;
        -aw-padding-bottom: 0.75pt;
        -aw-padding-right: 0.75pt;
      "
    >
      <p
        style="
          margin-bottom: 0pt;
          text-align: center;
          widows: 2;
          orphans: 2;
        "
      >
        <span>운영진의</span><span> </span><span>게임운영을</span
        ><span> </span><span>의도적으로</span><span> </span
        ><span>방해하거나</span><span> </span><span>정상적인</span
        ><span> </span><span>운영을</span><span> </span
        ><span>저해하는</span><span> </span><span>행위</span>
      </p>
    </td>
    <td
      style="
        width: 13.72%;
        border-right-style: solid;
        border-right-width: 1.5pt;
        border-bottom-style: solid;
        border-bottom-width: 1.5pt;
        padding-top: 0.75pt;
        padding-left: 0.75pt;
        padding-bottom: 0.75pt;
        vertical-align: middle;
        -aw-padding-bottom: 0.75pt;
        -aw-padding-right: 0.75pt;
      "
    >
      <p
        style="
          margin-right: 6pt;
          margin-left: 6pt;
          margin-bottom: 0pt;
          text-align: center;
          widows: 2;
          orphans: 2;
        "
      >
        <span>경고</span>
      </p>
    </td>
    <td
      style="
        width: 13.72%;
        border-right-style: solid;
        border-right-width: 1.5pt;
        border-bottom-style: solid;
        border-bottom-width: 1.5pt;
        padding-top: 0.75pt;
        padding-left: 0.75pt;
        padding-bottom: 0.75pt;
        vertical-align: middle;
        -aw-padding-bottom: 0.75pt;
        -aw-padding-right: 0.75pt;
      "
    >
      <p
        style="
          margin-bottom: 0pt;
          text-align: center;
          widows: 2;
          orphans: 2;
        "
      >
        <span>1</span><span>일정지</span>
      </p>
    </td>
    <td
      style="
        width: 19.5%;
        border-right-style: solid;
        border-right-width: 1.5pt;
        border-bottom-style: solid;
        border-bottom-width: 1.5pt;
        padding-top: 0.75pt;
        padding-left: 0.75pt;
        padding-bottom: 0.75pt;
        vertical-align: middle;
        -aw-padding-bottom: 0.75pt;
        -aw-padding-right: 0.75pt;
      "
    >
      <p
        style="
          margin-bottom: 0pt;
          text-align: center;
          widows: 2;
          orphans: 2;
        "
      >
        <span>3</span><span>일정지</span>
      </p>
    </td>
    <td
      style="
        width: 7.46%;
        border-right-style: solid;
        border-right-width: 1.5pt;
        border-bottom-style: solid;
        border-bottom-width: 1.5pt;
        padding-top: 0.75pt;
        padding-left: 0.75pt;
        padding-bottom: 0.75pt;
        vertical-align: middle;
        -aw-padding-bottom: 0.75pt;
        -aw-padding-right: 0.75pt;
      "
    >
      <p
        style="
          margin-bottom: 0pt;
          text-align: center;
          widows: 2;
          orphans: 2;
        "
      >
        <span>5</span><span>일정지</span>
      </p>
    </td>
    <td
      style="
        width: 7.46%;
        border-bottom-style: solid;
        border-bottom-width: 1.5pt;
        padding-top: 0.75pt;
        padding-left: 0.75pt;
        padding-bottom: 0.75pt;
        vertical-align: middle;
        -aw-padding-bottom: 0.75pt;
        -aw-padding-right: 0.75pt;
      "
    >
      <p
        style="
          margin-bottom: 0pt;
          text-align: center;
          widows: 2;
          orphans: 2;
        "
      >
        <span>영구정지</span>
      </p>
    </td>
  </tr>
  <tr style="height: 160.5pt">
    <td
      style="
        width: 10.52%;
        border-right-style: solid;
        border-right-width: 1.5pt;
        border-bottom-style: solid;
        border-bottom-width: 1.5pt;
        padding-top: 0.75pt;
        padding-left: 0.75pt;
        padding-bottom: 0.75pt;
        vertical-align: middle;
        -aw-padding-bottom: 0.75pt;
        -aw-padding-right: 0.75pt;
      "
    >
      <p
        style="
          margin-bottom: 0pt;
          text-align: center;
          widows: 2;
          orphans: 2;
        "
      >
        <span>유언비어</span><span> </span><span>유포</span><span>, </span
        ><span>대한민국</span><span> </span><span>실정법</span
        ><span> </span><span>및</span><span> </span><span>공공질서</span
        ><span>, </span><span>미풍약속에</span><span> </span
        ><span>위반되는</span><span> </span><span>모든</span><span> </span
        ><span>행위</span>
      </p>
    </td>
    <td
      style="
        width: 13.72%;
        border-right-style: solid;
        border-right-width: 1.5pt;
        border-bottom-style: solid;
        border-bottom-width: 1.5pt;
        padding-top: 0.75pt;
        padding-left: 0.75pt;
        padding-bottom: 0.75pt;
        vertical-align: middle;
        -aw-padding-bottom: 0.75pt;
        -aw-padding-right: 0.75pt;
      "
    >
      <p
        style="
          margin-right: 6pt;
          margin-left: 6pt;
          margin-bottom: 0pt;
          text-align: center;
          widows: 2;
          orphans: 2;
        "
      >
        <span>경고</span>
      </p>
    </td>
    <td
      style="
        width: 13.72%;
        border-right-style: solid;
        border-right-width: 1.5pt;
        border-bottom-style: solid;
        border-bottom-width: 1.5pt;
        padding-top: 0.75pt;
        padding-left: 0.75pt;
        padding-bottom: 0.75pt;
        vertical-align: middle;
        -aw-padding-bottom: 0.75pt;
        -aw-padding-right: 0.75pt;
      "
    >
      <p
        style="
          margin-bottom: 0pt;
          text-align: center;
          widows: 2;
          orphans: 2;
        "
      >
        <span>1</span><span>일정지</span>
      </p>
    </td>
    <td
      style="
        width: 19.5%;
        border-right-style: solid;
        border-right-width: 1.5pt;
        border-bottom-style: solid;
        border-bottom-width: 1.5pt;
        padding-top: 0.75pt;
        padding-left: 0.75pt;
        padding-bottom: 0.75pt;
        vertical-align: middle;
        -aw-padding-bottom: 0.75pt;
        -aw-padding-right: 0.75pt;
      "
    >
      <p
        style="
          margin-bottom: 0pt;
          text-align: center;
          widows: 2;
          orphans: 2;
        "
      >
        <span>3</span><span>일정지</span>
      </p>
    </td>
    <td
      style="
        width: 7.46%;
        border-right-style: solid;
        border-right-width: 1.5pt;
        border-bottom-style: solid;
        border-bottom-width: 1.5pt;
        padding-top: 0.75pt;
        padding-left: 0.75pt;
        padding-bottom: 0.75pt;
        vertical-align: middle;
        -aw-padding-bottom: 0.75pt;
        -aw-padding-right: 0.75pt;
      "
    >
      <p
        style="
          margin-bottom: 0pt;
          text-align: center;
          widows: 2;
          orphans: 2;
        "
      >
        <span>5</span><span>일정지</span>
      </p>
    </td>
    <td
      style="
        width: 7.46%;
        border-bottom-style: solid;
        border-bottom-width: 1.5pt;
        padding-top: 0.75pt;
        padding-left: 0.75pt;
        padding-bottom: 0.75pt;
        vertical-align: middle;
        -aw-padding-bottom: 0.75pt;
        -aw-padding-right: 0.75pt;
      "
    >
      <p
        style="
          margin-bottom: 0pt;
          text-align: center;
          widows: 2;
          orphans: 2;
        "
      >
        <span>영구정지</span>
      </p>
    </td>
  </tr>
  <tr style="height: 316.5pt">
    <td
      style="
        width: 27.58%;
        border-right-style: solid;
        border-right-width: 1.5pt;
        padding-top: 0.75pt;
        padding-bottom: 0.75pt;
        vertical-align: middle;
        -aw-padding-bottom: 0.75pt;
        -aw-padding-left: 0.75pt;
        -aw-padding-right: 0.75pt;
      "
    >
      <p
        style="
          margin-right: 6pt;
          margin-left: 6pt;
          margin-bottom: 0pt;
          text-align: center;
          widows: 2;
          orphans: 2;
        "
      >
        <span>운영자</span><span style="">&#xa0;</span><span>및</span
        ><span style="">&#xa0;</span><span>직원사칭</span>
      </p>
    </td>
    <td
      style="
        width: 10.52%;
        border-right-style: solid;
        border-right-width: 1.5pt;
        padding-top: 0.75pt;
        padding-left: 0.75pt;
        padding-bottom: 0.75pt;
        vertical-align: middle;
        -aw-padding-bottom: 0.75pt;
        -aw-padding-right: 0.75pt;
      "
    >
      <p
        style="
          margin-bottom: 0pt;
          text-align: center;
          widows: 2;
          orphans: 2;
        "
      >
        <span>타인을</span><span> </span><span>기망하여</span
        ><span> </span><span>이득을</span><span> </span
        ><span>취하려는</span><span> </span><span>행위</span><span> </span
        ><span>또는</span><span> </span><span>타인의</span><span> </span
        ><span>서비스</span><span> </span><span>이용을</span><span> </span
        ><span>방해한</span><span> </span><span>경우</span>
      </p>
    </td>
    <td
      style="
        width: 13.72%;
        border-right-style: solid;
        border-right-width: 1.5pt;
        padding-top: 0.75pt;
        padding-left: 0.75pt;
        padding-bottom: 0.75pt;
        vertical-align: middle;
        -aw-padding-bottom: 0.75pt;
        -aw-padding-right: 0.75pt;
      "
    >
      <p
        style="
          margin-bottom: 0pt;
          text-align: center;
          widows: 2;
          orphans: 2;
        "
      >
        <span>재화회수후</span><span>&#xa0;</span><span> </span
        ><span>3</span><span>일</span><span> </span><span>정지</span>
      </p>
    </td>
    <td
      style="
        width: 13.72%;
        border-right-style: solid;
        border-right-width: 1.5pt;
        padding-top: 0.75pt;
        padding-left: 0.75pt;
        padding-bottom: 0.75pt;
        vertical-align: middle;
        -aw-padding-bottom: 0.75pt;
        -aw-padding-right: 0.75pt;
      "
    >
      <p
        style="
          margin-bottom: 0pt;
          text-align: center;
          widows: 2;
          orphans: 2;
        "
      >
        <span>재화회수후</span><span>&#xa0;</span><span> </span
        ><span>7</span><span>일</span><span> </span><span>정지</span>
      </p>
    </td>
    <td
      style="
        width: 19.5%;
        border-right-style: solid;
        border-right-width: 1.5pt;
        padding-top: 0.75pt;
        padding-left: 0.75pt;
        padding-bottom: 0.75pt;
        vertical-align: middle;
        -aw-padding-bottom: 0.75pt;
        -aw-padding-right: 0.75pt;
      "
    >
      <p
        style="
          margin-bottom: 0pt;
          text-align: center;
          widows: 2;
          orphans: 2;
        "
      >
        <span>재화회수후</span><span>&#xa0;</span><span> </span
        ><span>30</span><span>일</span><span>&#xa0;</span><span> </span
        ><span>정지</span>
      </p>
    </td>
    <td
      style="
        width: 7.46%;
        border-right-style: solid;
        border-right-width: 1.5pt;
        padding-top: 0.75pt;
        padding-left: 0.75pt;
        padding-bottom: 0.75pt;
        vertical-align: middle;
        -aw-padding-bottom: 0.75pt;
        -aw-padding-right: 0.75pt;
      "
    >
      <p
        style="
          margin-bottom: 0pt;
          text-align: center;
          widows: 2;
          orphans: 2;
        "
      >
        <span>영구정지</span>
      </p>
    </td>
    <td
      style="
        width: 7.46%;
        padding-top: 0.75pt;
        padding-left: 0.75pt;
        padding-bottom: 0.75pt;
        vertical-align: middle;
        -aw-padding-bottom: 0.75pt;
        -aw-padding-right: 0.75pt;
      "
    >
      <p
        style="
          margin-bottom: 0pt;
          text-align: center;
          widows: 2;
          orphans: 2;
        "
      >
        <span>&#xa0;</span>
      </p>
    </td>
  </tr>
</table>
<p
  style="
    margin-top: 14pt;
    margin-bottom: 14pt;
    line-height: normal;
    widows: 2;
    orphans: 2;
  "
>
  <span>&#xa0;</span>
</p>
<table
  cellspacing="0"
  cellpadding="0"
  style="
    width: 100%;
    margin-bottom: 0pt;
    border: 1.5pt solid #000000;
    border-collapse: collapse;
    float: left;
  "
>
  <tr style="height: 40.5pt">
    <td
      style="
        width: 20%;
        border-right-style: solid;
        border-right-width: 1.5pt;
        border-bottom-style: solid;
        border-bottom-width: 1.5pt;
        padding-top: 0.75pt;
        padding-bottom: 0.75pt;
        vertical-align: middle;
        -aw-padding-bottom: 0.75pt;
        -aw-padding-left: 0.75pt;
        -aw-padding-right: 0.75pt;
        -aw-padding-top: 0.75pt;
      "
      class="td-title"
    >
      <p
        style="
          margin-bottom: 0pt;
          text-align: center;
          widows: 2;
          orphans: 2;
        "
      >
        <span style="font-weight: bold">유형</span>
      </p>
    </td>
    <td
      style="
        width: 20%;
        border-right-style: solid;
        border-right-width: 1.5pt;
        border-bottom-style: solid;
        border-bottom-width: 1.5pt;
        padding-top: 0.75pt;
        padding-left: 0.75pt;
        padding-bottom: 0.75pt;
        vertical-align: middle;
        -aw-padding-bottom: 0.75pt;
        -aw-padding-right: 0.75pt;
        -aw-padding-top: 0.75pt;
      "
      class="td-title"
    >
      <p
        style="
          margin-bottom: 0pt;
          text-align: center;
          widows: 2;
          orphans: 2;
        "
      >
        <span style="font-weight: bold">상세설명</span>
      </p>
    </td>
    <td
      style="
        width: 8%;
        border-right-style: solid;
        border-right-width: 1.5pt;
        border-bottom-style: solid;
        border-bottom-width: 1.5pt;
        padding-top: 0.75pt;
        padding-left: 0.75pt;
        padding-bottom: 0.75pt;
        vertical-align: middle;
        -aw-padding-bottom: 0.75pt;
        -aw-padding-right: 0.75pt;
        -aw-padding-top: 0.75pt;
      "
      class="td-title"
    >
      <p
        style="
          margin-bottom: 0pt;
          text-align: center;
          widows: 2;
          orphans: 2;
        "
      >
        <span style="font-weight: bold">1</span
        ><span style="font-weight: bold">차</span>
      </p>
    </td>
    <td
      style="
        width: 8%;
        border-right-style: solid;
        border-right-width: 1.5pt;
        border-bottom-style: solid;
        border-bottom-width: 1.5pt;
        padding-top: 0.75pt;
        padding-left: 0.75pt;
        padding-bottom: 0.75pt;
        vertical-align: middle;
        -aw-padding-bottom: 0.75pt;
        -aw-padding-right: 0.75pt;
        -aw-padding-top: 0.75pt;
      "
      class="td-title"
    >
      <p
        style="
          margin-bottom: 0pt;
          text-align: center;
          widows: 2;
          orphans: 2;
        "
      >
        <span style="font-weight: bold">2</span
        ><span style="font-weight: bold">차</span>
      </p>
    </td>
    <td
      style="
        width: 10%;
        border-right-style: solid;
        border-right-width: 1.5pt;
        border-bottom-style: solid;
        border-bottom-width: 1.5pt;
        padding-top: 0.75pt;
        padding-left: 0.75pt;
        padding-bottom: 0.75pt;
        vertical-align: middle;
        -aw-padding-bottom: 0.75pt;
        -aw-padding-right: 0.75pt;
        -aw-padding-top: 0.75pt;
      "
      class="td-title"
    >
      <p
        style="
          margin-bottom: 0pt;
          text-align: center;
          widows: 2;
          orphans: 2;
        "
      >
        <span style="font-weight: bold">3</span
        ><span style="font-weight: bold">차</span>
      </p>
    </td>
    <td
      style="
        width: 6%;
        border-right-style: solid;
        border-right-width: 1.5pt;
        border-bottom-style: solid;
        border-bottom-width: 1.5pt;
        padding-top: 0.75pt;
        padding-left: 0.75pt;
        padding-bottom: 0.75pt;
        vertical-align: middle;
        -aw-padding-bottom: 0.75pt;
        -aw-padding-right: 0.75pt;
        -aw-padding-top: 0.75pt;
      "
      class="td-title"
    >
      <p
        style="
          margin-bottom: 0pt;
          text-align: center;
          widows: 2;
          orphans: 2;
        "
      >
        <span style="font-weight: bold">4</span
        ><span style="font-weight: bold">차</span>
      </p>
    </td>
    <td
      style="
        width: 6%;
        border-bottom-style: solid;
        border-bottom-width: 1.5pt;
        padding-top: 0.75pt;
        padding-left: 0.75pt;
        padding-bottom: 0.75pt;
        vertical-align: middle;
        -aw-padding-bottom: 0.75pt;
        -aw-padding-right: 0.75pt;
        -aw-padding-top: 0.75pt;
      "
      class="td-title"
    >
      <p
        style="
          margin-bottom: 0pt;
          text-align: center;
          widows: 2;
          orphans: 2;
        "
      >
        <span style="font-weight: bold">5</span
        ><span style="font-weight: bold">차</span>
      </p>
    </td>
  </tr>
  <tr style="height: 90pt">
    <td
      style="
        width: 20%;
        border-right-style: solid;
        border-right-width: 1.5pt;
        border-bottom-style: solid;
        border-bottom-width: 1.5pt;
        padding-top: 0.75pt;
        padding-bottom: 0.75pt;
        vertical-align: middle;
        -aw-padding-bottom: 0.75pt;
        -aw-padding-left: 0.75pt;
        -aw-padding-right: 0.75pt;
      "
    >
      <p
        style="
          margin-right: 6pt;
          margin-left: 6pt;
          margin-bottom: 0pt;
          text-align: center;
          widows: 2;
          orphans: 2;
        "
      >
        <span>명칭</span>
      </p>
    </td>
    <td
      style="
        width: 20%;
        border-right-style: solid;
        border-right-width: 1.5pt;
        border-bottom-style: solid;
        border-bottom-width: 1.5pt;
        padding-top: 0.75pt;
        padding-left: 0.75pt;
        padding-bottom: 0.75pt;
        vertical-align: middle;
        -aw-padding-bottom: 0.75pt;
        -aw-padding-right: 0.75pt;
      "
    >
      <p
        style="
          margin-bottom: 0pt;
          text-align: center;
          widows: 2;
          orphans: 2;
        "
      >
        <span>명칭</span><span> </span><span>관리</span><span> </span
        ><span>기준에</span><span> </span><span>어긋나는</span
        ><span> </span><span>명칭을</span><span> </span
        ><span>사용하는</span><span> </span><span>경우</span>
      </p>
    </td>
    <td
      style="
        width: 8%;
        border-right-style: solid;
        border-right-width: 1.5pt;
        border-bottom-style: solid;
        border-bottom-width: 1.5pt;
        padding-top: 0.75pt;
        padding-left: 0.75pt;
        padding-bottom: 0.75pt;
        vertical-align: middle;
        -aw-padding-bottom: 0.75pt;
        -aw-padding-right: 0.75pt;
      "
    >
      <p
        style="
          margin-right: 6pt;
          margin-left: 6pt;
          margin-bottom: 0pt;
          text-align: center;
          widows: 2;
          orphans: 2;
        "
      >
        <span>경고</span>
      </p>
    </td>
    <td
      style="
        width: 8%;
        border-right-style: solid;
        border-right-width: 1.5pt;
        border-bottom-style: solid;
        border-bottom-width: 1.5pt;
        padding-top: 0.75pt;
        padding-left: 0.75pt;
        padding-bottom: 0.75pt;
        vertical-align: middle;
        -aw-padding-bottom: 0.75pt;
        -aw-padding-right: 0.75pt;
      "
    >
      <p
        style="
          margin-bottom: 0pt;
          text-align: center;
          widows: 2;
          orphans: 2;
        "
      >
        <span>1</span><span>일정지</span>
      </p>
    </td>
    <td
      style="
        width: 10%;
        border-right-style: solid;
        border-right-width: 1.5pt;
        border-bottom-style: solid;
        border-bottom-width: 1.5pt;
        padding-top: 0.75pt;
        padding-left: 0.75pt;
        padding-bottom: 0.75pt;
        vertical-align: middle;
        -aw-padding-bottom: 0.75pt;
        -aw-padding-right: 0.75pt;
      "
    >
      <p
        style="
          margin-bottom: 0pt;
          text-align: center;
          widows: 2;
          orphans: 2;
        "
      >
        <span>3</span><span>일정지</span>
      </p>
    </td>
    <td
      style="
        width: 6%;
        border-right-style: solid;
        border-right-width: 1.5pt;
        border-bottom-style: solid;
        border-bottom-width: 1.5pt;
        padding-top: 0.75pt;
        padding-left: 0.75pt;
        padding-bottom: 0.75pt;
        vertical-align: middle;
        -aw-padding-bottom: 0.75pt;
        -aw-padding-right: 0.75pt;
      "
    >
      <p
        style="
          margin-bottom: 0pt;
          text-align: center;
          widows: 2;
          orphans: 2;
        "
      >
        <span>5</span><span>일정지</span>
      </p>
    </td>
    <td
      style="
        width: 6%;
        border-bottom-style: solid;
        border-bottom-width: 1.5pt;
        padding-top: 0.75pt;
        padding-left: 0.75pt;
        padding-bottom: 0.75pt;
        vertical-align: middle;
        -aw-padding-bottom: 0.75pt;
        -aw-padding-right: 0.75pt;
      "
    >
      <p
        style="
          margin-bottom: 0pt;
          text-align: center;
          widows: 2;
          orphans: 2;
        "
      >
        <span>영구정지</span>
      </p>
    </td>
  </tr>
  <tr style="height: 156pt">
    <td
      rowspan="2"
      style="
        width: 20%;
        border-right-style: solid;
        border-right-width: 1.5pt;
        border-bottom-style: solid;
        border-bottom-width: 1.5pt;
        padding-top: 0.75pt;
        padding-bottom: 0.75pt;
        vertical-align: middle;
        -aw-padding-bottom: 0.75pt;
        -aw-padding-left: 0.75pt;
        -aw-padding-right: 0.75pt;
      "
    >
      <p
        style="
          margin-right: 6pt;
          margin-left: 6pt;
          margin-bottom: 0pt;
          text-align: center;
          widows: 2;
          orphans: 2;
        "
      >
        <span>사기</span>
      </p>
    </td>
    <td
      style="
        width: 20%;
        border-right-style: solid;
        border-right-width: 1.5pt;
        border-bottom-style: solid;
        border-bottom-width: 1.5pt;
        padding-top: 0.75pt;
        padding-left: 0.75pt;
        padding-bottom: 0.75pt;
        vertical-align: middle;
        -aw-padding-bottom: 0.75pt;
        -aw-padding-right: 0.75pt;
      "
    >
      <p
        style="
          margin-bottom: 0pt;
          text-align: center;
          widows: 2;
          orphans: 2;
        "
      >
        <span>특정</span><span> </span><span>캐릭터와</span><span> </span
        ><span>혼동을</span><span> </span><span>줄</span><span> </span
        ><span>수</span><span> </span><span>있는</span><span> </span
        ><span>닉넴임을</span><span> </span><span>사용하여</span
        ><span> </span><span>사기</span><span> </span><span>행위를</span
        ><span> </span><span>하는</span><span> </span><span>경우</span>
      </p>
    </td>
    <td
      style="
        width: 8%;
        border-right-style: solid;
        border-right-width: 1.5pt;
        border-bottom-style: solid;
        border-bottom-width: 1.5pt;
        padding-top: 0.75pt;
        padding-left: 0.75pt;
        padding-bottom: 0.75pt;
        vertical-align: middle;
        -aw-padding-bottom: 0.75pt;
        -aw-padding-right: 0.75pt;
      "
    >
      <p
        style="
          margin-bottom: 0pt;
          text-align: center;
          widows: 2;
          orphans: 2;
        "
      >
        <span>재화회수후</span><span>&#xa0;</span><span> </span
        ><span>3</span><span>일</span><span> </span><span>영구정지</span>
      </p>
    </td>
    <td
      style="
        width: 8%;
        border-right-style: solid;
        border-right-width: 1.5pt;
        border-bottom-style: solid;
        border-bottom-width: 1.5pt;
        padding-top: 0.75pt;
        padding-left: 0.75pt;
        padding-bottom: 0.75pt;
        vertical-align: middle;
        -aw-padding-bottom: 0.75pt;
        -aw-padding-right: 0.75pt;
      "
    >
      <p
        style="
          margin-bottom: 0pt;
          text-align: center;
          widows: 2;
          orphans: 2;
        "
      >
        <span>재화회수후</span><span>&#xa0;</span><span> </span
        ><span>7</span><span>일</span><span> </span><span>영구정지</span>
      </p>
    </td>
    <td
      style="
        width: 10%;
        border-right-style: solid;
        border-right-width: 1.5pt;
        border-bottom-style: solid;
        border-bottom-width: 1.5pt;
        padding-top: 0.75pt;
        padding-left: 0.75pt;
        padding-bottom: 0.75pt;
        vertical-align: middle;
        -aw-padding-bottom: 0.75pt;
        -aw-padding-right: 0.75pt;
      "
    >
      <p
        style="
          margin-bottom: 0pt;
          text-align: center;
          widows: 2;
          orphans: 2;
        "
      >
        <span>재화회수후</span><span>&#xa0;</span><span> </span
        ><span>30</span><span>일</span><span>&#xa0;</span><span> </span
        ><span>영구정지</span>
      </p>
    </td>
    <td
      style="
        width: 6%;
        border-right-style: solid;
        border-right-width: 1.5pt;
        border-bottom-style: solid;
        border-bottom-width: 1.5pt;
        padding-top: 0.75pt;
        padding-left: 0.75pt;
        padding-bottom: 0.75pt;
        vertical-align: middle;
        -aw-padding-bottom: 0.75pt;
        -aw-padding-right: 0.75pt;
      "
    >
      <p
        style="
          margin-bottom: 0pt;
          text-align: center;
          widows: 2;
          orphans: 2;
        "
      >
        <span>&#xa0;</span>
      </p>
    </td>
    <td
      style="
        width: 6%;
        border-bottom-style: solid;
        border-bottom-width: 1.5pt;
        padding-top: 0.75pt;
        padding-left: 0.75pt;
        padding-bottom: 0.75pt;
        vertical-align: middle;
        -aw-padding-bottom: 0.75pt;
        -aw-padding-right: 0.75pt;
      "
    >
      <p
        style="
          margin-bottom: 0pt;
          text-align: center;
          widows: 2;
          orphans: 2;
        "
      >
        <span>&#xa0;</span>
      </p>
    </td>
  </tr>
  <tr style="height: 153pt">
    <td
      style="
        width: 20%;
        border-right-style: solid;
        border-right-width: 1.5pt;
        border-bottom-style: solid;
        border-bottom-width: 1.5pt;
        padding-top: 0.75pt;
        padding-left: 0.75pt;
        padding-bottom: 0.75pt;
        vertical-align: middle;
        -aw-padding-bottom: 0.75pt;
        -aw-padding-right: 0.75pt;
      "
    >
      <p
        style="
          margin-bottom: 0pt;
          text-align: center;
          widows: 2;
          orphans: 2;
        "
      >
        <span>게임내</span><span> </span><span>아이템</span><span>/</span
        ><span>게임</span><span> </span><span>머니</span><span> </span
        ><span>등을</span><span> </span><span>부당하게</span><span> </span
        ><span>취하기</span><span> </span><span>위해</span><span> </span
        ><span>고의적인</span><span> </span><span>목적을</span
        ><span> </span><span>가지고</span><span> </span><span>사기</span
        ><span> </span><span>행위를</span><span> </span><span>하는</span
        ><span> </span><span>경우</span>
      </p>
    </td>
    <td
      style="
        width: 8%;
        border-right-style: solid;
        border-right-width: 1.5pt;
        border-bottom-style: solid;
        border-bottom-width: 1.5pt;
        padding-top: 0.75pt;
        padding-left: 0.75pt;
        padding-bottom: 0.75pt;
        vertical-align: middle;
        -aw-padding-bottom: 0.75pt;
        -aw-padding-right: 0.75pt;
      "
    >
      <p
        style="
          margin-bottom: 0pt;
          text-align: center;
          widows: 2;
          orphans: 2;
        "
      >
        <span>재화회수후</span><span>&#xa0;</span><span> </span
        ><span>3</span><span>일</span><span> </span><span>정지</span>
      </p>
    </td>
    <td
      style="
        width: 8%;
        border-right-style: solid;
        border-right-width: 1.5pt;
        border-bottom-style: solid;
        border-bottom-width: 1.5pt;
        padding-top: 0.75pt;
        padding-left: 0.75pt;
        padding-bottom: 0.75pt;
        vertical-align: middle;
        -aw-padding-bottom: 0.75pt;
        -aw-padding-right: 0.75pt;
      "
    >
      <p
        style="
          margin-bottom: 0pt;
          text-align: center;
          widows: 2;
          orphans: 2;
        "
      >
        <span>재화회수후</span><span>&#xa0;</span><span> </span
        ><span>7</span><span>일</span><span> </span><span>정지</span>
      </p>
    </td>
    <td
      style="
        width: 10%;
        border-right-style: solid;
        border-right-width: 1.5pt;
        border-bottom-style: solid;
        border-bottom-width: 1.5pt;
        padding-top: 0.75pt;
        padding-left: 0.75pt;
        padding-bottom: 0.75pt;
        vertical-align: middle;
        -aw-padding-bottom: 0.75pt;
        -aw-padding-right: 0.75pt;
      "
    >
      <p
        style="
          margin-bottom: 0pt;
          text-align: center;
          widows: 2;
          orphans: 2;
        "
      >
        <span>재화회수후</span><span>&#xa0;</span><span> </span
        ><span>30</span><span>일</span><span>&#xa0;</span><span> </span
        ><span>정지</span>
      </p>
    </td>
    <td
      style="
        width: 6%;
        border-right-style: solid;
        border-right-width: 1.5pt;
        border-bottom-style: solid;
        border-bottom-width: 1.5pt;
        padding-top: 0.75pt;
        padding-left: 0.75pt;
        padding-bottom: 0.75pt;
        vertical-align: middle;
        -aw-padding-bottom: 0.75pt;
        -aw-padding-right: 0.75pt;
      "
    >
      <p
        style="
          margin-bottom: 0pt;
          text-align: center;
          widows: 2;
          orphans: 2;
        "
      >
        <span>영구정지</span>
      </p>
    </td>
    <td
      style="
        width: 6%;
        border-bottom-style: solid;
        border-bottom-width: 1.5pt;
        padding-top: 0.75pt;
        padding-left: 0.75pt;
        padding-bottom: 0.75pt;
        vertical-align: middle;
        -aw-padding-bottom: 0.75pt;
        -aw-padding-right: 0.75pt;
      "
    >
      <p
        style="
          margin-bottom: 0pt;
          text-align: center;
          widows: 2;
          orphans: 2;
        "
      >
        <span>&#xa0;</span>
      </p>
    </td>
  </tr>
  <tr style="height: 146.25pt">
    <td
      style="
        width: 20%;
        border-right-style: solid;
        border-right-width: 1.5pt;
        padding-top: 0.75pt;
        padding-bottom: 0.75pt;
        vertical-align: middle;
        -aw-padding-bottom: 0.75pt;
        -aw-padding-left: 0.75pt;
        -aw-padding-right: 0.75pt;
      "
    >
      <p
        style="
          margin-bottom: 0pt;
          text-align: center;
          widows: 2;
          orphans: 2;
        "
      >
        <span>시스템오류</span><span style="">&#xa0;</span
        ><span>또는</span><span style="">&#xa0;</span><span>버그의</span
        ><span style="">&#xa0;</span><span>악용</span>
      </p>
    </td>
    <td
      style="
        width: 20%;
        border-right-style: solid;
        border-right-width: 1.5pt;
        padding-top: 0.75pt;
        padding-left: 0.75pt;
        padding-bottom: 0.75pt;
        vertical-align: middle;
        -aw-padding-bottom: 0.75pt;
        -aw-padding-right: 0.75pt;
      "
    >
      <p
        style="
          margin-bottom: 0pt;
          text-align: center;
          widows: 2;
          orphans: 2;
        "
      >
        <span>서비스상의</span><span> </span><span>버그임을</span
        ><span> </span><span>인지하고도</span><span> </span
        ><span>반복적으로</span><span> </span><span>또는</span
        ><span> </span><span>경고조치</span><span> </span
        ><span>후에도</span><span> </span><span>이를</span><span> </span
        ><span>악용하여</span><span> </span><span>시스템이나</span
        ><span> </span><span>서비스</span><span> </span><span>또는</span
        ><span> </span><span>게임</span><span> </span><span>환경에</span
        ><span> </span><span>중대한</span><span> </span><span>영향을</span
        ><span> </span><span>미치는</span><span> </span><span>행위</span>
      </p>
    </td>
    <td
      style="
        width: 8%;
        border-right-style: solid;
        border-right-width: 1.5pt;
        padding-top: 0.75pt;
        padding-left: 0.75pt;
        padding-bottom: 0.75pt;
        vertical-align: middle;
        -aw-padding-bottom: 0.75pt;
        -aw-padding-right: 0.75pt;
      "
    >
      <p
        style="
          margin-bottom: 0pt;
          text-align: center;
          widows: 2;
          orphans: 2;
        "
      >
        <span>재화회수후</span><span>&#xa0;</span><span> </span
        ><span>3</span><span>일</span><span> </span><span>정지</span>
      </p>
    </td>
    <td
      style="
        width: 8%;
        border-right-style: solid;
        border-right-width: 1.5pt;
        padding-top: 0.75pt;
        padding-left: 0.75pt;
        padding-bottom: 0.75pt;
        vertical-align: middle;
        -aw-padding-bottom: 0.75pt;
        -aw-padding-right: 0.75pt;
      "
    >
      <p
        style="
          margin-bottom: 0pt;
          text-align: center;
          widows: 2;
          orphans: 2;
        "
      >
        <span>재화회수후</span><span>&#xa0;</span><span> </span
        ><span>7</span><span>일</span><span> </span><span>정지</span>
      </p>
    </td>
    <td
      style="
        width: 10%;
        border-right-style: solid;
        border-right-width: 1.5pt;
        padding-top: 0.75pt;
        padding-left: 0.75pt;
        padding-bottom: 0.75pt;
        vertical-align: middle;
        -aw-padding-bottom: 0.75pt;
        -aw-padding-right: 0.75pt;
      "
    >
      <p
        style="
          margin-bottom: 0pt;
          text-align: center;
          widows: 2;
          orphans: 2;
        "
      >
        <span>재화회수후</span><span>&#xa0;</span><span> </span
        ><span>30</span><span>일</span><span>&#xa0;</span><span> </span
        ><span>정지</span>
      </p>
    </td>
    <td
      style="
        width: 6%;
        border-right-style: solid;
        border-right-width: 1.5pt;
        padding-top: 0.75pt;
        padding-left: 0.75pt;
        padding-bottom: 0.75pt;
        vertical-align: middle;
        -aw-padding-bottom: 0.75pt;
        -aw-padding-right: 0.75pt;
      "
    >
      <p
        style="
          margin-bottom: 0pt;
          text-align: center;
          widows: 2;
          orphans: 2;
        "
      >
        <span>영구정지</span>
      </p>
    </td>
    <td
      style="
        width: 6%;
        padding-top: 0.75pt;
        padding-left: 0.75pt;
        padding-bottom: 0.75pt;
        vertical-align: middle;
        -aw-padding-bottom: 0.75pt;
        -aw-padding-right: 0.75pt;
      "
    >
      <p
        style="
          margin-bottom: 0pt;
          text-align: center;
          widows: 2;
          orphans: 2;
        "
      >
        <span>&#xa0;</span>
      </p>
    </td>
  </tr>
</table>
<p
  style="
    margin-top: 14pt;
    margin-bottom: 14pt;
    text-align: justify;
    line-height: normal;
    widows: 2;
    orphans: 2;
  "
>
  <span>&#xa0;</span>
</p>
<table
  cellspacing="0"
  cellpadding="0"
  style="
    width: 100%;
    margin-bottom: 0pt;
    border: 1.5pt solid #000000;
    border-collapse: collapse;
    float: left;
  "
>
  <tr style="height: 40.5pt">
    <td
      style="
        width: 11.56%;
        border-right-style: solid;
        border-right-width: 1.5pt;
        border-bottom-style: solid;
        border-bottom-width: 1.5pt;
        padding-top: 0.75pt;
        padding-bottom: 0.75pt;
        vertical-align: middle;
        -aw-padding-bottom: 0.75pt;
        -aw-padding-left: 0.75pt;
        -aw-padding-right: 0.75pt;
        -aw-padding-top: 0.75pt;
      "
      class="td-title"
    >
      <p
        style="
          margin-bottom: 0pt;
          text-align: center;
          widows: 2;
          orphans: 2;
        "
      >
        <span style="font-weight: bold">유형</span>
      </p>
    </td>
    <td
      style="
        width: 53.38%;
        border-right-style: solid;
        border-right-width: 1.5pt;
        border-bottom-style: solid;
        border-bottom-width: 1.5pt;
        padding-top: 0.75pt;
        padding-left: 0.75pt;
        padding-bottom: 0.75pt;
        vertical-align: middle;
        -aw-padding-bottom: 0.75pt;
        -aw-padding-right: 0.75pt;
        -aw-padding-top: 0.75pt;
      "
      class="td-title"
    >
      <p
        style="
          margin-bottom: 0pt;
          text-align: center;
          widows: 2;
          orphans: 2;
        "
      >
        <span style="font-weight: bold">상세설명</span>
      </p>
    </td>
    <td
      style="
        width: 10.42%;
        border-right-style: solid;
        border-right-width: 1.5pt;
        border-bottom-style: solid;
        border-bottom-width: 1.5pt;
        padding-top: 0.75pt;
        padding-left: 0.75pt;
        padding-bottom: 0.75pt;
        vertical-align: middle;
        -aw-padding-bottom: 0.75pt;
        -aw-padding-right: 0.75pt;
        -aw-padding-top: 0.75pt;
      "
      class="td-title"
    >
      <p
        style="
          margin-bottom: 0pt;
          text-align: center;
          widows: 2;
          orphans: 2;
        "
      >
        <span style="font-weight: bold">1</span
        ><span style="font-weight: bold">차</span>
      </p>
    </td>
    <td
      style="
        width: 6.24%;
        border-right-style: solid;
        border-right-width: 1.5pt;
        border-bottom-style: solid;
        border-bottom-width: 1.5pt;
        padding-top: 0.75pt;
        padding-left: 0.75pt;
        padding-bottom: 0.75pt;
        vertical-align: middle;
        -aw-padding-bottom: 0.75pt;
        -aw-padding-right: 0.75pt;
        -aw-padding-top: 0.75pt;
      "
      class="td-title"
    >
      <p
        style="
          margin-bottom: 0pt;
          text-align: center;
          widows: 2;
          orphans: 2;
        "
      >
        <span style="font-weight: bold">2</span
        ><span style="font-weight: bold">차</span>
      </p>
    </td>
    <td
      style="
        width: 5.9%;
        border-right-style: solid;
        border-right-width: 1.5pt;
        border-bottom-style: solid;
        border-bottom-width: 1.5pt;
        padding-top: 0.75pt;
        padding-left: 0.75pt;
        padding-bottom: 0.75pt;
        vertical-align: middle;
        -aw-padding-bottom: 0.75pt;
        -aw-padding-right: 0.75pt;
        -aw-padding-top: 0.75pt;
      "
      class="td-title"
    >
      <p
        style="
          margin-bottom: 0pt;
          text-align: center;
          widows: 2;
          orphans: 2;
        "
      >
        <span style="font-weight: bold">3</span
        ><span style="font-weight: bold">차</span>
      </p>
    </td>
    <td
      style="
        width: 6.24%;
        border-right-style: solid;
        border-right-width: 1.5pt;
        border-bottom-style: solid;
        border-bottom-width: 1.5pt;
        padding-top: 0.75pt;
        padding-left: 0.75pt;
        padding-bottom: 0.75pt;
        vertical-align: middle;
        -aw-padding-bottom: 0.75pt;
        -aw-padding-right: 0.75pt;
        -aw-padding-top: 0.75pt;
      "
      class="td-title"
    >
      <p
        style="
          margin-bottom: 0pt;
          text-align: center;
          widows: 2;
          orphans: 2;
        "
      >
        <span style="font-weight: bold">4</span
        ><span style="font-weight: bold">차</span>
      </p>
    </td>
    <td
      style="
        width: 6.24%;
        border-bottom-style: solid;
        border-bottom-width: 1.5pt;
        padding-top: 0.75pt;
        padding-left: 0.75pt;
        padding-bottom: 0.75pt;
        vertical-align: middle;
        -aw-padding-bottom: 0.75pt;
        -aw-padding-right: 0.75pt;
        -aw-padding-top: 0.75pt;
      "
      class="td-title"
    >
      <p
        style="
          margin-bottom: 0pt;
          text-align: center;
          widows: 2;
          orphans: 2;
        "
      >
        <span style="font-weight: bold">5</span
        ><span style="font-weight: bold">차</span>
      </p>
    </td>
  </tr>
  <tr style="height: 99pt">
    <td
      rowspan="2"
      style="
        width: 11.56%;
        border-right-style: solid;
        border-right-width: 1.5pt;
        border-bottom-style: solid;
        border-bottom-width: 1.5pt;
        padding-top: 0.75pt;
        padding-bottom: 0.75pt;
        vertical-align: middle;
        -aw-padding-bottom: 0.75pt;
        -aw-padding-left: 0.75pt;
        -aw-padding-right: 0.75pt;
      "
    >
      <p
        style="
          margin-right: 6pt;
          margin-left: 6pt;
          margin-bottom: 0pt;
          text-align: center;
          widows: 2;
          orphans: 2;
        "
      >
        <span>현금거래</span>
      </p>
    </td>
    <td
      style="
        width: 53.38%;
        border-right-style: solid;
        border-right-width: 1.5pt;
        border-bottom-style: solid;
        border-bottom-width: 1.5pt;
        padding-top: 0.75pt;
        padding-left: 0.75pt;
        padding-bottom: 0.75pt;
        vertical-align: middle;
        -aw-padding-bottom: 0.75pt;
        -aw-padding-right: 0.75pt;
      "
    >
      <p
        style="
          margin-bottom: 0pt;
          text-align: center;
          widows: 2;
          orphans: 2;
        "
      >
        <span>게임내</span><span> </span><span>컨텐츠</span><span> </span
        ><span>(</span><span>아이템</span><span>/</span
        ><span>게임머니</span><span> </span><span>등</span><span>)</span
        ><span>를</span><span> </span><span>현금</span><span>/</span
        ><span>현물</span><span> </span><span>등으로</span><span> </span
        ><span>거래하거나</span><span> </span><span>거래를</span
        ><span> </span><span>알선한</span><span> </span><span>행위</span>
      </p>
    </td>
    <td
      style="
        width: 10.42%;
        border-right-style: solid;
        border-right-width: 1.5pt;
        border-bottom-style: solid;
        border-bottom-width: 1.5pt;
        padding-top: 0.75pt;
        padding-left: 0.75pt;
        padding-bottom: 0.75pt;
        vertical-align: middle;
        -aw-padding-bottom: 0.75pt;
        -aw-padding-right: 0.75pt;
      "
    >
      <p
        style="
          margin-bottom: 0pt;
          text-align: center;
          widows: 2;
          orphans: 2;
        "
      >
        <span>1</span><span>일정지</span>
      </p>
    </td>
    <td
      style="
        width: 6.24%;
        border-right-style: solid;
        border-right-width: 1.5pt;
        border-bottom-style: solid;
        border-bottom-width: 1.5pt;
        padding-top: 0.75pt;
        padding-left: 0.75pt;
        padding-bottom: 0.75pt;
        vertical-align: middle;
        -aw-padding-bottom: 0.75pt;
        -aw-padding-right: 0.75pt;
      "
    >
      <p
        style="
          margin-bottom: 0pt;
          text-align: center;
          widows: 2;
          orphans: 2;
        "
      >
        <span>3</span><span>일정지</span>
      </p>
    </td>
    <td
      style="
        width: 5.9%;
        border-right-style: solid;
        border-right-width: 1.5pt;
        border-bottom-style: solid;
        border-bottom-width: 1.5pt;
        padding-top: 0.75pt;
        padding-left: 0.75pt;
        padding-bottom: 0.75pt;
        vertical-align: middle;
        -aw-padding-bottom: 0.75pt;
        -aw-padding-right: 0.75pt;
      "
    >
      <p
        style="
          margin-bottom: 0pt;
          text-align: center;
          widows: 2;
          orphans: 2;
        "
      >
        <span>5</span><span>일정지</span>
      </p>
    </td>
    <td
      style="
        width: 6.24%;
        border-right-style: solid;
        border-right-width: 1.5pt;
        border-bottom-style: solid;
        border-bottom-width: 1.5pt;
        padding-top: 0.75pt;
        padding-left: 0.75pt;
        padding-bottom: 0.75pt;
        vertical-align: middle;
        -aw-padding-bottom: 0.75pt;
        -aw-padding-right: 0.75pt;
      "
    >
      <p
        style="
          margin-bottom: 0pt;
          text-align: center;
          widows: 2;
          orphans: 2;
        "
      >
        <span>영구정지</span>
      </p>
    </td>
    <td
      style="
        width: 6.24%;
        border-bottom-style: solid;
        border-bottom-width: 1.5pt;
        padding-top: 0.75pt;
        padding-left: 0.75pt;
        padding-bottom: 0.75pt;
        vertical-align: middle;
        -aw-padding-bottom: 0.75pt;
        -aw-padding-right: 0.75pt;
      "
    >
      <p
        style="
          margin-right: 6pt;
          margin-left: 6pt;
          margin-bottom: 0pt;
          text-align: center;
          widows: 2;
          orphans: 2;
        "
      >
        <span>&#xa0;</span>
      </p>
    </td>
  </tr>
  <tr style="height: 163.5pt">
    <td
      style="
        width: 53.38%;
        border-right-style: solid;
        border-right-width: 1.5pt;
        border-bottom-style: solid;
        border-bottom-width: 1.5pt;
        padding-top: 0.75pt;
        padding-left: 0.75pt;
        padding-bottom: 0.75pt;
        vertical-align: middle;
        -aw-padding-bottom: 0.75pt;
        -aw-padding-right: 0.75pt;
      "
    >
      <p
        style="
          margin-bottom: 0pt;
          text-align: center;
          widows: 2;
          orphans: 2;
        "
      >
        <span>게임내</span><span> </span><span>컨텐츠</span><span>(</span
        ><span>아이템</span><span>/</span><span>게임머니</span
        ><span>)</span><span>를</span><span> </span><span>현금</span
        ><span>/</span><span>현물</span><span> </span><span>등으로</span
        ><span> </span><span>거래</span><span> </span><span>또는</span
        ><span> </span><span>시도하는</span><span> </span
        ><span>행위</span>
      </p>
    </td>
    <td
      style="
        width: 10.42%;
        border-right-style: solid;
        border-right-width: 1.5pt;
        border-bottom-style: solid;
        border-bottom-width: 1.5pt;
        padding-top: 0.75pt;
        padding-left: 0.75pt;
        padding-bottom: 0.75pt;
        vertical-align: middle;
        -aw-padding-bottom: 0.75pt;
        -aw-padding-right: 0.75pt;
      "
    >
      <p
        style="
          margin-bottom: 0pt;
          text-align: center;
          widows: 2;
          orphans: 2;
        "
      >
        <span>재화회수후</span><span>&#xa0;</span><span> </span
        ><span>7</span><span>일</span><span> </span><span>정지</span>
      </p>
    </td>
    <td
      style="
        width: 6.24%;
        border-right-style: solid;
        border-right-width: 1.5pt;
        border-bottom-style: solid;
        border-bottom-width: 1.5pt;
        padding-top: 0.75pt;
        padding-left: 0.75pt;
        padding-bottom: 0.75pt;
        vertical-align: middle;
        -aw-padding-bottom: 0.75pt;
        -aw-padding-right: 0.75pt;
      "
    >
      <p
        style="
          margin-bottom: 0pt;
          text-align: center;
          widows: 2;
          orphans: 2;
        "
      >
        <span>영구정지</span>
      </p>
    </td>
    <td
      style="
        width: 5.9%;
        border-right-style: solid;
        border-right-width: 1.5pt;
        border-bottom-style: solid;
        border-bottom-width: 1.5pt;
        padding-top: 0.75pt;
        padding-left: 0.75pt;
        padding-bottom: 0.75pt;
        vertical-align: middle;
        -aw-padding-bottom: 0.75pt;
        -aw-padding-right: 0.75pt;
      "
    >
      <p
        style="
          margin-bottom: 0pt;
          text-align: center;
          widows: 2;
          orphans: 2;
        "
      >
        <span>&#xa0;</span>
      </p>
    </td>
    <td
      style="
        width: 6.24%;
        border-right-style: solid;
        border-right-width: 1.5pt;
        border-bottom-style: solid;
        border-bottom-width: 1.5pt;
        padding-top: 0.75pt;
        padding-left: 0.75pt;
        padding-bottom: 0.75pt;
        vertical-align: middle;
        -aw-padding-bottom: 0.75pt;
        -aw-padding-right: 0.75pt;
      "
    >
      <p
        style="
          margin-bottom: 0pt;
          text-align: center;
          widows: 2;
          orphans: 2;
        "
      >
        <span>&#xa0;</span>
      </p>
    </td>
    <td
      style="
        width: 6.24%;
        border-bottom-style: solid;
        border-bottom-width: 1.5pt;
        padding-top: 0.75pt;
        padding-left: 0.75pt;
        padding-bottom: 0.75pt;
        vertical-align: middle;
        -aw-padding-bottom: 0.75pt;
        -aw-padding-right: 0.75pt;
      "
    >
      <p
        style="
          margin-right: 6pt;
          margin-left: 6pt;
          margin-bottom: 0pt;
          text-align: center;
          widows: 2;
          orphans: 2;
        "
      >
        <span>&#xa0;</span>
      </p>
    </td>
  </tr>
  <tr style="height: 177pt">
    <td
      rowspan="2"
      style="
        width: 11.56%;
        border-right-style: solid;
        border-right-width: 1.5pt;
        border-bottom-style: solid;
        border-bottom-width: 1.5pt;
        padding-top: 0.75pt;
        padding-bottom: 0.75pt;
        vertical-align: middle;
        -aw-padding-bottom: 0.75pt;
        -aw-padding-left: 0.75pt;
        -aw-padding-right: 0.75pt;
      "
    >
      <p
        style="
          margin-right: 6pt;
          margin-left: 6pt;
          margin-bottom: 0pt;
          text-align: center;
          widows: 2;
          orphans: 2;
        "
      >
        <span>불법프로그램</span>
      </p>
    </td>
    <td
      style="
        width: 53.38%;
        border-right-style: solid;
        border-right-width: 1.5pt;
        border-bottom-style: solid;
        border-bottom-width: 1.5pt;
        padding-top: 0.75pt;
        padding-left: 0.75pt;
        padding-bottom: 0.75pt;
        vertical-align: middle;
        -aw-padding-bottom: 0.75pt;
        -aw-padding-right: 0.75pt;
      "
    >
      <p
        style="
          margin-bottom: 0pt;
          text-align: center;
          widows: 2;
          orphans: 2;
        "
      >
        <span>스프드</span><span> </span><span>핵</span><span>, </span
        ><span>메모리</span><span> </span><span>핵</span><span>, </span
        ><span>멀티로더</span><span>, </span><span>매크로</span
        ><span> </span><span>프로그램</span><span>, </span
        ><span>해킹</span><span> </span><span>프로그램</span><span> </span
        ><span>등</span><span> </span><span>회사가</span><span> </span
        ><span>제공하거나</span><span> </span><span>승인하지</span
        ><span> </span><span>않은</span><span> </span><span>모든</span
        ><span> </span><span>소프트웨어나</span><span> </span
        ><span>장치</span><span>(</span><span>하드웨어</span><span>)</span
        ><span>등</span><span> </span><span>불법프로그램을</span
        ><span> </span><span>이용</span><span>/</span><span>제작</span
        ><span>/</span><span>유포</span><span> </span><span>하는</span
        ><span> </span><span>행위</span>
      </p>
    </td>
    <td
      style="
        width: 10.42%;
        border-right-style: solid;
        border-right-width: 1.5pt;
        border-bottom-style: solid;
        border-bottom-width: 1.5pt;
        padding-top: 0.75pt;
        padding-left: 0.75pt;
        padding-bottom: 0.75pt;
        vertical-align: middle;
        -aw-padding-bottom: 0.75pt;
        -aw-padding-right: 0.75pt;
      "
    >
      <p
        style="
          margin-bottom: 0pt;
          text-align: center;
          widows: 2;
          orphans: 2;
        "
      >
        <span>재화회수후</span><span>&#xa0;</span><span> </span
        ><span>7</span><span>일</span><span> </span><span>정지</span>
      </p>
    </td>
    <td
      colspan="4"
      style="
        border-bottom-style: solid;
        border-bottom-width: 1.5pt;
        padding-top: 0.75pt;
        padding-left: 0.75pt;
        padding-bottom: 0.75pt;
        vertical-align: middle;
        -aw-padding-bottom: 0.75pt;
        -aw-padding-right: 0.75pt;
      "
    >
      <p
        style="
          margin-right: 6pt;
          margin-left: 6pt;
          margin-bottom: 0pt;
          text-align: center;
          widows: 2;
          orphans: 2;
        "
      >
        <span>재화</span><span> </span><span>회수후</span><span> </span
        ><span>영구</span><span> </span><span>정지</span><span>(</span
        ><span>사안의</span><span> </span><span>경중에</span><span> </span
        ><span>따라</span><span> </span><span>사법기관</span><span> </span
        ><span>수사</span><span> </span><span>의뢰</span><span>)</span>
      </p>
    </td>
  </tr>
  <tr style="height: 193.5pt">
    <td
      style="
        width: 53.38%;
        border-right-style: solid;
        border-right-width: 1.5pt;
        border-bottom-style: solid;
        border-bottom-width: 1.5pt;
        padding-top: 0.75pt;
        padding-left: 0.75pt;
        padding-bottom: 0.75pt;
        vertical-align: middle;
        -aw-padding-bottom: 0.75pt;
        -aw-padding-right: 0.75pt;
      "
    >
      <p
        style="
          margin-bottom: 0pt;
          text-align: center;
          widows: 2;
          orphans: 2;
        "
      >
        <span>회사로부터</span><span> </span><span>특별한</span
        ><span> </span><span>권리를</span><span> </span><span>받지</span
        ><span> </span><span>않고</span><span> </span
        ><span>프로그램을</span><span> </span><span>제작하거나</span
        ><span>, </span><span>조작된</span><span> </span
        ><span>프로그램을</span><span> </span><span>이용하여</span
        ><span> </span><span>회사의</span><span> </span
        ><span>서비스를</span><span> </span><span>비정상적으로</span
        ><span> </span><span>사용하는</span><span> </span
        ><span>행위</span>
      </p>
    </td>
    <td
      style="
        width: 10.42%;
        border-right-style: solid;
        border-right-width: 1.5pt;
        border-bottom-style: solid;
        border-bottom-width: 1.5pt;
        padding-top: 0.75pt;
        padding-left: 0.75pt;
        padding-bottom: 0.75pt;
        vertical-align: middle;
        -aw-padding-bottom: 0.75pt;
        -aw-padding-right: 0.75pt;
      "
    >
      <p
        style="
          margin-bottom: 0pt;
          text-align: center;
          widows: 2;
          orphans: 2;
        "
      >
        <span>재화회수후</span><span>&#xa0;</span><span> </span
        ><span>7</span><span>일</span><span> </span><span>정지</span>
      </p>
    </td>
    <td
      colspan="4"
      style="
        border-bottom-style: solid;
        border-bottom-width: 1.5pt;
        padding-top: 0.75pt;
        padding-left: 0.75pt;
        padding-bottom: 0.75pt;
        vertical-align: middle;
        -aw-padding-bottom: 0.75pt;
        -aw-padding-right: 0.75pt;
      "
    >
      <p
        style="
          margin-right: 6pt;
          margin-left: 6pt;
          margin-bottom: 0pt;
          text-align: center;
          widows: 2;
          orphans: 2;
        "
      >
        <span>재화</span><span> </span><span>회수후</span><span> </span
        ><span>영구</span><span> </span><span>정지</span><span>(</span
        ><span>사안의</span><span> </span><span>경중에</span><span> </span
        ><span>따라</span><span> </span><span>사법기관</span><span> </span
        ><span>수사</span><span> </span><span>의뢰</span><span>)</span>
      </p>
    </td>
  </tr>
  <tr style="height: 40.5pt">
    <td
      style="
        width: 11.56%;
        border-right-style: solid;
        border-right-width: 1.5pt;
        border-bottom-style: solid;
        border-bottom-width: 1.5pt;
        padding-top: 0.75pt;
        padding-bottom: 0.75pt;
        vertical-align: middle;
        -aw-padding-bottom: 0.75pt;
        -aw-padding-left: 0.75pt;
        -aw-padding-right: 0.75pt;
      "
      class="td-title"
    >
      <p
        style="
          margin-bottom: 0pt;
          text-align: center;
          widows: 2;
          orphans: 2;
        "
      >
        <span style="font-weight: bold">유형</span>
      </p>
    </td>
    <td
      style="
        width: 53.38%;
        border-right-style: solid;
        border-right-width: 1.5pt;
        border-bottom-style: solid;
        border-bottom-width: 1.5pt;
        padding-top: 0.75pt;
        padding-left: 0.75pt;
        padding-bottom: 0.75pt;
        vertical-align: middle;
        -aw-padding-bottom: 0.75pt;
        -aw-padding-right: 0.75pt;
      "
      class="td-title"
    >
      <p
        style="
          margin-bottom: 0pt;
          text-align: center;
          widows: 2;
          orphans: 2;
        "
      >
        <span style="font-weight: bold">상세설명</span>
      </p>
    </td>
    <td
      style="
        width: 10.42%;
        border-right-style: solid;
        border-right-width: 1.5pt;
        border-bottom-style: solid;
        border-bottom-width: 1.5pt;
        padding-top: 0.75pt;
        padding-left: 0.75pt;
        padding-bottom: 0.75pt;
        vertical-align: middle;
        -aw-padding-bottom: 0.75pt;
        -aw-padding-right: 0.75pt;
      "
      class="td-title"
    >
      <p
        style="
          margin-bottom: 0pt;
          text-align: center;
          widows: 2;
          orphans: 2;
        "
      >
        <span style="font-weight: bold">1</span
        ><span style="font-weight: bold">차</span>
      </p>
    </td>
    <td
      style="
        width: 6.24%;
        border-right-style: solid;
        border-right-width: 1.5pt;
        border-bottom-style: solid;
        border-bottom-width: 1.5pt;
        padding-top: 0.75pt;
        padding-left: 0.75pt;
        padding-bottom: 0.75pt;
        vertical-align: middle;
        -aw-padding-bottom: 0.75pt;
        -aw-padding-right: 0.75pt;
      "
      class="td-title"
    >
      <p
        style="
          margin-bottom: 0pt;
          text-align: center;
          widows: 2;
          orphans: 2;
        "
      >
        <span style="font-weight: bold">2</span
        ><span style="font-weight: bold">차</span>
      </p>
    </td>
    <td
      style="
        width: 5.9%;
        border-right-style: solid;
        border-right-width: 1.5pt;
        border-bottom-style: solid;
        border-bottom-width: 1.5pt;
        padding-top: 0.75pt;
        padding-left: 0.75pt;
        padding-bottom: 0.75pt;
        vertical-align: middle;
        -aw-padding-bottom: 0.75pt;
        -aw-padding-right: 0.75pt;
      "
      class="td-title"
    >
      <p
        style="
          margin-bottom: 0pt;
          text-align: center;
          widows: 2;
          orphans: 2;
        "
      >
        <span style="font-weight: bold">3</span
        ><span style="font-weight: bold">차</span>
      </p>
    </td>
    <td
      style="
        width: 6.24%;
        border-right-style: solid;
        border-right-width: 1.5pt;
        border-bottom-style: solid;
        border-bottom-width: 1.5pt;
        padding-top: 0.75pt;
        padding-left: 0.75pt;
        padding-bottom: 0.75pt;
        vertical-align: middle;
        -aw-padding-bottom: 0.75pt;
        -aw-padding-right: 0.75pt;
      "
      class="td-title"
    >
      <p
        style="
          margin-bottom: 0pt;
          text-align: center;
          widows: 2;
          orphans: 2;
        "
      >
        <span style="font-weight: bold">4</span
        ><span style="font-weight: bold">차</span>
      </p>
    </td>
    <td
      style="
        width: 6.24%;
        border-bottom-style: solid;
        border-bottom-width: 1.5pt;
        padding-top: 0.75pt;
        padding-left: 0.75pt;
        padding-bottom: 0.75pt;
        vertical-align: middle;
        -aw-padding-bottom: 0.75pt;
        -aw-padding-right: 0.75pt;
      "
      class="td-title"
    >
      <p
        style="
          margin-bottom: 0pt;
          text-align: center;
          widows: 2;
          orphans: 2;
        "
      >
        <span style="font-weight: bold">5</span
        ><span style="font-weight: bold">차</span>
      </p>
    </td>
  </tr>
  <tr style="height: 131.25pt">
    <td
      rowspan="2"
      style="
        width: 11.56%;
        border-right-style: solid;
        border-right-width: 1.5pt;
        border-bottom-style: solid;
        border-bottom-width: 1.5pt;
        padding-top: 0.75pt;
        padding-bottom: 0.75pt;
        vertical-align: middle;
        -aw-padding-bottom: 0.75pt;
        -aw-padding-left: 0.75pt;
        -aw-padding-right: 0.75pt;
      "
    >
      <p
        style="
          margin-right: 6pt;
          margin-left: 6pt;
          margin-bottom: 0pt;
          text-align: center;
          widows: 2;
          orphans: 2;
        "
      >
        <span>계정도용</span>
      </p>
    </td>
    <td
      style="
        width: 53.38%;
        border-right-style: solid;
        border-right-width: 1.5pt;
        border-bottom-style: solid;
        border-bottom-width: 1.5pt;
        padding-top: 0.75pt;
        padding-left: 0.75pt;
        padding-bottom: 0.75pt;
        vertical-align: middle;
        -aw-padding-bottom: 0.75pt;
        -aw-padding-right: 0.75pt;
      "
    >
      <p
        style="
          margin-bottom: 0pt;
          text-align: center;
          widows: 2;
          orphans: 2;
        "
      >
        <span>다른</span><span> </span><span>회원의</span><span> </span
        ><span>계정에</span><span> </span><span>접속하여</span
        ><span> </span><span>피해를</span><span> </span><span>주는</span
        ><span> </span><span>행위</span>
      </p>
    </td>
    <td
      style="
        width: 10.42%;
        border-right-style: solid;
        border-right-width: 1.5pt;
        border-bottom-style: solid;
        border-bottom-width: 1.5pt;
        padding-top: 0.75pt;
        padding-left: 0.75pt;
        padding-bottom: 0.75pt;
        vertical-align: middle;
        -aw-padding-bottom: 0.75pt;
        -aw-padding-right: 0.75pt;
      "
    >
      <p
        style="
          margin-bottom: 0pt;
          text-align: center;
          widows: 2;
          orphans: 2;
        "
      >
        <span>재화회수후</span><span>&#xa0;</span><span> </span
        ><span>30</span><span>일</span><span> </span><span>정지</span>
      </p>
    </td>
    <td
      style="
        width: 6.24%;
        border-right-style: solid;
        border-right-width: 1.5pt;
        border-bottom-style: solid;
        border-bottom-width: 1.5pt;
        padding-top: 0.75pt;
        padding-left: 0.75pt;
        padding-bottom: 0.75pt;
        vertical-align: middle;
        -aw-padding-bottom: 0.75pt;
        -aw-padding-right: 0.75pt;
      "
    >
      <p
        style="
          margin-bottom: 0pt;
          text-align: center;
          widows: 2;
          orphans: 2;
        "
      >
        <span>영구정지</span>
      </p>
    </td>
    <td
      style="
        width: 5.9%;
        border-right-style: solid;
        border-right-width: 1.5pt;
        border-bottom-style: solid;
        border-bottom-width: 1.5pt;
        padding-top: 0.75pt;
        padding-left: 0.75pt;
        padding-bottom: 0.75pt;
        vertical-align: middle;
        -aw-padding-bottom: 0.75pt;
        -aw-padding-right: 0.75pt;
      "
    >
      <p
        style="
          margin-bottom: 0pt;
          text-align: center;
          widows: 2;
          orphans: 2;
        "
      >
        <span>&#xa0;</span>
      </p>
    </td>
    <td
      style="
        width: 6.24%;
        border-right-style: solid;
        border-right-width: 1.5pt;
        border-bottom-style: solid;
        border-bottom-width: 1.5pt;
        padding-top: 0.75pt;
        padding-left: 0.75pt;
        padding-bottom: 0.75pt;
        vertical-align: middle;
        -aw-padding-bottom: 0.75pt;
        -aw-padding-right: 0.75pt;
      "
    >
      <p
        style="
          margin-right: 6pt;
          margin-left: 6pt;
          margin-bottom: 0pt;
          text-align: center;
          widows: 2;
          orphans: 2;
        "
      >
        <span>&#xa0;</span>
      </p>
    </td>
    <td
      style="
        width: 6.24%;
        border-bottom-style: solid;
        border-bottom-width: 1.5pt;
        padding-top: 0.75pt;
        padding-left: 0.75pt;
        padding-bottom: 0.75pt;
        vertical-align: middle;
        -aw-padding-bottom: 0.75pt;
        -aw-padding-right: 0.75pt;
      "
    >
      <p
        style="
          margin-right: 6pt;
          margin-left: 6pt;
          margin-bottom: 0pt;
          text-align: center;
          widows: 2;
          orphans: 2;
        "
      >
        <span>&#xa0;</span>
      </p>
    </td>
  </tr>
  <tr style="height: 131.25pt">
    <td
      style="
        width: 53.38%;
        border-right-style: solid;
        border-right-width: 1.5pt;
        border-bottom-style: solid;
        border-bottom-width: 1.5pt;
        padding-top: 0.75pt;
        padding-left: 0.75pt;
        padding-bottom: 0.75pt;
        vertical-align: middle;
        -aw-padding-bottom: 0.75pt;
        -aw-padding-right: 0.75pt;
      "
    >
      <p
        style="
          margin-bottom: 0pt;
          text-align: center;
          widows: 2;
          orphans: 2;
        "
      >
        <span>제</span><span>3</span><span>자의</span><span> </span
        ><span>신용카드</span><span>, </span><span>휴대폰</span
        ><span>, ARS </span><span>등</span><span> </span
        ><span>결제수단을</span><span> </span><span>무단으로</span
        ><span> </span><span>도용하여</span><span> </span
        ><span>아이템</span><span> </span><span>구매등</span><span> </span
        ><span>게임서비스를</span><span> </span><span>이용한</span
        ><span> </span><span>경우</span>
      </p>
    </td>
    <td
      style="
        width: 10.42%;
        border-right-style: solid;
        border-right-width: 1.5pt;
        border-bottom-style: solid;
        border-bottom-width: 1.5pt;
        padding-top: 0.75pt;
        padding-left: 0.75pt;
        padding-bottom: 0.75pt;
        vertical-align: middle;
        -aw-padding-bottom: 0.75pt;
        -aw-padding-right: 0.75pt;
      "
    >
      <p
        style="
          margin-bottom: 0pt;
          text-align: center;
          widows: 2;
          orphans: 2;
        "
      >
        <span>재화회수후</span><span>&#xa0;</span><span>&#xa0;</span
        ><span> </span><span>영구정지</span>
      </p>
    </td>
    <td
      style="
        width: 6.24%;
        border-right-style: solid;
        border-right-width: 1.5pt;
        border-bottom-style: solid;
        border-bottom-width: 1.5pt;
        padding-top: 0.75pt;
        padding-left: 0.75pt;
        padding-bottom: 0.75pt;
        vertical-align: middle;
        -aw-padding-bottom: 0.75pt;
        -aw-padding-right: 0.75pt;
      "
    >
      <p
        style="
          margin-bottom: 0pt;
          text-align: center;
          widows: 2;
          orphans: 2;
        "
      >
        <span>&#xa0;</span>
      </p>
    </td>
    <td
      style="
        width: 5.9%;
        border-right-style: solid;
        border-right-width: 1.5pt;
        border-bottom-style: solid;
        border-bottom-width: 1.5pt;
        padding-top: 0.75pt;
        padding-left: 0.75pt;
        padding-bottom: 0.75pt;
        vertical-align: middle;
        -aw-padding-bottom: 0.75pt;
        -aw-padding-right: 0.75pt;
      "
    >
      <p
        style="
          margin-bottom: 0pt;
          text-align: center;
          widows: 2;
          orphans: 2;
        "
      >
        <span>&#xa0;</span>
      </p>
    </td>
    <td
      style="
        width: 6.24%;
        border-right-style: solid;
        border-right-width: 1.5pt;
        border-bottom-style: solid;
        border-bottom-width: 1.5pt;
        padding-top: 0.75pt;
        padding-left: 0.75pt;
        padding-bottom: 0.75pt;
        vertical-align: middle;
        -aw-padding-bottom: 0.75pt;
        -aw-padding-right: 0.75pt;
      "
    >
      <p
        style="
          margin-right: 6pt;
          margin-left: 6pt;
          margin-bottom: 0pt;
          text-align: center;
          widows: 2;
          orphans: 2;
        "
      >
        <span>&#xa0;</span>
      </p>
    </td>
    <td
      style="
        width: 6.24%;
        border-bottom-style: solid;
        border-bottom-width: 1.5pt;
        padding-top: 0.75pt;
        padding-left: 0.75pt;
        padding-bottom: 0.75pt;
        vertical-align: middle;
        -aw-padding-bottom: 0.75pt;
        -aw-padding-right: 0.75pt;
      "
    >
      <p
        style="
          margin-right: 6pt;
          margin-left: 6pt;
          margin-bottom: 0pt;
          text-align: center;
          widows: 2;
          orphans: 2;
        "
      >
        <span>&#xa0;</span>
      </p>
    </td>
  </tr>
  <tr style="height: 169.5pt">
    <td
      rowspan="2"
      style="
        width: 11.56%;
        border-right-style: solid;
        border-right-width: 1.5pt;
        border-bottom-style: solid;
        border-bottom-width: 1.5pt;
        padding-top: 0.75pt;
        padding-bottom: 0.75pt;
        vertical-align: middle;
        -aw-padding-bottom: 0.75pt;
        -aw-padding-left: 0.75pt;
        -aw-padding-right: 0.75pt;
      "
    >
      <p
        style="
          margin-right: 6pt;
          margin-left: 6pt;
          margin-bottom: 0pt;
          text-align: center;
          widows: 2;
          orphans: 2;
        "
      >
        <span>게임운영방해</span>
      </p>
    </td>
    <td
      style="
        width: 53.38%;
        border-right-style: solid;
        border-right-width: 1.5pt;
        border-bottom-style: solid;
        border-bottom-width: 1.5pt;
        padding-top: 0.75pt;
        padding-left: 0.75pt;
        padding-bottom: 0.75pt;
        vertical-align: middle;
        -aw-padding-bottom: 0.75pt;
        -aw-padding-right: 0.75pt;
      "
    >
      <p
        style="
          margin-bottom: 0pt;
          text-align: center;
          widows: 2;
          orphans: 2;
        "
      >
        <span>게임내</span><span> </span><span>사행성을</span
        ><span> </span><span>조장하는</span><span> </span
        ><span>불건전한</span><span> </span><span>도박진행</span
        ><span> </span><span>및</span><span> </span><span>사행성</span
        ><span> </span><span>행위</span><span> </span><span>조장</span
        ><span> </span><span>및</span><span> </span><span>관련</span
        ><span> </span><span>광고</span><span> </span><span>등을</span
        ><span> </span><span>유포하는</span><span> </span><span>행위</span
        ><span> </span><span>또한</span><span>, </span
        ><span>우연성에</span><span> </span><span>따른</span><span> </span
        ><span>득실을</span><span> </span><span>통해서</span><span> </span
        ><span>다른</span><span> </span><span>유저로부터</span
        ><span> </span><span>이득을</span><span> </span><span>취하는</span
        ><span> </span><span>행위</span>
      </p>
    </td>
    <td
      style="
        width: 10.42%;
        border-right-style: solid;
        border-right-width: 1.5pt;
        border-bottom-style: solid;
        border-bottom-width: 1.5pt;
        padding-top: 0.75pt;
        padding-left: 0.75pt;
        padding-bottom: 0.75pt;
        vertical-align: middle;
        -aw-padding-bottom: 0.75pt;
        -aw-padding-right: 0.75pt;
      "
    >
      <p
        style="
          margin-bottom: 0pt;
          text-align: center;
          widows: 2;
          orphans: 2;
        "
      >
        <span>재화회수후</span><span>&#xa0;</span><span> </span
        ><span>30</span><span>일</span><span> </span><span>정지</span>
      </p>
    </td>
    <td
      style="
        width: 6.24%;
        border-right-style: solid;
        border-right-width: 1.5pt;
        border-bottom-style: solid;
        border-bottom-width: 1.5pt;
        padding-top: 0.75pt;
        padding-left: 0.75pt;
        padding-bottom: 0.75pt;
        vertical-align: middle;
        -aw-padding-bottom: 0.75pt;
        -aw-padding-right: 0.75pt;
      "
    >
      <p
        style="
          margin-bottom: 0pt;
          text-align: center;
          widows: 2;
          orphans: 2;
        "
      >
        <span>영구정지</span>
      </p>
    </td>
    <td
      style="
        width: 5.9%;
        border-right-style: solid;
        border-right-width: 1.5pt;
        border-bottom-style: solid;
        border-bottom-width: 1.5pt;
        padding-top: 0.75pt;
        padding-left: 0.75pt;
        padding-bottom: 0.75pt;
        vertical-align: middle;
        -aw-padding-bottom: 0.75pt;
        -aw-padding-right: 0.75pt;
      "
    >
      <p
        style="
          margin-bottom: 0pt;
          text-align: center;
          widows: 2;
          orphans: 2;
        "
      >
        <span>&#xa0;</span>
      </p>
    </td>
    <td
      style="
        width: 6.24%;
        border-right-style: solid;
        border-right-width: 1.5pt;
        border-bottom-style: solid;
        border-bottom-width: 1.5pt;
        padding-top: 0.75pt;
        padding-left: 0.75pt;
        padding-bottom: 0.75pt;
        vertical-align: middle;
        -aw-padding-bottom: 0.75pt;
        -aw-padding-right: 0.75pt;
      "
    >
      <p
        style="
          margin-right: 6pt;
          margin-left: 6pt;
          margin-bottom: 0pt;
          text-align: center;
          widows: 2;
          orphans: 2;
        "
      >
        <span>&#xa0;</span>
      </p>
    </td>
    <td
      style="
        width: 6.24%;
        border-bottom-style: solid;
        border-bottom-width: 1.5pt;
        padding-top: 0.75pt;
        padding-left: 0.75pt;
        padding-bottom: 0.75pt;
        vertical-align: middle;
        -aw-padding-bottom: 0.75pt;
        -aw-padding-right: 0.75pt;
      "
    >
      <p
        style="
          margin-right: 6pt;
          margin-left: 6pt;
          margin-bottom: 0pt;
          text-align: center;
          widows: 2;
          orphans: 2;
        "
      >
        <span>&#xa0;</span>
      </p>
    </td>
  </tr>
  <tr style="height: 172.5pt">
    <td
      style="
        width: 53.38%;
        border-right-style: solid;
        border-right-width: 1.5pt;
        padding-top: 0.75pt;
        padding-left: 0.75pt;
        padding-bottom: 0.75pt;
        vertical-align: middle;
        -aw-padding-bottom: 0.75pt;
        -aw-padding-right: 0.75pt;
      "
    >
      <p
        style="
          margin-bottom: 0pt;
          text-align: center;
          widows: 2;
          orphans: 2;
        "
      >
        <span>허위사실을</span><span> </span><span>유포하거나</span
        ><span> </span><span>공지되지</span><span> </span><span>않은</span
        ><span> </span><span>비밀정보를</span><span> </span
        ><span>유포하여</span><span> </span><span>부당한</span
        ><span> </span><span>이득을</span><span> </span><span>얻거나</span
        ><span> </span><span>타인에게</span><span> </span><span>혼란</span
        ><span> </span><span>및</span><span> </span><span>피해를</span
        ><span> </span><span>야기</span><span>&#xa0;</span><span> </span
        ><span>시키는</span><span> </span><span>행위</span>
      </p>
    </td>
    <td
      style="
        width: 10.42%;
        border-right-style: solid;
        border-right-width: 1.5pt;
        padding-top: 0.75pt;
        padding-left: 0.75pt;
        padding-bottom: 0.75pt;
        vertical-align: middle;
        -aw-padding-bottom: 0.75pt;
        -aw-padding-right: 0.75pt;
      "
    >
      <p
        style="
          margin-right: 6pt;
          margin-left: 6pt;
          margin-bottom: 0pt;
          text-align: center;
          widows: 2;
          orphans: 2;
        "
      >
        <span>경고</span>
      </p>
    </td>
    <td
      style="
        width: 6.24%;
        border-right-style: solid;
        border-right-width: 1.5pt;
        padding-top: 0.75pt;
        padding-left: 0.75pt;
        padding-bottom: 0.75pt;
        vertical-align: middle;
        -aw-padding-bottom: 0.75pt;
        -aw-padding-right: 0.75pt;
      "
    >
      <p
        style="
          margin-bottom: 0pt;
          text-align: center;
          widows: 2;
          orphans: 2;
        "
      >
        <span>1</span><span>일정지</span>
      </p>
    </td>
    <td
      style="
        width: 5.9%;
        border-right-style: solid;
        border-right-width: 1.5pt;
        padding-top: 0.75pt;
        padding-left: 0.75pt;
        padding-bottom: 0.75pt;
        vertical-align: middle;
        -aw-padding-bottom: 0.75pt;
        -aw-padding-right: 0.75pt;
      "
    >
      <p
        style="
          margin-bottom: 0pt;
          text-align: center;
          widows: 2;
          orphans: 2;
        "
      >
        <span>3</span><span>일정지</span>
      </p>
    </td>
    <td
      style="
        width: 6.24%;
        border-right-style: solid;
        border-right-width: 1.5pt;
        padding-top: 0.75pt;
        padding-left: 0.75pt;
        padding-bottom: 0.75pt;
        vertical-align: middle;
        -aw-padding-bottom: 0.75pt;
        -aw-padding-right: 0.75pt;
      "
    >
      <p
        style="
          margin-bottom: 0pt;
          text-align: center;
          widows: 2;
          orphans: 2;
        "
      >
        <span>5</span><span>일정지</span>
      </p>
    </td>
    <td
      style="
        width: 6.24%;
        padding-top: 0.75pt;
        padding-left: 0.75pt;
        padding-bottom: 0.75pt;
        vertical-align: middle;
        -aw-padding-bottom: 0.75pt;
        -aw-padding-right: 0.75pt;
      "
    >
      <p
        style="
          margin-bottom: 0pt;
          text-align: center;
          widows: 2;
          orphans: 2;
        "
      >
        <span>영구정지</span>
      </p>
    </td>
  </tr>
</table>
<p
  style="
    margin-top: 14pt;
    margin-bottom: 14pt;
    line-height: normal;
    widows: 2;
    orphans: 2;
  "
>
  <span>&#xa0;</span>
</p>
<p
  style="
    margin-top: 14pt;
    margin-bottom: 14pt;
    line-height: normal;
    widows: 2;
    orphans: 2;
  "
>
  <span>운영진</span><span> </span><span>판단</span><span> </span
  ><span>하에</span><span> </span><span>이용</span><span> </span
  ><span>제한</span><span> </span><span>기간과</span><span> </span
  ><span>방법이</span><span> </span><span>변경될</span><span> </span
  ><span>수</span><span> </span><span>있습니다</span><span>.</span>
</p>
<p
  style="
    margin-top: 14pt;
    margin-bottom: 14pt;
    line-height: normal;
    widows: 2;
    orphans: 2;
  "
>
  <span>&#xa0;</span>
</p>
<p
  style="
    margin-top: 14pt;
    margin-bottom: 14pt;
    line-height: normal;
    widows: 2;
    orphans: 2;
  "
>
  <span>사례가</span><span> </span><span>중복되는</span><span> </span
  ><span>경우</span><span> </span><span>가중하여</span><span> </span
  ><span>이용이</span><span> </span><span>제한될</span><span> </span
  ><span>수</span><span> </span><span>있습니다</span><span>.</span>
</p>
<p
  style="
    margin-top: 14pt;
    margin-bottom: 14pt;
    line-height: normal;
    widows: 2;
    orphans: 2;
  "
>
  <span>위의</span><span> </span><span>항목에</span><span> </span
  ><span>해당되지</span><span> </span><span>않는</span><span> </span
  ><span>사항이라</span><span> </span><span>하더라도</span><span> </span
  ><span>운영진의</span><span> </span><span>객관적인</span><span> </span
  ><span>판단하에</span><span> </span><span>이용이</span><span> </span
  ><span>제한</span><span> </span><span>될</span><span> </span
  ><span>수</span><span> </span><span>있습니다</span><span>.</span>
</p>
<p
  style="
    margin-top: 14pt;
    margin-bottom: 14pt;
    line-height: normal;
    widows: 2;
    orphans: 2;
  "
>
  <span>11.</span><span>&#xa0;</span><span>커뮤니티</span><span> </span
  ><span>운영</span><span> </span><span>기준</span>
</p>
<p
  style="
    margin-top: 14pt;
    margin-bottom: 14pt;
    line-height: normal;
    widows: 2;
    orphans: 2;
  "
>
  <span>1)</span><span>회사는</span><span> </span><span>서비스와</span
  ><span> </span><span>관련된</span><span> </span><span>커뮤니티를</span
  ><span> </span><span>운영할수</span><span> </span><span>있고</span
  ><span>, </span><span>커뮤니티</span><span> </span><span>서비스는</span
  ><span> </span><span>회원</span><span> </span><span>여러분</span
  ><span> </span><span>누구나</span><span> </span><span>이용하실</span
  ><span> </span><span>수</span><span> </span><span>있습니다</span
  ><span>.</span>
</p>
<p
  style="
    margin-top: 14pt;
    margin-bottom: 14pt;
    line-height: normal;
    widows: 2;
    orphans: 2;
  "
>
  <span>2)</span><span>본</span><span> </span><span>커뮤니티</span
  ><span> </span><span>운영</span><span> </span><span>기준은</span
  ><span> </span><span>회사가</span><span> </span
  ><span>제공하는커뮤니티의</span><span> </span><span>원활한</span
  ><span> </span><span>이용</span><span> </span><span>및</span
  ><span> </span><span>건전한</span><span> </span><span>온라인</span
  ><span> </span><span>커뮤니티</span><span> </span><span>문화를</span
  ><span> </span><span>위하여</span><span> </span><span>제공되는</span
  ><span> </span><span>회사의</span><span> </span><span>규정입니다</span
  ><span>.</span>
</p>
<p
  style="
    margin-top: 14pt;
    margin-bottom: 14pt;
    line-height: normal;
    widows: 2;
    orphans: 2;
  "
>
  <span>3)</span><span>회원</span><span> </span><span>여러분이</span
  ><span> </span><span>커뮤니티</span><span> </span><span>내</span
  ><span> </span><span>다음과</span><span> </span><span>같은</span
  ><span>&#xa0;</span><span>불건전하고</span><span> </span
  ><span>매너에</span><span> </span><span>어긋나는</span><span> </span
  ><span>유형의</span><span> </span><span>글</span><span> </span
  ><span>또는</span><span> </span><span>댓글을</span><span> </span
  ><span>게재할</span><span> </span><span>경우</span><span> </span
  ><span>사전</span><span> </span><span>안내</span><span> </span
  ><span>없이</span><span> </span><span>게시물이</span><span> </span
  ><span>삭제될</span><span> </span><span>수</span><span> </span
  ><span>있으며</span><span>, </span><span>작성하신</span
  ><span>&#xa0;</span><span>회원</span><span> </span><span>여러분에</span
  ><span> </span><span>대하여</span><span> </span><span>서비스</span
  ><span> </span><span>이용제한</span><span> </span><span>조치를</span
  ><span> </span><span>취할</span><span> </span><span>수</span
  ><span> </span><span>있습니다</span><span>.</span>
</p>
<p
  style="
    margin-top: 14pt;
    margin-bottom: 14pt;
    line-height: normal;
    widows: 2;
    orphans: 2;
  "
>
  <span>①</span><span> </span><span>사회</span><span> </span
  ><span>질서나</span><span> </span><span>기타</span><span> </span
  ><span>미풍양속에</span><span> </span><span>위배되는</span><span> </span
  ><span>내용</span><span> </span><span>②</span><span> </span
  ><span>회사의</span><span> </span><span>영업을</span><span> </span
  ><span>방해하거나</span><span> </span><span>음해하는</span><span> </span
  ><span>내용</span><span> </span><span>③</span><span> </span
  ><span>특정</span><span> </span><span>또는</span><span> </span
  ><span>불특정</span><span> </span><span>대상을</span><span> </span
  ><span>비하하거나</span><span> </span><span>비방하는</span><span> </span
  ><span>내용</span><span> </span><span>④</span><span> </span
  ><span>불법프로그램의</span><span> </span><span>제작</span
  ><span>, </span><span>공유</span><span>, </span><span>배포와</span
  ><span> </span><span>관련된내용</span><span> </span><span>⑤</span
  ><span> </span><span>계정이나</span><span> </span><span>아이템</span
  ><span> </span><span>매매</span><span>, </span><span>교환</span
  ><span> </span><span>등과</span><span> </span><span>관련된</span
  ><span> </span><span>내용</span><span> </span><span>⑥</span
  ><span> </span><span>상업적</span><span> </span><span>광고성</span
  ><span> </span><span>내용</span><span> </span><span>⑦</span
  ><span> </span><span>회사의</span><span> </span><span>임직원을</span
  ><span> </span><span>사칭하거나</span><span>, </span
  ><span>사칭하려는</span><span> </span><span>의도를</span><span> </span
  ><span>담은</span><span> </span><span>내용</span><span> </span
  ><span>⑧</span><span> </span><span>타인의</span><span> </span
  ><span>개인정보를</span><span> </span><span>침해하거나</span
  ><span> </span><span>명예훼손</span><span> </span><span>및</span
  ><span> </span><span>모욕하는</span><span> </span><span>내용</span
  ><span> </span><span>⑨</span><span> </span><span>현금</span
  ><span> </span><span>및</span><span> </span><span>현물을</span
  ><span> </span><span>이용한</span><span> </span><span>거래와</span
  ><span> </span><span>관련된</span><span> </span><span>내용</span
  ><span> </span><span>⑩</span><span> </span><span>같은</span
  ><span> </span><span>내용을</span><span> </span><span>반복적</span
  ><span>(</span><span>도배성</span><span>)</span><span>으로</span
  ><span> </span><span>게시하는내용</span><span> </span><span>⑪</span
  ><span> </span><span>반사회적이거나</span><span> </span
  ><span>관계법령에</span><span> </span><span>저촉되는</span><span> </span
  ><span>내용</span><span> </span><span>⑫</span><span> </span
  ><span>기타</span><span> </span><span>각</span><span> </span
  ><span>게시판의</span><span> </span><span>용도와</span><span> </span
  ><span>무관하다고</span><span> </span><span>판단되는</span><span> </span
  ><span>내용</span><span> </span><span>⑬</span><span> </span
  ><span>저작권법에</span><span> </span><span>의거하여</span><span> </span
  ><span>저작권</span><span> </span><span>침해</span><span> </span
  ><span>소지가</span><span> </span><span>있다고</span><span> </span
  ><span>판단되는</span><span> </span><span>내용의</span><span> </span
  ><span>게시물</span><span> </span><span>및</span><span> </span
  ><span>파일</span>
</p>
<p
  style="
    margin-top: 14pt;
    margin-bottom: 14pt;
    line-height: normal;
    widows: 2;
    orphans: 2;
  "
>
  <span>4)</span><span>회사는</span><span> </span><span>각</span
  ><span> </span><span>커뮤니티</span><span> </span><span>게시판의</span
  ><span> </span><span>성격에</span><span> </span><span>맞지않는</span
  ><span> </span><span>글이나</span><span> </span><span>댓글은</span
  ><span> </span><span>다른</span><span> </span><span>게시판으로</span
  ><span> </span><span>이동시키거나</span><span> </span><span>삭제할</span
  ><span> </span><span>수</span><span> </span><span>있습니다</span
  ><span>.</span>
</p>
<p
  style="
    margin-top: 14pt;
    margin-bottom: 14pt;
    line-height: normal;
    widows: 2;
    orphans: 2;
  "
>
  <span>5)"</span><span>서비스</span><span>"</span><span>관련</span
  ><span> </span><span>커뮤니티</span><span> </span><span>내에</span
  ><span> </span><span>등록된</span><span> </span><span>게시물은</span
  ><span> </span><span>등록한</span><span> </span><span>회원</span
  ><span> </span><span>여러분께</span><span> </span><span>책임이</span
  ><span> </span><span>있습니다</span><span>.</span>
</p>
<p
  style="
    margin-top: 14pt;
    margin-bottom: 14pt;
    line-height: normal;
    widows: 2;
    orphans: 2;
  "
>
  <span>6)"</span><span>서비스</span><span>"</span><span>관련</span
  ><span> </span><span>커뮤니티는</span><span> </span><span>각</span
  ><span> </span><span>게시판에</span><span> </span><span>올린</span
  ><span> </span><span>회원</span><span> </span><span>여러분의</span
  ><span> </span><span>글을</span><span> </span><span>소중하게</span
  ><span> </span><span>관리하고</span><span> </span><span>유지하는데</span
  ><span> </span><span>최선을</span><span> </span><span>다합니다</span
  ><span>.</span><span>단</span><span>, </span><span>불의의</span
  ><span> </span><span>사고나</span><span> </span><span>자연재해</span
  ><span>, </span><span>기타</span><span> </span
  ><span>기술적인문제로</span><span> </span><span>발생하는</span
  ><span> </span><span>게시판</span><span> </span><span>데이터</span
  ><span> </span><span>손실에</span><span> </span><span>대하여</span
  ><span> </span><span>"</span><span>회사</span><span>"</span
  ><span>가책임을</span><span> </span><span>지지</span><span> </span
  ><span>않습니다</span><span>.</span>
</p>
<p
  style="
    margin-top: 14pt;
    margin-bottom: 14pt;
    line-height: normal;
    widows: 2;
    orphans: 2;
  "
>
  <span>7)"</span><span>서비스</span><span>"</span><span>관련</span
  ><span> </span><span>커뮤니티</span><span> </span><span>내에서</span
  ><span> </span><span>타인의</span><span> </span><span>명예를</span
  ><span> </span><span>훼손하거나</span><span> </span><span>이로</span
  ><span> </span><span>이한</span><span> </span><span>발생한</span
  ><span> </span><span>문제에</span><span> </span><span>대해서</span
  ><span> </span><span>이용자간의</span><span> </span><span>해결을</span
  ><span> </span><span>원칙으로</span><span> </span><span>하며</span
  ><span>, "</span><span>회사</span><span>"</span><span>는</span
  ><span> </span><span>책임을</span><span> </span><span>지지</span
  ><span> </span><span>않습니다</span><span>.</span>
</p>
<p
  style="
    margin-top: 14pt;
    margin-bottom: 14pt;
    line-height: normal;
    widows: 2;
    orphans: 2;
  "
>
  <span>12.</span><span>부칙</span>
</p>
<p
  style="
    margin-top: 14pt;
    margin-bottom: 14pt;
    line-height: normal;
    widows: 2;
    orphans: 2;
  "
>
  <span>본</span><span> </span><span>운영</span><span> </span
  ><span>정책은</span><span> </span><span>2020</span><span>년</span
  ><span> </span><span>5</span><span>월</span><span> </span><span>14</span
  ><span>일부로적용</span><span> </span><span>됩니다</span><span>.</span>
</p>
<p
  style="
    margin-top: 14pt;
    margin-bottom: 14pt;
    text-align: justify;
    line-height: normal;
    widows: 2;
    orphans: 2;
  "
>
  <span>&#xa0;</span>
</p>
<p><span style="-aw-import: ignore">&#xa0;</span></p>
</div>`;

export const threeSeventTermDetailHtml = `
  <div>
        <p style="margin-bottom:14pt; text-align:center; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:微软雅黑">이용약관</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:center; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:微软雅黑">제</span><span style="font-family:'Times New Roman'">1</span><span
                style="font-family:宋体">장 총칙</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">&#xa0;</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:微软雅黑">제</span><span style="font-family:'Times New Roman'">1</span><span
                style="font-family:宋体">조 약관의 목적</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">&#xa0;</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:微软雅黑">이</span><span style="font-family:'Times New Roman'">&#xa0;</span><span
                style="font-family:微软雅黑">약관은</span><span style="font-family:'Times New Roman'">&#xa0;</span><span
                style="font-family:'Times New Roman'">37 GAMES (</span><span style="font-family:宋体">이하 </span><span
                style="font-family:'Times New Roman'">“</span><span style="font-family:宋体">회사</span><span
                style="font-family:'Times New Roman'">”)</span><span style="font-family:宋体">가 온라인으로 제공하는 게임상품 및 이에 부수된
                제반 서비스</span><span style="font-family:'Times New Roman'">(</span><span style="font-family:宋体">이하
            </span><span style="font-family:'Times New Roman'">“</span><span style="font-family:宋体">게임콘텐츠</span><span
                style="font-family:'Times New Roman'">”)</span><span style="font-family:宋体">의 이용과 관련하여 이용자의 이용을 허용하는 계약상
                법적 근거를 제공하고</span><span style="font-family:'Times New Roman'">, </span><span style="font-family:宋体">본
                약관을 토대로 게임콘텐츠를 이용함에 있어 회사와 이용자 간의 권리</span><span style="font-family:'Times New Roman'">, </span><span
                style="font-family:宋体">의무 등 사항을 규정함을 목적으로 합니다</span><span style="font-family:'Times New Roman'">.</span>
        </p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">&#xa0;</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">&#xa0;</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:微软雅黑">제</span><span style="font-family:'Times New Roman'">2</span><span
                style="font-family:宋体">조 용어의 정의</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">&#xa0;</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">1. ‘</span><span style="font-family:宋体">회사</span><span
                style="font-family:'Times New Roman'">’</span><span style="font-family:宋体">라 함은 디바이스 및 온라인을 통하여 게임콘텐츠를
                제공하는 사업자를 말합니다</span><span style="font-family:'Times New Roman'">.</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">&#xa0;</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">2. ‘</span><span style="font-family:宋体">디바이스</span><span
                style="font-family:'Times New Roman'">’</span><span style="font-family:宋体">라 함은 콘텐츠를 다운로드 받거나 설치하여 사용할 수
                있는 </span><span style="font-family:'Times New Roman'">PC, </span><span
                style="font-family:宋体">휴대전화</span><span style="font-family:'Times New Roman'">, </span><span
                style="font-family:宋体">스마트폰</span><span style="font-family:'Times New Roman'">, PDA, </span><span
                style="font-family:宋体">태블릿</span><span style="font-family:'Times New Roman'">, </span><span
                style="font-family:宋体">휴대용 게임기</span><span style="font-family:'Times New Roman'">, </span><span
                style="font-family:宋体">콘솔 게임기 등의 기기를 말합니다</span><span style="font-family:'Times New Roman'">.</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">&#xa0;</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">3. ‘</span><span style="font-family:宋体">이용자</span><span
                style="font-family:'Times New Roman'">’</span><span style="font-family:宋体">라 함은 본 약관에 동의하고 게임콘텐츠의 이용 자격을
                부여받은 자연인</span><span style="font-family:'Times New Roman'">(</span><span
                style="font-family:宋体">회원</span><span style="font-family:'Times New Roman'">, </span><span
                style="font-family:宋体">임시회원</span><span style="font-family:'Times New Roman'">, </span><span
                style="font-family:宋体">비회원이 포함되며</span><span style="font-family:'Times New Roman'">, ‘</span><span
                style="font-family:宋体">임시회원</span><span style="font-family:'Times New Roman'">’</span><span
                style="font-family:宋体">이라 함은 회원인증을 하지 않고 게스트로그인 모드로 이용하는 이용자를 의미함</span><span
                style="font-family:'Times New Roman'">)</span><span style="font-family:宋体">을 말합니다</span><span
                style="font-family:'Times New Roman'">.</span><span style="font-family:'Times New Roman'">&#xa0;</span>
        </p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">&#xa0;</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">4. ‘</span><span style="font-family:宋体">게임콘텐츠</span><span
                style="font-family:'Times New Roman'">’</span><span style="font-family:宋体">라 함은 회사가 제공하는 모든 게임 및 네트워크
                서비스</span><span style="font-family:'Times New Roman'">, </span><span
                style="font-family:宋体">애플리케이션</span><span style="font-family:'Times New Roman'">, </span><span
                style="font-family:宋体">게임머니 및 게임 아이템 등 서비스와 관련되어 디지털 방식으로 제작된 내용물 일체뿐만 아니라</span><span
                style="font-family:'Times New Roman'">, </span><span style="font-family:宋体">인터넷에 연결하여 순위등록</span><span
                style="font-family:'Times New Roman'">, </span><span style="font-family:宋体">게시물 작성</span><span
                style="font-family:'Times New Roman'">, </span><span style="font-family:宋体">게임머니 또는 게임 아이템 등의
                구매</span><span style="font-family:'Times New Roman'">, </span><span style="font-family:宋体">네트워크 게임 이용을 할
                수 있도록 회사가 제공하는 게임 및 이에 부수된 부가서비스 일체를 말합니다</span><span style="font-family:'Times New Roman'">.</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">&#xa0;</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">5. ‘</span><span style="font-family:宋体">게임세계</span><span
                style="font-family:'Times New Roman'">’</span><span style="font-family:宋体">라 함은 게임콘텐츠를 통해 회사가 제정한
                게임규칙</span><span style="font-family:'Times New Roman'">(</span><span style="font-family:宋体">이하
            </span><span style="font-family:'Times New Roman'">“</span><span style="font-family:宋体">게임규칙</span><span
                style="font-family:'Times New Roman'">”)</span><span style="font-family:宋体">에 따라 오락을 하거나 오락게임 등 활동을 구현한
                각종 가상환경을 말합니다</span><span style="font-family:'Times New Roman'">.</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">&#xa0;</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">6. ‘</span><span style="font-family:宋体">계정</span><span
                style="font-family:'Times New Roman'">(ID)’</span><span style="font-family:宋体">이라 함은 회사가 허용하는 범위 내에서
                이용자의 신분 식별과 게임콘텐츠 이용을 위하여 이용자가 선정하는 문자</span><span style="font-family:'Times New Roman'">, </span><span
                style="font-family:宋体">숫자 또는 특수문자의 조합을 말합니다</span><span style="font-family:'Times New Roman'">.</span>
        </p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">&#xa0;</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">7. ‘</span><span style="font-family:宋体">계정정보</span><span
                style="font-family:'Times New Roman'">’</span><span style="font-family:宋体">라 함은 이용자의 계정</span><span
                style="font-family:'Times New Roman'">, </span><span style="font-family:宋体">비밀번호</span><span
                style="font-family:'Times New Roman'">, </span><span style="font-family:宋体">성명 등 회사에 제공한 정보 및 게임
                이용정보</span><span style="font-family:'Times New Roman'">, </span><span style="font-family:宋体">이용요금 결제상태 등
                생성정보를 통칭합니다</span><span style="font-family:'Times New Roman'">.</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">&#xa0;</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">8. ‘</span><span style="font-family:宋体">캐릭터</span><span
                style="font-family:'Times New Roman'">’</span><span style="font-family:宋体">라 함은 이용자가 게임콘텐츠의 이용 범위 내에서
                게임콘텐츠에 따라 게임세계 내에서 회사에서 제공하는 방식으로 창조하는 가상인물데이터를 말합니다</span><span
                style="font-family:'Times New Roman'">.</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">&#xa0;</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">9. ‘</span><span style="font-family:宋体">비밀번호</span><span
                style="font-family:'Times New Roman'">’</span><span style="font-family:宋体">라 함은 이용자의 계좌정보 안전 및 게임권익보호를
                위해 이용자 자신이 선정하는 문자</span><span style="font-family:'Times New Roman'">, </span><span
                style="font-family:宋体">숫자 또는 특수문자의 조합을 말합니다</span><span style="font-family:'Times New Roman'">.</span>
        </p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">&#xa0;</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">10. ‘</span><span style="font-family:宋体">게임머니</span><span
                style="font-family:'Times New Roman'">’</span><span style="font-family:宋体">라 함은 게임콘텐츠 또는 게임콘텐츠의 구매에 사용되는
                가상 화폐를 말합니다</span><span style="font-family:'Times New Roman'">.</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">&#xa0;</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">11. ‘</span><span style="font-family:宋体">사이버 포인트</span><span
                style="font-family:'Times New Roman'">’</span><span style="font-family:宋体">라 함은 게임 아이템이나 게임콘텐츠를 이용 또는
                구매하기 위해 사용되는 가상의 데이터로서 회사가 책정하고 무료로 지급하는 것을 말합니다</span><span
                style="font-family:'Times New Roman'">.</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">&#xa0;</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">12. ‘</span><span style="font-family:宋体">게시물</span><span
                style="font-family:'Times New Roman'">’</span><span style="font-family:宋体">이라 함은 이용자가 게시판에서 게시한
                문자</span><span style="font-family:'Times New Roman'">, </span><span
                style="font-family:宋体">그림</span><span style="font-family:'Times New Roman'">, </span><span
                style="font-family:宋体">음성</span><span style="font-family:'Times New Roman'">, </span><span
                style="font-family:宋体">영상 또는 이들의 조합으로 이루어진 정보를 말합니다</span><span
                style="font-family:'Times New Roman'">.</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">&#xa0;</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">13. </span><span style="font-family:宋体">이 약관에서 사용하는 전문용어의 정의는 이미
                정한 것을 제외하고는 관계 법령에 의합니다</span><span style="font-family:'Times New Roman'">.</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">&#xa0;</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">&#xa0;</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:微软雅黑">제</span><span style="font-family:'Times New Roman'">3</span><span
                style="font-family:宋体">조 회사정보의 공시</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">&#xa0;</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:微软雅黑">회사는</span><span style="font-family:'Times New Roman'">&#xa0;</span><span
                style="font-family:微软雅黑">다음</span><span style="font-family:'Times New Roman'">&#xa0;</span><span
                style="font-family:微软雅黑">각</span><span style="font-family:'Times New Roman'">&#xa0;</span><span
                style="font-family:微软雅黑">호의</span><span style="font-family:'Times New Roman'">&#xa0;</span><span
                style="font-family:微软雅黑">사항을</span><span style="font-family:'Times New Roman'">&#xa0;</span><span
                style="font-family:微软雅黑">게임</span><span style="font-family:'Times New Roman'">&#xa0;</span><span
                style="font-family:微软雅黑">초기화면이나</span><span style="font-family:'Times New Roman'">&#xa0;</span><span
                style="font-family:微软雅黑">게임</span><span style="font-family:'Times New Roman'">&#xa0;</span><span
                style="font-family:微软雅黑">홈페이지</span><span
                style="font-family:'Times New Roman'">(https://www.domain.com/)</span><span style="font-family:宋体">에
                게시하여 이용자가 이를 바로 알 수 있도록 합니다</span><span style="font-family:'Times New Roman'">. </span><span
                style="font-family:宋体">다만 회사의 개인정보처리방침과 구체적인 약관 내용은 링크를 통해 확인할 있습니다</span><span
                style="font-family:'Times New Roman'">. 8</span><span style="font-family:宋体">번 항목의 확률 정보는 게임과 웹페이지에
                공개됩니다</span><span style="font-family:'Times New Roman'">.</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">&#xa0;</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">1. </span><span style="font-family:宋体">상호 및 대표자의 성명</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">&#xa0;</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">2. </span><span style="font-family:宋体">영업소 소재지</span><span
                style="font-family:'Times New Roman'">(</span><span style="font-family:宋体">고객서비스센터 포함</span><span
                style="font-family:'Times New Roman'">) </span><span style="font-family:宋体">및 전자우편주소</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">&#xa0;</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">3. </span><span style="font-family:宋体">전화번호</span><span
                style="font-family:'Times New Roman'">, </span><span style="font-family:宋体">팩스번호</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">&#xa0;</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">4. </span><span style="font-family:宋体">사업자등록번호</span><span
                style="font-family:'Times New Roman'">, </span><span style="font-family:宋体">통신판매업 신고번호</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">&#xa0;</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">5. </span><span style="font-family:宋体">개인정보처리방침</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">&#xa0;</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">6. </span><span style="font-family:宋体">서비스 이용약관</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">&#xa0;</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">7. </span><span style="font-family:宋体">호스팅서비스를 제공하는 사업자의 상호</span>
        </p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">&#xa0;</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:微软雅黑">8. 「게임산업진흥에</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span style="font-family:微软雅黑">관한</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span style="font-family:微软雅黑">법률」</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span style="font-family:微软雅黑">등</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span style="font-family:微软雅黑">관련</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span style="font-family:微软雅黑">법령에</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span style="font-family:微软雅黑">따라</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span style="font-family:微软雅黑">표시할</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span style="font-family:微软雅黑">의무가</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span style="font-family:微软雅黑">있는</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span style="font-family:微软雅黑">확률형</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span style="font-family:微软雅黑">아이템</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span style="font-family:微软雅黑">관련</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span style="font-family:微软雅黑">정보</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">&#xa0;</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">&#xa0;</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:微软雅黑">제</span><span style="font-family:'Times New Roman'">4</span><span
                style="font-family:宋体">조 약관의 공시 및 개정</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">&#xa0;</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">1. </span><span style="font-family:宋体">회사는 이 약관의 구체적인 내용을 이용자가 알 수
                있도록 게임 초기화면이나 게임 홈페이지</span><span
                style="font-family:'Times New Roman'">(https://www.domain.com/)</span><span style="font-family:宋体">에 본
                약관의 조항들을 게시하는 방법으로 이용자에게 공시합니다</span><span style="font-family:'Times New Roman'">. </span><span
                style="font-family:宋体">본 약관의 효력은 공시한 후에 발생합니다</span><span style="font-family:'Times New Roman'">.</span>
        </p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">&#xa0;</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">2. </span><span style="font-family:宋体">이용자는 회사가 지정한 메일주소에
                메일</span><span style="font-family:'Times New Roman'">(global.support@domain.com)</span><span
                style="font-family:宋体">을 보냄으로써</span><span style="font-family:'Times New Roman'">, </span><span
                style="font-family:宋体">본 약관 내용에 대한 질의를 할 수 있으며</span><span style="font-family:'Times New Roman'">,
            </span><span style="font-family:宋体">회사는 합리적인 시간 내에 답변합니다</span><span
                style="font-family:'Times New Roman'">.</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">&#xa0;</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">3. </span><span style="font-family:宋体">회사는 게임콘텐츠 이용자의 편의를 위해 관련
                약관을 작성하여야 합니다</span><span style="font-family:'Times New Roman'">. </span><span
                style="font-family:宋体">약정할 약관의 효력이 발생하기에 앞서 회사는 쉬운 용어로 계약 해제</span><span
                style="font-family:'Times New Roman'">·</span><span style="font-family:宋体">해지조항</span><span
                style="font-family:'Times New Roman'">, </span><span style="font-family:宋体">면책조항 및 이용자에 대한 충전잔액반환이나 피해보상
                등과 같은 중요한 내용을 이용자가 쉽게 알아볼 수 있도록 작성하거나</span><span style="font-family:'Times New Roman'">, </span><span
                style="font-family:宋体">이러한 중요한 조항들을 굵게 표시하거나 그 제시를 위해 팝업화면을 제공합니다</span><span
                style="font-family:'Times New Roman'">.</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">&#xa0;</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">4. </span><span style="font-family:宋体">회사는 「전자상거래 등에서의 소비자보호에 관한
                법률」</span><span style="font-family:'Times New Roman'">, </span><span style="font-family:宋体">「게임산업진흥에 관한
                법률」</span><span style="font-family:'Times New Roman'">, </span><span style="font-family:宋体">「약관의 규제에 관한
                법률」</span><span style="font-family:'Times New Roman'">, </span><span style="font-family:宋体">「정보통신망이용촉진 및
                정보보호 등에 관한 법률」</span><span style="font-family:'Times New Roman'">, </span><span
                style="font-family:宋体">「콘텐츠산업진흥법」 등 관련 벌령에 근거하여</span><span style="font-family:'Times New Roman'">,
            </span><span style="font-family:宋体">위 법령에 위배하지 않는 전제 하에 이 약관을 보충 또는 개정할 수 있으며</span><span
                style="font-family:'Times New Roman'">, </span><span style="font-family:宋体">약관에 대한 보충 및 개정은 동등한 법적 효력을
                가집니다</span><span style="font-family:'Times New Roman'">.</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">&#xa0;</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">5. </span><span style="font-family:宋体">회사는 회사의 재량에 따라 본 약관을 수시로
                개정할 수 있습니다</span><span style="font-family:'Times New Roman'">. </span><span style="font-family:宋体">회사가
                약관을 개정할 경우에는 개정약관 효력발생일의 최소 </span><span style="font-family:'Times New Roman'">7</span><span
                style="font-family:宋体">일 이전부터 게임 초기화면을 통해 이용자에게 이를 공지합니다</span><span
                style="font-family:'Times New Roman'">. </span><span style="font-family:宋体">다만</span><span
                style="font-family:'Times New Roman'">, </span><span style="font-family:宋体">이용자에게 불리하거나 중대한 변경인 경우에는 최소
            </span><span style="font-family:'Times New Roman'">30</span><span style="font-family:宋体">일 이전부터 동일한 방법으로
                이용자에게 공지하며</span><span style="font-family:'Times New Roman'">, </span><span style="font-family:宋体">이용자가
                인터넷에 연결하여 게임콘텐츠 접속 시 쉽게 확인할 수 있도록 게임 내에서 공지하여야 합니다</span><span style="font-family:'Times New Roman'">.
            </span><span style="font-family:宋体">개정약관의 효력은 공시일 또는 공고 실시일로부터 발생합니다</span><span
                style="font-family:'Times New Roman'">.</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">&#xa0;</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">6. </span><span style="font-family:宋体">회사가 약관을 개정할 경우에는 개정약관 공지 후
                개정약관의 적용에 대한 이용자의 동의 여부를 확인합니다</span><span style="font-family:'Times New Roman'">. </span><span
                style="font-family:宋体">개정약관 공지시 이용자가 동의 또는 거부의 의사표시를 하지 않으면 승낙한 것으로 간주하겠다는 내용도 함께 공지한 경우에는 이용자가 약관 시행일까지
                거부의사를 표시하지 않는다면 개정약관에 동의한 것으로 간주할 수 있습니다</span><span style="font-family:'Times New Roman'">.</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">&#xa0;</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">7. </span><span style="font-family:宋体">이용자에게는 약관개정 확인을 위해 비정기적으로
                사이트를 방문하거나 공지 창을 확인하여야 할 의무가 있습니다</span><span style="font-family:'Times New Roman'">. </span><span
                style="font-family:宋体">만약 이용자가 변경된 약관의 내용에 동의하지 않는 경우</span><span
                style="font-family:'Times New Roman'">, </span><span style="font-family:宋体">회사와 이용자는 계약을 해지</span><span
                style="font-family:'Times New Roman'">(</span><span style="font-family:宋体">회원탈퇴</span><span
                style="font-family:'Times New Roman'">)</span><span style="font-family:宋体">할 수 있습니다</span><span
                style="font-family:'Times New Roman'">.</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">&#xa0;</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">&#xa0;</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:微软雅黑">제</span><span style="font-family:'Times New Roman'">5</span><span
                style="font-family:宋体">조 약관 외 준칙</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">&#xa0;</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:微软雅黑">회사는</span><span style="font-family:'Times New Roman'">&#xa0;</span><span
                style="font-family:微软雅黑">이</span><span style="font-family:'Times New Roman'">&#xa0;</span><span
                style="font-family:微软雅黑">약관에</span><span style="font-family:'Times New Roman'">&#xa0;</span><span
                style="font-family:微软雅黑">포함되지</span><span style="font-family:'Times New Roman'">&#xa0;</span><span
                style="font-family:微软雅黑">아니한</span><span style="font-family:'Times New Roman'">&#xa0;</span><span
                style="font-family:微软雅黑">사항에</span><span style="font-family:'Times New Roman'">&#xa0;</span><span
                style="font-family:微软雅黑">관하여</span><span style="font-family:'Times New Roman'">&#xa0;</span><span
                style="font-family:微软雅黑">「전자상거래</span><span style="font-family:'Times New Roman'">&#xa0;</span><span
                style="font-family:微软雅黑">등에서의</span><span style="font-family:'Times New Roman'">&#xa0;</span><span
                style="font-family:微软雅黑">소비자보호에</span><span style="font-family:'Times New Roman'">&#xa0;</span><span
                style="font-family:微软雅黑">관한</span><span style="font-family:'Times New Roman'">&#xa0;</span><span
                style="font-family:微软雅黑">법률」</span><span style="font-family:'Times New Roman'">, </span><span
                style="font-family:宋体">「게임산업진흥에 관한 법률」</span><span style="font-family:'Times New Roman'">, </span><span
                style="font-family:宋体">「약관의 규제에 관한 법률」</span><span style="font-family:'Times New Roman'">, </span><span
                style="font-family:宋体">「정보통신망이용촉진 및 정보보호 등에 관한 법률」</span><span style="font-family:'Times New Roman'">,
            </span><span style="font-family:宋体">「콘텐츠산업진흥법」등 관련 법령을 참조하여 따릅니다</span><span
                style="font-family:'Times New Roman'">.</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">&#xa0;</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">&#xa0;</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">&#xa0;</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:微软雅黑">제</span><span style="font-family:'Times New Roman'">6</span><span
                style="font-family:宋体">조 운영정책</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">&#xa0;</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">1. </span><span style="font-family:宋体">이용자의 권익을 보호하고 게임세계 내 질서를
                유지하기 위하여 회사는 아래와 같이 게임콘텐츠 운영정책</span><span style="font-family:'Times New Roman'">(</span><span
                style="font-family:宋体">이하 </span><span style="font-family:'Times New Roman'">“</span><span
                style="font-family:宋体">운영정책</span><span style="font-family:'Times New Roman'">”)</span><span
                style="font-family:宋体">을 제정합니다</span><span style="font-family:'Times New Roman'">.</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">&#xa0;</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">2. </span><span style="font-family:宋体">회사는 이용자가 운영정책의 내용을 구체적으로
                이해할 수 있도록 게임 초기화면이나 게임 홈페이지</span><span
                style="font-family:'Times New Roman'">(https://www.domain.com/)</span><span style="font-family:宋体">에 이를
                공지합니다</span><span style="font-family:'Times New Roman'">.</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">&#xa0;</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">3. </span><span style="font-family:宋体">이용자의 권리 또는 의무에 변경을 가져오는 것과
                관련된 운영정책 개정의 경우에는 본 약관 제</span><span style="font-family:'Times New Roman'">4</span><span
                style="font-family:宋体">조</span><span style="font-family:'Times New Roman'">(</span><span
                style="font-family:宋体">약관의 공시 및 개정</span><span style="font-family:'Times New Roman'">)</span><span
                style="font-family:宋体">에 따릅니다</span><span style="font-family:'Times New Roman'">. </span><span
                style="font-family:宋体">만약 이용자의 권리의무와 관련 없는 사항을 개정하는 경우</span><span
                style="font-family:'Times New Roman'">, </span><span style="font-family:宋体">본 약관 제</span><span
                style="font-family:'Times New Roman'">6</span><span style="font-family:宋体">조 제</span><span
                style="font-family:'Times New Roman'">2</span><span style="font-family:宋体">항의 방법으로 공지할 수
                있습니다</span><span style="font-family:'Times New Roman'">.</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">&#xa0;</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">4. </span><span style="font-family:宋体">회사는 운영정책의 내용이 본 약관에서 정한 내용과
                일치하도록 유지하며</span><span style="font-family:'Times New Roman'">, </span><span style="font-family:宋体">운영정책에
                대한 개정은 이용자가 예측 가능한 범위에 한하여 할 수 있습니다</span><span style="font-family:'Times New Roman'">.</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">&#xa0;</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">&#xa0;</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">&#xa0;</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:微软雅黑">제</span><span style="font-family:'Times New Roman'">2</span><span
                style="font-family:宋体">장 이용조례</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">&#xa0;</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">&#xa0;</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:微软雅黑">제</span><span style="font-family:'Times New Roman'">7</span><span
                style="font-family:宋体">조 이용자 신청 및 방법</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">&#xa0;</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">1. </span><span style="font-family:宋体">회사가 제공하는 게임콘텐츠를 이용하고자 하는 경우
                이용자는 게임 초기화면이나 게임 홈페이지에서 이용신청서를 제출하여야 합니다</span><span style="font-family:'Times New Roman'">.</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">&#xa0;</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">2. </span><span style="font-family:宋体">이용자는 이용신청서 작성 시 회사에서 필요로 하는
                각종 정보를 제공하여야 합니다</span><span style="font-family:'Times New Roman'">.</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">&#xa0;</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">3. </span><span style="font-family:宋体">이용자는 제</span><span
                style="font-family:'Times New Roman'">1</span><span style="font-family:宋体">항에 따른 이용신청서 제출 시 반드시 본인의 실명 및
                실제 정보를 기재하여야 합니다</span><span style="font-family:'Times New Roman'">. </span><span
                style="font-family:宋体">정보를 허위로 제공하거나 타인의 신원을 도용하는 등 불법 행위를 행하였을 경우 회사는 당해 이용자에 대하여 제공하는 전부 또는 일부
                서비스를</span><span style="font-family:'Times New Roman'">&#xa0;</span><span
                style="font-family:'Malgun Gothic'">중단</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span
                style="font-family:'Malgun Gothic'">또는</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span
                style="font-family:'Malgun Gothic'">종료</span><span style="font-family:微软雅黑">할</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span style="font-family:微软雅黑">수</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span style="font-family:微软雅黑">있습니다</span><span
                style="font-family:'Times New Roman'">.</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">&#xa0;</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">4. </span><span style="font-family:宋体">청소년</span><span
                style="font-family:'Times New Roman'">(1</span><span style="font-family:微软雅黑">9세</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span style="font-family:微软雅黑">미만</span><span
                style="font-family:'Malgun Gothic'">인</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span style="font-family:微软雅黑">자</span><span
                style="font-family:'Times New Roman'">.</span><span style="font-family:宋体">「초</span><span
                style="font-family:'Times New Roman'">·</span><span style="font-family:宋体">중등교육법 」제</span><span
                style="font-family:'Times New Roman'">2</span><span style="font-family:宋体">조의 규정에 의한 고등학교에 재학 중인 학생을
                포함함</span><span style="font-family:'Times New Roman'">)</span><span style="font-family:宋体">이 이용신청을 할 경우
                법정대리인의 동의를 얻어야 하고</span><span style="font-family:'Times New Roman'">, </span><span
                style="font-family:宋体">동의를 이미 받은 청소년이 이용신청을 할 경우에는 위 법령</span><span
                style="font-family:'Times New Roman'">, </span><span style="font-family:宋体">약관 및 운영정책에 따르도록
                합니다</span><span style="font-family:'Times New Roman'">.</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">&#xa0;</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">&#xa0;</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">&#xa0;</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:微软雅黑">제</span><span style="font-family:'Times New Roman'">8</span><span
                style="font-family:宋体">조 이용신청의 승낙과 제한</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">&#xa0;</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">1. </span><span style="font-family:宋体">이용신청을 하고자 하는 이용자는 기재할 계정과
                개인정보를 준비하여야 하며</span><span style="font-family:'Times New Roman'">, </span><span
                style="font-family:宋体">자신이 제공한 개인신원자료에 관한 정보의 진실성</span><span style="font-family:'Times New Roman'">,
            </span><span style="font-family:宋体">완전성 및 유효성을 보증하여야 합니다</span><span style="font-family:'Times New Roman'">.
            </span><span style="font-family:宋体">회사는 이용조건에 부합되는 신청에 대하여 승낙할 수 있습니다</span><span
                style="font-family:'Times New Roman'">. </span><span style="font-family:宋体">회사는 이용자의 이용신청을 승낙한 때부터
                게임콘텐츠에 대한 제공을 개시합니다</span><span style="font-family:'Times New Roman'">. </span><span
                style="font-family:宋体">다만</span><span style="font-family:'Times New Roman'">, </span><span
                style="font-family:宋体">일부 서비스의 경우에는 회사의 필요에 따라 지정된 일자부터 서비스를 개시할 수 있으며</span><span
                style="font-family:'Times New Roman'">, </span><span style="font-family:宋体">특정 서비스에 대해서는 유료로 제공할 수
                있습니다</span><span style="font-family:'Times New Roman'">.</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">&#xa0;</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">2. </span><span style="font-family:宋体">회사는 다음 각 호의 어느 하나에 해당하는
                경우에는 신청을 거절할 수 있습니다</span><span style="font-family:'Times New Roman'">.</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">&#xa0;</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">1) </span><span style="font-family:宋体">제</span><span
                style="font-family:'Times New Roman'">7</span><span style="font-family:宋体">조에 따른 이용자 신청 및 방법 규정에 위반하는
                경우</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">&#xa0;</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">2) </span><span style="font-family:宋体">이용요금을 납부하지 않거나</span><span
                style="font-family:'Times New Roman'">, </span><span style="font-family:宋体">전액 납부하지 않고 잔액이 완전히 납부할 수 있을
                지 여부를 확인할 수 없는 경우</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">&#xa0;</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">3) </span><span style="font-family:宋体">미성년자</span><span
                style="font-family:'Times New Roman'">(</span><span style="font-family:宋体">제</span><span
                style="font-family:'Times New Roman'">7</span><span style="font-family:宋体">조 제</span><span
                style="font-family:'Times New Roman'">4</span><span style="font-family:宋体">항</span><span
                style="font-family:'Times New Roman'">)</span><span style="font-family:宋体">가 법정대리인의 동의를 얻지 아니하거나 동의를
                얻었음을 확인할 수 없는 경우</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">&#xa0;</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">4) </span><span style="font-family:宋体">최근 </span><span
                style="font-family:'Times New Roman'">3</span><span style="font-family:宋体">개월 내 이용제한 기록이 있는 경우</span>
        </p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">&#xa0;</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">5) </span><span style="font-family:宋体">타인의 신용카드</span><span
                style="font-family:'Times New Roman'">, </span><span style="font-family:宋体">신원자료를 무단으로 도용하여 게임 가입에 사용하거나
                서비스이용요금을 결제하는 경우</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">&#xa0;</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">6) </span><span style="font-family:宋体">대한민국 이외의 국가에서 게임콘텐츠를 이용하고자
                하는 경우</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">&#xa0;</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">7) </span><span style="font-family:宋体">게임콘텐츠 제공과 관련하여 일정한 제한을 둘 수
                있는 경우</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">&#xa0;</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">8) </span><span style="font-family:宋体">기타 「게임산업진흥에 관한
                법률」</span><span style="font-family:'Times New Roman'">, </span><span style="font-family:宋体">「정보통신망 이용촉진
                및 정보보호 등에 관한 관련 법률」등 규정에 위반하는 경우</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">&#xa0;</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">9) </span><span style="font-family:宋体">그 밖에 </span><span
                style="font-family:'Times New Roman'">1</span><span style="font-family:宋体">호 내지 </span><span
                style="font-family:'Times New Roman'">8</span><span style="font-family:宋体">호에 준하는 사유와 유사한 행위가 발생하는
                경우</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">&#xa0;</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">3. </span><span style="font-family:宋体">회사는 이용자의 이용신청에 대하여 다음 각 호의
                어느 하나에 해당하는 경우에는 그 사유가 해소될 때까지 이용신청에 대한 승낙을 유보하거나 거절할 수 있습니다</span><span
                style="font-family:'Times New Roman'">. </span><span style="font-family:宋体">다만</span><span
                style="font-family:'Times New Roman'">, </span><span style="font-family:宋体">업무상 또는 기술적인 장애로 인하여 회사가 서비스를
                제공할 수 없을 경우 사이트에 공시하거나 이용자에게 통지하여야 합니다</span><span style="font-family:'Times New Roman'">.</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">&#xa0;</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">1) </span><span style="font-family:宋体">회사 운영정책에 부합하지 아니한 이용신청을 한
                경우</span><span style="font-family:'Times New Roman'">(</span><span style="font-family:宋体">단</span><span
                style="font-family:'Times New Roman'">, </span><span style="font-family:宋体">이 경우 신청인이 회사 정책 상응한 조건에
                부합된다고 인정될 때까지</span><span style="font-family:'Times New Roman'">)</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">&#xa0;</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">2) </span><span style="font-family:宋体">서비스 제공상의 장애 또는 이용요금 결제수단의
                장애가 발생한 경우</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">&#xa0;</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">3) </span><span style="font-family:宋体">신청의 승낙에 기술상의 장애가 발생한
                경우</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">&#xa0;</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">4. </span><span style="font-family:宋体">회사는 서비스를 제공함에 있어 이용자에 대하여 본
                약관 외에 별도 서비스약관의 체결을 요구할 수 있습니다</span><span style="font-family:'Times New Roman'">. </span><span
                style="font-family:宋体">별도의 약관체결이 요구되는 게임은 이용자의 동의 및 이용신청 후 이용 가능합니다</span><span
                style="font-family:'Times New Roman'">.</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">&#xa0;</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">5. </span><span style="font-family:宋体">회사는 업무상 또는 기술상 특별한 지장이 없는
                한</span><span style="font-family:'Times New Roman'">, </span><span style="font-family:宋体">연중무휴
            </span><span style="font-family:'Times New Roman'">1</span><span style="font-family:宋体">일 </span><span
                style="font-family:'Times New Roman'">24</span><span style="font-family:宋体">시간 서비스 제공을 원칙으로
                합니다</span><span style="font-family:'Times New Roman'">. </span><span
                style="font-family:宋体">다만</span><span style="font-family:'Times New Roman'">, </span><span
                style="font-family:宋体">시스템 정기점검</span><span style="font-family:'Times New Roman'">, </span><span
                style="font-family:宋体">서버의 증설 및 교체</span><span style="font-family:'Times New Roman'">, </span><span
                style="font-family:宋体">새로운 게임 내용의 추가</span><span style="font-family:'Times New Roman'">, </span><span
                style="font-family:宋体">각종 버그 패치</span><span style="font-family:'Times New Roman'">, </span><span
                style="font-family:宋体">새로운 서비스로의 교체 등 운영상 필요한 경우</span><span style="font-family:'Times New Roman'">,
            </span><span style="font-family:宋体">일정기간 서비스를 일시 종료시킬 수 있으며</span><span
                style="font-family:'Times New Roman'">, </span><span style="font-family:宋体">이러한 경우 회사는 사전에 그 내용 및 시간을
                홈페이지에 공지합니다</span><span style="font-family:'Times New Roman'">. </span><span
                style="font-family:宋体">다만</span><span style="font-family:'Times New Roman'">, </span><span
                style="font-family:宋体">회사가 사전에 통지할 수 없는 부득이한 사유가 있는 경우 사후에 통지할 수 있습니다</span><span
                style="font-family:'Times New Roman'">.</span><span style="font-family:'Times New Roman'">&#xa0;</span>
        </p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">&#xa0;</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">6. </span><span style="font-family:宋体">회사는 이용자에게 아래와 같은 게임콘텐츠를
                제공합니다</span><span style="font-family:'Times New Roman'">.</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">&#xa0;</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">1) </span><span style="font-family:宋体">게임 서비스 및 관련 서비스</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">&#xa0;</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">2) </span><span style="font-family:宋体">소셜 네트워크 서비스 </span><span
                style="font-family:'Times New Roman'">(SNS)</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">&#xa0;</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">3) </span><span style="font-family:宋体">기타 회사가 자체 개발하거나 다른 회사와의 협력
                계약 등 방식을 통해 이용자에게 제공하는 일체의 서비스</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">&#xa0;</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">7. </span><span style="font-family:宋体">회사는 이용자에게 서비스를 제공함에 있어 관련
                법령</span><span style="font-family:'Times New Roman'">, </span><span style="font-family:宋体">이용자의
                연령</span><span style="font-family:'Times New Roman'">, </span><span style="font-family:宋体">서비스의 이용 절차에
                따라 일부 서비스 이용 등을 제한할 수 있습니다</span><span style="font-family:'Times New Roman'">. </span><span
                style="font-family:宋体">이 경우 회사는 해당 내용을 사전에 이용자에게 안내합니다</span><span
                style="font-family:'Times New Roman'">.</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">&#xa0;</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">8. </span><span style="font-family:宋体">회사는 이용자의 편의를 위하여 일부 서비스에 대해
            </span><span style="font-family:'Times New Roman'">‘</span><span style="font-family:宋体">임시회원</span><span
                style="font-family:'Times New Roman'">’ </span><span style="font-family:宋体">기능을 제공할 수 있습니다</span><span
                style="font-family:'Times New Roman'">. </span><span style="font-family:宋体">단</span><span
                style="font-family:'Times New Roman'">, </span><span style="font-family:宋体">임시회원 기능 이용 중 아래 각 호에 해당하는 경우
                서비스 이용기록 및 구매기록이 삭제되거나 기록을 확인할 수 없는 문제가 발생할 수 있습니다</span><span style="font-family:'Times New Roman'">.
            </span><span style="font-family:宋体">따라서 이러한 사실에 대해 회사는 서비스 최초 이용 시 팝업 등으로 공지할 예정이며</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span style="font-family:微软雅黑">회원인증을</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span style="font-family:微软雅黑">통한</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span style="font-family:微软雅黑">서비스</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span style="font-family:微软雅黑">이용을</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span style="font-family:微软雅黑">권장하며</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span style="font-family:微软雅黑">서비스별로</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span style="font-family:微软雅黑">임시회원이</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span style="font-family:微软雅黑">회원인증을</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span style="font-family:微软雅黑">받는</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span style="font-family:微软雅黑">방식이</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span style="font-family:微软雅黑">다르므로</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span style="font-family:微软雅黑">자세한</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span style="font-family:微软雅黑">사항은</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span style="font-family:微软雅黑">고객센터</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span style="font-family:微软雅黑">메일로</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span style="font-family:微软雅黑">문의</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span style="font-family:微软雅黑">바랍니다.</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">1) </span><span style="font-family:宋体">모바일 기기를 변경한 경우</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">&#xa0;</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">2)</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span style="font-family:'Times New Roman'">
            </span><span style="font-family:宋体">모바일 기기를 개조하거나 초기화한 경우</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">&#xa0;</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">3)</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span style="font-family:'Times New Roman'">
            </span><span style="font-family:宋体">모바일 기기에서 어플리케이션 등 콘텐츠를 삭제한 경우</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">&#xa0;</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">&#xa0;</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:微软雅黑">제</span><span style="font-family:'Times New Roman'">9</span><span
                style="font-family:宋体">조 이용자 계정 및 비밀번호</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">&#xa0;</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">1. </span><span style="font-family:宋体">회사가 허용하는 범위 내에서 이용자의 신분식별과
                게임콘텐츠 이용을 위하여 이용자가 선정한 문자</span><span style="font-family:'Times New Roman'">, </span><span
                style="font-family:宋体">숫자 또는 특수문자의 조합을 사용합니다</span><span style="font-family:'Times New Roman'">.</span>
        </p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">&#xa0;</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">2. </span><span style="font-family:宋体">회사는 이용자 가입 시 제공한 신원정보에 대한
                진실성과 유효성을 심사할 수 있습니다</span><span style="font-family:'Times New Roman'">.</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">&#xa0;</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">3. </span><span style="font-family:宋体">이용자는 자신의 계정과 비밀번호를 적절히 보관하여
                이를 정확하고 안전하게 사용할 의무가 있습니다</span><span style="font-family:'Times New Roman'">. </span><span
                style="font-family:宋体">이용자가 위 의무를 소홀히 함으로 인하여 계정 및 비밀번호를 분실하거나 도용 당하거나</span><span
                style="font-family:'Times New Roman'">, </span><span style="font-family:宋体">이용자가 제</span><span
                style="font-family:'Times New Roman'">3</span><span style="font-family:宋体">자에게 이용을 승낙으로써 본인 또는 타인에게 발생하는
                민사상 손해에 대하여는 이용자 본인에게 법률상 책임이 있습니다</span><span style="font-family:'Times New Roman'">. </span><span
                style="font-family:宋体">이 경우 회사는 회사의 고의 또는 중과실이 없는 한 면책됩니다</span><span
                style="font-family:'Times New Roman'">.</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">&#xa0;</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">4. </span><span style="font-family:宋体">실제 정보로 가입한 이용자가 개인신원자료에 관한
                기존 정보를 변경할 필요가 있는 경우 회사는 적시에 유효하게 이러한 서비스를 제공하여야 합니다</span><span
                style="font-family:'Times New Roman'">.</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">&#xa0;</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">5. </span><span style="font-family:宋体">이용자는 적시에 본인의 비밀번호를 변경하여야
                합니다</span><span style="font-family:'Times New Roman'">.</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">&#xa0;</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">&#xa0;</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">&#xa0;</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:微软雅黑">제</span><span style="font-family:'Times New Roman'">10</span><span
                style="font-family:宋体">조 이용자 정보의 제공 및 변경</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">&#xa0;</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">1. </span><span style="font-family:宋体">이용자는 제공한 개인신원자료에 관한 정보가
                진실되고 완전하며 유효한 것임을 보증하여야 합니다</span><span style="font-family:'Times New Roman'">. </span><span
                style="font-family:宋体">허위정보 제공으로 인해 발생한 손해에 대하여 이용자 본인이 책임을 부담하여야 합니다</span><span
                style="font-family:'Times New Roman'">.</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">&#xa0;</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">2. </span><span style="font-family:宋体">회원은 개인정보관리화면을 통해 언제든지 자신의
                개인정보를 열람할 수 있습니다</span><span style="font-family:'Times New Roman'">. </span><span
                style="font-family:宋体">다만</span><span style="font-family:'Times New Roman'">, </span><span
                style="font-family:宋体">서비스 관리를 위해 필요한 실명</span><span style="font-family:'Times New Roman'">,
            </span><span style="font-family:宋体">계정</span><span style="font-family:'Times New Roman'">(ID) </span><span
                style="font-family:宋体">등은 수정할 수 없습니다</span><span style="font-family:'Times New Roman'">.</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">&#xa0;</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">3. </span><span style="font-family:宋体">이용자가 등록정보를 변경하고자 하는 경우에는
                온라인으로 수정을 하거나 기타 유효한 연락수단으로 회사에 대하여 그 변경사항을 알려야 합니다</span><span
                style="font-family:'Times New Roman'">.</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">&#xa0;</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">4. </span><span style="font-family:宋体">이용자가 회사에 정보 변경사항을 적시에 통지하지
                않아 발생한 손해에 대하여 회사는 책임을 부담하지 않습니다</span><span style="font-family:'Times New Roman'">.</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">&#xa0;</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">&#xa0;</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">&#xa0;</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:微软雅黑">제</span><span style="font-family:'Times New Roman'">11</span><span
                style="font-family:宋体">조 개인정보의 관리 및 안전</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">&#xa0;</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">&#xa0;</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">1. </span><span style="font-family:宋体">회사는 위 법령에 따라 이용자계정의 안전성과
                유효성을 보호하기 위해 기술상 및 관리상의 합리적인 조치를 적극적으로 취합니다</span><span style="font-family:'Times New Roman'">.
            </span><span style="font-family:宋体">회사는 관계 법령의 규정에 따라 이용자 등록정보를 포함한 이용자의 개인정보를 보호하기 위해 노력합니다</span><span
                style="font-family:'Times New Roman'">. </span><span style="font-family:宋体">이용자 개인정보의 보호 및 사용에 대해서는 관련
                법령 및 회사의 개인정보처리방침이 적용됩니다</span><span style="font-family:'Times New Roman'">. </span><span
                style="font-family:宋体">단</span><span style="font-family:'Times New Roman'">, </span><span
                style="font-family:宋体">회사 서비스를 통해 링크된 제</span><span style="font-family:'Times New Roman'">3</span><span
                style="font-family:宋体">자 제공의 서비스</span><span style="font-family:'Times New Roman'">(</span><span
                style="font-family:宋体">모든 제</span><span style="font-family:'Times New Roman'">3</span><span
                style="font-family:宋体">자 사이트 포함</span><span style="font-family:'Times New Roman'">)</span><span
                style="font-family:宋体">로부터 수집된 개인정보나 회사의 서비스를 통해 광고 서비스를 하고 있는 다른 회사 또는 기관으로부터 수집된 정보에는 회사의 개인정보처리방침이
                적용되지 않습니다</span><span style="font-family:'Times New Roman'">.</span><span
                style="font-family:'Times New Roman'">&#xa0;</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">&#xa0;</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">2. </span><span style="font-family:宋体">회사에서 이용자를 대상으로 제공하는 게임콘텐츠와
                계정정보 안전보호를 위한 서비스는 이용자 자격이 없는 기타 제</span><span style="font-family:'Times New Roman'">3</span><span
                style="font-family:宋体">의 이용자에게 적용되지 않습니다</span><span style="font-family:'Times New Roman'">.</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">&#xa0;</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">3. </span><span style="font-family:宋体">게임콘텐츠 이용에 동의한 것은 이용자의 자율적
                의사표시이며</span><span style="font-family:'Times New Roman'">, </span><span style="font-family:宋体">이용자는
                계정정보의 노출이 수반되는 모든 리스크 및 해당 리스크로 인하여 발생한 모든 직</span><span
                style="font-family:'Times New Roman'">∙</span><span style="font-family:宋体">간접적</span><span
                style="font-family:'Times New Roman'">, </span><span style="font-family:宋体">파생적 손해에 대하여 책임을
                부담하며</span><span style="font-family:'Times New Roman'">, </span><span style="font-family:宋体">회사는 이에 대한
                일체적 책임을 지지 않습니다</span><span style="font-family:'Times New Roman'">. </span><span
                style="font-family:宋体">다만</span><span style="font-family:'Times New Roman'">, </span><span
                style="font-family:宋体">법령에 따라 완전히 배제될 수 없을 경우 회사의 배상책임 한도는 관련 사유로 인하여 이용자가 회사에 지급한 금액에 한합니다</span><span
                style="font-family:'Times New Roman'">. </span><span style="font-family:宋体">회사는 이용자의 귀책사유로 노출된 이용자의
                계정정보를 포함한 모든 손해에 대해서 일체의 책임을 지지 않습니다</span><span style="font-family:'Times New Roman'">.</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">&#xa0;</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">4. </span><span style="font-family:宋体">회사는 이용자의 본인 확인을 위해 필요한
                경우</span><span style="font-family:'Times New Roman'">, </span><span style="font-family:宋体">대한민국 법령상 적법하게
                본인 확인을 할 수 있는 자격을 가진 제</span><span style="font-family:'Times New Roman'">3</span><span
                style="font-family:宋体">의 기관이나 사업자</span><span style="font-family:'Times New Roman'">(“</span><span
                style="font-family:宋体">본인확인기관</span><span style="font-family:'Times New Roman'">”)</span><span
                style="font-family:宋体">를 통하여 본인확인을 진행합니다</span><span style="font-family:'Times New Roman'">.
            </span><span style="font-family:宋体">회사는 본인확인기관으로부터 이용자가 입력한 정보에 따른 본인 확인 결과만을 확인합니다</span><span
                style="font-family:'Times New Roman'">.</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">&#xa0;</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">&#xa0;</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">&#xa0;</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:微软雅黑">제</span><span style="font-family:'Times New Roman'">3</span><span
                style="font-family:宋体">장 회사 및 이용자의 의무</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">&#xa0;</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">&#xa0;</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">&#xa0;</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:微软雅黑">제</span><span style="font-family:'Times New Roman'">12</span><span
                style="font-family:宋体">조 회사의 의무</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">&#xa0;</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">&#xa0;</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">&#xa0;</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">1. </span><span style="font-family:宋体">회사는 현행 법령</span><span
                style="font-family:'Times New Roman'">, </span><span style="font-family:宋体">정책을 엄격히 준수하고</span><span
                style="font-family:'Times New Roman'">, </span><span style="font-family:宋体">법률로 부여받은 권리를 가지며</span><span
                style="font-family:'Times New Roman'">, </span><span style="font-family:宋体">법률 규정에 따라 의무를
                이행합니다</span><span style="font-family:'Times New Roman'">. </span><span style="font-family:宋体">회사는 법령과 본
                약관이 금지하거나 미풍양속에 반하는 행위를 하지 않으며</span><span style="font-family:'Times New Roman'">, </span><span
                style="font-family:宋体">계속적이고 안정적인 서비스를 제공하기 위하여 노력합니다</span><span
                style="font-family:'Times New Roman'">.</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">&#xa0;</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">2. </span><span style="font-family:宋体">회사는 이용자 안전 및
                개인정보</span><span style="font-family:'Times New Roman'">(</span><span style="font-family:宋体">신용정보
                포함</span><span style="font-family:'Times New Roman'">) </span><span style="font-family:宋体">보호를 위해 반드시
                보안시스템을 구축하며 개인정보처리방침을 공시하고 준수함과 동시에 본 약관과 관련 법령을 준수하여야 합니다</span><span
                style="font-family:'Times New Roman'">. </span><span style="font-family:宋体">회사는 관련 법령 및 본 약관에서 명확하게 정한
                예외적인 경우를 제외하고는 이용자의 개인정보가 제</span><span style="font-family:'Times New Roman'">3</span><span
                style="font-family:宋体">자에게 누설되지 않도록 합니다</span><span style="font-family:'Times New Roman'">.</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">&#xa0;</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">3. </span><span style="font-family:宋体">해커공격</span><span
                style="font-family:'Times New Roman'">, </span><span style="font-family:宋体">컴퓨터바이러스 감염</span><span
                style="font-family:'Times New Roman'">, </span><span style="font-family:宋体">시스템 붕괴</span><span
                style="font-family:'Times New Roman'">, </span><span style="font-family:宋体">네트워크 접속 끊김</span><span
                style="font-family:'Times New Roman'">, </span><span style="font-family:宋体">인터넷 속도 저하</span><span
                style="font-family:'Times New Roman'">, </span><span style="font-family:宋体">소프트웨어 오류 등 문제로 인한 장애 및 위협이
                발생하였을 경우</span><span style="font-family:'Times New Roman'">, </span><span style="font-family:宋体">이용자는 위
                각종 불량 정보</span><span style="font-family:'Times New Roman'">, </span><span style="font-family:宋体">네트워크 안전
                및 인터넷의 장애 발생은 회사 및 회사의 게임콘텐츠로 인한 것이 아니라는 점과 이러한 문제점 때문에 이용자에게 생길 수 있는 불만</span><span
                style="font-family:'Times New Roman'">, </span><span style="font-family:宋体">구역질</span><span
                style="font-family:'Times New Roman'">, </span><span style="font-family:宋体">구토 등 정신적 손해 및 다른 손실에 대하여 모두
                자체적으로 책임을 부담하되</span><span style="font-family:'Times New Roman'">, </span><span
                style="font-family:宋体">회사가 책임을 지지 아니한다는 점을 충분히 이해하여야 합니다</span><span
                style="font-family:'Times New Roman'">.</span><span style="font-family:'Times New Roman'">&#xa0;</span>
        </p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">&#xa0;</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">4. </span><span style="font-family:宋体">회사는 이용자로부터 제기되는 의견이나 불만이
                정당하다고 인정될 경우에는 즉시 처리합니다</span><span style="font-family:'Times New Roman'">. </span><span
                style="font-family:宋体">다만</span><span style="font-family:'Times New Roman'">, </span><span
                style="font-family:宋体">바로 처리하기가 곤란한 경우에는 전화나 전자우편으로 그 사유와 처리예정일을 이용자에게 통보합니다</span><span
                style="font-family:'Times New Roman'">.</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">&#xa0;</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">&#xa0;</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">&#xa0;</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:微软雅黑">제</span><span style="font-family:'Times New Roman'">13</span><span
                style="font-family:宋体">조 이용자의 의무</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">&#xa0;</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">1. </span><span style="font-family:宋体">이용자는 게임콘텐츠 및 네트워크 서비스 이용에
                있어서 본 약관에서 정하고 있는 사항 및 운영정책 관련 법률 규정을 준수하여야 합니다</span><span style="font-family:'Times New Roman'">.
            </span><span style="font-family:宋体">이용자는 다음 각 호의 행위 및 본 약관에 반하는 행위와 현행 법령</span><span
                style="font-family:'Times New Roman'">, </span><span style="font-family:宋体">정책에서 금지하는 행위를 하여서는 아니
                됩니다</span><span style="font-family:'Times New Roman'">.</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span
                style="font-family:'Times New Roman'">&#xa0;</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">&#xa0;</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">1) </span><span style="font-family:宋体">신청 또는 신청 변경 시 허위정보의
                제공</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">&#xa0;</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">2) </span><span style="font-family:宋体">타인의 신원정보 도용</span><span
                style="font-family:'Times New Roman'">(</span><span style="font-family:宋体">타인으로 가장하는 행위 및 타인과의 관계를 허위로
                표시하는 행위</span><span style="font-family:'Times New Roman'">)</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">&#xa0;</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">3) </span><span style="font-family:宋体">회사의 임직원</span><span
                style="font-family:'Times New Roman'">, </span><span style="font-family:宋体">운영자</span><span
                style="font-family:'Times New Roman'">, </span><span style="font-family:宋体">기타 관계자를 사칭하는 행위</span><span
                style="font-family:'Times New Roman'">(</span><span style="font-family:宋体">회사의 직원 또는 게시판관리자로 가장하거나 사칭하는
                행위</span><span style="font-family:'Times New Roman'">, </span><span style="font-family:宋体">타인의 명의를 도용하여
                문장을 게시하거나 메일을 발송하는 행위 포함</span><span style="font-family:'Times New Roman'">)</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">&#xa0;</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">4) </span><span style="font-family:宋体">회사가 대외적으로 게시한 정보의 임의적
                변경</span><span style="font-family:'Times New Roman'">(</span><span style="font-family:宋体">서비스 공지정보에 대한
                변경행위 포함</span><span style="font-family:'Times New Roman'">)</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">&#xa0;</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">5) </span><span style="font-family:宋体">회사가 외부 노출을 금지한 상품 및
                정보</span><span style="font-family:'Times New Roman'">(</span><span
                style="font-family:宋体">컴퓨터프로그램</span><span style="font-family:'Times New Roman'">, </span><span
                style="font-family:宋体">회사 동의 없이 기타 이용자의 개인정보를 수집</span><span style="font-family:'Times New Roman'">,
            </span><span style="font-family:宋体">보관</span><span style="font-family:'Times New Roman'">, </span><span
                style="font-family:宋体">배포</span><span style="font-family:'Times New Roman'">, </span><span
                style="font-family:宋体">게시하는 행위</span><span style="font-family:'Times New Roman'">)</span><span
                style="font-family:宋体">의 배포</span><span style="font-family:'Times New Roman'">, </span><span
                style="font-family:宋体">공유</span><span style="font-family:'Times New Roman'">, </span><span
                style="font-family:宋体">전송</span><span style="font-family:'Times New Roman'">, </span><span
                style="font-family:宋体">또는 게시</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">&#xa0;</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">6) </span><span style="font-family:宋体">회사가 대외적으로 제공하지 않는 컴퓨터프로그램이나
                설비의 제작</span><span style="font-family:'Times New Roman'">, </span><span
                style="font-family:宋体">배포</span><span style="font-family:'Times New Roman'">, </span><span
                style="font-family:宋体">사용</span><span style="font-family:'Times New Roman'">, </span><span
                style="font-family:宋体">전송</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">&#xa0;</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">7) </span><span style="font-family:宋体">회사가 제공하는 게임 상품 또는 그 소프트웨어
                요소 작품의 지식재산권을 침해하는 모든 행위</span><span style="font-family:'Times New Roman'">, </span><span
                style="font-family:宋体">또는 회사 또는 기타 이용자의 합법적인 권익에 손해를 끼치는 행위를 진행하는 행위</span><span
                style="font-family:'Times New Roman'">. </span><span style="font-family:宋体">회사는 이용자가 이러한 행위를 행하는 것을
                금지하여야 하며 기술상 조치를 취하여 이용자가 이러한 행위에 종사하는 것을 방지할 수 있음</span><span
                style="font-family:'Times New Roman'">.</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">&#xa0;</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">8) </span><span style="font-family:宋体">회사 및</span><span
                style="font-family:'Times New Roman'">/</span><span style="font-family:宋体">또는 제</span><span
                style="font-family:'Times New Roman'">3</span><span style="font-family:宋体">자에 대한 욕설</span><span
                style="font-family:'Times New Roman'">, </span><span style="font-family:宋体">저주</span><span
                style="font-family:'Times New Roman'">, </span><span style="font-family:宋体">모욕</span><span
                style="font-family:'Times New Roman'">, </span><span style="font-family:宋体">공격</span><span
                style="font-family:'Times New Roman'">, </span><span style="font-family:宋体">비방이 포함되는 내용의 공유</span><span
                style="font-family:'Times New Roman'">, </span><span style="font-family:宋体">전송</span><span
                style="font-family:'Times New Roman'">; </span><span style="font-family:宋体">미신</span><span
                style="font-family:'Times New Roman'">, </span><span style="font-family:宋体">음란</span><span
                style="font-family:'Times New Roman'">, </span><span style="font-family:宋体">외설</span><span
                style="font-family:'Times New Roman'">, </span><span style="font-family:宋体">저질</span><span
                style="font-family:'Times New Roman'">, </span><span style="font-family:宋体">공포</span><span
                style="font-family:'Times New Roman'">, </span><span style="font-family:宋体">폭력</span><span
                style="font-family:'Times New Roman'">, </span><span style="font-family:宋体">흉악</span><span
                style="font-family:'Times New Roman'">, </span><span style="font-family:宋体">도박</span><span
                style="font-family:'Times New Roman'">, </span><span style="font-family:宋体">반란</span><span
                style="font-family:'Times New Roman'">, </span><span style="font-family:宋体">민족혐오</span><span
                style="font-family:'Times New Roman'">, </span><span style="font-family:宋体">국가통일방해</span><span
                style="font-family:'Times New Roman'">, </span><span style="font-family:宋体">정권전복 등 불만</span><span
                style="font-family:'Times New Roman'">·</span><span style="font-family:宋体">혐오한 언론의 함유</span><span
                style="font-family:'Times New Roman'">; </span><span style="font-family:宋体">위 내용들이 들어 있는
                사이트명칭</span><span style="font-family:'Times New Roman'">, </span><span style="font-family:宋体">게임 캐릭터
                이름</span><span style="font-family:'Times New Roman'">(</span><span style="font-family:宋体">재물성 도박 등 사행행위에
                대한 권유</span><span style="font-family:'Times New Roman'">, </span><span
                style="font-family:宋体">참여</span><span style="font-family:'Times New Roman'">, </span><span
                style="font-family:宋体">또는 상대방에게 수치심</span><span style="font-family:'Times New Roman'">, </span><span
                style="font-family:宋体">혐오감</span><span style="font-family:'Times New Roman'">, </span><span
                style="font-family:宋体">공포심을 느끼게 하는 언행</span><span style="font-family:'Times New Roman'">, </span><span
                style="font-family:宋体">음향</span><span style="font-family:'Times New Roman'">, </span><span
                style="font-family:宋体">글</span><span style="font-family:'Times New Roman'">, </span><span
                style="font-family:宋体">화상</span><span style="font-family:'Times New Roman'">, </span><span
                style="font-family:宋体">영상의 전송</span><span style="font-family:'Times New Roman'">, </span><span
                style="font-family:宋体">공유</span><span style="font-family:'Times New Roman'">, </span><span
                style="font-family:宋体">배포행위 포함</span><span style="font-family:'Times New Roman'">)</span><span
                style="font-family:宋体">의 설치</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">&#xa0;</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">9) </span><span style="font-family:宋体">게임 데이터</span><span
                style="font-family:'Times New Roman'">(</span><span style="font-family:宋体">계정</span><span
                style="font-family:'Times New Roman'">, </span><span style="font-family:宋体">캐릭터</span><span
                style="font-family:'Times New Roman'">, </span><span style="font-family:宋体">게임아이템 등</span><span
                style="font-family:'Times New Roman'">)</span><span style="font-family:宋体">의 유상 거래</span><span
                style="font-family:'Times New Roman'">, </span><span style="font-family:宋体">또는 권리의 객체에 대한 담보</span><span
                style="font-family:'Times New Roman'">, </span><span style="font-family:宋体">대여 등을 제공하는 행위</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">&#xa0;</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">10) </span><span style="font-family:宋体">게임 데이터</span><span
                style="font-family:'Times New Roman'">(</span><span style="font-family:宋体">계정</span><span
                style="font-family:'Times New Roman'">, </span><span style="font-family:宋体">캐릭터</span><span
                style="font-family:'Times New Roman'">, </span><span style="font-family:宋体">게임아이템 등</span><span
                style="font-family:'Times New Roman'">)</span><span style="font-family:宋体">의 유상 거래를 공개적으로 광고 선전하고 참여하거나
                또는 권리의 객체에 대한 담보</span><span style="font-family:'Times New Roman'">, </span><span
                style="font-family:宋体">대여 등을 제공하는 행위</span><span style="font-family:'Times New Roman'">(</span><span
                style="font-family:宋体">기타 이용자의 캐릭터를 불법 사용하는 행위 포함</span><span
                style="font-family:'Times New Roman'">)</span><span style="font-family:'Times New Roman'">&#xa0;</span>
        </p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">&#xa0;</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">11) </span><span style="font-family:宋体">회사의 승낙 없이 광고를 발표하고 상품을
                판매하는 상업 행위를 진행하거나 불법적으로 회사 이익을 침해하는 여하한 행위를 진행</span><span style="font-family:'Times New Roman'">,
            </span><span style="font-family:宋体">또는 회사 서비스 운영을 고의로 방해하거나 서비스의 안정적 운영을 방해할 수 있는 정보 및 수신자의 명시적인 수신 거부 의사에
                반하여 광고성 정보를 전송</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">&#xa0;</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">12) </span><span style="font-family:宋体">회사의 사전 승낙 없이 회사의 서비스 또는
                서비스를 이용하여 얻은 정보를 복제</span><span style="font-family:'Times New Roman'">, </span><span
                style="font-family:宋体">유통</span><span style="font-family:'Times New Roman'">, </span><span
                style="font-family:宋体">조장하거나 상업적으로 이용</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">&#xa0;</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">13) </span><span style="font-family:宋体">자기 또는 타인의 재산적 이익을 위한 회사
                서비스의 이용 행위</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">&#xa0;</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">14) </span><span style="font-family:宋体">타인의 명예를 훼손하거나 손해를 가하는
                행위</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">&#xa0;</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">15) </span><span style="font-family:宋体">명의자의 동의나 승낙 없이 결제 수단을 무단
                도용하여 서비스 이용 요금을 결제</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">&#xa0;</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">16) </span><span style="font-family:宋体">회사의 지식재산권</span><span
                style="font-family:'Times New Roman'">, </span><span style="font-family:宋体">제</span><span
                style="font-family:'Times New Roman'">3</span><span style="font-family:宋体">자의 지식재산권</span><span
                style="font-family:'Times New Roman'">, </span><span style="font-family:宋体">초상권 등 기타 권리의 침해</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">&#xa0;</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">17) </span><span style="font-family:宋体">프로그램의 버그를 악용하거나 서비스와 관련된
                설비의 오작동이나 정보 등의 파괴 및 혼란을 유발하는 컴퓨터바이러스 감염자료를 등록 또는 유포</span><span style="font-family:'Times New Roman'">,
            </span><span style="font-family:宋体">관련 법령에 의하여 그 전송 또는 게시가 금지되는 정보</span><span
                style="font-family:'Times New Roman'">(</span><span style="font-family:宋体">컴퓨터프로그램</span><span
                style="font-family:'Times New Roman'">) </span><span style="font-family:宋体">또는 컴퓨터소프트웨어</span><span
                style="font-family:'Times New Roman'">, </span><span style="font-family:宋体">하드웨어</span><span
                style="font-family:'Times New Roman'">, </span><span style="font-family:宋体">전기통신 장비의 정상적인 가동을
                방해</span><span style="font-family:'Times New Roman'">, </span><span style="font-family:宋体">파괴할 목적으로 고안된
                소프트웨어 바이러스</span><span style="font-family:'Times New Roman'">, </span><span style="font-family:宋体">다른
                컴퓨터 코드</span><span style="font-family:'Times New Roman'">, </span><span
                style="font-family:宋体">파일</span><span style="font-family:'Times New Roman'">, </span><span
                style="font-family:宋体">프로그램을 포함하고 있는 자료를 전송</span><span style="font-family:'Times New Roman'">,
            </span><span style="font-family:宋体">게시</span><span style="font-family:'Times New Roman'">, </span><span
                style="font-family:宋体">유포</span><span style="font-family:'Times New Roman'">, </span><span
                style="font-family:宋体">사용</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">&#xa0;</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">18) </span><span style="font-family:宋体">회사가 제공한 서비스 안에서나 홈페이지상에서
                이용자 계정을 현금 거래하는 행위</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">&#xa0;</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">19) </span><span style="font-family:宋体">결제와 관련된 모든 부정행위</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">&#xa0;</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">20) </span><span style="font-family:宋体">회사에서 제공하는 게임콘텐츠 사용법 외에 타인의
                정상적인 게임콘텐츠 이용을 방해 및 타인에게 손해를 가하는 행위</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">&#xa0;</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">21) </span><span style="font-family:宋体">기타 공공질서 및 미풍양속에 반하거나 반사회적
                행동</span><span style="font-family:'Times New Roman'">, </span><span
                style="font-family:宋体">불법</span><span style="font-family:'Times New Roman'">∙</span><span
                style="font-family:宋体">부당한 행위와 관련 법령에 위배하는 행위</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">&#xa0;</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">2. </span><span style="font-family:宋体">이용자는 약관 내용</span><span
                style="font-family:'Times New Roman'">, </span><span style="font-family:宋体">회사의 게임콘텐츠 등 관련 주의사항을 성실하게
                열람하고 회사가 공시한 통지와 공지들을 준수할 의무가 있으며 회사의 업무에 방해되는 행위를 하여서는 아니 됩니다</span><span
                style="font-family:'Times New Roman'">. </span><span style="font-family:宋体">회원은 수시로 관계 법령</span><span
                style="font-family:'Times New Roman'">, </span><span style="font-family:宋体">본 약관의 규정을 비롯하여 회사가 통지하는 사항
                등을 준수하여야 하며</span><span style="font-family:'Times New Roman'">, </span><span style="font-family:宋体">기타
                회사의 업무에 방해되는 행위를 하여서는 아니 됩니다</span><span style="font-family:'Times New Roman'">. </span><span
                style="font-family:宋体">이용자는 홈페이지의 공지사항 및 게임운영정책 사항을 수시로 확인하여야 합니다</span><span
                style="font-family:'Times New Roman'">.</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">&#xa0;</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">3. </span><span style="font-family:宋体">회사는 다음 각 호의 어느 하나에 해당하는
                게임내용이나 서비스 사항에 대하여 일정한 한도 내에서 제한을 둘 수 있으며</span><span style="font-family:'Times New Roman'">,
            </span><span style="font-family:宋体">이용자는 이를 충분히 이해하고 관련 규정을 준수하여야 합니다</span><span
                style="font-family:'Times New Roman'">.</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">&#xa0;</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">1) </span><span style="font-family:宋体">이용자의 계정명</span><span
                style="font-family:'Times New Roman'">, </span><span style="font-family:宋体">캐릭터명</span><span
                style="font-family:'Times New Roman'">,</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span style="font-family:微软雅黑">연맹명</span><span
                style="font-family:'Times New Roman'">, </span><span style="font-family:宋体">그룹명칭에 대한 제한</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">&#xa0;</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">2) </span><span style="font-family:宋体">채팅 내용과 방법에 대한 제한</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">&#xa0;</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">3) </span><span style="font-family:宋体">게시물 내용에 대한 일정한 제한</span>
        </p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">&#xa0;</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">4) </span><span style="font-family:宋体">게임플레이방법에 대한 제한</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">&#xa0;</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">5) </span><span style="font-family:宋体">기타 이용자의 게임콘텐츠 이용에 대한 합리적
                권리를 침해하지 않는 범위 내에서 회사가 게임콘텐츠 운영상 필요하다고 인정되는 제한</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">&#xa0;</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">4. </span><span style="font-family:宋体">이용자는 본 서비스를 이용하기 위하여 자신의
                개인정보를 적절히 관리하여야 합니다</span><span style="font-family:'Times New Roman'">. </span><span
                style="font-family:宋体">개인정보에 변경이 발생할 경우 상응한 변경 처리를 해야 합니다</span><span
                style="font-family:'Times New Roman'">. </span><span style="font-family:宋体">이용자의 개인정보 변경이 지연되거나 누락되어
                발생하는 손실은 이용자가 부담합니다</span><span style="font-family:'Times New Roman'">. </span><span
                style="font-family:宋体">이용자의 주소</span><span style="font-family:'Times New Roman'">, </span><span
                style="font-family:宋体">연락처</span><span style="font-family:'Times New Roman'">, </span><span
                style="font-family:宋体">전자우편 등 이용계약 사항에 변경이 발생할 경우 관련 절차를 통해 회사에 즉시 고지하여야 합니다</span><span
                style="font-family:'Times New Roman'">. </span><span style="font-family:宋体">이용자가 제공한 가입정보 및 업데이트한 가입정보가
                정확하지 않을 경우 및 회원이 본조 제</span><span style="font-family:'Times New Roman'">1</span><span
                style="font-family:宋体">항에 명시된 행위를 행할 경우 회사는 본 약관에 근거하여 회원의 서비스이용을</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span
                style="font-family:'Malgun Gothic'">중단</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span style="font-family:微软雅黑">또는</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span
                style="font-family:'Malgun Gothic'">종료</span><span style="font-family:微软雅黑">할</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span style="font-family:微软雅黑">수</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span style="font-family:微软雅黑">있습니다</span><span
                style="font-family:'Times New Roman'">.</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">&#xa0;</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">5. </span><span style="font-family:宋体">이용자는 콘텐츠를 다운로드 받은 디바이스에 대해
                책임을 져야 하며 보관 및 관리를 잘하여 타인이 이용자의 승낙 없이 서비스를 이용하거나 온라인 게임콘텐츠를 이용하는 것을 방지하여야 합니다</span><span
                style="font-family:'Times New Roman'">.</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">&#xa0;</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">6. </span><span style="font-family:宋体">이용자는 회사에서 공식적으로 인정한 경우를
                제외하고는 서비스를 이용하여 상품을 판매하는 등의 영업활동을 할 수 없고</span><span style="font-family:'Times New Roman'">,
            </span><span style="font-family:宋体">서비스를 통해 취득한 아이템 및 </span><span style="font-family:'Times New Roman'">ID
            </span><span style="font-family:宋体">등을 거래에 제공하거나 제공받을 수 없고</span><span
                style="font-family:'Times New Roman'">, </span><span style="font-family:宋体">해킹</span><span
                style="font-family:'Times New Roman'">, </span><span style="font-family:宋体">광고로부터 수익취득</span><span
                style="font-family:'Times New Roman'">, </span><span style="font-family:宋体">상용소프트웨어 불법배포 등의 행위를 할 수
                없으며</span><span style="font-family:'Times New Roman'">, </span><span style="font-family:宋体">그와 같은 행위를
                준비하거나 홍보할 수 없습니다</span><span style="font-family:'Times New Roman'">. </span><span
                style="font-family:宋体">이를 위반하여 발생한 영업 활동의 결과 및 손실</span><span style="font-family:'Times New Roman'">,
            </span><span style="font-family:宋体">관계기관에 의한 구속 등 법적 조치 등에 관해서는 전적으로 이용자의 책임으로 하며 회사는 고의 또는 중과실이 없는 한 이에 대해
                일체의 책임을 지지 않습니다</span><span style="font-family:'Times New Roman'">. </span><span
                style="font-family:宋体">만약 이용자의 이와 같은 행위와 관련하여 회사에 손해가 발생한 경우 이용자는 일체의 손해배상 책임을 부담합니다</span><span
                style="font-family:'Times New Roman'">.</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span
                style="font-family:'Times New Roman'">&#xa0;</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">&#xa0;</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">7. </span><span style="font-family:宋体">회사는 본 서비스 등을 유지하기 위하여 광고를
                게재할 수 있으며</span><span style="font-family:'Times New Roman'">, </span><span style="font-family:宋体">이용자는
                서비스 이용 시 노출되는 광고 게재에 대하여 동의합니다</span><span style="font-family:'Times New Roman'">.</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">&#xa0;</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">1) </span><span style="font-family:宋体">회사가 제공하는 제</span><span
                style="font-family:'Times New Roman'">3</span><span style="font-family:宋体">자가 주체인 광고에 이용자가 참여하거나 교신 또는
                거래함으로써 발생하는 손실과 손해에 대해서 회사는 어떠한 책임도 부담하지 않습니다</span><span
                style="font-family:'Times New Roman'">.</span><span style="font-family:'Times New Roman'">&#xa0;</span>
        </p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">&#xa0;</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">2) </span><span style="font-family:宋体">회사는 서비스 개선 및 이용자 대상 서비스 소개
                등을 위한 목적으로 이용자 개인에 대한 추가정보를 요구할 수 있으며</span><span style="font-family:'Times New Roman'">, </span><span
                style="font-family:宋体">동 요청에 대해 이용자는 승낙하여 추가정보를 제공하거나 이를 거부할 수 있습니다</span><span
                style="font-family:'Times New Roman'">.</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">&#xa0;</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">3) </span><span style="font-family:宋体">회사는 이용자의 사전 동의 하에 이용자로부터
                수집한 개인정보를 활용하는 경우 </span><span style="font-family:'Times New Roman'">SMS(LMS), </span><span
                style="font-family:宋体">스마트폰 알림</span><span style="font-family:'Times New Roman'">(Push</span><span
                style="font-family:宋体">알림</span><span style="font-family:'Times New Roman'">), </span><span
                style="font-family:宋体">전자우편을 활용하여 발송할 수 있으며</span><span style="font-family:'Times New Roman'">,
            </span><span style="font-family:宋体">이용자는 원하지 않는 경우 언제든지 수신을 거부할 수 있습니다</span><span
                style="font-family:'Times New Roman'">.</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">&#xa0;</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">8. </span><span style="font-family:宋体">이용자가 게임 운영정책사항에 위반되는 행위를
                하였을 때 회사는 이용자에게 게임 이용제재 혹은 경우에 따라 법적 책임을 물을 수 있습니다</span><span
                style="font-family:'Times New Roman'">.</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">&#xa0;</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">&#xa0;</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">&#xa0;</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:微软雅黑">제</span><span style="font-family:'Times New Roman'">4</span><span
                style="font-family:宋体">장 게임콘텐츠 및 이용방법</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">&#xa0;</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">&#xa0;</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:微软雅黑">제</span><span style="font-family:'Times New Roman'">14</span><span
                style="font-family:宋体">조 게임콘텐츠의 변경</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">&#xa0;</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">1. </span><span style="font-family:宋体">이용자는 본 약관에 근거하여 회사로부터
                게임콘텐츠를 제공받을 수 있으며</span><span style="font-family:'Times New Roman'">, </span><span
                style="font-family:宋体">회사의 운영정책 및 회사가 설정한 게임규칙을 준수합니다</span><span
                style="font-family:'Times New Roman'">.</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">&#xa0;</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">1) </span><span style="font-family:宋体">이용자는 이동통신사의
                무선인터넷</span><span style="font-family:'Times New Roman'">, </span><span style="font-family:宋体">오픈마켓
                스토어</span><span style="font-family:'Times New Roman'">, </span><span style="font-family:宋体">애플리케이션
                스토어</span><span style="font-family:'Times New Roman'">, </span><span style="font-family:宋体">온라인
                사이트</span><span style="font-family:'Times New Roman'">(</span><span
                style="font-family:宋体">포털</span><span style="font-family:'Times New Roman'">, </span><span
                style="font-family:宋体">모바일게임 사이트 또는 당사 홈페이지 등</span><span style="font-family:'Times New Roman'">)
            </span><span style="font-family:宋体">및 기타 채널을 통하여 회사가 제공하는 콘텐츠를 구매하거나 다운로드할 수 있습니다</span><span
                style="font-family:'Times New Roman'">.</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">&#xa0;</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">2) </span><span style="font-family:宋体">회사가 개발한 게임 타이틀은 회사가 거래하는
                유통업체 및 온라인 쇼핑몰 등을 통하여 구매할 수 있습니다</span><span style="font-family:'Times New Roman'">.</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">&#xa0;</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">3) </span><span style="font-family:宋体">회사가 제공하는 아이템 등은 온라인
                사이트</span><span style="font-family:'Times New Roman'">, </span><span style="font-family:宋体">게임 및 애플리케이션
                내에서 제공하는 네트워크 서비스를 통하여 구매할 수 있습니다</span><span style="font-family:'Times New Roman'">.</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">&#xa0;</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">4) </span><span style="font-family:宋体">이용자가 이동통신사의 무선인터넷 및 오픈마켓
                스토어</span><span style="font-family:'Times New Roman'">, </span><span style="font-family:宋体">애플리케이션 스토어를
                통하여 모바일 게임</span><span style="font-family:'Times New Roman'">, </span><span
                style="font-family:宋体">애플리케이션을 구매하거나 네트워크 서비스를 이용하는 경우 이동통신사에서 정하는 소정의 데이터 통화료가 부과될 수 있습니다</span><span
                style="font-family:'Times New Roman'">.</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">&#xa0;</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">2. </span><span style="font-family:宋体">회사가 게임을 통해 이용자에게 제공하는 게임세계는
                회사가 창조한 가상세계이며 회사가 게임콘텐츠의 제작</span><span style="font-family:'Times New Roman'">, </span><span
                style="font-family:宋体">변경</span><span style="font-family:'Times New Roman'">, </span><span
                style="font-family:宋体">유지보수</span><span style="font-family:'Times New Roman'">, </span><span
                style="font-family:宋体">수정에 대한 포괄적인 권한을 보유합니다</span><span style="font-family:'Times New Roman'">.</span>
        </p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">&#xa0;</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">3. </span><span style="font-family:宋体">회사는 현실세계로부터 게임세계를 보호하고
                게임세계의 질서와 게임성을 유지하기 위하여 필요한 조치를 취할 수 있습니다</span><span style="font-family:'Times New Roman'">.</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">&#xa0;</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">4. </span><span style="font-family:宋体">회사는 수시로 운영방식을 변경할 수 있는 권한을
                보유합니다</span><span style="font-family:'Times New Roman'">. </span><span
                style="font-family:宋体">즉</span><span style="font-family:'Times New Roman'">, </span><span
                style="font-family:宋体">요금부과기준</span><span style="font-family:'Times New Roman'">, </span><span
                style="font-family:宋体">유료 소프트웨어의 기능</span><span style="font-family:'Times New Roman'">, </span><span
                style="font-family:宋体">유료 대상 및 시간 등 내용을 변경할 수 있습니다 또한 회사는 게임콘텐츠 및 제공하는 서비스에 대하여 업그레이드</span><span
                style="font-family:'Times New Roman'">, </span><span style="font-family:宋体">버전변경</span><span
                style="font-family:'Times New Roman'">, </span><span style="font-family:宋体">증가</span><span
                style="font-family:'Times New Roman'">, </span><span style="font-family:宋体">삭제</span><span
                style="font-family:'Times New Roman'">, </span><span style="font-family:宋体">수정하거나 기능변경이나 게임규칙을 변경하는 등 관련
                권한을 보유합니다</span><span style="font-family:'Times New Roman'">. </span><span style="font-family:宋体">이러한
                내용의 변경을 하고자 하는 경우 회사는 이용자에게 본 약관 제</span><span style="font-family:'Times New Roman'">4</span><span
                style="font-family:宋体">조 제</span><span style="font-family:'Times New Roman'">5</span><span
                style="font-family:宋体">항</span><span style="font-family:'Times New Roman'">, </span><span
                style="font-family:宋体">제</span><span style="font-family:'Times New Roman'">6</span><span
                style="font-family:宋体">항의 방법에 따라 공지합니다</span><span style="font-family:'Times New Roman'">. </span><span
                style="font-family:宋体">이용자가 관련 변경에 동의할 수 없는 경우 게임콘텐츠 에 대한 이용을 즉시</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span
                style="font-family:'Malgun Gothic'">종료</span><span style="font-family:微软雅黑">하여야</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span style="font-family:微软雅黑">합니다</span><span
                style="font-family:'Times New Roman'">. </span><span style="font-family:宋体">계속적 이용행위는 이용자가 개정된 운영방식에 대하여
                동의한 것으로 간주합니다</span><span style="font-family:'Times New Roman'">.</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">&#xa0;</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">&#xa0;</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">&#xa0;</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:微软雅黑">제</span><span style="font-family:'Times New Roman'">15</span><span
                style="font-family:宋体">조 서비스 중단 및 종료</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">&#xa0;</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">1. </span><span style="font-family:宋体">회사는 경영방침에 따라 이용자에게 충분한
                게임시간을 제공하여야 합니다</span><span style="font-family:'Times New Roman'">. </span><span
                style="font-family:宋体">게임 서비스 일정은 게임 초기화면이나 게임 홈페이지</span><span
                style="font-family:'Times New Roman'">(https://www.domain.com/)</span><span style="font-family:宋体">에서
                공지합니다</span><span style="font-family:'Times New Roman'">. </span><span style="font-family:宋体">회사는 운영상 또는
                기술상의 필요에 따라 제공하고 있는 서비스를 변경할 수 있습니다</span><span style="font-family:'Times New Roman'">. </span><span
                style="font-family:宋体">변경될 서비스의 내용 및 변경 실시 일자 등에 대해서는 이용자에게 사전에 통지합니다</span><span
                style="font-family:'Times New Roman'">. </span><span style="font-family:宋体">단</span><span
                style="font-family:'Times New Roman'">, </span><span style="font-family:宋体">회사가 사전에 통지할 수 없는 치명적인 고장
                발생</span><span style="font-family:'Times New Roman'">, </span><span style="font-family:宋体">서버
                기기결함</span><span style="font-family:'Times New Roman'">, </span><span style="font-family:宋体">긴급 보안 문제 해결
                등의 부득이한 사정이 있는 경우는 사후에 통지할 수 있습니다</span><span style="font-family:'Times New Roman'">.</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">&#xa0;</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">2. </span><span style="font-family:宋体">회사는 다음 각 호의 어느 하나에 해당하는 운영상
                필요에 따라 게임콘텐츠를</span><span style="font-family:'Times New Roman'">&#xa0;</span><span
                style="font-family:'Malgun Gothic'">중단</span><span style="font-family:微软雅黑">하고</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span style="font-family:微软雅黑">보수를</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span style="font-family:微软雅黑">진행할</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span style="font-family:微软雅黑">수</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span style="font-family:微软雅黑">있으며</span><span
                style="font-family:'Times New Roman'">,</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span
                style="font-family:'Malgun Gothic'">중단</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span style="font-family:微软雅黑">기간</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span style="font-family:微软雅黑">동안</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span style="font-family:微软雅黑">이용자에게</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span style="font-family:微软雅黑">발생한</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span style="font-family:微软雅黑">손실에</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span style="font-family:微软雅黑">대하여</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span style="font-family:微软雅黑">배상할</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span style="font-family:微软雅黑">의무는</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span style="font-family:微软雅黑">없습니다</span><span
                style="font-family:'Times New Roman'">.</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">&#xa0;</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">1) </span><span style="font-family:宋体">회사의 컴퓨터 등 설비의
                보수점검</span><span style="font-family:'Times New Roman'">, </span><span
                style="font-family:宋体">교체</span><span style="font-family:'Times New Roman'">, </span><span
                style="font-family:宋体">정기점검 또는 게임콘텐츠의 수정 및 기타 필요한 경우</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">&#xa0;</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">2) </span><span style="font-family:宋体">회사가 게임 상품 중 이용자가 버그 또는 패치를
                사용하는 행위를 효과적으로 억제하기 위하여 서비스 중단 유지보수 또는 복구 등 처리조치를 채택할 수 있습니다</span><span
                style="font-family:'Times New Roman'">. </span><span style="font-family:宋体">서비스 중단 유지보수 기간 동안 이용자는 게임
                상품의 일부 게임서버 및</span><span style="font-family:'Times New Roman'">/</span><span style="font-family:宋体">또는
                일부 게임 구역에 접속할 수 없을 수도 있습니다</span><span style="font-family:'Times New Roman'">. </span><span
                style="font-family:宋体">복구라 함은 모든 이용자의 게임 계정상의 게임 데이터를 어느 한 시점에서의 기록에서 이전의 다른 한 시점의 기록으로 돌려 놓는 것을 말하며 이로
                인해 이용자가 이 기간 동안 정상적인 게임 행위를 통해 획득한 게임도구</span><span style="font-family:'Times New Roman'">, </span><span
                style="font-family:宋体">게임아이템 등 게임물품의 등급</span><span style="font-family:'Times New Roman'">, </span><span
                style="font-family:宋体">포인트</span><span style="font-family:'Times New Roman'">, </span><span
                style="font-family:宋体">명예 등이 영구적으로 상실되거나 또는 기타 손실을 초래할 수 있습니다</span><span
                style="font-family:'Times New Roman'">.</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span style="font-family:'Times New Roman'">
            </span><span style="font-family:宋体">이에 대해 이용자는 충분히 숙지하고 자체적으로 책임을 부담하여야 하며</span><span
                style="font-family:'Times New Roman'">, </span><span style="font-family:宋体">회사는 어떠한 배상도 하지
                않습니다</span><span style="font-family:'Times New Roman'">.</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">&#xa0;</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">3) </span><span style="font-family:宋体">회사는 재량에 따라 본 약관 및 본 약관에 따른
                권리를 수시로</span><span style="font-family:'Times New Roman'">&#xa0;</span><span
                style="font-family:'Malgun Gothic'">중단</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span style="font-family:微软雅黑">또는</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span style="font-family:微软雅黑">종료할</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span style="font-family:微软雅黑">수</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span style="font-family:微软雅黑">있습니다</span><span
                style="font-family:'Times New Roman'">. </span><span style="font-family:宋体">이러한</span><span
                style="font-family:'Malgun Gothic'">중단</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span
                style="font-family:'Malgun Gothic'">혹은</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span style="font-family:微软雅黑">종료는</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span style="font-family:微软雅黑">회사의</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span style="font-family:微软雅黑">해산</span><span
                style="font-family:'Times New Roman'">, </span><span style="font-family:宋体">말소</span><span
                style="font-family:'Times New Roman'">, </span><span style="font-family:宋体">합병</span><span
                style="font-family:'Times New Roman'">, </span><span style="font-family:宋体">분할 또는 회사의 게임상품이나 그의 운영권한을
                제</span><span style="font-family:'Times New Roman'">3</span><span style="font-family:宋体">자에게 양도함으로써 초래될
                수 있으며</span><span style="font-family:'Times New Roman'">, </span><span style="font-family:宋体">또한
                법령</span><span style="font-family:'Times New Roman'">, </span><span
                style="font-family:宋体">정책</span><span style="font-family:'Times New Roman'">, </span><span
                style="font-family:宋体">국가기관의 명령 또는 지진</span><span style="font-family:'Times New Roman'">, </span><span
                style="font-family:宋体">화재</span><span style="font-family:'Times New Roman'">, </span><span
                style="font-family:宋体">태풍</span><span style="font-family:'Times New Roman'">, </span><span
                style="font-family:宋体">파업</span><span style="font-family:'Times New Roman'">, </span><span
                style="font-family:宋体">전쟁 등 불가항력 사유로 인하여 발생할 수도 있습니다</span><span style="font-family:'Times New Roman'">.
            </span><span style="font-family:宋体">그리고 위 사유 이외의 기타 원인도</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span
                style="font-family:'Malgun Gothic'">중단이나</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span style="font-family:微软雅黑">종료를</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span style="font-family:微软雅黑">초래할</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span style="font-family:微软雅黑">수</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span style="font-family:微软雅黑">있습니다</span><span
                style="font-family:'Times New Roman'">.</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">&#xa0;</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">3. </span><span style="font-family:宋体">회사가 매 주 또는 격주에 한번씩 게임콘텐츠를
                중단하여 보수를 진행해야 하면</span><span style="font-family:'Times New Roman'">, </span><span
                style="font-family:宋体">회사는 최소한 </span><span style="font-family:'Times New Roman'">24</span><span
                style="font-family:宋体">시간 이전에 게임 초기화면이나 게임 홈페이지에서 서비스 중단을 고지합니다</span><span
                style="font-family:'Times New Roman'">.</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">&#xa0;</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">4. </span><span style="font-family:宋体">만약 부득이한 사유로 회사가 이용자에게
                서비스</span><span style="font-family:'Times New Roman'">&#xa0;</span><span
                style="font-family:'Malgun Gothic'">중단</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span style="font-family:微软雅黑">등에</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span style="font-family:微软雅黑">관한</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span style="font-family:微软雅黑">사항을</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span style="font-family:微软雅黑">사전</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span style="font-family:微软雅黑">고지</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span style="font-family:微软雅黑">하지</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span style="font-family:微软雅黑">못한</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span style="font-family:微软雅黑">경우</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span style="font-family:微软雅黑">빠른</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span style="font-family:微软雅黑">시일</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span style="font-family:微软雅黑">내에</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span style="font-family:微软雅黑">게임</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span style="font-family:微软雅黑">초기화면</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span style="font-family:微软雅黑">및</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span style="font-family:微软雅黑">게임</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span style="font-family:微软雅黑">홈페이지의</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span style="font-family:微软雅黑">첫</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span style="font-family:微软雅黑">페이지에서</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span style="font-family:微软雅黑">서비스</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span style="font-family:微软雅黑">중단</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span style="font-family:微软雅黑">유지보수에</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span style="font-family:微软雅黑">관한</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span style="font-family:微软雅黑">통지를</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span style="font-family:微软雅黑">사후</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span style="font-family:微软雅黑">고지할</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span style="font-family:微软雅黑">수</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span style="font-family:微软雅黑">있습니다</span><span
                style="font-family:'Times New Roman'">.</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">&#xa0;</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">5. </span><span style="font-family:宋体">이용자가 회사가 제공하는 무료 상품 또는 서비스를
                이용함으로써 손실을 받게 된 경우</span><span style="font-family:'Times New Roman'">, </span><span
                style="font-family:宋体">회사의 고의 또는 중과실이 없는 한 회사는 이에 대한 책임을 부담하지 않습니다</span><span
                style="font-family:'Times New Roman'">.</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">&#xa0;</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">6. </span><span style="font-family:宋体">회사는 제</span><span
                style="font-family:'Times New Roman'">2</span><span style="font-family:宋体">항 제</span><span
                style="font-family:'Times New Roman'">3</span><span style="font-family:宋体">호에 의하여 게임</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span
                style="font-family:'Malgun Gothic'">서비스</span><span style="font-family:微软雅黑">를</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span
                style="font-family:'Malgun Gothic'">종료</span><span style="font-family:微软雅黑">할</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span style="font-family:微软雅黑">경우</span><span
                style="font-family:'Times New Roman'">, 30</span><span style="font-family:宋体">일 전에 홈페이지에서 서비스 중단고지를
                공지하여야 합니다</span><span style="font-family:'Times New Roman'">. </span><span style="font-family:宋体">부득이한
                상황으로 적시에 공지하지 못하였을 경우 사후에 다시 공지할 수 있습니다</span><span style="font-family:'Times New Roman'">.</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">&#xa0;</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">7. </span><span style="font-family:宋体">회사가 제</span><span
                style="font-family:'Times New Roman'">2</span><span style="font-family:宋体">항에 의하여 게임</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span
                style="font-family:'Malgun Gothic'">서비스를</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span
                style="font-family:'Malgun Gothic'">종료하는</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span style="font-family:微软雅黑">경우</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span
                style="font-family:'Malgun Gothic'">환불</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span
                style="font-family:'Malgun Gothic'">및</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span
                style="font-family:'Malgun Gothic'">손해</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span
                style="font-family:'Malgun Gothic'">배상은</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span
                style="font-family:'Malgun Gothic'">「콘텐츠이용자</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span
                style="font-family:'Malgun Gothic'">보호지침」에</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span
                style="font-family:'Malgun Gothic'">따라</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span style="font-family:'Malgun Gothic'">처리되며, 이용자는
                무료 서비스, 잔여 사용 기간이 없는 유료 서비스, 연속 유료 사용 항목 또는 정기 유료 항목을 신청할 수 없습니다.</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">&#xa0;</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">8. </span><span style="font-family:宋体">게임</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span
                style="font-family:'Malgun Gothic'">서비스를</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span style="font-family:微软雅黑">종료하는</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span style="font-family:微软雅黑">경우</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span
                style="font-family:'Malgun Gothic'">사용</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span
                style="font-family:'Malgun Gothic'">기간에</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span
                style="font-family:'Malgun Gothic'">제한이</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span
                style="font-family:'Malgun Gothic'">없는</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span
                style="font-family:'Malgun Gothic'">유료</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span
                style="font-family:'Malgun Gothic'">항목의</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span
                style="font-family:'Malgun Gothic'">사용</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span
                style="font-family:'Malgun Gothic'">기한은</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span
                style="font-family:'Malgun Gothic'">고지된</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span
                style="font-family:'Malgun Gothic'">서비스</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span
                style="font-family:'Malgun Gothic'">종료</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span
                style="font-family:'Malgun Gothic'">시간에</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span
                style="font-family:'Malgun Gothic'">따라</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span
                style="font-family:'Malgun Gothic'">종료됩니다.</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">&#xa0;</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">9. </span><span style="font-family:宋体">회사는 서비스의 변경 및</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span
                style="font-family:'Malgun Gothic'">중단으</span><span style="font-family:微软雅黑">로</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span style="font-family:微软雅黑">발생하는</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span style="font-family:微软雅黑">문제에</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span style="font-family:微软雅黑">대해서는</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span style="font-family:微软雅黑">책임을</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span style="font-family:微软雅黑">지지</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span style="font-family:微软雅黑">않습니다</span><span
                style="font-family:'Times New Roman'">.</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">&#xa0;</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">&#xa0;</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:微软雅黑">제</span><span style="font-family:'Times New Roman'">16</span><span
                style="font-family:宋体">조 정보제공</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">&#xa0;</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:微软雅黑">회사는</span><span style="font-family:'Times New Roman'">&#xa0;</span><span
                style="font-family:微软雅黑">게임</span><span style="font-family:'Times New Roman'">&#xa0;</span><span
                style="font-family:微软雅黑">홈페이지에서</span><span style="font-family:'Times New Roman'">&#xa0;</span><span
                style="font-family:微软雅黑">이용자에게</span><span style="font-family:'Times New Roman'">&#xa0;</span><span
                style="font-family:微软雅黑">아래의</span><span style="font-family:'Times New Roman'">&#xa0;</span><span
                style="font-family:微软雅黑">정보를</span><span style="font-family:'Times New Roman'">&#xa0;</span><span
                style="font-family:微软雅黑">제공하여야</span><span style="font-family:'Times New Roman'">&#xa0;</span><span
                style="font-family:微软雅黑">합니다</span><span style="font-family:'Times New Roman'">.</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">&#xa0;</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">1. </span><span style="font-family:宋体">상호</span><span
                style="font-family:'Times New Roman'">:</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">&#xa0;</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">2. </span><span style="font-family:宋体">게임물 명칭</span><span
                style="font-family:'Times New Roman'">:</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">&#xa0;</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">3. </span><span style="font-family:宋体">이용등급</span><span
                style="font-family:'Times New Roman'">:</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">&#xa0;</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">4. </span><span style="font-family:宋体">등급분류번호</span><span
                style="font-family:'Times New Roman'">:</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">&#xa0;</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">5. </span><span style="font-family:宋体">제작연월일</span><span
                style="font-family:'Times New Roman'">:</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">&#xa0;</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">6. </span><span style="font-family:宋体">게임물제작업체 또는 배급업자의 신고번호 또는
                등기번호</span><span style="font-family:'Times New Roman'">:</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">&#xa0;</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">7. </span><span style="font-family:宋体">기타 회사가 필요하다고 인정하는
                사항</span><span style="font-family:'Times New Roman'">:</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">&#xa0;</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">&#xa0;</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">&#xa0;</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:微软雅黑">제</span><span style="font-family:'Times New Roman'">17</span><span
                style="font-family:宋体">조 정보의 수집</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">&#xa0;</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">1. </span><span style="font-family:宋体">회사는 이용자의 게임 내에서의 채팅내용을 보관할
                수 있습니다</span><span style="font-family:'Times New Roman'">. </span><span style="font-family:宋体">회사는 이용자간의
                분쟁 조정</span><span style="font-family:'Times New Roman'">, </span><span style="font-family:宋体">민원 처리 또는
                게임 질서의 유지를 위하여 회사가 유사한 분쟁 처리에 협조가 필요하다고 판단하는 경우에 관련 이용자의 정보를 열람할 수 있고</span><span
                style="font-family:'Times New Roman'">, </span><span style="font-family:宋体">사전에 열람사유 및 열람범위를 이용자에게
                고지합니다</span><span style="font-family:'Times New Roman'">. </span><span style="font-family:宋体">열람한 내용에
                대하여 엄격한 비밀유지의무를 준수하여야 하며</span><span style="font-family:'Times New Roman'">, </span><span
                style="font-family:宋体">권한을 부여 받지 아니한 제</span><span style="font-family:'Times New Roman'">3</span><span
                style="font-family:宋体">자는 절대로 열람할 수 없습니다</span><span style="font-family:'Times New Roman'">.
            </span><span style="font-family:宋体">계정 도용</span><span style="font-family:'Times New Roman'">, </span><span
                style="font-family:宋体">현금거래</span><span style="font-family:'Times New Roman'">, </span><span
                style="font-family:宋体">언행폭력</span><span style="font-family:'Times New Roman'">, </span><span
                style="font-family:宋体">게임사기 등 행위와 연관될 경우 회사는 이용자에게 사전 고지 없이 열람 할 수 있으며</span><span
                style="font-family:'Times New Roman'">, </span><span style="font-family:宋体">사후에 다시 이용자에게 관련 결정 및 사유를
                통지합니다</span><span style="font-family:'Times New Roman'">.</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">&#xa0;</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">2. </span><span style="font-family:宋体">회사는 이용자의 디바이스 정보를 수집할 수
                있으며</span><span style="font-family:'Times New Roman'">, </span><span style="font-family:宋体">게임콘텐츠 개선을 위해
                프로그램 최적화를 통해 게임콘텐츠 품질을 보증합니다</span><span style="font-family:'Times New Roman'">.</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">&#xa0;</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">&#xa0;</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:微软雅黑">제</span><span style="font-family:'Times New Roman'">18</span><span
                style="font-family:宋体">조 게임콘텐츠의 사용</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">&#xa0;</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">&#xa0;</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">&#xa0;</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">1. </span><span style="font-family:宋体">회사는 이용자에게 무료 게임콘텐츠와 유료
                게임콘텐츠를 제공할 수 있습니다</span><span style="font-family:'Times New Roman'">. </span><span
                style="font-family:宋体">이용자는 유료 게임콘텐츠를 자유로이 선택할 수 있습니다</span><span
                style="font-family:'Times New Roman'">.</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">&#xa0;</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">1) </span><span style="font-family:宋体">회사는 이용자에게 아이템을 포함한 게임콘텐츠를
                제공할 수 있습니다</span><span style="font-family:'Times New Roman'">. </span><span style="font-family:宋体">회사가
                제공한 게임콘텐츠는 회사의 정책에 따라서 이용자에게 이용기한을 정할 수 있으며</span><span style="font-family:'Times New Roman'">,
            </span><span style="font-family:宋体">이러한 이용기한은 각 게임콘텐츠 서비스 세부이용 지침에서 정하거나 각 게임콘텐츠 서비스 결제화면 등에 미리 게시하여 이용자에게
                고지합니다</span><span style="font-family:'Times New Roman'">.</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">&#xa0;</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">2) </span><span style="font-family:宋体">회사는 게임콘텐츠에 필요한 최소한의 기술사양에
                관한 정보를 서비스별 홈페이지 권장사양정보에서 제공하며</span><span style="font-family:'Times New Roman'">, </span><span
                style="font-family:宋体">이용자는 게임콘텐츠를 이용하기 위하여 서비스에 이용할 단말기 사양</span><span
                style="font-family:'Times New Roman'">, </span><span style="font-family:宋体">유무선 통신망의 품질 등이 해당 게임콘텐츠의 이용에
                적합한지를 사전에 확인하여야 합니다</span><span style="font-family:'Times New Roman'">.</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">&#xa0;</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">3) </span><span style="font-family:宋体">회사는 게임콘텐츠 중 회원에게 치장성아이템 및
                게임에 사용하는 아이템</span><span style="font-family:'Times New Roman'">(</span><span style="font-family:宋体">이하
            </span><span style="font-family:'Times New Roman'">'</span><span style="font-family:宋体">아이템</span><span
                style="font-family:'Times New Roman'">'</span><span style="font-family:宋体">이라 함</span><span
                style="font-family:'Times New Roman'">) </span><span style="font-family:宋体">서비스를 유료 또는 무료로 구분하여 제공할 수
                있으며 아이템 관련 정책은 다음을 따릅니다</span><span style="font-family:'Times New Roman'">.</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">&#xa0;</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">a. </span><span style="font-family:宋体">보증기간이 별도로 명시된 유료아이템의 경우는 구매
                시 명기한 보증기간을 따릅니다</span><span style="font-family:'Times New Roman'">. </span><span
                style="font-family:宋体">단</span><span style="font-family:'Times New Roman'">, </span><span
                style="font-family:宋体">회사가 이용자에게 지급한 무료아이템의 경우에는 서비스 제공 기간을 보증하지 않습니다</span><span
                style="font-family:'Times New Roman'">.</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">&#xa0;</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">b. </span><span style="font-family:宋体">보증기간이 </span><span
                style="font-family:'Times New Roman'">'</span><span style="font-family:宋体">영구</span><span
                style="font-family:'Times New Roman'">'</span><span style="font-family:宋体">로 표시된 유료아이템이나 보증기간이 표시되지 않은
                유료아이템</span><span style="font-family:'Times New Roman'">(</span><span style="font-family:宋体">이하
            </span><span style="font-family:'Times New Roman'">'</span><span style="font-family:宋体">영구아이템</span><span
                style="font-family:'Times New Roman'">'</span><span style="font-family:宋体">이라 함</span><span
                style="font-family:'Times New Roman'">)</span><span style="font-family:宋体">에 대한 사용은 게임콘텐츠가 정상적으로 제공되는 기간
                동안의 이용권을 보장하는 것이며</span><span style="font-family:'Times New Roman'">, </span><span
                style="font-family:宋体">만약 이용자가 이용 약관상 금지 행위를 하였거나 휴면 </span><span
                style="font-family:'Times New Roman'">ID </span><span style="font-family:宋体">또는 휴면 캐릭터로 분류되어 그에 따른 제재로서
                당해 </span><span style="font-family:'Times New Roman'">ID </span><span style="font-family:宋体">또는 캐릭터가
                이용제한 또는 삭제되는 경우</span><span style="font-family:'Times New Roman'">, </span><span
                style="font-family:宋体">영구아이템의 사용도 종료되며 회사는 이용자에 대하여 구매대금을 반환할 책임을 부담하지 아니합니다</span><span
                style="font-family:'Times New Roman'">.</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">&#xa0;</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">c. </span><span style="font-family:宋体">회사는 이용자의 부정한 이용을 방지하기 위하여
                타인으로부터 선물 받은 아이템이나 회사로부터 무료로 제공받은 아이템은 환불하지 않습니다</span><span
                style="font-family:'Times New Roman'">.</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">&#xa0;</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">d. </span><span style="font-family:宋体">회사는 아이템의 보증 기간에 회사의 게임 내용의
                변경 및 아이템 정책에 따라 기존 아이템의 기능 등을 변경하거나 사용할 수 없도록 변경할 수 있습니다</span><span
                style="font-family:'Times New Roman'">. </span><span style="font-family:宋体">이때</span><span
                style="font-family:'Times New Roman'">, </span><span style="font-family:宋体">유료로 구매한 아이템 사용이 불가능하게 되는
                경우에는 </span><span style="font-family:'Times New Roman'">30</span><span style="font-family:宋体">일 이상 홈페이지
                또는 관련 홈페이지에 공지하고 사용권이 남은 아이템을 유료로 구매한 이용자에 한해 기존 아이템의 잔여 기간을 산정한 뒤 등가의 신규 아이템 등으로 보상합니다</span><span
                style="font-family:'Times New Roman'">.</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">&#xa0;</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">4) </span><span style="font-family:宋体">회사가 제공하는 아이템을 포함한 콘텐츠의
                지식재산권을 포함한 모든 소유권은 회사에 있으며</span><span style="font-family:'Times New Roman'">, </span><span
                style="font-family:宋体">이용자는 회사가 제공하는 범위 내에서 서비스 이용권을 가집니다</span><span
                style="font-family:'Times New Roman'">. </span><span style="font-family:宋体">즉</span><span
                style="font-family:'Times New Roman'">, </span><span style="font-family:宋体">이용자는 회사가 제공하는 콘텐츠를 일정기간 동안
                회사가 제공하는 서비스 범위 내에서 이용할 권한을 갖는 것이며</span><span style="font-family:'Times New Roman'">, </span><span
                style="font-family:宋体">이를 회사가 정한 방법 이외의 방법으로 이용 또는 사용하거나 양도</span><span
                style="font-family:'Times New Roman'">, </span><span style="font-family:宋体">판매할 수 없습니다</span><span
                style="font-family:'Times New Roman'">.</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">&#xa0;</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">2. </span><span style="font-family:宋体">게임비용을 지불하는 가격과 지불방식은 회사에
                의하여 정합니다</span><span style="font-family:'Times New Roman'">. </span><span style="font-family:宋体">게임콘텐츠에
                대한 구매 대금은 원칙적으로 이동통신사와 애플리케이션 스토어</span><span style="font-family:'Times New Roman'">, </span><span
                style="font-family:宋体">온라인사이트에서 정하는 방법</span><span style="font-family:'Times New Roman'">, </span><span
                style="font-family:宋体">정책 등에 따라 부과되며</span><span style="font-family:'Times New Roman'">, </span><span
                style="font-family:宋体">납부 방법 역시 정해진 방법에 따라 납부하여야 합니다</span><span style="font-family:'Times New Roman'">.
            </span><span style="font-family:宋体">회사의 정책 및 결제업체</span><span
                style="font-family:'Times New Roman'">(</span><span style="font-family:宋体">이동통신사</span><span
                style="font-family:'Times New Roman'">, </span><span style="font-family:宋体">오픈마켓 스토어</span><span
                style="font-family:'Times New Roman'">, </span><span style="font-family:宋体">애플리케이션 스토어 등</span><span
                style="font-family:'Times New Roman'">)</span><span style="font-family:宋体">의 정책</span><span
                style="font-family:'Times New Roman'">, </span><span style="font-family:宋体">정부의 방침 등에 따라 각 결제 수단별로 결제
                한도가 부여될 수 있습니다</span><span style="font-family:'Times New Roman'">.</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">&#xa0;</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">3. </span><span style="font-family:宋体">이용자가 유료 게임콘텐츠를 선택할 경우에는 아래
                사항에 유의하여야 합니다</span><span style="font-family:'Times New Roman'">.</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">&#xa0;</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">1)</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span
                style="font-family:'Malgun Gothic'">이용자는</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span
                style="font-family:'Malgun Gothic'">게임콘텐츠</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span
                style="font-family:'Malgun Gothic'">비용을</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span
                style="font-family:'Malgun Gothic'">전액</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span
                style="font-family:'Malgun Gothic'">납부하여야</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span
                style="font-family:'Malgun Gothic'">합니다</span><span style="font-family:'Times New Roman'">.</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span
                style="font-family:'Malgun Gothic'">만약</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span
                style="font-family:'Malgun Gothic'">이용자가</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span
                style="font-family:'Malgun Gothic'">환불을</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span
                style="font-family:'Malgun Gothic'">요청하여</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span
                style="font-family:'Malgun Gothic'">본</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span
                style="font-family:'Malgun Gothic'">약관</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span
                style="font-family:'Malgun Gothic'">및</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span
                style="font-family:'Malgun Gothic'">관련</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span
                style="font-family:'Malgun Gothic'">법령을</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span
                style="font-family:'Malgun Gothic'">위반한</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span
                style="font-family:'Malgun Gothic'">상태에서</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span
                style="font-family:'Malgun Gothic'">결제</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span
                style="font-family:'Malgun Gothic'">업체를</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span
                style="font-family:'Malgun Gothic'">통해</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span
                style="font-family:'Malgun Gothic'">환불을</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span
                style="font-family:'Malgun Gothic'">받은</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span
                style="font-family:'Malgun Gothic'">경우</span><span style="font-family:微软雅黑">,</span><span
                style="font-family:微软雅黑">&#xa0;</span><span style="font-family:'Malgun Gothic'">게임콘텐츠 비용을 미납한 것으로
                간주합니다</span><span style="font-family:微软雅黑">.</span><span style="font-family:微软雅黑">&#xa0;</span><span
                style="font-family:'Malgun Gothic'">회사는 본 약관 제</span><span style="font-family:微软雅黑">24</span><span
                style="font-family:'Malgun Gothic'">조에 따라 이용자가 미납 금액을 지불할 때까지 제한 조치를 취할 권리가 있습니다</span><span
                style="font-family:微软雅黑">.</span><span style="font-family:'Times New Roman'">&#xa0;</span><span
                style="font-family:'Malgun Gothic'">이용자가</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span
                style="font-family:'Malgun Gothic'">새로운</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span
                style="font-family:'Malgun Gothic'">유료</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span
                style="font-family:'Malgun Gothic'">게임</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span
                style="font-family:'Malgun Gothic'">콘텐츠를</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span
                style="font-family:'Malgun Gothic'">구매하기</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span
                style="font-family:'Malgun Gothic'">위해</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span
                style="font-family:'Malgun Gothic'">미지급</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span
                style="font-family:'Malgun Gothic'">비용을</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span
                style="font-family:'Malgun Gothic'">보충하기</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span
                style="font-family:'Malgun Gothic'">전에</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span
                style="font-family:'Malgun Gothic'">게임콘텐츠</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span
                style="font-family:'Malgun Gothic'">비용을</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span
                style="font-family:'Malgun Gothic'">납부할</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span
                style="font-family:'Malgun Gothic'">경우</span><span style="font-family:'Times New Roman'">,</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span style="font-family:'Malgun Gothic'">회사는 다시 납부한
                비용을 우선적으로 미지급 금액을 공제할 권리가 있습니다</span><span style="font-family:微软雅黑">.</span><span
                style="font-family:微软雅黑">&#xa0;</span><span style="font-family:'Malgun Gothic'">따라 이용자가 미지급 금액을 보충하기 전에는
                새로운 유료 게임 콘텐츠를 정상적으로 구매할 수 없습니다</span><span style="font-family:微软雅黑">.</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">2) </span><span style="font-family:宋体">유료 게임콘텐츠를 구매한 이용자는 회사가 지정한
                방식에 따라 비용을 지불하여야 합니다</span><span style="font-family:'Times New Roman'">. </span><span
                style="font-family:宋体">단</span><span style="font-family:'Times New Roman'">, </span><span
                style="font-family:宋体">무통장입금 방식으로 지급한 이용자는 신청한 날로부터 </span><span
                style="font-family:'Times New Roman'">3</span><span style="font-family:宋体">일 후 동등한 금액을 반드시 입금하여야
                하며</span><span style="font-family:'Times New Roman'">, </span><span style="font-family:宋体">기한이 만료되었으나
                미지불인 경우 회사는 해당 거래를 취소할 권리가 있습니다</span><span style="font-family:'Times New Roman'">.</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">&#xa0;</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">3) </span><span style="font-family:宋体">미성년자가 유료 게임아이템을 구매할 경우에는 부모
                등 법정대리인의 동의를 받아야 합니다</span><span style="font-family:'Times New Roman'">. </span><span
                style="font-family:宋体">동의를 받지 않은 유료 게임콘텐츠의 이용자는 법정대리인에게 고지한 후 법정대리인이 비용의 지급을 취소할 수 있습니다</span><span
                style="font-family:'Times New Roman'">.</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">4.</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span style="font-family:'Malgun Gothic'">구독</span>
        </p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:微软雅黑">1）</span><span style="font-family:'Malgun Gothic'">구독은</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span
                style="font-family:'Malgun Gothic'">자동</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span
                style="font-family:'Malgun Gothic'">연장</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span
                style="font-family:'Malgun Gothic'">정액제</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span
                style="font-family:'Malgun Gothic'">서비스로</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span
                style="font-family:'Malgun Gothic'">구매</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span
                style="font-family:'Malgun Gothic'">후</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span
                style="font-family:'Malgun Gothic'">스토어</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span
                style="font-family:'Malgun Gothic'">마켓에서</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span
                style="font-family:'Malgun Gothic'">자동</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span
                style="font-family:'Malgun Gothic'">결제가</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span
                style="font-family:'Malgun Gothic'">됩니다</span><span style="font-family:'Times New Roman'">.</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">2</span><span style="font-family:微软雅黑">）</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span
                style="font-family:'Malgun Gothic'">자동</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span
                style="font-family:'Malgun Gothic'">연장</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span
                style="font-family:'Malgun Gothic'">규칙</span><span style="font-family:微软雅黑">：</span><span
                style="font-family:'Malgun Gothic'">구독</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span
                style="font-family:'Malgun Gothic'">기간</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span
                style="font-family:'Malgun Gothic'">만료</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span
                style="font-family:'Malgun Gothic'">시</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span
                style="font-family:'Malgun Gothic'">스토어</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span
                style="font-family:'Malgun Gothic'">마켓에서</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span
                style="font-family:'Malgun Gothic'">자동으로</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span
                style="font-family:'Malgun Gothic'">구독료가</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span
                style="font-family:'Malgun Gothic'">결제되며</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span
                style="font-family:'Malgun Gothic'">구독</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span
                style="font-family:'Malgun Gothic'">기간이</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span
                style="font-family:'Malgun Gothic'">연장됩니다</span><span style="font-family:'Times New Roman'">.</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">3</span><span style="font-family:微软雅黑">）</span><span
                style="font-family:'Malgun Gothic'">자동</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span
                style="font-family:'Malgun Gothic'">연장</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span
                style="font-family:'Malgun Gothic'">서비스</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span
                style="font-family:'Malgun Gothic'">취소를</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span
                style="font-family:'Malgun Gothic'">원하는</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span
                style="font-family:'Malgun Gothic'">경우</span><span style="font-family:'Times New Roman'">,</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span
                style="font-family:'Malgun Gothic'">최소</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span
                style="font-family:'Malgun Gothic'">구독</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span
                style="font-family:'Malgun Gothic'">기간</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span
                style="font-family:'Malgun Gothic'">만료</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span
                style="font-family:'Times New Roman'">24</span><span style="font-family:'Malgun Gothic'">시간</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span
                style="font-family:'Malgun Gothic'">전까지</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span
                style="font-family:'Malgun Gothic'">스토어</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span
                style="font-family:'Malgun Gothic'">마켓에서</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span
                style="font-family:'Malgun Gothic'">자동</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span
                style="font-family:'Malgun Gothic'">연장을</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span
                style="font-family:'Malgun Gothic'">수동으로</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span
                style="font-family:'Malgun Gothic'">취소해야</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span
                style="font-family:'Malgun Gothic'">합니다</span><span style="font-family:'Times New Roman'">.</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span
                style="font-family:'Malgun Gothic'">자동</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span
                style="font-family:'Malgun Gothic'">연장</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span
                style="font-family:'Malgun Gothic'">취소</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span
                style="font-family:'Malgun Gothic'">후</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span
                style="font-family:'Malgun Gothic'">구독</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span
                style="font-family:'Malgun Gothic'">기간</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span
                style="font-family:'Malgun Gothic'">만료</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span
                style="font-family:'Malgun Gothic'">후</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span
                style="font-family:'Malgun Gothic'">자동으로</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span
                style="font-family:'Malgun Gothic'">결제가</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span
                style="font-family:'Malgun Gothic'">되지</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span
                style="font-family:'Malgun Gothic'">않고</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span
                style="font-family:'Malgun Gothic'">이번</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span
                style="font-family:'Malgun Gothic'">구독</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span
                style="font-family:'Malgun Gothic'">기간이</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span
                style="font-family:'Malgun Gothic'">만료될</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span
                style="font-family:'Malgun Gothic'">때까지</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span
                style="font-family:'Malgun Gothic'">유효하며</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span
                style="font-family:'Malgun Gothic'">이미</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span
                style="font-family:'Malgun Gothic'">결제한</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span
                style="font-family:'Malgun Gothic'">금액은</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span
                style="font-family:'Malgun Gothic'">반납되지</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span
                style="font-family:'Malgun Gothic'">않습니다</span><span style="font-family:'Times New Roman'">.</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">4</span><span style="font-family:微软雅黑">）</span><span
                style="font-family:'Malgun Gothic'">자동</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span
                style="font-family:'Malgun Gothic'">연장을</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span
                style="font-family:'Malgun Gothic'">취소한</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span
                style="font-family:'Malgun Gothic'">후</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span
                style="font-family:'Malgun Gothic'">언제든지</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span
                style="font-family:'Malgun Gothic'">다시</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span
                style="font-family:'Malgun Gothic'">구독할</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span
                style="font-family:'Malgun Gothic'">수</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span
                style="font-family:'Malgun Gothic'">있습니다</span><span style="font-family:'Times New Roman'">.</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:微软雅黑">5）</span><span style="font-family:'Malgun Gothic'">해당</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span
                style="font-family:'Malgun Gothic'">구독은</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span
                style="font-family:'Malgun Gothic'">구매</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span
                style="font-family:'Malgun Gothic'">후</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span
                style="font-family:'Malgun Gothic'">즉시</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span
                style="font-family:'Malgun Gothic'">사용이</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span
                style="font-family:'Malgun Gothic'">시작되거나</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span
                style="font-family:'Malgun Gothic'">게임</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span
                style="font-family:'Malgun Gothic'">서비스에</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span
                style="font-family:'Malgun Gothic'">바로</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span
                style="font-family:'Malgun Gothic'">적용되는</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span
                style="font-family:'Malgun Gothic'">콘텐츠이다</span><span style="font-family:'Times New Roman'">.</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">&#xa0;</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">5. </span><span style="font-family:宋体">게임 내 </span><span
                style="font-family:'Times New Roman'">‘</span><span style="font-family:宋体">캐시</span><span
                style="font-family:'Times New Roman'">’ </span><span style="font-family:宋体">및 </span><span
                style="font-family:'Times New Roman'">‘</span><span style="font-family:宋体">금전</span><span
                style="font-family:'Times New Roman'">’</span><span style="font-family:宋体">의 사용</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">&#xa0;</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">1) </span><span style="font-family:宋体">이용자가 보유하고 있는 </span><span
                style="font-family:'Times New Roman'">‘</span><span style="font-family:宋体">캐시 또한 금전</span><span
                style="font-family:'Times New Roman'">’ </span><span style="font-family:宋体">중 게임 내에서 퀘스트를 진행하면서
                획득하거나</span><span style="font-family:'Times New Roman'">, </span><span style="font-family:宋体">이벤트로 지급하는
                캐시 또는 금전을 </span><span style="font-family:'Times New Roman'">‘</span><span style="font-family:宋体">무료
                캐시</span><span style="font-family:'Times New Roman'">’ </span><span style="font-family:宋体">및
            </span><span style="font-family:'Times New Roman'">‘</span><span style="font-family:宋体">무료 금전</span><span
                style="font-family:'Times New Roman'">’</span><span style="font-family:宋体">이라 정의합니다</span><span
                style="font-family:'Times New Roman'">. </span><span style="font-family:宋体">획득한 무료 캐시 및 무료 금전은
                유효기간</span><span style="font-family:'Times New Roman'">, </span><span style="font-family:宋体">사용범위 등을 별도로
                공지합니다</span><span style="font-family:'Times New Roman'">.</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">&#xa0;</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">2) </span><span style="font-family:宋体">무료 캐시 및 무료 금전의
                경우</span><span style="font-family:'Times New Roman'">, </span><span style="font-family:宋体">사용범위가 제한될 수
                있습니다</span><span style="font-family:'Times New Roman'">.</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">&#xa0;</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">3) </span><span style="font-family:宋体">무료 캐시 및 무료 금전은 환불 또는 보상의
                대상이 되지 않습니다</span><span style="font-family:'Times New Roman'">.</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span
                style="font-family:'Malgun Gothic'">결제를</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span
                style="font-family:'Malgun Gothic'">통해</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span
                style="font-family:'Malgun Gothic'">구매한</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span
                style="font-family:'Malgun Gothic'">유료</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span
                style="font-family:'Malgun Gothic'">상품</span><span style="font-family:微软雅黑">(</span><span
                style="font-family:'Malgun Gothic'">게임 머니 포함</span><span style="font-family:微软雅黑">),</span><span
                style="font-family:微软雅黑">&#xa0;</span><span style="font-family:'Malgun Gothic'">무료 캐시 및 무료 금전이 공존하는
                경우</span><span style="font-family:微软雅黑">,</span><span style="font-family:微软雅黑">&#xa0;</span><span
                style="font-family:'Malgun Gothic'">결제를 통해 구매한 유료 상품</span><span style="font-family:微软雅黑">(</span><span
                style="font-family:'Malgun Gothic'">게임 머니 포함</span><span style="font-family:微软雅黑">)</span><span
                style="font-family:'Malgun Gothic'">이 먼저 소모됩니다</span><span style="font-family:微软雅黑">.</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span
                style="font-family:'Malgun Gothic'">단</span><span style="font-family:'Times New Roman'">,</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span
                style="font-family:'Malgun Gothic'">사정에</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span
                style="font-family:'Malgun Gothic'">따라</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span
                style="font-family:'Malgun Gothic'">상품의</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span
                style="font-family:'Malgun Gothic'">이용</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span
                style="font-family:'Malgun Gothic'">순서는</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span
                style="font-family:'Malgun Gothic'">다르게</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span
                style="font-family:'Malgun Gothic'">적용될</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span
                style="font-family:'Malgun Gothic'">수</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span
                style="font-family:'Malgun Gothic'">있으며</span><span style="font-family:微软雅黑">,</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span
                style="font-family:'Malgun Gothic'">이</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span
                style="font-family:'Malgun Gothic'">경우</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span
                style="font-family:'Malgun Gothic'">홈페이지</span><span style="font-family:微软雅黑">,</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span
                style="font-family:'Malgun Gothic'">공식카페</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span
                style="font-family:'Malgun Gothic'">등을</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span
                style="font-family:'Malgun Gothic'">통하여</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span
                style="font-family:'Malgun Gothic'">공지합니다</span><span style="font-family:微软雅黑">.</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">&#xa0;</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:微软雅黑">제</span><span style="font-family:'Times New Roman'">19</span><span
                style="font-family:宋体">조 사이버 포인트</span><span style="font-family:'Times New Roman'">&#xa0;</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">&#xa0;</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">1. </span><span style="font-family:宋体">회사는 이용자의 정보에 근거하여 이용자에게 사이버
                포인트를 제공할 수 있습니다</span><span style="font-family:'Times New Roman'">(</span><span
                style="font-family:宋体">이용자 정보는 </span><span style="font-family:'Times New Roman'">&lt;</span><span
                style="font-family:宋体">개인정보처리방침</span><span style="font-family:'Times New Roman'">&gt; </span><span
                style="font-family:宋体">참조</span><span style="font-family:'Times New Roman'">). </span><span
                style="font-family:宋体">회사가 정한 유효기간 내에 사용되지 않은 사이버 포인트는 소멸될 수 있습니다</span><span
                style="font-family:'Times New Roman'">.</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">&#xa0;</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">2. </span><span style="font-family:宋体">회사에서 제공한 사이버 포인트의 적립에 오류가
                있을 경우</span><span style="font-family:'Times New Roman'">, </span><span style="font-family:宋体">이용자는 회사에
                정정 신청을 할 수 있으며</span><span style="font-family:'Times New Roman'">, </span><span
                style="font-family:宋体">회사는 확인한 후 인터넷에서 정정조치를 취할 수 있습니다</span><span
                style="font-family:'Times New Roman'">.</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">&#xa0;</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">3. </span><span style="font-family:宋体">회사는 이용자에게 제공한 게임콘텐츠가 곧 만기되는
                경우</span><span style="font-family:'Times New Roman'">, </span><span style="font-family:宋体">회사는
            </span><span style="font-family:'Times New Roman'">1</span><span style="font-family:宋体">개월 전에 유효한 방법으로 이용자에게
                관련 통지를 발송하여야 합니다</span><span style="font-family:'Times New Roman'">.</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span style="font-family:微软雅黑">회사가</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span style="font-family:微软雅黑">이용자에게</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span style="font-family:微软雅黑">게임콘텐츠의</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span style="font-family:微软雅黑">제공을</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span
                style="font-family:'Malgun Gothic'">종료</span><span style="font-family:微软雅黑">할</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span style="font-family:微软雅黑">때</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span style="font-family:微软雅黑">이용자에게</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span style="font-family:微软雅黑">미사용</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span style="font-family:微软雅黑">사이버</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span style="font-family:微软雅黑">포인트가</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span style="font-family:微软雅黑">아직</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span style="font-family:微软雅黑">남아있는</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span style="font-family:微软雅黑">경우</span><span
                style="font-family:'Times New Roman'">, </span><span style="font-family:宋体">미사용 사이버 포인트는
                소멸됩니다</span><span style="font-family:'Times New Roman'">.</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">&#xa0;</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">&#xa0;</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">&#xa0;</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:微软雅黑">제</span><span style="font-family:'Times New Roman'">20</span><span
                style="font-family:宋体">조 지식재산권의 귀속</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">&#xa0;</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">1. </span><span style="font-family:宋体">본 약관 및 아래 모든 작품 또는 자료의 소유권
                및 저작권을 포함한 모든 지식 재산권은 회사에 귀속하고 관련 법령의 보호를 받습니다</span><span
                style="font-family:'Times New Roman'">.</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">&#xa0;</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">2. </span><span style="font-family:宋体">이용자는 회사나 서비스 제공업자의 사전 허가 없이
                회사가 제공한 게임콘텐츠 관련 정보를 제</span><span style="font-family:'Times New Roman'">3</span><span
                style="font-family:宋体">자에게 이용하게 할 수 없습니다</span><span style="font-family:'Times New Roman'">.</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">&#xa0;</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">3. </span><span style="font-family:宋体">다음 각 호의 어느 하나에 해당하는
                경우</span><span style="font-family:'Times New Roman'">, </span><span style="font-family:宋体">회사는
            </span><span style="font-family:'Times New Roman'">&lt;</span><span
                style="font-family:宋体">개인정보처리방침</span><span style="font-family:'Times New Roman'">&gt;</span><span
                style="font-family:宋体">에 명시되어 있는 방법으로 이용자 정보</span><span
                style="font-family:'Times New Roman'">(</span><span style="font-family:宋体">이용자가 게임단말기 혹은 게임콘텐츠를 통하여 획득한
                정보 등</span><span style="font-family:'Times New Roman'">, </span><span style="font-family:宋体">및
                문자</span><span style="font-family:'Times New Roman'">, </span><span
                style="font-family:宋体">이미지</span><span style="font-family:'Times New Roman'">, </span><span
                style="font-family:宋体">오디오</span><span style="font-family:'Times New Roman'">, </span><span
                style="font-family:宋体">비디오 및 모든 정보</span><span style="font-family:'Times New Roman'">)</span><span
                style="font-family:宋体">를 획득 및 사용할 수 있습니다</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">&#xa0;</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">1) </span><span style="font-family:宋体">이용자가 애플리케이션을 사용하는 관련
                정보</span><span style="font-family:'Times New Roman'">, </span><span
                style="font-family:宋体">사용시간</span><span style="font-family:'Times New Roman'">, </span><span
                style="font-family:宋体">사용장소 및 사용방식 포함 </span><span style="font-family:'Times New Roman'">(</span><span
                style="font-family:宋体">이용자가 애플리케이션에 대하여 변경</span><span style="font-family:'Times New Roman'">,
            </span><span style="font-family:宋体">복제</span><span style="font-family:'Times New Roman'">, </span><span
                style="font-family:宋体">전달</span><span style="font-family:'Times New Roman'">, </span><span
                style="font-family:宋体">발행</span><span style="font-family:'Times New Roman'">, </span><span
                style="font-family:宋体">방송 등 행위를 하였는지 여부</span><span style="font-family:'Times New Roman'">)</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">&#xa0;</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">2) </span><span style="font-family:宋体">회사는 이용자의 사전 동의 없이 이용자가 제작한
                작품을 판매</span><span style="font-family:'Times New Roman'">, </span><span
                style="font-family:宋体">임대</span><span style="font-family:'Times New Roman'">, </span><span
                style="font-family:宋体">양도할 수 없습니다</span><span style="font-family:'Times New Roman'">.</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">&#xa0;</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">4. </span><span style="font-family:宋体">회사는 이용자가 게임콘텐츠 내에 게시한
                작품</span><span style="font-family:'Times New Roman'">(</span><span style="font-family:宋体">예를 들어 게시판
                게시물</span><span style="font-family:'Times New Roman'">)</span><span style="font-family:宋体">에 대하여 이용자의
                명시적인 허락 없이는 무단으로 사용하지 않습니다</span><span style="font-family:'Times New Roman'">. </span><span
                style="font-family:宋体">이용자가 서비스 범위 내에서 게시한 게시물의 저작권은 해당 저작권자에 귀속되고 이용자는 해당 게시물을 수시로 삭제할 수
                있습니다</span><span style="font-family:'Times New Roman'">.</span><span
                style="font-family:'Times New Roman'">&#xa0;</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">&#xa0;</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">5. </span><span style="font-family:宋体">회사는 이용자가 게임 내 및 게시판에서
                제</span><span style="font-family:'Times New Roman'">13</span><span style="font-family:宋体">조 </span><span
                style="font-family:'Times New Roman'">(</span><span style="font-family:宋体">이용자의 의무</span><span
                style="font-family:'Times New Roman'">)</span><span style="font-family:宋体">에서 규정한 금지내용을 게시하였다고 판단하는
                경우</span><span style="font-family:'Times New Roman'">, </span><span style="font-family:宋体">본 약관 및 관련 법령에
                근거하여 이에 대하여 상응하는 조치를 취할 수 있습니다</span><span style="font-family:'Times New Roman'">.</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">&#xa0;</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">6. </span><span style="font-family:宋体">회사가 운영하는 게시판에 게시된 게시물로 인하여
                법률상 이익이 침해된 이용자는 회사에 해당 게시물의 삭제 또는 반박내용의 게재를 요청할 수 있으며</span><span
                style="font-family:'Times New Roman'">, </span><span style="font-family:宋体">회사는 유효한 조치를 신속히
                취하고</span><span style="font-family:'Times New Roman'">, </span><span style="font-family:宋体">이를 즉시 이용자에게
                통지하여야 합니다</span><span style="font-family:'Times New Roman'">.</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">&#xa0;</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">7. </span><span style="font-family:宋体">이용자가 회원신분이 해제된 후에도 여전히 회사가
                제공하는 게임콘텐츠를 사용하는 경우</span><span style="font-family:'Times New Roman'">, </span><span
                style="font-family:宋体">회사는 제</span><span style="font-family:'Times New Roman'">3</span><span
                style="font-family:宋体">항 규정에 따라 이용자 정보를 획득 및 사용할 권리가 있습니다</span><span
                style="font-family:'Times New Roman'">.</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">&#xa0;</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">8. </span><span style="font-family:宋体">이용자는 회사의 동의 없이 서비스 사용 시 획득한
                정보를 영리의 목적으로 사용하거나 제</span><span style="font-family:'Times New Roman'">3</span><span
                style="font-family:宋体">자에게 사용하도록 제공하여서는 아니 됩니다</span><span
                style="font-family:'Times New Roman'">.</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">&#xa0;</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">9. </span><span style="font-family:宋体">이용자가 게임콘텐츠 내에 게시한 게시물은 검색
                혹은 서비스나 관련 프로모션 활동 등으로 인하여 공개될 수 있습니다</span><span style="font-family:'Times New Roman'">. </span><span
                style="font-family:宋体">이때 해당 게시물은 필요한 범위 내에서 일부 수정</span><span style="font-family:'Times New Roman'">,
            </span><span style="font-family:宋体">복제</span><span style="font-family:'Times New Roman'">, </span><span
                style="font-family:宋体">편집 후 게시될 수 있습니다</span><span style="font-family:'Times New Roman'">. </span><span
                style="font-family:宋体">이때 회사는 저작권법의 내용을 준수하여야 하며</span><span style="font-family:'Times New Roman'">,
            </span><span style="font-family:宋体">이용자는 수시로 고객센터 혹은 서비스 관리 기능을 통하여 관련 게시물을 삭제하거나 검색결과에서 배제하거나 비공개로 설정하는 등
                처리를 할 수 있습니다</span><span style="font-family:'Times New Roman'">.</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">&#xa0;</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">10. </span><span style="font-family:宋体">이용자의 게시물이 저작권 등 문제로 인하여
                제</span><span style="font-family:'Times New Roman'">3</span><span style="font-family:宋体">자에 의하여 이의가 제기된
                경우</span><span style="font-family:'Times New Roman'">, </span><span style="font-family:宋体">회사가 해당 이의가
                합리적인 이유가 있다고 판단하는 경우</span><span style="font-family:'Times New Roman'">, </span><span
                style="font-family:宋体">회사는 이용자에게 사전 통지 없이 해당 게시물을 즉시 삭제하거나 등록을 거부할 수 있습니다</span><span
                style="font-family:'Times New Roman'">. </span><span style="font-family:宋体">저작권 및 권리침해로 인한 게시금지 등 사항은
                저작권법 및 관련 법령의 규정에 따릅니다</span><span style="font-family:'Times New Roman'">.</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">&#xa0;</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">11. </span><span style="font-family:宋体">이 외에는 이용자의 게시물 게시와 관련하여 아래
                유의사항이 있습니다</span><span style="font-family:'Times New Roman'">.</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">&#xa0;</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">1) </span><span style="font-family:宋体">게시물로 인한 손실 혹은 문제는 이용자 개인이
                책임을 지며 회사는 이에 대하여 책임을 부담하지 않습니다</span><span style="font-family:'Times New Roman'">.</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">&#xa0;</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">2) </span><span style="font-family:宋体">회사는 관리 상의 필요에 따라 사전 통지 없이
                게시물을 이동할 수 있습니다</span><span style="font-family:'Times New Roman'">.</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">&#xa0;</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">3) </span><span style="font-family:宋体">타인이 이용자의 게시물이 그 타인의 권리를
                침해하였음을 이유로 회사를 상대로 손해배상 등을 청구한 경우</span><span style="font-family:'Times New Roman'">, </span><span
                style="font-family:宋体">게시물을 작성한 이용자는 회사가 면책될 수 있도록 적극 협조하여야 합니다</span><span
                style="font-family:'Times New Roman'">. </span><span style="font-family:宋体">회사가 면책되지 못한 경우</span><span
                style="font-family:'Times New Roman'">, </span><span style="font-family:宋体">이용자는 이로 인한 문제에 대한 책임을 부담하여야
                합니다</span><span style="font-family:'Times New Roman'">.</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">&#xa0;</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">4) </span><span style="font-family:宋体">이용자가 작성하거나 전달한 게시물이 다음 중 어느
                하나에 해당하는 경우</span><span style="font-family:'Times New Roman'">, </span><span style="font-family:宋体">회사는
                사전 통지 없이 이를 삭제하거나 등록을 거부할 수 있습니다</span><span style="font-family:'Times New Roman'">.</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">&#xa0;</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">a. </span><span style="font-family:宋体">다른 이용자 혹은 다른 사람에 대하여
                비방</span><span style="font-family:'Times New Roman'">, </span><span style="font-family:宋体">사생활
                침해</span><span style="font-family:'Times New Roman'">, </span><span style="font-family:宋体">모욕행위를
                하거나</span><span style="font-family:'Times New Roman'">, </span><span style="font-family:宋体">혹은 이로 인하여
                타인의 명예를 훼손한 경우</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">&#xa0;</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">b. </span><span style="font-family:宋体">서비스의 안정적인 운영에 영향을 미치거나 미칠
                가능성이 있는 경우</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">&#xa0;</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">c. </span><span style="font-family:宋体">범죄행위와 관련된 내용이라고 판단되는
                경우</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">&#xa0;</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">d. </span><span style="font-family:宋体">회사 및 제</span><span
                style="font-family:'Times New Roman'">3</span><span style="font-family:宋体">자의 지식재산권 등 기타 권리를 침해하는 내용이 있는
                경우</span><span style="font-family:'Times New Roman'">.</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">&#xa0;</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">&#xa0;</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">&#xa0;</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">&#xa0;</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">&#xa0;</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:微软雅黑">제</span><span style="font-family:'Times New Roman'">5</span><span
                style="font-family:宋体">장 청약 철회 및 계약해제</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">&#xa0;</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">&#xa0;</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:微软雅黑">제</span><span style="font-family:'Times New Roman'">21</span><span
                style="font-family:宋体">조 청약 철회</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">&#xa0;</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">1. </span><span style="font-family:宋体">원칙적으로</span><span
                style="font-family:'Times New Roman'">, </span><span style="font-family:宋体">회사로부터 유료 게임상품을 구매한 이용자는 구매일
                혹은 지불일로부터 </span><span style="font-family:'Times New Roman'">7</span><span style="font-family:宋体">일 내에
                청약철회를 할 수 있습니다</span><span style="font-family:'Times New Roman'">. </span><span
                style="font-family:宋体">회사가 이용자에게 제공하는 유료 콘텐츠는 청약철회가 가능한 콘텐츠와 청약철회가 제한되는 콘텐츠로 구분되어 제공됩니다</span><span
                style="font-family:'Times New Roman'">. </span><span style="font-family:宋体">유료로 직접 구매하여 청약철회가 가능한 유료
                콘텐츠에 대해서는 구매 후 </span><span style="font-family:'Times New Roman'">7</span><span style="font-family:宋体">일
                기간 내에 청약철회를 할 수 있습니다</span><span style="font-family:'Times New Roman'">. </span><span
                style="font-family:宋体">단</span><span style="font-family:'Times New Roman'">, </span><span
                style="font-family:宋体">선물 및 이벤트 보상 등의 방법으로 회사나 제</span><span
                style="font-family:'Times New Roman'">3</span><span style="font-family:宋体">자로부터 제공받은 콘텐츠 또는 구매 즉시 효과가
                발생하는 등 일부 사용한 콘텐츠의 경우 등에는 관련법령에 따라 청약철회가 제한될 수 있으며</span><span style="font-family:'Times New Roman'">,
            </span><span style="font-family:宋体">이 경우 회사는 관련 법령에서 정한 바에 따른 조치를 취합니다</span><span
                style="font-family:'Times New Roman'">.</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">&#xa0;</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">2. </span><span style="font-family:宋体">이용자는 아래 경우에 청약철회를 할 수
                없습니다</span><span style="font-family:'Times New Roman'">.</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">&#xa0;</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">1) </span><span style="font-family:宋体">이용자에게 책임이 있는 사유로 재화 등이 멸실
                되거나 훼손된 경우</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">&#xa0;</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">2) </span><span style="font-family:宋体">이용자의 구매</span><span
                style="font-family:'Times New Roman'">, </span><span style="font-family:宋体">사용시간이 지나 다시 판매하기 곤란할
                경우</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">&#xa0;</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">3) </span><span style="font-family:宋体">제품의 포장이 훼손된 경우</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">&#xa0;</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">4) </span><span style="font-family:宋体">서비스 이용과정에서 획득한 아이템의
                경우</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">&#xa0;</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">5) </span><span style="font-family:宋体">구매 후 즉시 사용이 시작되거나 게임 서비스에
                바로 적용되는 콘텐츠의 경우</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">&#xa0;</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">6) </span><span style="font-family:宋体">부가적인 혜택이 제공되는 아이템 또는 묶음형 판매
                콘텐츠에서 이미 추가 혜택이 사용되거나 일부가 사용되어 회수가 불가능한 경우</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">&#xa0;</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">7) </span><span style="font-family:宋体">개봉 시 효용이 결정되는
                캡슐형</span><span style="font-family:'Times New Roman'">/</span><span style="font-family:宋体">확률형 아이템을 개봉한
                경우</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">&#xa0;</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">8) </span><span style="font-family:宋体">회사가 이용자에게 무료로 지급한 재화 및
                아이템</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">&#xa0;</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">9) </span><span style="font-family:宋体">타인으로부터 선물 받은 유료재화 및
                유료아이템</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">&#xa0;</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">10) </span><span style="font-family:宋体">그 밖에 거래의 안전을 위하여 관련 법령에
                의하여 </span><span style="font-family:'Times New Roman'">2</span><span style="font-family:宋体">차 거래가 명시적으로
                금지된 경우</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">&#xa0;</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">3. </span><span style="font-family:宋体">회사는 본조 제</span><span
                style="font-family:'Times New Roman'">2</span><span style="font-family:宋体">항 제</span><span
                style="font-family:'Times New Roman'">2</span><span style="font-family:宋体">호부터 제</span><span
                style="font-family:'Times New Roman'">8</span><span style="font-family:宋体">호까지 규정에 따라 이용자의 철회신청을 받아들이지
                아니할 경우에는 상품 포장에 표기 및 설명을 하거나 사전에 이용자에게 테스트용 서비스를 제공합니다</span><span
                style="font-family:'Times New Roman'">. </span><span style="font-family:宋体">만약 회사가 이러한 조치를 하지 않을 경우 이용자는
                위 조항에도 불구하고 청약을 철회할 수 있습니다</span><span style="font-family:'Times New Roman'">.</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">&#xa0;</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">4. </span><span style="font-family:宋体">이용자는 본조 제</span><span
                style="font-family:'Times New Roman'">2</span><span style="font-family:宋体">항 제</span><span
                style="font-family:'Times New Roman'">1</span><span style="font-family:宋体">호부터 제</span><span
                style="font-family:'Times New Roman'">3</span><span style="font-family:宋体">호까지의 규정에도 불구하고 유료 게임상품의 내용이
                표시</span><span style="font-family:'Times New Roman'">·</span><span style="font-family:宋体">광고 내용과 다르거나
                계약내용과 다르게 이행된 경우에는 구매 후 </span><span style="font-family:'Times New Roman'">3</span><span
                style="font-family:宋体">개월 내에 청약철회를 신청할 수 있고</span><span style="font-family:'Times New Roman'">,
            </span><span style="font-family:宋体">구매한 상품과 계약서에서 약정한 상품이 동일하지 아니함을 안 날로부터 </span><span
                style="font-family:'Times New Roman'">30</span><span style="font-family:宋体">일 내에 청약을 철회할 수
                있습니다</span><span style="font-family:'Times New Roman'">.</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">&#xa0;</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">5. </span><span style="font-family:宋体">미성년자가 법정대리인의 동의 없이 유료 게임상품을
                구매한 경우</span><span style="font-family:'Times New Roman'">, </span><span style="font-family:宋体">미성년자 또는
                법정대리인은 회사에 청약철회를 요청할 수 있으며</span><span style="font-family:'Times New Roman'">, </span><span
                style="font-family:宋体">회사는 법정대리인임을 증명할 수 있는 서류를 요구할 수 있습니다</span><span
                style="font-family:'Times New Roman'">.</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span style="font-family:微软雅黑">단</span><span
                style="font-family:'Times New Roman'">, </span><span style="font-family:宋体">미성년자의 구매가 법정대리인으로부터 처분을 허락
                받은 재산의 범위 내인 경우 또는 미성년자가 사술 등을 사용하여 성인으로 하여금 믿게 한 때에는 취소가 제한됩니다</span><span
                style="font-family:'Times New Roman'">. </span><span style="font-family:宋体">구매자의 미성년자 여부는 구매가 진행된 단말기 또는
                신용카드 등 결제수단의 명의자를 기준으로 판단됩니다</span><span style="font-family:'Times New Roman'">.</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">&#xa0;</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:微软雅黑">6</span><span style="font-family:'Times New Roman'">.</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span
                style="font-family:'Malgun Gothic'">상기</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span
                style="font-family:'Malgun Gothic'">제</span><span style="font-family:'Times New Roman'">21</span><span
                style="font-family:'Malgun Gothic'">조</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span
                style="font-family:'Malgun Gothic'">제</span><span style="font-family:'Times New Roman'">1</span><span
                style="font-family:'Malgun Gothic'">항</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span
                style="font-family:'Malgun Gothic'">내지</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span
                style="font-family:'Malgun Gothic'">제</span><span style="font-family:'Times New Roman'">5</span><span
                style="font-family:'Malgun Gothic'">항의</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span
                style="font-family:'Malgun Gothic'">경우</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span
                style="font-family:'Malgun Gothic'">외에도</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span
                style="font-family:'Malgun Gothic'">이용자는</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span
                style="font-family:'Malgun Gothic'">기타</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span
                style="font-family:'Malgun Gothic'">적용되는</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span
                style="font-family:'Malgun Gothic'">법령에</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span
                style="font-family:'Malgun Gothic'">따라</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span
                style="font-family:'Malgun Gothic'">청약</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span
                style="font-family:'Malgun Gothic'">철회를</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span
                style="font-family:'Malgun Gothic'">할</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span
                style="font-family:'Malgun Gothic'">수</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span
                style="font-family:'Malgun Gothic'">있습니다</span><span style="font-family:'Times New Roman'">.</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span
                style="font-family:'Malgun Gothic'">단</span><span style="font-family:'Times New Roman'">,</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span
                style="font-family:'Malgun Gothic'">본</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span
                style="font-family:'Malgun Gothic'">약관</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span
                style="font-family:'Malgun Gothic'">제</span><span style="font-family:'Times New Roman'">21</span><span
                style="font-family:'Malgun Gothic'">조</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span
                style="font-family:'Malgun Gothic'">제</span><span style="font-family:'Times New Roman'">1</span><span
                style="font-family:'Malgun Gothic'">항</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span
                style="font-family:'Malgun Gothic'">내지</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span
                style="font-family:'Malgun Gothic'">제</span><span style="font-family:'Times New Roman'">5</span><span
                style="font-family:'Malgun Gothic'">항의</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span
                style="font-family:'Malgun Gothic'">경우에</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span
                style="font-family:'Malgun Gothic'">해당하지</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span
                style="font-family:'Malgun Gothic'">않고</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span
                style="font-family:'Malgun Gothic'">여하한</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span
                style="font-family:'Malgun Gothic'">법령에</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span
                style="font-family:'Malgun Gothic'">의하여</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span
                style="font-family:'Malgun Gothic'">청약</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span
                style="font-family:'Malgun Gothic'">철회가</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span
                style="font-family:'Malgun Gothic'">허용되는</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span
                style="font-family:'Malgun Gothic'">것도</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span
                style="font-family:'Malgun Gothic'">아닌</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span
                style="font-family:'Malgun Gothic'">경우</span><span style="font-family:微软雅黑">,</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span
                style="font-family:'Malgun Gothic'">이용자는</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span
                style="font-family:'Malgun Gothic'">청약을</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span
                style="font-family:'Malgun Gothic'">철회할</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span
                style="font-family:'Malgun Gothic'">수</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span
                style="font-family:'Malgun Gothic'">없습니다</span><span style="font-family:'Times New Roman'">.</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">&#xa0;</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">7. </span><span style="font-family:宋体">이용자는 구두 또는 서면</span><span
                style="font-family:'Times New Roman'">(</span><span style="font-family:宋体">전자메일 포함</span><span
                style="font-family:'Times New Roman'">) </span><span style="font-family:宋体">등 형식으로 청약철회를 할 수
                있습니다</span><span style="font-family:'Times New Roman'">.</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">&#xa0;</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">&#xa0;</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">&#xa0;</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:微软雅黑">제</span><span style="font-family:'Times New Roman'">22</span><span
                style="font-family:宋体">조 청약철회 등의 효과</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">&#xa0;</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">1. </span><span style="font-family:宋体">이용자가 청약철회를 한 경우 회사는 지체 없이
                이용자의 유료 게임상품을 회수 또는 삭제하고</span><span style="font-family:'Times New Roman'">, </span><span
                style="font-family:宋体">유료 게임상품을 회수 또는 삭제한 날로부터 </span><span
                style="font-family:'Times New Roman'">3</span><span style="font-family:宋体">영업일 이내에 지급받은 대금을
                환급합니다</span><span style="font-family:'Times New Roman'">. </span><span style="font-family:宋体">동일한 방법으로
                환불이 불가할 경우 이를 사전에 고지합니다</span><span style="font-family:'Times New Roman'">.</span><span
                style="font-family:'Times New Roman'">&#xa0;</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">&#xa0;</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">2. </span><span style="font-family:宋体">이용자의 권익을 보장하기
                위하여</span><span style="font-family:'Times New Roman'">, </span><span style="font-family:宋体">회사가 이용자에게
                환급을 지연한 때에는 그 지연기간에 대하여 전자상거래 등에서의 소비자보호에 관한 법률 및 시행령에서 정하는 이율을 곱하여 산정한 지연이자를 지급합니다</span><span
                style="font-family:'Times New Roman'">.</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">&#xa0;</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">3. </span><span style="font-family:宋体">위 대금을 환급함에 있어서 이용자가 신용카드나 그
                밖에 이용자 계좌 정보의 안전을 보장하는 유사한 방식으로 지급하였는데 해당 대금이 회사에 입금되지 않은 경우</span><span
                style="font-family:'Times New Roman'">, </span><span style="font-family:宋体">회사는 신용카드를 발급한 금융기관 또는 결제수단을
                제공한 사업자</span><span style="font-family:'Times New Roman'">(</span><span style="font-family:宋体">이하
            </span><span style="font-family:'Times New Roman'">“</span><span style="font-family:宋体">금융기관 등</span><span
                style="font-family:'Times New Roman'">”)</span><span style="font-family:宋体">에게 빠른 시일 내로 이용자에게 지급받은 금액을
                환급할 것을 통지하여야 합니다</span><span style="font-family:'Times New Roman'">. </span><span
                style="font-family:宋体">회사가 위 금융기관 등으로부터 대금을 이미 지급받은 경우</span><span
                style="font-family:'Times New Roman'">, </span><span style="font-family:宋体">회사는 해당 금액을 금융기관 등에 반환하고 금융기관
                등이 다시 이를 이용자에게 반환하여야 합니다</span><span style="font-family:'Times New Roman'">. </span><span
                style="font-family:宋体">회사는 위 금액 환급 관련 사항을 이용자에게 고지하여야 합니다</span><span
                style="font-family:'Times New Roman'">.</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">&#xa0;</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">4. </span><span style="font-family:宋体">회사는 이미 유료 콘텐츠 등이 일부 사용되거나
                일부 소비된 경우에는 그 콘텐츠 등의 일부 사용 또는 일부 소비에 의하여 이용자가 얻은 이익 또는 그 콘텐츠의 공급에 든 비용에 상당하는 금액을 이용자에게 청구할 수
                있습니다</span><span style="font-family:'Times New Roman'">&#xa0;</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">&#xa0;</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">5. </span><span style="font-family:宋体">이용자가 청약철회를 신청한 경우 제품 혹은
                서비스의 반환에 필요한 비용은 이용자가 부담하고</span><span style="font-family:'Times New Roman'">, </span><span
                style="font-family:宋体">회사는 이용자에게 청약철회를 이유로 위약금 또는 손해배상을 청구할 수 없습니다</span><span
                style="font-family:'Times New Roman'">.</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">&#xa0;</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">&#xa0;</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:微软雅黑">제</span><span style="font-family:'Times New Roman'">23</span><span
                style="font-family:宋体">조 회사의 계약해지 신청</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">&#xa0;</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">1. </span><span style="font-family:宋体">이용자가 본 약관에서 정한 이용자의 의무를 위반한
                경우</span><span style="font-family:'Times New Roman'">, </span><span style="font-family:宋体">회사는 이용자에게
                게임콘텐츠 계약의 해지를 요청할 수 있습니다</span><span style="font-family:'Times New Roman'">. </span><span
                style="font-family:宋体">회사는 이용자의 실제 본인 여부를 확인한 후 필요한 조치를 취합니다</span><span
                style="font-family:'Times New Roman'">.</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">&#xa0;</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">2. </span><span style="font-family:宋体">회사가 이용계약을 해지하는 경우 회사는 이용자에게
                서면으로 다음 각 호의 사항을 통보합니다</span><span style="font-family:'Times New Roman'">.</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">&#xa0;</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">1) </span><span style="font-family:宋体">해지사유</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">&#xa0;</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">2) </span><span style="font-family:宋体">해지일</span><span
                style="font-family:'Times New Roman'">&#xa0;</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">&#xa0;</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">3. </span><span style="font-family:宋体">제</span><span
                style="font-family:'Times New Roman'">1</span><span style="font-family:宋体">항에 따라 이용자는 유료서비스를 비롯한 게임콘텐츠의
                사용권한을 상실하고</span><span style="font-family:'Times New Roman'">, </span><span style="font-family:宋体">이로 인한
                환불 및 손해배상을 청구할 수 없습니다</span><span style="font-family:'Times New Roman'">.</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">&#xa0;</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">4. </span><span style="font-family:宋体">회사는 이용자가 현행법 위반 및 고의 또는 중대한
                과실로 회사에 손해를 입힌 경우에는 사전 통보 없이 이용계약을 해지할 수 있으며</span><span style="font-family:'Times New Roman'">,
            </span><span style="font-family:宋体">이 경우 회원은 유료로 구매한 상품에 대해 사용권한이 상실되고 이로 인한 환불 및 손해배상을 청구할 수
                없습니다</span><span style="font-family:'Times New Roman'">.</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">&#xa0;</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">5. </span><span style="font-family:宋体">회사는 회원의 계정 또는 캐릭터가 부당한 목적으로
                사용되는 것을 방지하고 보다 원활한 서비스 제공을 위하여 </span><span style="font-family:'Times New Roman'">12</span><span
                style="font-family:宋体">개월 이상 접속기록이 없는 회원의 계정 또는 캐릭터</span><span
                style="font-family:'Times New Roman'">(</span><span style="font-family:宋体">이하 </span><span
                style="font-family:'Times New Roman'">“</span><span style="font-family:宋体">휴면계정</span><span
                style="font-family:'Times New Roman'">”</span><span style="font-family:宋体">이라고 함</span><span
                style="font-family:'Times New Roman'">) </span><span style="font-family:宋体">경우 해당 계정 또는 캐릭터를 삭제할 수
                있습니다</span><span style="font-family:'Times New Roman'">. </span><span style="font-family:宋体">휴면상태로 분류된
                경우</span><span style="font-family:'Times New Roman'">, </span><span style="font-family:宋体">안내메일 또는 공지사항
                발표 후 일주일 간의 안내 기간을 거쳐 계정 또는 캐릭터의 모든 정보가 삭제되며 복구되지 않습니다</span><span
                style="font-family:'Times New Roman'">. </span><span style="font-family:宋体">회원은 안내 기간 중 게임 접속 등을 통해 휴면
                상태를 해지할 수 있습니다</span><span style="font-family:'Times New Roman'">.</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">&#xa0;</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">&#xa0;</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">&#xa0;</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">&#xa0;</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">&#xa0;</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:微软雅黑">제</span><span style="font-family:'Times New Roman'">24</span><span
                style="font-family:宋体">조 이용자에 대한 제한조치</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">&#xa0;</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">1. </span><span style="font-family:宋体">회사는 이용자가 본 약관 및 관련 법령을 위반하는
                경우 이용자에 대하여 게임 내에서 일정한 제한조치를 설정할 수 있습니다</span><span style="font-family:'Times New Roman'">. </span><span
                style="font-family:宋体">구체적인 의무위반 사유 및 제한조치 등은 개별 게임의 운영정책에서 정합니다</span><span
                style="font-family:'Times New Roman'">.</span><span style="font-family:'Times New Roman'">&#xa0;</span>
        </p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">&#xa0;</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">1) </span><span style="font-family:宋体">캐릭터의 일부 권한 제한</span><span
                style="font-family:'Times New Roman'">: </span><span style="font-family:宋体">일정한 기간 동안 캐릭터의 채팅 등 게임 기능
                제한</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">&#xa0;</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">2) </span><span style="font-family:宋体">캐릭터 사용 제한</span><span
                style="font-family:'Times New Roman'">: </span><span style="font-family:宋体">지정 이용자의 캐릭터에 대한 임시 계정정지 혹은
                영구정지</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">&#xa0;</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">3) </span><span style="font-family:宋体">계정의 사용 제한</span><span
                style="font-family:'Times New Roman'">: </span><span style="font-family:宋体">지정 게임계정에 대한 임시 계정정지 혹은
                영구정지</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">&#xa0;</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">4) </span><span style="font-family:宋体">이용자의 사용 제한</span><span
                style="font-family:'Times New Roman'">: </span><span style="font-family:宋体">지정 이용자에 대한 임시 계정정지 혹은
                영구정지</span><span style="font-family:'Times New Roman'">.</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">&#xa0;</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">2. </span><span style="font-family:宋体">회사의 제한조치가 정당한
                경우</span><span style="font-family:'Times New Roman'">, </span><span style="font-family:宋体">이용자는 계정이 정지된
                기간 동안의 손해에 대하여 책임을 지며</span><span style="font-family:'Times New Roman'">, </span><span
                style="font-family:宋体">회사는 이에 대하여 배상책임을 부담하지 않습니다</span><span
                style="font-family:'Times New Roman'">.</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">&#xa0;</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:微软雅黑">제</span><span style="font-family:'Times New Roman'">25</span><span
                style="font-family:宋体">조 임시조치의 사용</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">&#xa0;</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">1. </span><span style="font-family:宋体">회사는 아래에 해당하는 경우 이용자에 대하여 임시
                계정정지 조치</span><span style="font-family:'Times New Roman'">, </span><span style="font-family:宋体">즉 이용자의
                게임 계정을 임시적으로 정지함으로써 정지 기간 동안 이용자가 회사의 게임 상품에 등록할 수 없고 관련 서비스를 사용할 수 없도록 할 수 있습니다</span><span
                style="font-family:'Times New Roman'">.</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">&#xa0;</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">1) </span><span style="font-family:宋体">이용자의 계정이 해킹 또는 타인에 의하여 도용된
                경우</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">&#xa0;</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">2) </span><span style="font-family:宋体">개인이용자 또는 기업에서 불법프로그램이 사용되는
                경우</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">&#xa0;</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">3) </span><span style="font-family:宋体">회사가 임시정지 외의 기타 임시적인 수단을 통하여
                관련 상황을 조사하여야 하는 경우</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">&#xa0;</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">2. </span><span style="font-family:宋体">회사는 조사가 완료된 후 임시조치를 해제하고
                정지된 기간만큼 이용자의 게임콘텐츠 시간을 반환하거나 연장합니다</span><span style="font-family:'Times New Roman'">. </span><span
                style="font-family:宋体">단</span><span style="font-family:'Times New Roman'">, </span><span
                style="font-family:宋体">회사의 조사 결과 관련 법령 및 본 약관에 위반한 것으로 판단된 이용자에 대해서는 그러하지 아니합니다</span><span
                style="font-family:'Times New Roman'">.</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">&#xa0;</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">&#xa0;</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">&#xa0;</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:微软雅黑">제</span><span style="font-family:'Times New Roman'">26</span><span
                style="font-family:宋体">조 제한조치 사유 및 절차</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">&#xa0;</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">1. </span><span style="font-family:宋体">회사는 이용자가 본 약관을 위반한 행위의
                내용</span><span style="font-family:'Times New Roman'">, </span><span
                style="font-family:宋体">정도</span><span style="font-family:'Times New Roman'">, </span><span
                style="font-family:宋体">횟수</span><span style="font-family:'Times New Roman'">, </span><span
                style="font-family:宋体">결과 등 제반 요소를 고려하여 제한조치를 부과하는 구체적인 이유와 절차를 정합니다</span><span
                style="font-family:'Times New Roman'">.</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">&#xa0;</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">2. </span><span style="font-family:宋体">회사가 제</span><span
                style="font-family:'Times New Roman'">25</span><span style="font-family:宋体">조에서 정한 제한조치를 하는
                경우에는</span><span style="font-family:'Times New Roman'">, </span><span style="font-family:宋体">전자우편을 통하거나
                게임 공식 홈페이지</span><span style="font-family:'Times New Roman'">(https://www.domain.com/)</span><span
                style="font-family:宋体">에서 이용자에게 아래 내용에 대하여 고지하여야 합니다</span><span
                style="font-family:'Times New Roman'">.</span><span style="font-family:'Times New Roman'">&#xa0;</span>
        </p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">&#xa0;</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">1) </span><span style="font-family:宋体">이용제한 이유</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">&#xa0;</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">2) </span><span style="font-family:宋体">이용제한 유형 및 기간</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">&#xa0;</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">3) </span><span style="font-family:宋体">이용제한에 대한 이의신청 방법</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">&#xa0;</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">&#xa0;</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">&#xa0;</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:微软雅黑">제</span><span style="font-family:'Times New Roman'">27</span><span
                style="font-family:宋体">조 사용제한에 대한 이의신청</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">&#xa0;</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">1. </span><span style="font-family:宋体">회사의 제한조치에 대하여 이의가 있는
                경우</span><span style="font-family:'Times New Roman'">, </span><span style="font-family:宋体">이용자는 통지를 받은
                날로부터 서면으로 회사에 이의를 제출하여야 합니다</span><span style="font-family:'Times New Roman'">.</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">&#xa0;</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">2. </span><span style="font-family:宋体">회사는 이용자의 서면신청을 받은 날로부터
            </span><span style="font-family:'Times New Roman'">15</span><span style="font-family:宋体">일 이내에 서면 또는 전자우편을
                통하여 답변을 하여야 합니다</span><span style="font-family:'Times New Roman'">. </span><span
                style="font-family:宋体">회사가 </span><span style="font-family:'Times New Roman'">15</span><span
                style="font-family:宋体">일 이내에 답변하지 못한 경우에는 지연의 이유 및 처리 일정을 이용자에게 통보하여야 합니다</span><span
                style="font-family:'Times New Roman'">.</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">&#xa0;</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">3. </span><span style="font-family:宋体">회사는 위 답변에 따라 상응하는 조치를 취하여야
                합니다</span><span style="font-family:'Times New Roman'">.</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">&#xa0;</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">&#xa0;</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">&#xa0;</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:微软雅黑">제</span><span style="font-family:'Times New Roman'">6</span><span
                style="font-family:宋体">장 배상 및 환불</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">&#xa0;</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">&#xa0;</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">&#xa0;</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:微软雅黑">제</span><span style="font-family:'Times New Roman'">28</span><span
                style="font-family:宋体">조 손해배상</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">&#xa0;</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">1. </span><span style="font-family:宋体">회사가 고의 또는 중과실로 이용자에게 손해를 끼친
                경우</span><span style="font-family:'Times New Roman'">, </span><span style="font-family:宋体">회사는 이용자에게 그
                손해를 배상하여야 합니다</span><span style="font-family:'Times New Roman'">.</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">&#xa0;</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">2. </span><span style="font-family:宋体">이용자가 본 약관의 규정을 위반함으로 인하여
                회사에 손해를 끼친 경우</span><span style="font-family:'Times New Roman'">, </span><span
                style="font-family:宋体">이용자는 회사에게 그 손해를 배상을 할 책임이 있습니다</span><span
                style="font-family:'Times New Roman'">.</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">&#xa0;</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">3. </span><span style="font-family:宋体">이용자가 게임콘텐츠를 이용하면서 행한 불법행위나
                본 약관 위반행위로 인하여 회사가 이용자 이외의 제</span><span style="font-family:'Times New Roman'">3</span><span
                style="font-family:宋体">자로부터 손해배상청구 또는 소송을 비롯한 각종 이의제기를 받는 경우</span><span
                style="font-family:'Times New Roman'">, </span><span style="font-family:宋体">이용자는 자신의 책임과 비용으로 회사를 면책시켜야
                하며</span><span style="font-family:'Times New Roman'">, </span><span style="font-family:宋体">관련 책임과 비용은
                이용자가 부담하여야 합니다</span><span style="font-family:'Times New Roman'">.</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span style="font-family:微软雅黑">회사가</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span style="font-family:微软雅黑">면책되지</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span style="font-family:微软雅黑">못한</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span style="font-family:微软雅黑">경우</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span style="font-family:微软雅黑">이용자는</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span style="font-family:微软雅黑">그로</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span style="font-family:微软雅黑">인하여</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span style="font-family:微软雅黑">회사에</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span style="font-family:微软雅黑">발생한</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span style="font-family:微软雅黑">모든</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span style="font-family:微软雅黑">손해를</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span style="font-family:微软雅黑">배상할</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span style="font-family:微软雅黑">책임이</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span style="font-family:微软雅黑">있습니다</span><span
                style="font-family:'Times New Roman'">.</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">&#xa0;</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">4. </span><span style="font-family:宋体">회사는 무료로 제공하는 서비스와 관련하여 발생하는
                사항에 대해서는 어떠한 손해도 책임을 지지 않습니다</span><span style="font-family:'Times New Roman'">. </span><span
                style="font-family:宋体">단</span><span style="font-family:'Times New Roman'">, </span><span
                style="font-family:宋体">회사의 고의나 중과실로 인한 손해인 경우는 예외로 합니다</span><span
                style="font-family:'Times New Roman'">.</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">&#xa0;</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">&#xa0;</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">&#xa0;</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:微软雅黑">제</span><span style="font-family:'Times New Roman'">29</span><span
                style="font-family:宋体">조 환불</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:微软雅黑">第</span><span style="font-family:'Times New Roman'">29</span><span
                style="font-family:宋体">条 退款</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">1.</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span
                style="font-family:'Malgun Gothic'">아래의</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span
                style="font-family:'Malgun Gothic'">경우에</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span
                style="font-family:'Malgun Gothic'">해당하면</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span
                style="font-family:'Malgun Gothic'">이용자는</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span
                style="font-family:'Malgun Gothic'">환불을</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span
                style="font-family:'Malgun Gothic'">요청할</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span
                style="font-family:'Malgun Gothic'">수</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span
                style="font-family:'Malgun Gothic'">있습니다</span><span style="font-family:微软雅黑">.</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">(1)</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span
                style="font-family:'Malgun Gothic'">이용자가</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span
                style="font-family:'Malgun Gothic'">이용약관</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span
                style="font-family:'Malgun Gothic'">제</span><span style="font-family:微软雅黑">21</span><span
                style="font-family:'Malgun Gothic'">조에 따라 청약을 철회할 경우</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">(2)</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span
                style="font-family:'Malgun Gothic'">적용되는</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span
                style="font-family:'Malgun Gothic'">다른</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span
                style="font-family:'Malgun Gothic'">법령에</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span
                style="font-family:'Malgun Gothic'">당사가</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span
                style="font-family:'Malgun Gothic'">이용자에게</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span
                style="font-family:'Malgun Gothic'">환불해야</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span
                style="font-family:'Malgun Gothic'">하는</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span
                style="font-family:'Malgun Gothic'">경우가</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span
                style="font-family:'Malgun Gothic'">명확히</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span
                style="font-family:'Malgun Gothic'">규정된</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span style="font-family:'Malgun Gothic'">경우</span>
        </p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">&#xa0;</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">2.</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span style="font-family:'Malgun Gothic'">제1항에 따라
                이용자의 환불 이유가 인정되는 경우 이용자는 이를 환불받을 수 있습니다.</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span
                style="font-family:'Malgun Gothic'">그러나</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span
                style="font-family:'Malgun Gothic'">이용자가</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span
                style="font-family:'Malgun Gothic'">환불받을</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span
                style="font-family:'Malgun Gothic'">수</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span
                style="font-family:'Malgun Gothic'">있는</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span
                style="font-family:'Malgun Gothic'">범위는</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span
                style="font-family:'Malgun Gothic'">이용자가</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span
                style="font-family:'Malgun Gothic'">아직까지</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span
                style="font-family:'Malgun Gothic'">소비하지</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span
                style="font-family:'Malgun Gothic'">않은</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span
                style="font-family:'Malgun Gothic'">부분으로</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span
                style="font-family:'Malgun Gothic'">제한되며,</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span style="font-family:微软雅黑">은행이체</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span style="font-family:微软雅黑">및</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span style="font-family:微软雅黑">결제대행수수료</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span style="font-family:微软雅黑">등의</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span style="font-family:微软雅黑">사유로</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span style="font-family:微软雅黑">환불</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span style="font-family:微软雅黑">금액이</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span
                style="font-family:'Times New Roman'">10,000</span><span style="font-family:宋体">원 이내인 경우에는</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span
                style="font-family:'Malgun Gothic'">회사가</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span style="font-family:微软雅黑">총</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span style="font-family:微软雅黑">금액의</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span style="font-family:'Times New Roman'">10%
            </span><span style="font-family:宋体">이내의 수수료를 공제하고 나머지 잔액을 환불할 수 있습니다</span><span
                style="font-family:'Times New Roman'">. </span><span style="font-family:宋体">이때 만약 총 금액의 </span><span
                style="font-family:'Times New Roman'">10% </span><span style="font-family:宋体">이내의 수수료 공제금액이 환불 금액보다 많은
                경우에는 환불하지 않습니다</span><span style="font-family:'Times New Roman'">.</span><span
                style="font-family:'Times New Roman'">&#xa0;</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">&#xa0;</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">3. </span><span style="font-family:宋体">이용자가 환불을 요청하고자 하는
                경우</span><span style="font-family:'Times New Roman'">, </span><span style="font-family:宋体">회사에서 정한 절차에
                따라 환불신청을 하여야 하며</span><span style="font-family:'Times New Roman'">, </span><span
                style="font-family:宋体">회사는 구매 내역을 확인한 후</span><span style="font-family:'Times New Roman'">, </span><span
                style="font-family:宋体">이용자에게 본인확인을 위한 별도의 서류 제출을 요구할 수 있고</span><span
                style="font-family:'Times New Roman'">, </span><span style="font-family:宋体">환불신청의 정당성을 심사합니다</span><span
                style="font-family:'Times New Roman'">. </span><span style="font-family:宋体">이때 회사는 이용자에게 중대한 위약행위가 없는지 등
                제반 사정을 고려하여 이용자의 요청에 따라 계약을 해제할지를 결정합니다</span><span style="font-family:'Times New Roman'">.</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">&#xa0;</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">4. </span><span style="font-family:宋体">계속적 이용계약의 경우에는 상품가액에서 이용자가
                이미 사용한 부분에 해당하는 금액</span><span style="font-family:'Times New Roman'">(</span><span
                style="font-family:宋体">각 상품별 사용금액 산정기준은 상품 구매 시 별도 고지함</span><span
                style="font-family:'Times New Roman'">)</span><span style="font-family:宋体">을 제외하고 남은 금액에서 남은금액의
            </span><span style="font-family:'Times New Roman'">10% </span><span style="font-family:宋体">이내 수수료 또는 남은 금액이
            </span><span style="font-family:'Times New Roman'">10,000</span><span style="font-family:宋体">원 이내인 경우에는
                일정수수료를 공제한 후 나머지 금액을 환불해 드립니다</span><span style="font-family:'Times New Roman'">.</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span style="font-family:微软雅黑">일정금액을</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span style="font-family:微软雅黑">공제하는</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span style="font-family:微软雅黑">경우</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span style="font-family:微软雅黑">공제</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span style="font-family:微软雅黑">후</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span style="font-family:微软雅黑">남은</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span style="font-family:微软雅黑">금액이</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span style="font-family:微软雅黑">공제금액보다</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span style="font-family:微软雅黑">작은</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span style="font-family:微软雅黑">경우에는</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span style="font-family:微软雅黑">환불할</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span style="font-family:微软雅黑">수</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span style="font-family:微软雅黑">없습니다</span><span
                style="font-family:'Times New Roman'">.</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">&#xa0;</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">5. </span><span style="font-family:宋体">현행법령 및 중대한 조항 위반 등 이용자의
                귀책사유로 이용계약을 해지하는 경우 환불이 제한될 수 있습니다</span><span style="font-family:'Times New Roman'">.</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">&#xa0;</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">&#xa0;</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">&#xa0;</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:微软雅黑">제</span><span style="font-family:'Times New Roman'">30</span><span
                style="font-family:宋体">조 면책조항</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">&#xa0;</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">1. </span><span style="font-family:宋体">회사는 이용자의 귀책사유로 인한 서비스의
                종료</span><span style="font-family:'Times New Roman'">, </span><span
                style="font-family:宋体">이용장애</span><span style="font-family:'Times New Roman'">, </span><span
                style="font-family:宋体">게임콘텐츠</span><span style="font-family:'Times New Roman'">&#xa0;</span><span
                style="font-family:'Malgun Gothic'">종료</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span style="font-family:微软雅黑">및</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span style="font-family:微软雅黑">계약해지에</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span style="font-family:微软雅黑">대하여</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span style="font-family:微软雅黑">책임이</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span style="font-family:微软雅黑">면제됩니다</span><span
                style="font-family:'Times New Roman'">.</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">&#xa0;</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">2. </span><span style="font-family:宋体">회사의 고의 또는 중대한 과실이 없는
                한</span><span style="font-family:'Times New Roman'">, </span><span style="font-family:宋体">회사는 이동통신 서비스의
                장애</span><span style="font-family:'Times New Roman'">[</span><span
                style="font-family:宋体">천재지변</span><span style="font-family:'Times New Roman'">(</span><span
                style="font-family:宋体">예로서</span><span style="font-family:'Times New Roman'">, </span><span
                style="font-family:宋体">지진</span><span style="font-family:'Times New Roman'">, </span><span
                style="font-family:宋体">홍수</span><span style="font-family:'Times New Roman'">, </span><span
                style="font-family:宋体">번개 등</span><span style="font-family:'Times New Roman'">, </span><span
                style="font-family:宋体">기계실 주요 설비</span><span style="font-family:'Times New Roman'">, </span><span
                style="font-family:宋体">선로나 전기공급 시스템에 중대한 고장이나 화재가 발생하는 경우 등</span><span
                style="font-family:'Times New Roman'">)</span><span style="font-family:宋体">을 포함하나</span><span
                style="font-family:'Times New Roman'">, </span><span style="font-family:宋体">이에 한하지 아니함</span><span
                style="font-family:'Times New Roman'">]</span><span style="font-family:宋体">으로 인한 책임이 면제됩니다</span><span
                style="font-family:'Times New Roman'">.</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">&#xa0;</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">3. </span><span style="font-family:宋体">회사는 사전에 이용자에게 공지된 게임콘텐츠용
                설비의 보수</span><span style="font-family:'Times New Roman'">, </span><span
                style="font-family:宋体">교체</span><span style="font-family:'Times New Roman'">, </span><span
                style="font-family:宋体">정기점검</span><span style="font-family:'Times New Roman'">, </span><span
                style="font-family:宋体">공사 등 부득이한 사유로 인하여 게임콘텐츠가 종료되거나 장애가 발생한 경우에 대해서 고의 또는 중대한 과실이 없는 한 책임이
                면제됩니다</span><span style="font-family:'Times New Roman'">.</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">&#xa0;</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">4. </span><span style="font-family:宋体">회사의 고의 또는 중대한 과실이 없는
                한</span><span style="font-family:'Times New Roman'">, </span><span style="font-family:宋体">회사는 이용자의 컴퓨터와
                기타 전자설비에 각종 소프트웨어</span><span style="font-family:'Times New Roman'">/</span><span
                style="font-family:宋体">하드웨어 장애로 인한 책임이 면제됩니다</span><span style="font-family:'Times New Roman'">.</span>
        </p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">&#xa0;</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">5. </span><span style="font-family:宋体">이용자는 제</span><span
                style="font-family:'Times New Roman'">3</span><span style="font-family:宋体">자로부터 게임상품을 획득하여서는 아니
                되며</span><span style="font-family:'Times New Roman'">, </span><span style="font-family:宋体">만약 이용자가
                제</span><span style="font-family:'Times New Roman'">3</span><span style="font-family:宋体">자로부터 게임상품을
                취득하였을 경우에는</span><span style="font-family:'Times New Roman'">, </span><span style="font-family:宋体">이용자는
                그에 상응하는 위험을 스스로 부담하고</span><span style="font-family:'Times New Roman'">, </span><span
                style="font-family:宋体">회사는 해당 게임상품이 정상적으로 사용될 수 있는 것과 반환청구를 받지 않는 것을 보장하지 않습니다</span><span
                style="font-family:'Times New Roman'">. </span><span style="font-family:宋体">이로 인하여 이용자가 손해를 입었을
                경우</span><span style="font-family:'Times New Roman'">, </span><span style="font-family:宋体">회사는 이에 대한 책임을
                지지 않습니다</span><span style="font-family:'Times New Roman'">.</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">&#xa0;</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">6. </span><span style="font-family:宋体">회사는 이용자 상호간 발생한 분쟁에 개입할 의무가
                없으며</span><span style="font-family:'Times New Roman'">, </span><span style="font-family:宋体">이에 따라 회사는 이와
                같은 유형의 분쟁으로 인한 손해배상책임을 부담할 의무도 없습니다</span><span style="font-family:'Times New Roman'">.</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">&#xa0;</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">7. </span><span style="font-family:宋体">이용자가 회사가 제공한 무료 제품 혹은 서비스를
                사용함으로 인하여 손해를 입은 경우</span><span style="font-family:'Times New Roman'">, </span><span
                style="font-family:宋体">회사는 이에 대한 책임을 지지 않습니다</span><span style="font-family:'Times New Roman'">.
            </span><span style="font-family:宋体">단 그 손해가 회사의 고의 또는 중대한 과실에 의한 경우는 제외합니다</span><span
                style="font-family:'Times New Roman'">.</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">&#xa0;</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">8. </span><span style="font-family:宋体">회원가입 시 이용자가 잘못된 정보를 제공하거나
                이용자의 잘못된 조작방법</span><span style="font-family:'Times New Roman'">, </span><span style="font-family:宋体">또는
                이용자 자신의 전자기기 고장으로 인하여 손해가 발생한 경우 회사는 일체의 책임을 지지 않습니다</span><span
                style="font-family:'Times New Roman'">.</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">&#xa0;</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">9. </span><span style="font-family:宋体">회사는 이용자가 서비스를 이용하면서 취득한
                등급</span><span style="font-family:'Times New Roman'">, </span><span
                style="font-family:宋体">아이템</span><span style="font-family:'Times New Roman'">, </span><span
                style="font-family:宋体">콘텐츠 등의 소실에 대해서 회사의 고의 또는 중대한 과실로 인한 경우를 제외하고는 책임을 부담하지 않습니다</span><span
                style="font-family:'Times New Roman'">.</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">&#xa0;</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">10. </span><span style="font-family:宋体">이용자의 단말기 변경</span><span
                style="font-family:'Times New Roman'">, </span><span style="font-family:宋体">번호 변경</span><span
                style="font-family:'Times New Roman'">, </span><span style="font-family:宋体">해외 로밍</span><span
                style="font-family:'Times New Roman'">, </span><span style="font-family:宋体">통신사 이동 등의 경우 게임콘텐츠의 전부 또는 일부
                기능을 이용할 수 없는 경우가 발생할 수 있으며</span><span style="font-family:'Times New Roman'">, </span><span
                style="font-family:宋体">이 경우 회사는 책임지지 않습니다</span><span style="font-family:'Times New Roman'">.</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">&#xa0;</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">11. </span><span style="font-family:宋体">회사에서 제공하는 게임콘텐츠를 삭제하는
                경우</span><span style="font-family:'Times New Roman'">, </span><span style="font-family:宋体">이용
                정보</span><span style="font-family:'Times New Roman'">(</span><span style="font-family:宋体">점수</span><span
                style="font-family:'Times New Roman'">, </span><span style="font-family:宋体">캐릭터</span><span
                style="font-family:'Times New Roman'">, </span><span style="font-family:宋体">아이템</span><span
                style="font-family:'Times New Roman'">, </span><span style="font-family:宋体">게임머니 등</span><span
                style="font-family:'Times New Roman'">)</span><span style="font-family:宋体">가 삭제되는 경우가 있을 수 있으므로 이용자는 삭제에
                신중을 기하여야 하며 회사는 이에 대해 책임을 지지 않습니다</span><span style="font-family:'Times New Roman'">.</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">&#xa0;</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">12. </span><span style="font-family:宋体">회사는 임시회원 기능 이용 중 발생한 문제에
                대해서는 일체 책임을 지지 않습니다</span><span style="font-family:'Times New Roman'">.</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">&#xa0;</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">13. </span><span style="font-family:宋体">회사는 이용자가 서비스를 이용하여 기대하는
                수익을 얻지 못한 것에 대하여 책임을 지지 않으며</span><span style="font-family:'Times New Roman'">, </span><span
                style="font-family:宋体">서비스에 대한 취소 또는 이용으로 발생하는 손해 등에 대해서는 책임을 지지 않습니다</span><span
                style="font-family:'Times New Roman'">.</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">&#xa0;</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">14. </span><span style="font-family:宋体">국가 법률</span><span
                style="font-family:'Times New Roman'">, </span><span style="font-family:宋体">법규</span><span
                style="font-family:'Times New Roman'">, </span><span style="font-family:宋体">정책 및 국가기관의 명령 등으로 인하여 이용자에게
                손실을 끼친 경우</span><span style="font-family:'Times New Roman'">, </span><span style="font-family:宋体">회사는 이에
                대한 책임을 지지 않습니다</span><span style="font-family:'Times New Roman'">.</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">&#xa0;</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">&#xa0;</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">&#xa0;</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:微软雅黑">제</span><span style="font-family:'Times New Roman'">31</span><span
                style="font-family:宋体">조 이용자 고발 및 분쟁의 해결</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">&#xa0;</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">1. </span><span style="font-family:宋体">이용자 고발 및 분쟁해결의 편리를
                위하여</span><span style="font-family:'Times New Roman'">, </span><span style="font-family:宋体">회사는 게임 초기화면
                및 게임 홈페이지에서 이용자 게시판을 마련하고 이를 담당하는 전문적인 고객서비스부서를 설립함으로써 관련 정보 수집 및 처리를 진행하도록 하여야 합니다</span><span
                style="font-family:'Times New Roman'">.</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">&#xa0;</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">2. </span><span style="font-family:宋体">회사는 합리적인 기한 내에 이용자의 의견과 불만을
                유효하게 처리하여야 합니다</span><span style="font-family:'Times New Roman'">. </span><span
                style="font-family:宋体">처리기간을 연장하여야 하는 경우</span><span style="font-family:'Times New Roman'">,
            </span><span style="font-family:宋体">회사는 홈페이지</span><span style="font-family:'Times New Roman'">,
            </span><span style="font-family:宋体">전자우편 혹은 서면의 방법으로 이용자에게 처리 상황을 통지하여야 합니다</span><span
                style="font-family:'Times New Roman'">.</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">&#xa0;</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">3. </span><span style="font-family:宋体">회사와 이용자 상호간의 분쟁은
                제</span><span style="font-family:'Times New Roman'">3</span><span style="font-family:宋体">의 분쟁조정기관에 조정을
                맡기는 경우</span><span style="font-family:'Times New Roman'">, </span><span style="font-family:宋体">회사는 사실대로
                진술하여야 하고 조정결과를 받아들여야 합니다</span><span style="font-family:'Times New Roman'">.</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">&#xa0;</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">&#xa0;</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">&#xa0;</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:微软雅黑">제</span><span style="font-family:'Times New Roman'">32</span><span
                style="font-family:宋体">조 이용자에 대한 통지</span><span style="font-family:'Times New Roman'">&#xa0;</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">&#xa0;</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">1. </span><span style="font-family:宋体">회사는 서비스를 사용하는 과정에서 이용자가 필요로
                하는 각종 정보에 대하여 서비스화면</span><span style="font-family:'Times New Roman'">, </span><span
                style="font-family:宋体">전자우편 또는 서신 우편 등 방식으로 이를 이용자에게 제공할 수 있습니다</span><span
                style="font-family:'Times New Roman'">. </span><span style="font-family:宋体">회사는 통지 발송 시에는 이용자가 지정한 전자우편
                주소 등 통신방법을 사용하여야 합니다</span><span style="font-family:'Times New Roman'">.</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">&#xa0;</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">2. </span><span style="font-family:宋体">회사는 전체 이용자에게 중요한 통지를 발송하여야
                할 때 회사 사이트에서 가장 윗 부분에 해당 통지 내용을 공시하여야 하며</span><span style="font-family:'Times New Roman'">,
            </span><span style="font-family:宋体">공시기한은 </span><span style="font-family:'Times New Roman'">7</span><span
                style="font-family:宋体">일보다 적어서는 아니 됩니다</span><span style="font-family:'Times New Roman'">.</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">&#xa0;</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">3. </span><span style="font-family:宋体">서비스 개선 및 이용자에 대한 서비스 소개 등을
                목적으로 회사는 이용자의 동의를 받은 후 추가적인 개인정보를 제공하도록 요구할 수 있습니다</span><span
                style="font-family:'Times New Roman'">.</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">&#xa0;</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">&#xa0;</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:微软雅黑">제</span><span style="font-family:'Times New Roman'">33</span><span
                style="font-family:宋体">조 준거법 및 관할권</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">&#xa0;</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">1. </span><span style="font-family:宋体">본 약관은 대한민국 법률에 따라 제정 및 해석되고
                해당 분쟁을 접수한 대한민국 법원이 관할권을 가집니다</span><span style="font-family:'Times New Roman'">.</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">&#xa0;</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">2. </span><span style="font-family:宋体">관련 서비스의 사용에 대하여 회사와 이용자 간에
                분쟁이 발생할 경우</span><span style="font-family:'Times New Roman'">, </span><span style="font-family:宋体">양
                당사자는 협상을 통하여 원만하게 해결하여야 합니다</span><span style="font-family:'Times New Roman'">.</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">&#xa0;</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Malgun Gothic'">제</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span style="font-family:微软雅黑">34</span><span
                style="font-family:'Malgun Gothic'">조</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span
                style="font-family:'Malgun Gothic'">연락</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span style="font-family:'Malgun Gothic'">방법</span>
        </p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt">
            <br /><span style="font-family:'Malgun Gothic'">회사</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span
                style="font-family:'Malgun Gothic'">연락처는</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span
                style="font-family:'Times New Roman'">global.support@domain.com</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span
                style="font-family:'Malgun Gothic'">입니다</span><span style="font-family:'Times New Roman'">.</span></p>
        <p style="margin-top:14pt; margin-bottom:13.5pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:微软雅黑">「</span><span style="font-family:'Malgun Gothic'">게임산업진흥에</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span
                style="font-family:'Malgun Gothic'">관한</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span
                style="font-family:'Malgun Gothic'">법률</span><span style="font-family:微软雅黑">」</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span
                style="font-family:'Malgun Gothic'">제</span><span style="font-family:'Times New Roman'">31</span><span
                style="font-family:'Malgun Gothic'">조</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span
                style="font-family:'Malgun Gothic'">제</span><span style="font-family:'Times New Roman'">2</span><span
                style="font-family:'Malgun Gothic'">항에</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span
                style="font-family:'Malgun Gothic'">따라</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span
                style="font-family:'Malgun Gothic'">회사는</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span
                style="font-family:'Malgun Gothic'">다음과</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span
                style="font-family:'Malgun Gothic'">같이</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span
                style="font-family:'Malgun Gothic'">국내대리인을</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span
                style="font-family:'Malgun Gothic'">지정합니다</span><span
                style="font-family:'Times New Roman'">.</span><br /><br /><span
                style="font-family:'Malgun Gothic'">국내대리인의</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span
                style="font-family:'Malgun Gothic'">성명</span><span style="font-family:微软雅黑">:</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span style="font-family:微软雅黑">주식회사</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span style="font-family:微软雅黑">버스터</span><br /><span
                style="font-family:'Malgun Gothic'">국내대리인의</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span
                style="font-family:'Malgun Gothic'">주소</span><span style="font-family:微软雅黑">:</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span style="font-family:微软雅黑">서울특별시</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span style="font-family:微软雅黑">금천구</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span style="font-family:微软雅黑">가산디지털2로 143, 12층
                1201호,1202호(가산 어반워크2)</span><br /><span style="font-family:'Malgun Gothic'">국내대리인의</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span
                style="font-family:'Malgun Gothic'">전화번호</span><span style="font-family:微软雅黑">:</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span
                style="font-family:微软雅黑">010-2638-1897</span><br /><span
                style="font-family:'Malgun Gothic'">국내대리인의</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span
                style="font-family:'Malgun Gothic'">전자우편주소</span><span style="font-family:微软雅黑">:</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span
                style="font-family:微软雅黑">team@busters.co.kr</span><br /><br /><span
                style="font-family:'Malgun Gothic'">국내대리인은</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span style="font-family:微软雅黑">「</span><span
                style="font-family:'Malgun Gothic'">게임산업진흥에</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span
                style="font-family:'Malgun Gothic'">관한</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span
                style="font-family:'Malgun Gothic'">법률</span><span style="font-family:微软雅黑">」</span><span
                style="font-family:'Malgun Gothic'">에</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span
                style="font-family:'Malgun Gothic'">따라</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span
                style="font-family:'Malgun Gothic'">부여된</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span
                style="font-family:'Malgun Gothic'">법정</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span
                style="font-family:'Malgun Gothic'">의무</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span
                style="font-family:'Malgun Gothic'">이행만을</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span
                style="font-family:'Malgun Gothic'">담당하며</span><span style="font-family:'Times New Roman'">,</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span
                style="font-family:'Malgun Gothic'">이용자를</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span
                style="font-family:'Malgun Gothic'">대상으로</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span
                style="font-family:'Malgun Gothic'">한</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span
                style="font-family:'Malgun Gothic'">고객</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span
                style="font-family:'Malgun Gothic'">서비스</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span
                style="font-family:'Malgun Gothic'">업무는</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span
                style="font-family:'Malgun Gothic'">담당하지</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span
                style="font-family:'Malgun Gothic'">않습니다</span><span
                style="font-family:'Times New Roman'">.</span><br /><span
                style="font-family:'Malgun Gothic'">서비스</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span
                style="font-family:'Malgun Gothic'">이용과</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span
                style="font-family:'Malgun Gothic'">관련하여</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span
                style="font-family:'Malgun Gothic'">문의</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span
                style="font-family:'Malgun Gothic'">사항이</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span
                style="font-family:'Malgun Gothic'">있을</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span
                style="font-family:'Malgun Gothic'">경우</span><span style="font-family:'Times New Roman'">,</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span
                style="font-family:'Malgun Gothic'">국내대리인이</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span
                style="font-family:'Malgun Gothic'">아닌</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span
                style="font-family:'Malgun Gothic'">회사</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span
                style="font-family:'Malgun Gothic'">측에</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span
                style="font-family:'Malgun Gothic'">문의해야</span><span
                style="font-family:'Times New Roman'">&#xa0;</span><span
                style="font-family:'Malgun Gothic'">합니다</span><span
                style="font-family:'Times New Roman'">.</span><br /><span
                style="font-family:'Times New Roman'; -aw-import:ignore">&#xa0;</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:微软雅黑">제</span><span style="font-family:'Times New Roman'">3</span><span
                style="font-family:微软雅黑">5조</span><span style="font-family:'Times New Roman'">&#xa0;</span><span
                style="font-family:微软雅黑">기타</span><span style="font-family:'Times New Roman'">&#xa0;</span><span
                style="font-family:微软雅黑">조항</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">&#xa0;</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:微软雅黑">본</span><span style="font-family:'Times New Roman'">&#xa0;</span><span
                style="font-family:微软雅黑">약관에</span><span style="font-family:'Times New Roman'">&#xa0;</span><span
                style="font-family:微软雅黑">기재되지</span><span style="font-family:'Times New Roman'">&#xa0;</span><span
                style="font-family:微软雅黑">않은</span><span style="font-family:'Times New Roman'">&#xa0;</span><span
                style="font-family:微软雅黑">사항</span><span style="font-family:'Times New Roman'">&#xa0;</span><span
                style="font-family:微软雅黑">및</span><span style="font-family:'Times New Roman'">&#xa0;</span><span
                style="font-family:微软雅黑">본</span><span style="font-family:'Times New Roman'">&#xa0;</span><span
                style="font-family:微软雅黑">약관의</span><span style="font-family:'Times New Roman'">&#xa0;</span><span
                style="font-family:微软雅黑">해석은</span><span style="font-family:'Times New Roman'">&#xa0;</span><span
                style="font-family:微软雅黑">정부가</span><span style="font-family:'Times New Roman'">&#xa0;</span><span
                style="font-family:微软雅黑">제정한</span><span style="font-family:'Times New Roman'">&#xa0;</span><span
                style="font-family:微软雅黑">관련</span><span style="font-family:'Times New Roman'">&#xa0;</span><span
                style="font-family:微软雅黑">법령</span><span style="font-family:'Times New Roman'">&#xa0;</span><span
                style="font-family:微软雅黑">혹은</span><span style="font-family:'Times New Roman'">&#xa0;</span><span
                style="font-family:微软雅黑">상관례를</span><span style="font-family:'Times New Roman'">&#xa0;</span><span
                style="font-family:微软雅黑">따릅니다</span><span style="font-family:'Times New Roman'">.</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">&#xa0;</span></p>
        <p style="margin-top:14pt; margin-bottom:14pt; text-align:left; widows:2; orphans:2; font-size:13.5pt"><span
                style="font-family:'Times New Roman'">&#xa0;</span></p>
        <p><span style="-aw-import:ignore">&#xa0;</span></p>
    </div>
`;

export const omnikadeTermDetailHtml = `<div>
<p style="text-align: left">
  <span>이용약관</span>
</p>
<p style="text-align: left">
  <span style="-aw-import: ignore">&#xa0;</span>
</p>
<p style="text-align: left">
  <span>업데이트 일자</span><span>: 2023</span><span>년</span><span>11</span
  ><span>월</span><span>24</span><span>일</span>
</p>
<p style="text-align: left">
  <span>제1장 총칙</span>
</p>
<p style="text-align: left">
  <span style="-aw-import: ignore">&#xa0;</span>
</p>
<p style="text-align: left">
  <span style="-aw-import: ignore">&#xa0;</span>
</p>
<p style="text-align: left">
  <span>제1조 약관의 목적</span>
</p>
<p style="text-align: left">
  <span style="-aw-import: ignore">&#xa0;</span>
</p>
<p style="text-align: left">
  <span
    >이 약관은 OMNIKADE (이하 “회사”)가 온라인으로 제공하는 게임상품 및 이에
    부수된 제반 서비스(이하 “게임콘텐츠”)의 이용과 관련하여 이용자의 이용을
    허용하는 계약상 법적 근거를 제공하고, 본 약관을 토대로 게임콘텐츠를
    이용함에 있어 회사와 이용자 간의 권리, 의무 등 사항을 규정함을 목적으로
    합니다.</span
  >
</p>
<p style="text-align: left">
  <span style="-aw-import: ignore">&#xa0;</span>
</p>
<p style="text-align: left">
  <span style="-aw-import: ignore">&#xa0;</span>
</p>
<p style="text-align: left">
  <span>제2조 용어의 정의</span>
</p>
<p style="text-align: left">
  <span style="-aw-import: ignore">&#xa0;</span>
</p>
<p style="text-align: left">
  <span
    >1. ‘회사’라 함은 디바이스 및 온라인을 통하여 게임콘텐츠를 제공하는
    사업자를 말합니다.</span
  >
</p>
<p style="text-align: left">
  <span style="-aw-import: ignore">&#xa0;</span>
</p>
<p style="text-align: left">
  <span
    >2. ‘디바이스’라 함은 콘텐츠를 다운로드 받거나 설치하여 사용할 수 있는 PC,
    휴대전화, 스마트폰, PDA, 태블릿, 휴대용 게임기, 콘솔 게임기 등의 기기를
    말합니다.</span
  >
</p>
<p style="text-align: left">
  <span style="-aw-import: ignore">&#xa0;</span>
</p>
<p style="text-align: left">
  <span
    >3. ‘이용자’라 함은 본 약관에 동의하고 게임콘텐츠의 이용 자격을 부여받은
    자연인(회원, 임시회원, 비회원이 포함되며, ‘임시회원’이라 함은 회원인증을
    하지 않고 게스트로그인 모드로 이용하는 이용자를 의미함)을 말합니다.</span
  ><span>&#xa0;</span>
</p>
<p style="text-align: left">
  <span style="-aw-import: ignore">&#xa0;</span>
</p>
<p style="text-align: left">
  <span
    >4. ‘게임콘텐츠’라 함은 회사가 제공하는 모든 게임 및 네트워크 서비스,
    애플리케이션, 게임머니 및 게임 아이템 등 서비스와 관련되어 디지털 방식으로
    제작된 내용물 일체뿐만 아니라, 인터넷에 연결하여 순위등록, 게시물 작성,
    게임머니 또는 게임 아이템 등의 구매, 네트워크 게임 이용을 할 수 있도록
    회사가 제공하는 게임 및 이에 부수된 부가서비스 일체를 말합니다.</span
  >
</p>
<p style="text-align: left">
  <span style="-aw-import: ignore">&#xa0;</span>
</p>
<p style="text-align: left">
  <span
    >5. ‘게임세계’라 함은 게임콘텐츠를 통해 회사가 제정한 게임규칙(이하
    “게임규칙”)에 따라 오락을 하거나 오락게임 등 활동을 구현한 각종 가상환경을
    말합니다.</span
  >
</p>
<p style="text-align: left">
  <span style="-aw-import: ignore">&#xa0;</span>
</p>
<p style="text-align: left">
  <span
    >6. ‘계정(ID)’이라 함은 회사가 허용하는 범위 내에서 이용자의 신분 식별과
    게임콘텐츠 이용을 위하여 이용자가 선정하는 문자, 숫자 또는 특수문자의
    조합을 말합니다.</span
  >
</p>
<p style="text-align: left">
  <span style="-aw-import: ignore">&#xa0;</span>
</p>
<p style="text-align: left">
  <span
    >7. ‘계정정보’라 함은 이용자의 계정, 비밀번호, 성명 등 회사에 제공한 정보
    및 게임 이용정보, 이용요금 결제상태 등 생성정보를 통칭합니다.</span
  >
</p>
<p style="text-align: left">
  <span style="-aw-import: ignore">&#xa0;</span>
</p>
<p style="text-align: left">
  <span
    >8. ‘캐릭터’라 함은 이용자가 게임콘텐츠의 이용 범위 내에서 게임콘텐츠에
    따라 게임세계 내에서 회사에서 제공하는 방식으로 창조하는 가상인물데이터를
    말합니다.</span
  >
</p>
<p style="text-align: left">
  <span style="-aw-import: ignore">&#xa0;</span>
</p>
<p style="text-align: left">
  <span
    >9. ‘비밀번호’라 함은 이용자의 계좌정보 안전 및 게임권익보호를 위해 이용자
    자신이 선정하는 문자, 숫자 또는 특수문자의 조합을 말합니다.</span
  >
</p>
<p style="text-align: left">
  <span style="-aw-import: ignore">&#xa0;</span>
</p>
<p style="text-align: left">
  <span
    >10. ‘게임머니’라 함은 게임콘텐츠 또는 게임콘텐츠의 구매에 사용되는 가상
    화폐를 말합니다.</span
  >
</p>
<p style="text-align: left">
  <span style="-aw-import: ignore">&#xa0;</span>
</p>
<p style="text-align: left">
  <span
    >11. ‘사이버 포인트’라 함은 게임 아이템이나 게임콘텐츠를 이용 또는
    구매하기 위해 사용되는 가상의 데이터로서 회사가 책정하고 무료로 지급하는
    것을 말합니다.</span
  >
</p>
<p style="text-align: left">
  <span style="-aw-import: ignore">&#xa0;</span>
</p>
<p style="text-align: left">
  <span
    >12. ‘게시물’이라 함은 이용자가 게시판에서 게시한 문자, 그림, 음성, 영상
    또는 이들의 조합으로 이루어진 정보를 말합니다.</span
  >
</p>
<p style="text-align: left">
  <span style="-aw-import: ignore">&#xa0;</span>
</p>
<p style="text-align: left">
  <span
    >13. 이 약관에서 사용하는 전문용어의 정의는 이미 정한 것을 제외하고는 관계
    법령에 의합니다.</span
  >
</p>
<p style="text-align: left">
  <span style="-aw-import: ignore">&#xa0;</span>
</p>
<p style="text-align: left">
  <span>제3조 회사정보의 공시</span>
</p>
<p style="text-align: left">
  <span style="-aw-import: ignore">&#xa0;</span>
</p>
<p style="text-align: left">
  <span
    >회사는 다음 각 호의 사항을 게임 초기화면이나 게임
    홈페이지(https://www.omnikade.com/)에 게시하여 이용자가 이를 바로 알 수
    있도록 합니다. 다만 회사의 개인정보처리방침과 구체적인 약관 내용은 링크를
    통해 확인할 있습니다.</span
  >
</p>
<p style="text-align: left">
  <span style="-aw-import: ignore">&#xa0;</span>
</p>
<p style="text-align: left">
  <span>1. 상호 및 대표자의 성명</span>
</p>
<p style="text-align: left">
  <span style="-aw-import: ignore">&#xa0;</span>
</p>
<p style="text-align: left">
  <span>2. 영업소 소재지(고객서비스센터 포함) 및 전자우편주소</span>
</p>
<p style="text-align: left">
  <span style="-aw-import: ignore">&#xa0;</span>
</p>
<p style="text-align: left">
  <span>3. 전화번호, 팩스번호</span>
</p>
<p style="text-align: left">
  <span style="-aw-import: ignore">&#xa0;</span>
</p>
<p style="text-align: left">
  <span>4. 사업자등록번호, 통신판매업 신고번호</span>
</p>
<p style="text-align: left">
  <span style="-aw-import: ignore">&#xa0;</span>
</p>
<p style="text-align: left">
  <span>5. 개인정보처리방침</span>
</p>
<p style="text-align: left">
  <span style="-aw-import: ignore">&#xa0;</span>
</p>
<p style="text-align: left">
  <span>6. 서비스 이용약관</span>
</p>
<p style="text-align: left">
  <span style="-aw-import: ignore">&#xa0;</span>
</p>
<p style="text-align: left">
  <span>7. 호스팅서비스를 제공하는 사업자의 상호</span>
</p>
<p style="text-align: left">
  <span style="-aw-import: ignore">&#xa0;</span>
</p>
<p style="text-align: left">
  <span style="-aw-import: ignore">&#xa0;</span>
</p>
<p style="text-align: left">
  <span style="-aw-import: ignore">&#xa0;</span>
</p>
<p style="text-align: left">
  <span>제4조 약관의 공시 및 개정</span>
</p>
<p style="text-align: left">
  <span style="-aw-import: ignore">&#xa0;</span>
</p>
<p style="text-align: left">
  <span
    >1. 회사는 이 약관의 구체적인 내용을 이용자가 알 수 있도록 게임
    초기화면이나 게임 홈페이지(https://www.omnikade.com/)에 본 약관의 조항들을
    게시하는 방법으로 이용자에게 공시합니다. 본 약관의 효력은 공시한 후에
    발생합니다.</span
  >
</p>
<p style="text-align: left">
  <span style="-aw-import: ignore">&#xa0;</span>
</p>
<p style="text-align: left">
  <span
    >2. 이용자는 회사가 지정한 메일주소에 메일(service@omnikade.com)을
    보냄으로써, 본 약관 내용에 대한 질의를 할 수 있으며, 회사는 합리적인 시간
    내에 답변합니다.</span
  >
</p>
<p style="text-align: left">
  <span style="-aw-import: ignore">&#xa0;</span>
</p>
<p style="text-align: left">
  <span
    >3. 회사는 게임콘텐츠 이용자의 편의를 위해 관련 약관을 작성하여야 합니다.
    약정할 약관의 효력이 발생하기에 앞서 회사는 쉬운 용어로 계약
    해제·해지조항, 면책조항 및 이용자에 대한 충전잔액반환이나 피해보상 등과
    같은 중요한 내용을 이용자가 쉽게 알아볼 수 있도록 작성하거나, 이러한
    중요한 조항들을 굵게 표시하거나 그 제시를 위해 팝업화면을
    제공합니다.</span
  >
</p>
<p style="text-align: left">
  <span style="-aw-import: ignore">&#xa0;</span>
</p>
<p style="text-align: left">
  <span
    >4. 회사는 「전자상거래 등에서의 소비자보호에 관한 법률」,
    「게임산업진흥에 관한 법률」, 「약관의 규제에 관한 법률」,
    「정보통신망이용촉진 및 정보보호 등에 관한 법률」, 「콘텐츠산업진흥법」 등
    관련 벌령에 근거하여, 위 법령에 위배하지 않는 전제 하에 이 약관을 보충
    또는 개정할 수 있으며, 약관에 대한 보충 및 개정은 동등한 법적 효력을
    가집니다.</span
  >
</p>
<p style="text-align: left">
  <span style="-aw-import: ignore">&#xa0;</span>
</p>
<p style="text-align: left">
  <span
    >5. 회사는 회사의 재량에 따라 본 약관을 수시로 개정할 수 있습니다. 회사가
    약관을 개정할 경우에는 개정약관 효력발생일의 최소 7일 이전부터 게임
    초기화면을 통해 이용자에게 이를 공지합니다. 다만, 이용자에게 불리하거나
    중대한 변경인 경우에는 최소 30일 이전부터 동일한 방법으로 이용자에게
    공지하며, 이용자가 인터넷에 연결하여 게임콘텐츠 접속 시 쉽게 확인할 수
    있도록 게임 내에서 공지하여야 합니다. 개정약관의 효력은 공시일 또는 공고
    실시일로부터 발생합니다.</span
  >
</p>
<p style="text-align: left">
  <span style="-aw-import: ignore">&#xa0;</span>
</p>
<p style="text-align: left">
  <span
    >6. 회사가 약관을 개정할 경우에는 개정약관 공지 후 개정약관의 적용에 대한
    이용자의 동의 여부를 확인합니다. 개정약관 공지시 이용자가 동의 또는 거부의
    의사표시를 하지 않으면 승낙한 것으로 간주하겠다는 내용도 함께 공지한
    경우에는 이용자가 약관 시행일까지 거부의사를 표시하지 않는다면 개정약관에
    동의한 것으로 간주할 수 있습니다.</span
  >
</p>
<p style="text-align: left">
  <span style="-aw-import: ignore">&#xa0;</span>
</p>
<p style="text-align: left">
  <span
    >7. 이용자에게는 약관개정 확인을 위해 비정기적으로 사이트를 방문하거나
    공지 창을 확인하여야 할 의무가 있습니다. 만약 이용자가 변경된 약관의
    내용에 동의하지 않는 경우, 회사와 이용자는 계약을 해지(회원탈퇴)할 수
    있습니다.</span
  >
</p>
<p style="text-align: left">
  <span style="-aw-import: ignore">&#xa0;</span>
</p>
<p style="text-align: left">
  <span>제5조 약관 외 준칙</span>
</p>
<p style="text-align: left">
  <span style="-aw-import: ignore">&#xa0;</span>
</p>
<p style="text-align: left">
  <span
    >회사는 이 약관에 포함되지 아니한 사항에 관하여 「전자상거래 등에서의
    소비자보호에 관한 법률」, 「게임산업진흥에 관한 법률」, 「약관의 규제에
    관한 법률」, 「정보통신망이용촉진 및 정보보호 등에 관한 법률」,
    「콘텐츠산업진흥법」등 관련 법령을 참조하여 따릅니다.</span
  >
</p>
<p style="text-align: left">
  <span style="-aw-import: ignore">&#xa0;</span>
</p>
<p style="text-align: left">
  <span style="-aw-import: ignore">&#xa0;</span>
</p>
<p style="text-align: left">
  <span>제6조 운영정책</span>
</p>
<p style="text-align: left">
  <span style="-aw-import: ignore">&#xa0;</span>
</p>
<p style="text-align: left">
  <span
    >1. 이용자의 권익을 보호하고 게임세계 내 질서를 유지하기 위하여 회사는
    아래와 같이 게임콘텐츠 운영정책(이하 “운영정책”)을 제정합니다.</span
  >
</p>
<p style="text-align: left">
  <span style="-aw-import: ignore">&#xa0;</span>
</p>
<p style="text-align: left">
  <span
    >2. 회사는 이용자가 운영정책의 내용을 구체적으로 이해할 수 있도록 게임
    초기화면이나 게임 홈페이지(https://www.omnikade.com/)에 이를
    공지합니다.</span
  >
</p>
<p style="text-align: left">
  <span style="-aw-import: ignore">&#xa0;</span>
</p>
<p style="text-align: left">
  <span
    >3. 이용자의 권리 또는 의무에 변경을 가져오는 것과 관련된 운영정책 개정의
    경우에는 본 약관 제4조(약관의 공시 및 개정)에 따릅니다. 만약 이용자의
    권리의무와 관련 없는 사항을 개정하는 경우, 본 약관 제6조 제2항의 방법으로
    공지할 수 있습니다.</span
  >
</p>
<p style="text-align: left">
  <span style="-aw-import: ignore">&#xa0;</span>
</p>
<p style="text-align: left">
  <span
    >4. 회사는 운영정책의 내용이 본 약관에서 정한 내용과 일치하도록 유지하며,
    운영정책에 대한 개정은 이용자가 예측 가능한 범위에 한하여 할 수
    있습니다.</span
  >
</p>
<p style="text-align: left">
  <span style="-aw-import: ignore">&#xa0;</span>
</p>
<p style="text-align: left">
  <span style="-aw-import: ignore">&#xa0;</span>
</p>
<p style="text-align: left">
  <span>제2장 이용조례</span>
</p>
<p style="text-align: left">
  <span style="-aw-import: ignore">&#xa0;</span>
</p>
<p style="text-align: left">
  <span style="-aw-import: ignore">&#xa0;</span>
</p>
<p style="text-align: left">
  <span>제7조 이용자 신청 및 방법</span>
</p>
<p style="text-align: left">
  <span style="-aw-import: ignore">&#xa0;</span>
</p>
<p style="text-align: left">
  <span
    >1. 회사가 제공하는 게임콘텐츠를 이용하고자 하는 경우 이용자는 게임
    초기화면이나 게임 홈페이지에서 이용신청서를 제출하여야 합니다.</span
  >
</p>
<p style="text-align: left">
  <span style="-aw-import: ignore">&#xa0;</span>
</p>
<p style="text-align: left">
  <span
    >2. 이용자는 이용신청서 작성 시 회사에서 필요로 하는 각종 정보를
    제공하여야 합니다.</span
  >
</p>
<p style="text-align: left">
  <span style="-aw-import: ignore">&#xa0;</span>
</p>
<p style="text-align: left">
  <span
    >3. 이용자는 제1항에 따른 이용신청서 제출 시 반드시 본인의 실명 및 실제
    정보를 기재하여야 합니다. 정보를 허위로 제공하거나 타인의 신원을 도용하는
    등 불법 행위를 행하였을 경우 회사는 당해 이용자에 대하여 제공하는 전부
    또는 일부 서비스를 중단할 수 있습니다.</span
  >
</p>
<p style="text-align: left">
  <span style="-aw-import: ignore">&#xa0;</span>
</p>
<p style="text-align: left">
  <span
    >4. 청소년(18세 미만의 자.「초·중등교육법 」제2조의 규정에 의한 고등학교에
    재학 중인 학생을 포함함)이 이용신청을 할 경우 법정대리인의 동의를 얻어야
    하고, 동의를 이미 받은 청소년이 이용신청을 할 경우에는 위 법령, 약관 및
    운영정책에 따르도록 합니다.</span
  >
</p>
<p style="text-align: left">
  <span style="-aw-import: ignore">&#xa0;</span>
</p>
<p style="text-align: left">
  <span style="-aw-import: ignore">&#xa0;</span>
</p>
<p style="text-align: left">
  <span>제8조 이용신청의 승낙과 제한</span>
</p>
<p style="text-align: left">
  <span style="-aw-import: ignore">&#xa0;</span>
</p>
<p style="text-align: left">
  <span
    >1. 이용신청을 하고자 하는 이용자는 기재할 계정과 개인정보를 준비하여야
    하며, 자신이 제공한 개인신원자료에 관한 정보의 진실성, 완전성 및 유효성을
    보증하여야 합니다. 회사는 이용조건에 부합되는 신청에 대하여 승낙할 수
    있습니다. 회사는 이용자의 이용신청을 승낙한 때부터 게임콘텐츠에 대한
    제공을 개시합니다. 다만, 일부 서비스의 경우에는 회사의 필요에 따라 지정된
    일자부터 서비스를 개시할 수 있으며, 특정 서비스에 대해서는 유료로 제공할
    수 있습니다.</span
  >
</p>
<p style="text-align: left">
  <span style="-aw-import: ignore">&#xa0;</span>
</p>
<p style="text-align: left">
  <span
    >2. 회사는 다음 각 호의 어느 하나에 해당하는 경우에는 신청을 거절할 수
    있습니다.</span
  >
</p>
<p style="text-align: left">
  <span style="-aw-import: ignore">&#xa0;</span>
</p>
<p style="text-align: left">
  <span>1) 제7조에 따른 이용자 신청 및 방법 규정에 위반하는 경우</span>
</p>
<p style="text-align: left">
  <span style="-aw-import: ignore">&#xa0;</span>
</p>
<p style="text-align: left">
  <span
    >2) 이용요금을 납부하지 않거나, 전액 납부하지 않고 잔액이 완전히 납부할 수
    있을 지 여부를 확인할 수 없는 경우</span
  >
</p>
<p style="text-align: left">
  <span style="-aw-import: ignore">&#xa0;</span>
</p>
<p style="text-align: left">
  <span
    >3) 미성년자(제7조 제4항)가 법정대리인의 동의를 얻지 아니하거나 동의를
    얻었음을 확인할 수 없는 경우</span
  >
</p>
<p style="text-align: left">
  <span style="-aw-import: ignore">&#xa0;</span>
</p>
<p style="text-align: left">
  <span>4) 최근 3개월 내 이용제한 기록이 있는 경우</span>
</p>
<p style="text-align: left">
  <span style="-aw-import: ignore">&#xa0;</span>
</p>
<p style="text-align: left">
  <span
    >5) 타인의 신용카드, 신원자료를 무단으로 도용하여 게임 가입에 사용하거나
    서비스이용요금을 결제하는 경우</span
  >
</p>
<p style="text-align: left">
  <span style="-aw-import: ignore">&#xa0;</span>
</p>
<p style="text-align: left">
  <span>6) 대한민국 이외의 국가에서 게임콘텐츠를 이용하고자 하는 경우</span>
</p>
<p style="text-align: left">
  <span style="-aw-import: ignore">&#xa0;</span>
</p>
<p style="text-align: left">
  <span>7) 게임콘텐츠 제공과 관련하여 일정한 제한을 둘 수 있는 경우</span>
</p>
<p style="text-align: left">
  <span style="-aw-import: ignore">&#xa0;</span>
</p>
<p style="text-align: left">
  <span
    >8) 기타 「게임산업진흥에 관한 법률」, 「정보통신망 이용촉진 및 정보보호
    등에 관한 관련 법률」등 규정에 위반하는 경우</span
  >
</p>
<p style="text-align: left">
  <span style="-aw-import: ignore">&#xa0;</span>
</p>
<p style="text-align: left">
  <span
    >9) 그 밖에 1호 내지 8호에 준하는 사유와 유사한 행위가 발생하는 경우</span
  >
</p>
<p style="text-align: left">
  <span style="-aw-import: ignore">&#xa0;</span>
</p>
<p style="text-align: left">
  <span
    >3. 회사는 이용자의 이용신청에 대하여 다음 각 호의 어느 하나에 해당하는
    경우에는 그 사유가 해소될 때까지 이용신청에 대한 승낙을 유보하거나 거절할
    수 있습니다. 다만, 업무상 또는 기술적인 장애로 인하여 회사가 서비스를
    제공할 수 없을 경우 사이트에 공시하거나 이용자에게 통지하여야
    합니다.</span
  >
</p>
<p style="text-align: left">
  <span style="-aw-import: ignore">&#xa0;</span>
</p>
<p style="text-align: left">
  <span
    >1) 회사 운영정책에 부합하지 아니한 이용신청을 한 경우(단, 이 경우
    신청인이 회사 정책 상응한 조건에 부합된다고 인정될 때까지)</span
  >
</p>
<p style="text-align: left">
  <span style="-aw-import: ignore">&#xa0;</span>
</p>
<p style="text-align: left">
  <span
    >2) 서비스 제공상의 장애 또는 이용요금 결제수단의 장애가 발생한 경우</span
  >
</p>
<p style="text-align: left">
  <span style="-aw-import: ignore">&#xa0;</span>
</p>
<p style="text-align: left">
  <span>3) 신청의 승낙에 기술상의 장애가 발생한 경우</span>
</p>
<p style="text-align: left">
  <span style="-aw-import: ignore">&#xa0;</span>
</p>
<p style="text-align: left">
  <span
    >4. 회사는 서비스를 제공함에 있어 이용자에 대하여 본 약관 외에 별도
    서비스약관의 체결을 요구할 수 있습니다. 별도의 약관체결이 요구되는 게임은
    이용자의 동의 및 이용신청 후 이용 가능합니다.</span
  >
</p>
<p style="text-align: left">
  <span style="-aw-import: ignore">&#xa0;</span>
</p>
<p style="text-align: left">
  <span
    >5. 회사는 업무상 또는 기술상 특별한 지장이 없는 한, 연중무휴 1일 24시간
    서비스 제공을 원칙으로 합니다. 다만, 시스템 정기점검, 서버의 증설 및 교체,
    새로운 게임 내용의 추가, 각종 버그 패치, 새로운 서비스로의 교체 등 운영상
    필요한 경우, 일정기간 서비스를 일시 종료시킬 수 있으며, 이러한 경우 회사는
    사전에 그 내용 및 시간을 홈페이지에 공지합니다. 다만, 회사가 사전에 통지할
    수 없는 부득이한 사유가 있는 경우 사후에 통지할 수 있습니다.</span
  ><span>&#xa0;</span>
</p>
<p style="text-align: left">
  <span style="-aw-import: ignore">&#xa0;</span>
</p>
<p style="text-align: left">
  <span>6. 회사는 이용자에게 아래와 같은 게임콘텐츠를 제공합니다.</span>
</p>
<p style="text-align: left">
  <span style="-aw-import: ignore">&#xa0;</span>
</p>
<p style="text-align: left">
  <span>1) 게임 서비스 및 관련 서비스</span>
</p>
<p style="text-align: left">
  <span style="-aw-import: ignore">&#xa0;</span>
</p>
<p style="text-align: left">
  <span>2) 소셜 네트워크 서비스 (SNS)</span>
</p>
<p style="text-align: left">
  <span style="-aw-import: ignore">&#xa0;</span>
</p>
<p style="text-align: left">
  <span
    >3) 기타 회사가 자체 개발하거나 다른 회사와의 협력 계약 등 방식을 통해
    이용자에게 제공하는 일체의 서비스</span
  >
</p>
<p style="text-align: left">
  <span style="-aw-import: ignore">&#xa0;</span>
</p>
<p style="text-align: left">
  <span
    >7. 회사는 이용자에게 서비스를 제공함에 있어 관련 법령, 이용자의 연령,
    서비스의 이용 절차에 따라 일부 서비스 이용 등을 제한할 수 있습니다. 이
    경우 회사는 해당 내용을 사전에 이용자에게 안내합니다.</span
  >
</p>
<p style="text-align: left">
  <span style="-aw-import: ignore">&#xa0;</span>
</p>
<p style="text-align: left">
  <span
    >8. 회사는 이용자의 편의를 위하여 일부 서비스에 대해 ‘임시회원’ 기능을
    제공할 수 있습니다. 단, 임시회원 기능 이용 중 아래 각 호에 해당하는 경우
    서비스 이용기록 및 구매기록이 삭제되거나 기록을 확인할 수 없는 문제가
    발생할 수 있습니다. 따라서 이러한 사실에 대해 회사는 서비스 최초 이용 시
    팝업 등으로 공지할 예정이며 회원인증을 통한 서비스 이용을 권장하며
    서비스별로 임시회원이 회원인증을 받는 방식이 다르므로 자세한 사항은
    고객센터 메일로 문의 바랍니다.</span
  >
</p>
<p style="text-align: left">
  <span>1) 모바일 기기를 변경한 경우</span>
</p>
<p style="text-align: left">
  <span style="-aw-import: ignore">&#xa0;</span>
</p>
<p style="text-align: left">
  <span>2)</span><span>&#xa0;</span
  ><span> 모바일 기기를 개조하거나 초기화한 경우</span>
</p>
<p style="text-align: left">
  <span style="-aw-import: ignore">&#xa0;</span>
</p>
<p style="text-align: left">
  <span>3)</span><span>&#xa0;</span
  ><span> 모바일 기기에서 어플리케이션 등 콘텐츠를 삭제한 경우</span>
</p>
<p style="text-align: left">
  <span style="-aw-import: ignore">&#xa0;</span>
</p>
<p style="text-align: left">
  <span style="-aw-import: ignore">&#xa0;</span>
</p>
<p style="text-align: left">
  <span>제9조 이용자 계정 및 비밀번호</span>
</p>
<p style="text-align: left">
  <span style="-aw-import: ignore">&#xa0;</span>
</p>
<p style="text-align: left">
  <span
    >1. 회사가 허용하는 범위 내에서 이용자의 신분식별과 게임콘텐츠 이용을
    위하여 이용자가 선정한 문자, 숫자 또는 특수문자의 조합을 사용합니다.</span
  >
</p>
<p style="text-align: left">
  <span style="-aw-import: ignore">&#xa0;</span>
</p>
<p style="text-align: left">
  <span
    >2. 회사는 이용자 가입 시 제공한 신원정보에 대한 진실성과 유효성을 심사할
    수 있습니다.</span
  >
</p>
<p style="text-align: left">
  <span style="-aw-import: ignore">&#xa0;</span>
</p>
<p style="text-align: left">
  <span
    >3. 이용자는 자신의 계정과 비밀번호를 적절히 보관하여 이를 정확하고
    안전하게 사용할 의무가 있습니다. 이용자가 위 의무를 소홀히 함으로 인하여
    계정 및 비밀번호를 분실하거나 도용 당하거나, 이용자가 제3자에게 이용을
    승낙으로써 본인 또는 타인에게 발생하는 민사상 손해에 대하여는 이용자
    본인에게 법률상 책임이 있습니다. 이 경우 회사는 회사의 고의 또는 중과실이
    없는 한 면책됩니다.</span
  >
</p>
<p style="text-align: left">
  <span style="-aw-import: ignore">&#xa0;</span>
</p>
<p style="text-align: left">
  <span
    >4. 실제 정보로 가입한 이용자가 개인신원자료에 관한 기존 정보를 변경할
    필요가 있는 경우 회사는 적시에 유효하게 이러한 서비스를 제공하여야
    합니다.</span
  >
</p>
<p style="text-align: left">
  <span style="-aw-import: ignore">&#xa0;</span>
</p>
<p style="text-align: left">
  <span>5. 이용자는 적시에 본인의 비밀번호를 변경하여야 합니다.</span>
</p>
<p style="text-align: left">
  <span style="-aw-import: ignore">&#xa0;</span>
</p>
<p style="text-align: left">
  <span style="-aw-import: ignore">&#xa0;</span>
</p>
<p style="text-align: left">
  <span>제10조 이용자 정보의 제공 및 변경</span>
</p>
<p style="text-align: left">
  <span style="-aw-import: ignore">&#xa0;</span>
</p>
<p style="text-align: left">
  <span
    >1. 이용자는 제공한 개인신원자료에 관한 정보가 진실되고 완전하며 유효한
    것임을 보증하여야 합니다. 허위정보 제공으로 인해 발생한 손해에 대하여
    이용자 본인이 책임을 부담하여야 합니다.</span
  >
</p>
<p style="text-align: left">
  <span style="-aw-import: ignore">&#xa0;</span>
</p>
<p style="text-align: left">
  <span
    >2. 회원은 개인정보관리화면을 통해 언제든지 자신의 개인정보를 열람할 수
    있습니다. 다만, 서비스 관리를 위해 필요한 실명, 계정(ID) 등은 수정할 수
    없습니다.</span
  >
</p>
<p style="text-align: left">
  <span style="-aw-import: ignore">&#xa0;</span>
</p>
<p style="text-align: left">
  <span
    >3. 이용자가 등록정보를 변경하고자 하는 경우에는 온라인으로 수정을 하거나
    기타 유효한 연락수단으로 회사에 대하여 그 변경사항을 알려야 합니다.</span
  >
</p>
<p style="text-align: left">
  <span style="-aw-import: ignore">&#xa0;</span>
</p>
<p style="text-align: left">
  <span
    >4. 이용자가 회사에 정보 변경사항을 적시에 통지하지 않아 발생한 손해에
    대하여 회사는 책임을 부담하지 않습니다.</span
  >
</p>
<p style="text-align: left">
  <span style="-aw-import: ignore">&#xa0;</span>
</p>
<p style="text-align: left">
  <span style="-aw-import: ignore">&#xa0;</span>
</p>
<p style="text-align: left">
  <span>제11조 개인정보의 관리 및 안전</span>
</p>
<p style="text-align: left">
  <span style="-aw-import: ignore">&#xa0;</span>
</p>
<p style="text-align: left">
  <span style="-aw-import: ignore">&#xa0;</span>
</p>
<p style="text-align: left">
  <span
    >1. 회사는 위 법령에 따라 이용자계정의 안전성과 유효성을 보호하기 위해
    기술상 및 관리상의 합리적인 조치를 적극적으로 취합니다. 회사는 관계 법령의
    규정에 따라 이용자 등록정보를 포함한 이용자의 개인정보를 보호하기 위해
    노력합니다. 이용자 개인정보의 보호 및 사용에 대해서는 관련 법령 및 회사의
    개인정보처리방침이 적용됩니다. 단, 회사 서비스를 통해 링크된 제3자 제공의
    서비스(모든 제3자 사이트 포함)로부터 수집된 개인정보나 회사의 서비스를
    통해 광고 서비스를 하고 있는 다른 회사 또는 기관으로부터 수집된 정보에는
    회사의 개인정보처리방침이 적용되지 않습니다.</span
  ><span>&#xa0;</span>
</p>
<p style="text-align: left">
  <span style="-aw-import: ignore">&#xa0;</span>
</p>
<p style="text-align: left">
  <span
    >2. 회사에서 이용자를 대상으로 제공하는 게임콘텐츠와 계정정보 안전보호를
    위한 서비스는 이용자 자격이 없는 기타 제3의 이용자에게 적용되지
    않습니다.</span
  >
</p>
<p style="text-align: left">
  <span style="-aw-import: ignore">&#xa0;</span>
</p>
<p style="text-align: left">
  <span
    >3. 게임콘텐츠 이용에 동의한 것은 이용자의 자율적 의사표시이며, 이용자는
    계정정보의 노출이 수반되는 모든 리스크 및 해당 리스크로 인하여 발생한 모든
    직∙간접적, 파생적 손해에 대하여 책임을 부담하며, 회사는 이에 대한 일체적
    책임을 지지 않습니다. 다만, 법령에 따라 완전히 배제될 수 없을 경우 회사의
    배상책임 한도는 관련 사유로 인하여 이용자가 회사에 지급한 금액에 한합니다.
    회사는 이용자의 귀책사유로 노출된 이용자의 계정정보를 포함한 모든 손해에
    대해서 일체의 책임을 지지 않습니다.</span
  >
</p>
<p style="text-align: left">
  <span style="-aw-import: ignore">&#xa0;</span>
</p>
<p style="text-align: left">
  <span
    >4. 회사는 이용자의 본인 확인을 위해 필요한 경우, 대한민국 법령상 적법하게
    본인 확인을 할 수 있는 자격을 가진 제3의 기관이나 사업자(“본인확인기관”)를
    통하여 본인확인을 진행합니다. 회사는 본인확인기관으로부터 이용자가 입력한
    정보에 따른 본인 확인 결과만을 확인합니다.</span
  >
</p>
<p style="text-align: left">
  <span style="-aw-import: ignore">&#xa0;</span>
</p>
<p style="text-align: left">
  <span style="-aw-import: ignore">&#xa0;</span>
</p>
<p style="text-align: left">
  <span>제3장 회사 및 이용자의 의무</span>
</p>
<p style="text-align: left">
  <span style="-aw-import: ignore">&#xa0;</span>
</p>
<p style="text-align: left">
  <span style="-aw-import: ignore">&#xa0;</span>
</p>
<p style="text-align: left">
  <span>제12조 회사의 의무</span>
</p>
<p style="text-align: left">
  <span style="-aw-import: ignore">&#xa0;</span>
</p>
<p style="text-align: left">
  <span style="-aw-import: ignore">&#xa0;</span>
</p>
<p style="text-align: left">
  <span
    >1. 회사는 현행 법령, 정책을 엄격히 준수하고, 법률로 부여받은 권리를
    가지며, 법률 규정에 따라 의무를 이행합니다. 회사는 법령과 본 약관이
    금지하거나 미풍양속에 반하는 행위를 하지 않으며, 계속적이고 안정적인
    서비스를 제공하기 위하여 노력합니다.</span
  >
</p>
<p style="text-align: left">
  <span style="-aw-import: ignore">&#xa0;</span>
</p>
<p style="text-align: left">
  <span
    >2. 회사는 이용자 안전 및 개인정보(신용정보 포함) 보호를 위해 반드시
    보안시스템을 구축하며 개인정보처리방침을 공시하고 준수함과 동시에 본
    약관과 관련 법령을 준수하여야 합니다. 회사는 관련 법령 및 본 약관에서
    명확하게 정한 예외적인 경우를 제외하고는 이용자의 개인정보가 제3자에게
    누설되지 않도록 합니다.</span
  >
</p>
<p style="text-align: left">
  <span style="-aw-import: ignore">&#xa0;</span>
</p>
<p style="text-align: left">
  <span
    >3. 해커공격, 컴퓨터바이러스 감염, 시스템 붕괴, 네트워크 접속 끊김, 인터넷
    속도 저하, 소프트웨어 오류 등 문제로 인한 장애 및 위협이 발생하였을 경우,
    이용자는 위 각종 불량 정보, 네트워크 안전 및 인터넷의 장애 발생은 회사 및
    회사의 게임콘텐츠로 인한 것이 아니라는 점과 이러한 문제점 때문에
    이용자에게 생길 수 있는 불만, 구역질, 구토 등 정신적 손해 및 다른 손실에
    대하여 모두 자체적으로 책임을 부담하되, 회사가 책임을 지지 아니한다는 점을
    충분히 이해하여야 합니다.</span
  ><span>&#xa0;</span>
</p>
<p style="text-align: left">
  <span style="-aw-import: ignore">&#xa0;</span>
</p>
<p style="text-align: left">
  <span
    >4. 회사는 이용자로부터 제기되는 의견이나 불만이 정당하다고 인정될
    경우에는 즉시 처리합니다. 다만, 바로 처리하기가 곤란한 경우에는 전화나
    전자우편으로 그 사유와 처리예정일을 이용자에게 통보합니다.</span
  >
</p>
<p style="text-align: left">
  <span style="-aw-import: ignore">&#xa0;</span>
</p>
<p style="text-align: left">
  <span style="-aw-import: ignore">&#xa0;</span>
</p>
<p style="text-align: left">
  <span>제13조 이용자의 의무</span>
</p>
<p style="text-align: left">
  <span style="-aw-import: ignore">&#xa0;</span>
</p>
<p style="text-align: left">
  <span
    >1. 이용자는 게임콘텐츠 및 네트워크 서비스 이용에 있어서 본 약관에서
    정하고 있는 사항 및 운영정책 관련 법률 규정을 준수하여야 합니다. 이용자는
    다음 각 호의 행위 및 본 약관에 반하는 행위와 현행 법령, 정책에서 금지하는
    행위를 하여서는 아니 됩니다.</span
  ><span>&#xa0;</span><span>&#xa0;</span>
</p>
<p style="text-align: left">
  <span style="-aw-import: ignore">&#xa0;</span>
</p>
<p style="text-align: left">
  <span>1) 신청 또는 신청 변경 시 허위정보의 제공</span>
</p>
<p style="text-align: left">
  <span style="-aw-import: ignore">&#xa0;</span>
</p>
<p style="text-align: left">
  <span
    >2) 타인의 신원정보 도용(타인으로 가장하는 행위 및 타인과의 관계를 허위로
    표시하는 행위)</span
  >
</p>
<p style="text-align: left">
  <span style="-aw-import: ignore">&#xa0;</span>
</p>
<p style="text-align: left">
  <span
    >3) 회사의 임직원, 운영자, 기타 관계자를 사칭하는 행위(회사의 직원 또는
    게시판관리자로 가장하거나 사칭하는 행위, 타인의 명의를 도용하여 문장을
    게시하거나 메일을 발송하는 행위 포함)</span
  >
</p>
<p style="text-align: left">
  <span style="-aw-import: ignore">&#xa0;</span>
</p>
<p style="text-align: left">
  <span
    >4) 회사가 대외적으로 게시한 정보의 임의적 변경(서비스 공지정보에 대한
    변경행위 포함)</span
  >
</p>
<p style="text-align: left">
  <span style="-aw-import: ignore">&#xa0;</span>
</p>
<p style="text-align: left">
  <span
    >5) 회사가 외부 노출을 금지한 상품 및 정보(컴퓨터프로그램, 회사 동의 없이
    기타 이용자의 개인정보를 수집, 보관, 배포, 게시하는 행위)의 배포, 공유,
    전송, 또는 게시</span
  >
</p>
<p style="text-align: left">
  <span style="-aw-import: ignore">&#xa0;</span>
</p>
<p style="text-align: left">
  <span
    >6) 회사가 대외적으로 제공하지 않는 컴퓨터프로그램이나 설비의 제작, 배포,
    사용, 전송</span
  >
</p>
<p style="text-align: left">
  <span style="-aw-import: ignore">&#xa0;</span>
</p>
<p style="text-align: left">
  <span
    >7) 회사가 제공하는 게임 상품 또는 그 소프트웨어 요소 작품의 지식재산권을
    침해하는 모든 행위, 또는 회사 또는 기타 이용자의 합법적인 권익에 손해를
    끼치는 행위를 진행하는 행위. 회사는 이용자가 이러한 행위를 행하는 것을
    금지하여야 하며 기술상 조치를 취하여 이용자가 이러한 행위에 종사하는 것을
    방지할 수 있음.</span
  >
</p>
<p style="text-align: left">
  <span style="-aw-import: ignore">&#xa0;</span>
</p>
<p style="text-align: left">
  <span
    >8) 회사 및/또는 제3자에 대한 욕설, 저주, 모욕, 공격, 비방이 포함되는
    내용의 공유, 전송; 미신, 음란, 외설, 저질, 공포, 폭력, 흉악, 도박, 반란,
    민족혐오, 국가통일방해, 정권전복 등 불만·혐오한 언론의 함유; 위 내용들이
    들어 있는 사이트명칭, 게임 캐릭터 이름(재물성 도박 등 사행행위에 대한
    권유, 참여, 또는 상대방에게 수치심, 혐오감, 공포심을 느끼게 하는 언행,
    음향, 글, 화상, 영상의 전송, 공유, 배포행위 포함)의 설치</span
  >
</p>
<p style="text-align: left">
  <span style="-aw-import: ignore">&#xa0;</span>
</p>
<p style="text-align: left">
  <span
    >9) 게임 데이터(계정, 캐릭터, 게임아이템 등)의 유상 거래, 또는 권리의
    객체에 대한 담보, 대여 등을 제공하는 행위</span
  >
</p>
<p style="text-align: left">
  <span style="-aw-import: ignore">&#xa0;</span>
</p>
<p style="text-align: left">
  <span
    >10) 게임 데이터(계정, 캐릭터, 게임아이템 등)의 유상 거래를 공개적으로
    광고 선전하고 참여하거나 또는 권리의 객체에 대한 담보, 대여 등을 제공하는
    행위(기타 이용자의 캐릭터를 불법 사용하는 행위 포함)</span
  ><span>&#xa0;</span>
</p>
<p style="text-align: left">
  <span style="-aw-import: ignore">&#xa0;</span>
</p>
<p style="text-align: left">
  <span
    >11) 회사의 승낙 없이 광고를 발표하고 상품을 판매하는 상업 행위를
    진행하거나 불법적으로 회사 이익을 침해하는 여하한 행위를 진행, 또는 회사
    서비스 운영을 고의로 방해하거나 서비스의 안정적 운영을 방해할 수 있는 정보
    및 수신자의 명시적인 수신 거부 의사에 반하여 광고성 정보를 전송</span
  >
</p>
<p style="text-align: left">
  <span style="-aw-import: ignore">&#xa0;</span>
</p>
<p style="text-align: left">
  <span
    >12) 회사의 사전 승낙 없이 회사의 서비스 또는 서비스를 이용하여 얻은
    정보를 복제, 유통, 조장하거나 상업적으로 이용</span
  >
</p>
<p style="text-align: left">
  <span style="-aw-import: ignore">&#xa0;</span>
</p>
<p style="text-align: left">
  <span>13) 자기 또는 타인의 재산적 이익을 위한 회사 서비스의 이용 행위</span>
</p>
<p style="text-align: left">
  <span style="-aw-import: ignore">&#xa0;</span>
</p>
<p style="text-align: left">
  <span>14) 타인의 명예를 훼손하거나 손해를 가하는 행위</span>
</p>
<p style="text-align: left">
  <span style="-aw-import: ignore">&#xa0;</span>
</p>
<p style="text-align: left">
  <span
    >15) 명의자의 동의나 승낙 없이 결제 수단을 무단 도용하여 서비스 이용
    요금을 결제</span
  >
</p>
<p style="text-align: left">
  <span style="-aw-import: ignore">&#xa0;</span>
</p>
<p style="text-align: left">
  <span
    >16) 회사의 지식재산권, 제3자의 지식재산권, 초상권 등 기타 권리의
    침해</span
  >
</p>
<p style="text-align: left">
  <span style="-aw-import: ignore">&#xa0;</span>
</p>
<p style="text-align: left">
  <span
    >17) 프로그램의 버그를 악용하거나 서비스와 관련된 설비의 오작동이나 정보
    등의 파괴 및 혼란을 유발하는 컴퓨터바이러스 감염자료를 등록 또는 유포,
    관련 법령에 의하여 그 전송 또는 게시가 금지되는 정보(컴퓨터프로그램) 또는
    컴퓨터소프트웨어, 하드웨어, 전기통신 장비의 정상적인 가동을 방해, 파괴할
    목적으로 고안된 소프트웨어 바이러스, 다른 컴퓨터 코드, 파일, 프로그램을
    포함하고 있는 자료를 전송, 게시, 유포, 사용</span
  >
</p>
<p style="text-align: left">
  <span style="-aw-import: ignore">&#xa0;</span>
</p>
<p style="text-align: left">
  <span
    >18) 회사가 제공한 서비스 안에서나 홈페이지상에서 이용자 계정을 현금
    거래하는 행위</span
  >
</p>
<p style="text-align: left">
  <span style="-aw-import: ignore">&#xa0;</span>
</p>
<p style="text-align: left">
  <span>19) 결제와 관련된 모든 부정행위</span>
</p>
<p style="text-align: left">
  <span style="-aw-import: ignore">&#xa0;</span>
</p>
<p style="text-align: left">
  <span
    >20) 회사에서 제공하는 게임콘텐츠 사용법 외에 타인의 정상적인 게임콘텐츠
    이용을 방해 및 타인에게 손해를 가하는 행위</span
  >
</p>
<p style="text-align: left">
  <span style="-aw-import: ignore">&#xa0;</span>
</p>
<p style="text-align: left">
  <span
    >21) 기타 공공질서 및 미풍양속에 반하거나 반사회적 행동, 불법∙부당한
    행위와 관련 법령에 위배하는 행위</span
  >
</p>
<p style="text-align: left">
  <span style="-aw-import: ignore">&#xa0;</span>
</p>
<p style="text-align: left">
  <span
    >2. 이용자는 약관 내용, 회사의 게임콘텐츠 등 관련 주의사항을 성실하게
    열람하고 회사가 공시한 통지와 공지들을 준수할 의무가 있으며 회사의 업무에
    방해되는 행위를 하여서는 아니 됩니다. 회원은 수시로 관계 법령, 본 약관의
    규정을 비롯하여 회사가 통지하는 사항 등을 준수하여야 하며, 기타 회사의
    업무에 방해되는 행위를 하여서는 아니 됩니다. 이용자는 홈페이지의 공지사항
    및 게임운영정책 사항을 수시로 확인하여야 합니다.</span
  >
</p>
<p style="text-align: left">
  <span style="-aw-import: ignore">&#xa0;</span>
</p>
<p style="text-align: left">
  <span
    >3. 회사는 다음 각 호의 어느 하나에 해당하는 게임내용이나 서비스 사항에
    대하여 일정한 한도 내에서 제한을 둘 수 있으며, 이용자는 이를 충분히
    이해하고 관련 규정을 준수하여야 합니다.</span
  >
</p>
<p style="text-align: left">
  <span style="-aw-import: ignore">&#xa0;</span>
</p>
<p style="text-align: left">
  <span>1) 이용자의 계정명, 캐릭터명, 연맹명, 그룹명칭에 대한 제한</span>
</p>
<p style="text-align: left">
  <span style="-aw-import: ignore">&#xa0;</span>
</p>
<p style="text-align: left">
  <span>2) 채팅 내용과 방법에 대한 제한</span>
</p>
<p style="text-align: left">
  <span style="-aw-import: ignore">&#xa0;</span>
</p>
<p style="text-align: left">
  <span>3) 게시물 내용에 대한 일정한 제한</span>
</p>
<p style="text-align: left">
  <span style="-aw-import: ignore">&#xa0;</span>
</p>
<p style="text-align: left">
  <span>4) 게임플레이방법에 대한 제한</span>
</p>
<p style="text-align: left">
  <span style="-aw-import: ignore">&#xa0;</span>
</p>
<p style="text-align: left">
  <span
    >5) 기타 이용자의 게임콘텐츠 이용에 대한 합리적 권리를 침해하지 않는 범위
    내에서 회사가 게임콘텐츠 운영상 필요하다고 인정되는 제한</span
  >
</p>
<p style="text-align: left">
  <span style="-aw-import: ignore">&#xa0;</span>
</p>
<p style="text-align: left">
  <span
    >4. 이용자는 본 서비스를 이용하기 위하여 자신의 개인정보를 적절히
    관리하여야 합니다. 개인정보에 변경이 발생할 경우 상응한 변경 처리를 해야
    합니다. 이용자의 개인정보 변경이 지연되거나 누락되어 발생하는 손실은
    이용자가 부담합니다. 이용자의 주소, 연락처, 전자우편 등 이용계약 사항에
    변경이 발생할 경우 관련 절차를 통해 회사에 즉시 고지하여야 합니다.
    이용자가 제공한 가입정보 및 업데이트한 가입정보가 정확하지 않을 경우 및
    회원이 본조 제1항에 명시된 행위를 행할 경우 회사는 본 약관에 근거하여
    회원의 서비스이용을 제한 또는 중단할 수 있습니다.</span
  >
</p>
<p style="text-align: left">
  <span style="-aw-import: ignore">&#xa0;</span>
</p>
<p style="text-align: left">
  <span
    >5. 이용자는 콘텐츠를 다운로드 받은 디바이스에 대해 책임을 져야 하며 보관
    및 관리를 잘하여 타인이 이용자의 승낙 없이 서비스를 이용하거나 온라인
    게임콘텐츠를 이용하는 것을 방지하여야 합니다.</span
  >
</p>
<p style="text-align: left">
  <span style="-aw-import: ignore">&#xa0;</span>
</p>
<p style="text-align: left">
  <span
    >6. 이용자는 회사에서 공식적으로 인정한 경우를 제외하고는 서비스를
    이용하여 상품을 판매하는 등의 영업활동을 할 수 없고, 서비스를 통해 취득한
    아이템 및 ID 등을 거래에 제공하거나 제공받을 수 없고, 해킹, 광고로부터
    수익취득, 상용소프트웨어 불법배포 등의 행위를 할 수 없으며, 그와 같은
    행위를 준비하거나 홍보할 수 없습니다. 이를 위반하여 발생한 영업 활동의
    결과 및 손실, 관계기관에 의한 구속 등 법적 조치 등에 관해서는 전적으로
    이용자의 책임으로 하며 회사는 고의 또는 중과실이 없는 한 이에 대해 일체의
    책임을 지지 않습니다. 만약 이용자의 이와 같은 행위와 관련하여 회사에
    손해가 발생한 경우 이용자는 일체의 손해배상 책임을 부담합니다.</span
  ><span>&#xa0;</span><span>&#xa0;</span>
</p>
<p style="text-align: left">
  <span style="-aw-import: ignore">&#xa0;</span>
</p>
<p style="text-align: left">
  <span
    >7. 회사는 본 서비스 등을 유지하기 위하여 광고를 게재할 수 있으며,
    이용자는 서비스 이용 시 노출되는 광고 게재에 대하여 동의합니다.</span
  >
</p>
<p style="text-align: left">
  <span style="-aw-import: ignore">&#xa0;</span>
</p>
<p style="text-align: left">
  <span
    >1) 회사가 제공하는 제3자가 주체인 광고에 이용자가 참여하거나 교신 또는
    거래함으로써 발생하는 손실과 손해에 대해서 회사는 어떠한 책임도 부담하지
    않습니다.</span
  ><span>&#xa0;</span>
</p>
<p style="text-align: left">
  <span style="-aw-import: ignore">&#xa0;</span>
</p>
<p style="text-align: left">
  <span
    >2) 회사는 서비스 개선 및 이용자 대상 서비스 소개 등을 위한 목적으로
    이용자 개인에 대한 추가정보를 요구할 수 있으며, 동 요청에 대해 이용자는
    승낙하여 추가정보를 제공하거나 이를 거부할 수 있습니다.</span
  >
</p>
<p style="text-align: left">
  <span style="-aw-import: ignore">&#xa0;</span>
</p>
<p style="text-align: left">
  <span
    >3) 회사는 이용자의 사전 동의 하에 이용자로부터 수집한 개인정보를 활용하는
    경우 SMS(LMS), 스마트폰 알림(Push알림), 전자우편을 활용하여 발송할 수
    있으며, 이용자는 원하지 않는 경우 언제든지 수신을 거부할 수
    있습니다.</span
  >
</p>
<p style="text-align: left">
  <span style="-aw-import: ignore">&#xa0;</span>
</p>
<p style="text-align: left">
  <span
    >8. 이용자가 게임 운영정책사항에 위반되는 행위를 하였을 때 회사는
    이용자에게 게임 이용제재 혹은 경우에 따라 법적 책임을 물을 수
    있습니다.</span
  >
</p>
<p style="text-align: left">
  <span style="-aw-import: ignore">&#xa0;</span>
</p>
<p style="text-align: left">
  <span style="-aw-import: ignore">&#xa0;</span>
</p>
<p style="text-align: left">
  <span>제4장 게임콘텐츠 및 이용방법</span>
</p>
<p style="text-align: left">
  <span style="-aw-import: ignore">&#xa0;</span>
</p>
<p style="text-align: left">
  <span style="-aw-import: ignore">&#xa0;</span>
</p>
<p style="text-align: left">
  <span>제14조 게임콘텐츠의 변경</span>
</p>
<p style="text-align: left">
  <span style="-aw-import: ignore">&#xa0;</span>
</p>
<p style="text-align: left">
  <span
    >1. 이용자는 본 약관에 근거하여 회사로부터 게임콘텐츠를 제공받을 수
    있으며, 회사의 운영정책 및 회사가 설정한 게임규칙을 준수합니다.</span
  >
</p>
<p style="text-align: left">
  <span style="-aw-import: ignore">&#xa0;</span>
</p>
<p style="text-align: left">
  <span
    >1) 이용자는 이동통신사의 무선인터넷, 오픈마켓 스토어, 애플리케이션
    스토어, 온라인 사이트(포털, 모바일게임 사이트 또는 당사 홈페이지 등) 및
    기타 채널을 통하여 회사가 제공하는 콘텐츠를 구매하거나 다운로드할 수
    있습니다.</span
  >
</p>
<p style="text-align: left">
  <span style="-aw-import: ignore">&#xa0;</span>
</p>
<p style="text-align: left">
  <span
    >2) 회사가 개발한 게임 타이틀은 회사가 거래하는 유통업체 및 온라인 쇼핑몰
    등을 통하여 구매할 수 있습니다.</span
  >
</p>
<p style="text-align: left">
  <span style="-aw-import: ignore">&#xa0;</span>
</p>
<p style="text-align: left">
  <span
    >3) 회사가 제공하는 아이템 등은 온라인 사이트, 게임 및 애플리케이션 내에서
    제공하는 네트워크 서비스를 통하여 구매할 수 있습니다.</span
  >
</p>
<p style="text-align: left">
  <span style="-aw-import: ignore">&#xa0;</span>
</p>
<p style="text-align: left">
  <span
    >4) 이용자가 이동통신사의 무선인터넷 및 오픈마켓 스토어, 애플리케이션
    스토어를 통하여 모바일 게임, 애플리케이션을 구매하거나 네트워크 서비스를
    이용하는 경우 이동통신사에서 정하는 소정의 데이터 통화료가 부과될 수
    있습니다.</span
  >
</p>
<p style="text-align: left">
  <span style="-aw-import: ignore">&#xa0;</span>
</p>
<p style="text-align: left">
  <span
    >2. 회사가 게임을 통해 이용자에게 제공하는 게임세계는 회사가 창조한
    가상세계이며 회사가 게임콘텐츠의 제작, 변경, 유지보수, 수정에 대한
    포괄적인 권한을 보유합니다.</span
  >
</p>
<p style="text-align: left">
  <span style="-aw-import: ignore">&#xa0;</span>
</p>
<p style="text-align: left">
  <span
    >3. 회사는 현실세계로부터 게임세계를 보호하고 게임세계의 질서와 게임성을
    유지하기 위하여 필요한 조치를 취할 수 있습니다.</span
  >
</p>
<p style="text-align: left">
  <span style="-aw-import: ignore">&#xa0;</span>
</p>
<p style="text-align: left">
  <span
    >4. 회사는 수시로 운영방식을 변경할 수 있는 권한을 보유합니다. 즉,
    요금부과기준, 유료 소프트웨어의 기능, 유료 대상 및 시간 등 내용을 변경할
    수 있습니다 또한 회사는 게임콘텐츠 및 제공하는 서비스에 대하여 업그레이드,
    버전변경, 증가, 삭제, 수정하거나 기능변경이나 게임규칙을 변경하는 등 관련
    권한을 보유합니다. 이러한 내용의 변경을 하고자 하는 경우 회사는 이용자에게
    본 약관 제4조 제5항, 제6항의 방법에 따라 공지합니다. 이용자가 관련 변경에
    동의할 수 없는 경우 게임콘텐츠 에 대한 이용을 즉시 중단하여야 합니다.
    계속적 이용행위는 이용자가 개정된 운영방식에 대하여 동의한 것으로
    간주합니다.</span
  >
</p>
<p style="text-align: left">
  <span style="-aw-import: ignore">&#xa0;</span>
</p>
<p style="text-align: left">
  <span style="-aw-import: ignore">&#xa0;</span>
</p>
<p style="text-align: left">
  <span>제15조 서비스 제공의 중단</span>
</p>
<p style="text-align: left">
  <span style="-aw-import: ignore">&#xa0;</span>
</p>
<p style="text-align: left">
  <span
    >1. 회사는 경영방침에 따라 이용자에게 충분한 게임시간을 제공하여야 합니다.
    게임 서비스 일정은 게임 초기화면이나 게임
    홈페이지(https://www.omnikade.com/)에서 공지합니다. 회사는 운영상 또는
    기술상의 필요에 따라 제공하고 있는 서비스를 변경할 수 있습니다. 변경될
    서비스의 내용 및 변경 실시 일자 등에 대해서는 이용자에게 사전에
    통지합니다. 단, 회사가 사전에 통지할 수 없는 치명적인 고장 발생, 서버
    기기결함, 긴급 보안 문제 해결 등의 부득이한 사정이 있는 경우는 사후에
    통지할 수 있습니다.</span
  >
</p>
<p style="text-align: left">
  <span style="-aw-import: ignore">&#xa0;</span>
</p>
<p style="text-align: left">
  <span
    >2. 회사는 다음 각 호의 어느 하나에 해당하는 운영상 필요에 따라
    게임콘텐츠를 중단하고 보수를 진행할 수 있으며, 중단기간 동안 이용자에게
    발생한 손실에 대하여 배상할 의무는 없습니다.</span
  >
</p>
<p style="text-align: left">
  <span style="-aw-import: ignore">&#xa0;</span>
</p>
<p style="text-align: left">
  <span
    >1) 회사의 컴퓨터 등 설비의 보수점검, 교체, 정기점검 또는 게임콘텐츠의
    수정 및 기타 필요한 경우</span
  >
</p>
<p style="text-align: left">
  <span style="-aw-import: ignore">&#xa0;</span>
</p>
<p style="text-align: left">
  <span
    >2) 회사가 게임 상품 중 이용자가 버그 또는 패치를 사용하는 행위를
    효과적으로 억제하기 위하여 서비스 중단 유지보수 또는 복구 등 처리조치를
    채택할 수 있습니다. 서비스 중단 유지보수 기간 동안 이용자는 게임 상품의
    일부 게임서버 및/또는 일부 게임 구역에 접속할 수 없을 수도 있습니다.
    복구라 함은 모든 이용자의 게임 계정상의 게임 데이터를 어느 한 시점에서의
    기록에서 이전의 다른 한 시점의 기록으로 돌려 놓는 것을 말하며 이로 인해
    이용자가 이 기간 동안 정상적인 게임 행위를 통해 획득한 게임도구,
    게임아이템 등 게임물품의 등급, 포인트, 명예 등이 영구적으로 상실되거나
    또는 기타 손실을 초래할 수 있습니다.</span
  ><span>&#xa0;</span
  ><span>
    이에 대해 이용자는 충분히 숙지하고 자체적으로 책임을 부담하여야 하며,
    회사는 어떠한 배상도 하지 않습니다.</span
  >
</p>
<p style="text-align: left">
  <span style="-aw-import: ignore">&#xa0;</span>
</p>
<p style="text-align: left">
  <span
    >3) 회사는 재량에 따라 본 약관 및 본 약관에 따른 권리를 수시로 중단 또는
    종료할 수 있습니다. 이러한 중단, 종료는 회사의 해산, 말소, 합병, 분할 또는
    회사의 게임상품이나 그의 운영권한을 제3자에게 양도함으로써 초래될 수
    있으며, 또한 법령, 정책, 국가기관의 명령 또는 지진, 화재, 태풍, 파업, 전쟁
    등 불가항력 사유로 인하여 발생할 수도 있습니다. 그리고 위 사유 이외의 기타
    원인도 중단이나 종료를 초래할 수 있습니다.</span
  >
</p>
<p style="text-align: left">
  <span style="-aw-import: ignore">&#xa0;</span>
</p>
<p style="text-align: left">
  <span
    >3. 회사가 매 주 또는 격주에 한번씩 게임콘텐츠를 중단하여 보수를 진행해야
    하면, 회사는 최소한 24시간 이전에 게임 초기화면이나 게임 홈페이지에서
    서비스 중단을 고지합니다.</span
  >
</p>
<p style="text-align: left">
  <span style="-aw-import: ignore">&#xa0;</span>
</p>
<p style="text-align: left">
  <span
    >4. 만약 부득이한 사유로 회사가 이용자에게 서비스 중단 보수 등에 관한
    사항을 사전 고지 하지 못한 경우 빠른 시일 내에 게임 초기화면 및 게임
    홈페이지의 첫 페이지에서 서비스 중단 유지보수에 관한 통지를 사후 고지할 수
    있습니다.</span
  >
</p>
<p style="text-align: left">
  <span style="-aw-import: ignore">&#xa0;</span>
</p>
<p style="text-align: left">
  <span
    >5. 이용자가 회사가 제공하는 무료 상품 또는 서비스를 이용함으로써 손실을
    받게 된 경우, 회사의 고의 또는 중과실이 없는 한 회사는 이에 대한 책임을
    부담하지 않습니다.</span
  >
</p>
<p style="text-align: left">
  <span style="-aw-import: ignore">&#xa0;</span>
</p>
<p style="text-align: left">
  <span
    >6. 회사는 제2항 제3호에 의하여 게임콘텐츠를 중단할 경우, 30일 전에
    홈페이지에서 서비스 중단고지를 공지하여야 합니다. 부득이한 상황으로 적시에
    공지하지 못하였을 경우 사후에 다시 공지할 수 있습니다.</span
  >
</p>
<p style="text-align: left">
  <span style="-aw-import: ignore">&#xa0;</span>
</p>
<p style="text-align: left">
  <span
    >7. 회사가 제2항에 의하여 게임콘텐츠를 중단할 경우 이용자는 무료 서비스나
    이용기간에 대한 요금을 부과하는 유료서비스 또는 계속적 유료항목에 대하여
    신청할 수 없습니다.</span
  >
</p>
<p style="text-align: left">
  <span style="-aw-import: ignore">&#xa0;</span>
</p>
<p style="text-align: left">
  <span
    >8. 게임콘텐츠를 종료하는 경우 이용자는 사용기간이 남아 있지 않은
    유료정액제 또는 기간제 유료아이템에 대하여 배상을 청구할 수 없습니다.
    영구아이템의 이용기간은 서비스 종료 고지시 안내한 바에 따라 사용기간이
    종료됩니다</span
  >
</p>
<p style="text-align: left">
  <span style="-aw-import: ignore">&#xa0;</span>
</p>
<p style="text-align: left">
  <span
    >9. 회사는 서비스의 변경 및 중단으로 발생하는 문제에 대해서는 책임을 지지
    않습니다.</span
  >
</p>
<p style="text-align: left">
  <span style="-aw-import: ignore">&#xa0;</span>
</p>
<p style="text-align: left">
  <span style="-aw-import: ignore">&#xa0;</span>
</p>
<p style="text-align: left">
  <span>제16조 정보제공</span>
</p>
<p style="text-align: left">
  <span style="-aw-import: ignore">&#xa0;</span>
</p>
<p style="text-align: left">
  <span
    >회사는 게임 홈페이지에서 이용자에게 아래의 정보를 제공하여야
    합니다.</span
  >
</p>
<p style="text-align: left">
  <span style="-aw-import: ignore">&#xa0;</span>
</p>
<p style="text-align: left">
  <span>1. 상호:</span>
</p>
<p style="text-align: left">
  <span style="-aw-import: ignore">&#xa0;</span>
</p>
<p style="text-align: left">
  <span>2. 게임물 명칭:</span>
</p>
<p style="text-align: left">
  <span style="-aw-import: ignore">&#xa0;</span>
</p>
<p style="text-align: left">
  <span>3. 이용등급:</span>
</p>
<p style="text-align: left">
  <span style="-aw-import: ignore">&#xa0;</span>
</p>
<p style="text-align: left">
  <span>4. 등급분류번호:</span>
</p>
<p style="text-align: left">
  <span style="-aw-import: ignore">&#xa0;</span>
</p>
<p style="text-align: left">
  <span>5. 제작연월일:</span>
</p>
<p style="text-align: left">
  <span style="-aw-import: ignore">&#xa0;</span>
</p>
<p style="text-align: left">
  <span>6. 게임물제작업체 또는 배급업자의 신고번호 또는 등기번호:</span>
</p>
<p style="text-align: left">
  <span style="-aw-import: ignore">&#xa0;</span>
</p>
<p style="text-align: left">
  <span>7. 기타 회사가 필요하다고 인정하는 사항:</span>
</p>
<p style="text-align: left">
  <span style="-aw-import: ignore">&#xa0;</span>
</p>
<p style="text-align: left">
  <span style="-aw-import: ignore">&#xa0;</span>
</p>
<p style="text-align: left">
  <span>제17조 정보의 수집</span>
</p>
<p style="text-align: left">
  <span style="-aw-import: ignore">&#xa0;</span>
</p>
<p style="text-align: left">
  <span
    >1. 회사는 이용자의 게임 내에서의 채팅내용을 보관할 수 있습니다. 회사는
    이용자간의 분쟁 조정, 민원 처리 또는 게임 질서의 유지를 위하여 회사가
    유사한 분쟁 처리에 협조가 필요하다고 판단하는 경우에 관련 이용자의 정보를
    열람할 수 있고, 사전에 열람사유 및 열람범위를 이용자에게 고지합니다.
    열람한 내용에 대하여 엄격한 비밀유지의무를 준수하여야 하며, 권한을 부여
    받지 아니한 제3자는 절대로 열람할 수 없습니다. 계정 도용, 현금거래,
    언행폭력, 게임사기 등 행위와 연관될 경우 회사는 이용자에게 사전 고지 없이
    열람 할 수 있으며, 사후에 다시 이용자에게 관련 결정 및 사유를
    통지합니다.</span
  >
</p>
<p style="text-align: left">
  <span style="-aw-import: ignore">&#xa0;</span>
</p>
<p style="text-align: left">
  <span
    >2. 회사는 이용자의 디바이스 정보를 수집할 수 있으며, 게임콘텐츠 개선을
    위해 프로그램 최적화를 통해 게임콘텐츠 품질을 보증합니다.</span
  >
</p>
<p style="text-align: left">
  <span>&#xa0;</span>
</p>
<p style="text-align: left">
  <span style="-aw-import: ignore">&#xa0;</span>
</p>
<p style="text-align: left">
  <span>제18조 게임콘텐츠의 사용</span>
</p>
<p style="text-align: left">
  <span style="-aw-import: ignore">&#xa0;</span>
</p>
<p style="text-align: left">
  <span style="-aw-import: ignore">&#xa0;</span>
</p>
<p style="text-align: left">
  <span
    >1. 회사는 이용자에게 무료 게임콘텐츠와 유료 게임콘텐츠를 제공할 수
    있습니다. 이용자는 유료 게임콘텐츠를 자유로이 선택할 수 있습니다.</span
  >
</p>
<p style="text-align: left">
  <span style="-aw-import: ignore">&#xa0;</span>
</p>
<p style="text-align: left">
  <span
    >1) 회사는 이용자에게 아이템을 포함한 게임콘텐츠를 제공할 수 있습니다.
    회사가 제공한 게임콘텐츠는 회사의 정책에 따라서 이용자에게 이용기한을 정할
    수 있으며, 이러한 이용기한은 각 게임콘텐츠 서비스 세부이용 지침에서
    정하거나 각 게임콘텐츠 서비스 결제화면 등에 미리 게시하여 이용자에게
    고지합니다.</span
  >
</p>
<p style="text-align: left">
  <span style="-aw-import: ignore">&#xa0;</span>
</p>
<p style="text-align: left">
  <span
    >2) 회사는 게임콘텐츠에 필요한 최소한의 기술사양에 관한 정보를 서비스별
    홈페이지 권장사양정보에서 제공하며, 이용자는 게임콘텐츠를 이용하기 위하여
    서비스에 이용할 단말기 사양, 유무선 통신망의 품질 등이 해당 게임콘텐츠의
    이용에 적합한지를 사전에 확인하여야 합니다.</span
  >
</p>
<p style="text-align: left">
  <span style="-aw-import: ignore">&#xa0;</span>
</p>
<p style="text-align: left">
  <span
    >3) 회사는 게임콘텐츠 중 회원에게 치장성아이템 및 게임에 사용하는
    아이템(이하 '아이템'이라 함) 서비스를 유료 또는 무료로 구분하여 제공할 수
    있으며 아이템 관련 정책은 다음을 따릅니다.</span
  >
</p>
<p style="text-align: left">
  <span style="-aw-import: ignore">&#xa0;</span>
</p>
<p style="text-align: left">
  <span
    >a. 보증기간이 별도로 명시된 유료아이템의 경우는 구매 시 명기한 보증기간을
    따릅니다. 단, 회사가 이용자에게 지급한 무료아이템의 경우에는 서비스 제공
    기간을 보증하지 않습니다.</span
  >
</p>
<p style="text-align: left">
  <span style="-aw-import: ignore">&#xa0;</span>
</p>
<p style="text-align: left">
  <span
    >b. 보증기간이 '영구'로 표시된 유료아이템이나 보증기간이 표시되지 않은
    유료아이템(이하 '영구아이템'이라 함)에 대한 사용은 게임콘텐츠가 정상적으로
    제공되는 기간 동안의 이용권을 보장하는 것이며, 만약 이용자가 이용 약관상
    금지 행위를 하였거나 휴면 ID 또는 휴면 캐릭터로 분류되어 그에 따른
    제재로서 당해 ID 또는 캐릭터가 이용제한 또는 삭제되는 경우, 영구아이템의
    사용도 종료되며 회사는 이용자에 대하여 구매대금을 반환할 책임을 부담하지
    아니합니다.</span
  >
</p>
<p style="text-align: left">
  <span style="-aw-import: ignore">&#xa0;</span>
</p>
<p style="text-align: left">
  <span
    >c. 회사는 이용자의 부정한 이용을 방지하기 위하여 타인으로부터 선물 받은
    아이템이나 회사로부터 무료로 제공받은 아이템은 환불하지 않습니다.</span
  >
</p>
<p style="text-align: left">
  <span style="-aw-import: ignore">&#xa0;</span>
</p>
<p style="text-align: left">
  <span
    >d. 회사는 아이템의 보증 기간에 회사의 게임 내용의 변경 및 아이템 정책에
    따라 기존 아이템의 기능 등을 변경하거나 사용할 수 없도록 변경할 수
    있습니다. 이때, 유료로 구매한 아이템 사용이 불가능하게 되는 경우에는 30일
    이상 홈페이지 또는 관련 홈페이지에 공지하고 사용권이 남은 아이템을 유료로
    구매한 이용자에 한해 기존 아이템의 잔여 기간을 산정한 뒤 등가의 신규
    아이템 등으로 보상합니다.</span
  >
</p>
<p style="text-align: left">
  <span style="-aw-import: ignore">&#xa0;</span>
</p>
<p style="text-align: left">
  <span
    >4) 회사가 제공하는 아이템을 포함한 콘텐츠의 지식재산권을 포함한 모든
    소유권은 회사에 있으며, 이용자는 회사가 제공하는 범위 내에서 서비스
    이용권을 가집니다. 즉, 이용자는 회사가 제공하는 콘텐츠를 일정기간 동안
    회사가 제공하는 서비스 범위 내에서 이용할 권한을 갖는 것이며, 이를 회사가
    정한 방법 이외의 방법으로 이용 또는 사용하거나 양도, 판매할 수
    없습니다.</span
  >
</p>
<p style="text-align: left">
  <span style="-aw-import: ignore">&#xa0;</span>
</p>
<p style="text-align: left">
  <span
    >2. 게임비용을 지불하는 가격과 지불방식은 회사에 의하여 정합니다.
    게임콘텐츠에 대한 구매 대금은 원칙적으로 이동통신사와 애플리케이션 스토어,
    온라인사이트에서 정하는 방법, 정책 등에 따라 부과되며, 납부 방법 역시
    정해진 방법에 따라 납부하여야 합니다. 회사의 정책 및 결제업체(이동통신사,
    오픈마켓 스토어, 애플리케이션 스토어 등)의 정책, 정부의 방침 등에 따라 각
    결제 수단별로 결제 한도가 부여될 수 있습니다.</span
  >
</p>
<p style="text-align: left">
  <span style="-aw-import: ignore">&#xa0;</span>
</p>
<p style="text-align: left">
  <span
    >3. 이용자가 유료 게임콘텐츠를 선택할 경우에는 아래 사항에 유의하여야
    합니다.</span
  >
</p>
<p style="text-align: left">
  <span style="-aw-import: ignore">&#xa0;</span>
</p>
<p style="text-align: left">
  <span>1) 이용자는 게임콘텐츠 비용을 전액 납부하여야 합니다.</span>
</p>
<p style="text-align: left">
  <span style="-aw-import: ignore">&#xa0;</span>
</p>
<p style="text-align: left">
  <span
    >2) 유료 게임콘텐츠를 구매한 이용자는 회사가 지정한 방식에 따라 비용을
    지불하여야 합니다. 단, 무통장입금 방식으로 지급한 이용자는 신청한 날로부터
    3일 후 동등한 금액을 반드시 입금하여야 하며, 기한이 만료되었으나 미지불인
    경우 회사는 해당 거래를 취소할 권리가 있습니다.</span
  >
</p>
<p style="text-align: left">
  <span style="-aw-import: ignore">&#xa0;</span>
</p>
<p style="text-align: left">
  <span
    >3) 미성년자가 유료 게임아이템을 구매할 경우에는 부모 등 법정대리인의
    동의를 받아야 합니다. 동의를 받지 않은 유료 게임콘텐츠의 이용자는
    법정대리인에게 고지한 후 법정대리인이 비용의 지급을 취소할 수
    있습니다.</span
  >
</p>
<p style="text-align: left">
  <span style="-aw-import: ignore">&#xa0;</span>
</p>
<p style="text-align: left"><span>4.</span><span> 구독</span></p>
<p style="text-align: left">
  <span>1）</span><span>구독은</span><span> </span><span>자동</span
  ><span> </span><span>연장</span><span> </span><span>정액제</span
  ><span> </span><span>서비스로</span><span> </span><span>구매</span
  ><span> </span><span>후</span><span> </span><span>스토어</span><span> </span
  ><span>마켓에서</span><span> </span><span>자동</span><span> </span
  ><span>결제가</span><span> </span><span>됩니다</span><span>.</span>
</p>
<p style="text-align: left">
  <span>2） </span><span>자동</span><span> </span><span>연장</span
  ><span> </span><span>규칙</span><span>：</span><span>구독</span
  ><span> </span><span>기간</span><span> </span><span>만료</span><span> </span
  ><span>시</span><span> </span><span>스토어</span><span> </span
  ><span>마켓에서</span><span> </span><span>자동으로</span><span> </span
  ><span>구독료가</span><span> </span><span>결제되며</span><span> </span
  ><span>구독</span><span> </span><span>기간이</span><span> </span
  ><span>연장됩니다</span><span>.</span>
</p>
<p style="text-align: left">
  <span>3）</span><span>자동</span><span> </span><span>연장</span
  ><span> </span><span>서비스</span><span> </span><span>취소를</span
  ><span> </span><span>원하는</span><span> </span><span>경우</span
  ><span>, </span><span>최소</span><span> </span><span>구독</span
  ><span> </span><span>기간</span><span> </span><span>만료</span
  ><span> 24</span><span>시간</span><span> </span><span>전까지</span
  ><span> </span><span>스토어</span><span> </span><span>마켓에서</span
  ><span> </span><span>자동</span><span> </span><span>연장을</span
  ><span> </span><span>수동으로</span><span> </span><span>취소해야</span
  ><span> </span><span>합니다</span><span>. </span><span>자동</span
  ><span> </span><span>연장</span><span> </span><span>취소</span><span> </span
  ><span>후</span><span> </span><span>구독</span><span> </span
  ><span>기간</span><span> </span><span>만료</span><span> </span
  ><span>후</span><span> </span><span>자동으로</span><span> </span
  ><span>결제가</span><span> </span><span>되지</span><span> </span
  ><span>않고</span><span> </span><span>이번</span><span> </span
  ><span>구독</span><span> </span><span>기간이</span><span> </span
  ><span>만료될</span><span> </span><span>때까지</span><span> </span
  ><span>유효하며</span><span> </span><span>이미</span><span> </span
  ><span>결제한</span><span> </span><span>금액은</span><span> </span
  ><span>반납되지</span><span> </span><span>않습니다</span><span>.</span>
</p>
<p style="text-align: left">
  <span>4）</span><span>자동</span><span> </span><span>연장을</span
  ><span> </span><span>취소한</span><span> </span><span>후</span><span> </span
  ><span>언제든지</span><span> </span><span>다시</span><span> </span
  ><span>구독할</span><span> </span><span>수</span><span> </span
  ><span>있습니다</span><span>.</span>
</p>
<p style="text-align: left">
  <span>5）</span><span>해당</span><span> </span><span>구독은</span
  ><span> </span><span>구매</span><span> </span><span>후</span><span> </span
  ><span>즉시</span><span> </span><span>사용이</span><span> </span
  ><span>시작되거나</span><span> </span><span>게임</span><span> </span
  ><span>서비스에</span><span> </span><span>바로</span><span> </span
  ><span>적용되는</span><span> </span><span>콘텐츠이다</span><span>.</span>
</p>
<p style="text-align: left">
  <span style="-aw-import: ignore">&#xa0;</span>
</p>
<p style="text-align: left">
  <span>5. 게임 내 ‘캐시’ 및 ‘금전’의 사용</span>
</p>
<p style="text-align: left">
  <span style="-aw-import: ignore">&#xa0;</span>
</p>
<p style="text-align: left">
  <span
    >1) 이용자가 보유하고 있는 ‘캐시 또한 금전’ 중 게임 내에서 퀘스트를
    진행하면서 획득하거나, 이벤트로 지급하는 캐시 또는 금전을 ‘무료 캐시’ 및
    ‘무료 금전’이라 정의합니다. 획득한 무료 캐시 및 무료 금전은 유효기간,
    사용범위 등을 별도로 공지합니다.</span
  >
</p>
<p style="text-align: left">
  <span style="-aw-import: ignore">&#xa0;</span>
</p>
<p style="text-align: left">
  <span
    >2) 무료 캐시 및 무료 금전의 경우, 사용범위가 제한될 수 있습니다.</span
  >
</p>
<p style="text-align: left">
  <span style="-aw-import: ignore">&#xa0;</span>
</p>
<p style="text-align: left">
  <span
    >3) 무료 캐시 및 무료 금전은 환불 또는 보상의 대상이 되지 않습니다. </span
  ><span>결제를 통해 구매한 유료 상품</span><span>(</span
  ><span>게임 머니 포함</span><span>), </span
  ><span>무료 캐시 및 무료 금전이 공존하는 경우</span><span>, </span
  ><span>결제를 통해 구매한 유료 상품</span><span>(</span
  ><span>게임 머니 포함</span><span>)</span><span>이 먼저 소모됩니다</span
  ><span>. </span><span>단</span><span>, </span
  ><span>사정에 따라 상품의 이용 순서는 다르게 적용될 수 있으며</span
  ><span>, </span><span>이 경우 홈페이지</span><span>, </span
  ><span>공식카페 등을 통하여 공지합니다</span><span>.</span>
</p>
<p style="text-align: left">
  <span style="-aw-import: ignore">&#xa0;</span>
</p>
<p style="text-align: left">
  <span>제19조 사이버 포인트</span><span>&#xa0;</span>
</p>
<p style="text-align: left">
  <span style="-aw-import: ignore">&#xa0;</span>
</p>
<p style="text-align: left">
  <span
    >1. 회사는 이용자의 정보에 근거하여 이용자에게 사이버 포인트를 제공할 수
    있습니다(이용자 정보는 &lt;개인정보처리방침&gt; 참조). 회사가 정한
    유효기간 내에 사용되지 않은 사이버 포인트는 소멸될 수 있습니다.</span
  >
</p>
<p style="text-align: left">
  <span style="-aw-import: ignore">&#xa0;</span>
</p>
<p style="text-align: left">
  <span
    >2. 회사에서 제공한 사이버 포인트의 적립에 오류가 있을 경우, 이용자는
    회사에 정정 신청을 할 수 있으며, 회사는 확인한 후 인터넷에서 정정조치를
    취할 수 있습니다.</span
  >
</p>
<p style="text-align: left">
  <span style="-aw-import: ignore">&#xa0;</span>
</p>
<p style="text-align: left">
  <span
    >3. 회사는 이용자에게 제공한 게임콘텐츠가 곧 만기되는 경우, 회사는 1개월
    전에 유효한 방법으로 이용자에게 관련 통지를 발송하여야 합니다. </span
  ><span
    >회사가 이용자에게 게임콘텐츠의 제공을 중단할 때 이용자에게 미사용 사이버
    포인트가 아직 남아있는 경우, 미사용 사이버 포인트는 소멸됩니다.</span
  >
</p>
<p style="text-align: left">
  <span style="-aw-import: ignore">&#xa0;</span>
</p>
<p style="text-align: left">
  <span style="-aw-import: ignore">&#xa0;</span>
</p>
<p style="text-align: left">
  <span>제20조 지식재산권의 귀속</span>
</p>
<p style="text-align: left">
  <span style="-aw-import: ignore">&#xa0;</span>
</p>
<p style="text-align: left">
  <span
    >1. 본 약관 및 아래 모든 작품 또는 자료의 소유권 및 저작권을 포함한 모든
    지식 재산권은 회사에 귀속하고 관련 법령의 보호를 받습니다.</span
  >
</p>
<p style="text-align: left">
  <span style="-aw-import: ignore">&#xa0;</span>
</p>
<p style="text-align: left">
  <span
    >2. 이용자는 회사나 서비스 제공업자의 사전 허가 없이 회사가 제공한
    게임콘텐츠 관련 정보를 제3자에게 이용하게 할 수 없습니다.</span
  >
</p>
<p style="text-align: left">
  <span style="-aw-import: ignore">&#xa0;</span>
</p>
<p style="text-align: left">
  <span
    >3. 다음 각 호의 어느 하나에 해당하는 경우, 회사는
    &lt;개인정보처리방침&gt;에 명시되어 있는 방법으로 이용자 정보(이용자가
    게임단말기 혹은 게임콘텐츠를 통하여 획득한 정보 등, 및 문자, 이미지,
    오디오, 비디오 및 모든 정보)를 획득 및 사용할 수 있습니다</span
  >
</p>
<p style="text-align: left">
  <span style="-aw-import: ignore">&#xa0;</span>
</p>
<p style="text-align: left">
  <span
    >1) 이용자가 애플리케이션을 사용하는 관련 정보, 사용시간, 사용장소 및
    사용방식 포함 (이용자가 애플리케이션에 대하여 변경, 복제, 전달, 발행, 방송
    등 행위를 하였는지 여부)</span
  >
</p>
<p style="text-align: left">
  <span style="-aw-import: ignore">&#xa0;</span>
</p>
<p style="text-align: left">
  <span
    >2) 회사는 이용자의 사전 동의 없이 이용자가 제작한 작품을 판매, 임대,
    양도할 수 없습니다.</span
  >
</p>
<p style="text-align: left">
  <span style="-aw-import: ignore">&#xa0;</span>
</p>
<p style="text-align: left">
  <span
    >4. 회사는 이용자가 게임콘텐츠 내에 게시한 작품(예를 들어 게시판 게시물)에
    대하여 이용자의 명시적인 허락 없이는 무단으로 사용하지 않습니다. 이용자가
    서비스 범위 내에서 게시한 게시물의 저작권은 해당 저작권자에 귀속되고
    이용자는 해당 게시물을 수시로 삭제할 수 있습니다.</span
  ><span>&#xa0;</span>
</p>
<p style="text-align: left">
  <span style="-aw-import: ignore">&#xa0;</span>
</p>
<p style="text-align: left">
  <span
    >5. 회사는 이용자가 게임 내 및 게시판에서 제13조 (이용자의 의무)에서
    규정한 금지내용을 게시하였다고 판단하는 경우, 본 약관 및 관련 법령에
    근거하여 이에 대하여 상응하는 조치를 취할 수 있습니다.</span
  >
</p>
<p style="text-align: left">
  <span style="-aw-import: ignore">&#xa0;</span>
</p>
<p style="text-align: left">
  <span
    >6. 회사가 운영하는 게시판에 게시된 게시물로 인하여 법률상 이익이 침해된
    이용자는 회사에 해당 게시물의 삭제 또는 반박내용의 게재를 요청할 수
    있으며, 회사는 유효한 조치를 신속히 취하고, 이를 즉시 이용자에게
    통지하여야 합니다.</span
  >
</p>
<p style="text-align: left">
  <span style="-aw-import: ignore">&#xa0;</span>
</p>
<p style="text-align: left">
  <span
    >7. 이용자가 회원신분이 해제된 후에도 여전히 회사가 제공하는 게임콘텐츠를
    사용하는 경우, 회사는 제3항 규정에 따라 이용자 정보를 획득 및 사용할
    권리가 있습니다.</span
  >
</p>
<p style="text-align: left">
  <span style="-aw-import: ignore">&#xa0;</span>
</p>
<p style="text-align: left">
  <span
    >8. 이용자는 회사의 동의 없이 서비스 사용 시 획득한 정보를 영리의 목적으로
    사용하거나 제3자에게 사용하도록 제공하여서는 아니 됩니다.</span
  >
</p>
<p style="text-align: left">
  <span style="-aw-import: ignore">&#xa0;</span>
</p>
<p style="text-align: left">
  <span
    >9. 이용자가 게임콘텐츠 내에 게시한 게시물은 검색 혹은 서비스나 관련
    프로모션 활동 등으로 인하여 공개될 수 있습니다. 이때 해당 게시물은 필요한
    범위 내에서 일부 수정, 복제, 편집 후 게시될 수 있습니다. 이때 회사는
    저작권법의 내용을 준수하여야 하며, 이용자는 수시로 고객센터 혹은 서비스
    관리 기능을 통하여 관련 게시물을 삭제하거나 검색결과에서 배제하거나
    비공개로 설정하는 등 처리를 할 수 있습니다.</span
  >
</p>
<p style="text-align: left">
  <span style="-aw-import: ignore">&#xa0;</span>
</p>
<p style="text-align: left">
  <span
    >10. 이용자의 게시물이 저작권 등 문제로 인하여 제3자에 의하여 이의가
    제기된 경우, 회사가 해당 이의가 합리적인 이유가 있다고 판단하는 경우,
    회사는 이용자에게 사전 통지 없이 해당 게시물을 즉시 삭제하거나 등록을
    거부할 수 있습니다. 저작권 및 권리침해로 인한 게시금지 등 사항은 저작권법
    및 관련 법령의 규정에 따릅니다.</span
  >
</p>
<p style="text-align: left">
  <span style="-aw-import: ignore">&#xa0;</span>
</p>
<p style="text-align: left">
  <span
    >11. 이 외에는 이용자의 게시물 게시와 관련하여 아래 유의사항이
    있습니다.</span
  >
</p>
<p style="text-align: left">
  <span style="-aw-import: ignore">&#xa0;</span>
</p>
<p style="text-align: left">
  <span
    >1) 게시물로 인한 손실 혹은 문제는 이용자 개인이 책임을 지며 회사는 이에
    대하여 책임을 부담하지 않습니다.</span
  >
</p>
<p style="text-align: left">
  <span style="-aw-import: ignore">&#xa0;</span>
</p>
<p style="text-align: left">
  <span
    >2) 회사는 관리 상의 필요에 따라 사전 통지 없이 게시물을 이동할 수
    있습니다.</span
  >
</p>
<p style="text-align: left">
  <span style="-aw-import: ignore">&#xa0;</span>
</p>
<p style="text-align: left">
  <span
    >3) 타인이 이용자의 게시물이 그 타인의 권리를 침해하였음을 이유로 회사를
    상대로 손해배상 등을 청구한 경우, 게시물을 작성한 이용자는 회사가 면책될
    수 있도록 적극 협조하여야 합니다. 회사가 면책되지 못한 경우, 이용자는 이로
    인한 문제에 대한 책임을 부담하여야 합니다.</span
  >
</p>
<p style="text-align: left">
  <span style="-aw-import: ignore">&#xa0;</span>
</p>
<p style="text-align: left">
  <span
    >4) 이용자가 작성하거나 전달한 게시물이 다음 중 어느 하나에 해당하는 경우,
    회사는 사전 통지 없이 이를 삭제하거나 등록을 거부할 수 있습니다.</span
  >
</p>
<p style="text-align: left">
  <span style="-aw-import: ignore">&#xa0;</span>
</p>
<p style="text-align: left">
  <span
    >a. 다른 이용자 혹은 다른 사람에 대하여 비방, 사생활 침해, 모욕행위를
    하거나, 혹은 이로 인하여 타인의 명예를 훼손한 경우</span
  >
</p>
<p style="text-align: left">
  <span style="-aw-import: ignore">&#xa0;</span>
</p>
<p style="text-align: left">
  <span
    >b. 서비스의 안정적인 운영에 영향을 미치거나 미칠 가능성이 있는 경우</span
  >
</p>
<p style="text-align: left">
  <span style="-aw-import: ignore">&#xa0;</span>
</p>
<p style="text-align: left">
  <span>c. 범죄행위와 관련된 내용이라고 판단되는 경우</span>
</p>
<p style="text-align: left">
  <span style="-aw-import: ignore">&#xa0;</span>
</p>
<p style="text-align: left">
  <span
    >d. 회사 및 제3자의 지식재산권 등 기타 권리를 침해하는 내용이 있는
    경우.</span
  >
</p>
<p style="text-align: left">
  <span style="-aw-import: ignore">&#xa0;</span>
</p>
<p style="text-align: left">
  <span style="-aw-import: ignore">&#xa0;</span>
</p>
<p style="text-align: left">
  <span style="-aw-import: ignore">&#xa0;</span>
</p>
<p style="text-align: left">
  <span>제5장 청약 철회 및 계약해제</span>
</p>
<p style="text-align: left">
  <span>&#xa0;</span>
</p>
<p style="text-align: left">
  <span style="-aw-import: ignore">&#xa0;</span>
</p>
<p style="text-align: left">
  <span>제21조 청약 철회</span>
</p>
<p style="text-align: left">
  <span style="-aw-import: ignore">&#xa0;</span>
</p>
<p style="text-align: left">
  <span
    >1. 원칙적으로, 회사로부터 유료 게임상품을 구매한 이용자는 구매일 혹은
    지불일로부터 7일 내에 청약철회를 할 수 있습니다. 회사가 이용자에게
    제공하는 유료 콘텐츠는 청약철회가 가능한 콘텐츠와 청약철회가 제한되는
    콘텐츠로 구분되어 제공됩니다. 유료로 직접 구매하여 청약철회가 가능한 유료
    콘텐츠에 대해서는 구매 후 7일 기간 내에 청약철회를 할 수 있습니다. 단,
    선물 및 이벤트 보상 등의 방법으로 회사나 제3자로부터 제공받은 콘텐츠 또는
    구매 즉시 효과가 발생하는 등 일부 사용한 콘텐츠의 경우 등에는 관련법령에
    따라 청약철회가 제한될 수 있으며, 이 경우 회사는 관련 법령에서 정한 바에
    따른 조치를 취합니다.</span
  >
</p>
<p style="text-align: left">
  <span style="-aw-import: ignore">&#xa0;</span>
</p>
<p style="text-align: left">
  <span>2. 이용자는 아래 경우에 청약철회를 할 수 없습니다.</span>
</p>
<p style="text-align: left">
  <span style="-aw-import: ignore">&#xa0;</span>
</p>
<p style="text-align: left">
  <span
    >1) 이용자에게 책임이 있는 사유로 재화 등이 멸실 되거나 훼손된 경우</span
  >
</p>
<p style="text-align: left">
  <span style="-aw-import: ignore">&#xa0;</span>
</p>
<p style="text-align: left">
  <span>2) 이용자의 구매, 사용시간이 지나 다시 판매하기 곤란할 경우</span>
</p>
<p style="text-align: left">
  <span style="-aw-import: ignore">&#xa0;</span>
</p>
<p style="text-align: left">
  <span>3) 제품의 포장이 훼손된 경우</span>
</p>
<p style="text-align: left">
  <span style="-aw-import: ignore">&#xa0;</span>
</p>
<p style="text-align: left">
  <span>4) 서비스 이용과정에서 획득한 아이템의 경우</span>
</p>
<p style="text-align: left">
  <span style="-aw-import: ignore">&#xa0;</span>
</p>
<p style="text-align: left">
  <span
    >5) 구매 후 즉시 사용이 시작되거나 게임 서비스에 바로 적용되는 콘텐츠의
    경우</span
  >
</p>
<p style="text-align: left">
  <span style="-aw-import: ignore">&#xa0;</span>
</p>
<p style="text-align: left">
  <span
    >6) 부가적인 혜택이 제공되는 아이템 또는 묶음형 판매 콘텐츠에서 이미 추가
    혜택이 사용되거나 일부가 사용되어 회수가 불가능한 경우</span
  >
</p>
<p style="text-align: left">
  <span style="-aw-import: ignore">&#xa0;</span>
</p>
<p style="text-align: left">
  <span>7) 개봉 시 효용이 결정되는 캡슐형/확률형 아이템을 개봉한 경우</span>
</p>
<p style="text-align: left">
  <span style="-aw-import: ignore">&#xa0;</span>
</p>
<p style="text-align: left">
  <span>8) 회사가 이용자에게 무료로 지급한 재화 및 아이템</span>
</p>
<p style="text-align: left">
  <span style="-aw-import: ignore">&#xa0;</span>
</p>
<p style="text-align: left">
  <span>9) 타인으로부터 선물 받은 유료재화 및 유료아이템</span>
</p>
<p style="text-align: left">
  <span style="-aw-import: ignore">&#xa0;</span>
</p>
<p style="text-align: left">
  <span
    >10) 그 밖에 거래의 안전을 위하여 관련 법령에 의하여 2차 거래가 명시적으로
    금지된 경우</span
  >
</p>
<p style="text-align: left">
  <span style="-aw-import: ignore">&#xa0;</span>
</p>
<p style="text-align: left">
  <span
    >3. 회사는 본조 제2항 제2호부터 제8호까지 규정에 따라 이용자의 철회신청을
    받아들이지 아니할 경우에는 상품 포장에 표기 및 설명을 하거나 사전에
    이용자에게 테스트용 서비스를 제공합니다. 만약 회사가 이러한 조치를 하지
    않을 경우 이용자는 위 조항에도 불구하고 청약을 철회할 수 있습니다.</span
  >
</p>
<p style="text-align: left">
  <span style="-aw-import: ignore">&#xa0;</span>
</p>
<p style="text-align: left">
  <span
    >4. 이용자는 본조 제2항 제1호부터 제3호까지의 규정에도 불구하고 유료
    게임상품의 내용이 표시·광고 내용과 다르거나 계약내용과 다르게 이행된
    경우에는 구매 후 3개월 내에 청약철회를 신청할 수 있고, 구매한 상품과
    계약서에서 약정한 상품이 동일하지 아니함을 안 날로부터 30일 내에 청약을
    철회할 수 있습니다.</span
  >
</p>
<p style="text-align: left">
  <span style="-aw-import: ignore">&#xa0;</span>
</p>
<p style="text-align: left">
  <span
    >5. 미성년자가 법정대리인의 동의 없이 유료 게임상품을 구매한 경우,
    미성년자 또는 법정대리인은 회사에 청약철회를 요청할 수 있으며, 회사는
    법정대리인임을 증명할 수 있는 서류를 요구할 수 있습니다. </span
  ><span
    >단, 미성년자의 구매가 법정대리인으로부터 처분을 허락 받은 재산의 범위
    내인 경우 또는 미성년자가 사술 등을 사용하여 성인으로 하여금 믿게 한
    때에는 취소가 제한됩니다. 구매자의 미성년자 여부는 구매가 진행된 단말기
    또는 신용카드 등 결제수단의 명의자를 기준으로 판단됩니다.</span
  >
</p>
<p style="text-align: left">
  <span style="-aw-import: ignore">&#xa0;</span>
</p>
<p style="text-align: left">
  <span>6. </span><span>상기</span><span> </span><span>제</span><span>21</span
  ><span>조</span><span> </span><span>제</span><span>1</span><span>항</span
  ><span> </span><span>내지</span><span> </span><span>제</span><span>5</span
  ><span>항의</span><span> </span><span>경우</span><span> </span
  ><span>외에도</span><span> </span><span>이용자는</span><span> </span
  ><span>기타</span><span> </span><span>적용되는</span><span> </span
  ><span>법령에</span><span> </span><span>따라</span><span> </span
  ><span>청약</span><span> </span><span>철회를</span><span> </span
  ><span>할</span><span> </span><span>수</span><span> </span
  ><span>있습니다</span><span>. </span><span>단</span><span>, </span
  ><span>본</span><span> </span><span>약관</span><span> </span><span>제</span
  ><span>21</span><span>조</span><span> </span><span>제</span><span>1</span
  ><span>항</span><span> </span><span>내지</span><span> </span><span>제</span
  ><span>5</span><span>항의</span><span> </span><span>경우에</span
  ><span> </span><span>해당하지</span><span> </span><span>않고</span
  ><span> </span><span>여하한</span><span> </span><span>법령에</span
  ><span> </span><span>의하여</span><span> </span><span>청약</span
  ><span> </span><span>철회가</span><span> </span><span>허용되는</span
  ><span> </span><span>것도</span><span> </span><span>아닌</span><span> </span
  ><span>경우</span><span>, </span><span>이용자는</span><span> </span
  ><span>청약을</span><span> </span><span>철회할</span><span> </span
  ><span>수</span><span> </span><span>없습니다</span><span>.</span>
</p>
<p style="">
  <span style="-aw-import: ignore">&#xa0;</span>
</p>
<p style="text-align: left">
  <span
    >7. 이용자는 구두 또는 서면(전자메일 포함) 등 형식으로 청약철회를 할 수
    있습니다.</span
  >
</p>
<p style="text-align: left">
  <span style="-aw-import: ignore">&#xa0;</span>
</p>
<p style="text-align: left">
  <span style="-aw-import: ignore">&#xa0;</span>
</p>
<p style="text-align: left">
  <span>제22조 청약철회 등의 효과</span>
</p>
<p style="text-align: left">
  <span style="-aw-import: ignore">&#xa0;</span>
</p>
<p style="text-align: left">
  <span
    >1. 이용자가 청약철회를 한 경우 회사는 지체 없이 이용자의 유료 게임상품을
    회수 또는 삭제하고, 유료 게임상품을 회수 또는 삭제한 날로부터 3영업일
    이내에 지급받은 대금을 환급합니다. 동일한 방법으로 환불이 불가할 경우 이를
    사전에 고지합니다.</span
  ><span>&#xa0;</span>
</p>
<p style="text-align: left">
  <span style="-aw-import: ignore">&#xa0;</span>
</p>
<p style="text-align: left">
  <span
    >2. 이용자의 권익을 보장하기 위하여, 회사가 이용자에게 환급을 지연한
    때에는 그 지연기간에 대하여 전자상거래 등에서의 소비자보호에 관한 법률 및
    시행령에서 정하는 이율을 곱하여 산정한 지연이자를 지급합니다.</span
  >
</p>
<p style="text-align: left">
  <span style="-aw-import: ignore">&#xa0;</span>
</p>
<p style="text-align: left">
  <span
    >3. 위 대금을 환급함에 있어서 이용자가 신용카드나 그 밖에 이용자 계좌
    정보의 안전을 보장하는 유사한 방식으로 지급하였는데 해당 대금이 회사에
    입금되지 않은 경우, 회사는 신용카드를 발급한 금융기관 또는 결제수단을
    제공한 사업자(이하 “금융기관 등”)에게 빠른 시일 내로 이용자에게 지급받은
    금액을 환급할 것을 통지하여야 합니다. 회사가 위 금융기관 등으로부터 대금을
    이미 지급받은 경우, 회사는 해당 금액을 금융기관 등에 반환하고 금융기관
    등이 다시 이를 이용자에게 반환하여야 합니다. 회사는 위 금액 환급 관련
    사항을 이용자에게 고지하여야 합니다.</span
  >
</p>
<p style="text-align: left">
  <span style="-aw-import: ignore">&#xa0;</span>
</p>
<p style="text-align: left">
  <span
    >4. 회사는 이미 유료 콘텐츠 등이 일부 사용되거나 일부 소비된 경우에는 그
    콘텐츠 등의 일부 사용 또는 일부 소비에 의하여 이용자가 얻은 이익 또는 그
    콘텐츠의 공급에 든 비용에 상당하는 금액을 이용자에게 청구할 수
    있습니다</span
  ><span>&#xa0;</span>
</p>
<p style="text-align: left">
  <span style="-aw-import: ignore">&#xa0;</span>
</p>
<p style="text-align: left">
  <span
    >5. 이용자가 청약철회를 신청한 경우 제품 혹은 서비스의 반환에 필요한
    비용은 이용자가 부담하고, 회사는 이용자에게 청약철회를 이유로 위약금 또는
    손해배상을 청구할 수 없습니다.</span
  >
</p>
<p style="text-align: left">
  <span>&#xa0;</span>
</p>
<p style="text-align: left">
  <span style="-aw-import: ignore">&#xa0;</span>
</p>
<p style="text-align: left">
  <span>제23조 회사의 계약해지 신청</span>
</p>
<p style="text-align: left">
  <span style="-aw-import: ignore">&#xa0;</span>
</p>
<p style="text-align: left">
  <span
    >1. 이용자가 본 약관에서 정한 이용자의 의무를 위반한 경우, 회사는
    이용자에게 게임콘텐츠 계약의 해지를 요청할 수 있습니다. 회사는 이용자의
    실제 본인 여부를 확인한 후 필요한 조치를 취합니다.</span
  >
</p>
<p style="text-align: left">
  <span style="-aw-import: ignore">&#xa0;</span>
</p>
<p style="text-align: left">
  <span
    >2. 회사가 이용계약을 해지하는 경우 회사는 이용자에게 서면으로 다음 각
    호의 사항을 통보합니다.</span
  >
</p>
<p style="text-align: left">
  <span style="-aw-import: ignore">&#xa0;</span>
</p>
<p style="text-align: left">
  <span>1) 해지사유</span>
</p>
<p style="text-align: left">
  <span style="-aw-import: ignore">&#xa0;</span>
</p>
<p style="text-align: left"><span>2) 해지일</span><span>&#xa0;</span></p>
<p style="text-align: left">
  <span style="-aw-import: ignore">&#xa0;</span>
</p>
<p style="text-align: left">
  <span
    >3. 제1항에 따라 이용자는 유료서비스를 비롯한 게임콘텐츠의 사용권한을
    상실하고, 이로 인한 환불 및 손해배상을 청구할 수 없습니다.</span
  >
</p>
<p style="text-align: left">
  <span style="-aw-import: ignore">&#xa0;</span>
</p>
<p style="text-align: left">
  <span
    >4. 회사는 이용자가 현행법 위반 및 고의 또는 중대한 과실로 회사에 손해를
    입힌 경우에는 사전 통보 없이 이용계약을 해지할 수 있으며, 이 경우 회원은
    유료로 구매한 상품에 대해 사용권한이 상실되고 이로 인한 환불 및 손해배상을
    청구할 수 없습니다.</span
  >
</p>
<p style="text-align: left">
  <span style="-aw-import: ignore">&#xa0;</span>
</p>
<p style="text-align: left">
  <span
    >5. 회사는 회원의 계정 또는 캐릭터가 부당한 목적으로 사용되는 것을
    방지하고 보다 원활한 서비스 제공을 위하여 12개월 이상 접속기록이 없는
    회원의 계정 또는 캐릭터(이하 “휴면계정”이라고 함) 경우 해당 계정 또는
    캐릭터를 삭제할 수 있습니다. 휴면상태로 분류된 경우, 안내메일 또는
    공지사항 발표 후 일주일 간의 안내 기간을 거쳐 계정 또는 캐릭터의 모든
    정보가 삭제되며 복구되지 않습니다. 회원은 안내 기간 중 게임 접속 등을 통해
    휴면 상태를 해지할 수 있습니다.</span
  >
</p>
<p style="text-align: left">
  <span style="-aw-import: ignore">&#xa0;</span>
</p>
<p style="text-align: left">
  <span style="-aw-import: ignore">&#xa0;</span>
</p>
<p style="text-align: left">
  <span style="-aw-import: ignore">&#xa0;</span>
</p>
<p style="text-align: left">
  <span>제24조 이용자에 대한 제한조치</span>
</p>
<p style="text-align: left">
  <span style="-aw-import: ignore">&#xa0;</span>
</p>
<p style="text-align: left">
  <span
    >1. 회사는 이용자가 본 약관 및 관련 법령을 위반하는 경우 이용자에 대하여
    게임 내에서 일정한 제한조치를 설정할 수 있습니다. 구체적인 의무위반 사유
    및 제한조치 등은 개별 게임의 운영정책에서 정합니다.</span
  ><span>&#xa0;</span>
</p>
<p style="text-align: left">
  <span style="-aw-import: ignore">&#xa0;</span>
</p>
<p style="text-align: left">
  <span
    >1) 캐릭터의 일부 권한 제한: 일정한 기간 동안 캐릭터의 채팅 등 게임 기능
    제한</span
  >
</p>
<p style="text-align: left">
  <span style="-aw-import: ignore">&#xa0;</span>
</p>
<p style="text-align: left">
  <span
    >2) 캐릭터 사용 제한: 지정 이용자의 캐릭터에 대한 임시 계정정지 혹은
    영구정지</span
  >
</p>
<p style="text-align: left">
  <span style="-aw-import: ignore">&#xa0;</span>
</p>
<p style="text-align: left">
  <span
    >3) 계정의 사용 제한: 지정 게임계정에 대한 임시 계정정지 혹은
    영구정지</span
  >
</p>
<p style="text-align: left">
  <span style="-aw-import: ignore">&#xa0;</span>
</p>
<p style="text-align: left">
  <span
    >4) 이용자의 사용 제한: 지정 이용자에 대한 임시 계정정지 혹은
    영구정지.</span
  >
</p>
<p style="text-align: left">
  <span style="-aw-import: ignore">&#xa0;</span>
</p>
<p style="text-align: left">
  <span
    >2. 회사의 제한조치가 정당한 경우, 이용자는 계정이 정지된 기간 동안의
    손해에 대하여 책임을 지며, 회사는 이에 대하여 배상책임을 부담하지
    않습니다.</span
  >
</p>
<p style="text-align: left">
  <span>&#xa0;</span>
</p>
<p style="text-align: left">
  <span style="-aw-import: ignore">&#xa0;</span>
</p>
<p style="text-align: left">
  <span>제25조 임시조치의 사용</span>
</p>
<p style="text-align: left">
  <span style="-aw-import: ignore">&#xa0;</span>
</p>
<p style="text-align: left">
  <span
    >1. 회사는 아래에 해당하는 경우 이용자에 대하여 임시 계정정지 조치, 즉
    이용자의 게임 계정을 임시적으로 정지함으로써 정지 기간 동안 이용자가
    회사의 게임 상품에 등록할 수 없고 관련 서비스를 사용할 수 없도록 할 수
    있습니다.</span
  >
</p>
<p style="text-align: left">
  <span style="-aw-import: ignore">&#xa0;</span>
</p>
<p style="text-align: left">
  <span>1) 이용자의 계정이 해킹 또는 타인에 의하여 도용된 경우</span>
</p>
<p style="text-align: left">
  <span style="-aw-import: ignore">&#xa0;</span>
</p>
<p style="text-align: left">
  <span>2) 개인이용자 또는 기업에서 불법프로그램이 사용되는 경우</span>
</p>
<p style="text-align: left">
  <span style="-aw-import: ignore">&#xa0;</span>
</p>
<p style="text-align: left">
  <span
    >3) 회사가 임시정지 외의 기타 임시적인 수단을 통하여 관련 상황을
    조사하여야 하는 경우</span
  >
</p>
<p style="text-align: left">
  <span style="-aw-import: ignore">&#xa0;</span>
</p>
<p style="text-align: left">
  <span
    >2. 회사는 조사가 완료된 후 임시조치를 해제하고 정지된 기간만큼 이용자의
    게임콘텐츠 시간을 반환하거나 연장합니다. 단, 회사의 조사 결과 관련 법령 및
    본 약관에 위반한 것으로 판단된 이용자에 대해서는 그러하지
    아니합니다.</span
  >
</p>
<p style="text-align: left">
  <span style="-aw-import: ignore">&#xa0;</span>
</p>
<p style="text-align: left">
  <span style="-aw-import: ignore">&#xa0;</span>
</p>
<p style="text-align: left">
  <span>제26조 제한조치 사유 및 절차</span>
</p>
<p style="text-align: left">
  <span style="-aw-import: ignore">&#xa0;</span>
</p>
<p style="text-align: left">
  <span
    >1. 회사는 이용자가 본 약관을 위반한 행위의 내용, 정도, 횟수, 결과 등 제반
    요소를 고려하여 제한조치를 부과하는 구체적인 이유와 절차를 정합니다.</span
  >
</p>
<p style="text-align: left">
  <span style="-aw-import: ignore">&#xa0;</span>
</p>
<p style="text-align: left">
  <span
    >2. 회사가 제25조에서 정한 제한조치를 하는 경우에는, 전자우편을 통하거나
    게임 공식 홈페이지(https://www.omnikade.com/)에서 이용자에게 아래 내용에
    대하여 고지하여야 합니다.</span
  ><span>&#xa0;</span>
</p>
<p style="text-align: left">
  <span style="-aw-import: ignore">&#xa0;</span>
</p>
<p style="text-align: left">
  <span>1) 이용제한 이유</span>
</p>
<p style="text-align: left">
  <span style="-aw-import: ignore">&#xa0;</span>
</p>
<p style="text-align: left">
  <span>2) 이용제한 유형 및 기간</span>
</p>
<p style="text-align: left">
  <span style="-aw-import: ignore">&#xa0;</span>
</p>
<p style="text-align: left">
  <span>3) 이용제한에 대한 이의신청 방법</span>
</p>
<p style="text-align: left">
  <span style="-aw-import: ignore">&#xa0;</span>
</p>
<p style="text-align: left">
  <span style="-aw-import: ignore">&#xa0;</span>
</p>
<p style="text-align: left">
  <span>제27조 사용제한에 대한 이의신청</span>
</p>
<p style="text-align: left">
  <span style="-aw-import: ignore">&#xa0;</span>
</p>
<p style="text-align: left">
  <span
    >1. 회사의 제한조치에 대하여 이의가 있는 경우, 이용자는 통지를 받은
    날로부터 서면으로 회사에 이의를 제출하여야 합니다.</span
  >
</p>
<p style="text-align: left">
  <span style="-aw-import: ignore">&#xa0;</span>
</p>
<p style="text-align: left">
  <span
    >2. 회사는 이용자의 서면신청을 받은 날로부터 15일 이내에 서면 또는
    전자우편을 통하여 답변을 하여야 합니다. 회사가 15일 이내에 답변하지 못한
    경우에는 지연의 이유 및 처리 일정을 이용자에게 통보하여야 합니다.</span
  >
</p>
<p style="text-align: left">
  <span style="-aw-import: ignore">&#xa0;</span>
</p>
<p style="text-align: left">
  <span>3. 회사는 위 답변에 따라 상응하는 조치를 취하여야 합니다.</span>
</p>
<p style="text-align: left">
  <span style="-aw-import: ignore">&#xa0;</span>
</p>
<p style="text-align: left">
  <span style="-aw-import: ignore">&#xa0;</span>
</p>
<p style="text-align: left">
  <span>제6장 배상 및 환불</span>
</p>
<p style="text-align: left">
  <span style="-aw-import: ignore">&#xa0;</span>
</p>
<p style="text-align: left">
  <span style="-aw-import: ignore">&#xa0;</span>
</p>
<p style="text-align: left">
  <span>제28조 손해배상</span>
</p>
<p style="text-align: left">
  <span style="-aw-import: ignore">&#xa0;</span>
</p>
<p style="text-align: left">
  <span
    >1. 회사가 고의 또는 중과실로 이용자에게 손해를 끼친 경우, 회사는
    이용자에게 그 손해를 배상하여야 합니다.</span
  >
</p>
<p style="text-align: left">
  <span style="-aw-import: ignore">&#xa0;</span>
</p>
<p style="text-align: left">
  <span
    >2. 이용자가 본 약관의 규정을 위반함으로 인하여 회사에 손해를 끼친 경우,
    이용자는 회사에게 그 손해를 배상을 할 책임이 있습니다.</span
  >
</p>
<p style="text-align: left">
  <span style="-aw-import: ignore">&#xa0;</span>
</p>
<p style="text-align: left">
  <span
    >3. 이용자가 게임콘텐츠를 이용하면서 행한 불법행위나 본 약관 위반행위로
    인하여 회사가 이용자 이외의 제3자로부터 손해배상청구 또는 소송을 비롯한
    각종 이의제기를 받는 경우, 이용자는 자신의 책임과 비용으로 회사를
    면책시켜야 하며, 관련 책임과 비용은 이용자가 부담하여야 합니다.</span
  ><span>
    회사가 면책되지 못한 경우 이용자는 그로 인하여 회사에 발생한 모든 손해를
    배상할 책임이 있습니다.</span
  >
</p>
<p style="text-align: left">
  <span style="-aw-import: ignore">&#xa0;</span>
</p>
<p style="text-align: left">
  <span
    >4. 회사는 무료로 제공하는 서비스와 관련하여 발생하는 사항에 대해서는
    어떠한 손해도 책임을 지지 않습니다. 단, 회사의 고의나 중과실로 인한 손해인
    경우는 예외로 합니다.</span
  >
</p>
<p style="text-align: left">
  <span style="-aw-import: ignore">&#xa0;</span>
</p>
<p style="text-align: left">
  <span style="-aw-import: ignore">&#xa0;</span>
</p>
<p style="text-align: left">
  <span>제29조 환불</span>
</p>
<ol type="1" style="margin: 0pt; padding-left: 0pt">
  <li
    style="
      text-align: left;

      list-style-position: inside;
    "
  >
    <span>아래의 경우에 해당하면 이용자는 환불을 요청할 수 있습니다</span
    ><span>.</span>
  </li>
</ol>
<ol type="1" class="awlist1" style="margin: 0pt; padding-left: 0pt">
  <li
    style="
      text-align: left;

      list-style-position: inside;
      -aw-list-padding-sml: 3.33pt;
    "
  >
    <span
      style="
        width: 3.33pt;
        font: 7pt 'Times New Roman';
        display: inline-block;
        -aw-import: ignore;
      "
      >&#xa0; </span
    ><span>이용자가 이용약관 제</span><span>21</span
    ><span>조에 따라 청약을 철회할 경우</span>
  </li>
  <li
    style="
      text-align: left;

      list-style-position: inside;
      -aw-list-padding-sml: 3.33pt;
    "
  >
    <span
      style="
        width: 3.33pt;
        font: 7pt 'Times New Roman';
        display: inline-block;
        -aw-import: ignore;
      "
      >&#xa0; </span
    ><span
      >적용되는 다른 법령에 당사가 이용자에게 환불해야 하는 경우가 명확히
      규정된 경우</span
    >
  </li>
</ol>
<p style="">
  <span style="-aw-import: ignore">&#xa0;</span>
</p>
<p style="text-align: left">
  <span>2. </span
  ><span
    >제1항에 따라 이용자의 환불 이유가 인정되는 경우 이용자는 이를 환불받을 수
    있습니다. </span
  ><span
    >그러나 이용자가 환불받을 수 있는 범위는 이용자가 아직까지 소비하지 않은
    부분으로 제한되며, </span
  ><span
    >은행이체 및 결제대행수수료 등의 사유로 환불 금액이 10,000원 이내인
    경우에는 </span
  ><span>회사가</span
  ><span>
    총 금액의 10% 이내의 수수료를 공제하고 나머지 잔액을 환불할 수 있습니다.
    이때 만약 총 금액의 10% 이내의 수수료 공제금액이 환불 금액보다 많은
    경우에는 환불하지 않습니다.</span
  ><span>&#xa0;</span>
</p>
<p style="text-align: left">
  <span style="-aw-import: ignore">&#xa0;</span>
</p>
<p style="text-align: left">
  <span
    >3. 이용자가 환불을 요청하고자 하는 경우, 회사에서 정한 절차에 따라
    환불신청을 하여야 하며, 회사는 구매 내역을 확인한 후, 이용자에게
    본인확인을 위한 별도의 서류 제출을 요구할 수 있고, 환불신청의 정당성을
    심사합니다. 이때 회사는 이용자에게 중대한 위약행위가 없는지 등 제반 사정을
    고려하여 이용자의 요청에 따라 계약을 해제할지를 결정합니다.</span
  >
</p>
<p style="text-align: left">
  <span style="-aw-import: ignore">&#xa0;</span>
</p>
<p style="text-align: left">
  <span
    >4. 계속적 이용계약의 경우에는 상품가액에서 이용자가 이미 사용한 부분에
    해당하는 금액(각 상품별 사용금액 산정기준은 상품 구매 시 별도 고지함)을
    제외하고 남은 금액에서 남은금액의 10% 이내 수수료 또는 남은 금액이
    10,000원 이내인 경우에는 일정수수료를 공제한 후 나머지 금액을 환불해
    드립니다. </span
  ><span
    >일정금액을 공제하는 경우 공제 후 남은 금액이 공제금액보다 작은 경우에는
    환불할 수 없습니다.</span
  >
</p>
<p style="text-align: left">
  <span style="-aw-import: ignore">&#xa0;</span>
</p>
<p style="text-align: left">
  <span
    >5. 현행법령 및 중대한 조항 위반 등 이용자의 귀책사유로 이용계약을
    해지하는 경우 환불이 제한될 수 있습니다.</span
  >
</p>
<p style="text-align: left">
  <span style="-aw-import: ignore">&#xa0;</span>
</p>
<p style="text-align: left">
  <span style="-aw-import: ignore">&#xa0;</span>
</p>
<p style="text-align: left">
  <span>제30조 면책조항</span>
</p>
<p style="text-align: left">
  <span style="-aw-import: ignore">&#xa0;</span>
</p>
<p style="text-align: left">
  <span
    >1. 회사는 이용자의 귀책사유로 인한 서비스의 종료, 이용장애, 게임콘텐츠
    중단 및 계약해지에 대하여 책임이 면제됩니다.</span
  >
</p>
<p style="text-align: left">
  <span style="-aw-import: ignore">&#xa0;</span>
</p>
<p style="text-align: left">
  <span
    >2. 회사의 고의 또는 중대한 과실이 없는 한, 회사는 이동통신 서비스의
    장애[천재지변(예로서, 지진, 홍수, 번개 등, 기계실 주요 설비, 선로나
    전기공급 시스템에 중대한 고장이나 화재가 발생하는 경우 등)을 포함하나,
    이에 한하지 아니함]으로 인한 책임이 면제됩니다.</span
  >
</p>
<p style="text-align: left">
  <span style="-aw-import: ignore">&#xa0;</span>
</p>
<p style="text-align: left">
  <span
    >3. 회사는 사전에 이용자에게 공지된 게임콘텐츠용 설비의 보수, 교체,
    정기점검, 공사 등 부득이한 사유로 인하여 게임콘텐츠가 종료되거나 장애가
    발생한 경우에 대해서 고의 또는 중대한 과실이 없는 한 책임이
    면제됩니다.</span
  >
</p>
<p style="text-align: left">
  <span style="-aw-import: ignore">&#xa0;</span>
</p>
<p style="text-align: left">
  <span
    >4. 회사의 고의 또는 중대한 과실이 없는 한, 회사는 이용자의 컴퓨터와 기타
    전자설비에 각종 소프트웨어/하드웨어 장애로 인한 책임이 면제됩니다.</span
  >
</p>
<p style="text-align: left">
  <span style="-aw-import: ignore">&#xa0;</span>
</p>
<p style="text-align: left">
  <span
    >5. 이용자는 제3자로부터 게임상품을 획득하여서는 아니 되며, 만약 이용자가
    제3자로부터 게임상품을 취득하였을 경우에는, 이용자는 그에 상응하는 위험을
    스스로 부담하고, 회사는 해당 게임상품이 정상적으로 사용될 수 있는 것과
    반환청구를 받지 않는 것을 보장하지 않습니다. 이로 인하여 이용자가 손해를
    입었을 경우, 회사는 이에 대한 책임을 지지 않습니다.</span
  >
</p>
<p style="text-align: left">
  <span style="-aw-import: ignore">&#xa0;</span>
</p>
<p style="text-align: left">
  <span
    >6. 회사는 이용자 상호간 발생한 분쟁에 개입할 의무가 없으며, 이에 따라
    회사는 이와 같은 유형의 분쟁으로 인한 손해배상책임을 부담할 의무도
    없습니다.</span
  >
</p>
<p style="text-align: left">
  <span style="-aw-import: ignore">&#xa0;</span>
</p>
<p style="text-align: left">
  <span
    >7. 이용자가 회사가 제공한 무료 제품 혹은 서비스를 사용함으로 인하여
    손해를 입은 경우, 회사는 이에 대한 책임을 지지 않습니다. 단 그 손해가
    회사의 고의 또는 중대한 과실에 의한 경우는 제외합니다.</span
  >
</p>
<p style="text-align: left">
  <span style="-aw-import: ignore">&#xa0;</span>
</p>
<p style="text-align: left">
  <span
    >8. 회원가입 시 이용자가 잘못된 정보를 제공하거나 이용자의 잘못된
    조작방법, 또는 이용자 자신의 전자기기 고장으로 인하여 손해가 발생한 경우
    회사는 일체의 책임을 지지 않습니다.</span
  >
</p>
<p style="text-align: left">
  <span style="-aw-import: ignore">&#xa0;</span>
</p>
<p style="text-align: left">
  <span
    >9. 회사는 이용자가 서비스를 이용하면서 취득한 등급, 아이템, 콘텐츠 등의
    소실에 대해서 회사의 고의 또는 중대한 과실로 인한 경우를 제외하고는 책임을
    부담하지 않습니다.</span
  >
</p>
<p style="text-align: left">
  <span style="-aw-import: ignore">&#xa0;</span>
</p>
<p style="text-align: left">
  <span
    >10. 이용자의 단말기 변경, 번호 변경, 해외 로밍, 통신사 이동 등의 경우
    게임콘텐츠의 전부 또는 일부 기능을 이용할 수 없는 경우가 발생할 수 있으며,
    이 경우 회사는 책임지지 않습니다.</span
  >
</p>
<p style="text-align: left">
  <span style="-aw-import: ignore">&#xa0;</span>
</p>
<p style="text-align: left">
  <span
    >11. 회사에서 제공하는 게임콘텐츠를 삭제하는 경우, 이용 정보(점수, 캐릭터,
    아이템, 게임머니 등)가 삭제되는 경우가 있을 수 있으므로 이용자는 삭제에
    신중을 기하여야 하며 회사는 이에 대해 책임을 지지 않습니다.</span
  >
</p>
<p style="text-align: left">
  <span style="-aw-import: ignore">&#xa0;</span>
</p>
<p style="text-align: left">
  <span
    >12. 회사는 임시회원 기능 이용 중 발생한 문제에 대해서는 일체 책임을 지지
    않습니다.</span
  >
</p>
<p style="text-align: left">
  <span style="-aw-import: ignore">&#xa0;</span>
</p>
<p style="text-align: left">
  <span
    >13. 회사는 이용자가 서비스를 이용하여 기대하는 수익을 얻지 못한 것에
    대하여 책임을 지지 않으며, 서비스에 대한 취소 또는 이용으로 발생하는 손해
    등에 대해서는 책임을 지지 않습니다.</span
  >
</p>
<p style="text-align: left">
  <span style="-aw-import: ignore">&#xa0;</span>
</p>
<p style="text-align: left">
  <span
    >14. 국가 법률, 법규, 정책 및 국가기관의 명령 등으로 인하여 이용자에게
    손실을 끼친 경우, 회사는 이에 대한 책임을 지지 않습니다.</span
  >
</p>
<p style="text-align: left">
  <span style="-aw-import: ignore">&#xa0;</span>
</p>
<p style="text-align: left">
  <span style="-aw-import: ignore">&#xa0;</span>
</p>
<p style="text-align: left">
  <span>제31조 이용자 고발 및 분쟁의 해결</span>
</p>
<p style="text-align: left">
  <span style="-aw-import: ignore">&#xa0;</span>
</p>
<p style="text-align: left">
  <span
    >1. 이용자 고발 및 분쟁해결의 편리를 위하여, 회사는 게임 초기화면 및 게임
    홈페이지에서 이용자 게시판을 마련하고 이를 담당하는 전문적인
    고객서비스부서를 설립함으로써 관련 정보 수집 및 처리를 진행하도록 하여야
    합니다.</span
  >
</p>
<p style="text-align: left">
  <span style="-aw-import: ignore">&#xa0;</span>
</p>
<p style="text-align: left">
  <span
    >2. 회사는 합리적인 기한 내에 이용자의 의견과 불만을 유효하게 처리하여야
    합니다. 처리기간을 연장하여야 하는 경우, 회사는 홈페이지, 전자우편 혹은
    서면의 방법으로 이용자에게 처리 상황을 통지하여야 합니다.</span
  >
</p>
<p style="text-align: left">
  <span style="-aw-import: ignore">&#xa0;</span>
</p>
<p style="text-align: left">
  <span
    >3. 회사와 이용자 상호간의 분쟁은 제3의 분쟁조정기관에 조정을 맡기는 경우,
    회사는 사실대로 진술하여야 하고 조정결과를 받아들여야 합니다.</span
  >
</p>
<p style="text-align: left">
  <span style="-aw-import: ignore">&#xa0;</span>
</p>
<p style="text-align: left">
  <span style="-aw-import: ignore">&#xa0;</span>
</p>
<p style="text-align: left">
  <span>제32조 이용자에 대한 통지</span><span>&#xa0;</span>
</p>
<p style="text-align: left">
  <span style="-aw-import: ignore">&#xa0;</span>
</p>
<p style="text-align: left">
  <span
    >1. 회사는 서비스를 사용하는 과정에서 이용자가 필요로 하는 각종 정보에
    대하여 서비스화면, 전자우편 또는 서신 우편 등 방식으로 이를 이용자에게
    제공할 수 있습니다. 회사는 통지 발송 시에는 이용자가 지정한 전자우편 주소
    등 통신방법을 사용하여야 합니다.</span
  >
</p>
<p style="text-align: left">
  <span style="-aw-import: ignore">&#xa0;</span>
</p>
<p style="text-align: left">
  <span
    >2. 회사는 전체 이용자에게 중요한 통지를 발송하여야 할 때 회사 사이트에서
    가장 윗 부분에 해당 통지 내용을 공시하여야 하며, 공시기한은 7일보다
    적어서는 아니 됩니다.</span
  >
</p>
<p style="text-align: left">
  <span style="-aw-import: ignore">&#xa0;</span>
</p>
<p style="text-align: left">
  <span
    >3. 서비스 개선 및 이용자에 대한 서비스 소개 등을 목적으로 회사는 이용자의
    동의를 받은 후 추가적인 개인정보를 제공하도록 요구할 수 있습니다.</span
  >
</p>
<p style="text-align: left">
  <span>&#xa0;</span>
</p>
<p style="text-align: left">
  <span style="-aw-import: ignore">&#xa0;</span>
</p>
<p style="text-align: left">
  <span>제33조 준거법 및 관할권</span>
</p>
<p style="text-align: left">
  <span style="-aw-import: ignore">&#xa0;</span>
</p>
<p style="text-align: left">
  <span
    >1. 본 약관은 대한민국 법률에 따라 제정 및 해석되고 해당 분쟁을 접수한
    대한민국 법원이 관할권을 가집니다.</span
  >
</p>
<p style="text-align: left">
  <span style="-aw-import: ignore">&#xa0;</span>
</p>
<p style="text-align: left">
  <span
    >2. 관련 서비스의 사용에 대하여 회사와 이용자 간에 분쟁이 발생할 경우, 양
    당사자는 협상을 통하여 원만하게 해결하여야 합니다.</span
  >
</p>
<p style="text-align: left">
  <span style="-aw-import: ignore">&#xa0;</span>
</p>
<p style="text-align: left">
  <span style="-aw-import: ignore">&#xa0;</span>
</p>
<p style="text-align: left">
  <span>제34조 기타 조항</span>
</p>
<p style="text-align: left">
  <span style="-aw-import: ignore">&#xa0;</span>
</p>
<p style="text-align: left">
  <span
    >본 약관에 기재되지 않은 사항 및 본 약관의 해석은 정부가 제정한 관련 법령
    혹은 상관례를 따릅니다.</span
  >
</p>
<p style="text-align: left">
  <span style="-aw-import: ignore">&#xa0;</span>
</p>
<p style="text-align: left">
  <span style="-aw-import: ignore">&#xa0;</span>
</p>
</div>
`;

export const threeSeventUseDetailHtml = `    <div>
        <p style="margin-right:38.75pt"><span style="font-family:'Malgun Gothic'">본사</span></p>
        <p style="margin-right:38.75pt; text-align:left; widows:2; orphans:2; font-size:9pt"><span
                style="font-family:'Malgun Gothic'; -aw-import:ignore">&#xa0;</span></p>
        <table cellspacing="0" cellpadding="0" class="TableGrid"
            style="margin-right:9pt; margin-left:9pt; border:0.75pt solid #000000; -aw-border:0.5pt single #000000; -aw-border-insideh:0.5pt single #000000; -aw-border-insidev:0.5pt single #000000; border-collapse:collapse; float:left">
            <tr>
                <td
                    style="width:163.5pt; border-right-style:solid; border-right-width:0.75pt; border-bottom-style:solid; border-bottom-width:0.75pt; padding-right:5.03pt; padding-left:5.03pt; vertical-align:top; -aw-border-bottom:0.5pt single #000000; -aw-border-right:0.5pt single #000000">
                    <p style="margin-right:38.75pt; text-align:justify; font-size:10.5pt"><span
                            style="font-family:'Malgun Gothic'">목적</span></p>
                </td>
                <td
                    style="width:166.4pt; border-right-style:solid; border-right-width:0.75pt; border-left-style:solid; border-left-width:0.75pt; border-bottom-style:solid; border-bottom-width:0.75pt; padding-right:5.03pt; padding-left:5.03pt; vertical-align:top; -aw-border-bottom:0.5pt single #000000; -aw-border-left:0.5pt single #000000; -aw-border-right:0.5pt single #000000">
                    <p style="margin-right:38.75pt; text-align:justify; font-size:10.5pt"><span
                            style="font-family:'Malgun Gothic'">정보 유형</span></p>
                </td>
                <td
                    style="width:163.55pt; border-left-style:solid; border-left-width:0.75pt; border-bottom-style:solid; border-bottom-width:0.75pt; padding-right:5.03pt; padding-left:5.03pt; vertical-align:top; -aw-border-bottom:0.5pt single #000000; -aw-border-left:0.5pt single #000000">
                    <p style="margin-right:38.75pt; text-align:justify; font-size:10.5pt"><span
                            style="font-family:'Malgun Gothic'">보관 기한</span></p>
                </td>
            </tr>
            <tr>
                <td
                    style="width:163.5pt; border-top-style:solid; border-top-width:0.75pt; border-right-style:solid; border-right-width:0.75pt; border-bottom-style:solid; border-bottom-width:0.75pt; padding-right:5.03pt; padding-left:5.03pt; vertical-align:top; -aw-border-bottom:0.5pt single #000000; -aw-border-right:0.5pt single #000000; -aw-border-top:0.5pt single #000000">
                    <p style="margin-right:38.75pt; text-align:justify; font-size:10.5pt"><span
                            style="font-family:'Malgun Gothic'">회원가입 시 사용자 신분 인증</span></p>
                </td>
                <td
                    style="width:166.4pt; border-style:solid; border-width:0.75pt; padding-right:5.03pt; padding-left:5.03pt; vertical-align:top; -aw-border:0.5pt single #000000">
                    <p style="margin-right:38.75pt; text-align:justify; font-size:10.5pt"><span
                            style="font-family:'Malgun Gothic'">계정, 비밀번호, 핸드폰 번호</span></p>
                </td>
                <td
                    style="width:163.55pt; border-top-style:solid; border-top-width:0.75pt; border-left-style:solid; border-left-width:0.75pt; border-bottom-style:solid; border-bottom-width:0.75pt; padding-right:5.03pt; padding-left:5.03pt; vertical-align:top; -aw-border-bottom:0.5pt single #000000; -aw-border-left:0.5pt single #000000; -aw-border-top:0.5pt single #000000">
                    <p style="margin-right:38.75pt; text-align:justify; font-size:10.5pt"><span
                            style="font-family:'Malgun Gothic'">회원 탈퇴 시 즉시 삭제</span></p>
                </td>
            </tr>
            <tr>
                <td
                    style="width:163.5pt; border-top-style:solid; border-top-width:0.75pt; border-right-style:solid; border-right-width:0.75pt; border-bottom-style:solid; border-bottom-width:0.75pt; padding-right:5.03pt; padding-left:5.03pt; vertical-align:top; -aw-border-bottom:0.5pt single #000000; -aw-border-right:0.5pt single #000000; -aw-border-top:0.5pt single #000000">
                    <p style="margin-right:38.75pt; text-align:justify; font-size:10.5pt"><span
                            style="font-family:'Malgun Gothic'">모바일 서비스 및 이벤트 상품 배송 등에 활용</span></p>
                </td>
                <td
                    style="width:166.4pt; border-style:solid; border-width:0.75pt; padding-right:5.03pt; padding-left:5.03pt; vertical-align:top; -aw-border:0.5pt single #000000">
                    <p style="margin-right:38.75pt; text-align:justify; font-size:10.5pt"><span
                            style="font-family:'Malgun Gothic'">IP 주소, 접속 날짜, 서비스 이용 기록, 부정 이용 기록, 오류 정보</span></p>
                </td>
                <td
                    style="width:163.55pt; border-top-style:solid; border-top-width:0.75pt; border-left-style:solid; border-left-width:0.75pt; border-bottom-style:solid; border-bottom-width:0.75pt; padding-right:5.03pt; padding-left:5.03pt; vertical-align:top; -aw-border-bottom:0.5pt single #000000; -aw-border-left:0.5pt single #000000; -aw-border-top:0.5pt single #000000">
                    <p style="margin-right:38.75pt; text-align:justify; font-size:10.5pt"><span
                            style="font-family:'Malgun Gothic'">회원 탈퇴 시 즉시 폐기되나, 계약 및 주문내역, 취소내역, 정산내역, 재무내역 등은 회원 탈퇴 후
                            5년간 보관됩니다.</span></p>
                </td>
            </tr>
            <tr>
                <td
                    style="width:163.5pt; border-top-style:solid; border-top-width:0.75pt; border-right-style:solid; border-right-width:0.75pt; border-bottom-style:solid; border-bottom-width:0.75pt; padding-right:5.03pt; padding-left:5.03pt; vertical-align:top; -aw-border-bottom:0.5pt single #000000; -aw-border-right:0.5pt single #000000; -aw-border-top:0.5pt single #000000">
                    <p style="margin-right:38.75pt; text-align:justify; font-size:10.5pt"><span
                            style="font-family:'Malgun Gothic'">서비스 이용 시 본인확인 절차, 비밀번호 분실, 계정 잠금, 결제 환불 등의 서비스 그리고 이용자
                            특성에 따른 맞춤형 서비스 제공 </span></p>
                </td>
                <td
                    style="width:166.4pt; border-style:solid; border-width:0.75pt; padding-right:5.03pt; padding-left:5.03pt; vertical-align:top; -aw-border:0.5pt single #000000">
                    <p style="margin-right:38.75pt; text-align:justify; font-size:10.5pt"><span
                            style="font-family:'Malgun Gothic'">ID, 비밀번호, 캐릭터명, 핸드폰 기종 그리고 광고 식별자</span></p>
                </td>
                <td
                    style="width:163.55pt; border-top-style:solid; border-top-width:0.75pt; border-left-style:solid; border-left-width:0.75pt; border-bottom-style:solid; border-bottom-width:0.75pt; padding-right:5.03pt; padding-left:5.03pt; vertical-align:top; -aw-border-bottom:0.5pt single #000000; -aw-border-left:0.5pt single #000000; -aw-border-top:0.5pt single #000000">
                    <p style="margin-right:38.75pt; text-align:justify; font-size:10.5pt"><span
                            style="font-family:'Malgun Gothic'">회원 탈퇴 시 즉시 삭제</span></p>
                </td>
            </tr>
            <tr>
                <td
                    style="width:163.5pt; border-top-style:solid; border-top-width:0.75pt; border-right-style:solid; border-right-width:0.75pt; border-bottom-style:solid; border-bottom-width:0.75pt; padding-right:5.03pt; padding-left:5.03pt; vertical-align:top; -aw-border-bottom:0.5pt single #000000; -aw-border-right:0.5pt single #000000; -aw-border-top:0.5pt single #000000">
                    <p style="margin-right:38.75pt; text-align:justify; font-size:10.5pt"><span
                            style="font-family:'Malgun Gothic'">요금을 정산하기 위해 유료 서비스 결제 시 수집</span></p>
                </td>
                <td
                    style="width:166.4pt; border-style:solid; border-width:0.75pt; padding-right:5.03pt; padding-left:5.03pt; vertical-align:top; -aw-border:0.5pt single #000000">
                    <p style="margin-right:38.75pt; text-align:justify; font-size:10.5pt"><span
                            style="font-family:'Malgun Gothic'">IP 주소</span></p>
                </td>
                <td
                    style="width:163.55pt; border-top-style:solid; border-top-width:0.75pt; border-left-style:solid; border-left-width:0.75pt; border-bottom-style:solid; border-bottom-width:0.75pt; padding-right:5.03pt; padding-left:5.03pt; vertical-align:top; -aw-border-bottom:0.5pt single #000000; -aw-border-left:0.5pt single #000000; -aw-border-top:0.5pt single #000000">
                    <p style="margin-right:38.75pt; text-align:justify; font-size:10.5pt"><span
                            style="font-family:'Malgun Gothic'">결제 정보는 회원 탈퇴 후 5년간 보관됩니다.</span></p>
                </td>
            </tr>
            <tr>
                <td
                    style="width:163.5pt; border-top-style:solid; border-top-width:0.75pt; border-right-style:solid; border-right-width:0.75pt; border-bottom-style:solid; border-bottom-width:0.75pt; padding-right:5.03pt; padding-left:5.03pt; vertical-align:top; -aw-border-bottom:0.5pt single #000000; -aw-border-right:0.5pt single #000000; -aw-border-top:0.5pt single #000000">
                    <p style="margin-right:38.75pt; text-align:justify; font-size:10.5pt"><span
                            style="font-family:'Malgun Gothic'">계약 이행 및 분쟁 처리</span></p>
                </td>
                <td
                    style="width:166.4pt; border-style:solid; border-width:0.75pt; padding-right:5.03pt; padding-left:5.03pt; vertical-align:top; -aw-border:0.5pt single #000000">
                    <p style="margin-right:38.75pt; text-align:justify; font-size:10.5pt"><span
                            style="font-family:'Malgun Gothic'">IP 주소, 서버 이용 기록(접속 로그 기록, 서비스 종료 일자)</span></p>
                </td>
                <td
                    style="width:163.55pt; border-top-style:solid; border-top-width:0.75pt; border-left-style:solid; border-left-width:0.75pt; border-bottom-style:solid; border-bottom-width:0.75pt; padding-right:5.03pt; padding-left:5.03pt; vertical-align:top; -aw-border-bottom:0.5pt single #000000; -aw-border-left:0.5pt single #000000; -aw-border-top:0.5pt single #000000">
                    <p style="margin-right:38.75pt; text-align:justify; font-size:10.5pt"><span
                            style="font-family:'Malgun Gothic'">분쟁 관련 정보는 회원 탈퇴 후 3년간 보관되며, 웹페이지 접속기록은 회원 탈퇴 후 3개월간
                            보관됩니다.</span></p>
                </td>
            </tr>
            <tr>
                <td
                    style="width:163.5pt; border-top-style:solid; border-top-width:0.75pt; border-right-style:solid; border-right-width:0.75pt; border-bottom-style:solid; border-bottom-width:0.75pt; padding-right:5.03pt; padding-left:5.03pt; vertical-align:top; -aw-border-bottom:0.5pt single #000000; -aw-border-right:0.5pt single #000000; -aw-border-top:0.5pt single #000000">
                    <p style="margin-right:38.75pt; text-align:justify; font-size:10.5pt"><span
                            style="font-family:'Malgun Gothic'">이용자 식별 및 중복 가입 확인, 결제 환불 등 고객 서비스를 위해 사용합니다.</span></p>
                </td>
                <td
                    style="width:166.4pt; border-style:solid; border-width:0.75pt; padding-right:5.03pt; padding-left:5.03pt; vertical-align:top; -aw-border:0.5pt single #000000">
                    <p style="margin-right:38.75pt; text-align:justify; font-size:10.5pt"><span
                            style="font-family:'Malgun Gothic'">중복 가입 확인 정보(DI)에 사용합니다.</span></p>
                </td>
                <td
                    style="width:163.55pt; border-top-style:solid; border-top-width:0.75pt; border-left-style:solid; border-left-width:0.75pt; border-bottom-style:solid; border-bottom-width:0.75pt; padding-right:5.03pt; padding-left:5.03pt; vertical-align:top; -aw-border-bottom:0.5pt single #000000; -aw-border-left:0.5pt single #000000; -aw-border-top:0.5pt single #000000">
                    <p style="margin-right:38.75pt; text-align:justify; font-size:10.5pt"><span
                            style="font-family:'Malgun Gothic'">회원 탈퇴 시 즉시 삭제</span></p>
                </td>
            </tr>
            <tr>
                <td
                    style="width:163.5pt; border-top-style:solid; border-top-width:0.75pt; border-right-style:solid; border-right-width:0.75pt; border-bottom-style:solid; border-bottom-width:0.75pt; padding-right:5.03pt; padding-left:5.03pt; vertical-align:top; -aw-border-bottom:0.5pt single #000000; -aw-border-right:0.5pt single #000000; -aw-border-top:0.5pt single #000000">
                    <p style="margin-right:38.75pt; text-align:justify; font-size:10.5pt"><span
                            style="font-family:'Malgun Gothic'">외부 기업과 연락하고 협력 서비스를 이용할 때 사용합니다.</span></p>
                </td>
                <td
                    style="width:166.4pt; border-style:solid; border-width:0.75pt; padding-right:5.03pt; padding-left:5.03pt; vertical-align:top; -aw-border:0.5pt single #000000">
                    <p style="margin-right:38.75pt; text-align:justify; font-size:10.5pt"><span
                            style="font-family:'Malgun Gothic'">암호화된 동일 인식 식별 정보(CI)</span></p>
                </td>
                <td
                    style="width:163.55pt; border-top-style:solid; border-top-width:0.75pt; border-left-style:solid; border-left-width:0.75pt; border-bottom-style:solid; border-bottom-width:0.75pt; padding-right:5.03pt; padding-left:5.03pt; vertical-align:top; -aw-border-bottom:0.5pt single #000000; -aw-border-left:0.5pt single #000000; -aw-border-top:0.5pt single #000000">
                    <p style="margin-right:38.75pt; text-align:justify; font-size:10.5pt"><span
                            style="font-family:'Malgun Gothic'">회원 탈퇴 시 즉시 삭제</span></p>
                </td>
            </tr>
            <tr>
                <td
                    style="width:163.5pt; border-top-style:solid; border-top-width:0.75pt; border-right-style:solid; border-right-width:0.75pt; padding-right:5.03pt; padding-left:5.03pt; vertical-align:top; -aw-border-right:0.5pt single #000000; -aw-border-top:0.5pt single #000000">
                    <p style="margin-right:38.75pt; text-align:justify; font-size:10.5pt"><span
                            style="font-family:'Malgun Gothic'">확인 가능한 연령</span></p>
                </td>
                <td
                    style="width:166.4pt; border-top-style:solid; border-top-width:0.75pt; border-right-style:solid; border-right-width:0.75pt; border-left-style:solid; border-left-width:0.75pt; padding-right:5.03pt; padding-left:5.03pt; vertical-align:top; -aw-border-left:0.5pt single #000000; -aw-border-right:0.5pt single #000000; -aw-border-top:0.5pt single #000000">
                    <p style="margin-right:38.75pt; text-align:justify; font-size:10.5pt"><span
                            style="font-family:'Malgun Gothic'">출생연월</span></p>
                </td>
                <td
                    style="width:163.55pt; border-top-style:solid; border-top-width:0.75pt; border-left-style:solid; border-left-width:0.75pt; padding-right:5.03pt; padding-left:5.03pt; vertical-align:top; -aw-border-left:0.5pt single #000000; -aw-border-top:0.5pt single #000000">
                    <p style="margin-right:38.75pt; text-align:justify; font-size:10.5pt"><span
                            style="font-family:'Malgun Gothic'">회원 탈퇴 시 즉시 삭제</span></p>
                </td>
            </tr>
        </table>
        <p style="margin-right:38.75pt; text-align:left; widows:2; orphans:2"><br
                style="page-break-before:always; clear:both" /><span style="font-family:'Malgun Gothic'"> 임시 회원 모드에서,
                회사는 사용자가 직접 만든 계정과 비밀번호를 수집하지 않습니다. 대신 임시 회원에게 암호화된 계정, 비밀 번호를 자동으로 생성합니다. 동시에 위 표에 나열된 다른 정보를
                수집합니다.</span></p>
        <p style="margin-right:38.75pt"><span style="font-family:'Malgun Gothic'; -aw-import:ignore">&#xa0;</span></p>
        <p style="margin-right:38.75pt"><span style="font-family:'Malgun Gothic'">다음 정보는 사용자가 특정 상황을 능동적으로 수행할 때만 회사가
                수집합니다. 회원이 해당 상황을 수행하지 않으면, 사용자가 이 방침에 동의하더라도 회사는 아래 정보를 자동으로 수집하지 않습니다.</span></p>
        <table cellspacing="0" cellpadding="0" class="TableGrid"
            style="border:0.75pt solid #000000; -aw-border:0.5pt single #000000; -aw-border-insideh:0.5pt single #000000; -aw-border-insidev:0.5pt single #000000; border-collapse:collapse">
            <tr>
                <td
                    style="width:144.9pt; border-right-style:solid; border-right-width:0.75pt; border-bottom-style:solid; border-bottom-width:0.75pt; padding-right:5.03pt; padding-left:5.03pt; vertical-align:top; -aw-border-bottom:0.5pt single #000000; -aw-border-right:0.5pt single #000000">
                    <p style="margin-right:38.75pt; text-align:justify; font-size:10.5pt"><span
                            style="font-family:'Malgun Gothic'">수행 상황</span></p>
                </td>
                <td
                    style="width:166.4pt; border-right-style:solid; border-right-width:0.75pt; border-left-style:solid; border-left-width:0.75pt; border-bottom-style:solid; border-bottom-width:0.75pt; padding-right:5.03pt; padding-left:5.03pt; vertical-align:top; -aw-border-bottom:0.5pt single #000000; -aw-border-left:0.5pt single #000000; -aw-border-right:0.5pt single #000000">
                    <p style="margin-right:38.75pt; text-align:justify; font-size:10.5pt"><span
                            style="font-family:'Malgun Gothic'">목적</span></p>
                </td>
                <td
                    style="width:81.3pt; border-right-style:solid; border-right-width:0.75pt; border-left-style:solid; border-left-width:0.75pt; border-bottom-style:solid; border-bottom-width:0.75pt; padding-right:5.03pt; padding-left:5.03pt; vertical-align:top; -aw-border-bottom:0.5pt single #000000; -aw-border-left:0.5pt single #000000; -aw-border-right:0.5pt single #000000">
                    <p style="margin-right:38.75pt; text-align:justify; font-size:10.5pt"><span
                            style="font-family:'Malgun Gothic'">정보 유형</span></p>
                </td>
                <td
                    style="width:187.65pt; border-left-style:solid; border-left-width:0.75pt; border-bottom-style:solid; border-bottom-width:0.75pt; padding-right:5.03pt; padding-left:5.03pt; vertical-align:top; -aw-border-bottom:0.5pt single #000000; -aw-border-left:0.5pt single #000000">
                    <p style="margin-right:38.75pt; text-align:justify; font-size:10.5pt"><span
                            style="font-family:'Malgun Gothic'">보관 기한</span></p>
                </td>
            </tr>
            <tr>
                <td
                    style="width:144.9pt; border-top-style:solid; border-top-width:0.75pt; border-right-style:solid; border-right-width:0.75pt; border-bottom-style:solid; border-bottom-width:0.75pt; padding-right:5.03pt; padding-left:5.03pt; vertical-align:top; -aw-border-bottom:0.5pt single #000000; -aw-border-right:0.5pt single #000000; -aw-border-top:0.5pt single #000000">
                    <p style="margin-right:38.75pt; text-align:justify; font-size:10.5pt"><span
                            style="font-family:'Malgun Gothic'">회원이 회사에 이메일을 쓰거나 고객서비스 직원과 연락할 때 제공하는 정보</span></p>
                </td>
                <td
                    style="width:166.4pt; border-style:solid; border-width:0.75pt; padding-right:5.03pt; padding-left:5.03pt; vertical-align:top; -aw-border:0.5pt single #000000">
                    <p style="margin-right:38.75pt; text-align:justify; font-size:10.5pt"><span
                            style="font-family:'Malgun Gothic'">회원에게 답변할 때 사용합니다.</span></p>
                </td>
                <td
                    style="width:81.3pt; border-style:solid; border-width:0.75pt; padding-right:5.03pt; padding-left:5.03pt; vertical-align:top; -aw-border:0.5pt single #000000">
                    <p style="margin-right:38.75pt; text-align:justify; font-size:10.5pt"><span
                            style="font-family:'Malgun Gothic'">이메일 주소</span></p>
                </td>
                <td
                    style="width:187.65pt; border-top-style:solid; border-top-width:0.75pt; border-left-style:solid; border-left-width:0.75pt; border-bottom-style:solid; border-bottom-width:0.75pt; padding-right:5.03pt; padding-left:5.03pt; vertical-align:top; -aw-border-bottom:0.5pt single #000000; -aw-border-left:0.5pt single #000000; -aw-border-top:0.5pt single #000000">
                    <p style="margin-right:38.75pt; text-align:justify; font-size:10.5pt"><span
                            style="font-family:'Malgun Gothic'">사용자가 회원 탈퇴할 때까지 해당 정보를 보관하지만, 분쟁과 관련된 정보는 회원 자격 해지 후 3년간
                            보관됩니다.</span></p>
                </td>
            </tr>
            <tr>
                <td
                    style="width:144.9pt; border-top-style:solid; border-top-width:0.75pt; border-right-style:solid; border-right-width:0.75pt; border-bottom-style:solid; border-bottom-width:0.75pt; padding-right:5.03pt; padding-left:5.03pt; vertical-align:top; -aw-border-bottom:0.5pt single #000000; -aw-border-right:0.5pt single #000000; -aw-border-top:0.5pt single #000000">
                    <p style="margin-right:38.75pt; text-align:justify; font-size:10.5pt"><span
                            style="font-family:'Malgun Gothic'">회원이 설문조사에 응답하여 선택적으로 작성합니다.</span></p>
                </td>
                <td
                    style="width:166.4pt; border-style:solid; border-width:0.75pt; padding-right:5.03pt; padding-left:5.03pt; vertical-align:top; -aw-border:0.5pt single #000000">
                    <p style="margin-right:38.75pt; text-align:justify; font-size:10.5pt"><span
                            style="font-family:'Malgun Gothic'">회원에게 피드백할 때 사용합니다.</span></p>
                </td>
                <td
                    style="width:81.3pt; border-style:solid; border-width:0.75pt; padding-right:5.03pt; padding-left:5.03pt; vertical-align:top; -aw-border:0.5pt single #000000">
                    <p style="margin-right:38.75pt; text-align:justify; font-size:10.5pt"><span
                            style="font-family:'Malgun Gothic'">이메일 주소</span></p>
                </td>
                <td
                    style="width:187.65pt; border-top-style:solid; border-top-width:0.75pt; border-left-style:solid; border-left-width:0.75pt; border-bottom-style:solid; border-bottom-width:0.75pt; padding-right:5.03pt; padding-left:5.03pt; vertical-align:top; -aw-border-bottom:0.5pt single #000000; -aw-border-left:0.5pt single #000000; -aw-border-top:0.5pt single #000000">
                    <p style="margin-right:38.75pt; text-align:justify; font-size:10.5pt"><span
                            style="font-family:'Malgun Gothic'">회원 탈퇴 시 즉시 삭제</span></p>
                </td>
            </tr>
            <tr>
                <td
                    style="width:144.9pt; border-top-style:solid; border-top-width:0.75pt; border-right-style:solid; border-right-width:0.75pt; border-bottom-style:solid; border-bottom-width:0.75pt; padding-right:5.03pt; padding-left:5.03pt; vertical-align:top; -aw-border-bottom:0.5pt single #000000; -aw-border-right:0.5pt single #000000; -aw-border-top:0.5pt single #000000">
                    <p style="margin-right:38.75pt; text-align:justify; font-size:10.5pt"><span
                            style="font-family:'Malgun Gothic'">회원이 이메일 구독 이벤트에 참여할 때의 정보</span></p>
                </td>
                <td
                    style="width:166.4pt; border-style:solid; border-width:0.75pt; padding-right:5.03pt; padding-left:5.03pt; vertical-align:top; -aw-border:0.5pt single #000000">
                    <p style="margin-right:38.75pt; text-align:justify; font-size:10.5pt"><span
                            style="font-family:'Malgun Gothic'">회원 이메일로 정보를 발송할 때 사용하며, 여기에는 마케팅 정보 등이 포함되나 이에 국한되지
                            않습니다.</span></p>
                </td>
                <td
                    style="width:81.3pt; border-style:solid; border-width:0.75pt; padding-right:5.03pt; padding-left:5.03pt; vertical-align:top; -aw-border:0.5pt single #000000">
                    <p style="margin-right:38.75pt; text-align:justify; font-size:10.5pt"><span
                            style="font-family:'Malgun Gothic'">이메일 주소</span></p>
                </td>
                <td
                    style="width:187.65pt; border-top-style:solid; border-top-width:0.75pt; border-left-style:solid; border-left-width:0.75pt; border-bottom-style:solid; border-bottom-width:0.75pt; padding-right:5.03pt; padding-left:5.03pt; vertical-align:top; -aw-border-bottom:0.5pt single #000000; -aw-border-left:0.5pt single #000000; -aw-border-top:0.5pt single #000000">
                    <p style="margin-right:38.75pt; text-align:justify; font-size:10.5pt"><span
                            style="font-family:'Malgun Gothic'">구독 취소 혹은 회원 탈퇴 시 즉시 삭제</span></p>
                </td>
            </tr>
            <tr>
                <td
                    style="width:144.9pt; border-top-style:solid; border-top-width:0.75pt; border-right-style:solid; border-right-width:0.75pt; border-bottom-style:solid; border-bottom-width:0.75pt; padding-right:5.03pt; padding-left:5.03pt; vertical-align:top; -aw-border-bottom:0.5pt single #000000; -aw-border-right:0.5pt single #000000; -aw-border-top:0.5pt single #000000">
                    <p style="margin-right:38.75pt; text-align:justify; font-size:10.5pt"><span
                            style="font-family:'Malgun Gothic'">14세 미만 회원가입 절차 중</span></p>
                </td>
                <td
                    style="width:166.4pt; border-style:solid; border-width:0.75pt; padding-right:5.03pt; padding-left:5.03pt; vertical-align:top; -aw-border:0.5pt single #000000">
                    <p style="margin-right:38.75pt; text-align:justify; font-size:10.5pt"><span
                            style="font-family:'Malgun Gothic'">미성년자 회원의 개인정보 수집 및 이용에 대해 보호자의 동의를 확인하는 데 사용합니다.</span>
                    </p>
                </td>
                <td
                    style="width:81.3pt; border-style:solid; border-width:0.75pt; padding-right:5.03pt; padding-left:5.03pt; vertical-align:top; -aw-border:0.5pt single #000000">
                    <p style="margin-right:38.75pt; text-align:justify; font-size:10.5pt"><span
                            style="font-family:'Malgun Gothic'">보호자 이메일 주소</span></p>
                </td>
                <td
                    style="width:187.65pt; border-top-style:solid; border-top-width:0.75pt; border-left-style:solid; border-left-width:0.75pt; border-bottom-style:solid; border-bottom-width:0.75pt; padding-right:5.03pt; padding-left:5.03pt; vertical-align:top; -aw-border-bottom:0.5pt single #000000; -aw-border-left:0.5pt single #000000; -aw-border-top:0.5pt single #000000">
                    <p style="margin-right:38.75pt; text-align:justify; font-size:10.5pt"><span
                            style="font-family:'Malgun Gothic'">이용자가 회원 탈퇴할 때까지, 혹은 이용자의 나이가 24살이 될 때까지</span></p>
                </td>
            </tr>
            <tr>
                <td
                    style="width:144.9pt; border-top-style:solid; border-top-width:0.75pt; border-right-style:solid; border-right-width:0.75pt; border-bottom-style:solid; border-bottom-width:0.75pt; padding-right:5.03pt; padding-left:5.03pt; vertical-align:top; -aw-border-bottom:0.5pt single #000000; -aw-border-right:0.5pt single #000000; -aw-border-top:0.5pt single #000000">
                    <p style="margin-right:38.75pt; text-align:justify; font-size:10.5pt"><span
                            style="font-family:'Malgun Gothic'">회원이 회사에 전화를 걸거나 회사 고객서비스 직원과 연락할 때 제공합니다.</span></p>
                </td>
                <td
                    style="width:166.4pt; border-style:solid; border-width:0.75pt; padding-right:5.03pt; padding-left:5.03pt; vertical-align:top; -aw-border:0.5pt single #000000">
                    <p style="margin-right:38.75pt; text-align:justify; font-size:10.5pt"><span
                            style="font-family:'Malgun Gothic'">회원에게 후속 연락을 취하는 데 사용합니다.</span></p>
                </td>
                <td
                    style="width:81.3pt; border-style:solid; border-width:0.75pt; padding-right:5.03pt; padding-left:5.03pt; vertical-align:top; -aw-border:0.5pt single #000000">
                    <p style="margin-right:38.75pt; text-align:justify; font-size:10.5pt"><span
                            style="font-family:'Malgun Gothic'">전화번호</span></p>
                </td>
                <td
                    style="width:187.65pt; border-top-style:solid; border-top-width:0.75pt; border-left-style:solid; border-left-width:0.75pt; border-bottom-style:solid; border-bottom-width:0.75pt; padding-right:5.03pt; padding-left:5.03pt; vertical-align:top; -aw-border-bottom:0.5pt single #000000; -aw-border-left:0.5pt single #000000; -aw-border-top:0.5pt single #000000">
                    <p style="margin-right:38.75pt; text-align:justify; font-size:10.5pt"><span
                            style="font-family:'Malgun Gothic'">사용자가 회원 탈퇴할 때까지 해당 정보를 보관하지만, 분쟁과 관련된 정보는 회원 자격 해지 후 3년간
                            보관됩니다.</span></p>
                </td>
            </tr>
            <tr>
                <td
                    style="width:144.9pt; border-top-style:solid; border-top-width:0.75pt; border-right-style:solid; border-right-width:0.75pt; border-bottom-style:solid; border-bottom-width:0.75pt; padding-right:5.03pt; padding-left:5.03pt; vertical-align:top; -aw-border-bottom:0.5pt single #000000; -aw-border-right:0.5pt single #000000; -aw-border-top:0.5pt single #000000">
                    <p style="margin-right:38.75pt; text-align:justify; font-size:10.5pt"><span
                            style="font-family:'Malgun Gothic'">회원이 설문조사에 응답하여 선택적으로 작성합니다.</span></p>
                </td>
                <td
                    style="width:166.4pt; border-style:solid; border-width:0.75pt; padding-right:5.03pt; padding-left:5.03pt; vertical-align:top; -aw-border:0.5pt single #000000">
                    <p style="margin-right:38.75pt; text-align:justify; font-size:10.5pt"><span
                            style="font-family:'Malgun Gothic'">회원에게 피드백할 때 사용합니다.</span></p>
                </td>
                <td
                    style="width:81.3pt; border-style:solid; border-width:0.75pt; padding-right:5.03pt; padding-left:5.03pt; vertical-align:top; -aw-border:0.5pt single #000000">
                    <p style="margin-right:38.75pt; text-align:justify; font-size:10.5pt"><span
                            style="font-family:'Malgun Gothic'">전화번호</span></p>
                </td>
                <td
                    style="width:187.65pt; border-top-style:solid; border-top-width:0.75pt; border-left-style:solid; border-left-width:0.75pt; border-bottom-style:solid; border-bottom-width:0.75pt; padding-right:5.03pt; padding-left:5.03pt; vertical-align:top; -aw-border-bottom:0.5pt single #000000; -aw-border-left:0.5pt single #000000; -aw-border-top:0.5pt single #000000">
                    <p style="margin-right:38.75pt; text-align:justify; font-size:10.5pt"><span
                            style="font-family:'Malgun Gothic'">회원 탈퇴 시 즉시 삭제</span></p>
                </td>
            </tr>
            <tr>
                <td
                    style="width:144.9pt; border-top-style:solid; border-top-width:0.75pt; border-right-style:solid; border-right-width:0.75pt; border-bottom-style:solid; border-bottom-width:0.75pt; padding-right:5.03pt; padding-left:5.03pt; vertical-align:top; -aw-border-bottom:0.5pt single #000000; -aw-border-right:0.5pt single #000000; -aw-border-top:0.5pt single #000000">
                    <p style="margin-right:38.75pt; text-align:justify; font-size:10.5pt"><span
                            style="font-family:'Malgun Gothic'">회원이 핸드폰 번호 구독 이벤트에 참가</span></p>
                </td>
                <td
                    style="width:166.4pt; border-style:solid; border-width:0.75pt; padding-right:5.03pt; padding-left:5.03pt; vertical-align:top; -aw-border:0.5pt single #000000">
                    <p style="margin-right:38.75pt; text-align:justify; font-size:10.5pt"><span
                            style="font-family:'Malgun Gothic'">회원 핸드폰으로 정보를 발송할 때 사용하며, 여기에는 마케팅 정보 등이 포함되나 이에 국한되지
                            않습니다.</span></p>
                </td>
                <td
                    style="width:81.3pt; border-style:solid; border-width:0.75pt; padding-right:5.03pt; padding-left:5.03pt; vertical-align:top; -aw-border:0.5pt single #000000">
                    <p style="margin-right:38.75pt; text-align:justify; font-size:10.5pt"><span
                            style="font-family:'Malgun Gothic'">이메일 주소</span></p>
                </td>
                <td
                    style="width:187.65pt; border-top-style:solid; border-top-width:0.75pt; border-left-style:solid; border-left-width:0.75pt; border-bottom-style:solid; border-bottom-width:0.75pt; padding-right:5.03pt; padding-left:5.03pt; vertical-align:top; -aw-border-bottom:0.5pt single #000000; -aw-border-left:0.5pt single #000000; -aw-border-top:0.5pt single #000000">
                    <p style="margin-right:38.75pt; text-align:justify; font-size:10.5pt"><span
                            style="font-family:'Malgun Gothic'">구독 취소 혹은 회원 탈퇴 시 즉시 삭제</span></p>
                </td>
            </tr>
            <tr>
                <td
                    style="width:144.9pt; border-top-style:solid; border-top-width:0.75pt; border-right-style:solid; border-right-width:0.75pt; padding-right:5.03pt; padding-left:5.03pt; vertical-align:top; -aw-border-right:0.5pt single #000000; -aw-border-top:0.5pt single #000000">
                    <p style="margin-right:38.75pt; text-align:justify; font-size:10.5pt"><span
                            style="font-family:'Malgun Gothic'">회원이 직원과 의사소통할 때 제공</span></p>
                </td>
                <td
                    style="width:166.4pt; border-top-style:solid; border-top-width:0.75pt; border-right-style:solid; border-right-width:0.75pt; border-left-style:solid; border-left-width:0.75pt; padding-right:5.03pt; padding-left:5.03pt; vertical-align:top; -aw-border-left:0.5pt single #000000; -aw-border-right:0.5pt single #000000; -aw-border-top:0.5pt single #000000">
                    <p style="margin-right:38.75pt; text-align:justify; font-size:10.5pt"><span
                            style="font-family:'Malgun Gothic'">회원에게 제공하는 생일 패키지 혹은 상품권</span></p>
                </td>
                <td
                    style="width:81.3pt; border-top-style:solid; border-top-width:0.75pt; border-right-style:solid; border-right-width:0.75pt; border-left-style:solid; border-left-width:0.75pt; padding-right:5.03pt; padding-left:5.03pt; vertical-align:top; -aw-border-left:0.5pt single #000000; -aw-border-right:0.5pt single #000000; -aw-border-top:0.5pt single #000000">
                    <p style="margin-right:38.75pt; text-align:justify; font-size:10.5pt"><span
                            style="font-family:'Malgun Gothic'">출생연월</span></p>
                </td>
                <td
                    style="width:187.65pt; border-top-style:solid; border-top-width:0.75pt; border-left-style:solid; border-left-width:0.75pt; padding-right:5.03pt; padding-left:5.03pt; vertical-align:top; -aw-border-left:0.5pt single #000000; -aw-border-top:0.5pt single #000000">
                    <p style="margin-right:38.75pt; text-align:justify; font-size:10.5pt"><span
                            style="font-family:'Malgun Gothic'">회원은 언제든지 회사에 요청하여 해당 정보를 삭제할 수 있습니다. 회원 탈퇴 시 즉시
                            폐기됩니다.</span></p>
                </td>
            </tr>
        </table>
        <p style="margin-right:38.75pt; font-size:9pt"><span
                style="font-family:'Malgun Gothic'; -aw-import:ignore">&#xa0;</span></p>
        <p style="margin-right:38.75pt; font-size:9pt"><span style="font-family:'Malgun Gothic'">법률에 따라 회사는 위의 경로를 통해
                획득한 전화번호 또는 이메일 주소로 마케팅 홍보 메일이나 문자 메시지를 발송할 수 있습니다. (회원 보호자 이메일 주소는 제외. 회사는 이러한 주소로 보호자의 동의와 무관한 마케팅 홍보
                메일을 보내지 않지만, 보호자 동의와 관련된 서비스 메일은 발송할 수 있습니다) 회원은 수신한 마케팅 홍보 메일이나 문자를 통해 언제든지 구독을 취소할 수 있습니다. 구독 취소 후에는
                회사가 해당 전화번호나 이메일 주소로 마케팅 홍보 메일을 보내지 않습니다. 다만 사용자가 직접 이메일 또는 휴대전화 번호 구독 이벤트에 다시 참여하는 경우는 예외입니다. 사용자의 별도
                동의를 다시 받지 않는 한, 회사는 밤 9시부터 다음날 오전 8시 사이에는 마케팅 홍보 문자 메시지를 발송하지 않습니다.</span></p>
        <p style="margin-right:38.75pt"><span style="font-family:'Malgun Gothic'; -aw-import:ignore">&#xa0;</span></p>
        <p style="margin-right:38.75pt"><span style="font-family:'Malgun Gothic'">회사가 제3자에게 획득한 정보</span></p>
        <p style="margin-right:38.75pt"><span style="font-family:'Malgun Gothic'; -aw-import:ignore">&#xa0;</span></p>
        <table cellspacing="0" cellpadding="0" class="TableGrid"
            style="border:0.75pt solid #000000; -aw-border:0.5pt single #000000; -aw-border-insideh:0.5pt single #000000; -aw-border-insidev:0.5pt single #000000; border-collapse:collapse">
            <tr>
                <td
                    style="width:163.55pt; border-right-style:solid; border-right-width:0.75pt; border-bottom-style:solid; border-bottom-width:0.75pt; padding-right:5.03pt; padding-left:5.03pt; vertical-align:top; -aw-border-bottom:0.5pt single #000000; -aw-border-right:0.5pt single #000000">
                    <p style="margin-right:38.75pt; text-align:justify; font-size:10.5pt"><span
                            style="font-family:'Malgun Gothic'">제3자 명칭</span></p>
                </td>
                <td
                    style="width:163.55pt; border-right-style:solid; border-right-width:0.75pt; border-left-style:solid; border-left-width:0.75pt; border-bottom-style:solid; border-bottom-width:0.75pt; padding-right:5.03pt; padding-left:5.03pt; vertical-align:top; -aw-border-bottom:0.5pt single #000000; -aw-border-left:0.5pt single #000000; -aw-border-right:0.5pt single #000000">
                    <p style="margin-right:38.75pt; text-align:justify; font-size:10.5pt"><span
                            style="font-family:'Malgun Gothic'">획득 정보 유형</span></p>
                </td>
                <td
                    style="width:163.55pt; border-right-style:solid; border-right-width:0.75pt; border-left-style:solid; border-left-width:0.75pt; border-bottom-style:solid; border-bottom-width:0.75pt; padding-right:5.03pt; padding-left:5.03pt; vertical-align:top; -aw-border-bottom:0.5pt single #000000; -aw-border-left:0.5pt single #000000; -aw-border-right:0.5pt single #000000">
                    <p style="margin-right:38.75pt; text-align:justify; font-size:10.5pt"><span
                            style="font-family:'Malgun Gothic'">목적</span></p>
                </td>
                <td
                    style="width:163.55pt; border-left-style:solid; border-left-width:0.75pt; border-bottom-style:solid; border-bottom-width:0.75pt; padding-right:5.03pt; padding-left:5.03pt; vertical-align:top; -aw-border-bottom:0.5pt single #000000; -aw-border-left:0.5pt single #000000">
                    <p style="margin-right:38.75pt; text-align:justify; font-size:10.5pt"><span
                            style="font-family:'Malgun Gothic'">보관 기한</span></p>
                </td>
            </tr>
            <tr>
                <td
                    style="width:163.55pt; border-top-style:solid; border-top-width:0.75pt; border-right-style:solid; border-right-width:0.75pt; border-bottom-style:solid; border-bottom-width:0.75pt; padding-right:5.03pt; padding-left:5.03pt; vertical-align:top; -aw-border-bottom:0.5pt single #000000; -aw-border-right:0.5pt single #000000; -aw-border-top:0.5pt single #000000">
                    <p style="margin-right:38.75pt; text-align:justify; font-size:10.5pt"><span
                            style="font-family:'Malgun Gothic'">Google</span></p>
                </td>
                <td
                    style="width:163.55pt; border-style:solid; border-width:0.75pt; padding-right:5.03pt; padding-left:5.03pt; vertical-align:top; -aw-border:0.5pt single #000000">
                    <p style="margin-right:38.75pt; text-align:justify; font-size:10.5pt"><span
                            style="font-family:'Malgun Gothic'">공개 프로필 (이름), 이메일 주소</span></p>
                </td>
                <td
                    style="width:163.55pt; border-style:solid; border-width:0.75pt; padding-right:5.03pt; padding-left:5.03pt; vertical-align:top; -aw-border:0.5pt single #000000">
                    <p style="margin-right:38.75pt; text-align:justify; font-size:10.5pt"><span
                            style="font-family:'Malgun Gothic'">제3자 계정으로 게임에 로그인하거나 임시 회원이 제3자 계정을 연결하여 정식 회원으로 업그레이드할 때
                            사용합니다.</span></p>
                    <p style="margin-right:38.75pt; text-align:justify; font-size:10.5pt"><span
                            style="font-family:'Malgun Gothic'">회원이 Google 계정으로 로그인하거나 Google 계정을 연동할 때, Google이 자동으로
                            이메일 주소를 회사에 제공합니다.</span></p>
                </td>
                <td
                    style="width:163.55pt; border-top-style:solid; border-top-width:0.75pt; border-left-style:solid; border-left-width:0.75pt; border-bottom-style:solid; border-bottom-width:0.75pt; padding-right:5.03pt; padding-left:5.03pt; vertical-align:top; -aw-border-bottom:0.5pt single #000000; -aw-border-left:0.5pt single #000000; -aw-border-top:0.5pt single #000000">
                    <p style="margin-right:38.75pt; text-align:justify; font-size:10.5pt"><span
                            style="font-family:'Malgun Gothic'">회원 탈퇴 시 즉시 삭제</span></p>
                </td>
            </tr>
            <tr>
                <td
                    style="width:163.55pt; border-top-style:solid; border-top-width:0.75pt; border-right-style:solid; border-right-width:0.75pt; border-bottom-style:solid; border-bottom-width:0.75pt; padding-right:5.03pt; padding-left:5.03pt; vertical-align:top; -aw-border-bottom:0.5pt single #000000; -aw-border-right:0.5pt single #000000; -aw-border-top:0.5pt single #000000">
                    <p style="margin-right:38.75pt; text-align:justify; font-size:10.5pt"><span
                            style="font-family:'Malgun Gothic'">Facebook</span></p>
                </td>
                <td
                    style="width:163.55pt; border-style:solid; border-width:0.75pt; padding-right:5.03pt; padding-left:5.03pt; vertical-align:top; -aw-border:0.5pt single #000000">
                    <p style="margin-right:38.75pt; text-align:justify; font-size:10.5pt"><span
                            style="font-family:'Malgun Gothic'">공개 프로필 (이름), 이메일 주소 (선택 가능)</span></p>
                </td>
                <td
                    style="width:163.55pt; border-style:solid; border-width:0.75pt; padding-right:5.03pt; padding-left:5.03pt; vertical-align:top; -aw-border:0.5pt single #000000">
                    <p style="margin-right:38.75pt; text-align:justify; font-size:10.5pt"><span
                            style="font-family:'Malgun Gothic'">제3자 계정으로 게임에 로그인하거나 임시 회원이 제3자 계정을 연결하여 정식 회원으로 업그레이드할 때
                            사용합니다.</span></p>
                    <p style="margin-right:38.75pt; text-align:justify; font-size:10.5pt"><span
                            style="font-family:'Malgun Gothic'">회원은 Facebook 계정으로 로그인하거나 연동할 때 추가로 이메일 주소를 제공할지 여부를 선택할
                            수 있습니다.</span></p>
                </td>
                <td
                    style="width:163.55pt; border-top-style:solid; border-top-width:0.75pt; border-left-style:solid; border-left-width:0.75pt; border-bottom-style:solid; border-bottom-width:0.75pt; padding-right:5.03pt; padding-left:5.03pt; vertical-align:top; -aw-border-bottom:0.5pt single #000000; -aw-border-left:0.5pt single #000000; -aw-border-top:0.5pt single #000000">
                    <p style="margin-right:38.75pt; text-align:justify; font-size:10.5pt"><span
                            style="font-family:'Malgun Gothic'">회원 탈퇴 시 즉시 삭제</span></p>
                </td>
            </tr>
            <tr>
                <td
                    style="width:163.55pt; border-top-style:solid; border-top-width:0.75pt; border-right-style:solid; border-right-width:0.75pt; border-bottom-style:solid; border-bottom-width:0.75pt; padding-right:5.03pt; padding-left:5.03pt; vertical-align:top; -aw-border-bottom:0.5pt single #000000; -aw-border-right:0.5pt single #000000; -aw-border-top:0.5pt single #000000">
                    <p style="margin-right:38.75pt; text-align:justify; font-size:10.5pt"><span
                            style="font-family:'Malgun Gothic'">Apple</span></p>
                </td>
                <td
                    style="width:163.55pt; border-style:solid; border-width:0.75pt; padding-right:5.03pt; padding-left:5.03pt; vertical-align:top; -aw-border:0.5pt single #000000">
                    <p style="margin-right:38.75pt; text-align:justify; font-size:10.5pt"><span
                            style="font-family:'Malgun Gothic'">공개 프로필 (이름), 이메일 주소 (선택 가능)</span></p>
                </td>
                <td
                    style="width:163.55pt; border-style:solid; border-width:0.75pt; padding-right:5.03pt; padding-left:5.03pt; vertical-align:top; -aw-border:0.5pt single #000000">
                    <p style="margin-right:38.75pt; text-align:justify; font-size:10.5pt"><span
                            style="font-family:'Malgun Gothic'">제3자 계정으로 게임에 로그인하거나 임시 회원이 제3자 계정을 연결하여 정식 회원으로 업그레이드할 때
                            사용합니다.</span></p>
                    <p style="margin-right:38.75pt; text-align:justify; font-size:10.5pt"><span
                            style="font-family:'Malgun Gothic'">회원은 Apple 계정으로 로그인하거나 연동할 때 추가로 이메일 주소를 제공할지 여부를 선택할 수
                            있습니다.</span></p>
                </td>
                <td
                    style="width:163.55pt; border-top-style:solid; border-top-width:0.75pt; border-left-style:solid; border-left-width:0.75pt; border-bottom-style:solid; border-bottom-width:0.75pt; padding-right:5.03pt; padding-left:5.03pt; vertical-align:top; -aw-border-bottom:0.5pt single #000000; -aw-border-left:0.5pt single #000000; -aw-border-top:0.5pt single #000000">
                    <p style="margin-right:38.75pt; text-align:justify; font-size:10.5pt"><span
                            style="font-family:'Malgun Gothic'">회원 탈퇴 시 즉시 삭제</span></p>
                </td>
            </tr>
            <tr>
                <td
                    style="width:163.55pt; border-top-style:solid; border-top-width:0.75pt; border-right-style:solid; border-right-width:0.75pt; border-bottom-style:solid; border-bottom-width:0.75pt; padding-right:5.03pt; padding-left:5.03pt; vertical-align:top; -aw-border-bottom:0.5pt single #000000; -aw-border-right:0.5pt single #000000; -aw-border-top:0.5pt single #000000">
                    <p style="margin-right:38.75pt; text-align:justify; font-size:10.5pt"><span
                            style="font-family:'Malgun Gothic'">Discord</span></p>
                </td>
                <td
                    style="width:163.55pt; border-style:solid; border-width:0.75pt; padding-right:5.03pt; padding-left:5.03pt; vertical-align:top; -aw-border:0.5pt single #000000">
                    <p style="margin-right:38.75pt; text-align:justify; font-size:10.5pt"><span
                            style="font-family:'Malgun Gothic'">Discord 계정</span></p>
                </td>
                <td
                    style="width:163.55pt; border-style:solid; border-width:0.75pt; padding-right:5.03pt; padding-left:5.03pt; vertical-align:top; -aw-border:0.5pt single #000000">
                    <p style="margin-right:38.75pt; text-align:justify; font-size:10.5pt"><span
                            style="font-family:'Malgun Gothic'">회원이 Discord 커뮤니티에서 게임 계정을 연동할 때 수집합니다. 연동 후 회원은 회사가
                            커뮤니티에서 주최하는 이벤트에 참여할 수 있고, Discord 커뮤니티 내에서 회사의 관련 이벤트 알림을 받게 됩니다.</span></p>
                </td>
                <td
                    style="width:163.55pt; border-top-style:solid; border-top-width:0.75pt; border-left-style:solid; border-left-width:0.75pt; border-bottom-style:solid; border-bottom-width:0.75pt; padding-right:5.03pt; padding-left:5.03pt; vertical-align:top; -aw-border-bottom:0.5pt single #000000; -aw-border-left:0.5pt single #000000; -aw-border-top:0.5pt single #000000">
                    <p style="margin-right:38.75pt; text-align:justify; font-size:10.5pt"><span
                            style="font-family:'Malgun Gothic'">회원 탈퇴 혹은 연동 해지 시 즉시 삭제</span></p>
                </td>
            </tr>
            <tr>
                <td
                    style="width:163.55pt; border-top-style:solid; border-top-width:0.75pt; border-right-style:solid; border-right-width:0.75pt; padding-right:5.03pt; padding-left:5.03pt; vertical-align:top; -aw-border-right:0.5pt single #000000; -aw-border-top:0.5pt single #000000">
                    <p style="margin-right:38.75pt; text-align:justify; font-size:10.5pt"><span
                            style="font-family:'Malgun Gothic'">Kakao Talk</span></p>
                </td>
                <td
                    style="width:163.55pt; border-top-style:solid; border-top-width:0.75pt; border-right-style:solid; border-right-width:0.75pt; border-left-style:solid; border-left-width:0.75pt; padding-right:5.03pt; padding-left:5.03pt; vertical-align:top; -aw-border-left:0.5pt single #000000; -aw-border-right:0.5pt single #000000; -aw-border-top:0.5pt single #000000">
                    <p style="margin-right:38.75pt; text-align:justify; font-size:10.5pt"><span
                            style="font-family:'Malgun Gothic'">Kakao Talk계정</span></p>
                </td>
                <td
                    style="width:163.55pt; border-top-style:solid; border-top-width:0.75pt; border-right-style:solid; border-right-width:0.75pt; border-left-style:solid; border-left-width:0.75pt; padding-right:5.03pt; padding-left:5.03pt; vertical-align:top; -aw-border-left:0.5pt single #000000; -aw-border-right:0.5pt single #000000; -aw-border-top:0.5pt single #000000">
                    <p style="margin-right:38.75pt; text-align:justify; font-size:10.5pt"><span
                            style="font-family:'Malgun Gothic'">회원이 게임 내에서 개인 Kakao Talk 계정을 연동하거나 회사의 Kakao Talk 공식 채널을
                            추가하면 관련 정보가 수집됩니다.</span></p>
                </td>
                <td
                    style="width:163.55pt; border-top-style:solid; border-top-width:0.75pt; border-left-style:solid; border-left-width:0.75pt; padding-right:5.03pt; padding-left:5.03pt; vertical-align:top; -aw-border-left:0.5pt single #000000; -aw-border-top:0.5pt single #000000">
                    <p style="margin-right:38.75pt; text-align:justify; font-size:10.5pt"><span
                            style="font-family:'Malgun Gothic'">회원 탈퇴 후 즉시 삭제(회원이 숙려 기간을 선택하지 않은 경우)/숙려 기간 종료 및 회사의
                            Kakao Talk 공식 채널 추가 취소 후 삭제</span></p>
                    <p style="margin-right:38.75pt; text-align:justify; font-size:10.5pt"><span
                            style="font-family:'Malgun Gothic'">회원이 게임 내에서 개인 Kakao Talk 계정 연동을 해제하고, 회사의 Kakao Talk 공식
                            채널 추가를 취소하면 관련 정보가 삭제됩니다.</span></p>
                </td>
            </tr>
        </table>
        <p style="margin-right:38.75pt"><span style="font-family:'Malgun Gothic'; -aw-import:ignore">&#xa0;</span></p>
        <p style="margin-right:38.75pt"><span style="font-family:'Malgun Gothic'">일부 게임에서만 임시 회원이 제3자 계정을 연결하여 정식 회원으로
                업그레이드할 수 있는 기능을 제공합니다.</span></p>
        <p style="margin-right:38.75pt"><span style="font-family:'Malgun Gothic'">제3자 플랫폼 인증을 통해 회원가입할 때, 위에 언급된 정보 외의
                다른 개인정보는 저장하지 않습니다.</span></p>
        <p style="margin-right:38.75pt; font-size:9pt"><span
                style="font-family:'Malgun Gothic'; -aw-import:ignore">&#xa0;</span></p>
    </div>`;

export const omnikadeUseDetailHtml = `<div>
<p><span>본사가 스스로 수집하는 정보</span></p>
<table
  cellspacing="0"
  cellpadding="0"
  class="TableGrid"
  style="
    border: 0.75pt solid #000000;
    -aw-border: 0.5pt single;
    -aw-border-insideh: 0.5pt single #000000;
    -aw-border-insidev: 0.5pt single #000000;
    border-collapse: collapse;
    float: left;
  "
>
  <tr>
    <td
      style="
        width: 163.5pt;
        border-right-style: solid;
        border-right-width: 0.75pt;
        border-bottom-style: solid;
        border-bottom-width: 0.75pt;
        padding-right: 5.03pt;
        padding-left: 5.03pt;
        vertical-align: top;
        -aw-border-bottom: 0.5pt single;
        -aw-border-right: 0.5pt single;
      "
    >
      <p style="text-align: justify"><span>목적</span></p>
    </td>
    <td
      style="
        width: 166.4pt;
        border-right-style: solid;
        border-right-width: 0.75pt;
        border-left-style: solid;
        border-left-width: 0.75pt;
        border-bottom-style: solid;
        border-bottom-width: 0.75pt;
        padding-right: 5.03pt;
        padding-left: 5.03pt;
        vertical-align: top;
        -aw-border-bottom: 0.5pt single;
        -aw-border-left: 0.5pt single;
        -aw-border-right: 0.5pt single;
      "
    >
      <p style="text-align: justify">
        <span>정보 유형</span>
      </p>
    </td>
    <td
      style="
        width: 163.55pt;
        border-left-style: solid;
        border-left-width: 0.75pt;
        border-bottom-style: solid;
        border-bottom-width: 0.75pt;
        padding-right: 5.03pt;
        padding-left: 5.03pt;
        vertical-align: top;
        -aw-border-bottom: 0.5pt single;
        -aw-border-left: 0.5pt single;
      "
    >
      <p style="text-align: justify">
        <span>보존 기간</span>
      </p>
    </td>
  </tr>
  <tr>
    <td
      style="
        width: 163.5pt;
        border-top-style: solid;
        border-top-width: 0.75pt;
        border-right-style: solid;
        border-right-width: 0.75pt;
        border-bottom-style: solid;
        border-bottom-width: 0.75pt;
        padding-right: 5.03pt;
        padding-left: 5.03pt;
        vertical-align: top;
        -aw-border-bottom: 0.5pt single;
        -aw-border-right: 0.5pt single;
        -aw-border-top: 0.5pt single;
      "
    >
      <p style="text-align: justify">
        <span>회원가입 시 이용자 신분 인증</span>
      </p>
    </td>
    <td
      style="
        width: 166.4pt;
        border-style: solid;
        border-width: 0.75pt;
        padding-right: 5.03pt;
        padding-left: 5.03pt;
        vertical-align: top;
        -aw-border: 0.5pt single;
      "
    >
      <p style="text-align: justify">
        <span>아이디, 비밀번호, 휴대폰 기종</span>
      </p>
    </td>
    <td
      style="
        width: 163.55pt;
        border-top-style: solid;
        border-top-width: 0.75pt;
        border-left-style: solid;
        border-left-width: 0.75pt;
        border-bottom-style: solid;
        border-bottom-width: 0.75pt;
        padding-right: 5.03pt;
        padding-left: 5.03pt;
        vertical-align: top;
        -aw-border-bottom: 0.5pt single;
        -aw-border-left: 0.5pt single;
        -aw-border-top: 0.5pt single;
      "
    >
      <p style="text-align: justify">
        <span>회원탈퇴 시 즉시 </span><span>폐기</span>
      </p>
    </td>
  </tr>
  <tr>
    <td
      style="
        width: 163.5pt;
        border-top-style: solid;
        border-top-width: 0.75pt;
        border-right-style: solid;
        border-right-width: 0.75pt;
        border-bottom-style: solid;
        border-bottom-width: 0.75pt;
        padding-right: 5.03pt;
        padding-left: 5.03pt;
        vertical-align: top;
        -aw-border-bottom: 0.5pt single;
        -aw-border-right: 0.5pt single;
        -aw-border-top: 0.5pt single;
      "
    >
      <p style="text-align: justify">
        <span>모바일 서비스 이용 및 이벤트 경품 배송 등.</span>
      </p>
    </td>
    <td
      style="
        width: 166.4pt;
        border-style: solid;
        border-width: 0.75pt;
        padding-right: 5.03pt;
        padding-left: 5.03pt;
        vertical-align: top;
        -aw-border: 0.5pt single;
      "
    >
      <p style="text-align: justify">
        <span
          >IP주소, 방문 일시, 서비스 이용 기록, 불량 이용 기록, 결제 기록,
          오류 정보.</span
        >
      </p>
    </td>
    <td
      style="
        width: 163.55pt;
        border-top-style: solid;
        border-top-width: 0.75pt;
        border-left-style: solid;
        border-left-width: 0.75pt;
        border-bottom-style: solid;
        border-bottom-width: 0.75pt;
        padding-right: 5.03pt;
        padding-left: 5.03pt;
        vertical-align: top;
        -aw-border-bottom: 0.5pt single;
        -aw-border-left: 0.5pt single;
        -aw-border-top: 0.5pt single;
      "
    >
      <p style="text-align: justify">
        <span>회원탈퇴 시 즉시 </span><span>폐기</span
        ><span
          >. 단 계약과 청약 기록, 청약 철회 기록, 결제 정보, 재무 기록은 회원
          탈퇴 </span
        ><span>시점</span><span>부터 5년 </span><span>동안</span
        ><span> 보관.</span>
      </p>
    </td>
  </tr>
  <tr>
    <td
      style="
        width: 163.5pt;
        border-top-style: solid;
        border-top-width: 0.75pt;
        border-right-style: solid;
        border-right-width: 0.75pt;
        border-bottom-style: solid;
        border-bottom-width: 0.75pt;
        padding-right: 5.03pt;
        padding-left: 5.03pt;
        vertical-align: top;
        -aw-border-bottom: 0.5pt single;
        -aw-border-right: 0.5pt single;
        -aw-border-top: 0.5pt single;
      "
    >
      <p style="text-align: justify">
        <span
          >서비스 이용에 따른 본인 확인 절차, 비밀번호 분실, 아이디 잠김,
          결제환불 등 대 고객 서비스 및 대 고객 맞춤 서비스
        </span>
      </p>
    </td>
    <td
      style="
        width: 166.4pt;
        border-style: solid;
        border-width: 0.75pt;
        padding-right: 5.03pt;
        padding-left: 5.03pt;
        vertical-align: top;
        -aw-border: 0.5pt single;
      "
    >
      <p style="text-align: justify">
        <span>아이디, 비밀번호, 캐릭터명, 휴대폰 기종과 광고식별자</span>
      </p>
    </td>
    <td
      style="
        width: 163.55pt;
        border-top-style: solid;
        border-top-width: 0.75pt;
        border-left-style: solid;
        border-left-width: 0.75pt;
        border-bottom-style: solid;
        border-bottom-width: 0.75pt;
        padding-right: 5.03pt;
        padding-left: 5.03pt;
        vertical-align: top;
        -aw-border-bottom: 0.5pt single;
        -aw-border-left: 0.5pt single;
        -aw-border-top: 0.5pt single;
      "
    >
      <p style="text-align: justify">
        <span>회원탈퇴 시 즉시 삭제</span>
      </p>
    </td>
  </tr>
  <tr>
    <td
      style="
        width: 163.5pt;
        border-top-style: solid;
        border-top-width: 0.75pt;
        border-right-style: solid;
        border-right-width: 0.75pt;
        border-bottom-style: solid;
        border-bottom-width: 0.75pt;
        padding-right: 5.03pt;
        padding-left: 5.03pt;
        vertical-align: top;
        -aw-border-bottom: 0.5pt single;
        -aw-border-right: 0.5pt single;
        -aw-border-top: 0.5pt single;
      "
    >
      <p style="text-align: justify">
        <span>요금정산을 위해 유료 서비스 결제 시 수집</span>
      </p>
    </td>
    <td
      style="
        width: 166.4pt;
        border-style: solid;
        border-width: 0.75pt;
        padding-right: 5.03pt;
        padding-left: 5.03pt;
        vertical-align: top;
        -aw-border: 0.5pt single;
      "
    >
      <p style="text-align: justify">
        <span>IP주소</span>
      </p>
    </td>
    <td
      style="
        width: 163.55pt;
        border-top-style: solid;
        border-top-width: 0.75pt;
        border-left-style: solid;
        border-left-width: 0.75pt;
        border-bottom-style: solid;
        border-bottom-width: 0.75pt;
        padding-right: 5.03pt;
        padding-left: 5.03pt;
        vertical-align: top;
        -aw-border-bottom: 0.5pt single;
        -aw-border-left: 0.5pt single;
        -aw-border-top: 0.5pt single;
      "
    >
      <p style="text-align: justify">
        <span>결제 정보는 회원 탈퇴 </span><span>시점부터</span
        ><span> 5년 동안 보관</span>
      </p>
    </td>
  </tr>
  <tr>
    <td
      style="
        width: 163.5pt;
        border-top-style: solid;
        border-top-width: 0.75pt;
        border-right-style: solid;
        border-right-width: 0.75pt;
        border-bottom-style: solid;
        border-bottom-width: 0.75pt;
        padding-right: 5.03pt;
        padding-left: 5.03pt;
        vertical-align: top;
        -aw-border-bottom: 0.5pt single;
        -aw-border-right: 0.5pt single;
        -aw-border-top: 0.5pt single;
      "
    >
      <p style="text-align: justify">
        <span>계약 이행 및 분쟁 처리</span>
      </p>
    </td>
    <td
      style="
        width: 166.4pt;
        border-style: solid;
        border-width: 0.75pt;
        padding-right: 5.03pt;
        padding-left: 5.03pt;
        vertical-align: top;
        -aw-border: 0.5pt single;
      "
    >
      <p style="text-align: justify">
        <span>IP주소, 서버 이용 기록(방문 접속 로그, 이용 정지 일시) : </span>
      </p>
    </td>
    <td
      style="
        width: 163.55pt;
        border-top-style: solid;
        border-top-width: 0.75pt;
        border-left-style: solid;
        border-left-width: 0.75pt;
        border-bottom-style: solid;
        border-bottom-width: 0.75pt;
        padding-right: 5.03pt;
        padding-left: 5.03pt;
        vertical-align: top;
        -aw-border-bottom: 0.5pt single;
        -aw-border-left: 0.5pt single;
        -aw-border-top: 0.5pt single;
      "
    >
      <p style="text-align: justify">
        <span>분쟁과 관련된 정보는 회원 탈퇴 </span><span>시점</span
        ><span>부터 3년 동안 보관. 웹사이트 방문 기록은 회원 탈퇴 </span
        ><span>시점</span><span>부터 3개월 동안 보관.</span>
      </p>
    </td>
  </tr>
  <tr>
    <td
      style="
        width: 163.5pt;
        border-top-style: solid;
        border-top-width: 0.75pt;
        border-right-style: solid;
        border-right-width: 0.75pt;
        border-bottom-style: solid;
        border-bottom-width: 0.75pt;
        padding-right: 5.03pt;
        padding-left: 5.03pt;
        vertical-align: top;
        -aw-border-bottom: 0.5pt single;
        -aw-border-right: 0.5pt single;
        -aw-border-top: 0.5pt single;
      "
    >
      <p style="text-align: justify">
        <span
          >이용자 식별 및 중복가입 확인, 결제환불 등 고객 서비스 이용</span
        >
      </p>
    </td>
    <td
      style="
        width: 166.4pt;
        border-style: solid;
        border-width: 0.75pt;
        padding-right: 5.03pt;
        padding-left: 5.03pt;
        vertical-align: top;
        -aw-border: 0.5pt single;
      "
    >
      <p style="text-align: justify">
        <span>중복가입확인정보(DI)</span>
      </p>
    </td>
    <td
      style="
        width: 163.55pt;
        border-top-style: solid;
        border-top-width: 0.75pt;
        border-left-style: solid;
        border-left-width: 0.75pt;
        border-bottom-style: solid;
        border-bottom-width: 0.75pt;
        padding-right: 5.03pt;
        padding-left: 5.03pt;
        vertical-align: top;
        -aw-border-bottom: 0.5pt single;
        -aw-border-left: 0.5pt single;
        -aw-border-top: 0.5pt single;
      "
    >
      <p style="text-align: justify">
        <span>회원탈퇴 시 즉시 </span><span>폐기</span>
      </p>
    </td>
  </tr>
  <tr>
    <td
      style="
        width: 163.5pt;
        border-top-style: solid;
        border-top-width: 0.75pt;
        border-right-style: solid;
        border-right-width: 0.75pt;
        border-bottom-style: solid;
        border-bottom-width: 0.75pt;
        padding-right: 5.03pt;
        padding-left: 5.03pt;
        vertical-align: top;
        -aw-border-bottom: 0.5pt single;
        -aw-border-right: 0.5pt single;
        -aw-border-top: 0.5pt single;
      "
    >
      <p style="text-align: justify">
        <span>채널링 서비스 등 외부 사업자와의 연계, 제휴서비스 시 이용</span>
      </p>
    </td>
    <td
      style="
        width: 166.4pt;
        border-style: solid;
        border-width: 0.75pt;
        padding-right: 5.03pt;
        padding-left: 5.03pt;
        vertical-align: top;
        -aw-border: 0.5pt single;
      "
    >
      <p style="text-align: justify">
        <span>암호화된 동일인식별정보(CI)</span>
      </p>
    </td>
    <td
      style="
        width: 163.55pt;
        border-top-style: solid;
        border-top-width: 0.75pt;
        border-left-style: solid;
        border-left-width: 0.75pt;
        border-bottom-style: solid;
        border-bottom-width: 0.75pt;
        padding-right: 5.03pt;
        padding-left: 5.03pt;
        vertical-align: top;
        -aw-border-bottom: 0.5pt single;
        -aw-border-left: 0.5pt single;
        -aw-border-top: 0.5pt single;
      "
    >
      <p style="text-align: justify">
        <span>회원탈퇴 시 즉시 </span><span>폐기</span>
      </p>
    </td>
  </tr>
  <tr>
    <td
      style="
        width: 163.5pt;
        border-top-style: solid;
        border-top-width: 0.75pt;
        border-right-style: solid;
        border-right-width: 0.75pt;
        border-bottom-style: solid;
        border-bottom-width: 0.75pt;
        padding-right: 5.03pt;
        padding-left: 5.03pt;
        vertical-align: top;
        -aw-border-bottom: 0.5pt single;
        -aw-border-right: 0.5pt single;
        -aw-border-top: 0.5pt single;
      "
    >
      <p style="text-align: justify">
        <span>이용 가능한 연령인지 확인</span>
      </p>
    </td>
    <td
      style="
        width: 166.4pt;
        border-style: solid;
        border-width: 0.75pt;
        padding-right: 5.03pt;
        padding-left: 5.03pt;
        vertical-align: top;
        -aw-border: 0.5pt single;
      "
    >
      <p style="text-align: justify">
        <span>만 14세 이상 여부</span>
      </p>
    </td>
    <td
      style="
        width: 163.55pt;
        border-top-style: solid;
        border-top-width: 0.75pt;
        border-left-style: solid;
        border-left-width: 0.75pt;
        border-bottom-style: solid;
        border-bottom-width: 0.75pt;
        padding-right: 5.03pt;
        padding-left: 5.03pt;
        vertical-align: top;
        -aw-border-bottom: 0.5pt single;
        -aw-border-left: 0.5pt single;
        -aw-border-top: 0.5pt single;
      "
    >
      <p style="text-align: justify">
        <span>회원탈퇴 시 즉시 </span><span>폐기</span>
      </p>
    </td>
  </tr>
  <tr>
    <td
      style="
        width: 163.5pt;
        border-top-style: solid;
        border-top-width: 0.75pt;
        border-right-style: solid;
        border-right-width: 0.75pt;
        padding-right: 5.03pt;
        padding-left: 5.03pt;
        vertical-align: top;
        -aw-border-right: 0.5pt single;
        -aw-border-top: 0.5pt single;
      "
    >
      <p style="text-align: justify">
        <span>아바타 등 콘텐츠 사용에 따른 성별 확인</span>
      </p>
    </td>
    <td
      style="
        width: 166.4pt;
        border-top-style: solid;
        border-top-width: 0.75pt;
        border-right-style: solid;
        border-right-width: 0.75pt;
        border-left-style: solid;
        border-left-width: 0.75pt;
        padding-right: 5.03pt;
        padding-left: 5.03pt;
        vertical-align: top;
        -aw-border-left: 0.5pt single;
        -aw-border-right: 0.5pt single;
        -aw-border-top: 0.5pt single;
      "
    >
      <p style="text-align: justify"><span>성별</span></p>
      <p style="text-align: justify">
        <span style="-aw-import: ignore">&#xa0;</span>
      </p>
    </td>
    <td
      style="
        width: 163.55pt;
        border-top-style: solid;
        border-top-width: 0.75pt;
        border-left-style: solid;
        border-left-width: 0.75pt;
        padding-right: 5.03pt;
        padding-left: 5.03pt;
        vertical-align: top;
        -aw-border-left: 0.5pt single;
        -aw-border-top: 0.5pt single;
      "
    >
      <p style="text-align: justify">
        <span>회원탈퇴 시 즉시 </span><span>폐기</span>
      </p>
    </td>
  </tr>
</table>



<p style="text-align: left; widows: 2; orphans: 2">
  <span style="-aw-import: ignore">&#xa0;</span>
</p>
<p style="text-align: left; widows: 2; orphans: 2">
  <span style="-aw-import: ignore">&#xa0;</span>
</p>
<p style="text-align: left; widows: 2; orphans: 2">
  <span style="-aw-import: ignore">&#xa0;</span>
</p>
<p style="text-align: left; widows: 2; orphans: 2">
  <span style="-aw-import: ignore">&#xa0;</span>
</p>
<p>
  <span
    >임시 회원 모드에서, 본사는 이용자가 스스로 생성한 계정, 비밀번호를
    수집하지 않으며, 임시 회원에게 자동적으로 무작위 계정과 비밀번호를 생성해
    줍니다. 또한 상술된 기타 정보를 수집합니다.</span
  >
</p>
<p>
  <span>다음의 정보는 </span><span>이용</span><span>자가 </span
  ><span>특정 행위를 능동적으로 수행하여 특정 상황을 야기해야 </span
  ><span>회사가 수집할 수 있는 사항입니다. </span><span>이</span
  ><span>용자가 </span
  ><span>특정 행위를 통해 다음의 상황을 야기하지 않으면 </span
  ><span
    >이용자가 해당 정책에 동의함을 클릭하여도 회사는 다음의 정보를 자동적으로
    수집하지 않습니다.</span
  >
</p>
<table
  cellspacing="0"
  cellpadding="0"
  class="TableGrid"
  style="
    border: 0.75pt solid #000000;
    -aw-border: 0.5pt single;
    -aw-border-insideh: 0.5pt single #000000;
    -aw-border-insidev: 0.5pt single #000000;
    border-collapse: collapse;
  "
>
  <tr>
    <td
      style="
        width: 88.2pt;
        border-right-style: solid;
        border-right-width: 0.75pt;
        border-bottom-style: solid;
        border-bottom-width: 0.75pt;
        padding-right: 5.03pt;
        padding-left: 5.03pt;
        vertical-align: top;
        -aw-border-bottom: 0.5pt single;
        -aw-border-right: 0.5pt single;
      "
    >
      <p style="text-align: justify">
        <span>상황</span>
      </p>
    </td>
    <td
      style="
        width: 74.25pt;
        border-right-style: solid;
        border-right-width: 0.75pt;
        border-left-style: solid;
        border-left-width: 0.75pt;
        border-bottom-style: solid;
        border-bottom-width: 0.75pt;
        padding-right: 5.03pt;
        padding-left: 5.03pt;
        vertical-align: top;
        -aw-border-bottom: 0.5pt single;
        -aw-border-left: 0.5pt single;
        -aw-border-right: 0.5pt single;
      "
    >
      <p style="text-align: justify"><span>목적</span></p>
    </td>
    <td
      style="
        width: 74.25pt;
        border-right-style: solid;
        border-right-width: 0.75pt;
        border-left-style: solid;
        border-left-width: 0.75pt;
        border-bottom-style: solid;
        border-bottom-width: 0.75pt;
        padding-right: 5.03pt;
        padding-left: 5.03pt;
        vertical-align: top;
        -aw-border-bottom: 0.5pt single;
        -aw-border-left: 0.5pt single;
        -aw-border-right: 0.5pt single;
      "
    >
      <p style="text-align: justify">
        <span>정보 유형</span>
      </p>
    </td>
    <td
      style="
        width: 414.45pt;
        border-left-style: solid;
        border-left-width: 0.75pt;
        border-bottom-style: solid;
        border-bottom-width: 0.75pt;
        padding-right: 5.03pt;
        padding-left: 5.03pt;
        vertical-align: top;
        -aw-border-bottom: 0.5pt single;
        -aw-border-left: 0.5pt single;
      "
    >
      <p style="text-align: justify">
        <span>보존 기간</span>
      </p>
    </td>
  </tr>
  <tr>
    <td
      style="
        width: 88.2pt;
        border-top-style: solid;
        border-top-width: 0.75pt;
        border-right-style: solid;
        border-right-width: 0.75pt;
        border-bottom-style: solid;
        border-bottom-width: 0.75pt;
        padding-right: 5.03pt;
        padding-left: 5.03pt;
        vertical-align: top;
        -aw-border-bottom: 0.5pt single;
        -aw-border-right: 0.5pt single;
        -aw-border-top: 0.5pt single;
      "
    >
      <p style="text-align: justify">
        <span>회원이 회사에 쓴 이메일</span>
      </p>
    </td>
    <td
      style="
        width: 74.25pt;
        border-style: solid;
        border-width: 0.75pt;
        padding-right: 5.03pt;
        padding-left: 5.03pt;
        vertical-align: top;
        -aw-border: 0.5pt single;
      "
    >
      <p style="text-align: justify">
        <span>회원에게 답장을 보내는 데 사용</span>
      </p>
    </td>
    <td
      style="
        width: 74.25pt;
        border-style: solid;
        border-width: 0.75pt;
        padding-right: 5.03pt;
        padding-left: 5.03pt;
        vertical-align: top;
        -aw-border: 0.5pt single;
      "
    >
      <p style="text-align: justify">
        <span>이메일 주소</span>
      </p>
    </td>
    <td
      style="
        width: 414.45pt;
        border-top-style: solid;
        border-top-width: 0.75pt;
        border-left-style: solid;
        border-left-width: 0.75pt;
        border-bottom-style: solid;
        border-bottom-width: 0.75pt;
        padding-right: 5.03pt;
        padding-left: 5.03pt;
        vertical-align: top;
        -aw-border-bottom: 0.5pt single;
        -aw-border-left: 0.5pt single;
        -aw-border-top: 0.5pt single;
      "
    >
      <p style="text-align: justify">
        <span
          >해당 회원 문의가 완료될 때까지 보존되지만, 분쟁과 관련된 정보는
          회원 탈퇴 </span
        ><span>시점</span><span>부터 3년 동안 보관됨.</span>
      </p>
    </td>
  </tr>
  <tr>
    <td
      style="
        width: 88.2pt;
        border-top-style: solid;
        border-top-width: 0.75pt;
        border-right-style: solid;
        border-right-width: 0.75pt;
        border-bottom-style: solid;
        border-bottom-width: 0.75pt;
        padding-right: 5.03pt;
        padding-left: 5.03pt;
        vertical-align: top;
        -aw-border-bottom: 0.5pt single;
        -aw-border-right: 0.5pt single;
        -aw-border-top: 0.5pt single;
      "
    >
      <p style="text-align: justify">
        <span>회원이 회사에 전화를 검</span>
      </p>
    </td>
    <td
      style="
        width: 74.25pt;
        border-style: solid;
        border-width: 0.75pt;
        padding-right: 5.03pt;
        padding-left: 5.03pt;
        vertical-align: top;
        -aw-border: 0.5pt single;
      "
    >
      <p style="text-align: justify">
        <span>회원에게 회신 목적으로 전화를 거는 데 사용</span>
      </p>
    </td>
    <td
      style="
        width: 74.25pt;
        border-style: solid;
        border-width: 0.75pt;
        padding-right: 5.03pt;
        padding-left: 5.03pt;
        vertical-align: top;
        -aw-border: 0.5pt single;
      "
    >
      <p style="text-align: justify">
        <span>전화번호</span>
      </p>
    </td>
    <td
      style="
        width: 414.45pt;
        border-top-style: solid;
        border-top-width: 0.75pt;
        border-left-style: solid;
        border-left-width: 0.75pt;
        border-bottom-style: solid;
        border-bottom-width: 0.75pt;
        padding-right: 5.03pt;
        padding-left: 5.03pt;
        vertical-align: top;
        -aw-border-bottom: 0.5pt single;
        -aw-border-left: 0.5pt single;
        -aw-border-top: 0.5pt single;
      "
    >
      <p style="text-align: justify">
        <span
          >해당 회원 문의가 완료될 때까지 보존되지만, 분쟁과 관련된 정보는
          회원 탈퇴 </span
        ><span>시점</span><span>부터 3년 동안 보관됨.</span>
      </p>
    </td>
  </tr>
  <tr>
    <td
      style="
        width: 88.2pt;
        border-top-style: solid;
        border-top-width: 0.75pt;
        border-right-style: solid;
        border-right-width: 0.75pt;
        padding-right: 5.03pt;
        padding-left: 5.03pt;
        vertical-align: top;
        -aw-border-right: 0.5pt single;
        -aw-border-top: 0.5pt single;
      "
    >
      <p style="text-align: justify">
        <span>회원이 이메일 구독 이벤트에 참여</span>
      </p>
    </td>
    <td
      style="
        width: 74.25pt;
        border-top-style: solid;
        border-top-width: 0.75pt;
        border-right-style: solid;
        border-right-width: 0.75pt;
        border-left-style: solid;
        border-left-width: 0.75pt;
        padding-right: 5.03pt;
        padding-left: 5.03pt;
        vertical-align: top;
        -aw-border-left: 0.5pt single;
        -aw-border-right: 0.5pt single;
        -aw-border-top: 0.5pt single;
      "
    >
      <p style="text-align: justify">
        <span>이용자 이메일에 서비스 정보를 발송하는 데 사용</span>
      </p>
    </td>
    <td
      style="
        width: 74.25pt;
        border-top-style: solid;
        border-top-width: 0.75pt;
        border-right-style: solid;
        border-right-width: 0.75pt;
        border-left-style: solid;
        border-left-width: 0.75pt;
        padding-right: 5.03pt;
        padding-left: 5.03pt;
        vertical-align: top;
        -aw-border-left: 0.5pt single;
        -aw-border-right: 0.5pt single;
        -aw-border-top: 0.5pt single;
      "
    >
      <p style="text-align: justify">
        <span>이메일 주소</span>
      </p>
    </td>
    <td
      style="
        width: 414.45pt;
        border-top-style: solid;
        border-top-width: 0.75pt;
        border-left-style: solid;
        border-left-width: 0.75pt;
        padding-right: 5.03pt;
        padding-left: 5.03pt;
        vertical-align: top;
        -aw-border-left: 0.5pt single;
        -aw-border-top: 0.5pt single;
      "
    >
      <p style="text-align: justify">
        <span>구독을 취소하거나 회원 탈퇴 시 즉시 삭제</span>
      </p>
    </td>
  </tr>
</table>
<p>
  <span style="-aw-import: ignore">&#xa0;</span>
</p>
<p>
  <span style="-aw-import: ignore">&#xa0;</span>
</p>
<p>
  <span style="-aw-import: ignore">&#xa0;</span>
</p>
<p><span>본사가 제3자에게 얻은 정보</span></p>
<p>
  <span style="-aw-import: ignore">&#xa0;</span>
</p>
<table
  cellspacing="0"
  cellpadding="0"
  class="TableGrid"
  style="
    border: 0.75pt solid #000000;
    -aw-border: 0.5pt single;
    -aw-border-insideh: 0.5pt single #000000;
    -aw-border-insidev: 0.5pt single #000000;
    border-collapse: collapse;
  "
>
  <tr>
    <td
      style="
        width: 163.55pt;
        border-right-style: solid;
        border-right-width: 0.75pt;
        border-bottom-style: solid;
        border-bottom-width: 0.75pt;
        padding-right: 5.03pt;
        padding-left: 5.03pt;
        vertical-align: top;
        -aw-border-bottom: 0.5pt single;
        -aw-border-right: 0.5pt single;
      "
    >
      <p style="text-align: justify">
        <span>제3자 명칭</span>
      </p>
    </td>
    <td
      style="
        width: 163.55pt;
        border-right-style: solid;
        border-right-width: 0.75pt;
        border-left-style: solid;
        border-left-width: 0.75pt;
        border-bottom-style: solid;
        border-bottom-width: 0.75pt;
        padding-right: 5.03pt;
        padding-left: 5.03pt;
        vertical-align: top;
        -aw-border-bottom: 0.5pt single;
        -aw-border-left: 0.5pt single;
        -aw-border-right: 0.5pt single;
      "
    >
      <p style="text-align: justify">
        <span>획득 정보 유형</span>
      </p>
    </td>
    <td
      style="
        width: 163.55pt;
        border-right-style: solid;
        border-right-width: 0.75pt;
        border-left-style: solid;
        border-left-width: 0.75pt;
        border-bottom-style: solid;
        border-bottom-width: 0.75pt;
        padding-right: 5.03pt;
        padding-left: 5.03pt;
        vertical-align: top;
        -aw-border-bottom: 0.5pt single;
        -aw-border-left: 0.5pt single;
        -aw-border-right: 0.5pt single;
      "
    >
      <p style="text-align: justify"><span>목적</span></p>
    </td>
    <td
      style="
        width: 163.55pt;
        border-left-style: solid;
        border-left-width: 0.75pt;
        border-bottom-style: solid;
        border-bottom-width: 0.75pt;
        padding-right: 5.03pt;
        padding-left: 5.03pt;
        vertical-align: top;
        -aw-border-bottom: 0.5pt single;
        -aw-border-left: 0.5pt single;
      "
    >
      <p style="text-align: justify">
        <span>보존 기간</span>
      </p>
    </td>
  </tr>
  <tr>
    <td
      style="
        width: 163.55pt;
        border-top-style: solid;
        border-top-width: 0.75pt;
        border-right-style: solid;
        border-right-width: 0.75pt;
        border-bottom-style: solid;
        border-bottom-width: 0.75pt;
        padding-right: 5.03pt;
        padding-left: 5.03pt;
        vertical-align: top;
        -aw-border-bottom: 0.5pt single;
        -aw-border-right: 0.5pt single;
        -aw-border-top: 0.5pt single;
      "
    >
      <p style="text-align: justify">
        <span>Google</span>
      </p>
    </td>
    <td
      style="
        width: 163.55pt;
        border-style: solid;
        border-width: 0.75pt;
        padding-right: 5.03pt;
        padding-left: 5.03pt;
        vertical-align: top;
        -aw-border: 0.5pt single;
      "
    >
      <p style="text-align: justify">
        <span>공개 프로필</span><span>(</span><span>이름</span><span>), </span
        ><span>이메일 주소</span>
      </p>
    </td>
    <td
      style="
        width: 163.55pt;
        border-style: solid;
        border-width: 0.75pt;
        padding-right: 5.03pt;
        padding-left: 5.03pt;
        vertical-align: top;
        -aw-border: 0.5pt single;
      "
    >
      <p style="text-align: justify">
        <span
          >제3자 계정으로 게임에 접속하거나 임시 회원이 제3자 계정으로
          연동하는 방식으로 회원으로 전환합니다.</span
        >
      </p>
      <p style="text-align: justify">
        <span
          >회원이 Google 계정으로 접속하거나 Google 계정에 연동할 때, Google은
          자동으로 이메일 주소를 회사에 제공합니다.</span
        >
      </p>
    </td>
    <td
      style="
        width: 163.55pt;
        border-top-style: solid;
        border-top-width: 0.75pt;
        border-left-style: solid;
        border-left-width: 0.75pt;
        border-bottom-style: solid;
        border-bottom-width: 0.75pt;
        padding-right: 5.03pt;
        padding-left: 5.03pt;
        vertical-align: top;
        -aw-border-bottom: 0.5pt single;
        -aw-border-left: 0.5pt single;
        -aw-border-top: 0.5pt single;
      "
    >
      <p style="text-align: justify">
        <span>회원탈퇴 시 즉시 삭제</span>
      </p>
    </td>
  </tr>
  <tr>
    <td
      style="
        width: 163.55pt;
        border-top-style: solid;
        border-top-width: 0.75pt;
        border-right-style: solid;
        border-right-width: 0.75pt;
        border-bottom-style: solid;
        border-bottom-width: 0.75pt;
        padding-right: 5.03pt;
        padding-left: 5.03pt;
        vertical-align: top;
        -aw-border-bottom: 0.5pt single;
        -aw-border-right: 0.5pt single;
        -aw-border-top: 0.5pt single;
      "
    >
      <p style="text-align: justify">
        <span>Facebook</span>
      </p>
    </td>
    <td
      style="
        width: 163.55pt;
        border-style: solid;
        border-width: 0.75pt;
        padding-right: 5.03pt;
        padding-left: 5.03pt;
        vertical-align: top;
        -aw-border: 0.5pt single;
      "
    >
      <p style="text-align: justify">
        <span>공개</span><span> </span><span>프로필</span><span>(</span
        ><span>이름</span><span>)，</span><span>이메일</span><span> </span
        ><span>주소</span><span>(</span><span>선택 가능)</span>
      </p>
    </td>
    <td
      style="
        width: 163.55pt;
        border-style: solid;
        border-width: 0.75pt;
        padding-right: 5.03pt;
        padding-left: 5.03pt;
        vertical-align: top;
        -aw-border: 0.5pt single;
      "
    >
      <p style="text-align: justify">
        <span
          >제3자 계정으로 게임에 접속하거나 임시 회원이 제3자 계정으로
          연동하는 방식으로 회원으로 전환합니다.</span
        >
      </p>
      <p style="text-align: justify">
        <span
          >회원은 Facebook 계정으로 로그인하거나 Facebook 계정에 연동할 때
          이메일 주소를 추가적으로 제공할 지를 선택할 수 있습니다.</span
        >
      </p>
    </td>
    <td
      style="
        width: 163.55pt;
        border-top-style: solid;
        border-top-width: 0.75pt;
        border-left-style: solid;
        border-left-width: 0.75pt;
        border-bottom-style: solid;
        border-bottom-width: 0.75pt;
        padding-right: 5.03pt;
        padding-left: 5.03pt;
        vertical-align: top;
        -aw-border-bottom: 0.5pt single;
        -aw-border-left: 0.5pt single;
        -aw-border-top: 0.5pt single;
      "
    >
      <p style="text-align: justify">
        <span>회원탈퇴 시 즉시 삭제</span>
      </p>
    </td>
  </tr>
  <tr>
    <td
      style="
        width: 163.55pt;
        border-top-style: solid;
        border-top-width: 0.75pt;
        border-right-style: solid;
        border-right-width: 0.75pt;
        padding-right: 5.03pt;
        padding-left: 5.03pt;
        vertical-align: top;
        -aw-border-right: 0.5pt single;
        -aw-border-top: 0.5pt single;
      "
    >
      <p style="text-align: justify">
        <span>Apple</span>
      </p>
    </td>
    <td
      style="
        width: 163.55pt;
        border-top-style: solid;
        border-top-width: 0.75pt;
        border-right-style: solid;
        border-right-width: 0.75pt;
        border-left-style: solid;
        border-left-width: 0.75pt;
        padding-right: 5.03pt;
        padding-left: 5.03pt;
        vertical-align: top;
        -aw-border-left: 0.5pt single;
        -aw-border-right: 0.5pt single;
        -aw-border-top: 0.5pt single;
      "
    >
      <p style="text-align: justify">
        <span>공개</span><span> </span><span>프로필</span><span>(</span
        ><span>이름</span><span>)，</span><span>이메일</span><span> </span
        ><span>주소</span><span>(</span><span>선택 가능</span><span>)</span>
      </p>
    </td>
    <td
      style="
        width: 163.55pt;
        border-top-style: solid;
        border-top-width: 0.75pt;
        border-right-style: solid;
        border-right-width: 0.75pt;
        border-left-style: solid;
        border-left-width: 0.75pt;
        padding-right: 5.03pt;
        padding-left: 5.03pt;
        vertical-align: top;
        -aw-border-left: 0.5pt single;
        -aw-border-right: 0.5pt single;
        -aw-border-top: 0.5pt single;
      "
    >
      <p style="text-align: justify">
        <span
          >제3자 계정으로 게임에 접속하거나 임시 회원이 제3자 계정으로
          연동하는 방식으로 회원으로 전환합니다.</span
        >
      </p>
      <p style="text-align: justify">
        <span
          >회원은 Apple 계정으로 로그인하거나 Apple 계정에 연동할 때 이메일
          주소를 추가적으로 제공할 지를 선택할 수 있습니다.</span
        >
      </p>
    </td>
    <td
      style="
        width: 163.55pt;
        border-top-style: solid;
        border-top-width: 0.75pt;
        border-left-style: solid;
        border-left-width: 0.75pt;
        padding-right: 5.03pt;
        padding-left: 5.03pt;
        vertical-align: top;
        -aw-border-left: 0.5pt single;
        -aw-border-top: 0.5pt single;
      "
    >
      <p style="text-align: justify">
        <span>회원탈퇴 시 즉시 삭제</span>
      </p>
    </td>
  </tr>
</table>
<p>
  <span
    >일부 게임만 임시 회원이 제3자 계정 연동 방식을 통해 회원으로 전환하는
    기능을 지원합니다.</span
  >
</p>
<p>
  <span
    >외부 플랫폼 인증을 통한 회원가입 시 위 정보 이외에 다른 개인정보는
    저장하지 않습니다</span
  ><span>.</span>
</p>
</div>`;
